(function ()
{
    'use strict';

    angular
        .module('app.scrumboard', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.scrumboard', {
                abstract : true,
                url      : '/scrumboard',
                resolve  : {
                    BoardList: function (apiResolver)
                    {
                        return apiResolver.resolve('scrumboard.boardList@get');
                    }
                },
                bodyClass: 'scrumboard'
            })

            // Home
            .state('app.scrumboard.boards', {
                url    : '/boards',
                views  : {
                    'content@app'                           : {
                        templateUrl: 'app/main/apps/scrumboard/views/boards/boards-view.html',
                        controller : 'BoardsViewController as vm'
                    }
                }
            })

            // Board
            .state('app.scrumboard.boards.board', {
                    url    : '/:id/:uri',
                    views  : {
                        'content@app'                           : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.board': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, apiResolver, BoardService)
                        {
                            return BoardService.getBoardData($stateParams.id);
                        }
                    }
                }
            )

            // Add board
            .state('app.scrumboard.boards.addBoard', {
                    url    : '/add',
                    views  : {
                        'content@app'                           : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.addBoard': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, apiResolver, BoardService)
                        {
                            return BoardService.addNewBoard();
                        }
                    }
                }
            )

            // Calendar
            .state('app.scrumboard.boards.board.calendar', {
                url  : '/calendar',
                views: {
                    'scrumboardContent@app.scrumboard.boards.board': {
                        templateUrl: 'app/main/apps/scrumboard/views/calendar/calendar-view.html',
                        controller : 'CalendarViewController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/scrumboard');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.scrumboard', {
            title : 'Scrumboard',
            icon  : 'icon-trello',
            state : 'app.scrumboard.boards',
            weight: 5
        });
    }

    /** @ngInject */
    function run(editableThemes)
    {
        /**
         * Inline Edit Configuration
         * @type {string}
         */
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCalendarEventDialogController', ScrumboardCalendarEventDialogController);

    /** @ngInject */
    function ScrumboardCalendarEventDialogController($mdDialog, dueDate, BoardService, msUtils)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.dueDate = dueDate;
        vm.newCard = {
            name  : '',
            listId: ''
        };
        vm.selectedCards = [];

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.closeDialog = closeDialog;
        vm.addNewCard = addNewCard;
        vm.assignDueDate = assignDueDate;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Add New Card
         */
        function addNewCard()
        {
            var newCardId = msUtils.guidGenerator();

            vm.board.cards.push({
                'id'               : newCardId,
                'name'             : vm.newCard.name,
                'description'      : '',
                'idAttachmentCover': '',
                'idMembers'        : [],
                'idLabels'         : [],
                'attachments'      : [],
                'subscribed'       : false,
                'checklists'       : [],
                'checkItems'       : 0,
                'checkItemsChecked': 0,
                'comments'         : [],
                'activities'       : [],
                'due'              : vm.dueDate
            });

            vm.board.lists.getById(vm.newCard.listId).idCards.push(newCardId);

            // Reset the newCard object
            vm.newCard = {
                name: '',
                listId: ''
            };

            closeDialog();
        }

        /**
         * Assign Due Date
         */
        function assignDueDate()
        {
            angular.forEach(vm.selectedCards, function (cardId)
            {
                vm.board.cards.getById(cardId).due = vm.dueDate;
            });

            vm.selectedCards = [];

            closeDialog();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('MembersMenuController', MembersMenuController);

    /** @ngInject */
    function MembersMenuController($document, $mdDialog, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.newMemberSearchInput = '';

        // Methods
        vm.addNewMember = addNewMember;
        vm.removeMember = removeMember;

        ////////

        /**
         * Add New Member
         */
        function addNewMember()
        {
            // Add new member
        }

        /**
         * Remove member
         *
         * @param ev
         * @param memberId
         */
        function removeMember(ev, memberId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Member',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove member?',
                ariaLabel          : 'remove member',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.members;
                arr.splice(arr.indexOf(arr.getById(memberId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idMembers && card.idMembers.indexOf(memberId) > -1 )
                    {
                        card.idMembers.splice(card.idMembers.indexOf(memberId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('LabelsMenuController', LabelsMenuController);

    /** @ngInject */
    function LabelsMenuController($document, $mdColorPalette, $mdDialog, fuseGenerator, msUtils, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.rgba = fuseGenerator.rgba;
        vm.hue = 500;
        vm.newLabelColor = 'red';
        vm.newLabelName = '';

        // Methods
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;

        ////////

        /**
         * Add New Label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                "id"   : msUtils.guidGenerator(),
                "name" : vm.newLabelName,
                "color": vm.newLabelColor
            });
            vm.newLabelName = '';
        }

        /**
         * Remove label
         *
         * @param ev
         * @param labelId
         */
        function removeLabel(ev, labelId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Label',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove label?',
                ariaLabel          : 'remove label',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.labels;
                arr.splice(arr.indexOf(arr.getById(labelId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idLabels && card.idLabels.indexOf(labelId) > -1 )
                    {
                        card.idLabels.splice(card.idLabels.indexOf(labelId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ColorMenuController', ColorMenuController);

    /** @ngInject */
    function ColorMenuController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;

        // Methods

        ////////

    }
})();
angular.module('whiteframeBasicUsage', ['ngMaterial']);

(function () {
  'use strict';

    angular
      .module('virtualRepeatVerticalDemo', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.items = [];
        for (var i = 0; i < 1000; i++) {
          this.items.push(i);
        }
      });

})();


angular.module('toolbarDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

});

(function () {
  'use strict';

    angular
      .module('virtualRepeatScrollToDemo', ['ngMaterial'])
      .controller('AppCtrl', function($scope) {
        this.selectedYear = 0;
        this.years = [];
        this.items = [];
        var currentYear = new Date().getFullYear();
        var monthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
          'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
        // Build a list of months over 20 years
        for (var y = currentYear; y >= (currentYear-20); y--) {
          this.years.push(y);
          this.items.push({year: y, text: y, header: true});
          for (var m = 11; m >= 0; m--) {
            this.items.push({year: y, month: m, text: monthNames[m]});
          }
        }
        // Whenever a different year is selected, scroll to that year
        $scope.$watch('ctrl.selectedYear', angular.bind(this, function(yearIndex) {
          var scrollYear = Math.floor(this.topIndex / 13);
          if(scrollYear !== yearIndex) {
            this.topIndex = yearIndex * 13;
          }
        }));
        // The selected year should follow the year that is at the top of the scroll container
        $scope.$watch('ctrl.topIndex', angular.bind(this, function(topIndex) {
          var scrollYear = Math.floor(topIndex / 13);
          this.selectedYear = scrollYear;
        }));
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatInfiniteScrollDemo', ['ngMaterial'])
      .controller('AppCtrl', function($timeout) {

        // In this example, we set up our model using a plain object.
        // Using a class works too. All that matters is that we implement
        // getItemAtIndex and getLength.
        this.infiniteItems = {
          numLoaded_: 0,
          toLoad_: 0,

          // Required.
          getItemAtIndex: function(index) {
            if (index > this.numLoaded_) {
              this.fetchMoreItems_(index);
              return null;
            }

            return index;
          },

          // Required.
          // For infinite scroll behavior, we always return a slightly higher
          // number than the previously loaded items.
          getLength: function() {
            return this.numLoaded_ + 5;
          },

          fetchMoreItems_: function(index) {
            // For demo purposes, we simulate loading more items with a timed
            // promise. In real code, this function would likely contain an
            // $http request.

            if (this.toLoad_ < index) {
              this.toLoad_ += 20;
              $timeout(angular.noop, 300).then(angular.bind(this, function() {
                this.numLoaded_ = this.toLoad_;
              }));
            }
          }
        };
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatHorizontalDemo', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.items = [];
        for (var i = 0; i < 1000; i++) {
          this.items.push(i);
        }
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatDeferredLoadingDemo', ['ngMaterial'])
      .controller('AppCtrl', function($timeout) {

        // In this example, we set up our model using a class.
        // Using a plain object works too. All that matters
        // is that we implement getItemAtIndex and getLength.
        var DynamicItems = function() {
          /**
           * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
           */
          this.loadedPages = {};

          /** @type {number} Total number of items. */
          this.numItems = 0;

          /** @const {number} Number of items to fetch per request. */
          this.PAGE_SIZE = 50;

          this.fetchNumItems_();
        };

        // Required.
        DynamicItems.prototype.getItemAtIndex = function(index) {
          var pageNumber = Math.floor(index / this.PAGE_SIZE);
          var page = this.loadedPages[pageNumber];

          if (page) {
            return page[index % this.PAGE_SIZE];
          } else if (page !== null) {
            this.fetchPage_(pageNumber);
          }
        };

        // Required.
        DynamicItems.prototype.getLength = function() {
          return this.numItems;
        };

        DynamicItems.prototype.fetchPage_ = function(pageNumber) {
          // Set the page to null so we know it is already being fetched.
          this.loadedPages[pageNumber] = null;

          // For demo purposes, we simulate loading more items with a timed
          // promise. In real code, this function would likely contain an
          // $http request.
          $timeout(angular.noop, 300).then(angular.bind(this, function() {
            this.loadedPages[pageNumber] = [];
            var pageOffset = pageNumber * this.PAGE_SIZE;
            for (var i = pageOffset; i < pageOffset + this.PAGE_SIZE; i++) {
              this.loadedPages[pageNumber].push(i);
            }
          }));
        };

        DynamicItems.prototype.fetchNumItems_ = function() {
          // For demo purposes, we simulate loading the item count with a timed
          // promise. In real code, this function would likely contain an
          // $http request.
          $timeout(angular.noop, 300).then(angular.bind(this, function() {
            this.numItems = 50000;
          }));
        };
        
        this.dynamicItems = new DynamicItems();
      });
})();

angular.module('tooltipDemo1', ['ngMaterial'])
.controller('AppCtrl', function($scope) {
  $scope.demo = {
    showTooltip : false,
    tipDirection : ''
  };

  $scope.$watch('demo.tipDirection',function(val) {
    if (val && val.length ) {
      $scope.demo.showTooltip = true;
    }
  })
});

var app = angular.module('toolbarDemo2', ['ngMaterial']);

app.controller('TitleController', function($scope) {
  $scope.title = 'My App Title';
});

app.controller('AppCtrl', function($scope) {
  var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';

  $scope.todos = [];
  for (var i = 0; i < 15; i++) {
    $scope.todos.push({
      face: imagePath,
      what: "Brunch this weekend?",
      who: "Min Li Chan",
      notes: "I'll be in your neighborhood doing errands."
    });
  }
});


angular.module('toastDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdToast, $document) {
  var last = {
      bottom: false,
      top: true,
      left: false,
      right: true
    };

  $scope.toastPosition = angular.extend({},last);

  $scope.getToastPosition = function() {
    sanitizePosition();

    return Object.keys($scope.toastPosition)
      .filter(function(pos) { return $scope.toastPosition[pos]; })
      .join(' ');
  };

  function sanitizePosition() {
    var current = $scope.toastPosition;

    if ( current.bottom && last.top ) current.top = false;
    if ( current.top && last.bottom ) current.bottom = false;
    if ( current.right && last.left ) current.left = false;
    if ( current.left && last.right ) current.right = false;

    last = angular.extend({},current);
  }

  $scope.showCustomToast = function() {
    $mdToast.show({
      controller: 'ToastCtrl',
      templateUrl: 'toast-template.html',
      parent : $document[0].querySelector('#toastBounds'),
      hideDelay: 6000,
      position: $scope.getToastPosition()
    });
  };

  $scope.showSimpleToast = function() {
    $mdToast.show(
      $mdToast.simple()
        .textContent('Simple Toast!')
        .position($scope.getToastPosition())
        .hideDelay(3000)
    );
  };

  $scope.showActionToast = function() {
    var toast = $mdToast.simple()
          .textContent('Action Toast!')
          .action('OK')
          .highlightAction(false)
          .position($scope.getToastPosition());

    $mdToast.show(toast).then(function(response) {
      if ( response == 'ok' ) {
        alert('You clicked \'OK\'.');
      }
    });
  };

})

.controller('ToastCtrl', function($scope, $mdToast) {
  $scope.closeToast = function() {
    $mdToast.hide();
  };
});

(function () {
  'use strict';

  angular
      .module('tabsDemoStaticTabs', ['ngMaterial'] )
      .controller('AppCtrl', AppCtrl);

  function AppCtrl ( $scope ) {
    $scope.data = {
      selectedIndex: 0,
      secondLocked:  true,
      secondLabel:   "Item Two",
      bottom:        false
    };
    $scope.next = function() {
      $scope.data.selectedIndex = Math.min($scope.data.selectedIndex + 1, 2) ;
    };
    $scope.previous = function() {
      $scope.data.selectedIndex = Math.max($scope.data.selectedIndex - 1, 0);
    };
  }
})();

(function () {
  'use strict';
  angular
      .module('tabsDemoDynamicTabs', ['ngMaterial'])
      .controller('AppCtrl', AppCtrl);

  function AppCtrl ($scope, $log) {
    var tabs = [
          { title: 'One', content: "Tabs will become paginated if there isn't enough room for them."},
          { title: 'Two', content: "You can swipe left and right on a mobile device to change tabs."},
          { title: 'Three', content: "You can bind the selected tab via the selected attribute on the md-tabs element."},
          { title: 'Four', content: "If you set the selected tab binding to -1, it will leave no tab selected."},
          { title: 'Five', content: "If you remove a tab, it will try to select a new one."},
          { title: 'Six', content: "There's an ink bar that follows the selected tab, you can turn it off if you want."},
          { title: 'Seven', content: "If you set ng-disabled on a tab, it becomes unselectable. If the currently selected tab becomes disabled, it will try to select the next tab."},
          { title: 'Eight', content: "If you look at the source, you're using tabs to look at a demo for tabs. Recursion!"},
          { title: 'Nine', content: "If you set md-theme=\"green\" on the md-tabs element, you'll get green tabs."},
          { title: 'Ten', content: "If you're still reading this, you should just go check out the API docs for tabs!"}
        ],
        selected = null,
        previous = null;
    $scope.tabs = tabs;
    $scope.selectedIndex = 2;
    $scope.$watch('selectedIndex', function(current, old){
      previous = selected;
      selected = tabs[current];
      if ( old + 1 && (old != current)) $log.debug('Goodbye ' + previous.title + '!');
      if ( current + 1 )                $log.debug('Hello ' + selected.title + '!');
    });
    $scope.addTab = function (title, view) {
      view = view || title + " Content View";
      tabs.push({ title: title, content: view, disabled: false});
    };
    $scope.removeTab = function (tab) {
      var index = tabs.indexOf(tab);
      tabs.splice(index, 1);
    };
  }
})();


angular.module('switchDemo1', ['ngMaterial'])
.controller('SwitchDemoCtrl', function($scope) {
  $scope.data = {
    cb1: true,
    cb4: true,
    cb5: false
  };

  $scope.message = 'false';

  $scope.onChange = function(cbState) {
  	$scope.message = cbState;
  };
});

angular.module('demoSwipe', ['ngMaterial'])
  .controller('demoSwipeCtrl', function($scope) {
    $scope.onSwipeLeft = function(ev) {
      alert('You swiped left!!');
    };

    $scope.onSwipeRight = function(ev) {
      alert('You swiped right!!');
    };
    $scope.onSwipeUp = function(ev) {
      alert('You swiped up!!');
    };

    $scope.onSwipeDown = function(ev) {
      alert('You swiped down!!');
    };
  });


angular.module('subheaderBasicDemo', ['ngMaterial'])
.config(function($mdThemingProvider) {
  $mdThemingProvider.theme('altTheme')
    .primaryPalette('purple');
})
.controller('SubheaderAppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';
    $scope.messages = [
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
    ];
});


angular.module('sliderDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

  $scope.color = {
    red: Math.floor(Math.random() * 255),
    green: Math.floor(Math.random() * 255),
    blue: Math.floor(Math.random() * 255)
  };

  $scope.rating1 = 3;
  $scope.rating2 = 2;
  $scope.rating3 = 4;

  $scope.disabled1 = 0;
  $scope.disabled2 = 70;

});

angular
  .module('sidenavDemo1', ['ngMaterial'])
  .controller('AppCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.toggleLeft = buildDelayedToggler('left');
    $scope.toggleRight = buildToggler('right');
    $scope.isOpenRight = function(){
      return $mdSidenav('right').isOpen();
    };

    /**
     * Supplies a function that will continue to operate until the
     * time is up.
     */
    function debounce(func, wait, context) {
      var timer;

      return function debounced() {
        var context = $scope,
            args = Array.prototype.slice.call(arguments);
        $timeout.cancel(timer);
        timer = $timeout(function() {
          timer = undefined;
          func.apply(context, args);
        }, wait || 10);
      };
    }

    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildDelayedToggler(navID) {
      return debounce(function() {
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      }, 200);
    }

    function buildToggler(navID) {
      return function() {
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      }
    }
  })
  .controller('LeftCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      $mdSidenav('left').close()
        .then(function () {
          $log.debug("close LEFT is done");
        });

    };
  })
  .controller('RightCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      $mdSidenav('right').close()
        .then(function () {
          $log.debug("close RIGHT is done");
        });
    };
  });

angular.module('selectDemoValidation', ['ngMaterial', 'ngMessages'])
.controller('AppCtrl', function($scope) {
  $scope.clearValue = function() {
    $scope.myModel = undefined;
  };
  $scope.save = function() {
    alert('Form was valid!');
  };
});

angular.module('selectDemoOptionsAsync', ['ngMaterial'])
.controller('SelectAsyncController', function($timeout, $scope) {
  $scope.user = null;
  $scope.users = null;

  $scope.loadUsers = function() {

    // Use timeout to simulate a 650ms request.
    return $timeout(function() {

      $scope.users =  $scope.users  || [
        { id: 1, name: 'Scooby Doo' },
        { id: 2, name: 'Shaggy Rodgers' },
        { id: 3, name: 'Fred Jones' },
        { id: 4, name: 'Daphne Blake' },
        { id: 5, name: 'Velma Dinkley' }
      ];

    }, 650);
  };
});

(function () {
  'use strict';
  angular
      .module('selectDemoBasic', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.userState = '';
        this.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
            'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
            'WY').split(' ').map(function (state) { return { abbrev: state }; });
      });
})();

angular
    .module('selectDemoOptGroups', ['ngMaterial'])
    .controller('SelectOptGroupController', function($scope) {
      $scope.sizes = [
          "small (12-inch)",
          "medium (14-inch)",
          "large (16-inch)",
          "insane (42-inch)"
      ];
      $scope.toppings = [
        { category: 'meat', name: 'Pepperoni' },
        { category: 'meat', name: 'Sausage' },
        { category: 'meat', name: 'Ground Beef' },
        { category: 'meat', name: 'Bacon' },
        { category: 'veg', name: 'Mushrooms' },
        { category: 'veg', name: 'Onion' },
        { category: 'veg', name: 'Green Pepper' },
        { category: 'veg', name: 'Green Olives' }
      ];
    });

angular
  .module('radioDemo2', ['ngMaterial'])
  .controller('ContactController', function($scope) {
    var self = this;

    self.contacts = [{
      'id': 1,
      'fullName': 'Maria Guadalupe',
      'lastName': 'Guadalupe',
      'title': "CEO, Found"
    }, {
      'id': 2,
      'fullName': 'Gabriel García Marquéz',
      'lastName': 'Marquéz',
      'title': "VP Sales & Marketing"
    }, {
      'id': 3,
      'fullName': 'Miguel de Cervantes',
      'lastName': 'Cervantes',
      'title': "Manager, Operations"
    }, {
      'id': 4,
      'fullName': 'Pacorro de Castel',
      'lastName': 'Castel',
      'title': "Security"
    }];
    self.selectedIndex = 2;
    self.selectedUser = function() {
      return self.contacts[self.selectedIndex].lastName;
    }
  });


angular
  .module('radioDemo1', ['ngMaterial'])
  .controller('AppCtrl', function($scope) {

    $scope.data = {
      group1 : 'Banana',
      group2 : '2',
      group3 : 'avatar-1'
    };

    $scope.avatarData = [{
        id: "avatars:svg-1",
        title: 'avatar 1',
        value: 'avatar-1'
      },{
        id: "avatars:svg-2",
        title: 'avatar 2',
        value: 'avatar-2'
      },{
        id: "avatars:svg-3",
        title: 'avatar 3',
        value: 'avatar-3'
    }];

    $scope.radioData = [
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: '3', isDisabled: true },
      { label: '4', value: '4' }
    ];


    $scope.submit = function() {
      alert('submit');
    };

    $scope.addItem = function() {
      var r = Math.ceil(Math.random() * 1000);
      $scope.radioData.push({ label: r, value: r });
    };

    $scope.removeItem = function() {
      $scope.radioData.pop();
    };

  })
  .config(function($mdIconProvider) {
    $mdIconProvider.iconSet("avatars", 'assets/angular-material-assets/icons/avatar-icons.svg',128);
  });

angular.module('progressLinearDemo1', ['ngMaterial'])
  .config(function($mdThemingProvider) {
  })
  .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
    var self = this, j= 0, counter = 0;

    self.mode = 'query';
    self.activated = true;
    self.determinateValue = 30;
    self.determinateValue2 = 30;

    self.modes = [ ];

    /**
     * Turn off or on the 5 themed loaders
     */
    self.toggleActivation = function() {
        if ( !self.activated ) self.modes = [ ];
        if (  self.activated ) {
          j = counter = 0;
          self.determinateValue = 30;
          self.determinateValue2 = 30;
        }
    };

    $interval(function() {
      self.determinateValue += 1;
      self.determinateValue2 += 1.5;

      if (self.determinateValue > 100) self.determinateValue = 30;
      if (self.determinateValue2 > 100) self.determinateValue2 = 30;

        // Incrementally start animation the five (5) Indeterminate,
        // themed progress circular bars

        if ( (j < 2) && !self.modes[j] && self.activated ) {
          self.modes[j] = (j==0) ? 'buffer' : 'query';
        }
        if ( counter++ % 4 == 0 ) j++;

        // Show the indicator in the "Used within Containers" after 200ms delay
        if ( j == 2 ) self.contained = "indeterminate";

    }, 100, 0, true);

    $interval(function() {
      self.mode = (self.mode == 'query' ? 'determinate' : 'query');
    }, 7200, 0, true);
  }]);

angular
  .module('progressCircularDemo1', ['ngMaterial'])
  .controller('AppCtrl', ['$scope', '$interval',
    function($scope, $interval) {
      var self = this,  j= 0, counter = 0;

      self.modes = [ ];
      self.activated = true;
      self.determinateValue = 30;

      /**
       * Turn off or on the 5 themed loaders
       */
      self.toggleActivation = function() {
          if ( !self.activated ) self.modes = [ ];
          if (  self.activated ) j = counter = 0;
      };

      // Iterate every 100ms, non-stop
      $interval(function() {

        // Increment the Determinate loader

        self.determinateValue += 1;
        if (self.determinateValue > 100) {
          self.determinateValue = 30;
        }

        // Incrementally start animation the five (5) Indeterminate,
        // themed progress circular bars

        if ( (j < 5) && !self.modes[j] && self.activated ) {
          self.modes[j] = 'indeterminate';
        }
        if ( counter++ % 4 == 0 ) j++;

      }, 100, 0, true);
    }
  ]);

angular
  .module('menuBarDemoBasic', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
  })
  .filter('keyboardShortcut', function($window) {
    return function(str) {
      if (!str) return;
      var keys = str.split('-');
      var isOSX = /Mac OS X/.test($window.navigator.userAgent);

      var seperator = (!isOSX || keys.length > 2) ? '+' : '';

      var abbreviations = {
        M: isOSX ? '⌘' : 'Ctrl',
        A: isOSX ? 'Option' : 'Alt',
        S: 'Shift'
      };

      return keys.map(function(key, index) {
        var last = index == keys.length - 1;
        return last ? key : abbreviations[key];
      }).join(seperator);
    };
  })
  .controller('DemoBasicCtrl', function DemoCtrl($mdDialog) {
    this.settings = {
      printLayout: true,
      showRuler: true,
      showSpellingSuggestions: true,
      presentationMode: 'edit'
    };

    this.sampleAction = function(name, ev) {
      $mdDialog.show($mdDialog.alert()
        .title(name)
        .textContent('You triggered the "' + name + '" action')
        .ok('Great')
        .targetEvent(ev)
      );
    };
  });


angular.module('menuDemoWidth', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
    .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
})
.controller('WidthDemoCtrl', DemoCtrl);

function DemoCtrl($mdDialog) {
  var vm = this;

  this.announceClick = function(index) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('You clicked!')
        .textContent('You clicked the menu item at index ' + index)
        .ok('Nice')
    );
  };
}


angular
  .module('menuDemoBasic', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
      .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .controller('BasicDemoCtrl', function DemoCtrl($mdDialog) {
    var originatorEv;

    this.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

    this.notificationsEnabled = true;
    this.toggleNotifications = function() {
      this.notificationsEnabled = !this.notificationsEnabled;
    };

    this.redial = function() {
      $mdDialog.show(
        $mdDialog.alert()
          .targetEvent(originatorEv)
          .clickOutsideToClose(true)
          .parent('body')
          .title('Suddenly, a redial')
          .textContent('You just called a friend; who told you the most amazing story. Have a cookie!')
          .ok('That was easy')
      );

      originatorEv = null;
    };

    this.checkVoicemail = function() {
      // This never happens.
    };
  });

angular
  .module('menuDemoPosition', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
      .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .controller('PositionDemoCtrl', function DemoCtrl($mdDialog) {
    var originatorEv;

    this.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

    this.announceClick = function(index) {
      $mdDialog.show(
        $mdDialog.alert()
          .title('You clicked!')
          .textContent('You clicked the menu item at index ' + index)
          .ok('Nice')
          .targetEvent(originatorEv)
      );
      originatorEv = null;
    };
  });



angular.module('listDemo2', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet('social', 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24)
    .iconSet('device', 'assets/angular-material-assets/img/icons/sets/device-icons.svg', 24)
    .iconSet('communication', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
    .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
})
.controller('ListCtrl', function($scope, $mdDialog) {
  $scope.toppings = [
    { name: 'Pepperoni', wanted: true },
    { name: 'Sausage', wanted: false },
    { name: 'Black Olives', wanted: true },
    { name: 'Green Peppers', wanted: false }
  ];

  $scope.settings = [
    { name: 'Wi-Fi', extraScreen: 'Wi-fi menu', icon: 'device:network-wifi', enabled: true },
    { name: 'Bluetooth', extraScreen: 'Bluetooth menu', icon: 'device:bluetooth', enabled: false },
  ];

  $scope.messages = [
    {id: 1, title: "Message A", selected: false},
    {id: 2, title: "Message B", selected: true},
    {id: 3, title: "Message C", selected: true},
  ];

  $scope.people = [
    { name: 'Janet Perkins', img: 'assets/angular-material-assets/img/100-0.jpeg', newMessage: true },
    { name: 'Mary Johnson', img: 'assets/angular-material-assets/img/100-1.jpeg', newMessage: false },
    { name: 'Peter Carlsson', img: 'assets/angular-material-assets/img/100-2.jpeg', newMessage: false }
  ];

  $scope.goToPerson = function(person, event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Navigating')
        .textContent('Inspect ' + person)
        .ariaLabel('Person inspect demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

  $scope.navigateTo = function(to, event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Navigating')
        .textContent('Imagine being taken to ' + to)
        .ariaLabel('Navigation demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

  $scope.doPrimaryAction = function(event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Primary Action')
        .textContent('Primary actions can be used for one click actions')
        .ariaLabel('Primary click demo')
        .ok('Awesome!')
        .targetEvent(event)
    );
  };

  $scope.doSecondaryAction = function(event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Secondary Action')
        .textContent('Secondary actions can be used for one click actions')
        .ariaLabel('Secondary click demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

});


angular.module('listDemo1', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet('communication', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24);
})
.controller('AppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';

    $scope.phones = [
      { type: 'Home', number: '(555) 251-1234' },
      { type: 'Cell', number: '(555) 786-9841' },
      { type: 'Office', number: '(555) 314-1592' }
    ];
    $scope.todos = [
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
    ];
});

angular
  .module('inputIconDemo', ['ngMaterial', 'ngMessages'])
  .controller('DemoCtrl', function($scope) {
    $scope.user = {
      name: 'John Doe',
      email: '',
      phone: '',
      address: 'Mountain View, CA',
      donation: 19.99
    };
  });

angular.module('inputErrorsAdvancedApp', ['ngMaterial', 'ngMessages'])

  .controller('AppCtrl', function($scope) {
    $scope.showHints = true;

    $scope.user = {
      name: "",
      email: "",
      social: "123456789",
      phone: "N/A"
    };
  });

angular.module('inputErrorsApp', ['ngMaterial', 'ngMessages'])

.controller('AppCtrl', function($scope) {
  $scope.project = {
    description: 'Nuclear Missile Defense System',
    rate: 500
  };
});

angular
  .module('inputBasicDemo', ['ngMaterial', 'ngMessages'])
  .controller('DemoCtrl', function($scope) {
    $scope.user = {
      title: 'Developer',
      email: 'ipsum@lorem.com',
      firstName: '',
      lastName: '',
      company: 'Google',
      address: '1600 Amphitheatre Pkwy',
      city: 'Mountain View',
      state: 'CA',
      biography: 'Loves kittens, snowboarding, and can type at 130 WPM.\n\nAnd rumor has it she bouldered up Castle Craig!',
      postalCode: '94043'
    };

    $scope.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
    'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
    'WY').split(' ').map(function(state) {
        return {abbrev: state};
      })
  })
  .config(function($mdThemingProvider) {

    // Configure a dark theme with primary foreground yellow

    $mdThemingProvider.theme('docs-dark', 'default')
      .primaryPalette('yellow')
      .dark();

  });


angular.module('appUsingTemplateCache', ['ngMaterial'])
  .controller('DemoCtrl', function($scope) {})
  .config(function($mdIconProvider) {

    // Register icon IDs with sources. Future $mdIcon( <id> ) lookups
    // will load by url and retrieve the data via the $http and $templateCache

    $mdIconProvider
      .iconSet('core', 'assets/angular-material-assets/img/icons/sets/core-icons.svg',24)
      .icon('social:cake', 'assets/angular-material-assets/img/icons/cake.svg',24);

  })
  .run(function($http, $templateCache) {

    var urls = [
      'assets/angular-material-assets/img/icons/sets/core-icons.svg',
      'assets/angular-material-assets/img/icons/cake.svg',
      'assets/angular-material-assets/img/icons/android.svg'
    ];

    // Pre-fetch icons sources by URL and cache in the $templateCache...
    // subsequent $http calls will look there first.

    angular.forEach(urls, function(url) {
      $http.get(url, {cache: $templateCache});
    });

  })
  ;


angular.module('appSvgIconSets', ['ngMaterial'])
  .controller('DemoCtrl', function($scope) {})
  .config(['$mdIconProvider', function($mdIconProvider) {
    $mdIconProvider
      .iconSet('social', 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24)
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
  }]);


angular.module('appDemoSvgIcons', ['ngMaterial'])
.controller('DemoCtrl', function( $scope ) {

    $scope.insertDriveIconURL = 'assets/angular-material-assets/img/icons/ic_insert_drive_file_24px.svg';
    $scope.getAndroid = function() {
      return 'assets/angular-material-assets/img/icons/android.svg';
    }
});


angular
  .module('appDemoFontIconsWithLigatures', ['ngMaterial'])
  .controller('DemoCtrl', function( $scope ) {
      // Specify a list of font-icons with ligatures and color overrides
      var iconData = [
            {name: 'accessibility'  , color: "#777" },
            {name: 'question_answer', color: "rgb(89, 226, 168)" },
            {name: 'backup'         , color: "#A00" },
            {name: 'email'          , color: "#00A" }
          ];

      $scope.fonts = [].concat(iconData);

      // Create a set of sizes...
      $scope.sizes = [
        {size:"md-18",padding:0},
        {size:"md-24",padding:2},
        {size:"md-36",padding:6},
        {size:"md-48",padding:10}
      ];

  });


angular
  .module('appDemoFontIconsWithClassnames', ['ngMaterial'])
  .controller('DemoCtrl', function( $scope ) {
      // Create list of font-icon names with color overrides
      var iconData = [
            {name: 'icon-home'        , color: "#777" },
            {name: 'icon-user-plus'   , color: "rgb(89, 226, 168)" },
            {name: 'icon-google-plus2', color: "#A00" },
            {name: 'icon-youtube4'    , color:"#00A" },
             // Use theming to color the font-icon
            {name: 'icon-settings'    , color:"#A00", theme:"md-warn md-hue-5"}
          ];

      // Create a set of sizes...
      $scope.sizes = [
        {size:48,padding:10},
        {size:36,padding:6},
        {size:24,padding:2},
        {size:12,padding:0}
      ];

      $scope.fonts = [].concat(iconData);



  })
  .config(function($mdThemingProvider){
    // Update the theme colors to use themes on font-icons
    $mdThemingProvider.theme('default')
          .primaryPalette("red")
          .accentPalette('green')
          .warnPalette('blue');
  });


angular.module('gridListDemo1', ['ngMaterial'])
.controller('AppCtrl', function($scope) {
  var COLORS = ['#ffebee', '#ffcdd2', '#ef9a9a', '#e57373', '#ef5350', '#f44336', '#e53935', '#d32f2f', '#c62828', '#b71c1c', '#ff8a80', '#ff5252', '#ff1744', '#d50000', '#f8bbd0', '#f48fb1', '#f06292', '#ec407a', '#e91e63', '#d81b60', '#c2185b', '#ad1457', '#880e4f', '#ff80ab', '#ff4081', '#f50057', '#c51162', '#e1bee7', '#ce93d8', '#ba68c8', '#ab47bc', '#9c27b0', '#8e24aa', '#7b1fa2', '#4a148c', '#ea80fc', '#e040fb', '#d500f9', '#aa00ff', '#ede7f6', '#d1c4e9', '#b39ddb', '#9575cd', '#7e57c2', '#673ab7', '#5e35b1', '#4527a0', '#311b92', '#b388ff', '#7c4dff', '#651fff', '#6200ea', '#c5cae9', '#9fa8da', '#7986cb', '#5c6bc0', '#3f51b5', '#3949ab', '#303f9f', '#283593', '#1a237e', '#8c9eff', '#536dfe', '#3d5afe', '#304ffe', '#e3f2fd', '#bbdefb', '#90caf9', '#64b5f6', '#42a5f5', '#2196f3', '#1e88e5', '#1976d2', '#1565c0', '#0d47a1', '#82b1ff', '#448aff', '#2979ff', '#2962ff', '#b3e5fc', '#81d4fa', '#4fc3f7', '#29b6f6', '#03a9f4', '#039be5', '#0288d1', '#0277bd', '#01579b', '#80d8ff', '#40c4ff', '#00b0ff', '#0091ea', '#e0f7fa', '#b2ebf2', '#80deea', '#4dd0e1', '#26c6da', '#00bcd4', '#00acc1', '#0097a7', '#00838f', '#006064', '#84ffff', '#18ffff', '#00e5ff', '#00b8d4', '#e0f2f1', '#b2dfdb', '#80cbc4', '#4db6ac', '#26a69a', '#009688', '#00897b', '#00796b', '#00695c', '#a7ffeb', '#64ffda', '#1de9b6', '#00bfa5', '#e8f5e9', '#c8e6c9', '#a5d6a7', '#81c784', '#66bb6a', '#4caf50', '#43a047', '#388e3c', '#2e7d32', '#1b5e20', '#b9f6ca', '#69f0ae', '#00e676', '#00c853', '#f1f8e9', '#dcedc8', '#c5e1a5', '#aed581', '#9ccc65', '#8bc34a', '#7cb342', '#689f38', '#558b2f', '#33691e', '#ccff90', '#b2ff59', '#76ff03', '#64dd17', '#f9fbe7', '#f0f4c3', '#e6ee9c', '#dce775', '#d4e157', '#cddc39', '#c0ca33', '#afb42b', '#9e9d24', '#827717', '#f4ff81', '#eeff41', '#c6ff00', '#aeea00', '#fffde7', '#fff9c4', '#fff59d', '#fff176', '#ffee58', '#ffeb3b', '#fdd835', '#fbc02d', '#f9a825', '#f57f17', '#ffff8d', '#ffff00', '#ffea00', '#ffd600', '#fff8e1', '#ffecb3', '#ffe082', '#ffd54f', '#ffca28', '#ffc107', '#ffb300', '#ffa000', '#ff8f00', '#ff6f00', '#ffe57f', '#ffd740', '#ffc400', '#ffab00', '#fff3e0', '#ffe0b2', '#ffcc80', '#ffb74d', '#ffa726', '#ff9800', '#fb8c00', '#f57c00', '#ef6c00', '#e65100', '#ffd180', '#ffab40', '#ff9100', '#ff6d00', '#fbe9e7', '#ffccbc', '#ffab91', '#ff8a65', '#ff7043', '#ff5722', '#f4511e', '#e64a19', '#d84315', '#bf360c', '#ff9e80', '#ff6e40', '#ff3d00', '#dd2c00', '#d7ccc8', '#bcaaa4', '#795548', '#d7ccc8', '#bcaaa4', '#8d6e63', '#eceff1', '#cfd8dc', '#b0bec5', '#90a4ae', '#78909c', '#607d8b', '#546e7a', '#cfd8dc', '#b0bec5', '#78909c'];

  this.colorTiles = (function() {
    var tiles = [];
    for (var i = 0; i < 46; i++) {
      tiles.push({
        color: randomColor(),
        colspan: randomSpan(),
        rowspan: randomSpan()
      });
    }
    return tiles;
  })();


  function randomColor() {
    return COLORS[Math.floor(Math.random() * COLORS.length)];
  }

  function randomSpan() {
    var r = Math.random();
    if (r < 0.8) {
      return 1;
    } else if (r < 0.9) {
      return 2;
    } else {
      return 3;
    }
  }
});


angular
  .module('gridListDemoApp', ['ngMaterial'])
  .controller('gridListDemoCtrl', function($scope) {

    this.tiles = buildGridModel({
            icon : "avatar:svg-",
            title: "Svg-",
            background: ""
          });

    function buildGridModel(tileTmpl){
      var it, results = [ ];

      for (var j=0; j<11; j++) {

        it = angular.extend({},tileTmpl);
        it.icon  = it.icon + (j+1);
        it.title = it.title + (j+1);
        it.span  = { row : 1, col : 1 };

        switch(j+1) {
          case 1:
            it.background = "red";
            it.span.row = it.span.col = 2;
            break;

          case 2: it.background = "green";         break;
          case 3: it.background = "darkBlue";      break;
          case 4:
            it.background = "blue";
            it.span.col = 2;
            break;

          case 5:
            it.background = "yellow";
            it.span.row = it.span.col = 2;
            break;

          case 6: it.background = "pink";          break;
          case 7: it.background = "darkBlue";      break;
          case 8: it.background = "purple";        break;
          case 9: it.background = "deepBlue";      break;
          case 10: it.background = "lightPurple";  break;
          case 11: it.background = "yellow";       break;
        }

        results.push(it);
      }
      return results;
    }
  })
  .config( function( $mdIconProvider ){
    $mdIconProvider.iconSet("avatar", 'assets/angular-material-assets/icons/avatar-icons.svg', 128);
  });


angular.module('gridListDemo1', ['ngMaterial'])
.controller('AppCtrl', function($scope) {});

(function() {
  'use strict';

  angular.module('fabToolbarBasicUsageDemo', ['ngMaterial'])
    .controller('AppCtrl', function($scope) {
      $scope.isOpen = false;

      $scope.demo = {
        isOpen: false,
        count: 0,
        selectedDirection: 'left'
      };
    });
})();
(function() {
  'use strict';

  angular.module('fabSpeedDialDemoMoreOptions', ['ngMaterial'])
    .controller('DemoCtrl', function($scope, $mdDialog, $timeout) {
      var self = this;

      self.hidden = false;
      self.isOpen = false;
      self.hover = false;

      // On opening, add a delayed property which shows tooltips after the speed dial has opened
      // so that they have the proper position; if closing, immediately hide the tooltips
      $scope.$watch('demo.isOpen', function(isOpen) {
        if (isOpen) {
          $timeout(function() {
            $scope.tooltipVisible = self.isOpen;
          }, 600);
        } else {
          $scope.tooltipVisible = self.isOpen;
        }
      });

      self.items = [
        { name: "Twitter", icon: "assets/angular-material-assets/img/icons/twitter.svg", direction: "bottom" },
        { name: "Facebook", icon: "assets/angular-material-assets/img/icons/facebook.svg", direction: "top" },
        { name: "Google Hangout", icon: "assets/angular-material-assets/img/icons/hangout.svg", direction: "bottom" }
      ];

      self.openDialog = function($event, item) {
        // Show the dialog
        $mdDialog.show({
          clickOutsideToClose: true,
          controller: function($mdDialog) {
            // Save the clicked item
            this.item = item;

            // Setup some handlers
            this.close = function() {
              $mdDialog.cancel();
            };
            this.submit = function() {
              $mdDialog.hide();
            };
          },
          controllerAs: 'dialog',
          templateUrl: 'dialog.html',
          targetEvent: $event
        });
      }
    });
})();

(function() {
  'use strict';

  angular.module('fabSpeedDialDemoBasicUsage', ['ngMaterial'])
    .controller('DemoCtrl', function() {
      this.topDirections = ['left', 'up'];
      this.bottomDirections = ['down', 'right'];

      this.isOpen = false;

      this.availableModes = ['md-fling', 'md-scale'];
      this.selectedMode = 'md-fling';

      this.availableDirections = ['up', 'down', 'left', 'right'];
      this.selectedDirection = 'up';
    });
})();

angular.module('dividerDemo1', ['ngMaterial'])
  .controller('AppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';
    $scope.messages = [{
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }];
  });

angular.module('dialogDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdDialog) {
  $scope.openFromLeft = function() {
    $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Opening from the left')
        .textContent('Closing to the right!')
        .ariaLabel('Left to right demo')
        .parent(angular.element(document.body))
        .ok('Nice!')
        // You can specify either sting with query selector
        .openFrom('#left')
        // or an element
        .closeTo(angular.element(document.querySelector('#right')))
    );
  };

  $scope.openOffscreen = function() {
    $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Opening from offscreen')
        .textContent('Closing to offscreen')
        .ariaLabel('Offscreen Demo')
        .parent(angular.element(document.body))
        .ok('Amazing!')
        // Or you can specify the rect to do the transition from
        .openFrom({
          top: -50,
          width: 30,
          height: 80
        })
        .closeTo({
          left: 1500
        })
    );
  };
});

angular.module('dialogDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdDialog, $mdMedia) {
  $scope.status = '  ';
  $scope.customFullscreen = $mdMedia('xs') || $mdMedia('sm');

  $scope.showAlert = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    // Modal dialogs should fully cover application
    // to prevent interaction outside of dialog
    $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .title('This is an alert title')
        .textContent('You can specify some description text in here.')
        .ariaLabel('Alert Dialog Demo')
        .ok('Got it!')
        .targetEvent(ev)
    );
  };

  $scope.showConfirm = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.confirm()
          .title('Would you like to delete your debt?')
          .textContent('All of the banks have agreed to forgive you your debts.')
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .ok('Please do it!')
          .cancel('Sounds like a scam');

    $mdDialog.show(confirm).then(function() {
      $scope.status = 'You decided to get rid of your debt.';
    }, function() {
      $scope.status = 'You decided to keep your debt.';
    });
  };

  $scope.showAdvanced = function(ev) {
    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && $scope.customFullscreen;

    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'dialog1.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: useFullScreen
    })
    .then(function(answer) {
      $scope.status = 'You said the information was "' + answer + '".';
    }, function() {
      $scope.status = 'You cancelled the dialog.';
    });



    $scope.$watch(function() {
      return $mdMedia('xs') || $mdMedia('sm');
    }, function(wantsFullScreen) {
      $scope.customFullscreen = (wantsFullScreen === true);
    });

  };

  $scope.showTabDialog = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'tabDialog.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true
    })
        .then(function(answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function() {
          $scope.status = 'You cancelled the dialog.';
        });
  };
});

function DialogController($scope, $mdDialog) {
  $scope.hide = function() {
    $mdDialog.hide();
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };

  $scope.answer = function(answer) {
    $mdDialog.hide(answer);
  };
}

angular.module('datepickerBasicUsage',
    ['ngMaterial', 'ngMessages']).controller('AppCtrl', function($scope) {
  $scope.myDate = new Date();

  $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() - 2,
      $scope.myDate.getDate());

  $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 2,
      $scope.myDate.getDate());
  
  $scope.onlyWeekendsPredicate = function(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  }
});


angular.module('contentDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

});

(function () {
  'use strict';
  angular
      .module('staticChipsDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    this.chipText = 'Football';
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsCustomSeparatorDemo', ['ngMaterial'])
      .controller('CustomSeparatorCtrl', DemoCtrl);

  function DemoCtrl ($mdConstant) {
    // Use common key codes found in $mdConstant.KEY_CODE...
    this.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    this.tags = [];

    // Any key code can be used to create a custom separator
    var semicolon = 186;
    this.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, semicolon];
    this.contacts = ['test@example.com'];
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsCustomInputDemo', ['ngMaterial'])
      .controller('CustomInputDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.readonly = false;
    self.selectedItem = null;
    self.searchText = null;
    self.querySearch = querySearch;
    self.vegetables = loadVegetables();
    self.selectedVegetables = [];
    self.numberChips = [];
    self.numberChips2 = [];
    self.numberBuffer = '';
    self.autocompleteDemoRequireMatch = true;
    self.transformChip = transformChip;

    /**
     * Return the proper object when the append is called.
     */
    function transformChip(chip) {
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return chip;
      }

      // Otherwise, create a new one
      return { name: chip, type: 'new' }
    }

    /**
     * Search for vegetables.
     */
    function querySearch (query) {
      var results = query ? self.vegetables.filter(createFilterFor(query)) : [];
      return results;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(vegetable) {
        return (vegetable._lowername.indexOf(lowercaseQuery) === 0) ||
            (vegetable._lowertype.indexOf(lowercaseQuery) === 0);
      };

    }

    function loadVegetables() {
      var veggies = [
        {
          'name': 'Broccoli',
          'type': 'Brassica'
        },
        {
          'name': 'Cabbage',
          'type': 'Brassica'
        },
        {
          'name': 'Carrot',
          'type': 'Umbelliferous'
        },
        {
          'name': 'Lettuce',
          'type': 'Composite'
        },
        {
          'name': 'Spinach',
          'type': 'Goosefoot'
        }
      ];

      return veggies.map(function (veg) {
        veg._lowername = veg.name.toLowerCase();
        veg._lowertype = veg.type.toLowerCase();
        return veg;
      });
    }
  }
})();

(function () {
  'use strict';
  angular
      .module('contactChipsDemo', ['ngMaterial'])
      .controller('ContactChipDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.querySearch = querySearch;
    self.allContacts = loadContacts();
    self.contacts = [self.allContacts[0]];
    self.filterSelected = true;

    /**
     * Search for contacts.
     */
    function querySearch (query) {
      var results = query ?
          self.allContacts.filter(createFilterFor(query)) : [];
      return results;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(contact) {
        return (contact._lowername.indexOf(lowercaseQuery) != -1);;
      };

    }

    function loadContacts() {
      var contacts = [
        'Marina Augustine',
        'Oddr Sarno',
        'Nick Giannopoulos',
        'Narayana Garner',
        'Anita Gros',
        'Megan Smith',
        'Tsvetko Metzger',
        'Hector Simek',
        'Some-guy withalongalastaname'
      ];

      return contacts.map(function (c, index) {
        var cParts = c.split(' ');
        var contact = {
          name: c,
          email: cParts[0][0].toLowerCase() + '.' + cParts[1].toLowerCase() + '@example.com',
          image: 'http://lorempixel.com/50/50/people?' + index
        };
        contact._lowername = contact.name.toLowerCase();
        return contact;
      });
    }
  }


})();

(function () {
  'use strict';
  angular
      .module('chipsDemo', ['ngMaterial'])
      .controller('BasicDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.readonly = false;

    // Lists of fruit names and Vegetable objects
    self.fruitNames = ['Apple', 'Banana', 'Orange'];
    self.roFruitNames = angular.copy(self.fruitNames);
    self.tags = [];
    self.vegObjs = [
      {
        'name' : 'Broccoli',
        'type' : 'Brassica'
      },
      {
        'name' : 'Cabbage',
        'type' : 'Brassica'
      },
      {
        'name' : 'Carrot',
        'type' : 'Umbelliferous'
      }
    ];

    self.newVeg = function(chip) {
      return {
        name: chip,
        type: 'unknown'
      };
    };
  }
})();


angular.module('checkboxDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

    $scope.items = [1,2,3,4,5];
      $scope.selected = [];

      $scope.toggle = function (item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) list.splice(idx, 1);
        else list.push(item);
      };

      $scope.exists = function (item, list) {
        return list.indexOf(item) > -1;
      };
});


angular.module('checkboxDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

  $scope.data = {};
  $scope.data.cb1 = true;
  $scope.data.cb2 = false;
  $scope.data.cb3 = false;
  $scope.data.cb4 = false;
  $scope.data.cb5 = false;

});


angular.module('cardDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('cardDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('cardDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('buttonsDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.title1 = 'Button';
  $scope.title4 = 'Warn';
  $scope.isDisabled = true;

  $scope.googleUrl = 'http://google.com';

});

angular.module('bottomSheetDemo1', ['ngMaterial'])
.config(function($mdIconProvider) {
    $mdIconProvider
      .icon('share-arrow', 'assets/angular-material-assets/img/icons/share-arrow.svg', 24)
      .icon('upload', 'assets/angular-material-assets/img/icons/upload.svg', 24)
      .icon('copy', 'assets/angular-material-assets/img/icons/copy.svg', 24)
      .icon('print', 'assets/angular-material-assets/img/icons/print.svg', 24)
      .icon('hangout', 'assets/angular-material-assets/img/icons/hangout.svg', 24)
      .icon('mail', 'assets/angular-material-assets/img/icons/mail.svg', 24)
      .icon('message', 'assets/angular-material-assets/img/icons/message.svg', 24)
      .icon('copy2', 'assets/angular-material-assets/img/icons/copy2.svg', 24)
      .icon('facebook', 'assets/angular-material-assets/img/icons/facebook.svg', 24)
      .icon('twitter', 'assets/angular-material-assets/img/icons/twitter.svg', 24);
  })
.controller('BottomSheetExample', function($scope, $timeout, $mdBottomSheet, $mdToast) {
  $scope.alert = '';

  $scope.showListBottomSheet = function($event) {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-list-template.html',
      controller: 'ListBottomSheetCtrl',
      targetEvent: $event
    }).then(function(clickedItem) {
      $scope.alert = clickedItem['name'] + ' clicked!';
    });
  };

  $scope.showGridBottomSheet = function($event) {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-grid-template.html',
      controller: 'GridBottomSheetCtrl',
      clickOutsideToClose: false,
      targetEvent: $event
    }).then(function(clickedItem) {
      $mdToast.show(
            $mdToast.simple()
              .textContent(clickedItem['name'] + ' clicked!')
              .position('top right')
              .hideDelay(1500)
          );
    });
  };
})

.controller('ListBottomSheetCtrl', function($scope, $mdBottomSheet) {

  $scope.items = [
    { name: 'Share', icon: 'share-arrow' },
    { name: 'Upload', icon: 'upload' },
    { name: 'Copy', icon: 'copy' },
    { name: 'Print this page', icon: 'print' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
})
.controller('GridBottomSheetCtrl', function($scope, $mdBottomSheet) {
  $scope.items = [
    { name: 'Hangout', icon: 'hangout' },
    { name: 'Mail', icon: 'mail' },
    { name: 'Message', icon: 'message' },
    { name: 'Copy', icon: 'copy2' },
    { name: 'Facebook', icon: 'facebook' },
    { name: 'Twitter', icon: 'twitter' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
})
.run(function($http, $templateCache) {

    var urls = [
      'assets/angular-material-assets/img/icons/share-arrow.svg',
      'assets/angular-material-assets/img/icons/upload.svg',
      'assets/angular-material-assets/img/icons/copy.svg',
      'assets/angular-material-assets/img/icons/print.svg',
      'assets/angular-material-assets/img/icons/hangout.svg',
      'assets/angular-material-assets/img/icons/mail.svg',
      'assets/angular-material-assets/img/icons/message.svg',
      'assets/angular-material-assets/img/icons/copy2.svg',
      'assets/angular-material-assets/img/icons/facebook.svg',
      'assets/angular-material-assets/img/icons/twitter.svg'
    ];

    angular.forEach(urls, function(url) {
      $http.get(url, {cache: $templateCache});
    });

  });

(function () {
  'use strict';
  angular
      .module('autocompleteDemoInsideDialog', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl($mdDialog) {
    var self = this;

    self.openDialog = function($event) {
      $mdDialog.show({
        controller: DialogCtrl,
        controllerAs: 'ctrl',
        templateUrl: 'dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose:true
      })
    }
  }

  function DialogCtrl ($timeout, $q, $scope, $mdDialog) {
    var self = this;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.querySearch   = querySearch;

    // ******************************
    // Template methods
    // ******************************

    self.cancel = function($event) {
      $mdDialog.cancel();
    };
    self.finish = function($event) {
      $mdDialog.hide();
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      return query ? self.states.filter( createFilterFor(query) ) : self.states;
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteFloatingLabelDemo', ['ngMaterial', 'ngMessages'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.selectedItem  = null;
    self.searchText    = null;
    self.querySearch   = querySearch;

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.states.filter( createFilterFor(query) ) : [];
      return results;
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteCustomTemplateDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q, $log) {
    var self = this;

    self.simulateQuery = false;
    self.isDisabled    = false;

    self.repos         = loadAll();
    self.querySearch   = querySearch;
    self.selectedItemChange = selectedItemChange;
    self.searchTextChange   = searchTextChange;

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.repos.filter( createFilterFor(query) ) : self.repos,
          deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Build `components` list of key/value pairs
     */
    function loadAll() {
      var repos = [
        {
          'name'      : 'Angular 1',
          'url'       : 'https://github.com/angular/angular.js',
          'watchers'  : '3,623',
          'forks'     : '16,175',
        },
        {
          'name'      : 'Angular 2',
          'url'       : 'https://github.com/angular/angular',
          'watchers'  : '469',
          'forks'     : '760',
        },
        {
          'name'      : 'Angular Material',
          'url'       : 'https://github.com/angular/material',
          'watchers'  : '727',
          'forks'     : '1,241',
        },
        {
          'name'      : 'Bower Material',
          'url'       : 'https://github.com/angular/bower-material',
          'watchers'  : '42',
          'forks'     : '84',
        },
        {
          'name'      : 'Material Start',
          'url'       : 'https://github.com/angular/material-start',
          'watchers'  : '81',
          'forks'     : '303',
        }
      ];
      return repos.map( function (repo) {
        repo.value = repo.name.toLowerCase();
        return repo;
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(item) {
        return (item.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q, $log) {
    var self = this;

    self.simulateQuery = false;
    self.isDisabled    = false;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.querySearch   = querySearch;
    self.selectedItemChange = selectedItemChange;
    self.searchTextChange   = searchTextChange;

    self.newState = newState;

    function newState(state) {
      alert("Sorry! You'll need to create a Constituion for " + state + " first!");
    }

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.states.filter( createFilterFor(query) ) : self.states,
          deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

'use strict';


(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_theme-colors', {
            url      : '/ui/theme-colors',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/theme-colors/theme-colors.html',
                    controller : 'ThemeColorsController as vm'
                }
            },
            bodyClass: 'theme-colors'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('CustomThemeDialogController', CustomThemeDialogController);

    /** @ngInject */
    function CustomThemeDialogController(fuseTheming, $mdDialog, fuseGenerator, $cookies, $window)
    {
        // Data
        var vm = this;
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.themes = fuseTheming.getRegisteredThemes();

        // Delete Unnecessary hue value
        delete vm.palettes.grey['1000'];

        // Methods
        vm.rgba = fuseGenerator.rgba;
        vm.setTheme = setTheme;
        vm.closeDialog = closeDialog;

        //////////

        // If custom theme exist keep using it otherwise set default as a custom
        if ( !vm.themes.custom )
        {
            vm.theme = angular.copy(vm.themes['default'].colors);
        }
        else
        {
            vm.theme = vm.themes.custom.colors;
        }

        /**
         * Put custom theme into the cookies
         * and reload for generate styles
         */
        function setTheme()
        {
            $cookies.putObject('customTheme', vm.theme);
            $cookies.put('selectedTheme', 'custom');
            $window.location.reload();
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_tabbed', {
            url  : '/ui/page-layouts/simple/tabbed',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/tabbed/tabbed.html',
                    controller : 'SimpleTabbedController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed')
        .controller('SimpleTabbedController', SimpleTabbedController);

    /** @ngInject */
    function SimpleTabbedController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-ii', {
            url  : '/ui/page-layouts/simple/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'SimpleRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii')
        .controller('SimpleRightSidenavIIController', SimpleRightSidenavIIController);

    /** @ngInject */
    function SimpleRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav', {
            url  : '/ui/page-layouts/simple/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html',
                    controller : 'SimpleRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav')
        .controller('SimpleRightSidenavController', SimpleRightSidenavController);

    /** @ngInject */
    function SimpleRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-ii', {
            url  : '/ui/page-layouts/simple/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'SimpleLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii')
        .controller('SimpleLeftSidenavIIController', SimpleLeftSidenavIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav', {
            url  : '/ui/page-layouts/simple/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html',
                    controller : 'SimpleLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav')
        .controller('SimpleLeftSidenavController', SimpleLeftSidenavController);

    /** @ngInject */
    function SimpleLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_fullwidth', {
            url  : '/ui/page-layouts/simple/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/fullwidth/fullwidth.html',
                    controller : 'SimpleFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth')
        .controller('SimpleFullwidthController', SimpleFullwidthController);

    /** @ngInject */
    function SimpleFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav-ii', {
            url  : '/ui/page-layouts/carded/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'CardedRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii')
        .controller('CardedRightSidenavIIController', CardedRightSidenavIIController);

    /** @ngInject */
    function CardedRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav', {
            url  : '/ui/page-layouts/carded/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html',
                    controller : 'CardedRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav')
        .controller('CardedRightSidenavController', CardedRightSidenavController);

    /** @ngInject */
    function CardedRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav-ii', {
            url  : '/ui/page-layouts/carded/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'CardedLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii')
        .controller('CardedLeftSidenavIIController', CardedLeftSidenavIIController);

    /** @ngInject */
    function CardedLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav', {
            url  : '/ui/page-layouts/carded/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html',
                    controller : 'CardedLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav')
        .controller('CardedLeftSidenavController', CardedLeftSidenavController);

    /** @ngInject */
    function CardedLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth-ii', {
            url  : '/ui/page-layouts/carded/fullwidth-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html',
                    controller : 'CardedFullwidthIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii')
        .controller('CardedFullwidthIIController', CardedFullwidthIIController);

    /** @ngInject */
    function CardedFullwidthIIController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth', {
            url  : '/ui/page-layouts/carded/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth/fullwidth.html',
                    controller : 'CardedFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth')
        .controller('CardedFullwidthController', CardedFullwidthController);

    /** @ngInject */
    function CardedFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.todo', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.to-do', {
            url      : '/to-do',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/todo/todo.html',
                    controller : 'TodoController as vm'
                }
            },
            resolve  : {
                Tasks: function (apiResolver)
                {
                    return apiResolver.resolve('todo.tasks@get');
                },
                Tags : function (apiResolver)
                {
                    return apiResolver.resolve('todo.tags@get');
                }
            },
            bodyClass: 'todo'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/todo');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.to-do', {
            title : 'To-Do',
            icon  : 'icon-checkbox-marked',
            state : 'app.to-do',
            badge : {
                content: 3,
                color  : '#4CAF50'
            },
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TaskDialogController', TaskDialogController);

    /** @ngInject */
    function TaskDialogController($mdDialog, Task, Tasks, event)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Task';
        vm.task = angular.copy(Task);
        vm.tasks = Tasks;
        vm.newTask = false;

        if ( !vm.task )
        {
            vm.task = {
                'id'                : '',
                'title'             : '',
                'notes'             : '',
                'startDate'         : new Date(),
                'startDateTimeStamp': new Date().getTime(),
                'dueDate'           : '',
                'dueDateTimeStamp'  : '',
                'completed'         : false,
                'starred'           : false,
                'important'         : false,
                'deleted'           : false,
                'tags'              : []
            };
            vm.title = 'New Task';
            vm.newTask = true;
            vm.task.tags = [];
        }

        // Methods
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.deleteTask = deleteTask;
        vm.newTag = newTag;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewTask()
        {
            vm.tasks.unshift(vm.task);

            closeDialog();
        }

        /**
         * Save task
         */
        function saveTask()
        {
            // Dummy save action
            for ( var i = 0; i < vm.tasks.length; i++ )
            {
                if ( vm.tasks[i].id === vm.task.id )
                {
                    vm.tasks[i] = angular.copy(vm.task);
                    break;
                }
            }

            closeDialog();
        }

        /**
         * Delete task
         */
        function deleteTask()
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('The Task will be deleted.')
                .ariaLabel('Delete Task')
                .ok('Delete')
                .cancel('Cancel')
                .targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                // Dummy delete action
                for ( var i = 0; i < vm.tasks.length; i++ )
                {
                    if ( vm.tasks[i].id === vm.task.id )
                    {
                        vm.tasks[i].deleted = true;
                        break;
                    }
                }
            }, function ()
            {
                // Cancel Action
            });
        }


        /**
         * New tag
         *
         * @param chip
         * @returns {{label: *, color: string}}
         */
        function newTag(chip)
        {
            var tagColors = ['#388E3C', '#F44336', '#FF9800', '#0091EA', '#9C27B0'];

            return {
                name : chip,
                label: chip,
                color: tagColors[Math.floor(Math.random() * (tagColors.length))]
            };
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('CalendarViewController', CalendarViewController);

    /** @ngInject */
    function CalendarViewController($scope, $document, $mdDialog, $mdSidenav, BoardService, DialogService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.eventSources = [];

        vm.calendarUiConfig = {
            calendar: {
                editable                 : true,
                eventLimit               : true,
                header                   : '',
                handleWindowResize       : false,
                aspectRatio              : 1,
                dayNames                 : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort            : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                //monthNamesShort	  		 : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                timezone                 : 'local',
                eventDurationEditable    : false,
                defaultTimedEventDuration: '01:00:00',
                viewRender               : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat             : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd D'
                },
                eventClick               : function eventDetail(calendarEvent, ev)
                {
                    vm.openCardDialog(ev, calendarEvent.idCard);
                },
                eventDrop                : function (event)
                {
                    vm.board.cards.getById(event.idCard).due = moment.utc(event.start).format('x');
                },
                selectable               : true,
                selectHelper             : true,
                dayClick                 : function (date, ev)
                {
                    var offset = moment().utcOffset();
                    var corrDate = '';

                    if ( offset < 0 )
                    {
                        corrDate = moment.utc(date).subtract(offset, 'm').format('x');
                    }
                    else
                    {
                        corrDate = moment.utc(date).add(offset, 'm').format('x');
                    }

                    eventDialog(corrDate, ev);
                }
            }
        };

        // Methods
        vm.next = next;
        vm.prev = prev;
        vm.goToDate = goToDate;
        vm.openCardDialog = DialogService.openCardDialog;
        vm.toggleSidenav = toggleSidenav;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            vm.cards = getScheduledCards();
            vm.eventSources[0] = vm.cards;
        }

        /**
         * Get scheduled cards and prepare
         * them to show on the calendar
         *
         * @returns {Array}
         */
        function getScheduledCards()
        {
            var cards = [];

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.due )
                {
                    cards.push({
                        idCard         : card.id,
                        title          : card.name,
                        start          : moment.utc(card.due, 'x'),
                        due            : card.due,
                        backgroundColor: getEventBgColor(card.due)
                    });
                }
            });

            return cards;
        }

        /**
         * Get background color
         *
         * @param cardDue
         * @returns {*}
         */
        function getEventBgColor(cardDue)
        {
            if ( moment() > moment(cardDue, 'x') )
            {
                return '#F44336';
            }

            return '#4CAF50';
        }

        /**
         * Watch board changes
         */
        $scope.$watch('vm.board', function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            init();

        }, true);

        /**
         * Go to Date
         *
         * @param date
         */
        function goToDate(date)
        {
            vm.calendarView.calendar.gotoDate(date);
            $mdSidenav('scheduled-tasks-sidenav').close();
        }

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Event Dialog
         */
        function eventDialog(date, ev)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html',
                controller         : "ScrumboardCalendarEventDialogController",
                controllerAs       : "vm",
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dueDate: date
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardsViewController', BoardsViewController);

    /** @ngInject */
    function BoardsViewController(BoardList)
    {
        var vm = this;

        // Data
        vm.boardList = BoardList.data;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardViewController', BoardViewController);

    /** @ngInject */
    function BoardViewController($document, $mdDialog, msUtils, BoardList, BoardService, CardFilters, DialogService)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.cardFilters = CardFilters;
        vm.card = {};
        vm.cardOptions = {};
        vm.newListName = '';
        vm.sortableListOptions = {
            axis       : 'x',
            delay      : 75,
            distance   : 7,
            items      : '> .list-wrapper',
            handle     : '.list-header',
            placeholder: 'list-wrapper list-sortable-placeholder',
            tolerance  : 'pointer',
            start      : function (event, ui)
            {
                var width = ui.item[0].children[0].clientWidth;
                var height = ui.item[0].children[0].clientHeight;
                ui.placeholder.css({
                    'min-width': width + 'px',
                    'width'    : width + 'px',
                    'height'   : height + 'px'
                });
            }
        };
        vm.sortableCardOptions = {
            appendTo            : 'body',
            connectWith         : '.list-cards',
            delay               : 75,
            distance            : 7,
            forceHelperSize     : true,
            forcePlaceholderSize: true,
            handle              : msUtils.isMobile() ? '.list-card-sort-handle' : false,
            helper              : function (event, el)
            {
                return el.clone().addClass('list-card-sort-helper');
            },
            placeholder         : 'list-card card-sortable-placeholder',
            tolerance           : 'pointer',
            scroll              : true,
            sort                : function (event, ui)
            {
                var listContentEl = ui.placeholder.closest('.list-content');
                var boardContentEl = ui.placeholder.closest('#board');

                if ( listContentEl )
                {
                    var listContentElHeight = listContentEl[0].clientHeight,
                        listContentElScrollHeight = listContentEl[0].scrollHeight;

                    if ( listContentElHeight !== listContentElScrollHeight )
                    {
                        var itemTop = ui.position.top,
                            itemBottom = itemTop + ui.item.height(),
                            listTop = listContentEl.offset().top,
                            listBottom = listTop + listContentElHeight;

                        if ( itemTop < listTop + 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() - 25);
                        }

                        if ( itemBottom > listBottom - 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() + 25);
                        }
                    }
                }

                if ( boardContentEl )
                {
                    var boardContentElWidth = boardContentEl[0].clientWidth;
                    var boardContentElScrollWidth = boardContentEl[0].scrollWidth;

                    if ( boardContentElWidth !== boardContentElScrollWidth )
                    {
                        var itemLeft = ui.position.left,
                            itemRight = itemLeft + ui.item.width(),
                            boardLeft = boardContentEl.offset().left,
                            boardRight = boardLeft + boardContentElWidth;

                        if ( itemLeft < boardLeft + 25 )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
                        }

                        if ( itemRight > boardRight)
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
                        }
                    }
                }
            }
        };

        // Methods
        vm.openCardDialog = DialogService.openCardDialog;
        vm.addNewList = addNewList;
        vm.removeList = removeList;
        vm.cardFilter = cardFilter;
        vm.isOverdue = isOverdue;

        //////////


        /**
         * Add new list
         */
        function addNewList()
        {
            if ( vm.newListName === '' )
            {
                return;
            }

            vm.board.lists.push({
                "id"     : msUtils.guidGenerator(),
                "name"   : vm.newListName,
                "idCards": []
            });

            vm.newListName = '';
        }

        /**
         * Remove list
         *
         * @param ev
         * @param list
         */
        function removeList(ev, list)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove List',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove list?',
                ariaLabel          : 'remove list',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });
            $mdDialog.show(confirm).then(function ()
            {
                vm.board.lists.splice(vm.board.lists.indexOf(list), 1);
            }, function ()
            {
                // Canceled
            });

        }

        /**
         * Card filter
         *
         * @param cardId
         * @returns {*}
         */
        function cardFilter(cardId)
        {
            var card = vm.board.cards.getById(cardId);

            try
            {
                if ( angular.lowercase(card.name).indexOf(angular.lowercase(vm.cardFilters.name)) < 0 )
                {
                    throw false;
                }

                angular.forEach(vm.cardFilters.labels, function (label)
                {
                    if ( !msUtils.exists(label, card.idLabels) )
                    {
                        throw false;
                    }
                });

                angular.forEach(vm.cardFilters.members, function (member)
                {
                    if ( !msUtils.exists(member, card.idMembers) )
                    {
                        throw false;
                    }
                });


            } catch ( err )
            {
                return err;
            }

            return true;
        }

        /**
         * Is the card overdue?
         *
         * @param cardDate
         * @returns {boolean}
         */
        function isOverdue(cardDate)
        {
            return moment() > moment(cardDate, 'x');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('SettingsSidenavController', SettingsSidenavController);

    /** @ngInject */
    function SettingsSidenavController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.selectedMenu = 'Settings';

        // Methods

        ////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('FiltersSidenavController', FiltersSidenavController);

    /** @ngInject */
    function FiltersSidenavController(msUtils, BoardService, CardFilters)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.cardFilters = CardFilters;
        vm.labels = vm.board.labels;
        vm.members = vm.board.members;
        vm.selectedMenu = 'Settings';

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('msSbAddCardController', msSbAddCardController)
        .directive('msSbAddCard', msSbAddCardDirective);

    /** @ngInject */
    function msSbAddCardController($scope, $timeout, BoardService, msUtils)
    {
        var vm = this;

        vm.newCardName = '';
        vm.listId = $scope.msListId;
        vm.board = BoardService.data;
        vm.cards = vm.board.cards;
        vm.list = vm.board.lists.getById(vm.listId);

        // Methods
        vm.addNewCard = addNewCard;

        /////

        /**
         * Add New Card
         */
        function addNewCard()
        {
            if ( vm.newCardName === '' )
            {
                return;
            }

            var newCardId = msUtils.guidGenerator();

            vm.cards.push({
                "id"               : newCardId,
                "name"             : vm.newCardName,
                "description"      : '',
                "idAttachmentCover": '',
                "idMembers"        : [],
                "idLabels"         : [],
                "attachments"      : [],
                "subscribed"       : false,
                "checklists"       : [],
                "checkItems"       : 0,
                "checkItemsChecked": 0,
                "comments"         : [],
                "activities"       : [],
                "due"              : null
            });

            vm.list.idCards.push(newCardId);

            $timeout(function ()
            {
                $scope.scrollListContentBottom();
            });

            vm.newCardName = '';
        }
    }

    /** @ngInject */
    function msSbAddCardDirective($document, $compile, $timeout)
    {
        return {
            restrict    : 'A',
            controller  : 'msSbAddCardController',
            controllerAs: 'vm',
            scope       : {
                msListId: '='
            },
            link        : function (scope, iElement)
            {
                scope.closeForm = closeForm;
                scope.scrollListContentBottom = scrollListContentBottom;

                var form = '<form ng-submit="vm.addNewCard()" class="ms-sb-add-card-form md-whiteframe-2dp" layout="column">\n\n    <md-input-container flex md-no-float>\n        <input placeholder="Card title" type="text" autocomplete="off"\n               ng-model="vm.newCardName" translate-attr-placeholder="SB.CARD_TITLE">\n    </md-input-container>\n\n    <div layout="row" layout-align="space-between center">\n        <md-button type="submit"\n                   class="add-button md-accent md-raised"\n                   aria-label="add" translate-attr-aria-label="SB.ADD">\n            <span translate="SB.ADD">Add</span>\n        </md-button>\n        <md-button ng-click="closeForm()" class="cancel-button md-icon-button"\n                   aria-label="cancel" translate-attr-aria-label="SB.CANCEL">\n            <md-icon md-font-icon="icon-close"></md-icon>\n        </md-button>\n    </div>\n\n</form>',
                    formEl = '',
                    listContent = iElement.prev();

                /**
                 * Click Event
                 */
                iElement.on('click', function (event)
                {
                    event.preventDefault();
                    openForm();
                });

                /**
                 * Open Form
                 */
                function openForm()
                {
                    iElement.hide();

                    formEl = $compile(form)(scope);

                    listContent.append(formEl);

                    scrollListContentBottom();

                    formEl.find('input').focus();

                    $timeout(function ()
                    {
                        $document.on('click', outSideClick);
                    });
                }

                /**
                 * Close Form
                 */
                function closeForm()
                {
                    formEl.remove();

                    iElement.next().remove();

                    iElement.show();

                    PerfectScrollbar.update(listContent[0]);

                    // Clean
                    $document.off('click', outSideClick);
                    scope.$on('$destroy', function ()
                    {
                        $document.off('click', outSideClick);
                    });
                }

                /**
                 * Scroll List to the Bottom
                 */
                function scrollListContentBottom()
                {
                    listContent[0].scrollTop = listContent[0].scrollHeight;
                }

                /**
                 * Click Outside Event Handler
                 * @param event
                 */
                var outSideClick = function (event)
                {
                    var isChild = formEl.has(event.target).length > 0;
                    var isSelf = formEl[0] == event.target;
                    var isInside = isChild || isSelf;

                    if ( !isInside )
                    {
                        closeForm();
                    }
                }

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCardDialogController', ScrumboardCardDialogController);

    /** @ngInject */
    function ScrumboardCardDialogController($document, $mdDialog, fuseTheming, fuseGenerator, msUtils, BoardService, cardId)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.card = vm.board.cards.getById(cardId);
        vm.newLabelColor = 'red';
        vm.members = vm.board.members;
        vm.labels = vm.board.labels;

        // Methods
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.rgba = fuseGenerator.rgba;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.closeDialog = closeDialog;
        vm.getCardList = getCardList;
        vm.removeCard = removeCard;
        /* Attachment */
        vm.toggleCoverImage = toggleCoverImage;
        vm.removeAttachment = removeAttachment;
        /* Labels */
        vm.labelQuerySearch = labelQuerySearch;
        vm.filterLabel = filterLabel;
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;
        /* Members */
        vm.memberQuerySearch = memberQuerySearch;
        vm.filterMember = filterMember;
        /* Checklist */
        vm.updateCheckedCount = updateCheckedCount;
        vm.addCheckItem = addCheckItem;
        vm.removeChecklist = removeChecklist;
        vm.createCheckList = createCheckList;
        /* Comment */
        vm.addNewComment = addNewComment;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Get Card List
         */
        function getCardList()
        {
            var response;
            for ( var i = 0, len = vm.board.lists.length; i < len; i++ )
            {
                if ( vm.board.lists[i].idCards.indexOf(vm.card.id) > -1 )
                {
                    response = vm.board.lists[i];
                    break;
                }
            }
            return response;
        }

        /**
         * Remove card
         *
         * @param ev
         */
        function removeCard(ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Card',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove card?',
                ariaLabel          : 'remove card',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var cardList = getCardList();

                cardList.idCards.splice(cardList.idCards.indexOf(vm.card.id), 1);

                vm.board.cards.splice(vm.board.cards.indexOf(vm.card), 1);

            }, function ()
            {
                // Canceled
            });
        }

        /**
         * Toggle cover image
         *
         * @param attachmentId
         */
        function toggleCoverImage(attachmentId)
        {
            if ( attachmentId === vm.card.idAttachmentCover )
            {
                vm.card.idAttachmentCover = null;
            }
            else
            {
                vm.card.idAttachmentCover = attachmentId;
            }
        }

        /**
         * Remove attachment
         *
         * @param item
         */
        function removeAttachment(item)
        {
            if ( vm.card.idAttachmentCover === item.id )
            {
                vm.card.idAttachmentCover = '';
            }
            vm.card.attachments.splice(vm.card.attachments.indexOf(item), 1);
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query)
        {
            return query ? vm.labels.filter(createFilterFor(query)) : [];
        }

        /**
         * Label filter
         *
         * @param label
         * @returns {boolean}
         */
        function filterLabel(label)
        {
            if ( !vm.labelSearchText || vm.labelSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(label.name).indexOf(angular.lowercase(vm.labelSearchText)) >= 0;
        }

        /**
         * Add new label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                "id"   : msUtils.guidGenerator(),
                "name" : vm.newLabelName,
                "color": vm.newLabelColor
            });

            vm.newLabelName = '';
        }

        /**
         * Remove label
         */
        function removeLabel()
        {
            var arr = vm.board.labels;
            arr.splice(arr.indexOf(arr.getById(vm.editLabelId)), 1);

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.idLabels && card.idLabels.indexOf(vm.editLabelId) > -1 )
                {
                    card.idLabels.splice(card.idLabels.indexOf(vm.editLabelId), 1);
                }
            });

            vm.newLabelName = '';
        }

        /**
         * Add member chips
         *
         * @param query
         * @returns {Array}
         */
        function memberQuerySearch(query)
        {
            return query ? vm.members.filter(createFilterFor(query)) : [];
        }

        /**
         * Member filter
         *
         * @param member
         * @returns {boolean}
         */
        function filterMember(member)
        {
            if ( !vm.memberSearchText || vm.memberSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(member.name).indexOf(angular.lowercase(vm.memberSearchText)) >= 0;
        }

        /**
         * Update check list stats
         * @param list
         */
        function updateCheckedCount(list)
        {
            var checkItems = list.checkItems;
            var checkedItems = 0;
            var allCheckedItems = 0;
            var allCheckItems = 0;

            angular.forEach(checkItems, function (checkItem)
            {
                if ( checkItem.checked )
                {
                    checkedItems++;
                }
            });

            list.checkItemsChecked = checkedItems;

            angular.forEach(vm.card.checklists, function (item)
            {
                allCheckItems += item.checkItems.length;
                allCheckedItems += item.checkItemsChecked;
            });

            vm.card.checkItems = allCheckItems;
            vm.card.checkItemsChecked = allCheckedItems;
        }

        /**
         * Add checklist item
         *
         * @param text
         * @param checkList
         */
        function addCheckItem(text, checkList)
        {
            if ( !text || text === '' )
            {
                return;
            }

            var newCheckItem = {
                'name'   : text,
                'checked': false
            };

            checkList.checkItems.push(newCheckItem);

            updateCheckedCount(checkList);
        }

        /**
         * Remove checklist
         *
         * @param item
         */
        function removeChecklist(item)
        {
            vm.card.checklists.splice(vm.card.checklists.indexOf(item), 1);

            angular.forEach(vm.card.checklists, function (list)
            {
                updateCheckedCount(list);
            });
        }

        /**
         * Create checklist
         */
        function createCheckList()
        {
            vm.card.checklists.push({
                "id"               : msUtils.guidGenerator(),
                "name"             : vm.newCheckListTitle,
                "checkItemsChecked": 0,
                "checkItems"       : []
            });

            vm.newCheckListTitle = '';
        }

        /**
         * Add new comment
         *
         * @param newCommentText
         */
        function addNewComment(newCommentText)
        {
            var newComment = {
                "idMember": "36027j1930450d8bf7b10158",
                "message" : newCommentText,
                "time"    : "now"
            };

            vm.card.comments.unshift(newComment);
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query)
        {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item)
            {
                return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
            };
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mail', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, $httpProvider, msNavigationServiceProvider)
    {
		$httpProvider.defaults.useXDomain = true;
        // State
        $stateProvider.state('app.mail', {
            url      : '/mail',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/mail/mail.html',
                    controller : 'MailController as vm'
                }
            },
            resolve  : {
                Inbox: function (apiResolver)
                {
                    return apiResolver.resolve('mail.inbox@get');
                }
            },
            bodyClass: 'mail'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/mail');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.mail', {
            title : 'Сообщения',
            icon  : 'icon-email',
            state : 'app.mail',
            badge : {
                content: 8,
                color  : '#F44336'
            },
            weight: 2
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('ComposeDialogController', ComposeDialogController);

    /** @ngInject */
    function ComposeDialogController($mdDialog, selectedMail)
    {
        var vm = this;

        // Data
        vm.form = {
            from: 'johndoe@creapond.com'
        };

        vm.hiddenCC = true;
        vm.hiddenBCC = true;

        // If replying
        if ( angular.isDefined(selectedMail) )
        {
            vm.form.to = selectedMail.from.email;
            vm.form.subject = 'RE: ' + selectedMail.subject;
            vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        }

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.calendar', [
            'ui.calendar'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
            bodyClass: 'calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/calendar');
		
		// Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title : 'Панель управления',
            group : true,
            weight: 0
        });

        msNavigationServiceProvider.saveItem('apps.calendar', {
            title : 'Календарь',
            icon  : 'icon-calendar-today',
            state : 'app.calendar',
            weight: 1
        });
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 минут назад', '30 минут назад', '1 час назад'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogTitle = (vm.dialogData.type === 'add' ? 'Создать событие' : 'Редактировать событие');

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake the Full Calendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        function saveEvent()
        {
            var response = {
                type         : vm.dialogData.type,
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }

        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editflat', ['datatables','ngResource','angularFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_editflat', {
            url    : '/objects/edit/flat/{id:int}',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/editobject/editflat/editflat.html',
                    controller : 'EditFlatController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }




})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editflat')
        .controller('EditFlatController', EditFlatController);
  
    /** @ngInject */
    function EditFlatController($scope, $mdDialog, $location, FileUploader, api)
    {
        var vm = this;
        // Data
        vm.formWizard = {};       

		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
		//типы населенных пунктов
        vm.city_types = [{'socr': 'г', 'name': 'город'}, 
						{'socr': 'г.о.', 'name': 'городской округ'}, 
						{'socr': 'п', 'name': 'поселение/поселок'},
						{'socr': 'дп', 'name': 'дачный поселок'},
						{'socr': 'кп', 'name': 'курортный поселок'},
						{'socr': 'пгт', 'name': 'поселок городского типа'},
						{'socr': 'рп', 'name': 'рабочий поселок'},
						{'socr': 'с/п', 'name': 'сельское поселение'},
						{'socr': 'д', 'name': 'деревня'},
						{'socr': 'с', 'name': 'село'},
						{'socr': 'сл', 'name': 'слобода'},
						{'socr': 'снт', 'name': 'СНТ'},
						{'socr': 'жилрайон', 'name': 'жилой район'},
						{'socr': 'кв-л', 'name': 'квартал'},
						{'socr': 'мкр', 'name': 'микрорайон'},
						{'socr': 'нп', 'name': 'населенный пункт'},
						{'socr': 'тер', 'name': 'территория'},
						{'socr': 'промзона', 'name': 'промышленная зона'}];
						
		//названия нас.пунктов и улицы подгружаем после выбора
		vm.districts = {};
		vm.cities = {};
		vm.streets = {};
		
		//Список метро и направлений
		api.objects.metrostations.query({}, function(data) {			
				vm.metrostations = data;
				});				
		api.objects.directions.query({}, function(data) {			
				vm.directions = data;
				});
				
		api.contacts.my_clients.query({}, function(data) {			
				vm.my_clients = data;
				});
		
		vm.metro_time_list = [{'name': 'f_2', 'rusname': '2 минуты пешком'}, 
						{'name': 'f_5', 'rusname': '5 минут пешком'}, 
						{'name': 'f_7', 'rusname': '7 минут пешком'},
						{'name': 'f_10', 'rusname': '10 минут пешком'},
						{'name': 'f_15', 'rusname': '15 минут пешком'},
						{'name': 'f_20', 'rusname': '20 минут пешком'},
						{'name': 't_5', 'rusname': '5 минут транспортом'},
						{'name': 't_10', 'rusname': '10 минут транспортом'},
						{'name': 't_15', 'rusname': '15 минут транспортом'},
						{'name': 't_20', 'rusname': '20 минут транспортом'}];
		
		//тип объекта
		vm.object_types = [{'name': 'flat', 'rusname': 'Квартира'}, 
						{'name': 'flat_new_building', 'rusname': 'Квартира в новостройке'}, 
						{'name': 'room', 'rusname': 'Комната'},
						{'name': 'part', 'rusname': 'Доля в квартире'},
						{'name': 'penthouse', 'rusname': 'Пентхаус'}];
		
        //тип объекта 2
		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'}, 
						{'name': 'hog-wash', 'rusname': 'Утка'}, 
						{'name': 'auction', 'rusname': 'Аукцион'},
						{'name': 'invest', 'rusname': 'Инвестиционный'}];
		
		//источник
		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'}, 
						{'id': '2', 'rusname': 'Расклейка'}, 
						{'id': '3', 'rusname': 'Баннер'},
						{'id': '4', 'rusname': 'Рекомендация'},
						{'id': '5', 'rusname': 'База собственников'},
						{'id': '6', 'rusname': 'База заявок'},
						{'id': '7', 'rusname': 'Диспетчерская'},
						{'id': '8', 'rusname': 'Avito'},
						{'id': '9', 'rusname': 'Другие сайты'},
						{'id': '10', 'rusname': 'Сам нашел'}];
						
		//тип комиссии
		vm.commission_types = [{'name': 'percent', 'rusname': '%'}, 
						{'name': 'sum', 'rusname': 'руб.'}];
		
		//типы сделок
		vm.deal_types = [{'name': 'rent', 'rusname': 'Аренда'},
						{'name': 'change', 'rusname': 'Альтернатива'},
						{'name': 'sale', 'rusname': 'Продажа'}];
		
        vm.rent_durations = [{'name': 'short', 'rusname': 'Несколько месяцев'},
						{'name': 'long', 'rusname': 'Длительный срок'},
						{'name': 'day', 'rusname': 'Посуточно'}];
						
		vm.pay_durations = [{'name': 'month', 'rusname': 'ежемесячно'},
							{'name': 'day', 'rusname': 'посуточно'}];	
							
        //типы комнат для квартиры
        vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'}, 
						{'name': '2', 'rusname': 'Двухкомнатная'}, 
						{'name': '3', 'rusname': 'Трехкомнатная'},
						{'name': '4', 'rusname': 'Четырехкомнатная'},
						{'name': '5', 'rusname': 'Пятикомнатная'},
						{'name': 'm', 'rusname': 'Многокомнатная'},
						{'name': 'studio', 'rusname': 'Студия'}];
						
		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'}, 
						{'name': 'no', 'rusname': 'Нет'}];				
		//телефон			
		vm.phone_types = [{'name': 'yes', 'rusname': 'Есть'}, 
						{'name': 'para', 'rusname': 'Спаренный'},
						{'name': 'possible', 'rusname': 'Возможно подключить'},
						{'name': 'no', 'rusname': 'Нет'}];
		//мебель
		vm.furniture_types = [{'name': 'no', 'rusname': 'Нет'}, 
						{'name': 'old', 'rusname': 'Старая'},
						{'name': '90s', 'rusname': 'Мебель 90-х'},
						{'name': 'modern', 'rusname': 'Современная'}];	
		//ремонт
		vm.repairs_types = [{'name': 'no', 'rusname': 'Без ремонта'},
						{'name': 'cosmetic', 'rusname': 'Косметический'},
						{'name': 'capital', 'rusname': 'Капитальный'},
						{'name': 'euro', 'rusname': 'Евро'}];
		//типы санузла
		vm.types_bathroom = [{'name': 'separated', 'rusname': 'Раздельный'}, 
						{'name': 'combined', 'rusname': 'Совмещенный'}];

		//право собственности
		vm.ownership_types = [{'name': 'primary', 'rusname': 'Первичная приватизация'}, 
						{'name': 'contract-sales', 'rusname': 'Договор купли/продажи'}, 
						{'name': 'contract-donat', 'rusname': 'Договор дарения'},
						{'name': 'contract-rent', 'rusname': 'Договор ренты'},
						{'name': 'paid', 'rusname': 'ЖСК, выплаченный пай'},
						{'name': 'legacy', 'rusname': 'Наследство'},
						{'name': 'court', 'rusname': 'Решение суда'},
						{'name': 'mortgage', 'rusname': 'Залог (ипотека)'},
						{'name': 'invest', 'rusname': 'По договору инвестирования'}];	   
		//Тип дома
		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'}, 
						{'name': 'panel', 'rusname': 'Панельный'}, 
						{'name': 'brick', 'rusname': 'Кирпичный'},
						{'name': 'wood', 'rusname': 'Деревянный'},
						{'name': 'stalin', 'rusname': 'Сталинский'},
						{'name': 'monolith', 'rusname': 'Монолит'},
						{'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'}];	
		 
		//Статус
		vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
						{'name': 'free', 'rusname': 'Свободна'},
						{'name': 'patrol', 'rusname': 'Расселение/разъед'},
						{'name': 'alternate', 'rusname': 'Альтернатива'}];
		//Лифт
		vm.lift_types = [{'name': 'pass', 'rusname': 'Пассажирский'},
						{'name': 'serv', 'rusname': 'Грузовой'},
						{'name': 'passserv', 'rusname': 'Пасс. + груз.'},
						{'name': 'no', 'rusname': 'Нет'}];
		//Балкон
		vm.balcony_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'loggia', 'rusname': 'Лоджия'},
						{'name': '2balcon', 'rusname': '2 балкона'},
						{'name': '2loggia', 'rusname': '2 лоджии'}];
		//В собственности
		vm.years_own_types = [{'name': 'less3', 'rusname': 'Менее 3 лет'}, 
						{'name': 'more3', 'rusname': 'Более 3 лет'}];	
										
        //получаем id объекта, который будем редактировать
        vm.objectId = $location.path().split('/');
        vm.objectId = vm.objectId[vm.objectId.length-1];
        //id главного изображения
        vm.mainImage = 0;
        //информацию по объекту
		api.objects.objectbyid.query({'id':vm.objectId}, function(data) {
				//console.log(data);		
				vm.formWizard.region = parseInt(data.region);										
				vm.formWizard.district = parseInt(data.district);
				vm.formWizard.city_type = data.city_type;				
				vm.formWizard.city = data.city;
				vm.formWizard.street = data.street;
				vm.formWizard.house_number = data.house_number;
				//загружаем адрес полностью
				loadAddress();
				//id главного изображения
				vm.mainImage = (parseInt(data.image)==0)?0:data.image;
				
				vm.formWizard.object_type = data.object_type;
				vm.formWizard.object_type_2 = data.object_type_2;
				vm.formWizard.direction = data.direction;
				vm.formWizard.metro_1 = data.metro_1;
				vm.formWizard.metro_2 = data.metro_2;
				vm.formWizard.metro_3 = data.metro_3;
				vm.formWizard.metro_1_time = data.metro_1_time;
				vm.formWizard.metro_2_time = data.metro_2_time;
				vm.formWizard.metro_3_time = data.metro_3_time;
				vm.formWizard.deal_type = data.deal_type;
				vm.formWizard.source_id = data.source_id;
				vm.formWizard.part_percent = data.part_percent;
				vm.formWizard.rentcost = data.rentcost;
				vm.formWizard.rent_duration = data.rent_duration;
				vm.formWizard.pay_duration = data.pay_duration;
				vm.formWizard.cost = parseInt(data.cost);
				vm.formWizard.commission = parseInt(data.commission);
				vm.formWizard.commission_type = data.commission_type;
				vm.formWizard.rooms_number = data.rooms_number;
				vm.formWizard.story = parseInt(data.story);
				vm.formWizard.story_count = parseInt(data.story_count);
				vm.formWizard.tech_4 = data.tech_4;
				vm.formWizard.tech_8 = data.tech_8;
				vm.formWizard.furniture = data.furniture;
				vm.formWizard.repairs = data.repairs;
				vm.formWizard.flat_status = data.flat_status;
				vm.formWizard.years_own = data.years_own;
				vm.formWizard.balcony = data.balcony;
				vm.formWizard.ownership = data.ownership;
				vm.formWizard.type_bild = data.type_bild;
				vm.formWizard.lift = data.lift;
				vm.formWizard.type_bathroom = data.type_bathroom;
				vm.formWizard.count_bathroom_flat = data.count_bathroom_flat;
				vm.formWizard.inet = data.inet;
				vm.formWizard.phone = data.phone;
				vm.formWizard.square_all = parseInt(data.square_all);
				vm.formWizard.square_living = parseInt(data.square_living);
				vm.formWizard.square_kitchen = parseInt(data.square_kitchen);
				vm.formWizard.square_rooms = data.square_rooms;
				vm.formWizard.description = data.description;
				vm.formWizard.description_en = data.description_en;
				vm.formWizard.creator_id = data.creator_id;				
				vm.formWizard.owner_id = parseInt(data.owner_id);				
		});
		
		updatePhotos();
		
		//опции
		vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            searching: false,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				{ "orderable": false },				
				{ "orderable": false },
				{ "orderable": false }
			  ],
			  "order": [0, "desc"]			
        };	
				
        // Methods
        vm.sendForm = sendForm;
		vm.loadDistricts = loadDistricts;
		vm.loadCities = loadCities;
		vm.loadStreets = loadStreets;
		vm.changeRoomTypes = changeRoomTypes;
		vm.changeFlatStatuses = changeFlatStatuses;
		vm.loadAddress = loadAddress;
		vm.updatePhotos = updatePhotos;
		vm.successLoadPhotosMessage = successLoadPhotosMessage;
		vm.removePhoto = removePhoto;
		vm.setMainPhoto = setMainPhoto;		
		vm.reloadData = reloadData;
		
		//vm.total = 0;
		vm.dtInstance = {};
		
		function reloadData() {
			var resetPaging = true;
			vm.dtInstance.reloadData(callback, resetPaging);
			//vm.dtInstance.reload();
		}

		function callback(json) {
			console.log(json);
		}
    
		//устанавливаем фотографию главной
		function setMainPhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var mainphoto = new api.objects.mainphoto();					
					mainphoto.id = id;
					mainphoto.$save();
					
					vm.mainImage = id;
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография помечена как главная</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),                               
                clickOutsideToClose: true
            });
		}
		
		//////////удаление фотографии
		function removePhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var archivephoto = new api.objects.archivephoto();					
					archivephoto.id = id;
					archivephoto.$save();
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография удалена</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),                               
                clickOutsideToClose: true
            });
            //обновляем список фотографий и таблицу сразу после загрузки
				updatePhotos();
				reloadData();
				vm.photos = null;
		}
		//////////обновление таблицы фотографий
		function updatePhotos()
        {			
			//TODO обновлять на ходу таблицу фото
			//получаем уже загруженные фотографии		
			api.objects.objectphotosbyid.query({'id':vm.objectId}, function(data) {
				vm.photos = data.data;
				
				//меняем адреса изображений
				for(var i=0; i < vm.photos.length;i++){
					vm.photos[i].filename = api.localhost_backend + "uploads/" + vm.photos[i].filename;
				}				
			});
		}
		//Сообщение, что фото загружены
		function successLoadPhotosMessage()
        {
			$mdDialog.show({
					controller         : function ($scope, $mdDialog)
					{
						$scope.closeDialog = function ()
						{
							$mdDialog.hide();
						}
					},
					template: '<md-dialog>' +
					'  <md-dialog-content><h1>Фотографии успешно добавлены</h1></md-dialog-content>' +
					'  <md-dialog-actions>' +
					'    <md-button ng-click="closeDialog()" class="md-primary">' +
					'      Закрыть' +
					'    </md-button>' +
					'  </md-dialog-actions>' +
					'</md-dialog>',
					parent             : angular.element('body'),
					clickOutsideToClose: true
				});
				//обновляем список фотографий и таблицу сразу после загрузки
				updatePhotos();
				reloadData();
		}
        //////////первоначальная загрузка адреса редактируемого объекта
        function loadAddress()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {			
				vm.districts = data;
				//vm.formWizard.district = id;					
					var index_district = 0;
					//определяем реальный порядковый номер в массиве
					for (var i = 0; i < vm.districts.length; i++) 
						if (vm.districts[i]['id'] == vm.formWizard.district) {
							index_district = i;
							api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {			
								vm.cities = data;
								var index_city = 0;
								//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
								//его код КЛАДР
								for (var i = 0; i < vm.cities.length; i++) 
									if (vm.cities[i]['name'] == vm.formWizard.city) {
										index_city = i;
										//TODO оптимизировать загрузку улиц				
										api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {			
											vm.streets = data;											
										});
								}
							});
					}
				});	
		}
        //////////оставляем те же функции, что и при создании
        function loadDistricts()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {			
				vm.districts = data;
				//обнуляем все, что ниже иерархически
				vm.cities = {};
				vm.streets = {};
				//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.district = null;
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;
				//для Москвы выбираем любой район, так как район города необязателен
				if (vm.formWizard.region == 1) {					
					vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
					loadCities();
					}
				});	
		}
		
		function loadCities()
        {	
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;
				
			if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
				vm.cities = {};				
			} else {		
				var index_district = 0;
				//определяем реальный порядковый номер в массиве
				for (var i = 0; i < vm.districts.length; i++) 
					if (vm.districts[i]['id'] == vm.formWizard.district) {
						index_district = i;
						api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {			
							vm.cities = data;
							});
				}			
			}
			vm.streets = {};			
		}		
		
		function loadStreets()
        {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
			vm.formWizard.street = null;
			vm.formWizard.house_number = null;

			if (!vm.formWizard.city) {
				vm.streets = {};
			} else {
				var index_city = 0;
				//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
				//его код КЛАДР
				for (var i = 0; i < vm.cities.length; i++) 
					if (vm.cities[i]['name'] == vm.formWizard.city) {
						index_city = i;
						//TODO оптимизировать загрузку улиц				
						api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {			
							vm.streets = data;
						});
				}		
			}
		}
		
		function changeFlatStatuses() {
		 if (vm.formWizard.deal_type == 'change') {
			 vm.flat_status_types = [{'name': 'patrol', 'rusname': 'Расселение/разъед'},
									 {'name': 'alternate', 'rusname': 'Альтернатива'}];
			  vm.formWizard.flat_status = 'alternate';
			} else {
			 vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
				{'name': 'free', 'rusname': 'Свободна'},
				{'name': 'patrol', 'rusname': 'Расселение/разъед'}];			
			}		 
		}
		
		function changeRoomTypes() {
			switch (vm.formWizard.object_type) {
				//типы комнат для квартиры, новостройки, пентхауса
				case 'flat_new_building': //doNothing
				case 'penthouse': //doNothing
				case 'flat': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'}, 
										{'name': '2', 'rusname': 'Двухкомнатная'}, 
										{'name': '3', 'rusname': 'Трехкомнатная'},
										{'name': '4', 'rusname': 'Четырехкомнатная'},
										{'name': '5', 'rusname': 'Пятикомнатная'},
										{'name': 'm', 'rusname': 'Многокомнатная'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
				case 'part': vm.rooms_type_list = [{'name': 'd_1', 'rusname': 'Доля в однокомнатной'}, 
										{'name': 'd_2', 'rusname': 'Доля в двухкомнатной'}, 
										{'name': 'd_3', 'rusname': 'Доля в трехкомнатной'},
										{'name': 'd_4', 'rusname': 'Доля в четырехкомнатной'},
										{'name': 'd_5', 'rusname': 'Доля в пятикомнатной'}];
										break
				case 'room': vm.rooms_type_list = [{'name': '1_2', 'rusname': 'Комната в двухкомнатной'}, 
										{'name': '1_3', 'rusname': 'Комната в трехкомнатной'}, 
										{'name': '1_4', 'rusname': 'Комната в четырехкомнатной'},
										{'name': '1_5', 'rusname': 'Комната в пятикомнатной'},
										{'name': '2_3', 'rusname': '2 комнаты в трехкомнатной'},
										{'name': '2_4', 'rusname': '2 комнаты в четырехкомнатной'},
										{'name': '2_5', 'rusname': '2 комнаты в пятикомнатной'},
										{'name': '3_4', 'rusname': '3 комнаты в четырехкомнатной'},
										{'name': '3_5', 'rusname': '3 комнаты в пятикомнатной'}];
										break											
					  }
		}
		
        function sendForm(ev)
        {			
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
		
					var newobject = new api.objects.newobjectdata();					
					newobject.data = formWizardData;
					newobject.$save();
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flats');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект успешно создан</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}
	
	///////////////////////Загрузка фотографий
	var uploader = $scope.uploader = new FileUploader({
			//инкапсулируем скрипт загрузки в общий модуль, чтобы проверять авторизацию
            url: api.localhost_backend + 'upload',
            removeAfterUpload: true,
			formData: {'id':vm.objectId}
        });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        //События Callbacks
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
        };
        uploader.onAfterAddingFile = function(fileItem) {
            console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
            console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function(item) {
            console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            console.info('onCompleteAll');
        };
        console.info('uploader', uploader);
        
  }    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editflat')
        .controller('EditFlatController', EditFlatController);
  
    /** @ngInject */
    function EditFlatController($scope, $mdDialog, $location, FileUploader, api)
    {
        var vm = this;
        // Data
        vm.formWizard = {};       

		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
		//типы населенных пунктов
        vm.city_types = [{'socr': 'г', 'name': 'город'}, 
						{'socr': 'г.о.', 'name': 'городской округ'}, 
						{'socr': 'п', 'name': 'поселение/поселок'},
						{'socr': 'дп', 'name': 'дачный поселок'},
						{'socr': 'кп', 'name': 'курортный поселок'},
						{'socr': 'пгт', 'name': 'поселок городского типа'},
						{'socr': 'рп', 'name': 'рабочий поселок'},
						{'socr': 'с/п', 'name': 'сельское поселение'},
						{'socr': 'д', 'name': 'деревня'},
						{'socr': 'с', 'name': 'село'},
						{'socr': 'сл', 'name': 'слобода'},
						{'socr': 'снт', 'name': 'СНТ'},
						{'socr': 'жилрайон', 'name': 'жилой район'},
						{'socr': 'кв-л', 'name': 'квартал'},
						{'socr': 'мкр', 'name': 'микрорайон'},
						{'socr': 'нп', 'name': 'населенный пункт'},
						{'socr': 'тер', 'name': 'территория'},
						{'socr': 'промзона', 'name': 'промышленная зона'}];
						
		//названия нас.пунктов и улицы подгружаем после выбора
		vm.districts = {};
		vm.cities = {};
		vm.streets = {};
		
		//Список метро и направлений
		api.objects.metrostations.query({}, function(data) {			
				vm.metrostations = data;
				});				
		api.objects.directions.query({}, function(data) {			
				vm.directions = data;
				});
				
		api.contacts.my_clients.query({}, function(data) {			
				vm.my_clients = data;
				});
		
		vm.metro_time_list = [{'name': 'f_2', 'rusname': '2 минуты пешком'}, 
						{'name': 'f_5', 'rusname': '5 минут пешком'}, 
						{'name': 'f_7', 'rusname': '7 минут пешком'},
						{'name': 'f_10', 'rusname': '10 минут пешком'},
						{'name': 'f_15', 'rusname': '15 минут пешком'},
						{'name': 'f_20', 'rusname': '20 минут пешком'},
						{'name': 't_5', 'rusname': '5 минут транспортом'},
						{'name': 't_10', 'rusname': '10 минут транспортом'},
						{'name': 't_15', 'rusname': '15 минут транспортом'},
						{'name': 't_20', 'rusname': '20 минут транспортом'}];
		
		//тип объекта
		vm.object_types = [{'name': 'flat', 'rusname': 'Квартира'}, 
						{'name': 'flat_new_building', 'rusname': 'Квартира в новостройке'}, 
						{'name': 'room', 'rusname': 'Комната'},
						{'name': 'part', 'rusname': 'Доля в квартире'},
						{'name': 'penthouse', 'rusname': 'Пентхаус'}];
		
        //тип объекта 2
		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'}, 
						{'name': 'hog-wash', 'rusname': 'Утка'}, 
						{'name': 'auction', 'rusname': 'Аукцион'},
						{'name': 'invest', 'rusname': 'Инвестиционный'}];
		
		//источник
		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'}, 
						{'id': '2', 'rusname': 'Расклейка'}, 
						{'id': '3', 'rusname': 'Баннер'},
						{'id': '4', 'rusname': 'Рекомендация'},
						{'id': '5', 'rusname': 'База собственников'},
						{'id': '6', 'rusname': 'База заявок'},
						{'id': '7', 'rusname': 'Диспетчерская'},
						{'id': '8', 'rusname': 'Avito'},
						{'id': '9', 'rusname': 'Другие сайты'},
						{'id': '10', 'rusname': 'Сам нашел'}];
						
		//тип комиссии
		vm.commission_types = [{'name': 'percent', 'rusname': '%'}, 
						{'name': 'sum', 'rusname': 'руб.'}];
		
		//типы сделок
		vm.deal_types = [{'name': 'rent', 'rusname': 'Аренда'},
						{'name': 'change', 'rusname': 'Альтернатива'},
						{'name': 'sale', 'rusname': 'Продажа'}];
		
        vm.rent_durations = [{'name': 'short', 'rusname': 'Несколько месяцев'},
						{'name': 'long', 'rusname': 'Длительный срок'},
						{'name': 'day', 'rusname': 'Посуточно'}];
						
		vm.pay_durations = [{'name': 'month', 'rusname': 'ежемесячно'},
							{'name': 'day', 'rusname': 'посуточно'}];	
							
        //типы комнат для квартиры
        vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'}, 
						{'name': '2', 'rusname': 'Двухкомнатная'}, 
						{'name': '3', 'rusname': 'Трехкомнатная'},
						{'name': '4', 'rusname': 'Четырехкомнатная'},
						{'name': '5', 'rusname': 'Пятикомнатная'},
						{'name': 'm', 'rusname': 'Многокомнатная'},
						{'name': 'studio', 'rusname': 'Студия'}];
						
		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'}, 
						{'name': 'no', 'rusname': 'Нет'}];				
		//телефон			
		vm.phone_types = [{'name': 'yes', 'rusname': 'Есть'}, 
						{'name': 'para', 'rusname': 'Спаренный'},
						{'name': 'possible', 'rusname': 'Возможно подключить'},
						{'name': 'no', 'rusname': 'Нет'}];
		//мебель
		vm.furniture_types = [{'name': 'no', 'rusname': 'Нет'}, 
						{'name': 'old', 'rusname': 'Старая'},
						{'name': '90s', 'rusname': 'Мебель 90-х'},
						{'name': 'modern', 'rusname': 'Современная'}];	
		//ремонт
		vm.repairs_types = [{'name': 'no', 'rusname': 'Без ремонта'},
						{'name': 'cosmetic', 'rusname': 'Косметический'},
						{'name': 'capital', 'rusname': 'Капитальный'},
						{'name': 'euro', 'rusname': 'Евро'}];
		//типы санузла
		vm.types_bathroom = [{'name': 'separated', 'rusname': 'Раздельный'}, 
						{'name': 'combined', 'rusname': 'Совмещенный'}];

		//право собственности
		vm.ownership_types = [{'name': 'primary', 'rusname': 'Первичная приватизация'}, 
						{'name': 'contract-sales', 'rusname': 'Договор купли/продажи'}, 
						{'name': 'contract-donat', 'rusname': 'Договор дарения'},
						{'name': 'contract-rent', 'rusname': 'Договор ренты'},
						{'name': 'paid', 'rusname': 'ЖСК, выплаченный пай'},
						{'name': 'legacy', 'rusname': 'Наследство'},
						{'name': 'court', 'rusname': 'Решение суда'},
						{'name': 'mortgage', 'rusname': 'Залог (ипотека)'},
						{'name': 'invest', 'rusname': 'По договору инвестирования'}];	   
		//Тип дома
		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'}, 
						{'name': 'panel', 'rusname': 'Панельный'}, 
						{'name': 'brick', 'rusname': 'Кирпичный'},
						{'name': 'wood', 'rusname': 'Деревянный'},
						{'name': 'stalin', 'rusname': 'Сталинский'},
						{'name': 'monolith', 'rusname': 'Монолит'},
						{'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'}];	
		 
		//Статус
		vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
						{'name': 'free', 'rusname': 'Свободна'},
						{'name': 'patrol', 'rusname': 'Расселение/разъед'},
						{'name': 'alternate', 'rusname': 'Альтернатива'}];
		//Лифт
		vm.lift_types = [{'name': 'pass', 'rusname': 'Пассажирский'},
						{'name': 'serv', 'rusname': 'Грузовой'},
						{'name': 'passserv', 'rusname': 'Пасс. + груз.'},
						{'name': 'no', 'rusname': 'Нет'}];
		//Балкон
		vm.balcony_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'loggia', 'rusname': 'Лоджия'},
						{'name': '2balcon', 'rusname': '2 балкона'},
						{'name': '2loggia', 'rusname': '2 лоджии'}];
		//В собственности
		vm.years_own_types = [{'name': 'less3', 'rusname': 'Менее 3 лет'}, 
						{'name': 'more3', 'rusname': 'Более 3 лет'}];	
										
        //получаем id объекта, который будем редактировать
        vm.objectId = $location.path().split('/');
        vm.objectId = vm.objectId[vm.objectId.length-1];
        //id главного изображения
        vm.mainImage = 0;
        //информацию по объекту
		api.objects.objectbyid.query({'id':vm.objectId}, function(data) {
				//console.log(data);		
				vm.formWizard.region = parseInt(data.region);										
				vm.formWizard.district = parseInt(data.district);
				vm.formWizard.city_type = data.city_type;				
				vm.formWizard.city = data.city;
				vm.formWizard.street = data.street;
				vm.formWizard.house_number = data.house_number;
				//загружаем адрес полностью
				loadAddress();
				//id главного изображения
				vm.mainImage = (parseInt(data.image)==0)?0:data.image;
				
				vm.formWizard.object_type = data.object_type;
				vm.formWizard.object_type_2 = data.object_type_2;
				vm.formWizard.direction = data.direction;
				vm.formWizard.metro_1 = data.metro_1;
				vm.formWizard.metro_2 = data.metro_2;
				vm.formWizard.metro_3 = data.metro_3;
				vm.formWizard.metro_1_time = data.metro_1_time;
				vm.formWizard.metro_2_time = data.metro_2_time;
				vm.formWizard.metro_3_time = data.metro_3_time;
				vm.formWizard.deal_type = data.deal_type;
				vm.formWizard.source_id = data.source_id;
				vm.formWizard.part_percent = data.part_percent;
				vm.formWizard.rentcost = data.rentcost;
				vm.formWizard.rent_duration = data.rent_duration;
				vm.formWizard.pay_duration = data.pay_duration;
				vm.formWizard.cost = parseInt(data.cost);
				vm.formWizard.commission = parseInt(data.commission);
				vm.formWizard.commission_type = data.commission_type;
				vm.formWizard.rooms_number = data.rooms_number;
				vm.formWizard.story = parseInt(data.story);
				vm.formWizard.story_count = parseInt(data.story_count);
				vm.formWizard.tech_4 = data.tech_4;
				vm.formWizard.tech_8 = data.tech_8;
				vm.formWizard.furniture = data.furniture;
				vm.formWizard.repairs = data.repairs;
				vm.formWizard.flat_status = data.flat_status;
				vm.formWizard.years_own = data.years_own;
				vm.formWizard.balcony = data.balcony;
				vm.formWizard.ownership = data.ownership;
				vm.formWizard.type_bild = data.type_bild;
				vm.formWizard.lift = data.lift;
				vm.formWizard.type_bathroom = data.type_bathroom;
				vm.formWizard.count_bathroom_flat = data.count_bathroom_flat;
				vm.formWizard.inet = data.inet;
				vm.formWizard.phone = data.phone;
				vm.formWizard.square_all = parseInt(data.square_all);
				vm.formWizard.square_living = parseInt(data.square_living);
				vm.formWizard.square_kitchen = parseInt(data.square_kitchen);
				vm.formWizard.square_rooms = data.square_rooms;
				vm.formWizard.description = data.description;
				vm.formWizard.description_en = data.description_en;
				vm.formWizard.creator_id = data.creator_id;				
				vm.formWizard.owner_id = parseInt(data.owner_id);				
		});
		
		//updatePhotos();
		
		//опции
		vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            searching: false,
            bServerSide: true,
            sAjaxSource: api.localhost_backend + 'object/photos',
            sServerMethod: "POST", 
            bPaginate: false,           
            aoColumns: [
			////////////////////////////////Фотография
			  { "sTitle": "Фотография", 
			    "mData": function(aaData) { 
				 var resObj = {
				  'filename' : aaData.filename,
				  'width' : aaData.width,
				  'height': aaData.height
				  }
				 return resObj;
				 },
				"mRender": function (resObj) {
				return '<img src="/'+ api.localhost_backend + api.localhost_uploads + resObj.filename +'" style="width: 400px; height: '+ resObj.height*400/resObj.width +'px">';
			  }},
			////////////////////////////////Размер  
			  { "sTitle": "Фотография", 
			    "mData": function(aaData) { 
				 var resObj = {
				  'size' : aaData.size,
				  'width' : aaData.width,
				  'height': aaData.height
				  }
				 return resObj;
				 },
				"mRender": function (resObj) {
				var size = parseInt(resObj.size)/1024/1024;
				return resObj.width +'x'+ resObj.height+'px / '+ size.toFixed(2) +' Мб';
			  }},
		    ////////////////////////////////Действия
			  { "sTitle": "Фотография", 
			    "mData": function(aaData) { 
				 var resObj = {
				  'id' : aaData.id
				  }
				 return resObj;
				 },
				"mRender": function (resObj) {				
				var res = '';
							
				if (resObj.id!=vm.mainImage) res = '<button alt="Установить эту фотографию главной" class="md-raised md-icon-button md-button md-ink-ripple md-default-theme md-accent" ng-click="vm.setMainPhoto('+resObj.id+');" aria-label="Set this as main photo" type="button" ng-transclude=""><md-icon md-font-icon="icon-flag-variant" class="ng-scope ng-isolate-scope icon-flag-variant md-font material-icons md-default-theme"></md-icon><div class="md-ripple-container"></div></button>'
													+
													'<md-button class="md-raised md-warn" ng-click="vm.removePhoto('+resObj.id+');" aria-label="Remove this"><md-icon md-font-icon="icon-content-cut" class="s16"></md-icon></md-button>';
													
				if (resObj.id==vm.mainImage) res = '<span>Главная фотография выводится<br>как миниатюра на рекламных порталах.<br> Вы не можете ее удалить</span>';	
																						
				return res;							
			  }}							
			],
            oLanguage: {
				sUrl:"/assets/datatables.lang",
				sInfo: ''
			},
			"columns": [
				{ "orderable": false },				
				{ "orderable": false },
				{ "orderable": false }
			  ],
			  "order": [0, "desc"]			
        };
				
        // Methods
        vm.sendForm = sendForm;
		vm.loadDistricts = loadDistricts;
		vm.loadCities = loadCities;
		vm.loadStreets = loadStreets;
		vm.changeRoomTypes = changeRoomTypes;
		vm.changeFlatStatuses = changeFlatStatuses;
		vm.loadAddress = loadAddress;
		vm.updatePhotos = updatePhotos;
		vm.successLoadPhotosMessage = successLoadPhotosMessage;
		vm.removePhoto = removePhoto;
		vm.setMainPhoto = setMainPhoto;		
		//vm.reloadData = reloadData;		
		
		vm.dtInstance = {};

/*
		function reloadData() {
			var resetPaging = true;
			vm.dtInstance.rerender(callback, resetPaging);
		}

		function callback(json) {
			console.log(json);
		}
*/    
		//устанавливаем фотографию главной
		function setMainPhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var mainphoto = new api.objects.mainphoto();					
					mainphoto.id = id;
					mainphoto.$save();
					
					vm.mainImage = id;
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография помечена как главная</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),                               
                clickOutsideToClose: true
            });
		}
		
		//////////удаление фотографии
		function removePhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var archivephoto = new api.objects.archivephoto();					
					archivephoto.id = id;
					archivephoto.$save();
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография удалена</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),                               
                clickOutsideToClose: true
            });
            //обновляем список фотографий и таблицу сразу после загрузки
				updatePhotos();
				//reloadData();
		}
		//////////обновление таблицы фотографий
		function updatePhotos()
        {			
			//TODO обновлять на ходу таблицу фото
			//получаем уже загруженные фотографии		
			api.objects.objectphotosbyid.query({'id':vm.objectId}, function(data) {
				vm.photos = data.data;
				
				//меняем адреса изображений
				for(var i=0; i < vm.photos.length;i++){
					vm.photos[i].filename = api.localhost_backend + "uploads/" + vm.photos[i].filename;
				}		
			});
		}
		//Сообщение, что фото загружены
		function successLoadPhotosMessage()
        {
			$mdDialog.show({
					controller         : function ($scope, $mdDialog)
					{
						$scope.closeDialog = function ()
						{
							$mdDialog.hide();
						}
					},
					template: '<md-dialog>' +
					'  <md-dialog-content><h1>Фотографии успешно добавлены</h1></md-dialog-content>' +
					'  <md-dialog-actions>' +
					'    <md-button ng-click="closeDialog()" class="md-primary">' +
					'      Закрыть' +
					'    </md-button>' +
					'  </md-dialog-actions>' +
					'</md-dialog>',
					parent             : angular.element('body'),
					clickOutsideToClose: true
				});
				//обновляем список фотографий и таблицу сразу после загрузки
				updatePhotos();
				//reloadData();
		}
        //////////первоначальная загрузка адреса редактируемого объекта
        function loadAddress()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {			
				vm.districts = data;
				//vm.formWizard.district = id;					
					var index_district = 0;
					//определяем реальный порядковый номер в массиве
					for (var i = 0; i < vm.districts.length; i++) 
						if (vm.districts[i]['id'] == vm.formWizard.district) {
							index_district = i;
							api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {			
								vm.cities = data;
								var index_city = 0;
								//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
								//его код КЛАДР
								for (var i = 0; i < vm.cities.length; i++) 
									if (vm.cities[i]['name'] == vm.formWizard.city) {
										index_city = i;
										//TODO оптимизировать загрузку улиц				
										api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {			
											vm.streets = data;											
										});
								}
							});
					}
				});	
		}
        //////////оставляем те же функции, что и при создании
        function loadDistricts()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {			
				vm.districts = data;
				//обнуляем все, что ниже иерархически
				vm.cities = {};
				vm.streets = {};
				//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.district = null;
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;
				//для Москвы выбираем любой район, так как район города необязателен
				if (vm.formWizard.region == 1) {					
					vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
					loadCities();
					}
				});	
		}
		
		function loadCities()
        {	
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;
				
			if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
				vm.cities = {};				
			} else {		
				var index_district = 0;
				//определяем реальный порядковый номер в массиве
				for (var i = 0; i < vm.districts.length; i++) 
					if (vm.districts[i]['id'] == vm.formWizard.district) {
						index_district = i;
						api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {			
							vm.cities = data;
							});
				}			
			}
			vm.streets = {};			
		}		
		
		function loadStreets()
        {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
			vm.formWizard.street = null;
			vm.formWizard.house_number = null;

			if (!vm.formWizard.city) {
				vm.streets = {};
			} else {
				var index_city = 0;
				//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
				//его код КЛАДР
				for (var i = 0; i < vm.cities.length; i++) 
					if (vm.cities[i]['name'] == vm.formWizard.city) {
						index_city = i;
						//TODO оптимизировать загрузку улиц				
						api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {			
							vm.streets = data;
						});
				}		
			}
		}
		
		function changeFlatStatuses() {
		 if (vm.formWizard.deal_type == 'change') {
			 vm.flat_status_types = [{'name': 'patrol', 'rusname': 'Расселение/разъед'},
									 {'name': 'alternate', 'rusname': 'Альтернатива'}];
			  vm.formWizard.flat_status = 'alternate';
			} else {
			 vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
				{'name': 'free', 'rusname': 'Свободна'},
				{'name': 'patrol', 'rusname': 'Расселение/разъед'}];			
			}		 
		}
		
		function changeRoomTypes() {
			switch (vm.formWizard.object_type) {
				//типы комнат для квартиры, новостройки, пентхауса
				case 'flat_new_building': //doNothing
				case 'penthouse': //doNothing
				case 'flat': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'}, 
										{'name': '2', 'rusname': 'Двухкомнатная'}, 
										{'name': '3', 'rusname': 'Трехкомнатная'},
										{'name': '4', 'rusname': 'Четырехкомнатная'},
										{'name': '5', 'rusname': 'Пятикомнатная'},
										{'name': 'm', 'rusname': 'Многокомнатная'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
				case 'part': vm.rooms_type_list = [{'name': 'd_1', 'rusname': 'Доля в однокомнатной'}, 
										{'name': 'd_2', 'rusname': 'Доля в двухкомнатной'}, 
										{'name': 'd_3', 'rusname': 'Доля в трехкомнатной'},
										{'name': 'd_4', 'rusname': 'Доля в четырехкомнатной'},
										{'name': 'd_5', 'rusname': 'Доля в пятикомнатной'}];
										break
				case 'room': vm.rooms_type_list = [{'name': '1_2', 'rusname': 'Комната в двухкомнатной'}, 
										{'name': '1_3', 'rusname': 'Комната в трехкомнатной'}, 
										{'name': '1_4', 'rusname': 'Комната в четырехкомнатной'},
										{'name': '1_5', 'rusname': 'Комната в пятикомнатной'},
										{'name': '2_3', 'rusname': '2 комнаты в трехкомнатной'},
										{'name': '2_4', 'rusname': '2 комнаты в четырехкомнатной'},
										{'name': '2_5', 'rusname': '2 комнаты в пятикомнатной'},
										{'name': '3_4', 'rusname': '3 комнаты в четырехкомнатной'},
										{'name': '3_5', 'rusname': '3 комнаты в пятикомнатной'}];
										break											
					  }
		}
		
        function sendForm(ev)
        {			
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
		
					var newobject = new api.objects.newobjectdata();					
					newobject.data = formWizardData;
					newobject.$save();
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flats');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект успешно создан</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}
	
	///////////////////////Загрузка фотографий
	var uploader = $scope.uploader = new FileUploader({
			//инкапсулируем скрипт загрузки в общий модуль, чтобы проверять авторизацию
            url: api.localhost_backend + 'upload',
            removeAfterUpload: true,
			formData: {'id':vm.objectId}
        });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        //События Callbacks
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
        };
        uploader.onAfterAddingFile = function(fileItem) {
            console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
            console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function(item) {
            console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            console.info('onCompleteAll');
        };
        console.info('uploader', uploader);
        
  }    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editflat')
        .controller('EditFlatController', EditFlatController);
  
    /** @ngInject */
    function EditFlatController($scope, $mdDialog, $location, FileUploader, api)
    {
        var vm = this;
        // Data
        vm.formWizard = {};       

		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
		//типы населенных пунктов
        vm.city_types = [{'socr': 'г', 'name': 'город'}, 
						{'socr': 'г.о.', 'name': 'городской округ'}, 
						{'socr': 'п', 'name': 'поселение/поселок'},
						{'socr': 'дп', 'name': 'дачный поселок'},
						{'socr': 'кп', 'name': 'курортный поселок'},
						{'socr': 'пгт', 'name': 'поселок городского типа'},
						{'socr': 'рп', 'name': 'рабочий поселок'},
						{'socr': 'с/п', 'name': 'сельское поселение'},
						{'socr': 'д', 'name': 'деревня'},
						{'socr': 'с', 'name': 'село'},
						{'socr': 'сл', 'name': 'слобода'},
						{'socr': 'снт', 'name': 'СНТ'},
						{'socr': 'жилрайон', 'name': 'жилой район'},
						{'socr': 'кв-л', 'name': 'квартал'},
						{'socr': 'мкр', 'name': 'микрорайон'},
						{'socr': 'нп', 'name': 'населенный пункт'},
						{'socr': 'тер', 'name': 'территория'},
						{'socr': 'промзона', 'name': 'промышленная зона'}];
						
		//названия нас.пунктов и улицы подгружаем после выбора
		vm.districts = {};
		vm.cities = {};
		vm.streets = {};
		
		//Список метро и направлений
		api.objects.metrostations.query({}, function(data) {			
				vm.metrostations = data;
				});				
		api.objects.directions.query({}, function(data) {			
				vm.directions = data;
				});
				
		api.contacts.my_clients.query({}, function(data) {			
				vm.my_clients = data;
				});
		
		vm.metro_time_list = [{'name': 'f_2', 'rusname': '2 минуты пешком'}, 
						{'name': 'f_5', 'rusname': '5 минут пешком'}, 
						{'name': 'f_7', 'rusname': '7 минут пешком'},
						{'name': 'f_10', 'rusname': '10 минут пешком'},
						{'name': 'f_15', 'rusname': '15 минут пешком'},
						{'name': 'f_20', 'rusname': '20 минут пешком'},
						{'name': 't_5', 'rusname': '5 минут транспортом'},
						{'name': 't_10', 'rusname': '10 минут транспортом'},
						{'name': 't_15', 'rusname': '15 минут транспортом'},
						{'name': 't_20', 'rusname': '20 минут транспортом'}];
		
		//тип объекта
		vm.object_types = [{'name': 'flat', 'rusname': 'Квартира'}, 
						{'name': 'flat_new_building', 'rusname': 'Квартира в новостройке'}, 
						{'name': 'room', 'rusname': 'Комната'},
						{'name': 'part', 'rusname': 'Доля в квартире'},
						{'name': 'penthouse', 'rusname': 'Пентхаус'}];
		
        //тип объекта 2
		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'}, 
						{'name': 'hog-wash', 'rusname': 'Утка'}, 
						{'name': 'auction', 'rusname': 'Аукцион'},
						{'name': 'invest', 'rusname': 'Инвестиционный'}];
		
		//источник
		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'}, 
						{'id': '2', 'rusname': 'Расклейка'}, 
						{'id': '3', 'rusname': 'Баннер'},
						{'id': '4', 'rusname': 'Рекомендация'},
						{'id': '5', 'rusname': 'База собственников'},
						{'id': '6', 'rusname': 'База заявок'},
						{'id': '7', 'rusname': 'Диспетчерская'},
						{'id': '8', 'rusname': 'Avito'},
						{'id': '9', 'rusname': 'Другие сайты'},
						{'id': '10', 'rusname': 'Сам нашел'}];
						
		//тип комиссии
		vm.commission_types = [{'name': 'percent', 'rusname': '%'}, 
						{'name': 'sum', 'rusname': 'руб.'}];
		
		//типы сделок
		vm.deal_types = [{'name': 'rent', 'rusname': 'Аренда'},
						{'name': 'change', 'rusname': 'Альтернатива'},
						{'name': 'sale', 'rusname': 'Продажа'}];
		
        vm.rent_durations = [{'name': 'short', 'rusname': 'Несколько месяцев'},
						{'name': 'long', 'rusname': 'Длительный срок'},
						{'name': 'day', 'rusname': 'Посуточно'}];
						
		vm.pay_durations = [{'name': 'month', 'rusname': 'ежемесячно'},
							{'name': 'day', 'rusname': 'посуточно'}];	
							
        //типы комнат для квартиры
        vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'}, 
						{'name': '2', 'rusname': 'Двухкомнатная'}, 
						{'name': '3', 'rusname': 'Трехкомнатная'},
						{'name': '4', 'rusname': 'Четырехкомнатная'},
						{'name': '5', 'rusname': 'Пятикомнатная'},
						{'name': 'm', 'rusname': 'Многокомнатная'},
						{'name': 'studio', 'rusname': 'Студия'}];
						
		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'}, 
						{'name': 'no', 'rusname': 'Нет'}];				
		//телефон			
		vm.phone_types = [{'name': 'yes', 'rusname': 'Есть'}, 
						{'name': 'para', 'rusname': 'Спаренный'},
						{'name': 'possible', 'rusname': 'Возможно подключить'},
						{'name': 'no', 'rusname': 'Нет'}];
		//мебель
		vm.furniture_types = [{'name': 'no', 'rusname': 'Нет'}, 
						{'name': 'old', 'rusname': 'Старая'},
						{'name': '90s', 'rusname': 'Мебель 90-х'},
						{'name': 'modern', 'rusname': 'Современная'}];	
		//ремонт
		vm.repairs_types = [{'name': 'no', 'rusname': 'Без ремонта'},
						{'name': 'cosmetic', 'rusname': 'Косметический'},
						{'name': 'capital', 'rusname': 'Капитальный'},
						{'name': 'euro', 'rusname': 'Евро'}];
		//типы санузла
		vm.types_bathroom = [{'name': 'separated', 'rusname': 'Раздельный'}, 
						{'name': 'combined', 'rusname': 'Совмещенный'}];

		//право собственности
		vm.ownership_types = [{'name': 'primary', 'rusname': 'Первичная приватизация'}, 
						{'name': 'contract-sales', 'rusname': 'Договор купли/продажи'}, 
						{'name': 'contract-donat', 'rusname': 'Договор дарения'},
						{'name': 'contract-rent', 'rusname': 'Договор ренты'},
						{'name': 'paid', 'rusname': 'ЖСК, выплаченный пай'},
						{'name': 'legacy', 'rusname': 'Наследство'},
						{'name': 'court', 'rusname': 'Решение суда'},
						{'name': 'mortgage', 'rusname': 'Залог (ипотека)'},
						{'name': 'invest', 'rusname': 'По договору инвестирования'}];	   
		//Тип дома
		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'}, 
						{'name': 'panel', 'rusname': 'Панельный'}, 
						{'name': 'brick', 'rusname': 'Кирпичный'},
						{'name': 'wood', 'rusname': 'Деревянный'},
						{'name': 'stalin', 'rusname': 'Сталинский'},
						{'name': 'monolith', 'rusname': 'Монолит'},
						{'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'}];	
		 
		//Статус
		vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
						{'name': 'free', 'rusname': 'Свободна'},
						{'name': 'patrol', 'rusname': 'Расселение/разъед'},
						{'name': 'alternate', 'rusname': 'Альтернатива'}];
		//Лифт
		vm.lift_types = [{'name': 'pass', 'rusname': 'Пассажирский'},
						{'name': 'serv', 'rusname': 'Грузовой'},
						{'name': 'passserv', 'rusname': 'Пасс. + груз.'},
						{'name': 'no', 'rusname': 'Нет'}];
		//Балкон
		vm.balcony_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'loggia', 'rusname': 'Лоджия'},
						{'name': '2balcon', 'rusname': '2 балкона'},
						{'name': '2loggia', 'rusname': '2 лоджии'}];
		//В собственности
		vm.years_own_types = [{'name': 'less3', 'rusname': 'Менее 3 лет'}, 
						{'name': 'more3', 'rusname': 'Более 3 лет'}];	
										
        //получаем id объекта, который будем редактировать
        vm.objectId = $location.path().split('/');
        vm.objectId = vm.objectId[vm.objectId.length-1];
        //id главного изображения
        vm.mainImage = 0;
        //информацию по объекту
		api.objects.objectbyid.query({'id':vm.objectId}, function(data) {
				//console.log(data);		
				vm.formWizard.region = parseInt(data.region);										
				vm.formWizard.district = parseInt(data.district);
				vm.formWizard.city_type = data.city_type;				
				vm.formWizard.city = data.city;
				vm.formWizard.street = data.street;
				vm.formWizard.house_number = data.house_number;
				//загружаем адрес полностью
				loadAddress();
				//id главного изображения
				vm.mainImage = (parseInt(data.image)==0)?0:data.image;
				
				vm.formWizard.object_type = data.object_type;
				vm.formWizard.object_type_2 = data.object_type_2;
				vm.formWizard.direction = data.direction;
				vm.formWizard.metro_1 = data.metro_1;
				vm.formWizard.metro_2 = data.metro_2;
				vm.formWizard.metro_3 = data.metro_3;
				vm.formWizard.metro_1_time = data.metro_1_time;
				vm.formWizard.metro_2_time = data.metro_2_time;
				vm.formWizard.metro_3_time = data.metro_3_time;
				vm.formWizard.deal_type = data.deal_type;
				vm.formWizard.source_id = data.source_id;
				vm.formWizard.part_percent = data.part_percent;
				vm.formWizard.rentcost = data.rentcost;
				vm.formWizard.rent_duration = data.rent_duration;
				vm.formWizard.pay_duration = data.pay_duration;
				vm.formWizard.cost = parseInt(data.cost);
				vm.formWizard.commission = parseInt(data.commission);
				vm.formWizard.commission_type = data.commission_type;
				vm.formWizard.rooms_number = data.rooms_number;
				vm.formWizard.story = parseInt(data.story);
				vm.formWizard.story_count = parseInt(data.story_count);
				vm.formWizard.tech_4 = data.tech_4;
				vm.formWizard.tech_8 = data.tech_8;
				vm.formWizard.furniture = data.furniture;
				vm.formWizard.repairs = data.repairs;
				vm.formWizard.flat_status = data.flat_status;
				vm.formWizard.years_own = data.years_own;
				vm.formWizard.balcony = data.balcony;
				vm.formWizard.ownership = data.ownership;
				vm.formWizard.type_bild = data.type_bild;
				vm.formWizard.lift = data.lift;
				vm.formWizard.type_bathroom = data.type_bathroom;
				vm.formWizard.count_bathroom_flat = data.count_bathroom_flat;
				vm.formWizard.inet = data.inet;
				vm.formWizard.phone = data.phone;
				vm.formWizard.square_all = parseInt(data.square_all);
				vm.formWizard.square_living = parseInt(data.square_living);
				vm.formWizard.square_kitchen = parseInt(data.square_kitchen);
				vm.formWizard.square_rooms = data.square_rooms;
				vm.formWizard.description = data.description;
				vm.formWizard.description_en = data.description_en;
				vm.formWizard.creator_id = data.creator_id;				
				vm.formWizard.owner_id = parseInt(data.owner_id);				
		});
		
		updatePhotos();
		
		//опции
		vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            searching: false,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				{ "orderable": false },				
				{ "orderable": false },
				{ "orderable": false }
			  ],
			  "order": [0, "desc"]			
        };	
				
        // Methods
        vm.sendForm = sendForm;
		vm.loadDistricts = loadDistricts;
		vm.loadCities = loadCities;
		vm.loadStreets = loadStreets;
		vm.changeRoomTypes = changeRoomTypes;
		vm.changeFlatStatuses = changeFlatStatuses;
		vm.loadAddress = loadAddress;
		vm.updatePhotos = updatePhotos;
		vm.successLoadPhotosMessage = successLoadPhotosMessage;
		vm.removePhoto = removePhoto;
		vm.setMainPhoto = setMainPhoto;		
		vm.reloadData = reloadData;
		
		//vm.total = 0;
		vm.dtInstance = {};
		
		function reloadData() {
			var resetPaging = true;
			vm.dtInstance.reloadData(callback, resetPaging);
			//vm.dtInstance.reload();
		}

		function callback(json) {
			console.log(json);
		}
    
		//устанавливаем фотографию главной
		function setMainPhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var mainphoto = new api.objects.mainphoto();					
					mainphoto.id = id;
					mainphoto.$save();
					
					vm.mainImage = id;
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография помечена как главная</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),                               
                clickOutsideToClose: true
            });
		}
		
		//////////удаление фотографии
		function removePhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var archivephoto = new api.objects.archivephoto();					
					archivephoto.id = id;
					archivephoto.$save();
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография удалена</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),                               
                clickOutsideToClose: true
            });
            //обновляем список фотографий и таблицу сразу после загрузки
				updatePhotos();
				reloadData();
				vm.photos = null;
		}
		//////////обновление таблицы фотографий
		function updatePhotos()
        {			
			//TODO обновлять на ходу таблицу фото
			//получаем уже загруженные фотографии		
			api.objects.objectphotosbyid.query({'id':vm.objectId}, function(data) {
				vm.photos = data.data;
				
				//меняем адреса изображений
				for(var i=0; i < vm.photos.length;i++){
					vm.photos[i].filename = api.localhost_backend + "uploads/" + vm.photos[i].filename;
				}				
			});
		}
		//Сообщение, что фото загружены
		function successLoadPhotosMessage()
        {
			$mdDialog.show({
					controller         : function ($scope, $mdDialog)
					{
						$scope.closeDialog = function ()
						{
							$mdDialog.hide();
						}
					},
					template: '<md-dialog>' +
					'  <md-dialog-content><h1>Фотографии успешно добавлены</h1></md-dialog-content>' +
					'  <md-dialog-actions>' +
					'    <md-button ng-click="closeDialog()" class="md-primary">' +
					'      Закрыть' +
					'    </md-button>' +
					'  </md-dialog-actions>' +
					'</md-dialog>',
					parent             : angular.element('body'),
					clickOutsideToClose: true
				});
				//обновляем список фотографий и таблицу сразу после загрузки
				updatePhotos();
				reloadData();
		}
        //////////первоначальная загрузка адреса редактируемого объекта
        function loadAddress()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {			
				vm.districts = data;
				//vm.formWizard.district = id;					
					var index_district = 0;
					//определяем реальный порядковый номер в массиве
					for (var i = 0; i < vm.districts.length; i++) 
						if (vm.districts[i]['id'] == vm.formWizard.district) {
							index_district = i;
							api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {			
								vm.cities = data;
								var index_city = 0;
								//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
								//его код КЛАДР
								for (var i = 0; i < vm.cities.length; i++) 
									if (vm.cities[i]['name'] == vm.formWizard.city) {
										index_city = i;
										//TODO оптимизировать загрузку улиц				
										api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {			
											vm.streets = data;											
										});
								}
							});
					}
				});	
		}
        //////////оставляем те же функции, что и при создании
        function loadDistricts()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {			
				vm.districts = data;
				//обнуляем все, что ниже иерархически
				vm.cities = {};
				vm.streets = {};
				//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.district = null;
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;
				//для Москвы выбираем любой район, так как район города необязателен
				if (vm.formWizard.region == 1) {					
					vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
					loadCities();
					}
				});	
		}
		
		function loadCities()
        {	
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;
				
			if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
				vm.cities = {};				
			} else {		
				var index_district = 0;
				//определяем реальный порядковый номер в массиве
				for (var i = 0; i < vm.districts.length; i++) 
					if (vm.districts[i]['id'] == vm.formWizard.district) {
						index_district = i;
						api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {			
							vm.cities = data;
							});
				}			
			}
			vm.streets = {};			
		}		
		
		function loadStreets()
        {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
			vm.formWizard.street = null;
			vm.formWizard.house_number = null;

			if (!vm.formWizard.city) {
				vm.streets = {};
			} else {
				var index_city = 0;
				//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
				//его код КЛАДР
				for (var i = 0; i < vm.cities.length; i++) 
					if (vm.cities[i]['name'] == vm.formWizard.city) {
						index_city = i;
						//TODO оптимизировать загрузку улиц				
						api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {			
							vm.streets = data;
						});
				}		
			}
		}
		
		function changeFlatStatuses() {
		 if (vm.formWizard.deal_type == 'change') {
			 vm.flat_status_types = [{'name': 'patrol', 'rusname': 'Расселение/разъед'},
									 {'name': 'alternate', 'rusname': 'Альтернатива'}];
			  vm.formWizard.flat_status = 'alternate';
			} else {
			 vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
				{'name': 'free', 'rusname': 'Свободна'},
				{'name': 'patrol', 'rusname': 'Расселение/разъед'}];			
			}		 
		}
		
		function changeRoomTypes() {
			switch (vm.formWizard.object_type) {
				//типы комнат для квартиры, новостройки, пентхауса
				case 'flat_new_building': //doNothing
				case 'penthouse': //doNothing
				case 'flat': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'}, 
										{'name': '2', 'rusname': 'Двухкомнатная'}, 
										{'name': '3', 'rusname': 'Трехкомнатная'},
										{'name': '4', 'rusname': 'Четырехкомнатная'},
										{'name': '5', 'rusname': 'Пятикомнатная'},
										{'name': 'm', 'rusname': 'Многокомнатная'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
				case 'part': vm.rooms_type_list = [{'name': 'd_1', 'rusname': 'Доля в однокомнатной'}, 
										{'name': 'd_2', 'rusname': 'Доля в двухкомнатной'}, 
										{'name': 'd_3', 'rusname': 'Доля в трехкомнатной'},
										{'name': 'd_4', 'rusname': 'Доля в четырехкомнатной'},
										{'name': 'd_5', 'rusname': 'Доля в пятикомнатной'}];
										break
				case 'room': vm.rooms_type_list = [{'name': '1_2', 'rusname': 'Комната в двухкомнатной'}, 
										{'name': '1_3', 'rusname': 'Комната в трехкомнатной'}, 
										{'name': '1_4', 'rusname': 'Комната в четырехкомнатной'},
										{'name': '1_5', 'rusname': 'Комната в пятикомнатной'},
										{'name': '2_3', 'rusname': '2 комнаты в трехкомнатной'},
										{'name': '2_4', 'rusname': '2 комнаты в четырехкомнатной'},
										{'name': '2_5', 'rusname': '2 комнаты в пятикомнатной'},
										{'name': '3_4', 'rusname': '3 комнаты в четырехкомнатной'},
										{'name': '3_5', 'rusname': '3 комнаты в пятикомнатной'}];
										break											
					  }
		}
		
        function sendForm(ev)
        {			
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
		
					var newobject = new api.objects.newobjectdata();					
					newobject.data = formWizardData;
					newobject.$save();
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flats');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект успешно создан</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}
	
	///////////////////////Загрузка фотографий
	var uploader = $scope.uploader = new FileUploader({
			//инкапсулируем скрипт загрузки в общий модуль, чтобы проверять авторизацию
            url: api.localhost_backend + 'upload',
            removeAfterUpload: true,
			formData: {'id':vm.objectId}
        });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        //События Callbacks
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
        };
        uploader.onAfterAddingFile = function(fileItem) {
            console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
            console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function(item) {
            console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            console.info('onCompleteAll');
        };
        console.info('uploader', uploader);
        
  }    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editflat')
        .controller('EditFlatController', EditFlatController);
  
    /** @ngInject */
    function EditFlatController($scope, $mdDialog, $location, FileUploader, api)
    {
        var vm = this;
        // Data
        vm.formWizard = {};       

		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
		//типы населенных пунктов
        vm.city_types = [{'socr': 'г', 'name': 'город'}, 
						{'socr': 'г.о.', 'name': 'городской округ'}, 
						{'socr': 'п', 'name': 'поселение/поселок'},
						{'socr': 'дп', 'name': 'дачный поселок'},
						{'socr': 'кп', 'name': 'курортный поселок'},
						{'socr': 'пгт', 'name': 'поселок городского типа'},
						{'socr': 'рп', 'name': 'рабочий поселок'},
						{'socr': 'с/п', 'name': 'сельское поселение'},
						{'socr': 'д', 'name': 'деревня'},
						{'socr': 'с', 'name': 'село'},
						{'socr': 'сл', 'name': 'слобода'},
						{'socr': 'снт', 'name': 'СНТ'},
						{'socr': 'жилрайон', 'name': 'жилой район'},
						{'socr': 'кв-л', 'name': 'квартал'},
						{'socr': 'мкр', 'name': 'микрорайон'},
						{'socr': 'нп', 'name': 'населенный пункт'},
						{'socr': 'тер', 'name': 'территория'},
						{'socr': 'промзона', 'name': 'промышленная зона'}];
						
		//названия нас.пунктов и улицы подгружаем после выбора
		vm.districts = {};
		vm.cities = {};
		vm.streets = {};
		
		//Список метро и направлений
		api.objects.metrostations.query({}, function(data) {			
				vm.metrostations = data;
				});				
		api.objects.directions.query({}, function(data) {			
				vm.directions = data;
				});
				
		api.contacts.my_clients.query({}, function(data) {			
				vm.my_clients = data;
				});
		
		vm.metro_time_list = [{'name': 'f_2', 'rusname': '2 минуты пешком'}, 
						{'name': 'f_5', 'rusname': '5 минут пешком'}, 
						{'name': 'f_7', 'rusname': '7 минут пешком'},
						{'name': 'f_10', 'rusname': '10 минут пешком'},
						{'name': 'f_15', 'rusname': '15 минут пешком'},
						{'name': 'f_20', 'rusname': '20 минут пешком'},
						{'name': 't_5', 'rusname': '5 минут транспортом'},
						{'name': 't_10', 'rusname': '10 минут транспортом'},
						{'name': 't_15', 'rusname': '15 минут транспортом'},
						{'name': 't_20', 'rusname': '20 минут транспортом'}];
		
		//тип объекта
		vm.object_types = [{'name': 'flat', 'rusname': 'Квартира'}, 
						{'name': 'flat_new_building', 'rusname': 'Квартира в новостройке'}, 
						{'name': 'room', 'rusname': 'Комната'},
						{'name': 'part', 'rusname': 'Доля в квартире'},
						{'name': 'penthouse', 'rusname': 'Пентхаус'}];
		
        //тип объекта 2
		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'}, 
						{'name': 'hog-wash', 'rusname': 'Утка'}, 
						{'name': 'auction', 'rusname': 'Аукцион'},
						{'name': 'invest', 'rusname': 'Инвестиционный'}];
		
		//источник
		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'}, 
						{'id': '2', 'rusname': 'Расклейка'}, 
						{'id': '3', 'rusname': 'Баннер'},
						{'id': '4', 'rusname': 'Рекомендация'},
						{'id': '5', 'rusname': 'База собственников'},
						{'id': '6', 'rusname': 'База заявок'},
						{'id': '7', 'rusname': 'Диспетчерская'},
						{'id': '8', 'rusname': 'Avito'},
						{'id': '9', 'rusname': 'Другие сайты'},
						{'id': '10', 'rusname': 'Сам нашел'}];
						
		//тип комиссии
		vm.commission_types = [{'name': 'percent', 'rusname': '%'}, 
						{'name': 'sum', 'rusname': 'руб.'}];
		
		//типы сделок
		vm.deal_types = [{'name': 'rent', 'rusname': 'Аренда'},
						{'name': 'change', 'rusname': 'Альтернатива'},
						{'name': 'sale', 'rusname': 'Продажа'}];
		
        vm.rent_durations = [{'name': 'short', 'rusname': 'Несколько месяцев'},
						{'name': 'long', 'rusname': 'Длительный срок'},
						{'name': 'day', 'rusname': 'Посуточно'}];
						
		vm.pay_durations = [{'name': 'month', 'rusname': 'ежемесячно'},
							{'name': 'day', 'rusname': 'посуточно'}];	
							
        //типы комнат для квартиры
        vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'}, 
						{'name': '2', 'rusname': 'Двухкомнатная'}, 
						{'name': '3', 'rusname': 'Трехкомнатная'},
						{'name': '4', 'rusname': 'Четырехкомнатная'},
						{'name': '5', 'rusname': 'Пятикомнатная'},
						{'name': 'm', 'rusname': 'Многокомнатная'},
						{'name': 'studio', 'rusname': 'Студия'}];
						
		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'}, 
						{'name': 'no', 'rusname': 'Нет'}];				
		//телефон			
		vm.phone_types = [{'name': 'yes', 'rusname': 'Есть'}, 
						{'name': 'para', 'rusname': 'Спаренный'},
						{'name': 'possible', 'rusname': 'Возможно подключить'},
						{'name': 'no', 'rusname': 'Нет'}];
		//мебель
		vm.furniture_types = [{'name': 'no', 'rusname': 'Нет'}, 
						{'name': 'old', 'rusname': 'Старая'},
						{'name': '90s', 'rusname': 'Мебель 90-х'},
						{'name': 'modern', 'rusname': 'Современная'}];	
		//ремонт
		vm.repairs_types = [{'name': 'no', 'rusname': 'Без ремонта'},
						{'name': 'cosmetic', 'rusname': 'Косметический'},
						{'name': 'capital', 'rusname': 'Капитальный'},
						{'name': 'euro', 'rusname': 'Евро'}];
		//типы санузла
		vm.types_bathroom = [{'name': 'separated', 'rusname': 'Раздельный'}, 
						{'name': 'combined', 'rusname': 'Совмещенный'}];

		//право собственности
		vm.ownership_types = [{'name': 'primary', 'rusname': 'Первичная приватизация'}, 
						{'name': 'contract-sales', 'rusname': 'Договор купли/продажи'}, 
						{'name': 'contract-donat', 'rusname': 'Договор дарения'},
						{'name': 'contract-rent', 'rusname': 'Договор ренты'},
						{'name': 'paid', 'rusname': 'ЖСК, выплаченный пай'},
						{'name': 'legacy', 'rusname': 'Наследство'},
						{'name': 'court', 'rusname': 'Решение суда'},
						{'name': 'mortgage', 'rusname': 'Залог (ипотека)'},
						{'name': 'invest', 'rusname': 'По договору инвестирования'}];	   
		//Тип дома
		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'}, 
						{'name': 'panel', 'rusname': 'Панельный'}, 
						{'name': 'brick', 'rusname': 'Кирпичный'},
						{'name': 'wood', 'rusname': 'Деревянный'},
						{'name': 'stalin', 'rusname': 'Сталинский'},
						{'name': 'monolith', 'rusname': 'Монолит'},
						{'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'}];	
		 
		//Статус
		vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
						{'name': 'free', 'rusname': 'Свободна'},
						{'name': 'patrol', 'rusname': 'Расселение/разъед'},
						{'name': 'alternate', 'rusname': 'Альтернатива'}];
		//Лифт
		vm.lift_types = [{'name': 'pass', 'rusname': 'Пассажирский'},
						{'name': 'serv', 'rusname': 'Грузовой'},
						{'name': 'passserv', 'rusname': 'Пасс. + груз.'},
						{'name': 'no', 'rusname': 'Нет'}];
		//Балкон
		vm.balcony_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'loggia', 'rusname': 'Лоджия'},
						{'name': '2balcon', 'rusname': '2 балкона'},
						{'name': '2loggia', 'rusname': '2 лоджии'}];
		//В собственности
		vm.years_own_types = [{'name': 'less3', 'rusname': 'Менее 3 лет'}, 
						{'name': 'more3', 'rusname': 'Более 3 лет'}];	
										
        //получаем id объекта, который будем редактировать
        vm.objectId = $location.path().split('/');
        vm.objectId = vm.objectId[vm.objectId.length-1];
        //id главного изображения
        vm.mainImage = 0;
        //информацию по объекту
		api.objects.objectbyid.query({'id':vm.objectId}, function(data) {
				//console.log(data);		
				vm.formWizard.region = parseInt(data.region);										
				vm.formWizard.district = parseInt(data.district);
				vm.formWizard.city_type = data.city_type;				
				vm.formWizard.city = data.city;
				vm.formWizard.street = data.street;
				vm.formWizard.house_number = data.house_number;
				//загружаем адрес полностью
				loadAddress();
				//id главного изображения
				vm.mainImage = (parseInt(data.image)==0)?0:data.image;
				
				vm.formWizard.object_type = data.object_type;
				vm.formWizard.object_type_2 = data.object_type_2;
				vm.formWizard.direction = data.direction;
				vm.formWizard.metro_1 = data.metro_1;
				vm.formWizard.metro_2 = data.metro_2;
				vm.formWizard.metro_3 = data.metro_3;
				vm.formWizard.metro_1_time = data.metro_1_time;
				vm.formWizard.metro_2_time = data.metro_2_time;
				vm.formWizard.metro_3_time = data.metro_3_time;
				vm.formWizard.deal_type = data.deal_type;
				vm.formWizard.source_id = data.source_id;
				vm.formWizard.part_percent = data.part_percent;
				vm.formWizard.rentcost = data.rentcost;
				vm.formWizard.rent_duration = data.rent_duration;
				vm.formWizard.pay_duration = data.pay_duration;
				vm.formWizard.cost = parseInt(data.cost);
				vm.formWizard.commission = parseInt(data.commission);
				vm.formWizard.commission_type = data.commission_type;
				vm.formWizard.rooms_number = data.rooms_number;
				vm.formWizard.story = parseInt(data.story);
				vm.formWizard.story_count = parseInt(data.story_count);
				vm.formWizard.tech_4 = data.tech_4;
				vm.formWizard.tech_8 = data.tech_8;
				vm.formWizard.furniture = data.furniture;
				vm.formWizard.repairs = data.repairs;
				vm.formWizard.flat_status = data.flat_status;
				vm.formWizard.years_own = data.years_own;
				vm.formWizard.balcony = data.balcony;
				vm.formWizard.ownership = data.ownership;
				vm.formWizard.type_bild = data.type_bild;
				vm.formWizard.lift = data.lift;
				vm.formWizard.type_bathroom = data.type_bathroom;
				vm.formWizard.count_bathroom_flat = data.count_bathroom_flat;
				vm.formWizard.inet = data.inet;
				vm.formWizard.phone = data.phone;
				vm.formWizard.square_all = parseInt(data.square_all);
				vm.formWizard.square_living = parseInt(data.square_living);
				vm.formWizard.square_kitchen = parseInt(data.square_kitchen);
				vm.formWizard.square_rooms = data.square_rooms;
				vm.formWizard.description = data.description;
				vm.formWizard.description_en = data.description_en;
				vm.formWizard.creator_id = data.creator_id;				
				vm.formWizard.owner_id = parseInt(data.owner_id);				
		});
		
		//updatePhotos();
		
		//опции
		vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            searching: false,
            bServerSide: true,
            sAjaxSource: api.localhost_backend + 'object/photos',
            sServerMethod: "POST", 
            bPaginate: false,           
            aoColumns: [
			////////////////////////////////Фотография
			  { "sTitle": "Фотография", 
			    "mData": function(aaData) { 
				 var resObj = {
				  'filename' : aaData.filename,
				  'width' : aaData.width,
				  'height': aaData.height
				  }
				 return resObj;
				 },
				"mRender": function (resObj) {
				return '<img src="/'+ api.localhost_backend + api.localhost_uploads + resObj.filename +'" style="width: 400px; height: '+ resObj.height*400/resObj.width +'px">';
			  }},
			////////////////////////////////Размер  
			  { "sTitle": "Фотография", 
			    "mData": function(aaData) { 
				 var resObj = {
				  'size' : aaData.size,
				  'width' : aaData.width,
				  'height': aaData.height
				  }
				 return resObj;
				 },
				"mRender": function (resObj) {
				var size = parseInt(resObj.size)/1024/1024;
				return resObj.width +'x'+ resObj.height+'px / '+ size.toFixed(2) +' Мб';
			  }},
		    ////////////////////////////////Действия
			  { "sTitle": "Фотография", 
			    "mData": function(aaData) { 
				 var resObj = {
				  'id' : aaData.id
				  }
				 return resObj;
				 },
				"mRender": function (resObj) {				
				var res = '';
							
				if (resObj.id!=vm.mainImage) res = '<button alt="Установить эту фотографию главной" class="md-raised md-icon-button md-button md-ink-ripple md-default-theme md-accent" ng-click="vm.setMainPhoto('+resObj.id+');" aria-label="Set this as main photo" type="button" ng-transclude=""><md-icon md-font-icon="icon-flag-variant" class="ng-scope ng-isolate-scope icon-flag-variant md-font material-icons md-default-theme"></md-icon><div class="md-ripple-container"></div></button>'
													+
													'<md-button class="md-raised md-warn" ng-click="vm.removePhoto('+resObj.id+');" aria-label="Remove this"><md-icon md-font-icon="icon-content-cut" class="s16"></md-icon></md-button>';
													
				if (resObj.id==vm.mainImage) res = '<span>Главная фотография выводится<br>как миниатюра на рекламных порталах.<br> Вы не можете ее удалить</span>';	
																						
				return res;							
			  }}							
			],
            oLanguage: {
				sUrl:"/assets/datatables.lang",
				sInfo: ''
			},
			"columns": [
				{ "orderable": false },				
				{ "orderable": false },
				{ "orderable": false }
			  ],
			  "order": [0, "desc"]			
        };
				
        // Methods
        vm.sendForm = sendForm;
		vm.loadDistricts = loadDistricts;
		vm.loadCities = loadCities;
		vm.loadStreets = loadStreets;
		vm.changeRoomTypes = changeRoomTypes;
		vm.changeFlatStatuses = changeFlatStatuses;
		vm.loadAddress = loadAddress;
		vm.updatePhotos = updatePhotos;
		vm.successLoadPhotosMessage = successLoadPhotosMessage;
		vm.removePhoto = removePhoto;
		vm.setMainPhoto = setMainPhoto;		
		//vm.reloadData = reloadData;		
		
		vm.dtInstance = {};

/*
		function reloadData() {
			var resetPaging = true;
			vm.dtInstance.rerender(callback, resetPaging);
		}

		function callback(json) {
			console.log(json);
		}
*/    
		//устанавливаем фотографию главной
		function setMainPhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var mainphoto = new api.objects.mainphoto();					
					mainphoto.id = id;
					mainphoto.$save();
					
					vm.mainImage = id;
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография помечена как главная</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),                               
                clickOutsideToClose: true
            });
		}
		
		//////////удаление фотографии
		function removePhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var archivephoto = new api.objects.archivephoto();					
					archivephoto.id = id;
					archivephoto.$save();
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография удалена</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),                               
                clickOutsideToClose: true
            });
            //обновляем список фотографий и таблицу сразу после загрузки
				updatePhotos();
				//reloadData();
		}
		//////////обновление таблицы фотографий
		function updatePhotos()
        {			
			//TODO обновлять на ходу таблицу фото
			//получаем уже загруженные фотографии		
			api.objects.objectphotosbyid.query({'id':vm.objectId}, function(data) {
				vm.photos = data.data;
				
				//меняем адреса изображений
				for(var i=0; i < vm.photos.length;i++){
					vm.photos[i].filename = api.localhost_backend + "uploads/" + vm.photos[i].filename;
				}		
			});
		}
		//Сообщение, что фото загружены
		function successLoadPhotosMessage()
        {
			$mdDialog.show({
					controller         : function ($scope, $mdDialog)
					{
						$scope.closeDialog = function ()
						{
							$mdDialog.hide();
						}
					},
					template: '<md-dialog>' +
					'  <md-dialog-content><h1>Фотографии успешно добавлены</h1></md-dialog-content>' +
					'  <md-dialog-actions>' +
					'    <md-button ng-click="closeDialog()" class="md-primary">' +
					'      Закрыть' +
					'    </md-button>' +
					'  </md-dialog-actions>' +
					'</md-dialog>',
					parent             : angular.element('body'),
					clickOutsideToClose: true
				});
				//обновляем список фотографий и таблицу сразу после загрузки
				updatePhotos();
				//reloadData();
		}
        //////////первоначальная загрузка адреса редактируемого объекта
        function loadAddress()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {			
				vm.districts = data;
				//vm.formWizard.district = id;					
					var index_district = 0;
					//определяем реальный порядковый номер в массиве
					for (var i = 0; i < vm.districts.length; i++) 
						if (vm.districts[i]['id'] == vm.formWizard.district) {
							index_district = i;
							api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {			
								vm.cities = data;
								var index_city = 0;
								//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
								//его код КЛАДР
								for (var i = 0; i < vm.cities.length; i++) 
									if (vm.cities[i]['name'] == vm.formWizard.city) {
										index_city = i;
										//TODO оптимизировать загрузку улиц				
										api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {			
											vm.streets = data;											
										});
								}
							});
					}
				});	
		}
        //////////оставляем те же функции, что и при создании
        function loadDistricts()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {			
				vm.districts = data;
				//обнуляем все, что ниже иерархически
				vm.cities = {};
				vm.streets = {};
				//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.district = null;
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;
				//для Москвы выбираем любой район, так как район города необязателен
				if (vm.formWizard.region == 1) {					
					vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
					loadCities();
					}
				});	
		}
		
		function loadCities()
        {	
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;
				
			if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
				vm.cities = {};				
			} else {		
				var index_district = 0;
				//определяем реальный порядковый номер в массиве
				for (var i = 0; i < vm.districts.length; i++) 
					if (vm.districts[i]['id'] == vm.formWizard.district) {
						index_district = i;
						api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {			
							vm.cities = data;
							});
				}			
			}
			vm.streets = {};			
		}		
		
		function loadStreets()
        {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
			vm.formWizard.street = null;
			vm.formWizard.house_number = null;

			if (!vm.formWizard.city) {
				vm.streets = {};
			} else {
				var index_city = 0;
				//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
				//его код КЛАДР
				for (var i = 0; i < vm.cities.length; i++) 
					if (vm.cities[i]['name'] == vm.formWizard.city) {
						index_city = i;
						//TODO оптимизировать загрузку улиц				
						api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {			
							vm.streets = data;
						});
				}		
			}
		}
		
		function changeFlatStatuses() {
		 if (vm.formWizard.deal_type == 'change') {
			 vm.flat_status_types = [{'name': 'patrol', 'rusname': 'Расселение/разъед'},
									 {'name': 'alternate', 'rusname': 'Альтернатива'}];
			  vm.formWizard.flat_status = 'alternate';
			} else {
			 vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
				{'name': 'free', 'rusname': 'Свободна'},
				{'name': 'patrol', 'rusname': 'Расселение/разъед'}];			
			}		 
		}
		
		function changeRoomTypes() {
			switch (vm.formWizard.object_type) {
				//типы комнат для квартиры, новостройки, пентхауса
				case 'flat_new_building': //doNothing
				case 'penthouse': //doNothing
				case 'flat': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'}, 
										{'name': '2', 'rusname': 'Двухкомнатная'}, 
										{'name': '3', 'rusname': 'Трехкомнатная'},
										{'name': '4', 'rusname': 'Четырехкомнатная'},
										{'name': '5', 'rusname': 'Пятикомнатная'},
										{'name': 'm', 'rusname': 'Многокомнатная'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
				case 'part': vm.rooms_type_list = [{'name': 'd_1', 'rusname': 'Доля в однокомнатной'}, 
										{'name': 'd_2', 'rusname': 'Доля в двухкомнатной'}, 
										{'name': 'd_3', 'rusname': 'Доля в трехкомнатной'},
										{'name': 'd_4', 'rusname': 'Доля в четырехкомнатной'},
										{'name': 'd_5', 'rusname': 'Доля в пятикомнатной'}];
										break
				case 'room': vm.rooms_type_list = [{'name': '1_2', 'rusname': 'Комната в двухкомнатной'}, 
										{'name': '1_3', 'rusname': 'Комната в трехкомнатной'}, 
										{'name': '1_4', 'rusname': 'Комната в четырехкомнатной'},
										{'name': '1_5', 'rusname': 'Комната в пятикомнатной'},
										{'name': '2_3', 'rusname': '2 комнаты в трехкомнатной'},
										{'name': '2_4', 'rusname': '2 комнаты в четырехкомнатной'},
										{'name': '2_5', 'rusname': '2 комнаты в пятикомнатной'},
										{'name': '3_4', 'rusname': '3 комнаты в четырехкомнатной'},
										{'name': '3_5', 'rusname': '3 комнаты в пятикомнатной'}];
										break											
					  }
		}
		
        function sendForm(ev)
        {			
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
		
					var newobject = new api.objects.newobjectdata();					
					newobject.data = formWizardData;
					newobject.$save();
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flats');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект успешно создан</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}
	
	///////////////////////Загрузка фотографий
	var uploader = $scope.uploader = new FileUploader({
			//инкапсулируем скрипт загрузки в общий модуль, чтобы проверять авторизацию
            url: api.localhost_backend + 'upload',
            removeAfterUpload: true,
			formData: {'id':vm.objectId}
        });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        //События Callbacks
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
        };
        uploader.onAfterAddingFile = function(fileItem) {
            console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
            console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function(item) {
            console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            console.info('onCompleteAll');
        };
        console.info('uploader', uploader);
        
  }    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_blank', {
            url  : '/ui/page-layouts/blank',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/blank/blank.html',
                    controller : 'BlankController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank')
        .controller('BlankController', BlankController);

    /** @ngInject */
    function BlankController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors.error-500', {
            title : '500',
            state : 'app.pages_errors_error-500',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors', {
            title : 'Errors',
            icon  : 'icon-alert',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages.errors.error-404', {
            title : '404',
            state : 'app.pages_errors_error-404',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/pages/auth/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/reset-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.reset-password', {
            title : 'Reset Password',
            state : 'app.pages_auth_reset-password',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register-v2', {
            url      : '/pages/auth/register-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register-v2': {
                    templateUrl: 'app/main/pages/auth/register-v2/register-v2.html',
                    controller : 'RegisterV2Controller as vm'
                }
            },
            bodyClass: 'register-v2'
        });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register-v2');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register-v2', {
            title : 'Register v2',
            state : 'app.pages_auth_register-v2',
            weight: 4
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register-v2')
        .controller('RegisterV2Controller', RegisterV2Controller);

    /** @ngInject */
    function RegisterV2Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register', {
            url      : '/pages/auth/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register', {
            title : 'Register',
            state : 'app.pages_auth_register',
            weight: 3
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/pages/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth', {
            title : 'Authentication',
            icon  : 'icon-lock',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('pages.auth.login', {
            title : 'Login',
            state : 'app.pages_auth_login',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginV2Controller', LoginV2Controller);

    /** @ngInject */
    function LoginV2Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_lock', {
            url      : '/pages/auth/lock',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.lock', {
            title : 'Lock Screen',
            state : 'app.pages_auth_lock',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController()
    {
        var vm = this;

        // Data
        vm.form = {
            username: 'Jane Doe'
        };

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/pages/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
            title : 'Forgot Password',
            state : 'app.pages_auth_forgot-password',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_tables_datatable', {
            url    : '/components/table/datatable',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/tables/datatable/datatable.html',
                    controller : 'DatatableController as vm'
                }
            },
            resolve: {
                Employees: function (apiResolver)
                {
                    return apiResolver.resolve('tables.employees100@get');
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable')
        .controller('DatatableController', DatatableController);

    /** @ngInject */
    function DatatableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_tables_simple-table', {
            url  : '/components/table/simple-table',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/tables/simple-table/simple-table.html',
                    controller : 'SimpleTableController as vm'
                }
            },
            resolve: {
                Employees: function (apiResolver)
                {
                    return apiResolver.resolve('tables.employees@get');
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table')
        .controller('SimpleTableController', SimpleTableController);

    /** @ngInject */
    function SimpleTableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    /**
     * Replace those for demo assets
     * img/                     >>>            assets/angular-material-assets/img/
     * 'icons                   >>>            'assets/angular-material-assets/icons/
     */
    angular
        .module('app.components.material-docs', ['ngMaterial', 'ngMessages'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $stateProvider, ELEMENTS_NAVIGATION)
    {
        msNavigationServiceProvider.saveItem('components.elements', {
            title : 'Angular Material Elements',
            icon  : 'icon-layers',
            weight: 0
        });

        msNavigationServiceProvider.saveItem('components.elements.inputs', {
            title : 'Inputs',
            weight: 0
        });

        msNavigationServiceProvider.saveItem('components.elements.buttons', {
            title : 'Buttons',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('components.elements.content-elements', {
            title : 'Content Elements',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.elements.lists', {
            title : 'Lists',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.elements.menus', {
            title : 'Menus',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.elements.progress', {
            title : 'Progress',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.elements.others', {
            title : 'Others',
            weight: 6
        });


        angular.forEach(ELEMENTS_NAVIGATION, function (component)
        {

            $stateProvider.state('app.docs_' + component.stateName, {
                url  : '/components/angular-material-elements/' + component.url,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/material-docs/material-doc-template.html',
                        controller : 'DocTemplateController as vm'
                    }
                },
                data : component
            });

            // Navigation
            msNavigationServiceProvider.saveItem(component.navPath + '.' + component.url, {
                title : component.name,
                state : 'app.docs_' + component.stateName,
                weight: component.weight
            });
        });

    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .factory('$demoAngularScripts', DemoAngularScripts);

    function DemoAngularScripts()
    {
        var scripts = [
            'angular.js',
            'angular-animate.min.js',
            'angular-route.min.js',
            'angular-aria.min.js',
            'angular-messages.min.js'
        ];

        return {
            all: allAngularScripts
        };

        function allAngularScripts()
        {
            return scripts.map(fullPathToScript);
        }

        function fullPathToScript(script)
        {
            return "https://ajax.googleapis.com/ajax/libs/angularjs/1.4.8/" + script;
            //return "https://ajax.googleapis.com/ajax/libs/angularjs/" + BUILDCONFIG.ngVersion + "/" + script;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .directive('demoInclude', demoInclude)

    function demoInclude($q, $http, $compile, $templateCache, $timeout)
    {
        return {
            restrict: 'E',
            link    : postLink
        };

        function postLink(scope, element, attr)
        {
            var demoContainer;

            // Interpret the expression given as `demo-include files="something"`
            var files = scope.$eval(attr.files) || {};
            var ngModule = scope.$eval(attr.module) || '';

            $timeout(handleDemoIndexFile);

            /**
             * Fetch the index file, and if it contains its own ngModule
             * then bootstrap a new angular app with that ngModule. Otherwise, compile
             * the demo into the current ng-app.
             */
            function handleDemoIndexFile()
            {
                files.index.contentsPromise.then(function (contents)
                {
                    demoContainer = angular.element(
                        '<div class="demo-content ' + ngModule + '">'
                    );

                    var isStandalone = !!ngModule;
                    var demoScope;
                    var demoCompileService;
                    if ( isStandalone )
                    {
                        angular.bootstrap(demoContainer[0], [ngModule]);
                        demoScope = demoContainer.scope();
                        demoCompileService = demoContainer.injector().get('$compile');

                        scope.$on('$destroy', function ()
                        {
                            demoScope.$destroy();
                        });

                    }
                    else
                    {
                        demoScope = scope.$new();
                        demoCompileService = $compile;
                    }

                    // Once everything is loaded, put the demo into the DOM
                    $q.all([
                        handleDemoStyles(),
                        handleDemoTemplates()
                    ]).finally(function ()
                    {

                        demoScope.$evalAsync(function ()
                        {
                            element.append(demoContainer);
                            demoContainer.html(contents);
                            demoCompileService(demoContainer.contents())(demoScope);
                        });


                    });
                });

            }


            /**
             * Fetch the demo styles, and append them to the DOM.
             */
            function handleDemoStyles()
            {
                return $q.all(files.css.map(function (file)
                    {
                        return file.contentsPromise;
                    }))
                    .then(function (styles)
                    {
                        styles = styles.join('\n'); //join styles as one string

                        var styleElement = angular.element('<style>' + styles + '</style>');
                        document.body.appendChild(styleElement[0]);

                        scope.$on('$destroy', function ()
                        {
                            styleElement.remove();
                        });
                    });

            }

            /**
             * Fetch the templates for this demo, and put the templates into
             * the demo app's templateCache, with a url that allows the demo apps
             * to reference their templates local to the demo index file.
             *
             * For example, make it so the dialog demo can reference templateUrl
             * 'my-dialog.tmpl.html' instead of having to reference the url
             * 'generated/material.components.dialog/demo/demo1/my-dialog.tmpl.html'.
             */
            function handleDemoTemplates()
            {

                return $q.all(files.html.map(function (file)
                {

                    return file.contentsPromise.then(function (contents)
                    {
                        // Get the $templateCache instance that goes with the demo's specific ng-app.
                        var demoTemplateCache = demoContainer.injector().get('$templateCache');
                        demoTemplateCache.put(file.name, contents);

                        scope.$on('$destroy', function ()
                        {
                            demoTemplateCache.remove(file.name);
                        });

                    });

                }));

            }

        }

    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .directive('docsDemo', docsDemo)
        .directive('demoFile', demoFile)
        .filter('toHtml', toHtml)
        .directive('layoutAlign', function ()
        {
            return angular.noop;
        })
        .directive('layout', function ()
        {
            return angular.noop;
        });

    /** @ngInject */
    function docsDemo($mdUtil)
    {
        return {
            restrict        : 'E',
            scope           : true,
            templateUrl     : 'app/main/components/material-docs/demo/docs-demo.tmpl.html',
            transclude      : true,
            controller      :DocsDemoCtrl,
            controllerAs    : 'demoCtrl',
            bindToController: true
        };

        function DocsDemoCtrl($scope, $element, $attrs, $interpolate)
        {
            var self = this;

            self.interpolateCode = angular.isDefined($attrs.interpolateCode);
            self.demoId = $interpolate($attrs.demoId || '')($scope.$parent);
            self.demoTitle = $interpolate($attrs.demoTitle || '')($scope.$parent);
            self.demoModule = $interpolate($attrs.demoModule || '')($scope.$parent);
            self.files = {
                css : [],
                js  : [],
                html: []
            };

            self.addFile = function (name, contentsPromise)
            {
                var file = {
                    name           : convertName(name),
                    contentsPromise: contentsPromise,
                    fileType       : name.split('.').pop()
                };
                contentsPromise.then(function (contents)
                {
                    file.contents = contents;
                });

                if ( name === 'index.html' )
                {
                    self.files.index = file;
                }
                else if ( name === 'readme.html' )
                {
                    self.demoDescription = file;
                }
                else
                {
                    self.files[file.fileType] = self.files[file.fileType] || [];
                    self.files[file.fileType].push(file);
                }

                self.orderedFiles = []
                    .concat(self.files.index || [])
                    .concat(self.files.js || [])
                    .concat(self.files.css || [])
                    .concat(self.files.html || []);

            };

            self.editOnCodepen = function ()
            {
                codepen.editOnCodepen({
                    title : self.demoTitle,
                    files : self.files,
                    id    : self.demoId,
                    module: self.demoModule
                });
            };

            function convertName(name)
            {
                switch ( name )
                {
                    case "index.html" :
                        return "HTML";
                    case "script.js" :
                        return "JS";
                    case "style.css" :
                        return "CSS";
                    default :
                        return name;
                }
            }

        }
    }

    /** @ngInject */
    function demoFile($q, $interpolate)
    {
        return {
            restrict: 'E',
            require : '^docsDemo',
            compile : compile
        };

        function compile(element, attr)
        {
            var contentsAttr = attr.contents;
            var html = element.html();
            var name = attr.name;
            element.contents().remove();

            return function postLink(scope, element, attr, docsDemoCtrl)
            {
                docsDemoCtrl.addFile(
                    $interpolate(name)(scope),
                    $q.when(scope.$eval(contentsAttr) || html)
                );
                element.remove();
            };
        }
    }

    /** @ngInject */
    function toHtml($sce)
    {
        return function (str)
        {
            return $sce.trustAsHtml(str);
        };
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .factory('$demoAngularScripts', DemoAngularScripts);

    function DemoAngularScripts()
    {
        var scripts = [
            'angular.js',
            'angular-animate.min.js',
            'angular-route.min.js',
            'angular-aria.min.js',
            'angular-messages.min.js'
        ];

        return {
            all: allAngularScripts
        };

        function allAngularScripts()
        {
            return scripts.map(fullPathToScript);
        }

        function fullPathToScript(script)
        {
            return "https://ajax.googleapis.com/ajax/libs/angularjs/" + angular.version.full + "/" + script;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .constant('ELEMENTS_NAVIGATION', [
            /* INPUTS */
            {
                name      : 'Autocomplete',
                url       : 'autocomplete',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.autocomplete',
                stateName : 'material_components_autocomplete',
                weight    : 1
            },
            {
                name      : 'Checkbox',
                url       : 'checkbox',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.checkbox',
                stateName : 'material_components_checkbox',
                weight    : 2
            },
            {
                name      : 'Chips',
                url       : 'chips',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.chips',
                stateName : 'material_components_chips',
                weight    : 3
            },
            {
                name      : 'Date Picker',
                url       : 'date-picker',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.datepicker',
                stateName : 'material_components_datepicker',
                weight    : 4
            },
            {
                name      : 'Input',
                url       : 'input',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.input',
                stateName : 'material_components_input',
                weight    : 5
            },
            {
                name      : 'Radio Button',
                url       : 'radio-button',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.radioButton',
                stateName : 'material_components_radioButton',
                weight    : 6
            },
            {
                name      : 'Select',
                url       : 'select',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.select',
                stateName : 'material_components_select',
                weight    : 7
            },
            {
                name      : 'Slider',
                url       : 'slider',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.slider',
                stateName : 'material_components_slider',
                weight    : 8
            },
            {
                name      : 'Switch',
                url       : 'switch',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.switch',
                stateName : 'material_components_switch',
                weight    : 9
            },
            /* BUTTONS */
            {
                name      : 'Button',
                url       : 'button',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.button',
                stateName : 'material_components_button',
                weight    : 1
            },
            {
                name      : 'Fab Actions',
                url       : 'fab-actions',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabActions',
                stateName : 'material_components_fabActions',
                weight    : 2
            },
            {
                name      : 'Fab Speed Dial',
                url       : 'fab-speed-dial',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabSpeedDial',
                stateName : 'material_components_fabSpeedDial',
                weight    : 3
            },
            {
                name      : 'Fab Toolbar',
                url       : 'fab-toolbar',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabToolbar',
                stateName : 'material_components_fabToolbar',
                weight    : 4
            },
            /* CONTENT ELEMENTS */
            {
                name      : 'Bottom Sheet',
                url       : 'bottom-sheet',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.bottomSheet',
                stateName : 'material_components_bottomSheet',
                weight    : 1
            },
            {
                name      : 'Card',
                url       : 'card',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.card',
                stateName : 'material_components_card',
                weight    : 2
            },
            {
                name      : 'Content',
                url       : 'content',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.content',
                stateName : 'material_components_content',
                weight    : 3
            },
            {
                name      : 'Dialog',
                url       : 'dialog',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.dialog',
                stateName : 'material_components_dialog',
                weight    : 4
            },
            {
                name       : 'Icon',
                url        : 'icon',
                navPath    : 'components.elements.content-elements',
                moduleName : 'material.components.icon',
                stateName  : 'material_components_icon',
                excludeDemo: true,
                weight     : 5
            },
            {
                name      : 'Sidenav',
                url       : 'sidenav',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.sidenav',
                stateName : 'material_components_sidenav',
                weight    : 6
            },
            {
                name      : 'Subheader',
                url       : 'subheader',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.subheader',
                stateName : 'material_components_subheader',
                weight    : 7
            },
            {
                name      : 'Tabs',
                url       : 'tabs',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.tabs',
                stateName : 'material_components_tabs',
                weight    : 8
            },
            {
                name      : 'Toast',
                url       : 'toast',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.toast',
                stateName : 'material_components_toast',
                weight    : 9
            },
            {
                name      : 'Toolbar',
                url       : 'toolbar',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.toolbar',
                stateName : 'material_components_toolbar',
                weight    : 10
            },
            {
                name      : 'Tooltip',
                url       : 'tooltip',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.tooltip',
                stateName : 'material_components_tooltip',
                weight    : 11
            },
            {
                name      : "Whiteframe",
                url       : 'whiteframe',
                navPath   : 'components.elements.content-elements',
                moduleName: "material.components.whiteframe",
                stateName : 'material_components_whiteframe',
                weight    : 12
            },
            /* LISTS */
            {
                name      : 'Grid List',
                url       : 'grid-list',
                navPath   : 'components.elements.lists',
                moduleName: 'material.components.gridList',
                stateName : 'material_components_gridList',
                weight    : 1
            },
            {
                name      : 'List',
                url       : 'list',
                navPath   : 'components.elements.lists',
                moduleName: 'material.components.list',
                stateName : 'material_components_list',
                weight    : 2
            },
            /* MENUS */
            {
                name      : 'Menu',
                url       : 'menu',
                navPath   : 'components.elements.menus',
                moduleName: 'material.components.menu',
                stateName : 'material_components_menu',
                weight    : 1
            },
            {
                name      : 'Menu Bar',
                url       : 'menu-bar',
                navPath   : 'components.elements.menus',
                moduleName: 'material.components.menuBar',
                stateName : 'material_components_menu-bar',
                weight    : 2
            },
            /* PROGRESS */
            {
                name      : 'Progress Circular',
                url       : 'progress-circular',
                navPath   : 'components.elements.progress',
                moduleName: 'material.components.progressCircular',
                stateName : 'material_components_progressCircular',
                weight    : 1
            },
            {
                name      : 'Progress Linear',
                url       : 'progress-linear',
                navPath   : 'components.elements.progress',
                moduleName: 'material.components.progressLinear',
                stateName : 'material_components_progressLinear',
                weight    : 2
            },
            /* OTHERS */
            {
                name      : 'Divider',
                url       : 'divider',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.divider',
                stateName : 'material_components_divider',
                weight    : 1
            },
            {
                name      : 'Ripple',
                url       : 'ripple',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.ripple',
                stateName : 'material_core_ripple',
                weight    : 2
            },
            {
                name      : 'Sticky',
                url       : 'sticky',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.sticky',
                stateName : 'material_components_sticky',
                weight    : 3
            },
            {
                name      : 'Swipe',
                url       : 'swipe',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.swipe',
                stateName : 'material_components_swipe',
                weight    : 4
            },
            {
                name      : 'Util',
                url       : 'util',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.util',
                stateName : 'material_core_util',
                weight    : 5
            },
            {
                name      : 'Virtual Repeat',
                url       : 'virtual-repeat',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.virtualRepeat',
                stateName : 'material_components_virtualRepeat',
                weight    : 6
            }
        ]);
})();
angular.module('app.components.material-docs')
    .constant('DEMOS', [
        {
            "name"      : "autocomplete",
            "moduleName": "material.components.autocomplete",
            "label"     : "Autocomplete",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "autocompleteDemo",
                        "module"      : "autocompleteDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "autocompletedemoBasicUsage",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/autocomplete/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.autocomplete",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/autocomplete/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "autocompleteCustomTemplateDemo",
                        "module"      : "autocompleteCustomTemplateDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "autocompletedemoCustomTemplate",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/autocomplete/demoCustomTemplate/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/autocomplete/demoCustomTemplate/script.js"
                        }
                    ],
                    "moduleName": "material.components.autocomplete",
                    "name"      : "demoCustomTemplate",
                    "label"     : "Custom Template",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/autocomplete/demoCustomTemplate/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "autocompleteFloatingLabelDemo",
                        "module"      : "autocompleteFloatingLabelDemo",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "autocompletedemoFloatingLabel",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/autocomplete/demoFloatingLabel/script.js"
                        }
                    ],
                    "moduleName": "material.components.autocomplete",
                    "name"      : "demoFloatingLabel",
                    "label"     : "Floating Label",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/autocomplete/demoFloatingLabel/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "autocompleteDemoInsideDialog",
                        "module"      : "autocompleteDemoInsideDialog",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "autocompletedemoInsideDialog",
                    "css"       : [],
                    "html"      : [
                        {
                            "name"      : "dialog.tmpl.html",
                            "label"     : "dialog.tmpl.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/autocomplete/demoInsideDialog/dialog.tmpl.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/autocomplete/demoInsideDialog/script.js"
                        }
                    ],
                    "moduleName": "material.components.autocomplete",
                    "name"      : "demoInsideDialog",
                    "label"     : "Inside Dialog",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/autocomplete/demoInsideDialog/index.html"
                    }
                }
            ],
            "url"       : "demo/autocomplete"
        },
        {
            "name"      : "bottomSheet",
            "moduleName": "material.components.bottomSheet",
            "label"     : "Bottom Sheet",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "bottomSheetDemo1",
                        "module"      : "bottomSheetDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "bottomSheetdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/bottomSheet/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "bottom-sheet-grid-template.html",
                            "label"     : "bottom-sheet-grid-template.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/bottomSheet/demoBasicUsage/bottom-sheet-grid-template.html"
                        },
                        {
                            "name"      : "bottom-sheet-list-template.html",
                            "label"     : "bottom-sheet-list-template.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/bottomSheet/demoBasicUsage/bottom-sheet-list-template.html"
                        },
                        {
                            "name"      : "readme.html",
                            "label"     : "readme.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/bottomSheet/demoBasicUsage/readme.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/bottomSheet/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.bottomSheet",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/bottomSheet/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/bottomSheet"
        },
        {
            "name"      : "button",
            "moduleName": "material.components.button",
            "label"     : "Button",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "buttonsDemo1",
                        "module"      : "buttonsDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "buttondemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/button/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/button/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.button",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/button/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/button"
        },
        {
            "name"      : "card",
            "moduleName": "material.components.card",
            "label"     : "Card",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "cardDemo1",
                        "module"      : "cardDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "carddemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/card/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/card/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.card",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/card/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "cardDemo1",
                        "module"      : "cardDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "carddemoCardActionButtons",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/card/demoCardActionButtons/script.js"
                        }
                    ],
                    "moduleName": "material.components.card",
                    "name"      : "demoCardActionButtons",
                    "label"     : "Card Action Buttons",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/card/demoCardActionButtons/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "cardDemo1",
                        "module"      : "cardDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "carddemoInCardActions",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/card/demoInCardActions/script.js"
                        }
                    ],
                    "moduleName": "material.components.card",
                    "name"      : "demoInCardActions",
                    "label"     : "In Card Actions",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/card/demoInCardActions/index.html"
                    }
                }
            ],
            "url"       : "demo/card"
        },
        {
            "name"      : "checkbox",
            "moduleName": "material.components.checkbox",
            "label"     : "Checkbox",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "checkboxDemo1",
                        "module"      : "checkboxDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "checkboxdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/checkbox/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/checkbox/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.checkbox",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/checkbox/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "checkboxDemo1",
                        "module"      : "checkboxDemo2",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "checkboxdemoSyncing",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/checkbox/demoSyncing/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/checkbox/demoSyncing/script.js"
                        }
                    ],
                    "moduleName": "material.components.checkbox",
                    "name"      : "demoSyncing",
                    "label"     : "Syncing",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/checkbox/demoSyncing/index.html"
                    }
                }
            ],
            "url"       : "demo/checkbox"
        },
        {
            "name"      : "chips",
            "moduleName": "material.components.chips",
            "label"     : "Chips",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "chipsDemo",
                        "module"      : "chipsDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "chipsdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/chips/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/chips/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.chips",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/chips/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "contactChipsDemo",
                        "module"      : "contactChipsDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "chipsdemoContactChips",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/chips/demoContactChips/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/chips/demoContactChips/script.js"
                        }
                    ],
                    "moduleName": "material.components.chips",
                    "name"      : "demoContactChips",
                    "label"     : "Contact Chips",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/chips/demoContactChips/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "chipsCustomInputDemo",
                        "module"      : "chipsCustomInputDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "chipsdemoCustomInputs",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/chips/demoCustomInputs/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/chips/demoCustomInputs/script.js"
                        }
                    ],
                    "moduleName": "material.components.chips",
                    "name"      : "demoCustomInputs",
                    "label"     : "Custom Inputs",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/chips/demoCustomInputs/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "chipsCustomSeparatorDemo",
                        "module"      : "chipsCustomSeparatorDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "chipsdemoCustomSeparatorKeys",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/chips/demoCustomSeparatorKeys/script.js"
                        }
                    ],
                    "moduleName": "material.components.chips",
                    "name"      : "demoCustomSeparatorKeys",
                    "label"     : "Custom Separator Keys",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/chips/demoCustomSeparatorKeys/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "staticChipsDemo",
                        "module"      : "staticChipsDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "chipsdemoStaticChips",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/chips/demoStaticChips/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/chips/demoStaticChips/script.js"
                        }
                    ],
                    "moduleName": "material.components.chips",
                    "name"      : "demoStaticChips",
                    "label"     : "Static Chips",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/chips/demoStaticChips/index.html"
                    }
                }
            ],
            "url"       : "demo/chips"
        },
        {
            "name"      : "content",
            "moduleName": "material.components.content",
            "label"     : "Content",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "contentDemo1",
                        "module"      : "contentDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "contentdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/content/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/content/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.content",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/content/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/content"
        },
        {
            "name"      : "datepicker",
            "moduleName": "material.components.datepicker",
            "label"     : "Datepicker",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "datepickerBasicUsage",
                        "module"      : "datepickerBasicUsage",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "datepickerdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/datepicker/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/datepicker/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.datepicker",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/datepicker/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/datepicker"
        },
        {
            "name"      : "dialog",
            "moduleName": "material.components.dialog",
            "label"     : "Dialog",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "dialogDemo1",
                        "module"      : "dialogDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "dialogdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/dialog/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "dialog1.tmpl.html",
                            "label"     : "dialog1.tmpl.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/dialog/demoBasicUsage/dialog1.tmpl.html"
                        },
                        {
                            "name"      : "tabDialog.tmpl.html",
                            "label"     : "tabDialog.tmpl.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/dialog/demoBasicUsage/tabDialog.tmpl.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/dialog/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.dialog",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/dialog/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "dialogDemo2",
                        "module"      : "dialogDemo2",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "dialogdemoOpenFromCloseTo",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/dialog/demoOpenFromCloseTo/script.js"
                        }
                    ],
                    "moduleName": "material.components.dialog",
                    "name"      : "demoOpenFromCloseTo",
                    "label"     : "Open From Close To",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/dialog/demoOpenFromCloseTo/index.html"
                    }
                }
            ],
            "url"       : "demo/dialog"
        },
        {
            "name"      : "divider",
            "moduleName": "material.components.divider",
            "label"     : "Divider",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "dividerDemo1",
                        "module"      : "dividerDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "dividerdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/divider/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/divider/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.divider",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/divider/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/divider"
        },
        {
            "name"      : "fabSpeedDial",
            "moduleName": "material.components.fabSpeedDial",
            "label"     : "FAB Speed Dial",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "fabSpeedDialDemoBasicUsage",
                        "module"      : "fabSpeedDialDemoBasicUsage",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "fabSpeedDialdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/fabSpeedDial/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/fabSpeedDial/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.fabSpeedDial",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/fabSpeedDial/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "fabSpeedDialDemoMoreOptions",
                        "module"      : "fabSpeedDialDemoMoreOptions",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "fabSpeedDialdemoMoreOptions",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/fabSpeedDial/demoMoreOptions/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/fabSpeedDial/demoMoreOptions/script.js"
                        }
                    ],
                    "moduleName": "material.components.fabSpeedDial",
                    "name"      : "demoMoreOptions",
                    "label"     : "More Options",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/fabSpeedDial/demoMoreOptions/index.html"
                    }
                }
            ],
            "url"       : "demo/fabSpeedDial"
        },
        {
            "name"      : "fabToolbar",
            "moduleName": "material.components.fabToolbar",
            "label"     : "FAB Toolbar",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "fabToolbarBasicUsageDemo",
                        "module"      : "fabToolbarBasicUsageDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "fabToolbardemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/fabToolbar/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/fabToolbar/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.fabToolbar",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/fabToolbar/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/fabToolbar"
        },
        {
            "name"      : "gridList",
            "moduleName": "material.components.gridList",
            "label"     : "Grid List",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "gridListDemo1",
                        "module"      : "gridListDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "gridListdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "styles.css",
                            "label"     : "styles.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/gridList/demoBasicUsage/styles.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/gridList/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.gridList",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/gridList/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "gridListDemoApp",
                        "module"      : "gridListDemoApp",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "gridListdemoDynamicTiles",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/gridList/demoDynamicTiles/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/gridList/demoDynamicTiles/script.js"
                        }
                    ],
                    "moduleName": "material.components.gridList",
                    "name"      : "demoDynamicTiles",
                    "label"     : "Dynamic Tiles",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/gridList/demoDynamicTiles/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "gridListDemo1",
                        "module"      : "gridListDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "gridListdemoResponsiveUsage",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/gridList/demoResponsiveUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.gridList",
                    "name"      : "demoResponsiveUsage",
                    "label"     : "Responsive Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/gridList/demoResponsiveUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/gridList"
        },
        {
            "name"      : "icon",
            "moduleName": "material.components.icon",
            "label"     : "Icon",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "appDemoFontIconsWithClassnames",
                        "module"      : "appDemoFontIconsWithClassnames",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "icondemoFontIconsWithClassnames",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/icon/demoFontIconsWithClassnames/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/icon/demoFontIconsWithClassnames/script.js"
                        }
                    ],
                    "moduleName": "material.components.icon",
                    "name"      : "demoFontIconsWithClassnames",
                    "label"     : "Font Icons With Classnames",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/icon/demoFontIconsWithClassnames/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "appDemoFontIconsWithLigatures",
                        "module"      : "appDemoFontIconsWithLigatures",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "icondemoFontIconsWithLigatures",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/icon/demoFontIconsWithLigatures/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/icon/demoFontIconsWithLigatures/script.js"
                        }
                    ],
                    "moduleName": "material.components.icon",
                    "name"      : "demoFontIconsWithLigatures",
                    "label"     : "Font Icons With Ligatures",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/icon/demoFontIconsWithLigatures/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "appDemoSvgIcons",
                        "module"      : "appDemoSvgIcons",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "icondemoLoadSvgIconsFromUrl",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/icon/demoLoadSvgIconsFromUrl/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/icon/demoLoadSvgIconsFromUrl/script.js"
                        }
                    ],
                    "moduleName": "material.components.icon",
                    "name"      : "demoLoadSvgIconsFromUrl",
                    "label"     : "Load Svg Icons From Url",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/icon/demoLoadSvgIconsFromUrl/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "appSvgIconSets",
                        "module"      : "appSvgIconSets",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "icondemoSvgIconSets",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/icon/demoSvgIconSets/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/icon/demoSvgIconSets/script.js"
                        }
                    ],
                    "moduleName": "material.components.icon",
                    "name"      : "demoSvgIconSets",
                    "label"     : "Svg Icon Sets",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/icon/demoSvgIconSets/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "appUsingTemplateCache",
                        "module"      : "appUsingTemplateCache",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "icondemoUsingTemplateCache",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/icon/demoUsingTemplateCache/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/icon/demoUsingTemplateCache/script.js"
                        }
                    ],
                    "moduleName": "material.components.icon",
                    "name"      : "demoUsingTemplateCache",
                    "label"     : "Using Template Cache",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/icon/demoUsingTemplateCache/index.html"
                    }
                }
            ],
            "url"       : "demo/icon"
        },
        {
            "name"      : "input",
            "moduleName": "material.components.input",
            "label"     : "Input",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "inputBasicDemo",
                        "module"      : "inputBasicDemo",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "inputdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/input/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/input/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.input",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/input/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "inputErrorsApp",
                        "module"      : "inputErrorsApp",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "inputdemoErrors",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/input/demoErrors/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/input/demoErrors/script.js"
                        }
                    ],
                    "moduleName": "material.components.input",
                    "name"      : "demoErrors",
                    "label"     : "Errors",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/input/demoErrors/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "inputErrorsAdvancedApp",
                        "module"      : "inputErrorsAdvancedApp",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "inputdemoErrorsAdvanced",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/input/demoErrorsAdvanced/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/input/demoErrorsAdvanced/script.js"
                        }
                    ],
                    "moduleName": "material.components.input",
                    "name"      : "demoErrorsAdvanced",
                    "label"     : "Errors Advanced",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/input/demoErrorsAdvanced/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "inputIconDemo",
                        "module"      : "inputIconDemo",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "inputdemoIcons",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/input/demoIcons/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/input/demoIcons/script.js"
                        }
                    ],
                    "moduleName": "material.components.input",
                    "name"      : "demoIcons",
                    "label"     : "Icons",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/input/demoIcons/index.html"
                    }
                }
            ],
            "url"       : "demo/input"
        },
        {
            "name"      : "list",
            "moduleName": "material.components.list",
            "label"     : "List",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "listDemo1",
                        "module"      : "listDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "listdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/list/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/list/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.list",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/list/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "listDemo2",
                        "module"      : "listDemo2",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "listdemoListControls",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/list/demoListControls/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/list/demoListControls/script.js"
                        }
                    ],
                    "moduleName": "material.components.list",
                    "name"      : "demoListControls",
                    "label"     : "List Controls",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/list/demoListControls/index.html"
                    }
                }
            ],
            "url"       : "demo/list"
        },
        {
            "name"      : "menu",
            "moduleName": "material.components.menu",
            "label"     : "Menu",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "menuDemoBasic",
                        "module"      : "menuDemoBasic",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "menudemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/menu/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/menu/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.menu",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/menu/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "menuDemoPosition",
                        "module"      : "menuDemoPosition",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "menudemoMenuPositionModes",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/menu/demoMenuPositionModes/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/menu/demoMenuPositionModes/script.js"
                        }
                    ],
                    "moduleName": "material.components.menu",
                    "name"      : "demoMenuPositionModes",
                    "label"     : "Menu Position Modes",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/menu/demoMenuPositionModes/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "menuDemoWidth",
                        "module"      : "menuDemoWidth",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "menudemoMenuWidth",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/menu/demoMenuWidth/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/menu/demoMenuWidth/script.js"
                        }
                    ],
                    "moduleName": "material.components.menu",
                    "name"      : "demoMenuWidth",
                    "label"     : "Menu Width",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/menu/demoMenuWidth/index.html"
                    }
                }
            ],
            "url"       : "demo/menu"
        },
        {
            "name"      : "menuBar",
            "moduleName": "material.components.menuBar",
            "label"     : "Menu Bar",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "menuBarDemoBasic",
                        "module"      : "menuBarDemoBasic",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "menuBardemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/menuBar/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/menuBar/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.menuBar",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/menuBar/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/menuBar"
        },
        {
            "name"      : "progressCircular",
            "moduleName": "material.components.progressCircular",
            "label"     : "Progress Circular",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "progressCircularDemo1",
                        "module"      : "progressCircularDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "progressCirculardemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/progressCircular/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/progressCircular/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.progressCircular",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/progressCircular/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/progressCircular"
        },
        {
            "name"      : "progressLinear",
            "moduleName": "material.components.progressLinear",
            "label"     : "Progress Linear",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "progressLinearDemo1",
                        "module"      : "progressLinearDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "progressLineardemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/progressLinear/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/progressLinear/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.progressLinear",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/progressLinear/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/progressLinear"
        },
        {
            "name"      : "radioButton",
            "moduleName": "material.components.radioButton",
            "label"     : "Radio Button",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "radioDemo1",
                        "module"      : "radioDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "radioButtondemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/radioButton/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/radioButton/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.radioButton",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/radioButton/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "radioDemo2",
                        "module"      : "radioDemo2",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "radioButtondemoMultiColumn",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/radioButton/demoMultiColumn/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/radioButton/demoMultiColumn/script.js"
                        }
                    ],
                    "moduleName": "material.components.radioButton",
                    "name"      : "demoMultiColumn",
                    "label"     : "Multi Column",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/radioButton/demoMultiColumn/index.html"
                    }
                }
            ],
            "url"       : "demo/radioButton"
        },
        {
            "name"      : "select",
            "moduleName": "material.components.select",
            "label"     : "Select",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "selectDemoBasic",
                        "module"      : "selectDemoBasic",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "selectdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/select/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/select/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.select",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/select/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "selectDemoOptGroups",
                        "module"      : "selectDemoOptGroups",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "selectdemoOptionGroups",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/select/demoOptionGroups/script.js"
                        }
                    ],
                    "moduleName": "material.components.select",
                    "name"      : "demoOptionGroups",
                    "label"     : "Option Groups",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/select/demoOptionGroups/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "selectDemoOptionsAsync",
                        "module"      : "selectDemoOptionsAsync",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "selectdemoOptionsWithAsyncSearch",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/select/demoOptionsWithAsyncSearch/script.js"
                        }
                    ],
                    "moduleName": "material.components.select",
                    "name"      : "demoOptionsWithAsyncSearch",
                    "label"     : "Options With Async Search",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/select/demoOptionsWithAsyncSearch/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "selectDemoValidation",
                        "module"      : "selectDemoValidation",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "selectdemoValidations",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/select/demoValidations/script.js"
                        }
                    ],
                    "moduleName": "material.components.select",
                    "name"      : "demoValidations",
                    "label"     : "Validations",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/select/demoValidations/index.html"
                    }
                }
            ],
            "url"       : "demo/select"
        },
        {
            "name"      : "sidenav",
            "moduleName": "material.components.sidenav",
            "label"     : "Sidenav",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "sidenavDemo1",
                        "module"      : "sidenavDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "sidenavdemoBasicUsage",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/sidenav/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.sidenav",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/sidenav/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/sidenav"
        },
        {
            "name"      : "slider",
            "moduleName": "material.components.slider",
            "label"     : "Slider",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "sliderDemo1",
                        "module"      : "sliderDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "sliderdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/slider/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/slider/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.slider",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/slider/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/slider"
        },
        {
            "name"      : "subheader",
            "moduleName": "material.components.subheader",
            "label"     : "Subheader",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "subheaderBasicDemo",
                        "module"      : "subheaderBasicDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "subheaderdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/subheader/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/subheader/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.subheader",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/subheader/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/subheader"
        },
        {
            "name"      : "swipe",
            "moduleName": "material.components.swipe",
            "label"     : "Swipe",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "demoSwipe",
                        "module"      : "demoSwipe",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "swipedemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/swipe/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "readme.html",
                            "label"     : "readme.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/swipe/demoBasicUsage/readme.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/swipe/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.swipe",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/swipe/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/swipe"
        },
        {
            "name"      : "switch",
            "moduleName": "material.components.switch",
            "label"     : "Switch",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "switchDemo1",
                        "module"      : "switchDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "switchdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/switch/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/switch/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.switch",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/switch/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/switch"
        },
        {
            "name"      : "tabs",
            "moduleName": "material.components.tabs",
            "label"     : "Tabs",
            "demos"     : [
                {
                    "ngModule"  : "",
                    "id"        : "tabsdemoDynamicHeight",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/tabs/demoDynamicHeight/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "readme.html",
                            "label"     : "readme.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/tabs/demoDynamicHeight/readme.html"
                        }
                    ],
                    "js"        : [],
                    "moduleName": "material.components.tabs",
                    "name"      : "demoDynamicHeight",
                    "label"     : "Dynamic Height",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/tabs/demoDynamicHeight/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "tabsDemoDynamicTabs",
                        "module"      : "tabsDemoDynamicTabs",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "tabsdemoDynamicTabs",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/tabs/demoDynamicTabs/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "readme.html",
                            "label"     : "readme.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/tabs/demoDynamicTabs/readme.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/tabs/demoDynamicTabs/script.js"
                        }
                    ],
                    "moduleName": "material.components.tabs",
                    "name"      : "demoDynamicTabs",
                    "label"     : "Dynamic Tabs",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/tabs/demoDynamicTabs/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "tabsDemoStaticTabs",
                        "module"      : "tabsDemoStaticTabs",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "tabsdemoStaticTabs",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/tabs/demoStaticTabs/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "readme.html",
                            "label"     : "readme.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/tabs/demoStaticTabs/readme.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/tabs/demoStaticTabs/script.js"
                        }
                    ],
                    "moduleName": "material.components.tabs",
                    "name"      : "demoStaticTabs",
                    "label"     : "Static Tabs",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/tabs/demoStaticTabs/index.html"
                    }
                }
            ],
            "url"       : "demo/tabs"
        },
        {
            "name"      : "toast",
            "moduleName": "material.components.toast",
            "label"     : "Toast",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "toastDemo1",
                        "module"      : "toastDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "toastdemoBasicUsage",
                    "css"       : [],
                    "html"      : [
                        {
                            "name"      : "toast-template.html",
                            "label"     : "toast-template.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/toast/demoBasicUsage/toast-template.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/toast/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.toast",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/toast/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/toast"
        },
        {
            "name"      : "toolbar",
            "moduleName": "material.components.toolbar",
            "label"     : "Toolbar",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "toolbarDemo1",
                        "module"      : "toolbarDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "toolbardemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/toolbar/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/toolbar/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.toolbar",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/toolbar/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "toolbarDemo2",
                        "module"      : "toolbarDemo2",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "toolbardemoScrollShrink",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/toolbar/demoScrollShrink/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/toolbar/demoScrollShrink/script.js"
                        }
                    ],
                    "moduleName": "material.components.toolbar",
                    "name"      : "demoScrollShrink",
                    "label"     : "Scroll Shrink",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/toolbar/demoScrollShrink/index.html"
                    }
                }
            ],
            "url"       : "demo/toolbar"
        },
        {
            "name"      : "tooltip",
            "moduleName": "material.components.tooltip",
            "label"     : "Tooltip",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "tooltipDemo1",
                        "module"      : "tooltipDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "tooltipdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/tooltip/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/tooltip/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.tooltip",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/tooltip/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/tooltip"
        },
        {
            "name"      : "virtualRepeat",
            "moduleName": "material.components.virtualRepeat",
            "label"     : "Virtual Repeat",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "virtualRepeatDeferredLoadingDemo",
                        "module"      : "virtualRepeatDeferredLoadingDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "virtualRepeatdemoDeferredLoading",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/virtualRepeat/demoDeferredLoading/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/virtualRepeat/demoDeferredLoading/script.js"
                        }
                    ],
                    "moduleName": "material.components.virtualRepeat",
                    "name"      : "demoDeferredLoading",
                    "label"     : "Deferred Loading",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/virtualRepeat/demoDeferredLoading/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "virtualRepeatHorizontalDemo",
                        "module"      : "virtualRepeatHorizontalDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "virtualRepeatdemoHorizontalUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/virtualRepeat/demoHorizontalUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/virtualRepeat/demoHorizontalUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.virtualRepeat",
                    "name"      : "demoHorizontalUsage",
                    "label"     : "Horizontal Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/virtualRepeat/demoHorizontalUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "virtualRepeatInfiniteScrollDemo",
                        "module"      : "virtualRepeatInfiniteScrollDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "virtualRepeatdemoInfiniteScroll",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/virtualRepeat/demoInfiniteScroll/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/virtualRepeat/demoInfiniteScroll/script.js"
                        }
                    ],
                    "moduleName": "material.components.virtualRepeat",
                    "name"      : "demoInfiniteScroll",
                    "label"     : "Infinite Scroll",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/virtualRepeat/demoInfiniteScroll/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "virtualRepeatScrollToDemo",
                        "module"      : "virtualRepeatScrollToDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "virtualRepeatdemoScrollTo",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/virtualRepeat/demoScrollTo/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/virtualRepeat/demoScrollTo/script.js"
                        }
                    ],
                    "moduleName": "material.components.virtualRepeat",
                    "name"      : "demoScrollTo",
                    "label"     : "Scroll To",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/virtualRepeat/demoScrollTo/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "virtualRepeatVerticalDemo",
                        "module"      : "virtualRepeatVerticalDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "virtualRepeatdemoVerticalUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/virtualRepeat/demoVerticalUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/virtualRepeat/demoVerticalUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.virtualRepeat",
                    "name"      : "demoVerticalUsage",
                    "label"     : "Vertical Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/virtualRepeat/demoVerticalUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/virtualRepeat"
        },
        {
            "name"      : "whiteframe",
            "moduleName": "material.components.whiteframe",
            "label"     : "Whiteframe",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "whiteframeBasicUsage",
                        "module"      : "whiteframeBasicUsage",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "whiteframedemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/whiteframe/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/whiteframe/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.whiteframe",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/whiteframe/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/whiteframe"
        }
    ]);
angular.module('app.components.material-docs')
    .constant('COMPONENTS', [
        {
            "name"      : "material.components.autocomplete",
            "type"      : "module",
            "outputPath": "partials/api/material.components.autocomplete/index.html",
            "url"       : "api/material.components.autocomplete",
            "label"     : "material.components.autocomplete",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/autocomplete/autocomplete.js",
            "docs"      : [
                {
                    "name"      : "mdAutocomplete",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.autocomplete/directive/mdAutocomplete.html",
                    "url"       : "api/directive/mdAutocomplete",
                    "label"     : "mdAutocomplete",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/autocomplete/js/autocompleteDirective.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdHighlightText",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.autocomplete/directive/mdHighlightText.html",
                    "url"       : "api/directive/mdHighlightText",
                    "label"     : "mdHighlightText",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/autocomplete/js/highlightDirective.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.bottomSheet",
            "type"      : "module",
            "outputPath": "partials/api/material.components.bottomSheet/index.html",
            "url"       : "api/material.components.bottomSheet",
            "label"     : "material.components.bottomSheet",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/bottomSheet/bottom-sheet.js",
            "docs"      : [
                {
                    "name"      : "$mdBottomSheet",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.bottomSheet/service/$mdBottomSheet.html",
                    "url"       : "api/service/$mdBottomSheet",
                    "label"     : "$mdBottomSheet",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/bottomSheet/bottom-sheet.js",
                    "hasDemo"   : false
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.button",
            "type"      : "module",
            "outputPath": "partials/api/material.components.button/index.html",
            "url"       : "api/material.components.button",
            "label"     : "material.components.button",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/button/button.js",
            "docs"      : [
                {
                    "name"      : "mdButton",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.button/directive/mdButton.html",
                    "url"       : "api/directive/mdButton",
                    "label"     : "mdButton",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/button/button.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.card",
            "type"      : "module",
            "outputPath": "partials/api/material.components.card/index.html",
            "url"       : "api/material.components.card",
            "label"     : "material.components.card",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/card/card.js",
            "docs"      : [
                {
                    "name"      : "mdCard",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.card/directive/mdCard.html",
                    "url"       : "api/directive/mdCard",
                    "label"     : "mdCard",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/card/card.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.checkbox",
            "type"      : "module",
            "outputPath": "partials/api/material.components.checkbox/index.html",
            "url"       : "api/material.components.checkbox",
            "label"     : "material.components.checkbox",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/checkbox/checkbox.js",
            "docs"      : [
                {
                    "name"      : "mdCheckbox",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.checkbox/directive/mdCheckbox.html",
                    "url"       : "api/directive/mdCheckbox",
                    "label"     : "mdCheckbox",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/checkbox/checkbox.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.chips",
            "type"      : "module",
            "outputPath": "partials/api/material.components.chips/index.html",
            "url"       : "api/material.components.chips",
            "label"     : "material.components.chips",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/chips/chips.js",
            "docs"      : [
                {
                    "name"      : "mdChip",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.chips/directive/mdChip.html",
                    "url"       : "api/directive/mdChip",
                    "label"     : "mdChip",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/chips/js/chipDirective.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdChipRemove",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.chips/directive/mdChipRemove.html",
                    "url"       : "api/directive/mdChipRemove",
                    "label"     : "mdChipRemove",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/chips/js/chipRemoveDirective.js"
                },
                {
                    "name"      : "mdChips",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.chips/directive/mdChips.html",
                    "url"       : "api/directive/mdChips",
                    "label"     : "mdChips",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/chips/js/chipsDirective.js"
                },
                {
                    "name"      : "mdContactChips",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.chips/directive/mdContactChips.html",
                    "url"       : "api/directive/mdContactChips",
                    "label"     : "mdContactChips",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/chips/js/contactChipsDirective.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.content",
            "type"      : "module",
            "outputPath": "partials/api/material.components.content/index.html",
            "url"       : "api/material.components.content",
            "label"     : "material.components.content",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/content/content.js",
            "docs"      : [
                {
                    "name"      : "mdContent",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.content/directive/mdContent.html",
                    "url"       : "api/directive/mdContent",
                    "label"     : "mdContent",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/content/content.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.datepicker",
            "type"      : "module",
            "outputPath": "partials/api/material.components.datepicker/index.html",
            "url"       : "api/material.components.datepicker",
            "label"     : "material.components.datepicker",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/datepicker/calendar.js",
            "docs"      : [
                {
                    "name"      : "$mdDateLocaleProvider",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.datepicker/service/$mdDateLocaleProvider.html",
                    "url"       : "api/service/$mdDateLocaleProvider",
                    "label"     : "$mdDateLocaleProvider",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/datepicker/dateLocaleProvider.js",
                    "hasDemo"   : false
                },
                {
                    "name"      : "mdDatepicker",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.datepicker/directive/mdDatepicker.html",
                    "url"       : "api/directive/mdDatepicker",
                    "label"     : "mdDatepicker",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/datepicker/datePicker.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.dialog",
            "type"      : "module",
            "outputPath": "partials/api/material.components.dialog/index.html",
            "url"       : "api/material.components.dialog",
            "label"     : "material.components.dialog",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/dialog/dialog.js",
            "docs"      : [
                {
                    "name"      : "mdDialog",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.dialog/directive/mdDialog.html",
                    "url"       : "api/directive/mdDialog",
                    "label"     : "mdDialog",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/dialog/dialog.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "$mdDialog",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.dialog/service/$mdDialog.html",
                    "url"       : "api/service/$mdDialog",
                    "label"     : "$mdDialog",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/dialog/dialog.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.divider",
            "type"      : "module",
            "outputPath": "partials/api/material.components.divider/index.html",
            "url"       : "api/material.components.divider",
            "label"     : "material.components.divider",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/divider/divider.js",
            "docs"      : [
                {
                    "name"      : "mdDivider",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.divider/directive/mdDivider.html",
                    "url"       : "api/directive/mdDivider",
                    "label"     : "mdDivider",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/divider/divider.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.fabActions",
            "type"      : "module",
            "outputPath": "partials/api/material.components.fabActions/index.html",
            "url"       : "api/material.components.fabActions",
            "label"     : "material.components.fabActions",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabActions/fabActions.js",
            "docs"      : [
                {
                    "name"      : "mdFabActions",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.fabActions/directive/mdFabActions.html",
                    "url"       : "api/directive/mdFabActions",
                    "label"     : "mdFabActions",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabActions/fabActions.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.fabSpeedDial",
            "type"      : "module",
            "outputPath": "partials/api/material.components.fabSpeedDial/index.html",
            "url"       : "api/material.components.fabSpeedDial",
            "label"     : "material.components.fabSpeedDial",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabSpeedDial/fabSpeedDial.js",
            "docs"      : [
                {
                    "name"      : "mdFabSpeedDial",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.fabSpeedDial/directive/mdFabSpeedDial.html",
                    "url"       : "api/directive/mdFabSpeedDial",
                    "label"     : "mdFabSpeedDial",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabSpeedDial/fabSpeedDial.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdFabTrigger",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.fabSpeedDial/directive/mdFabTrigger.html",
                    "url"       : "api/directive/mdFabTrigger",
                    "label"     : "mdFabTrigger",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabTrigger/fabTrigger.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.fabToolbar",
            "type"      : "module",
            "outputPath": "partials/api/material.components.fabToolbar/index.html",
            "url"       : "api/material.components.fabToolbar",
            "label"     : "material.components.fabToolbar",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabToolbar/fabToolbar.js",
            "docs"      : [
                {
                    "name"      : "mdFabToolbar",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.fabToolbar/directive/mdFabToolbar.html",
                    "url"       : "api/directive/mdFabToolbar",
                    "label"     : "mdFabToolbar",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabToolbar/fabToolbar.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.gridList",
            "type"      : "module",
            "outputPath": "partials/api/material.components.gridList/index.html",
            "url"       : "api/material.components.gridList",
            "label"     : "material.components.gridList",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js",
            "docs"      : [
                {
                    "name"      : "mdGridList",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.gridList/directive/mdGridList.html",
                    "url"       : "api/directive/mdGridList",
                    "label"     : "mdGridList",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdGridTile",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.gridList/directive/mdGridTile.html",
                    "url"       : "api/directive/mdGridTile",
                    "label"     : "mdGridTile",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.icon",
            "type"      : "module",
            "outputPath": "partials/api/material.components.icon/index.html",
            "url"       : "api/material.components.icon",
            "label"     : "material.components.icon",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/icon/icon.js",
            "docs"      : [
                {
                    "name"      : "mdIcon",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.icon/directive/mdIcon.html",
                    "url"       : "api/directive/mdIcon",
                    "label"     : "mdIcon",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/icon/js/iconDirective.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "$mdIconProvider",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.icon/service/$mdIconProvider.html",
                    "url"       : "api/service/$mdIconProvider",
                    "label"     : "$mdIconProvider",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/icon/js/iconService.js"
                },
                {
                    "name"      : "$mdIcon",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.icon/service/$mdIcon.html",
                    "url"       : "api/service/$mdIcon",
                    "label"     : "$mdIcon",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/icon/js/iconService.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.input",
            "type"      : "module",
            "outputPath": "partials/api/material.components.input/index.html",
            "url"       : "api/material.components.input",
            "label"     : "material.components.input",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/input/input.js",
            "docs"      : [
                {
                    "name"      : "mdInputContainer",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.input/directive/mdInputContainer.html",
                    "url"       : "api/directive/mdInputContainer",
                    "label"     : "mdInputContainer",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/input/input.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdInput",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.input/directive/mdInput.html",
                    "url"       : "api/directive/mdInput",
                    "label"     : "mdInput",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/input/input.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.list",
            "type"      : "module",
            "outputPath": "partials/api/material.components.list/index.html",
            "url"       : "api/material.components.list",
            "label"     : "material.components.list",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/list/list.js",
            "docs"      : [
                {
                    "name"      : "mdList",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.list/directive/mdList.html",
                    "url"       : "api/directive/mdList",
                    "label"     : "mdList",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/list/list.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdListItem",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.list/directive/mdListItem.html",
                    "url"       : "api/directive/mdListItem",
                    "label"     : "mdListItem",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/list/list.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.menu",
            "type"      : "module",
            "outputPath": "partials/api/material.components.menu/index.html",
            "url"       : "api/material.components.menu",
            "label"     : "material.components.menu",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/menu/menu.js",
            "docs"      : [
                {
                    "name"      : "mdMenu",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.menu/directive/mdMenu.html",
                    "url"       : "api/directive/mdMenu",
                    "label"     : "mdMenu",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/menu/js/menuDirective.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.menu-bar",
            "type"      : "module",
            "outputPath": "partials/api/material.components.menu-bar/index.html",
            "url"       : "api/material.components.menu-bar",
            "label"     : "material.components.menu-bar",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/menuBar/menu-bar.js",
            "docs"      : [
                {
                    "name"      : "mdMenuBar",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.menu-bar/directive/mdMenuBar.html",
                    "url"       : "api/directive/mdMenuBar",
                    "label"     : "mdMenuBar",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/menuBar/js/menuBarDirective.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.progressCircular",
            "type"      : "module",
            "outputPath": "partials/api/material.components.progressCircular/index.html",
            "url"       : "api/material.components.progressCircular",
            "label"     : "material.components.progressCircular",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/progressCircular/progress-circular.js",
            "docs"      : [
                {
                    "name"      : "mdProgressCircular",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.progressCircular/directive/mdProgressCircular.html",
                    "url"       : "api/directive/mdProgressCircular",
                    "label"     : "mdProgressCircular",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/progressCircular/progress-circular.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.progressLinear",
            "type"      : "module",
            "outputPath": "partials/api/material.components.progressLinear/index.html",
            "url"       : "api/material.components.progressLinear",
            "label"     : "material.components.progressLinear",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/progressLinear/progress-linear.js",
            "docs"      : [
                {
                    "name"      : "mdProgressLinear",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.progressLinear/directive/mdProgressLinear.html",
                    "url"       : "api/directive/mdProgressLinear",
                    "label"     : "mdProgressLinear",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/progressLinear/progress-linear.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.radioButton",
            "type"      : "module",
            "outputPath": "partials/api/material.components.radioButton/index.html",
            "url"       : "api/material.components.radioButton",
            "label"     : "material.components.radioButton",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js",
            "docs"      : [
                {
                    "name"      : "mdRadioGroup",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.radioButton/directive/mdRadioGroup.html",
                    "url"       : "api/directive/mdRadioGroup",
                    "label"     : "mdRadioGroup",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdRadioButton",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.radioButton/directive/mdRadioButton.html",
                    "url"       : "api/directive/mdRadioButton",
                    "label"     : "mdRadioButton",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.select",
            "type"      : "module",
            "outputPath": "partials/api/material.components.select/index.html",
            "url"       : "api/material.components.select",
            "label"     : "material.components.select",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/select/select.js",
            "docs"      : [
                {
                    "name"      : "mdSelect",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.select/directive/mdSelect.html",
                    "url"       : "api/directive/mdSelect",
                    "label"     : "mdSelect",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/select/select.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.sidenav",
            "type"      : "module",
            "outputPath": "partials/api/material.components.sidenav/index.html",
            "url"       : "api/material.components.sidenav",
            "label"     : "material.components.sidenav",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js",
            "docs"      : [
                {
                    "name"      : "$mdSidenav",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.sidenav/service/$mdSidenav.html",
                    "url"       : "api/service/$mdSidenav",
                    "label"     : "$mdSidenav",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js",
                    "hasDemo"   : false
                },
                {
                    "name"      : "mdSidenavFocus",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.sidenav/directive/mdSidenavFocus.html",
                    "url"       : "api/directive/mdSidenavFocus",
                    "label"     : "mdSidenavFocus",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js"
                },
                {
                    "name"      : "mdSidenav",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.sidenav/directive/mdSidenav.html",
                    "url"       : "api/directive/mdSidenav",
                    "label"     : "mdSidenav",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.slider",
            "type"      : "module",
            "outputPath": "partials/api/material.components.slider/index.html",
            "url"       : "api/material.components.slider",
            "label"     : "material.components.slider",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/slider/slider.js",
            "docs"      : [
                {
                    "name"      : "mdSlider",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.slider/directive/mdSlider.html",
                    "url"       : "api/directive/mdSlider",
                    "label"     : "mdSlider",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/slider/slider.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.sticky",
            "type"      : "module",
            "outputPath": "partials/api/material.components.sticky/index.html",
            "url"       : "api/material.components.sticky",
            "label"     : "material.components.sticky",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sticky/sticky.js",
            "docs"      : [
                {
                    "name"      : "$mdSticky",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.sticky/service/$mdSticky.html",
                    "url"       : "api/service/$mdSticky",
                    "label"     : "$mdSticky",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sticky/sticky.js",
                    "hasDemo"   : false
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.subheader",
            "type"      : "module",
            "outputPath": "partials/api/material.components.subheader/index.html",
            "url"       : "api/material.components.subheader",
            "label"     : "material.components.subheader",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/subheader/subheader.js",
            "docs"      : [
                {
                    "name"      : "mdSubheader",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.subheader/directive/mdSubheader.html",
                    "url"       : "api/directive/mdSubheader",
                    "label"     : "mdSubheader",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/subheader/subheader.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.swipe",
            "type"      : "module",
            "outputPath": "partials/api/material.components.swipe/index.html",
            "url"       : "api/material.components.swipe",
            "label"     : "material.components.swipe",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/swipe/swipe.js",
            "docs"      : [
                {
                    "name"      : "mdSwipeLeft",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.swipe/directive/mdSwipeLeft.html",
                    "url"       : "api/directive/mdSwipeLeft",
                    "label"     : "mdSwipeLeft",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/swipe/swipe.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdSwipeRight",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.swipe/directive/mdSwipeRight.html",
                    "url"       : "api/directive/mdSwipeRight",
                    "label"     : "mdSwipeRight",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/swipe/swipe.js"
                },
                {
                    "name"      : "mdSwipeUp",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.swipe/directive/mdSwipeUp.html",
                    "url"       : "api/directive/mdSwipeUp",
                    "label"     : "mdSwipeUp",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/swipe/swipe.js"
                },
                {
                    "name"      : "mdSwipeDown",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.swipe/directive/mdSwipeDown.html",
                    "url"       : "api/directive/mdSwipeDown",
                    "label"     : "mdSwipeDown",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/swipe/swipe.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.switch",
            "type"      : "module",
            "outputPath": "partials/api/material.components.switch/index.html",
            "url"       : "api/material.components.switch",
            "label"     : "material.components.switch",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/switch/switch.js",
            "docs"      : [
                {
                    "name"      : "mdSwitch",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.switch/directive/mdSwitch.html",
                    "url"       : "api/directive/mdSwitch",
                    "label"     : "mdSwitch",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/switch/switch.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.tabs",
            "type"      : "module",
            "outputPath": "partials/api/material.components.tabs/index.html",
            "url"       : "api/material.components.tabs",
            "label"     : "material.components.tabs",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/tabs/tabs.js",
            "docs"      : [
                {
                    "name"      : "mdTab",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.tabs/directive/mdTab.html",
                    "url"       : "api/directive/mdTab",
                    "label"     : "mdTab",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/tabs/js/tabDirective.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdTabs",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.tabs/directive/mdTabs.html",
                    "url"       : "api/directive/mdTabs",
                    "label"     : "mdTabs",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/tabs/js/tabsDirective.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.toast",
            "type"      : "module",
            "outputPath": "partials/api/material.components.toast/index.html",
            "url"       : "api/material.components.toast",
            "label"     : "material.components.toast",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/toast/toast.js",
            "docs"      : [
                {
                    "name"      : "$mdToast",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.toast/service/$mdToast.html",
                    "url"       : "api/service/$mdToast",
                    "label"     : "$mdToast",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/toast/toast.js",
                    "hasDemo"   : false
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.toolbar",
            "type"      : "module",
            "outputPath": "partials/api/material.components.toolbar/index.html",
            "url"       : "api/material.components.toolbar",
            "label"     : "material.components.toolbar",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/toolbar/toolbar.js",
            "docs"      : [
                {
                    "name"      : "mdToolbar",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.toolbar/directive/mdToolbar.html",
                    "url"       : "api/directive/mdToolbar",
                    "label"     : "mdToolbar",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/toolbar/toolbar.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.tooltip",
            "type"      : "module",
            "outputPath": "partials/api/material.components.tooltip/index.html",
            "url"       : "api/material.components.tooltip",
            "label"     : "material.components.tooltip",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/tooltip/tooltip.js",
            "docs"      : [
                {
                    "name"      : "mdTooltip",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.tooltip/directive/mdTooltip.html",
                    "url"       : "api/directive/mdTooltip",
                    "label"     : "mdTooltip",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/tooltip/tooltip.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.virtualRepeat",
            "type"      : "module",
            "outputPath": "partials/api/material.components.virtualRepeat/index.html",
            "url"       : "api/material.components.virtualRepeat",
            "label"     : "material.components.virtualRepeat",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js",
            "docs"      : [
                {
                    "name"      : "mdVirtualRepeatContainer",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.virtualRepeat/directive/mdVirtualRepeatContainer.html",
                    "url"       : "api/directive/mdVirtualRepeatContainer",
                    "label"     : "mdVirtualRepeatContainer",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdVirtualRepeat",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.virtualRepeat/directive/mdVirtualRepeat.html",
                    "url"       : "api/directive/mdVirtualRepeat",
                    "label"     : "mdVirtualRepeat",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.core.ripple",
            "type"      : "module",
            "outputPath": "partials/api/material.core.ripple/index.html",
            "url"       : "api/material.core.ripple",
            "label"     : "material.core.ripple",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/l/src/core/services/ripple/ripple.js",
            "docs"      : [
                {
                    "name"      : "mdInkRipple",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.core.ripple/directive/mdInkRipple.html",
                    "url"       : "api/directive/mdInkRipple",
                    "label"     : "mdInkRipple",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/l/src/core/services/ripple/ripple.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "$mdInkRipple",
                    "type"      : "service",
                    "outputPath": "partials/api/material.core.ripple/service/$mdInkRipple.html",
                    "url"       : "api/service/$mdInkRipple",
                    "label"     : "$mdInkRipple",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/l/src/core/services/ripple/ripple.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.core.util",
            "type"      : "module",
            "outputPath": "partials/api/material.core.util/index.html",
            "url"       : "api/material.core.util",
            "label"     : "material.core.util",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/l/src/core/util/util.js",
            "docs"      : [
                {
                    "name"      : "mdAutofocus",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.core.util/directive/mdAutofocus.html",
                    "url"       : "api/directive/mdAutofocus",
                    "label"     : "mdAutofocus",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/l/src/core/util/util.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        }
    ]);
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_nvd3', {
            url  : '/components/charts/nvd3',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/nvd3/nvd3.html',
                    controller : 'Nvd3Controller as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3')
        .controller('Nvd3Controller', Nvd3Controller);

    function Nvd3Controller(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.lineChart = {
            options: {
                chart   : {
                    type                   : 'lineChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 40,
                        left  : 55
                    },
                    x                      : function (d)
                    {
                        return d.x;
                    },
                    y                      : function (d)
                    {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        axisLabel: 'Time (ms)'
                    },
                    yAxis                  : {
                        axisLabel        : 'Voltage (v)',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                },
                title   : {
                    enable: true,
                    text  : 'Title for Line Chart'
                },
                subtitle: {
                    enable: true,
                    text  : 'Subtitle for simple line chart. Lorem ipsum dolor sit amet, at eam blandit sadipscing, vim adhuc sanctus disputando ex, cu usu affert alienum urbanitas.',
                    css   : {
                        'text-align': 'center',
                        'margin'    : '10px 13px 0px 7px'
                    }
                },
                caption : {
                    enable: true,
                    html  : '<b>Figure 1.</b> Lorem ipsum dolor sit amet, at eam blandit sadipscing, <span style="text-decoration: underline;">vim adhuc sanctus disputando ex</span>, cu usu affert alienum urbanitas. <i>Cum in purto erat, mea ne nominavi persecuti reformidans.</i> Docendi blandit abhorreant ea has, minim tantas alterum pro eu. <span style="color: darkred;">Exerci graeci ad vix, elit tacimates ea duo</span>. Id mel eruditi fuisset. Stet vidit patrioque in pro, eum ex veri verterem abhorreant, id unum oportere intellegam nec<sup>[1, <a href="https://github.com/krispo/angular-nvd3" target="_blank">2</a>, 3]</sup>.',
                    css   : {
                        'text-align': 'justify',
                        'margin'    : '10px 13px 0px 7px'
                    }
                }
            },
            data   : sinAndCos()
        };

        vm.stackedAreaChart = {
            options: {
                chart: {
                    type                   : 'stackedAreaChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 40
                    },
                    x                      : function (d)
                    {
                        return d[0];
                    },
                    y                      : function (d)
                    {
                        return d[1];
                    },
                    useVoronoi             : false,
                    clipEdge               : true,
                    transitionDuration     : 500,
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        showMaxMin: false,
                        tickFormat: function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        }
                    },
                    yAxis                  : {
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'North America',
                    'values': [[1025409600000, 23.041422681023], [1028088000000, 19.854291255832], [1030766400000, 21.02286281168], [1033358400000, 22.093608385173], [1036040400000, 25.108079299458], [1038632400000, 26.982389242348], [1041310800000, 19.828984957662], [1043989200000, 19.914055036294], [1046408400000, 19.436150539916], [1049086800000, 21.558650338602], [1051675200000, 24.395594061773], [1054353600000, 24.747089309384], [1056945600000, 23.491755498807], [1059624000000, 23.376634878164], [1062302400000, 24.581223154533], [1064894400000, 24.922476843538], [1067576400000, 27.357712939042], [1070168400000, 26.503020572593], [1072846800000, 26.658901244878], [1075525200000, 27.065704156445], [1078030800000, 28.735320452588], [1080709200000, 31.572277846319], [1083297600000, 30.932161503638], [1085976000000, 31.627029785554], [1088568000000, 28.728743674232], [1091246400000, 26.858365172675], [1093924800000, 27.279922830032], [1096516800000, 34.408301211324], [1099195200000, 34.794362930439], [1101790800000, 35.609978198951], [1104469200000, 33.574394968037], [1107147600000, 31.979405070598], [1109566800000, 31.19009040297], [1112245200000, 31.083933968994], [1114833600000, 29.668971113185], [1117512000000, 31.490638014379], [1120104000000, 31.818617451128], [1122782400000, 32.960314008183], [1125460800000, 31.313383196209], [1128052800000, 33.125486081852], [1130734800000, 32.791805509149], [1133326800000, 33.506038030366], [1136005200000, 26.96501697216], [1138683600000, 27.38478809681], [1141102800000, 27.371377218209], [1143781200000, 26.309915460827], [1146369600000, 26.425199957518], [1149048000000, 26.823411519396], [1151640000000, 23.850443591587], [1154318400000, 23.158355444054], [1156996800000, 22.998689393695], [1159588800000, 27.9771285113], [1162270800000, 29.073672469719], [1164862800000, 28.587640408904], [1167541200000, 22.788453687637], [1170219600000, 22.429199073597], [1172638800000, 22.324103271052], [1175313600000, 17.558388444187], [1177905600000, 16.769518096208], [1180584000000, 16.214738201301], [1183176000000, 18.729632971229], [1185854400000, 18.814523318847], [1188532800000, 19.789986451358], [1191124800000, 17.070049054933], [1193803200000, 16.121349575716], [1196398800000, 15.141659430091], [1199077200000, 17.175388025297], [1201755600000, 17.286592443522], [1204261200000, 16.323141626568], [1206936000000, 19.231263773952], [1209528000000, 18.446256391095], [1212206400000, 17.822632399764], [1214798400000, 15.53936647598], [1217476800000, 15.255131790217], [1220155200000, 15.660963922592], [1222747200000, 13.254482273698], [1225425600000, 11.920796202299], [1228021200000, 12.122809090924], [1230699600000, 15.691026271393], [1233378000000, 14.720881635107], [1235797200000, 15.387939360044], [1238472000000, 13.765436672228], [1241064000000, 14.631445864799], [1243742400000, 14.292446536221], [1246334400000, 16.170071367017], [1249012800000, 15.948135554337], [1251691200000, 16.612872685134], [1254283200000, 18.778338719091], [1256961600000, 16.756026065421], [1259557200000, 19.385804443146], [1262235600000, 22.950590240168], [1264914000000, 23.61159018141], [1267333200000, 25.708586989581], [1270008000000, 26.883915999885], [1272600000000, 25.893486687065], [1275278400000, 24.678914263176], [1277870400000, 25.937275793024], [1280548800000, 29.461381693838], [1283227200000, 27.357322961861], [1285819200000, 29.057235285673], [1288497600000, 28.549434189386], [1291093200000, 28.506352379724], [1293771600000, 29.449241421598], [1296450000000, 25.796838168807], [1298869200000, 28.740145449188], [1301544000000, 22.091744141872], [1304136000000, 25.07966254541], [1306814400000, 23.674906973064], [1309406400000, 23.418002742929], [1312084800000, 23.24364413887], [1314763200000, 31.591854066817], [1317355200000, 31.497112374114], [1320033600000, 26.67238082043], [1322629200000, 27.297080015495], [1325307600000, 20.174315530051], [1327986000000, 19.631084213898], [1330491600000, 20.366462219461], [1333166400000, 19.284784434185], [1335758400000, 19.157810257624]]
                },

                {
                    'key'   : 'Africa',
                    'values': [[1025409600000, 7.9356392949025], [1028088000000, 7.4514668527298], [1030766400000, 7.9085410566608], [1033358400000, 5.8996782364764], [1036040400000, 6.0591869346923], [1038632400000, 5.9667815800451], [1041310800000, 8.65528925664], [1043989200000, 8.7690763386254], [1046408400000, 8.6386160387453], [1049086800000, 5.9895557449743], [1051675200000, 6.3840324338159], [1054353600000, 6.5196511461441], [1056945600000, 7.0738618553114], [1059624000000, 6.5745957367133], [1062302400000, 6.4658359184444], [1064894400000, 2.7622758754954], [1067576400000, 2.9794782986241], [1070168400000, 2.8735432712019], [1072846800000, 1.6344817513645], [1075525200000, 1.5869248754883], [1078030800000, 1.7172279157246], [1080709200000, 1.9649927409867], [1083297600000, 2.0261695079196], [1085976000000, 2.0541261923929], [1088568000000, 3.9466318927569], [1091246400000, 3.7826770946089], [1093924800000, 3.9543021004028], [1096516800000, 3.8309891064711], [1099195200000, 3.6340958946166], [1101790800000, 3.5289755762525], [1104469200000, 5.702378559857], [1107147600000, 5.6539569019223], [1109566800000, 5.5449506370392], [1112245200000, 4.7579993280677], [1114833600000, 4.4816139372906], [1117512000000, 4.5965558568606], [1120104000000, 4.3747066116976], [1122782400000, 4.4588822917087], [1125460800000, 4.4460351848286], [1128052800000, 3.7989113035136], [1130734800000, 3.7743883140088], [1133326800000, 3.7727852823828], [1136005200000, 7.2968111448895], [1138683600000, 7.2800122043237], [1141102800000, 7.1187787503354], [1143781200000, 8.351887016482], [1146369600000, 8.4156698763993], [1149048000000, 8.1673298604231], [1151640000000, 5.5132447126042], [1154318400000, 6.1152537710599], [1156996800000, 6.076765091942], [1159588800000, 4.6304473798646], [1162270800000, 4.6301068469402], [1164862800000, 4.3466656309389], [1167541200000, 6.830104897003], [1170219600000, 7.241633040029], [1172638800000, 7.1432372054153], [1175313600000, 10.608942063374], [1177905600000, 10.914964549494], [1180584000000, 10.933223880565], [1183176000000, 8.3457524851265], [1185854400000, 8.1078413081882], [1188532800000, 8.2697185922474], [1191124800000, 8.4742436475968], [1193803200000, 8.4994601179319], [1196398800000, 8.7387319683243], [1199077200000, 6.8829183612895], [1201755600000, 6.984133637885], [1204261200000, 7.0860136043287], [1206936000000, 4.3961787956053], [1209528000000, 3.8699674365231], [1212206400000, 3.6928925238305], [1214798400000, 6.7571718894253], [1217476800000, 6.4367313362344], [1220155200000, 6.4048441521454], [1222747200000, 5.4643833239669], [1225425600000, 5.3150786833374], [1228021200000, 5.3011272612576], [1230699600000, 4.1203601430809], [1233378000000, 4.0881783200525], [1235797200000, 4.1928665957189], [1238472000000, 7.0249415663205], [1241064000000, 7.006530880769], [1243742400000, 6.994835633224], [1246334400000, 6.1220222336254], [1249012800000, 6.1177436137653], [1251691200000, 6.1413396231981], [1254283200000, 4.8046006145874], [1256961600000, 4.6647600660544], [1259557200000, 4.544865006255], [1262235600000, 6.0488249316539], [1264914000000, 6.3188669540206], [1267333200000, 6.5873958262306], [1270008000000, 6.2281189839578], [1272600000000, 5.8948915746059], [1275278400000, 5.5967320482214], [1277870400000, 0.99784432084837], [1280548800000, 1.0950794175359], [1283227200000, 0.94479734407491], [1285819200000, 1.222093988688], [1288497600000, 1.335093106856], [1291093200000, 1.3302565104985], [1293771600000, 1.340824670897], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 4.4583692315], [1320033600000, 3.6493043348059], [1322629200000, 3.8610064091761], [1325307600000, 5.5144800685202], [1327986000000, 5.1750695220791], [1330491600000, 5.6710066952691], [1333166400000, 5.5611890039181], [1335758400000, 5.5979368839939]]
                },

                {
                    'key'   : 'South America',
                    'values': [[1025409600000, 7.9149900245423], [1028088000000, 7.0899888751059], [1030766400000, 7.5996132380614], [1033358400000, 8.2741174301034], [1036040400000, 9.3564460833513], [1038632400000, 9.7066786059904], [1041310800000, 10.213363052343], [1043989200000, 10.285809585273], [1046408400000, 10.222053149228], [1049086800000, 8.6188592137975], [1051675200000, 9.3335447543566], [1054353600000, 8.9312402186628], [1056945600000, 8.1895089343658], [1059624000000, 8.260622135079], [1062302400000, 7.7700786851364], [1064894400000, 7.9907428771318], [1067576400000, 8.7769091865606], [1070168400000, 8.4855077060661], [1072846800000, 9.6277203033655], [1075525200000, 9.9685913452624], [1078030800000, 10.615085181759], [1080709200000, 9.2902488079646], [1083297600000, 8.8610439830061], [1085976000000, 9.1075344931229], [1088568000000, 9.9156737639203], [1091246400000, 9.7826003238782], [1093924800000, 10.55403610555], [1096516800000, 10.926900264097], [1099195200000, 10.903144818736], [1101790800000, 10.862890389067], [1104469200000, 10.64604998964], [1107147600000, 10.042790814087], [1109566800000, 9.7173391591038], [1112245200000, 9.6122415755443], [1114833600000, 9.4337921146562], [1117512000000, 9.814827171183], [1120104000000, 12.059260396788], [1122782400000, 12.139649903873], [1125460800000, 12.281290663822], [1128052800000, 8.8037085409056], [1130734800000, 8.6300618239176], [1133326800000, 9.1225708491432], [1136005200000, 12.988124170836], [1138683600000, 13.356778764353], [1141102800000, 13.611196863271], [1143781200000, 6.8959030061189], [1146369600000, 6.9939633271353], [1149048000000, 6.7241510257676], [1151640000000, 5.5611293669517], [1154318400000, 5.6086488714041], [1156996800000, 5.4962849907033], [1159588800000, 6.9193153169278], [1162270800000, 7.0016334389778], [1164862800000, 6.7865422443273], [1167541200000, 9.0006454225383], [1170219600000, 9.2233916171431], [1172638800000, 8.8929316009479], [1175313600000, 10.345937520404], [1177905600000, 10.075914677026], [1180584000000, 10.089006188111], [1183176000000, 10.598330295008], [1185854400000, 9.9689546533009], [1188532800000, 9.7740580198146], [1191124800000, 10.558483060626], [1193803200000, 9.9314651823603], [1196398800000, 9.3997715873769], [1199077200000, 8.4086493387262], [1201755600000, 8.9698309085926], [1204261200000, 8.2778357995396], [1206936000000, 8.8585045600123], [1209528000000, 8.7013756413322], [1212206400000, 7.7933605469443], [1214798400000, 7.0236183483064], [1217476800000, 6.9873088186829], [1220155200000, 6.8031713070097], [1222747200000, 6.6869531315723], [1225425600000, 6.138256993963], [1228021200000, 5.6434994016354], [1230699600000, 5.495220262512], [1233378000000, 4.6885326869846], [1235797200000, 4.4524349883438], [1238472000000, 5.6766520778185], [1241064000000, 5.7675774480752], [1243742400000, 5.7882863168337], [1246334400000, 7.2666010034924], [1249012800000, 7.5191821322261], [1251691200000, 7.849651451445], [1254283200000, 10.383992037985], [1256961600000, 9.0653691861818], [1259557200000, 9.6705248324159], [1262235600000, 10.856380561349], [1264914000000, 11.27452370892], [1267333200000, 11.754156529088], [1270008000000, 8.2870811422455], [1272600000000, 8.0210264360699], [1275278400000, 7.5375074474865], [1277870400000, 8.3419527338039], [1280548800000, 9.4197471818443], [1283227200000, 8.7321733185797], [1285819200000, 9.6627062648126], [1288497600000, 10.187962234548], [1291093200000, 9.8144201733476], [1293771600000, 10.275723361712], [1296450000000, 16.796066079353], [1298869200000, 17.543254984075], [1301544000000, 16.673660675083], [1304136000000, 17.963944353609], [1306814400000, 16.63774086721], [1309406400000, 15.84857094609], [1312084800000, 14.767303362181], [1314763200000, 24.778452182433], [1317355200000, 18.370353229999], [1320033600000, 15.253137429099], [1322629200000, 14.989600840649], [1325307600000, 16.052539160125], [1327986000000, 16.424390322793], [1330491600000, 17.884020741104], [1333166400000, 18.372698836036], [1335758400000, 18.315881576096]]
                },

                {
                    'key'   : 'Asia',
                    'values': [[1025409600000, 13.153938631352], [1028088000000, 12.456410521864], [1030766400000, 12.537048663919], [1033358400000, 13.947386398309], [1036040400000, 14.421680682568], [1038632400000, 14.143238262286], [1041310800000, 12.229635347478], [1043989200000, 12.508479916948], [1046408400000, 12.155368409526], [1049086800000, 13.335455563994], [1051675200000, 12.888210138167], [1054353600000, 12.842092790511], [1056945600000, 12.513816474199], [1059624000000, 12.21453674494], [1062302400000, 11.750848343935], [1064894400000, 10.526579636787], [1067576400000, 10.873596086087], [1070168400000, 11.019967131519], [1072846800000, 11.235789380602], [1075525200000, 11.859910850657], [1078030800000, 12.531031616536], [1080709200000, 11.360451067019], [1083297600000, 11.456244780202], [1085976000000, 11.436991407309], [1088568000000, 11.638595744327], [1091246400000, 11.190418301469], [1093924800000, 11.835608007589], [1096516800000, 11.540980244475], [1099195200000, 10.958762325687], [1101790800000, 10.885791159509], [1104469200000, 13.605810720109], [1107147600000, 13.128978067437], [1109566800000, 13.119012086882], [1112245200000, 13.003706129783], [1114833600000, 13.326996807689], [1117512000000, 13.547947991743], [1120104000000, 12.807959646616], [1122782400000, 12.931763821068], [1125460800000, 12.795359993008], [1128052800000, 9.6998935538319], [1130734800000, 9.3473740089131], [1133326800000, 9.36902067716], [1136005200000, 14.258619539875], [1138683600000, 14.21241095603], [1141102800000, 13.973193618249], [1143781200000, 15.218233920664], [1146369600000, 14.382109727451], [1149048000000, 13.894310878491], [1151640000000, 15.593086090031], [1154318400000, 16.244839695189], [1156996800000, 16.017088850647], [1159588800000, 14.183951830057], [1162270800000, 14.148523245696], [1164862800000, 13.424326059971], [1167541200000, 12.974450435754], [1170219600000, 13.232470418021], [1172638800000, 13.318762655574], [1175313600000, 15.961407746104], [1177905600000, 16.287714639805], [1180584000000, 16.24659058389], [1183176000000, 17.564505594808], [1185854400000, 17.872725373164], [1188532800000, 18.018998508756], [1191124800000, 15.584518016602], [1193803200000, 15.480850647182], [1196398800000, 15.699120036985], [1199077200000, 19.184281817226], [1201755600000, 19.691226605205], [1204261200000, 18.982314051293], [1206936000000, 18.707820309008], [1209528000000, 17.459630929759], [1212206400000, 16.500616076782], [1214798400000, 18.086324003978], [1217476800000, 18.929464156259], [1220155200000, 18.233728682084], [1222747200000, 16.315776297325], [1225425600000, 14.632892190251], [1228021200000, 14.667835024479], [1230699600000, 13.946993947309], [1233378000000, 14.394304684398], [1235797200000, 13.724462792967], [1238472000000, 10.930879035807], [1241064000000, 9.8339915513708], [1243742400000, 10.053858541872], [1246334400000, 11.786998438286], [1249012800000, 11.780994901769], [1251691200000, 11.305889670277], [1254283200000, 10.918452290083], [1256961600000, 9.6811395055706], [1259557200000, 10.971529744038], [1262235600000, 13.330210480209], [1264914000000, 14.592637568961], [1267333200000, 14.605329141157], [1270008000000, 13.936853794037], [1272600000000, 12.189480759072], [1275278400000, 11.676151385046], [1277870400000, 13.058852800018], [1280548800000, 13.62891543203], [1283227200000, 13.811107569918], [1285819200000, 13.786494560786], [1288497600000, 14.045162857531], [1291093200000, 13.697412447286], [1293771600000, 13.677681376221], [1296450000000, 19.96151186453], [1298869200000, 21.049198298156], [1301544000000, 22.687631094009], [1304136000000, 25.469010617433], [1306814400000, 24.88379943712], [1309406400000, 24.203843814249], [1312084800000, 22.138760964036], [1314763200000, 16.034636966228], [1317355200000, 15.394958944555], [1320033600000, 12.62564246197], [1322629200000, 12.973735699739], [1325307600000, 15.78601833615], [1327986000000, 15.227368020134], [1330491600000, 15.899752650733], [1333166400000, 15.661317319168], [1335758400000, 15.359891177281]]
                },

                {
                    'key'   : 'Europe',
                    'values': [[1025409600000, 9.3433263069351], [1028088000000, 8.4583069475546], [1030766400000, 8.0342398154196], [1033358400000, 8.1538966876572], [1036040400000, 10.743604786849], [1038632400000, 12.349366155851], [1041310800000, 10.742682503899], [1043989200000, 11.360983869935], [1046408400000, 11.441336039535], [1049086800000, 10.897508791837], [1051675200000, 11.469101547709], [1054353600000, 12.086311476742], [1056945600000, 8.0697180773504], [1059624000000, 8.2004392233445], [1062302400000, 8.4566434900643], [1064894400000, 7.9565760979059], [1067576400000, 9.3764619255827], [1070168400000, 9.0747664160538], [1072846800000, 10.508939004673], [1075525200000, 10.69936754483], [1078030800000, 10.681562399145], [1080709200000, 13.184786109406], [1083297600000, 12.668213052351], [1085976000000, 13.430509403986], [1088568000000, 12.393086349213], [1091246400000, 11.942374044842], [1093924800000, 12.062227685742], [1096516800000, 11.969974363623], [1099195200000, 12.14374574055], [1101790800000, 12.69422821995], [1104469200000, 9.1235211044692], [1107147600000, 8.758211757584], [1109566800000, 8.8072309258443], [1112245200000, 11.687595946835], [1114833600000, 11.079723082664], [1117512000000, 12.049712896076], [1120104000000, 10.725319428684], [1122782400000, 10.844849996286], [1125460800000, 10.833535488461], [1128052800000, 17.180932407865], [1130734800000, 15.894764896516], [1133326800000, 16.412751299498], [1136005200000, 12.573569093402], [1138683600000, 13.242301508051], [1141102800000, 12.863536342041], [1143781200000, 21.034044171629], [1146369600000, 21.419084618802], [1149048000000, 21.142678863692], [1151640000000, 26.56848967753], [1154318400000, 24.839144939906], [1156996800000, 25.456187462166], [1159588800000, 26.350164502825], [1162270800000, 26.478333205189], [1164862800000, 26.425979547846], [1167541200000, 28.191461582256], [1170219600000, 28.930307448808], [1172638800000, 29.521413891117], [1175313600000, 28.188285966466], [1177905600000, 27.704619625831], [1180584000000, 27.49086242483], [1183176000000, 28.770679721286], [1185854400000, 29.06048067145], [1188532800000, 28.240998844973], [1191124800000, 33.004893194128], [1193803200000, 34.075180359928], [1196398800000, 32.548560664834], [1199077200000, 30.629727432729], [1201755600000, 28.642858788159], [1204261200000, 27.973575227843], [1206936000000, 27.393351882726], [1209528000000, 28.476095288522], [1212206400000, 29.29667866426], [1214798400000, 29.222333802896], [1217476800000, 28.092966093842], [1220155200000, 28.107159262922], [1222747200000, 25.482974832099], [1225425600000, 21.208115993834], [1228021200000, 20.295043095268], [1230699600000, 15.925754618402], [1233378000000, 17.162864628346], [1235797200000, 17.084345773174], [1238472000000, 22.24600710228], [1241064000000, 24.530543998508], [1243742400000, 25.084184918241], [1246334400000, 16.606166527359], [1249012800000, 17.239620011628], [1251691200000, 17.336739127379], [1254283200000, 25.478492475754], [1256961600000, 23.017152085244], [1259557200000, 25.617745423684], [1262235600000, 24.061133998641], [1264914000000, 23.223933318646], [1267333200000, 24.425887263936], [1270008000000, 35.501471156693], [1272600000000, 33.775013878675], [1275278400000, 30.417993630285], [1277870400000, 30.023598978467], [1280548800000, 33.327519522436], [1283227200000, 31.963388450372], [1285819200000, 30.49896723209], [1288497600000, 32.403696817913], [1291093200000, 31.47736071922], [1293771600000, 31.53259666241], [1296450000000, 41.760282761548], [1298869200000, 45.605771243237], [1301544000000, 39.986557966215], [1304136000000, 43.84633051005], [1306814400000, 39.857316881858], [1309406400000, 37.675127768207], [1312084800000, 35.775077970313], [1314763200000, 48.631009702578], [1317355200000, 42.830831754505], [1320033600000, 35.611502589362], [1322629200000, 35.320136981738], [1325307600000, 31.564136901516], [1327986000000, 32.074407502433], [1330491600000, 35.053013769977], [1333166400000, 33.873085184128], [1335758400000, 32.321039427046]]
                },

                {
                    'key'   : 'Australia',
                    'values': [[1025409600000, 5.1162447683392], [1028088000000, 4.2022848306513], [1030766400000, 4.3543715758736], [1033358400000, 5.4641223667245], [1036040400000, 6.0041275884577], [1038632400000, 6.6050520064486], [1041310800000, 5.0154059912793], [1043989200000, 5.1835708554647], [1046408400000, 5.1142682006164], [1049086800000, 5.0271381717695], [1051675200000, 5.3437782653456], [1054353600000, 5.2105844515767], [1056945600000, 6.552565997799], [1059624000000, 6.9873363581831], [1062302400000, 7.010986789097], [1064894400000, 4.4254242025515], [1067576400000, 4.9613848042174], [1070168400000, 4.8854920484764], [1072846800000, 4.0441111794228], [1075525200000, 4.0219596813179], [1078030800000, 4.3065749225355], [1080709200000, 3.9148434915404], [1083297600000, 3.8659430654512], [1085976000000, 3.9572824600686], [1088568000000, 4.7372190641522], [1091246400000, 4.6871476374455], [1093924800000, 5.0398702564196], [1096516800000, 5.5221787544964], [1099195200000, 5.424646299798], [1101790800000, 5.9240223067349], [1104469200000, 5.9936860983601], [1107147600000, 5.8499523215019], [1109566800000, 6.4149040329325], [1112245200000, 6.4547895561969], [1114833600000, 5.9385382611161], [1117512000000, 6.0486751030592], [1120104000000, 5.23108613838], [1122782400000, 5.5857797121029], [1125460800000, 5.3454665096987], [1128052800000, 5.0439154120119], [1130734800000, 5.054634702913], [1133326800000, 5.3819451380848], [1136005200000, 5.2638869269803], [1138683600000, 5.5806167415681], [1141102800000, 5.4539047069985], [1143781200000, 7.6728842432362], [1146369600000, 7.719946716654], [1149048000000, 8.0144619912942], [1151640000000, 7.942223133434], [1154318400000, 8.3998279827444], [1156996800000, 8.532324572605], [1159588800000, 4.7324285199763], [1162270800000, 4.7402397487697], [1164862800000, 4.9042069355168], [1167541200000, 5.9583963430882], [1170219600000, 6.3693899239171], [1172638800000, 6.261153903813], [1175313600000, 5.3443942184584], [1177905600000, 5.4932111235361], [1180584000000, 5.5747393101109], [1183176000000, 5.3833633060013], [1185854400000, 5.5125898831832], [1188532800000, 5.8116112661327], [1191124800000, 4.3962296939996], [1193803200000, 4.6967663605521], [1196398800000, 4.7963004350914], [1199077200000, 4.1817985183351], [1201755600000, 4.3797643870182], [1204261200000, 4.6966642197965], [1206936000000, 4.3609995132565], [1209528000000, 4.4736290996496], [1212206400000, 4.3749762738128], [1214798400000, 3.3274661194507], [1217476800000, 3.0316184691337], [1220155200000, 2.5718140204728], [1222747200000, 2.7034994044603], [1225425600000, 2.2033786591364], [1228021200000, 1.9850621240805], [1230699600000, 0], [1233378000000, 0], [1235797200000, 0], [1238472000000, 0], [1241064000000, 0], [1243742400000, 0], [1246334400000, 0], [1249012800000, 0], [1251691200000, 0], [1254283200000, 0.44495950017788], [1256961600000, 0.33945469262483], [1259557200000, 0.38348269455195], [1262235600000, 0], [1264914000000, 0], [1267333200000, 0], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0], [1288497600000, 0], [1291093200000, 0], [1293771600000, 0], [1296450000000, 0.52216435716176], [1298869200000, 0.59275786698454], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 0], [1320033600000, 0], [1322629200000, 0], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                },

                {
                    'key'   : 'Antarctica',
                    'values': [[1025409600000, 1.3503144674343], [1028088000000, 1.2232741112434], [1030766400000, 1.3930470790784], [1033358400000, 1.2631275030593], [1036040400000, 1.5842699103708], [1038632400000, 1.9546996043116], [1041310800000, 0.8504048300986], [1043989200000, 0.85340686311353], [1046408400000, 0.843061357391], [1049086800000, 2.119846992476], [1051675200000, 2.5285382124858], [1054353600000, 2.5056570712835], [1056945600000, 2.5212789901005], [1059624000000, 2.6192011642534], [1062302400000, 2.5382187823805], [1064894400000, 2.3393223047168], [1067576400000, 2.491219888698], [1070168400000, 2.497555874906], [1072846800000, 1.734018115546], [1075525200000, 1.9307268299646], [1078030800000, 2.2261679836799], [1080709200000, 1.7608893704206], [1083297600000, 1.6242690616808], [1085976000000, 1.7161663801295], [1088568000000, 1.7183554537038], [1091246400000, 1.7179780759145], [1093924800000, 1.7314274801784], [1096516800000, 1.2596883356752], [1099195200000, 1.381177053009], [1101790800000, 1.4408819615814], [1104469200000, 3.4743581836444], [1107147600000, 3.3603749903192], [1109566800000, 3.5350883257893], [1112245200000, 3.0949644237828], [1114833600000, 3.0796455899995], [1117512000000, 3.3441247640644], [1120104000000, 4.0947643978168], [1122782400000, 4.4072631274052], [1125460800000, 4.4870979780825], [1128052800000, 4.8404549457934], [1130734800000, 4.8293016233697], [1133326800000, 5.2238093263952], [1136005200000, 3.382306337815], [1138683600000, 3.7056975170243], [1141102800000, 3.7561118692318], [1143781200000, 2.861913700854], [1146369600000, 2.9933744103381], [1149048000000, 2.7127537218463], [1151640000000, 3.1195497076283], [1154318400000, 3.4066964004508], [1156996800000, 3.3754571113569], [1159588800000, 2.2965579982924], [1162270800000, 2.4486818633018], [1164862800000, 2.4002308848517], [1167541200000, 1.9649579750349], [1170219600000, 1.9385263638056], [1172638800000, 1.9128975336387], [1175313600000, 2.3412869836298], [1177905600000, 2.4337870351445], [1180584000000, 2.62179703171], [1183176000000, 3.2642864957929], [1185854400000, 3.3200396223709], [1188532800000, 3.3934212707572], [1191124800000, 4.2822327088179], [1193803200000, 4.1474964228541], [1196398800000, 4.1477082879801], [1199077200000, 5.2947122916128], [1201755600000, 5.2919843508028], [1204261200000, 5.198978305031], [1206936000000, 3.5603057673513], [1209528000000, 3.3009087690692], [1212206400000, 3.1784852603792], [1214798400000, 4.5889503538868], [1217476800000, 4.401779617494], [1220155200000, 4.2208301828278], [1222747200000, 3.89396671475], [1225425600000, 3.0423832241354], [1228021200000, 3.135520611578], [1230699600000, 1.9631418164089], [1233378000000, 1.8963543874958], [1235797200000, 1.8266636017025], [1238472000000, 0.93136635895188], [1241064000000, 0.92737801918888], [1243742400000, 0.97591889805002], [1246334400000, 2.6841193805515], [1249012800000, 2.5664341140531], [1251691200000, 2.3887523699873], [1254283200000, 1.1737801663681], [1256961600000, 1.0953582317281], [1259557200000, 1.2495674976653], [1262235600000, 0.36607452464754], [1264914000000, 0.3548719047291], [1267333200000, 0.36769242398939], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0.85450741275337], [1288497600000, 0.91360317921637], [1291093200000, 0.89647678692269], [1293771600000, 0.87800687192639], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0.43668720882994], [1304136000000, 0.4756523602692], [1306814400000, 0.46947368328469], [1309406400000, 0.45138896152316], [1312084800000, 0.43828726648117], [1314763200000, 2.0820861395316], [1317355200000, 0.9364411075395], [1320033600000, 0.60583907839773], [1322629200000, 0.61096950747437], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                }

            ]
        };

        vm.historicalBarChart = {
            options: {
                chart: {
                    type              : 'historicalBarChart',
                    height            : 450,
                    margin            : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 50
                    },
                    x                 : function (d)
                    {
                        return d[0];
                    },
                    y                 : function (d)
                    {
                        return d[1] / 100000;
                    },
                    showValues        : true,
                    valueFormat       : function (d)
                    {
                        return d3.format(',.1f')(d);
                    },
                    transitionDuration: 500,
                    xAxis             : {
                        axisLabel   : 'X Axis',
                        tickFormat  : function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        },
                        rotateLabels: 50,
                        showMaxMin  : false
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        axisLabelDistance: 35,
                        tickFormat       : function (d)
                        {
                            return d3.format(',.1f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'Quantity',
                    'bar'   : true,
                    'values': [[1159588800000, 3899486.0], [1162270800000, 3899486.0], [1164862800000, 3899486.0], [1167541200000, 3564700.0], [1170219600000, 3564700.0], [1172638800000, 3564700.0], [1175313600000, 2648493.0], [1177905600000, 2648493.0], [1180584000000, 2648493.0], [1183176000000, 2522993.0], [1185854400000, 2522993.0], [1188532800000, 2522993.0], [1191124800000, 2906501.0], [1193803200000, 2906501.0], [1196398800000, 2906501.0], [1199077200000, 2206761.0], [1201755600000, 2206761.0], [1204261200000, 2206761.0], [1206936000000, 2287726.0], [1209528000000, 2287726.0], [1212206400000, 2287726.0], [1214798400000, 2732646.0], [1217476800000, 2732646.0], [1220155200000, 2732646.0], [1222747200000, 2599196.0], [1225425600000, 2599196.0], [1228021200000, 2599196.0], [1230699600000, 1924387.0], [1233378000000, 1924387.0], [1235797200000, 1924387.0], [1238472000000, 1756311.0], [1241064000000, 1756311.0], [1243742400000, 1756311.0], [1246334400000, 1743470.0], [1249012800000, 1743470.0], [1251691200000, 1743470.0], [1254283200000, 1519010.0], [1256961600000, 1519010.0], [1259557200000, 1519010.0], [1262235600000, 1591444.0], [1264914000000, 1591444.0], [1267333200000, 1591444.0], [1270008000000, 1543784.0], [1272600000000, 1543784.0], [1275278400000, 1543784.0], [1277870400000, 1309915.0], [1280548800000, 1309915.0], [1283227200000, 1309915.0], [1285819200000, 1331875.0], [1288497600000, 1331875.0], [1291093200000, 1331875.0], [1293771600000, 1331875.0], [1296450000000, 1154695.0], [1298869200000, 1154695.0], [1301544000000, 1194025.0], [1304136000000, 1194025.0], [1306814400000, 1194025.0], [1309406400000, 1194025.0], [1312084800000, 1194025.0], [1314763200000, 1244525.0], [1317355200000, 475000.0], [1320033600000, 475000.0], [1322629200000, 475000.0], [1325307600000, 690033.0], [1327986000000, 690033.0], [1330491600000, 690033.0], [1333166400000, 514733.0], [1335758400000, 514733.0]]
                }]
        };

        vm.multiBarHorizontalChart = {
            options: {
                chart: {
                    type              : 'multiBarHorizontalChart',
                    height            : 450,
                    x                 : function (d)
                    {
                        return d.label;
                    },
                    y                 : function (d)
                    {
                        return d.value;
                    },
                    showControls      : true,
                    showValues        : true,
                    transitionDuration: 500,
                    xAxis             : {
                        showMaxMin: false
                    },
                    yAxis             : {
                        axisLabel : 'Values',
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },
            data   : [
                {
                    'key'   : 'Series1',
                    'color' : '#d62728',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': -1.8746444827653
                        },
                        {
                            'label': 'Group B',
                            'value': -8.0961543492239
                        },
                        {
                            'label': 'Group C',
                            'value': -0.57072943117674
                        },
                        {
                            'label': 'Group D',
                            'value': -2.4174010336624
                        },
                        {
                            'label': 'Group E',
                            'value': -0.72009071426284
                        },
                        {
                            'label': 'Group F',
                            'value': -0.77154485523777
                        },
                        {
                            'label': 'Group G',
                            'value': -0.90152097798131
                        },
                        {
                            'label': 'Group H',
                            'value': -0.91445417330854
                        },
                        {
                            'label': 'Group I',
                            'value': -0.055746319141851
                        }
                    ]
                },
                {
                    'key'   : 'Series2',
                    'color' : '#1f77b4',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': 25.307646510375
                        },
                        {
                            'label': 'Group B',
                            'value': 16.756779544553
                        },
                        {
                            'label': 'Group C',
                            'value': 18.451534877007
                        },
                        {
                            'label': 'Group D',
                            'value': 8.6142352811805
                        },
                        {
                            'label': 'Group E',
                            'value': 7.8082472075876
                        },
                        {
                            'label': 'Group F',
                            'value': 5.259101026956
                        },
                        {
                            'label': 'Group G',
                            'value': 0.30947953487127
                        },
                        {
                            'label': 'Group H',
                            'value': 0
                        },
                        {
                            'label': 'Group I',
                            'value': 0
                        }
                    ]
                }
            ]
        };

        vm.pieChart = {
            options: {
                chart: {
                    type              : 'pieChart',
                    height            : 500,
                    x                 : function (d)
                    {
                        return d.key;
                    },
                    y                 : function (d)
                    {
                        return d.y;
                    },
                    showLabels        : true,
                    transitionDuration: 500,
                    labelThreshold    : 0.01,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 35,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },
            data   : [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]
        };

        vm.donutChart = {
            options: {
                chart: {
                    type      : 'pieChart',
                    height    : 450,
                    donut     : true,
                    x         : function (d)
                    {
                        return d.key;
                    },
                    y         : function (d)
                    {
                        return d.y;
                    },
                    showLabels: true,

                    pie               : {
                        startAngle: function (d)
                        {
                            return d.startAngle / 2 - Math.PI / 2;
                        },
                        endAngle  : function (d)
                        {
                            return d.endAngle / 2 - Math.PI / 2;
                        }
                    },
                    transitionDuration: 500,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 70,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },

            data: [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]

        };

        vm.sparklineChart = {
            options: {
                chart: {
                    type              : 'sparklinePlus',
                    height            : 450,
                    x                 : function (d, i)
                    {
                        return i;
                    },
                    xTickFormat       : function (d)
                    {
                        return d3.time.format('%x')(new Date(vm.sparklineChart.data[d].x));
                    },
                    transitionDuration: 250
                }
            },

            //$scope.data = sine();
            data: volatileChart(130.0, 0.02)
        };

        vm.bulletChart = {
            options: {
                chart: {
                    type              : 'bulletChart',
                    transitionDuration: 500
                }
            },
            data   : {
                'title'   : 'Revenue',
                'subtitle': 'US$, in thousands',
                'ranges'  : [150, 225, 300],
                'measures': [220],
                'markers' : [250]
            }
        };

        vm.scatterChart = {
            options: {
                chart: {
                    type              : 'scatterChart',
                    height            : 450,
                    color             : d3.scale.category10().range(),
                    scatter           : {
                        onlyCircles: false
                    },
                    showDistX         : true,
                    showDistY         : true,
                    tooltipContent    : function (key)
                    {
                        return '<h3>' + key + '</h3>';
                    },
                    transitionDuration: 350,
                    xAxis             : {
                        axisLabel : 'X Axis',
                        tickFormat: function (d)
                        {
                            return d3.format('.02f')(d);
                        }
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                }
            },
            data   : generateData(4, 5)
        };

        // Methods


        //////////

        /*Random Data Generator */
        function sinAndCos()
        {
            var sin = [], sin2 = [],
                cos = [];

            //Data is represented as an array of {x,y} pairs.
            for ( var i = 0; i < 100; i++ )
            {
                sin.push({
                    x: i,
                    y: Math.sin(i / 10)
                });
                sin2.push({
                    x: i,
                    y: (i % 10 === 5 ? null : Math.sin(i / 10) * 0.25 + 0.5)
                });
                cos.push({
                    x: i,
                    y: 0.5 * Math.cos(i / 10 + 2) + Math.random() / 10
                });
            }

            //Line chart data should be sent as an array of series objects.
            return [
                {
                    values: sin,      //values - represents the array of {x,y} data points
                    key   : 'Sine Wave', //key  - the name of the series.
                    color : '#ff7f0e'  //color - optional: choose your own line color.
                },
                {
                    values: cos,
                    key   : 'Cosine Wave',
                    color : '#2ca02c'
                },
                {
                    values: sin2,
                    key   : 'Another sine wave',
                    color : '#7777ff',
                    area  : true      //area - set to true if you want this line to turn into a filled area chart.
                }
            ];
        }

        function volatileChart(startPrice, volatility, numPoints)
        {
            var rval = [];
            var now = +new Date();
            numPoints = numPoints || 100;
            for ( var i = 1; i < numPoints; i++ )
            {
                rval.push({
                    x: now + i * 1000 * 60 * 60 * 24,
                    y: startPrice
                });
                var rnd = Math.random();
                var changePct = 2 * volatility * rnd;
                if ( changePct > volatility )
                {
                    changePct -= (2 * volatility);
                }
                startPrice = startPrice + startPrice * changePct;
            }
            return rval;
        }

        /* Random Data Generator (took from nvd3.org) */
        function generateData(groups, points)
        {
            var data = [],
                shapes = ['circle', 'cross', 'triangle-up', 'triangle-down', 'diamond', 'square'],
                random = d3.random.normal();

            for ( var i = 0; i < groups; i++ )
            {
                data.push({
                    key   : 'Group ' + i,
                    values: []
                });

                for ( var j = 0; j < points; j++ )
                {
                    data[i].values.push(
                        {
                            x    : random(),
                            y    : random(),
                            size : Math.random(),
                            shape: shapes[j % 6]
                        });
                }
            }
            return data;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chartist', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_chartist', {
            url  : '/components/charts/chartist',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/chartist/chartist.html',
                    controller : 'ChartistController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chartist')
        .controller('ChartistController', ChartistController);

    function ChartistController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;


        // line chart
        vm.lineChart = {
            data   : {
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                series: [
                    [12, 9, 7, 8, 5],
                    [2, 1, 3.5, 7, 3],
                    [1, 3, 4, 5, 6]
                ]
            },
            options: {
                fullWidth   : true,
                chartPadding: {
                    right: 40
                }
            }
        };

        // line Area chart
        vm.lineAreaChart = {
            data   : {
                labels: [1, 2, 3, 4, 5, 6, 7, 8],
                series: [
                    [5, 9, 7, 8, 5, 3, 5, 4]
                ]
            },
            options: {
                low     : 0,
                showArea: true
            }
        };

        vm.biPolarLineChart = {
            data   : {
                labels: [1, 2, 3, 4, 5, 6, 7, 8],
                series: [
                    [1, 2, 3, 1, -2, 0, 1, 0],
                    [-2, -1, -2, -1, -2.5, -1, -2, -1],
                    [0, 0, 0, 1, 2, 2.5, 2, 1],
                    [2.5, 2, 1, 0.5, 1, 0.5, -1, -2.5]
                ]
            },
            options: {
                high     : 3,
                low      : -3,
                showArea : true,
                showLine : false,
                showPoint: false,
                fullWidth: true,
                axisX    : {
                    showLabel: false,
                    showGrid : false
                }
            }
        };

        vm.stackedBarChart = {
            data   : {
                labels: ['Q1', 'Q2', 'Q3', 'Q4'],
                series: [
                    [800000, 1200000, 1400000, 1300000],
                    [200000, 400000, 500000, 300000],
                    [100000, 200000, 400000, 600000]
                ]
            },
            options: {
                stackBars: true,
                axisY    : {
                    labelInterpolationFnc: function (value)
                    {
                        return (value / 1000) + 'k';
                    }
                }
            },
            events : {
                draw: function (data)
                {
                    if ( data.type === 'bar' )
                    {
                        data.element.attr({
                            style: 'stroke-width: 30px'
                        });
                    }
                }
            }
        };

        // bar chart
        vm.barChart = {
            data             : {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                series: [
                    [5, 4, 3, 7, 5, 10, 3, 4, 8, 10, 6, 8],
                    [3, 2, 9, 5, 4, 6, 4, 6, 7, 8, 7, 4]
                ]
            },
            options          : {
                seriesBarDistance: 15
            },
            responsiveOptions: [
                ['screen and (min-width: 641px) and (max-width: 1024px)', {
                    seriesBarDistance: 10,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value;
                        }
                    }
                }],
                ['screen and (max-width: 640px)', {
                    seriesBarDistance: 5,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value[0];
                        }
                    }
                }]
            ]
        };

        // Horizontal bar chart
        vm.horizontalBarChart = {
            data   : {
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                series: [
                    [5, 4, 3, 7, 5, 10, 3],
                    [3, 2, 9, 5, 4, 6, 4]
                ]
            },
            options: {
                seriesBarDistance: 10,
                reverseData      : true,
                horizontalBars   : true,
                axisY            : {
                    offset: 70
                }
            }
        };

        vm.biPolarBarChart = {
            data   : {
                labels: ['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8', 'W9', 'W10'],
                series: [
                    [1, 2, 4, 8, 6, -2, -1, -4, -6, -2]
                ]
            },
            options: {
                high : 10,
                low  : -10,
                axisX: {
                    labelInterpolationFnc: function (value, index)
                    {
                        return index % 2 === 0 ? value : null;
                    }
                }
            }
        };

        // pie chart
        vm.pieChart = {
            data             : {
                labels: ['Bananas', 'Apples', 'Grapes'],
                series: [20, 15, 40]
            },
            options          : {
                labelInterpolationFnc: function (value)
                {
                    return value[0];
                }
            },
            responsiveOptions: [
                ['screen and (min-width: 640px)', {
                    chartPadding         : 40,
                    labelOffset          : 150,
                    labelDirection       : 'explode',
                    labelInterpolationFnc: function (value)
                    {
                        return value;
                    }
                }],
                ['screen and (min-width: 1024px)', {
                    labelOffset : 120,
                    chartPadding: 30
                }]
            ]

        };

        // donut chart
        vm.donutChart = {
            data   : {
                series: [20, 10, 30, 40]
            },
            options: {
                donut: true
            }
        };

        vm.gaugeChart = {
            data   : {
                series: [20, 10, 30, 40]
            },
            options: {
                donut     : true,
                donutWidth: 60,
                startAngle: 270,
                total     : 200,
                showLabel : true
            }
        };
        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chart-js', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_chart-js', {
            url  : '/components/charts/chart-js',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/chart-js/chart-js.html',
                    controller : 'ChartJsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chart-js')
        .controller('ChartJsController', ChartJsController);

    function ChartJsController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.lineChart = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            series: ['Series A', 'Series B'],
            data  : [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ]
        };

        vm.barChart = {
            labels: ['2006', '2007', '2008', '2009', '2010', '2011', '2012'],
            series: ['Series A', 'Series B'],
            data  : [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ]
        };

        vm.doughnutChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'],
            data  : [300, 500, 100]
        };

        vm.radarChart = {
            labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
            data  : [
                [65, 59, 90, 81, 56, 55, 40],
                [28, 48, 40, 19, 96, 27, 100]
            ]
        };

        vm.pieChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'],
            data  : [300, 500, 100]
        };

        vm.polarChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales', 'Tele Sales', 'Corporate Sales'],
            data  : [300, 500, 100, 40, 120]
        };

        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.c3', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_c3', {
            url  : '/components/charts/c3',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/c3/c3.html',
                    controller : 'C3Controller as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.c3')
        .controller('C3Controller', C3Controller);

    function C3Controller(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('CardFilters', CardFiltersService);

    /** @ngInject */
    function CardFiltersService()
    {
        var service = {
            name   : '',
            labels : [],
            members: [],
            clear  : clear,
            isOn   : isOn
        };

        /**
         * Clear
         */
        function clear()
        {
            service.name = '';
            service.labels = [];
            service.members = [];
        }

        /**
         * Is on
         *
         * @returns {boolean}
         */
        function isOn()
        {
            return (service.name === '' && service.labels.length === 0 && service.members.length === 0 ) ? false : true;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('DialogService', DialogService);

    /** @ngInject */
    function DialogService($mdDialog, $document)
    {
        var service = {
            openCardDialog: openCardDialog
        };

        //////////

        /**
         * Open card dialog
         *
         * @param ev
         * @param cardId
         */
        function openCardDialog(ev, cardId)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/dialogs/card/card-dialog.html',
                controller         : "ScrumboardCardDialogController",
                controllerAs       : "vm",
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                locals             : {
                    cardId: cardId
                }
            });
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('BoardService', BoardService);

    /** @ngInject */
    function BoardService($q, api)
    {
        var service = {
            data        : {},
            addNewBoard : addNewBoard,
            getBoardData: getBoardData
        };

        /**
         * Get board data from the server
         *
         * @param boardId
         * @returns {*}
         */
        function getBoardData(boardId)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            api.scrumboard.board.get({id: boardId},

                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Create an empty board object and set it.
         *
         * For the demonstration purposes, we are creating the
         * empty object in the javascript which you wouldn't do
         * it in real life. Rather, you would make an API call
         * to your server to generate an empty object that fills
         * some of the areas for you like an ID, labels, members
         * or the default board settings.
         *
         * Then you would grab the response that comes from
         * the API call and attach it to the service.data object.
         */
        function addNewBoard()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Here you would make an API call to your server...
            _generateEmptyScrumboardObject().then(
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the response
                    deferred.resolve(response);
                },
                // ERROR
                function (response)
                {
                    // Reject the response
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Dummy function for generating an empty
         * scrumboard object for demonstration
         * purposes
         *
         * @private
         * returns {$promise}
         */
        function _generateEmptyScrumboardObject()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Fake id generator
            var id = parseInt(new Date().valueOf(), 16);

            // Prepare an empty scrumboard object
            var emptyObject = {
                data: {
                    name    : 'Untitled Board',
                    uri     : 'untitled-board',
                    id      : id,
                    settings: {
                        color          : '',
                        subscribed     : false,
                        cardCoverImages: true
                    },
                    lists   : [],
                    cards   : [],
                    members : [
                        {
                            id    : '56027c1930450d8bf7b10758',
                            name  : 'Alice Freeman',
                            avatar: 'assets/images/avatars/alice.jpg'
                        },
                        {
                            id    : '26027s1930450d8bf7b10828',
                            name  : 'Danielle Obrien',
                            avatar: 'assets/images/avatars/danielle.jpg'
                        },
                        {
                            id    : '76027g1930450d8bf7b10958',
                            name  : 'James Lewis',
                            avatar: 'assets/images/avatars/james.jpg'
                        },
                        {
                            id    : '36027j1930450d8bf7b10158',
                            name  : 'Vincent Munoz',
                            avatar: 'assets/images/avatars/vincent.jpg'
                        }
                    ],
                    labels  : [
                        {
                            id   : '26022e4129ad3a5sc28b36cd',
                            name : 'High Priority',
                            color: 'red'
                        },
                        {
                            id   : '56027e4119ad3a5dc28b36cd',
                            name : 'Design',
                            color: 'orange'
                        },
                        {
                            id   : '5640635e19ad3a5dc21416b2',
                            name : 'App',
                            color: 'blue'
                        },
                        {
                            id   : '6540635g19ad3s5dc31412b2',
                            name : 'Feature',
                            color: 'green'
                        }
                    ]
                }
            };

            // Resolve the promise
            deferred.resolve(emptyObject);

            return deferred.promise;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboards_server', {
            url      : '/dashboard-server',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/server/dashboard-server.html',
                    controller : 'DashboardServerController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server')
        .controller('DashboardServerController', DashboardServerController);

    /** @ngInject */
    function DashboardServerController($scope, $interval, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;

        // Widget 1
        vm.widget1 = {
            title: vm.dashboardData.widget1.title,
            chart: {
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#4caf50', '#3f51b5', '#ff5722'],
                        height                 : 320,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 32,
                            left  : 48
                        },
                        useInteractiveGuideline: true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' min.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' MB';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.chart
            }
        };

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = {
            title   : vm.dashboardData.widget4.title,
            value   : vm.dashboardData.widget4.value,
            footnote: vm.dashboardData.widget4.footnote,
            detail  : vm.dashboardData.widget4.detail,
            chart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'lineChart',
                        color       : ['rgba(0, 0, 0, 0.27)'],
                        height      : 50,
                        margin      : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        duration    : 1,
                        clipEdge    : true,
                        interpolate : 'cardinal',
                        interactive : false,
                        isArea      : true,
                        showLegend  : false,
                        showControls: false,
                        showXAxis   : false,
                        showYAxis   : false,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yDomain     : [0, 4]
                    }
                },
                data   : vm.dashboardData.widget4.chart
            },
            init    : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget4.chart[0].values.length - 1,
                    x = vm.dashboardData.widget4.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function latencyTicker(min, max)
                {
                    // Increase the x value
                    x++;

                    var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

                    var newValue = {
                        x: x,
                        y: randomNumber
                    };

                    vm.widget4.chart.data[0].values.shift();
                    vm.widget4.chart.data[0].values.push(newValue);

                    // Randomize the value
                    vm.widget4.value = 20 + randomNumber + 'ms';
                }

                // Set interval
                var latencyTickerInterval = $interval(function ()
                {
                    latencyTicker(1, 4);
                }, 1000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(latencyTickerInterval);
                });
            }
        };

        // Widget 5
        vm.widget5 = vm.dashboardData.widget5;

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            chart: {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 140,
                        margin                 : {
                            top   : 8,
                            right : 32,
                            bottom: 16,
                            left  : 48
                        },
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        showLegend             : false,
                        showControls           : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 100],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' sec.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + '%';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data   : vm.dashboardData.widget6.chart
            },
            init : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget6.chart[0].values.length - 1,
                    x = vm.dashboardData.widget6.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function cpuTicker(min, max)
                {
                    // Increase the x value
                    x = x + 5;

                    var newValue = {
                        x: x,
                        y: Math.floor(Math.random() * (max - min + 1)) + min
                    };

                    vm.widget6.chart.data[0].values.shift();
                    vm.widget6.chart.data[0].values.push(newValue);
                }

                // Set interval
                var cpuTickerInterval = $interval(function ()
                {
                    cpuTicker(0, 100);
                }, 5000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(cpuTickerInterval);
                });
            }
        };

        // Widget 7
        vm.widget7 = {
            title    : vm.dashboardData.widget7.title,
            table    : vm.dashboardData.widget7.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                pageLength: 10,
                lengthMenu: [10, 20, 50, 100],
                autoWidth : false,
                responsive: true,
                columnDefs: [
                    {
                        width  : '20%',
                        targets: [0, 1, 2, 3, 4]
                    }
                ],
                columns   : [
                    {},
                    {},
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + ' KB/s';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + '%';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                var el = angular.element(data);
                                el.html(el.text() + ' MB');

                                return el[0].outerHTML;
                            }
                            else
                            {
                                return data;
                            }
                        }
                    }
                ]
            }
        };

        // Widget 8
        vm.widget8 = vm.dashboardData.widget8;

        // Methods

        //////////

        // Init Widget 4
        vm.widget4.init();

        // Init Widget 6
        vm.widget6.init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboards_project', {
            url      : '/dashboard-project',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/dashboard-project.html',
                    controller : 'DashboardProjectController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project')
        .controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($scope, $interval, $mdSidenav, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;

        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            title       : vm.dashboardData.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            supporting  : {
                widgets: {
                    created  : {
                        data : vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed   : {
                        data : vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened : {
                        data : vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix  : {
                        data : vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data : vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed    : {
                        data : vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart  : {
                    config : {
                        refreshDataOnly: true,
                        deepWatchData  : true
                    },
                    options: {
                        chart: {
                            type                   : 'lineChart',
                            color                  : ['#03A9F4'],
                            height                 : 50,
                            margin                 : {
                                top   : 8,
                                right : 0,
                                bottom: 0,
                                left  : 0
                            },
                            isArea                 : true,
                            interpolate            : 'cardinal',
                            clipEdge               : true,
                            duration               : 500,
                            showXAxis              : false,
                            showYAxis              : false,
                            showLegend             : false,
                            useInteractiveGuideline: true,
                            x                      : function (d)
                            {
                                return d.x;
                            },
                            y                      : function (d)
                            {
                                return d.y;
                            },
                            yDomain                : [0, 9],
                            xAxis                  : {
                                tickFormat: function (d)
                                {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer       : {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data   : []
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name)
                {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key   : widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title       : vm.dashboardData.widget6.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft  : vm.dashboardData.widget6.footerLeft,
            footerRight : vm.dashboardData.widget6.footerRight,
            ranges      : vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title       : vm.dashboardData.widget7.title,
            ranges      : vm.dashboardData.widget7.ranges,
            schedule    : vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Widget 8
        vm.widget8 = {
            title    : vm.dashboardData.widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type     : 'pieChart',
                        color    : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height   : 400,
                        margin   : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        labelType: 'percent',
                        x        : function (d)
                        {
                            return d.label;
                        },
                        y        : function (d)
                        {
                            return d.value;
                        },
                        tooltip  : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : vm.dashboardData.widget8.mainChart
            }
        };

        // Widget 9
        vm.widget9 = {
            title       : vm.dashboardData.widget9.title,
            weeklySpent : {
                title    : vm.dashboardData.widget9.weeklySpent.title,
                count    : vm.dashboardData.widget9.weeklySpent.count,
                chartData: []
            },
            totalSpent  : {
                title    : vm.dashboardData.widget9.totalSpent.title,
                count    : vm.dashboardData.widget9.totalSpent.count,
                chartData: []
            },
            remaining   : {
                title    : vm.dashboardData.widget9.remaining.title,
                count    : vm.dashboardData.widget9.remaining.count,
                chartData: []
            },
            totalBudget : vm.dashboardData.widget9.totalBudget,
            chart       : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#00BCD4'],
                        height                 : 50,
                        margin                 : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 9],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return vm.widget9.days[d];
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 'e',
                                classes: 'gravity-e'
                            }
                        }
                    }
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget9.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget9.currentRange = range;

                /**
                 * Update mini charts. They only have 1 dataset
                 * so we can do [0] without needing to iterate
                 * through in their data arrays
                 */
                vm.widget9.weeklySpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.weeklySpent.chart.label,
                    values: vm.dashboardData.widget9.weeklySpent.chart.values[range]
                };

                vm.widget9.totalSpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.totalSpent.chart.label,
                    values: vm.dashboardData.widget9.totalSpent.chart.values[range]
                };

                vm.widget9.remaining.chartData[0] = {
                    key   : vm.dashboardData.widget9.remaining.chart.label,
                    values: vm.dashboardData.widget9.remaining.chart.values[range]
                };
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget9.changeRange('TW');
            }
        };

        // Widget 10
        vm.widget10 = vm.dashboardData.widget10;

        // Widget 11
        vm.widget11 = {
            title    : vm.dashboardData.widget11.title,
            table    : vm.dashboardData.widget11.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true,
                order     : [1, 'asc'],
                columnDefs: [
                    {
                        width    : '40',
                        orderable: false,
                        targets  : [0]
                    },
                    {
                        width  : '20%',
                        targets: [1, 2, 3, 4, 5]
                    }
                ]
            }
        };

        // Now widget
        vm.nowWidget = {
            now   : {
                second: '',
                minute: '',
                hour  : '',
                day   : '',
                month : '',
                year  : ''
            },
            ticker: function ()
            {
                var now = moment();
                vm.nowWidget.now = {
                    second : now.format('ss'),
                    minute : now.format('mm'),
                    hour   : now.format('HH'),
                    day    : now.format('D'),
                    weekDay: now.format('dddd'),
                    month  : now.format('MMMM'),
                    year   : now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();

        // Initialize Widget 9
        vm.widget9.init();

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project)
        {
            vm.selectedProject = project;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboards_analytics', {
            url      : '/dashboard-analytics',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/analytics/dashboard-analytics.html',
                    controller : 'DashboardAnalyticsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics')
        .controller('DashboardAnalyticsController', DashboardAnalyticsController);

    /** @ngInject */
    function DashboardAnalyticsController(DashboardData, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.widget1 = {
            title             : vm.dashboardData.widget1.title,
            onlineUsers       : vm.dashboardData.widget1.onlineUsers,
            bigChart          : {
                options: {
                    chart: {
                        type                   : 'lineWithFocusChart',
                        color                  : ['#2196F3'],
                        height                 : 400,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 64,
                            left  : 48
                        },
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        showLegend             : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        yAxis                  : {
                            showMaxMin: false
                        },
                        x2Axis                 : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        y2Axis                 : {
                            showMaxMin: false
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.bigChart.chart
            },
            sessions          : {
                title   : vm.dashboardData.widget1.sessions.title,
                value   : vm.dashboardData.widget1.sessions.value,
                previous: vm.dashboardData.widget1.sessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.sessions.chart
            },
            pageviews         : {
                title   : vm.dashboardData.widget1.pageviews.title,
                value   : vm.dashboardData.widget1.pageviews.value,
                previous: vm.dashboardData.widget1.pageviews.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#3F51B5'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pageviews.chart
            },
            pagesSessions     : {
                title   : vm.dashboardData.widget1.pagesSessions.title,
                value   : vm.dashboardData.widget1.pagesSessions.value,
                previous: vm.dashboardData.widget1.pagesSessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#E91E63'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pagesSessions.chart
            },
            avgSessionDuration: {
                title   : vm.dashboardData.widget1.avgSessionDuration.title,
                value   : vm.dashboardData.widget1.avgSessionDuration.value,
                previous: vm.dashboardData.widget1.avgSessionDuration.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#009688'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                var formatTime = d3.time.format('%M:%S');
                                return formatTime(new Date('2012', '0', '1', '0', '0', d));
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.avgSessionDuration.chart
            }
        };

        // Widget 2
        vm.widget2 = {
            title: vm.dashboardData.widget2.title
        };

        // Widget 3
        vm.widget3 = {
            title       : vm.dashboardData.widget3.title,
            pages       : vm.dashboardData.widget3.pages,
            ranges      : vm.dashboardData.widget3.ranges,
            currentRange: vm.dashboardData.widget3.currentRange,
            changeRange : function (range)
            {
                vm.widget3.currentRange(range);
            }
        };

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;


        // Methods

        //////////

        // Widget 2
        uiGmapGoogleMapApi.then(function ()
        {
            vm.widget2.map = vm.dashboardData.widget2.map;
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/quick-panel');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(api, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        api.quickPanel.contacts.get({}, function (response)
        {
            vm.contacts = response.data;
        });

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.objects.newobject.newsuburbian',[])
        .controller('NewSuburbianController', NewSuburbianController);

    /** @ngInject */
    function NewSuburbianController($scope, $mdDialog, GetStreetService, $location, api)
    {
        var vm = this;
        // Data
        vm.formWizard = {};

		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
		vm.formWizard.region = 2;
		//подгружаем список районов
		vm.districts = {};
		loadDistricts();
		//типы населенных пунктов
        vm.city_types = [{'socr': 'г', 'name': 'город'},
						{'socr': 'г.о.', 'name': 'городской округ'},
						{'socr': 'п', 'name': 'поселение/поселок'},
						{'socr': 'дп', 'name': 'дачный поселок'},
						{'socr': 'кп', 'name': 'курортный поселок'},
						{'socr': 'пгт', 'name': 'поселок городского типа'},
						{'socr': 'рп', 'name': 'рабочий поселок'},
						{'socr': 'с/п', 'name': 'сельское поселение'},
						{'socr': 'д', 'name': 'деревня'},
						{'socr': 'с', 'name': 'село'},
						{'socr': 'сл', 'name': 'слобода'},
						{'socr': 'снт', 'name': 'СНТ'},
						{'socr': 'жилрайон', 'name': 'жилой район'},
						{'socr': 'кв-л', 'name': 'квартал'},
						{'socr': 'мкр', 'name': 'микрорайон'},
						{'socr': 'нп', 'name': 'населенный пункт'},
						{'socr': 'тер', 'name': 'территория'},
						{'socr': 'промзона', 'name': 'промышленная зона'}];
		vm.formWizard.city_type = 'п';
		//названия нас.пунктов и улицы подгружаем после выбора
		vm.cities = {};
		vm.streets = {};
		//Список направлений
		api.objects.directions.query({}, function(data) {
				vm.directions = data;
				});
		api.contacts.my_clients.query({}, function(data) {
				vm.my_clients = data;
				});

		//тип объекта
		vm.object_types = [{'name': 'cottage', 'rusname': 'Дом (коттедж)'},
						{'name': 'country_house', 'rusname': 'Дача'},
						{'name': 'townhouse', 'rusname': 'Таунхаус'},
            {'name': 'production_land', 'rusname': 'Пром. земля'},
						{'name': 'parcel', 'rusname': 'Участок'},
            {'name': 'zsn', 'rusname': 'Участок - ЗСН'},
            {'name': 'znp', 'rusname': 'Участок - ЗНП'},
            {'name': 'zoot', 'rusname': 'Участок - ЗООТ'},
            {'name': 'zwilf', 'rusname': 'Участок - ЗВИЛФ'},
            {'name': 'zemli_zapasa', 'rusname': 'Участок - Земли запаса'}];
		vm.formWizard.object_type = 'cottage';

    //Целевое назначение земель
    vm.land_types = [{'name': 'snt', 'rusname': 'СНТ'},
            {'name': 'igs', 'rusname': 'ИЖС'},
            {'name': 'farm', 'rusname': 'Фермерское хозяйство'},
            {'name': 'dnp', 'rusname': 'ДНП'}];

    //тип объекта 2
		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'},
						{'name': 'hog-wash', 'rusname': 'Утка'},
						{'name': 'auction', 'rusname': 'Аукцион'}];
		vm.formWizard.object_type_2 = 'real';

		//источник
		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'},
						{'id': '2', 'rusname': 'Расклейка'},
						{'id': '3', 'rusname': 'Баннер'},
						{'id': '4', 'rusname': 'Рекомендация'},
						{'id': '5', 'rusname': 'База собственников'},
						{'id': '6', 'rusname': 'База заявок'},
						{'id': '7', 'rusname': 'Диспетчерская'},
						{'id': '8', 'rusname': 'Avito'},
						{'id': '9', 'rusname': 'Другие сайты'},
						{'id': '10', 'rusname': 'Сам нашел'}];

		//тип комиссии
		vm.commission_types = [{'name': 'percent', 'rusname': '%'},
						{'name': 'sum', 'rusname': 'руб.'}];
		vm.formWizard.commission_type = 'sum';

		//типы сделок
		vm.deal_types = [{'name': 'rent', 'rusname': 'Аренда'},
						{'name': 'sale', 'rusname': 'Продажа'}];
		vm.formWizard.deal_type = 'sale';

        vm.rent_durations = [{'name': 'short', 'rusname': 'Несколько месяцев'},
						{'name': 'long', 'rusname': 'Длительный срок'},
						{'name': 'day', 'rusname': 'Посуточно'}];
			//Коммуникации в гараже
      vm.energi_garage_types = [{'name': 'elect-heat', 'rusname': 'Эл-во и отопление'},
          {'name': 'heating', 'rusname': 'Отопление'},
          {'name': 'electricity', 'rusname': 'Электричество'}];

		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'no', 'rusname': 'Нет'}];

		//мебель
		vm.furniture_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'old', 'rusname': 'Есть'}];
		//ремонт
		vm.repairs_types = [{'name': 'no', 'rusname': 'Без ремонта'},
						{'name': 'cosmetic', 'rusname': 'Косметический'},
						{'name': 'euro', 'rusname': 'Евро'}];

    //газ
    vm.gas_types = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'no', 'rusname': 'Нет'},
						{'name': 'project', 'rusname': 'Оплачен проект'},
            {'name': 'autonomous', 'rusname': 'Автономная газ-я'},
						{'name': 'border', 'rusname': 'По границе участка'}];
    //электричество
    vm.enegi_types = [{'name': 'yes', 'rusname': 'Есть'},
            {'name': 'request', 'rusname': 'Подана заявка'},
            {'name': 'unknown', 'rusname': 'Возможность подключения неизвестна'},
            {'name': 'possible', 'rusname': 'Возможно подключить'}];
    //отопление
    vm.heating_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'central', 'rusname': 'Центральное'},
            {'name': 'autonomous', 'rusname': 'Автономное'}];
    //Водоснабжение
    vm.water_types = [{'name': 'cesspool', 'rusname': 'Есть'},
						{'name': 'well', 'rusname': 'Скважина'},
            {'name': 'centra', 'rusname': 'Центральное'},
						{'name': 'spring', 'rusname': 'Колодец/колонка'},
            {'name': 'no', 'rusname': 'Отсутствует'},
						{'name': 'border', 'rusname': 'По границе участка'}];

    //Канализация
    vm.sewage_types = [{'name': 'yes', 'rusname': 'Есть'},
  					{'name': 'no', 'rusname': 'Нет'},
  					{'name': 'cesspool', 'rusname': 'Выгребная яма'},
            {'name': 'bio', 'rusname': 'Устройства биоочистки'},
            {'name': 'autonomous', 'rusname': 'Автономная'},
            {'name': 'central', 'rusname': 'Центральная'},
  					{'name': 'septic', 'rusname': 'Септики'}];

		//право собственности
		vm.ownership_types = [{'name': 'primary', 'rusname': 'Первичная приватизация'},
						{'name': 'contract-sales', 'rusname': 'Договор купли/продажи'},
						{'name': 'contract-donat', 'rusname': 'Договор дарения'},
						{'name': 'contract-rent', 'rusname': 'Договор ренты'},
						{'name': 'paid', 'rusname': 'ЖСК, выплаченный пай'},
						{'name': 'legacy', 'rusname': 'Наследство'},
						{'name': 'court', 'rusname': 'Решение суда'},
						{'name': 'mortgage', 'rusname': 'Залог (ипотека)'},
						{'name': 'invest', 'rusname': 'По договору инвестирования'}];
		//Тип дома
		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
						{'name': 'brick', 'rusname': 'Кирпичный'},
						{'name': 'wood', 'rusname': 'Деревянный'},
						{'name': 'brus', 'rusname': 'Брус'},
						{'name': 'brevno', 'rusname': 'Бревно'},												
						{'name': 'monolith', 'rusname': 'Монолит'}];

    // Methods
    vm.sendForm = sendForm;
		vm.loadDistricts = loadDistricts;
		vm.loadCities = loadCities;
		//vm.loadStreets = loadStreets;
    vm.addClient = addClient;

        //////////
        function addClient()
        {
          $mdDialog.show({
                  controller         : function ($scope, $mdDialog)
                  {
                    /////////////////////
                    $scope.createClient = function ()
                    {
                      var newclient = new api.contacts.newclientdata();
                      newclient.firstname = $scope.dialog.firstname;
                      newclient.phone_1 = $scope.dialog.phone_1;
                      newclient.type = 'person';
                      newclient.status = 'work';
                      newclient.$save();
                      ///////обновляем список клиентов
                      api.contacts.my_clients.query({}, function(data) {
                          vm.my_clients = data;
                          vm.formWizard.client_id = vm.my_clients[vm.my_clients.length -1].id;
                      });
                      $mdDialog.hide();
                    }
                    ////////////////////
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                  },
                  templateUrl: 'app/contacts/clients/addClientDialog.html',
                  parent             : angular.element('body'),
                  clickOutsideToClose: true
          });
      }

        //////////
        function loadDistricts()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
				vm.districts = data;
				//обнуляем все, что ниже иерархически
				vm.cities = {};
				vm.streets = {};
				//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.district = null;
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;
				//для Москвы выбираем любой район, так как район города необязателен
				if (vm.formWizard.region == 1) {
					vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
					loadCities();
					}
				});
		}

		function loadCities()
        {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;

			if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
				vm.cities = {};
			} else {
				var index_district = 0;
				//определяем реальный порядковый номер в массиве
				for (var i = 0; i < vm.districts.length; i++)
					if (vm.districts[i]['id'] == vm.formWizard.district) {
						index_district = i;
						api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
							vm.cities = data;
							});
				}
			}
			vm.streets = {};
		}

    ///////////////////////
    vm.searchStreet = "";

    //функция вывода списка улиц
    vm.searchStreetResult = function (str) {
      //ищем хотя бы после 3 введенных символов, чтобы не показывать большие объемы улиц
      if (vm.searchStreet.length>2) {
        var index_city = 0;
        //так как города из КЛАДР и внутренних идентификаторов в массиве нет,
        //то ищем номер в массиве и узнаем его код КЛАДР

        for (var i = 0; i < vm.cities.length; i++)
          if (vm.cities[i]['name'] == vm.formWizard.city) {
            index_city = i;
            //стандартная загрузка через resource/http в контроллере не возвращает результат сразу же
            //dropdown обновляется на шаг позже - решено при помощи создания фабрики в модуле
            return GetStreetService.getStreets(vm.cities[index_city].code, str);
        }
      }
    }

    //если в директиве слушать напрямую изменение выбранной улицы, то
    //функция срабатывает до изменения параметра в этой функции
    //selectedItemChange() срабатывает позже непосредственной замены vm.selectedItem
    //поэтому Blur срабатывает один раз даже когда введена улица из списка

    //если объект создается
    vm.streetFromListWhenSelected = false;
    //если объект редактируется - улица уже введена
    //vm.streetFromListWhenSelected = true;

    //при выборе нового значения изменяем значение в модели для отправки
    vm.selectedItemChange = function () {
      if (typeof(vm.selectedItem)=='object' && vm.selectedItem!=null) {

        vm.formWizard.street = vm.selectedItem.value;
        //улица выбрана из списка
        //так как в formWizard не работают ngMessages, то проверка идет после потери
        //фокуса поля Улица
        vm.streetFromListWhenSelected = true;
      } else {
        //улица не из списка
      }
    }

    vm.searchStringChange = function (text) {
      //если текст вообще введен
      if (text!==null) {
        //при любом изменении вводимого в улицу текста помечаем, что улица выбрана не из списка
        vm.streetFromList = false;
        vm.streetFromListWhenSelected = false;
      }
    }

    //делает поле обязательным, если в нас. пункте есть улицы по базе КЛАДР
    vm.isStreetRequired = function () {
      var index_city = 0;
      //так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
      //его код КЛАДР
      for (var i = 0; i < vm.cities.length; i++)
        if (vm.cities[i]['name'] == vm.formWizard.city) {
          index_city = i;
          api.objects.count_streets.query({'code':vm.cities[index_city].code}, function(data) {
            vm.street_qty = data[0].qty;
            //console.log('В данном населенном пункте '+vm.street_qty+' улиц');
          });
      }
      //очищаем улицу
      vm.formWizard.street = null;
    }

        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;

					var newobject = new api.objects.newobjectdata();
					newobject.data = formWizardData;
					newobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/suburbian');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект успешно создан</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.newobject.newflatrent',[])
        .controller('NewFlatRentController', NewFlatRentController);

    /** @ngInject */
    function NewFlatRentController($scope, $mdDialog, $location, api, GetStreetService)
    {
        var vm = this;
        // Data
        vm.formWizard = {};

		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
		vm.formWizard.region = 1;
		//подгружаем список районов
		vm.districts = {};
		loadDistricts();
		//типы населенных пунктов
        vm.city_types = [{'socr': 'г', 'name': 'город'},
						{'socr': 'г.о.', 'name': 'городской округ'},
						{'socr': 'п', 'name': 'поселение/поселок'},
						{'socr': 'дп', 'name': 'дачный поселок'},
						{'socr': 'кп', 'name': 'курортный поселок'},
						{'socr': 'пгт', 'name': 'поселок городского типа'},
						{'socr': 'рп', 'name': 'рабочий поселок'},
						{'socr': 'с/п', 'name': 'сельское поселение'},
						{'socr': 'д', 'name': 'деревня'},
						{'socr': 'с', 'name': 'село'},
						{'socr': 'сл', 'name': 'слобода'},
						{'socr': 'снт', 'name': 'СНТ'},
						{'socr': 'жилрайон', 'name': 'жилой район'},
						{'socr': 'кв-л', 'name': 'квартал'},
						{'socr': 'мкр', 'name': 'микрорайон'},
						{'socr': 'нп', 'name': 'населенный пункт'},
						{'socr': 'тер', 'name': 'территория'},
						{'socr': 'промзона', 'name': 'промышленная зона'}];
		vm.formWizard.city_type = 'г';
		//названия нас.пунктов и улицы подгружаем после выбора
		vm.cities = {};
		vm.streets = {};
		//Список метро и направлений
		api.objects.metrostations.query({}, function(data) {
				vm.metrostations = data;
				});
		api.objects.directions.query({}, function(data) {
				vm.directions = data;
				});
		api.contacts.my_clients.query({}, function(data) {
				vm.my_clients = data;
				});

    vm.formWizard.meet = 'no';

		vm.metro_time_list = [{'name': 'f_2', 'rusname': '2 минуты пешком'},
						{'name': 'f_5', 'rusname': '5 минут пешком'},
						{'name': 'f_7', 'rusname': '7 минут пешком'},
						{'name': 'f_10', 'rusname': '10 минут пешком'},
						{'name': 'f_15', 'rusname': '15 минут пешком'},
						{'name': 'f_20', 'rusname': '20 минут пешком'},
						{'name': 't_5', 'rusname': '5 минут транспортом'},
						{'name': 't_10', 'rusname': '10 минут транспортом'},
						{'name': 't_15', 'rusname': '15 минут транспортом'},
						{'name': 't_20', 'rusname': '20 минут транспортом'}];
        vm.formWizard.metro_1_time = 'f_10';

		//тип объекта
		vm.object_types = [{'name': 'flat', 'rusname': 'Квартира'},
						{'name': 'room', 'rusname': 'Комната'},
						{'name': 'apartments', 'rusname': 'Апартаменты'},
						{'name': 'penthouse', 'rusname': 'Пентхаус'}];
		vm.formWizard.object_type = 'flat';

        //тип объекта 2
		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'},
						{'name': 'hog-wash', 'rusname': 'Утка'},
						{'name': 'auction', 'rusname': 'Аукцион'},
						{'name': 'invest', 'rusname': 'Инвестиционный'}];
		vm.formWizard.object_type_2 = 'real';

		//источник
		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'},
						{'id': '2', 'rusname': 'Расклейка'},
						{'id': '3', 'rusname': 'Баннер'},
						{'id': '4', 'rusname': 'Рекомендация'},
						{'id': '5', 'rusname': 'База собственников'},
						{'id': '6', 'rusname': 'База заявок'},
						{'id': '7', 'rusname': 'Диспетчерская'},
						{'id': '8', 'rusname': 'Avito'},
						{'id': '9', 'rusname': 'Другие сайты'},
						{'id': '10', 'rusname': 'Сам нашел'}];
		vm.formWizard.source_id = '5';


        // Предоплата, от 1 до 12 месяцев
		vm.class_bilds = [{'name': '1', 'rusname': '1'},
						{'name': '2', 'rusname': '2'},
						{'name': '3', 'rusname': '3'},
						{'name': '4', 'rusname': '4'},
						{'name': '5', 'rusname': '5'},
						{'name': '6', 'rusname': '6'},
						{'name': '7', 'rusname': '7'},
						{'name': '8', 'rusname': '8'},
						{'name': '9', 'rusname': '9'},
						{'name': '10', 'rusname': '10'},
						{'name': '11', 'rusname': '11'},
						{'name': '12', 'rusname': '12'}];
		vm.formWizard.class_bild = '1';		

		//тип комиссии
		vm.commission_types = [{'name': 'percent', 'rusname': '%'},
						{'name': 'sum', 'rusname': 'руб.'}];
		vm.formWizard.commission_type = 'sum';

		//типы сделок
		vm.deal_types = [{'name': 'rent', 'rusname': 'Аренда'}];
		vm.formWizard.deal_type = 'rent';

        vm.rent_durations = [{'name': 'short', 'rusname': 'Несколько месяцев'},
						{'name': 'long', 'rusname': 'Длительный срок'},
						{'name': 'day', 'rusname': 'Посуточно'}];
		vm.pay_durations = [{'name': 'month', 'rusname': 'ежемесячно'},
							{'name': 'day', 'rusname': 'посуточно'}];
        //типы комнат для квартиры
        vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'},
						{'name': '2', 'rusname': 'Двухкомнатная'},
						{'name': '3', 'rusname': 'Трехкомнатная'},
						{'name': '4', 'rusname': 'Четырехкомнатная'},
						{'name': '5', 'rusname': 'Пятикомнатная'},
						{'name': 'm', 'rusname': 'Многокомнатная'},
						{'name': 'studio', 'rusname': 'Студия'}];
		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'no', 'rusname': 'Нет'}];
		//стиральная машина
		vm.phone_types = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'no', 'rusname': 'Нет'}];
		vm.formWizard.phone_type = 'yes';	

    //окна
		vm.windows_type = [{'name': 'yard', 'rusname': 'Двор'},
						{'name': 'street', 'rusname': 'Улица'},
						{'name': 'both', 'rusname': 'Двор и улица'}];

		//кондиционер
		vm.furniture_types = [{'name': 'yes', 'rusname': 'Да'},
						{'name': 'no', 'rusname': 'Нет'}];
		vm.formWizard.furniture = 'no';						
						
						
		//ремонт //{'name': 'capital', 'rusname': 'Капитальный'},
		vm.repairs_types = [{'name': 'no', 'rusname': 'Без ремонта'},
						{'name': 'cosmetic', 'rusname': 'Косметический'},
						{'name': 'capital', 'rusname': 'Дизайнерский'},
						{'name': 'euro', 'rusname': 'Евро'}];
						
		vm.formWizard.repairs = 'cosmetic';
								
		//типы санузла
		vm.types_bathroom = [{'name': 'separated', 'rusname': 'Раздельный'},
						{'name': 'combined', 'rusname': 'Совмещенный'}];
						
		vm.formWizard.type_bathroom = 'separated';	
		
		vm.formWizard.count_bathroom_flat = 1;
		//право собственности
		vm.ownership_types = [{'name': 'primary', 'rusname': 'Первичная приватизация'},
						{'name': 'contract-sales', 'rusname': 'Договор купли/продажи'},
						{'name': 'contract-donat', 'rusname': 'Договор дарения'},
						{'name': 'contract-rent', 'rusname': 'Договор ренты'},
						{'name': 'paid', 'rusname': 'ЖСК, выплаченный пай'},
						{'name': 'legacy', 'rusname': 'Наследство'},
						{'name': 'court', 'rusname': 'Решение суда'},
						{'name': 'mortgage', 'rusname': 'Залог (ипотека)'},
						{'name': 'invest', 'rusname': 'По договору инвестирования'}];
		//Тип дома
		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
						{'name': 'panel', 'rusname': 'Панельный'},
						{'name': 'brick', 'rusname': 'Кирпичный'},
						{'name': 'wood', 'rusname': 'Деревянный'},
						{'name': 'stalin', 'rusname': 'Сталинский'},
						{'name': 'monolith', 'rusname': 'Монолит'},
						{'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'}];
						
		vm.formWizard.type_bild = 'panel';

		//Посудомоечная машина
		vm.flat_status_types = [{'name': 'yes', 'rusname': 'Да'},
						{'name': 'no', 'rusname': 'Нет'}];
					//	{'name': 'patrol', 'rusname': 'Расселение/разъед'},
						//{'name': 'alternate', 'rusname': 'Альтернатива'},
          //  {'name': 'courtdesicion', 'rusname': 'Прописан по решению суда'}];
		vm.formWizard.flat_status = 'no';         
        
		//Лифт
		vm.lift_types = [{'name': 'pass', 'rusname': 'Пассажирский'},
						{'name': 'serv', 'rusname': 'Грузовой'},
						{'name': 'passserv', 'rusname': 'Пасс. + груз.'},
            {'name': '2pass1serv', 'rusname': '2 Пасс. + груз.'},
            {'name': '1pass2serv', 'rusname': 'Пасс. + 2 груз.'},
            {'name': '2pass2serv', 'rusname': '2 пасс. + 2 груз.'},
            {'name': '2pass', 'rusname': '2 пассажирских'},
						{'name': '2serv', 'rusname': '2 грузовых'},
						{'name': 'no', 'rusname': 'Нет'}];
						
		vm.formWizard.lift = 'passserv';	
		
		//Балкон
		vm.balcony_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'loggia', 'rusname': 'Лоджия'},
						{'name': '2balcon', 'rusname': '2 балкона'},
						{'name': '2loggia', 'rusname': '2 лоджии'}];
						
		vm.formWizard.balcony = 'yes';	
		
		//В собственности
		vm.years_own_types = [{'name': 'less3', 'rusname': 'Менее 3 лет'},
						{'name': 'more3', 'rusname': 'Более 3 лет'}];

        // Methods
        vm.sendForm = sendForm;
		vm.loadDistricts = loadDistricts;
		vm.loadCities = loadCities;
		vm.changeRoomTypes = changeRoomTypes;
		
	    //	vm.changeFlatStatuses = changeFlatStatuses;
        vm.addClient = addClient;

        //////////
        function addClient()
        {
          $mdDialog.show({
                  controller         : function ($scope, $mdDialog)
                  {
                    /////////////////////
                    $scope.createClient = function ()
                    {
                      var newclient = new api.contacts.newclientdata();
                      newclient.firstname = $scope.dialog.firstname;
                      newclient.phone_1 = $scope.dialog.phone_1;
                      newclient.type = 'person';
                      newclient.status = 'work';
                      newclient.$save();
                      ///////обновляем список клиентов
                      api.contacts.my_clients.query({}, function(data) {
                  				vm.my_clients = data;
                          vm.formWizard.client_id = vm.my_clients[vm.my_clients.length -1].id;
              				});
                      $mdDialog.hide();
                    }
                    ////////////////////
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                  },
                  templateUrl: 'app/contacts/clients/addClientDialog.html',
                  parent             : angular.element('body'),
                  clickOutsideToClose: true
          });
  		}

    function loadDistricts()
    {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
				vm.districts = data;
				//обнуляем все, что ниже иерархически
				vm.cities = {};
				vm.streets = {};
				//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.district = null;
				vm.formWizard.city = null;
        //очищаем улицу
        vm.formWizard.street = '';
        vm.searchStreet = '';

				vm.formWizard.house_number = null;
        vm.formWizard.flat_number = null;
				//для Москвы выбираем любой район, так как район города необязателен
				if (vm.formWizard.region == 1) {
					vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
					loadCities();
          //город по умолчанию для региона Москва
          vm.formWizard.city = 'Москва';
					}
				});
		}

		function loadCities()
        {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.city = null;
        //очищаем улицу
        vm.formWizard.street = '';
        vm.searchStreet = '';
				vm.formWizard.house_number = null;
        vm.formWizard.flat_number = null;

			if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
				vm.cities = {};
			} else {
				var index_district = 0;
				//определяем реальный порядковый номер в массиве
				for (var i = 0; i < vm.districts.length; i++)
					if (vm.districts[i]['id'] == vm.formWizard.district) {
						index_district = i;
						api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
							vm.cities = data;
							});
				}
			}
			vm.streets = {};
		}


        ///////////////////////
        vm.searchStreet = "";

        //функция вывода списка улиц
        vm.searchStreetResult = function (str) {
          //ищем хотя бы после 3 введенных символов, чтобы не показывать большие объемы улиц
          if (vm.searchStreet.length>2) {
            var index_city = 0;
            //так как города из КЛАДР и внутренних идентификаторов в массиве нет,
            //то ищем номер в массиве и узнаем его код КЛАДР

            for (var i = 0; i < vm.cities.length; i++)
              if (vm.cities[i]['name'] == vm.formWizard.city) {
                index_city = i;
                //стандартная загрузка через resource/http в контроллере не возвращает результат сразу же
                //dropdown обновляется на шаг позже - решено при помощи создания фабрики в модуле
                return GetStreetService.getStreets(vm.cities[index_city].code, str);
            }
          }
        }

        //если в директиве слушать напрямую изменение выбранной улицы, то
        //функция срабатывает до изменения параметра в этой функции
        //selectedItemChange() срабатывает позже непосредственной замены vm.selectedItem
        //поэтому Blur срабатывает один раз даже когда введена улица из списка

        //если объект создается
        vm.streetFromListWhenSelected = false;
        //если объект редактируется - улица уже введена
        //vm.streetFromListWhenSelected = true;

        //при выборе нового значения изменяем значение в модели для отправки
        vm.selectedItemChange = function () {
          if (typeof(vm.selectedItem)=='object' && vm.selectedItem!=null) {

            vm.formWizard.street = vm.selectedItem.value;
            //улица выбрана из списка
            //так как в formWizard не работают ngMessages, то проверка идет после потери
            //фокуса поля Улица
            vm.streetFromListWhenSelected = true;
          } else {
            //улица не из списка
          }
        }

        vm.searchStringChange = function (text) {
          //если текст вообще введен
          if (text!==null) {
            //при любом изменении вводимого в улицу текста помечаем, что улица выбрана не из списка
            vm.streetFromList = false;
            vm.streetFromListWhenSelected = false;
          }
        }

        //делает поле обязательным, если в нас. пункте есть улицы по базе КЛАДР
        vm.isStreetRequired = function () {
          var index_city = 0;
          //так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
          //его код КЛАДР
          for (var i = 0; i < vm.cities.length; i++)
            if (vm.cities[i]['name'] == vm.formWizard.city) {
              index_city = i;
              api.objects.count_streets.query({'code':vm.cities[index_city].code}, function(data) {
                vm.street_qty = data[0].qty;
                //console.log('В данном населенном пункте '+vm.street_qty+' улиц');
              });
          }
          //очищаем улицу
          vm.formWizard.street = null;
        }

        //автозаполнение поля метро
        vm.metroQuerySearch = function (query) {
          var lowercaseQuery = angular.lowercase(query);
          query = lowercaseQuery[0].toUpperCase() + lowercaseQuery.substr(1);

          var results = lowercaseQuery ? vm.metrostations.filter( createFilterFor(query) ) : vm.metrostations;
          return results;
        }
        //фильтр
        function createFilterFor(query) {
          return function filterFn(metro) {
            return (metro.name.indexOf(query) === 0);
          };
        }

		function changeFlatStatuses() {
		 if (vm.formWizard.deal_type == 'change') {
			 vm.flat_status_types = [{'name': 'patrol', 'rusname': 'Расселение/разъед'},
									 {'name': 'alternate', 'rusname': 'Альтернатива'}];
			  vm.formWizard.flat_status = 'alternate';
			} else {
			 vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
				{'name': 'free', 'rusname': 'Свободна'},
				{'name': 'patrol', 'rusname': 'Расселение/разъед'},
        {'name': 'courtdesicion', 'rusname': 'Прописан по решению суда'}];
			}
		}

		function changeRoomTypes() {
			switch (vm.formWizard.object_type) {
				//типы комнат для квартиры, новостройки, пентхауса
				case 'flat_new_building': //doNothing
				case 'penthouse': //doNothing
				case 'flat': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'},
										{'name': '2', 'rusname': 'Двухкомнатная'},
										{'name': '3', 'rusname': 'Трехкомнатная'},
										{'name': '4', 'rusname': 'Четырехкомнатная'},
										{'name': '5', 'rusname': 'Пятикомнатная'},
										{'name': 'm', 'rusname': 'Многокомнатная'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
        case 'apartments': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'},
										{'name': '2', 'rusname': 'Двухкомнатная'},
										{'name': '3', 'rusname': 'Трехкомнатная'},
										{'name': '4', 'rusname': 'Четырехкомнатная'},
										{'name': '5', 'rusname': 'Пятикомнатная'},
										{'name': 'm', 'rusname': 'Многокомнатная'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
				case 'part': vm.rooms_type_list = [{'name': 'd_1', 'rusname': 'Доля в однокомнатной'},
										{'name': 'd_2', 'rusname': 'Доля в двухкомнатной'},
										{'name': 'd_3', 'rusname': 'Доля в трехкомнатной'},
										{'name': 'd_4', 'rusname': 'Доля в четырехкомнатной'},
										{'name': 'd_5', 'rusname': 'Доля в пятикомнатной'}];
										break
				case 'room': vm.rooms_type_list = [{'name': '1_2', 'rusname': 'Комната в двухкомнатной'},
										{'name': '1_3', 'rusname': 'Комната в трехкомнатной'},
										{'name': '1_4', 'rusname': 'Комната в четырехкомнатной'},
										{'name': '1_5', 'rusname': 'Комната в пятикомнатной'},
										{'name': '2_3', 'rusname': '2 комнаты в трехкомнатной'},
										{'name': '2_4', 'rusname': '2 комнаты в четырехкомнатной'},
										{'name': '2_5', 'rusname': '2 комнаты в пятикомнатной'},
										{'name': '3_4', 'rusname': '3 комнаты в четырехкомнатной'},
										{'name': '3_5', 'rusname': '3 комнаты в пятикомнатной'}];
										break
					  }
		}

        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;

					var newobject = new api.objects.newobjectdata();
					newobject.data = formWizardData;
					newobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flatsrent');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект успешно создан</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.newobject.newflat',[])
        .controller('NewFlatController', NewFlatController);

    /** @ngInject */
    function NewFlatController($scope, $mdDialog, $location, api, GetStreetService)
    {
        var vm = this;
        // Data
        vm.formWizard = {};

		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
		vm.formWizard.region = 1;
		//подгружаем список районов
		vm.districts = {};
		loadDistricts();
		//типы населенных пунктов
        vm.city_types = [{'socr': 'г', 'name': 'город'},
						{'socr': 'г.о.', 'name': 'городской округ'},
						{'socr': 'п', 'name': 'поселение/поселок'},
						{'socr': 'дп', 'name': 'дачный поселок'},
						{'socr': 'кп', 'name': 'курортный поселок'},
						{'socr': 'пгт', 'name': 'поселок городского типа'},
						{'socr': 'рп', 'name': 'рабочий поселок'},
						{'socr': 'с/п', 'name': 'сельское поселение'},
						{'socr': 'д', 'name': 'деревня'},
						{'socr': 'с', 'name': 'село'},
						{'socr': 'сл', 'name': 'слобода'},
						{'socr': 'снт', 'name': 'СНТ'},
						{'socr': 'жилрайон', 'name': 'жилой район'},
						{'socr': 'кв-л', 'name': 'квартал'},
						{'socr': 'мкр', 'name': 'микрорайон'},
						{'socr': 'нп', 'name': 'населенный пункт'},
						{'socr': 'тер', 'name': 'территория'},
						{'socr': 'промзона', 'name': 'промышленная зона'}];
		vm.formWizard.city_type = 'г';
		//названия нас.пунктов и улицы подгружаем после выбора
		vm.cities = {};
		vm.streets = {};
		//Список метро и направлений
		api.objects.metrostations.query({}, function(data) {
				vm.metrostations = data;
				});
		api.objects.directions.query({}, function(data) {
				vm.directions = data;
				});
		api.contacts.my_clients.query({}, function(data) {
				vm.my_clients = data;
				});

    vm.formWizard.meet = 'no';

		vm.metro_time_list = [{'name': 'f_2', 'rusname': '2 минуты пешком'},
						{'name': 'f_5', 'rusname': '5 минут пешком'},
						{'name': 'f_7', 'rusname': '7 минут пешком'},
						{'name': 'f_10', 'rusname': '10 минут пешком'},
						{'name': 'f_15', 'rusname': '15 минут пешком'},
						{'name': 'f_20', 'rusname': '20 минут пешком'},
						{'name': 't_5', 'rusname': '5 минут транспортом'},
						{'name': 't_10', 'rusname': '10 минут транспортом'},
						{'name': 't_15', 'rusname': '15 минут транспортом'},
						{'name': 't_20', 'rusname': '20 минут транспортом'}];
						
		vm.formWizard.metro_1_time = 'f_10';

		//тип объекта
		vm.object_types = [{'name': 'flat', 'rusname': 'Квартира'},
            {'name': 'apartments', 'rusname': 'Апартаменты'},
						{'name': 'flat_new_building', 'rusname': 'Квартира в новостройке'},
						{'name': 'room', 'rusname': 'Комната'},
						{'name': 'part', 'rusname': 'Доля в квартире'},
						{'name': 'penthouse', 'rusname': 'Пентхаус'}];
		vm.formWizard.object_type = 'flat';

        //тип объекта 2
		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'},
						{'name': 'hog-wash', 'rusname': 'Утка'},
						{'name': 'auction', 'rusname': 'Аукцион'},
						{'name': 'invest', 'rusname': 'Инвестиционный'}];
		vm.formWizard.object_type_2 = 'real';
        vm.formWizard.xml_domclick = '0';
		//источник
		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'},
						{'id': '2', 'rusname': 'Расклейка'},
						{'id': '3', 'rusname': 'Баннер'},
						{'id': '4', 'rusname': 'Рекомендация'},
						{'id': '5', 'rusname': 'База собственников'},
						{'id': '6', 'rusname': 'База заявок'},
						{'id': '7', 'rusname': 'Диспетчерская'},
						{'id': '8', 'rusname': 'Avito'},
						{'id': '9', 'rusname': 'Другие сайты'},
						{'id': '10', 'rusname': 'Сам нашел'}];
						
		vm.formWizard.source_id = '8';

		//тип комиссии
		vm.commission_types = [{'name': 'percent', 'rusname': '%'},
						{'name': 'sum', 'rusname': 'руб.'}];
		vm.formWizard.commission_type = 'percent';
		
		
			 	//Бонус агенту
		vm.bordersq_stocks = [{'name': '0', 'rusname': '0'},
						{'name': '0,1', 'rusname': '0,1'},
				        {'name': '0,25', 'rusname': '0,25'},
		                {'name': '0,5', 'rusname': '0,5'},
						{'name': '1', 'rusname': '1'},
						{'name': '1,5', 'rusname': '1,5'}];

		vm.formWizard.bordersq_stock = '0';

		//типы сделок
		vm.deal_types = [{'name': 'change', 'rusname': 'Альтернатива'},
						{'name': 'sale', 'rusname': 'Продажа'},
          {'name': 'dupt', 'rusname': 'Переуступка'}];
		vm.formWizard.deal_type = 'sale';

        vm.rent_durations = [{'name': 'short', 'rusname': 'Несколько месяцев'},
						{'name': 'long', 'rusname': 'Длительный срок'},
						{'name': 'day', 'rusname': 'Посуточно'}];
		vm.pay_durations = [{'name': 'month', 'rusname': 'ежемесячно'},
							{'name': 'day', 'rusname': 'посуточно'}];
        //типы комнат для квартиры
        vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'},
						{'name': '2', 'rusname': 'Двухкомнатная'},
						{'name': '3', 'rusname': 'Трехкомнатная'},
						{'name': '4', 'rusname': 'Четырехкомнатная'},
						{'name': '5', 'rusname': 'Пятикомнатная'},
						{'name': 'm', 'rusname': 'Многокомнатная'},
						{'name': 'studio', 'rusname': 'Студия'}];
						
		vm.formWizard.rooms_number = '2';
		
		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'no', 'rusname': 'Нет'}];
		//телефон
		vm.phone_types = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'para', 'rusname': 'Спаренный'},
						{'name': 'possible', 'rusname': 'Возможно подключить'},
						{'name': 'no', 'rusname': 'Нет'}];

    //окна
		vm.windows_type = [{'name': 'yard', 'rusname': 'Двор'},
						{'name': 'street', 'rusname': 'Улица'},
						{'name': 'both', 'rusname': 'Двор и улица'}];

		vm.formWizard.windows = 'both';

		//Тип комнат
		vm.furniture_types = [{'name': 'separate', 'rusname': 'Изолированные'},
						{'name': 'combined', 'rusname': 'Смежные'},
						{'name': 'both', 'rusname': 'Оба варианта'}];
						
		vm.formWizard.furniture = 'separate';
						
		//Стоимость
		vm.inet_types = [{'name': 'full', 'rusname': 'Полная'},
						{'name': 'partial', 'rusname': 'Неполная'},
						{'name': 'discussed', 'rusname': 'Обсуждается'}];	
						
		vm.formWizard.inet = 'full';
						
												
		//ремонт //{'name': 'capital', 'rusname': 'Капитальный'},
		vm.repairs_types = [{'name': 'no', 'rusname': 'Без ремонта'},
						{'name': 'cosmetic', 'rusname': 'Косметический'},
						{'name': 'capital', 'rusname': 'Дизайнерский'},
						{'name': 'euro', 'rusname': 'Евро'}];
						
		vm.formWizard.repairs = 'cosmetic';
		
								
		//типы санузла
		vm.types_bathroom = [{'name': 'separated', 'rusname': 'Раздельный'},
						{'name': 'combined', 'rusname': 'Совмещенный'}];
						
		vm.formWizard.type_bathroom = 'separated';		
		
		//парковка
		vm.types_parking = [{'name': 'ground', 'rusname': 'Наземная'},
	                    	{'name': 'multilevel', 'rusname': 'Многоуровневая'},
	                    	{'name': 'open', 'rusname': 'Открытая'},
		                    {'name': 'roof', 'rusname': 'На крыше'},
				    		{'name': 'underground', 'rusname': 'Подземная'}];
						
		vm.formWizard.tv = 'ground';								
						
						
		vm.formWizard.count_bathroom_flat = 1;
		//право собственности
		vm.ownership_types = [{'name': 'primary', 'rusname': 'Приватизация'},
						{'name': 'contract-sales', 'rusname': 'Договор купли/продажи'},
						{'name': 'contract-donat', 'rusname': 'Договор дарения'},
						{'name': 'contract-rent', 'rusname': 'Договор ренты'},
						{'name': 'paid', 'rusname': 'ЖСК, выплаченный пай'},
						{'name': 'legacy', 'rusname': 'Наследство'},
						{'name': 'court', 'rusname': 'Решение суда'},
						{'name': 'mortgage', 'rusname': 'Залог (ипотека)'},
						{'name': 'invest', 'rusname': 'ДДУ'},
						{'name': 'contract-meni', 'rusname': 'Договор мены'}];
						
		vm.formWizard.ownership = 'contract-sales';							
						
						
		//Тип дома
		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
						{'name': 'panel', 'rusname': 'Панельный'},
						{'name': 'brick', 'rusname': 'Кирпичный'},
						{'name': 'wood', 'rusname': 'Деревянный'},
						{'name': 'stalin', 'rusname': 'Сталинский'},
						{'name': 'monolith', 'rusname': 'Монолит'},
						{'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'}];
						
		vm.formWizard.type_bild = 'panel';

		//Ипотека (Статус)
		vm.flat_status_types = [{'name': 'yes', 'rusname': 'Да'},
						{'name': 'no', 'rusname': 'Нет'}];
						
		vm.formWizard.flat_status = 'yes';						
						
					//	{'name': 'patrol', 'rusname': 'Расселение/разъед'},
						//{'name': 'alternate', 'rusname': 'Альтернатива'},
          //  {'name': 'courtdesicion', 'rusname': 'Прописан по решению суда'}];
        
		//Лифт
		vm.lift_types = [{'name': 'pass', 'rusname': 'Пассажирский'},
						{'name': 'serv', 'rusname': 'Грузовой'},
						{'name': 'passserv', 'rusname': 'Пасс. + груз.'},
            {'name': '2pass1serv', 'rusname': '2 Пасс. + груз.'},
            {'name': '1pass2serv', 'rusname': 'Пасс. + 2 груз.'},
            {'name': '2pass2serv', 'rusname': '2 пасс. + 2 груз.'},
            {'name': '2pass', 'rusname': '2 пассажирских'},
						{'name': '2serv', 'rusname': '2 грузовых'},
						{'name': 'no', 'rusname': 'Нет'}];
						
		vm.formWizard.lift = 'passserv';						
						
		//Балкон
		vm.balcony_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'loggia', 'rusname': 'Лоджия'},
						{'name': '2balcon', 'rusname': '2 балкона'},
						{'name': '2loggia', 'rusname': '2 лоджии'}];
						
		vm.formWizard.balcony = 'yes';							
						
		//В собственности
		vm.years_own_types = [{'name': 'less3', 'rusname': 'Менее 3 лет'},
						{'name': 'more3', 'rusname': 'Более 3 лет'},
						{'name': 'more5', 'rusname': 'Более 5 лет'},];
		vm.formWizard.years_own = 'more3';	

        // Methods
        vm.sendForm = sendForm;
		vm.loadDistricts = loadDistricts;
		vm.loadCities = loadCities;
		vm.changeRoomTypes = changeRoomTypes;
	//	vm.changeFlatStatuses = changeFlatStatuses;
    vm.addClient = addClient;

        //////////
        function addClient()
        {
          $mdDialog.show({
                  controller         : function ($scope, $mdDialog)
                  {
                    /////////////////////
                    $scope.createClient = function ()
                    {
                      var newclient = new api.contacts.newclientdata();
                      newclient.firstname = $scope.dialog.firstname;
                      newclient.phone_1 = $scope.dialog.phone_1;
                      newclient.type = 'person';
                      newclient.status = 'work';
                      newclient.$save();
                      ///////обновляем список клиентов
                      api.contacts.my_clients.query({}, function(data) {
                  				vm.my_clients = data;
                          vm.formWizard.client_id = vm.my_clients[vm.my_clients.length -1].id;
              				});
                      $mdDialog.hide();
                    }
                    ////////////////////
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                  },
                  templateUrl: 'app/contacts/clients/addClientDialog.html',
                  parent             : angular.element('body'),
                  clickOutsideToClose: true
          });
  		}

    function loadDistricts()
    {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
				vm.districts = data;
				//обнуляем все, что ниже иерархически
				vm.cities = {};
				vm.streets = {};
				//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.district = null;
				vm.formWizard.city = null;
        //очищаем улицу
        vm.formWizard.street = '';
        vm.searchStreet = '';

				vm.formWizard.house_number = null;
        vm.formWizard.flat_number = null;
				//для Москвы выбираем любой район, так как район города необязателен
				if (vm.formWizard.region == 1) {
					vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
					loadCities();
          //город по умолчанию для региона Москва
          vm.formWizard.city = 'Москва';
					}
				});
		}

		function loadCities()
        {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.city = null;
        //очищаем улицу
        vm.formWizard.street = '';
        vm.searchStreet = '';
				vm.formWizard.house_number = null;
        vm.formWizard.flat_number = null;

			if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
				vm.cities = {};
			} else {
				var index_district = 0;
				//определяем реальный порядковый номер в массиве
				for (var i = 0; i < vm.districts.length; i++)
					if (vm.districts[i]['id'] == vm.formWizard.district) {
						index_district = i;
						api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
							vm.cities = data;
							});
				}
			}
			vm.streets = {};
		}


        ///////////////////////
        vm.searchStreet = "";

        //функция вывода списка улиц
        vm.searchStreetResult = function (str) {
          //ищем хотя бы после 3 введенных символов, чтобы не показывать большие объемы улиц
          if (vm.searchStreet.length>2) {
            var index_city = 0;
            //так как города из КЛАДР и внутренних идентификаторов в массиве нет,
            //то ищем номер в массиве и узнаем его код КЛАДР

            for (var i = 0; i < vm.cities.length; i++)
              if (vm.cities[i]['name'] == vm.formWizard.city) {
                index_city = i;
                //стандартная загрузка через resource/http в контроллере не возвращает результат сразу же
                //dropdown обновляется на шаг позже - решено при помощи создания фабрики в модуле
                return GetStreetService.getStreets(vm.cities[index_city].code, str);
            }
          }
        }

        //если в директиве слушать напрямую изменение выбранной улицы, то
        //функция срабатывает до изменения параметра в этой функции
        //selectedItemChange() срабатывает позже непосредственной замены vm.selectedItem
        //поэтому Blur срабатывает один раз даже когда введена улица из списка

        //если объект создается
        vm.streetFromListWhenSelected = false;
        //если объект редактируется - улица уже введена
        //vm.streetFromListWhenSelected = true;

        //при выборе нового значения изменяем значение в модели для отправки
        vm.selectedItemChange = function () {
          if (typeof(vm.selectedItem)=='object' && vm.selectedItem!=null) {

            vm.formWizard.street = vm.selectedItem.value;
            //улица выбрана из списка
            //так как в formWizard не работают ngMessages, то проверка идет после потери
            //фокуса поля Улица
            vm.streetFromListWhenSelected = true;
          } else {
            //улица не из списка
          }
        }

        vm.searchStringChange = function (text) {
          //если текст вообще введен
          if (text!==null) {
            //при любом изменении вводимого в улицу текста помечаем, что улица выбрана не из списка
            vm.streetFromList = false;
            vm.streetFromListWhenSelected = false;
          }
        }

        //делает поле обязательным, если в нас. пункте есть улицы по базе КЛАДР
        vm.isStreetRequired = function () {
          var index_city = 0;
          //так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
          //его код КЛАДР
          for (var i = 0; i < vm.cities.length; i++)
            if (vm.cities[i]['name'] == vm.formWizard.city) {
              index_city = i;
              api.objects.count_streets.query({'code':vm.cities[index_city].code}, function(data) {
                vm.street_qty = data[0].qty;
                //console.log('В данном населенном пункте '+vm.street_qty+' улиц');
              });
          }
          //очищаем улицу
          vm.formWizard.street = null;
        }

        //автозаполнение поля метро
        vm.metroQuerySearch = function (query) {
          var lowercaseQuery = angular.lowercase(query);
          query = lowercaseQuery[0].toUpperCase() + lowercaseQuery.substr(1);

          var results = lowercaseQuery ? vm.metrostations.filter( createFilterFor(query) ) : vm.metrostations;
          return results;
        }
        //фильтр
        function createFilterFor(query) {
          return function filterFn(metro) {
            return (metro.name.indexOf(query) === 0);
          };
        }

		function changeFlatStatuses() {
		 if (vm.formWizard.deal_type == 'change') {
			 vm.flat_status_types = [{'name': 'patrol', 'rusname': 'Расселение/разъед'},
									 {'name': 'alternate', 'rusname': 'Альтернатива'}];
			  vm.formWizard.flat_status = 'alternate';
			} else {
			 vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
				{'name': 'free', 'rusname': 'Свободна'},
				{'name': 'patrol', 'rusname': 'Расселение/разъед'},
        {'name': 'courtdesicion', 'rusname': 'Прописан по решению суда'}];
			}
		}

		function changeRoomTypes() {
			switch (vm.formWizard.object_type) {
				//типы комнат для квартиры, новостройки, пентхауса
				case 'flat_new_building': //doNothing
				case 'penthouse': //doNothing
				case 'flat': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'},
										{'name': '2', 'rusname': 'Двухкомнатная'},
										{'name': '3', 'rusname': 'Трехкомнатная'},
										{'name': '4', 'rusname': 'Четырехкомнатная'},
										{'name': '5', 'rusname': 'Пятикомнатная'},
										{'name': 'm', 'rusname': 'Многокомнатная'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
        case 'apartments': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'},
										{'name': '2', 'rusname': 'Двухкомнатная'},
										{'name': '3', 'rusname': 'Трехкомнатная'},
										{'name': '4', 'rusname': 'Четырехкомнатная'},
										{'name': '5', 'rusname': 'Пятикомнатная'},
										{'name': 'm', 'rusname': 'Многокомнатная'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
				case 'part': vm.rooms_type_list = [{'name': 'd_1', 'rusname': 'Доля в однокомнатной'},
										{'name': 'd_2', 'rusname': 'Доля в двухкомнатной'},
										{'name': 'd_3', 'rusname': 'Доля в трехкомнатной'},
										{'name': 'd_4', 'rusname': 'Доля в четырехкомнатной'},
										{'name': 'd_5', 'rusname': 'Доля в пятикомнатной'}];
										break
				case 'room': vm.rooms_type_list = [{'name': '1_2', 'rusname': 'Комната в двухкомнатной'},
										{'name': '1_3', 'rusname': 'Комната в трехкомнатной'},
										{'name': '1_4', 'rusname': 'Комната в четырехкомнатной'},
										{'name': '1_5', 'rusname': 'Комната в пятикомнатной'},
										{'name': '2_3', 'rusname': '2 комнаты в трехкомнатной'},
										{'name': '2_4', 'rusname': '2 комнаты в четырехкомнатной'},
										{'name': '2_5', 'rusname': '2 комнаты в пятикомнатной'},
										{'name': '3_4', 'rusname': '3 комнаты в четырехкомнатной'},
										{'name': '3_5', 'rusname': '3 комнаты в пятикомнатной'}];
										break
					  }
		}

        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;

					var newobject = new api.objects.newobjectdata();
					newobject.data = formWizardData;
					newobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flats');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект успешно создан</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.newobject.newcommerce',[])
        .controller('NewCommerceController', NewCommerceController);

    /** @ngInject */
    function NewCommerceController($scope, $mdDialog, GetStreetService, $location, api)
    {
        var vm = this;
        // Data
        vm.formWizard = {};

		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
		vm.formWizard.region = 1;
		//подгружаем список районов
		vm.districts = {};
		loadDistricts();
		//типы населенных пунктов
        vm.city_types = [{'socr': 'г', 'name': 'город'},
						{'socr': 'г.о.', 'name': 'городской округ'},
						{'socr': 'п', 'name': 'поселение/поселок'},
						{'socr': 'дп', 'name': 'дачный поселок'},
						{'socr': 'кп', 'name': 'курортный поселок'},
						{'socr': 'пгт', 'name': 'поселок городского типа'},
						{'socr': 'рп', 'name': 'рабочий поселок'},
						{'socr': 'с/п', 'name': 'сельское поселение'},
						{'socr': 'д', 'name': 'деревня'},
						{'socr': 'с', 'name': 'село'},
						{'socr': 'сл', 'name': 'слобода'},
						{'socr': 'снт', 'name': 'СНТ'},
						{'socr': 'жилрайон', 'name': 'жилой район'},
						{'socr': 'кв-л', 'name': 'квартал'},
						{'socr': 'мкр', 'name': 'микрорайон'},
						{'socr': 'нп', 'name': 'населенный пункт'},
						{'socr': 'тер', 'name': 'территория'},
						{'socr': 'промзона', 'name': 'промышленная зона'}];
		vm.formWizard.city_type = 'г';
		//названия нас.пунктов и улицы подгружаем после выбора
		vm.cities = {};
		vm.streets = {};
		//Список метро и направлений
		api.objects.metrostations.query({}, function(data) {
				vm.metrostations = data;
				});
		api.objects.directions.query({}, function(data) {
				vm.directions = data;
				});
		api.contacts.my_clients.query({}, function(data) {
				vm.my_clients = data;
				});

		vm.metro_time_list = [{'name': 'f_2', 'rusname': '2 минуты пешком'},
						{'name': 'f_5', 'rusname': '5 минут пешком'},
						{'name': 'f_7', 'rusname': '7 минут пешком'},
						{'name': 'f_10', 'rusname': '10 минут пешком'},
						{'name': 'f_15', 'rusname': '15 минут пешком'},
						{'name': 'f_20', 'rusname': '20 минут пешком'},
						{'name': 't_5', 'rusname': '5 минут транспортом'},
						{'name': 't_10', 'rusname': '10 минут транспортом'},
						{'name': 't_15', 'rusname': '15 минут транспортом'},
						{'name': 't_20', 'rusname': '20 минут транспортом'}];

		//тип объекта
		vm.object_types = [{'name': 'office', 'rusname': 'Офис'},
						{'name': 'garage', 'rusname': 'Гараж'},
					    {'name': 'parkingPlace', 'rusname': 'Машиноместо'},
						{'name': 'stock', 'rusname': 'Склад'},
						{'name': 'commercial_premises', 'rusname': 'Торговое помещение'},
            {'name': 'psn', 'rusname': 'ПСН'},
            {'name': 'production_room', 'rusname': 'Производственное помещение'},
						{'name': 'ready_business', 'rusname': 'Готовый бизнес'}];
		vm.formWizard.object_type = 'office';

        //тип объекта 2
		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'}];
		vm.formWizard.object_type_2 = 'real';

		//источник
		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'},
						{'id': '2', 'rusname': 'Расклейка'},
						{'id': '3', 'rusname': 'Баннер'},
						{'id': '4', 'rusname': 'Рекомендация'},
						{'id': '5', 'rusname': 'База собственников'},
						{'id': '6', 'rusname': 'База заявок'},
						{'id': '7', 'rusname': 'Диспетчерская'},
						{'id': '8', 'rusname': 'Avito'},
						{'id': '9', 'rusname': 'Другие сайты'},
						{'id': '10', 'rusname': 'Сам нашел'}];

		//тип комиссии
		vm.commission_types = [{'name': 'percent', 'rusname': '%'},
						{'name': 'sum', 'rusname': 'руб.'}];
		vm.formWizard.commission_type = 'sum';

		//типы сделок
		vm.deal_types = [{'name': 'rent', 'rusname': 'Прямая аренда'},
						{'name': 'subrent', 'rusname': 'Субаренда'},
            {'name': 'ppa', 'rusname': 'переуступка права аренды'},
            {'name': 'dsd', 'rusname': 'Договор совместной деятельности'},
						{'name': 'sale', 'rusname': 'Продажа объекта'}];
		vm.formWizard.deal_type = 'sale';

        vm.pay_types = [{'name': 'object', 'rusname': 'За весь объект'},
						{'name': 'squarem', 'rusname': 'За м2'}];

		vm.pay_durations = [{'name': 'month', 'rusname': 'в месяц'},
							{'name': 'year', 'rusname': 'в год'}];

		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'no', 'rusname': 'Нет'}];
						
						
       // vm.yes_no_array_living = [{'name': 'yes', 'rusname': 'Жилое'},
		//				{'name': 'no', 'rusname': 'Нежилое'}];
			// назначение			
          vm.yes_no_array_living = [{'name': 'shoppingFloorSpace', 'rusname': 'Торговая площадь'},
                                    {'name': 'publicCatering', 'rusname': 'Общепит'},
                                    {'name': 'restaurant', 'rusname': 'Ресторан'},  
                                    {'name': 'rentalBusiness', 'rusname': 'Арендный бизнес'},
                                    {'name': 'readyMadeBusiness', 'rusname': 'Готовый бизнес'},                                              
                                    {'name': 'flexiblePurpose', 'rusname': 'Свободное назначение'},
                                    {'name': 'streetRetail', 'rusname': 'Стрит ритейл'},  
                                    {'name': 'products', 'rusname': 'Продукты'},
                                    {'name': 'other', 'rusname': 'Другое'},];						
					
     //   vm.yes_no_array_enter = [{'name': 'free', 'rusname': 'Свободный'},
  			//		{'name': 'kpp', 'rusname': 'КПП'}];
// юридический адрес 
          vm.yes_no_array_enter = [{'name': 'yes', 'rusname': 'Предоставляется'},
    					{'name': 'no', 'rusname': 'Не предоставляется'}];  					
  					
          vm.int_yes_no_array = [{'name': '1', 'rusname': 'Есть'},
      							{'name': '0', 'rusname': 'Нет'}]; 					
  					
    //типы планировок
      vm.plan_bild_types = [{'name': 'cabinet', 'rusname': 'Кабинетная'},
  						{'name': 'corridorplan', 'rusname': 'Коридорная'},
  						{'name': 'mixed', 'rusname': 'Смешанная'},
  						{'name': 'openSpace', 'rusname': 'Открытая'}];	
  						
  						
		//телефон
		vm.phone_types = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'para', 'rusname': 'Спаренный'},
						{'name': 'possible', 'rusname': 'Возможно подключить'},
						{'name': 'no', 'rusname': 'Нет'}];
    //отопление и электричество
    vm.heating_types = [{'name': 'central', 'rusname': 'Центральное'},
						{'name': 'autonomous', 'rusname': 'Автономное'},
						{'name': 'no', 'rusname': 'Нет'}];
    vm.enegi_types = [{'name': 'yes', 'rusname': 'Есть'},
  					{'name': 'unknown', 'rusname': 'Неизвестно'},
  					{'name': 'possible', 'rusname': 'Возможно подключить'}];
		//мебель
		
  vm.furniture_types = [{'name': 'true', 'rusname': 'Да'},
  						{'name': 'false', 'rusname': 'Нет'}];
  						
	//	vm.furniture_types = [{'name': 'no', 'rusname': 'Нет'},
			//			{'name': 'old', 'rusname': 'Старая'},
			//			{'name': '90s', 'rusname': 'Мебель 90-х'},
			//			{'name': 'modern', 'rusname': 'Современная'}];   
						
						
		//ремонт
		vm.repairs_types = [{'name': 'no', 'rusname': 'Без ремонта'},
						{'name': 'cosmetic', 'rusname': 'Косметический'},
						{'name': 'capital', 'rusname': 'Дизайнерский ремонт'},
						{'name': 'euro', 'rusname': 'Евро'},
            {'name': 'quality', 'rusname': 'Качественная и дорогая отделка'},
            {'name': 'standard-office', 'rusname': 'Стандартная офисная отделка'},
            {'name': 'ready-for-final', 'rusname': 'Готово под чистовую отделку'},
            {'name': 'needcapital', 'rusname': 'Требуется капитальный'},
            {'name': 'needcosmetic', 'rusname': 'Требуется косметический'},
            {'name': 'needreconstruction', 'rusname': 'Требуется реконструкция'}
          ];
          
          
          	// типы ремонтов для готового бизнеса
         vm.repairs_types_2 = [ {'name': 'cosmetic', 'rusname': 'Типовой ремонт'},
								{'name': 'capital', 'rusname': 'Дизайнерский ремонт'},
								{'name': 'standard-office', 'rusname': 'Офисная отделка'},
								{'name': 'ready-for-final', 'rusname': 'Под чистовую отделку'},
								{'name': 'needcapital', 'rusname': 'Требуется капитальный'},
								{'name': 'needcosmetic', 'rusname': 'Требуется косметический'},
								{'name': 'needreconstruction', 'rusname': 'Требуется реконструкция'}
          ];

    //типы гаражей
    vm.garage_types = [{'name': 'shell', 'rusname': 'Ракушка'},
            {'name': 'detached', 'rusname': 'Отдельно стоящий'},
            {'name': 'secure-outdoors', 'rusname': 'Место на охраняемой наружной стоянке'},
            {'name': 'secure-underground', 'rusname': 'Место в подземном охраняемом гараже'},
            {'name': 'high-bay', 'rusname': 'Место в многоярусном охраняемом гараже'},
            {'name': 'cooperative', 'rusname': 'Гараж в гаражном кооперативе'},
            {'name': 'capital', 'rusname': 'Капитальный'}];
		//типы санузла
		vm.types_bathroom = [{'name': 'separated', 'rusname': 'Раздельный'},
						{'name': 'combined', 'rusname': 'Совмещенный'}];

		//Тип дома
		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
						{'name': 'panel', 'rusname': 'Панельный'},
						{'name': 'brick', 'rusname': 'Кирпичный'},
						{'name': 'wood', 'rusname': 'Деревянный'},
						{'name': 'stalin', 'rusname': 'Сталинский'},
						{'name': 'monolith', 'rusname': 'Монолит'},
						{'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'},
            {'name': 'business_center', 'rusname': 'Бизнес-центр'},
						{'name': 'office_building', 'rusname': 'Офисное здание'},
						{'name': 'office_complex', 'rusname': 'Комплекс офисных зданий'},
						{'name': 'mansion', 'rusname': 'Особняк'},
						{'name': 'retail_office_complex', 'rusname': 'Торгово-офисный комплекс'},
						{'name': 'office_residential_complex', 'rusname': 'Офисно-жилой комплекс'},
						{'name': 'administrative_building', 'rusname': 'Административное зданиие'},
            {'name': 'mall', 'rusname': 'Торгово-развлекательный центр'},
            {'name': 'business_park', 'rusname': 'Бизнес-парк'},
            {'name': 'multifuctional_complex', 'rusname': 'Многофункциональный комплекс'}];

    //Статус бизнес центра
    
	//	vm.bcenterstatus_list = [{'name': 'A', 'rusname': 'A'},
			//			{'name': 'A+', 'rusname': 'A+'},
			//			{'name': 'B', 'rusname': 'B'},
			//			{'name': 'B+', 'rusname': 'B+'},
			//			{'name': 'C', 'rusname': 'C'},
			//			{'name': 'C+', 'rusname': 'C+'},
			//			{'name': 'D', 'rusname': 'D'}];
			
		vm.bcenterstatus_list = [{'name': 'included', 'rusname': 'НДС включен'},
  						{'name': 'notIncluded', 'rusname': 'НДС не включен'},
  						{'name': 'usn', 'rusname': 'УСН '},
  						{'name': 'wvat', 'rusname': 'Без налога'}];

		//Лифт
		
	//	vm.lift_types = [{'name': 'pass', 'rusname': 'Пассажирский'},
	//					{'name': 'serv', 'rusname': 'Грузовой'},
	//					{'name': 'passserv', 'rusname': 'Пасс. + груз.'},
    //        {'name': '2pass1serv', 'rusname': '2 Пасс. + груз.'},
    //        {'name': '1pass2serv', 'rusname': 'Пасс. + 2 груз.'},
    //        {'name': '2pass', 'rusname': '2 пассажирских'},
	//					{'name': '2serv', 'rusname': '2 грузовых'},
	//					{'name': 'no', 'rusname': 'Нет'}];

  		vm.lift_types = [{'name': 'rur', 'rusname': 'Рубль'},
  						{'name': 'eur', 'rusname': 'Евро'},
  						{'name': 'usd', 'rusname': 'Доллар'}];


        // Methods
        vm.sendForm = sendForm;
		vm.loadDistricts = loadDistricts;
		vm.loadCities = loadCities;
		//vm.loadStreets = loadStreets;
		vm.changeBildTypes = changeBildTypes;
    vm.addClient = addClient;

        //////////
        function addClient()
        {
          $mdDialog.show({
                  controller         : function ($scope, $mdDialog)
                  {
                    /////////////////////
                    $scope.createClient = function ()
                    {
                      var newclient = new api.contacts.newclientdata();
                      newclient.firstname = $scope.dialog.firstname;
                      newclient.phone_1 = $scope.dialog.phone_1;
                      newclient.type = 'person';
                      newclient.status = 'work';
                      newclient.$save();
                      ///////обновляем список клиентов
                      api.contacts.my_clients.query({}, function(data) {
                          vm.my_clients = data;
                          vm.formWizard.client_id = vm.my_clients[vm.my_clients.length -1].id;
                      });
                      $mdDialog.hide();
                    }
                    ////////////////////
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                  },
                  templateUrl: 'app/contacts/clients/addClientDialog.html',
                  parent             : angular.element('body'),
                  clickOutsideToClose: true
          });
      }

        //////////
        function loadDistricts()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
				vm.districts = data;
				//обнуляем все, что ниже иерархически
				vm.cities = {};
				vm.streets = {};
				//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.district = null;
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;
				//для Москвы выбираем любой район, так как район города необязателен
				if (vm.formWizard.region == 1) {
					vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
					loadCities();
					}
				});
		}

		function loadCities()
        {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.city = null;
				vm.formWizard.street = null;
				vm.formWizard.house_number = null;

			if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
				vm.cities = {};
			} else {
				var index_district = 0;
				//определяем реальный порядковый номер в массиве
				for (var i = 0; i < vm.districts.length; i++)
					if (vm.districts[i]['id'] == vm.formWizard.district) {
						index_district = i;
						api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
							vm.cities = data;
							});
				}
			}
			vm.streets = {};
		}

    ///////////////////////
    vm.searchStreet = "";

    //функция вывода списка улиц
    vm.searchStreetResult = function (str) {
      //ищем хотя бы после 3 введенных символов, чтобы не показывать большие объемы улиц
      if (vm.searchStreet.length>2) {
        var index_city = 0;
        //так как города из КЛАДР и внутренних идентификаторов в массиве нет,
        //то ищем номер в массиве и узнаем его код КЛАДР

        for (var i = 0; i < vm.cities.length; i++)
          if (vm.cities[i]['name'] == vm.formWizard.city) {
            index_city = i;
            //стандартная загрузка через resource/http в контроллере не возвращает результат сразу же
            //dropdown обновляется на шаг позже - решено при помощи создания фабрики в модуле
            return GetStreetService.getStreets(vm.cities[index_city].code, str);
        }
      }
    }

    //если в директиве слушать напрямую изменение выбранной улицы, то
    //функция срабатывает до изменения параметра в этой функции
    //selectedItemChange() срабатывает позже непосредственной замены vm.selectedItem
    //поэтому Blur срабатывает один раз даже когда введена улица из списка

    //если объект создается
    vm.streetFromListWhenSelected = false;
    //если объект редактируется - улица уже введена
    //vm.streetFromListWhenSelected = true;

    //при выборе нового значения изменяем значение в модели для отправки
    vm.selectedItemChange = function () {
      if (typeof(vm.selectedItem)=='object' && vm.selectedItem!=null) {

        vm.formWizard.street = vm.selectedItem.value;
        //улица выбрана из списка
        //так как в formWizard не работают ngMessages, то проверка идет после потери
        //фокуса поля Улица
        vm.streetFromListWhenSelected = true;
      } else {
        //улица не из списка
      }
    }

    vm.searchStringChange = function (text) {
      //если текст вообще введен
      if (text!==null) {
        //при любом изменении вводимого в улицу текста помечаем, что улица выбрана не из списка
        vm.streetFromList = false;
        vm.streetFromListWhenSelected = false;
      }
    }

    //делает поле обязательным, если в нас. пункте есть улицы по базе КЛАДР
    vm.isStreetRequired = function () {
      var index_city = 0;
      //так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
      //его код КЛАДР
      for (var i = 0; i < vm.cities.length; i++)
        if (vm.cities[i]['name'] == vm.formWizard.city) {
          index_city = i;
          api.objects.count_streets.query({'code':vm.cities[index_city].code}, function(data) {
            vm.street_qty = data[0].qty;
            //console.log('В данном населенном пункте '+vm.street_qty+' улиц');
          });
      }
      //очищаем улицу
      vm.formWizard.street = null;
    }

    //автозаполнение поля метро
    vm.metroQuerySearch = function (query) {
      var lowercaseQuery = angular.lowercase(query);
      query = lowercaseQuery[0].toUpperCase() + lowercaseQuery.substr(1);

      var results = lowercaseQuery ? vm.metrostations.filter( createFilterFor(query) ) : vm.metrostations;
      return results;
    }
    //фильтр
    function createFilterFor(query) {
      return function filterFn(metro) {
        return (metro.name.indexOf(query) === 0);
      };
    }

		function changeBildTypes() {
			switch (vm.formWizard.object_type) {
				//типы зданий
				case 'office': //doNothing
				case 'stock': //doNothing
        case 'psn': //doNothing
        case 'production_room': //doNothing
        case 'ready_business': //doNothing
				case 'commercial_premises':
            vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
                {'name': 'panel', 'rusname': 'Панельный'},
                {'name': 'brick', 'rusname': 'Кирпичный'},
                {'name': 'wood', 'rusname': 'Деревянный'},
                {'name': 'stalin', 'rusname': 'Сталинский'},
                {'name': 'monolith', 'rusname': 'Монолит'},
                {'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'},
                {'name': 'business_center', 'rusname': 'Бизнес-центр'},
                {'name': 'office_building', 'rusname': 'Офисное здание'},
                {'name': 'office_complex', 'rusname': 'Комплекс офисных зданий'},
                {'name': 'mansion', 'rusname': 'Особняк'},
                {'name': 'retail_office_complex', 'rusname': 'Торгово-офисный комплекс'},
                {'name': 'office_residential_complex', 'rusname': 'Офисно-жилой комплекс'},
                {'name': 'administrative_building', 'rusname': 'Административное зданиие'},
                {'name': 'mall', 'rusname': 'Торгово-развлекательный центр'},
                {'name': 'business_park', 'rusname': 'Бизнес-парк'},
                {'name': 'multifuctional_complex', 'rusname': 'Многофункциональный комплекс'}];
		            break
				case 'garage':
            vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
                {'name': 'brick', 'rusname': 'Кирпичный'},
                {'name': 'iron', 'rusname': 'Железный каркас'},
                {'name': 'shell', 'rusname': 'Ракушка'}];
								break
	            case 'parkingPlace':
            vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
               {'name': 'brick', 'rusname': 'Кирпичный'},
               {'name': 'iron', 'rusname': 'Железный каркас'},
               {'name': 'shell', 'rusname': 'Ракушка'}];
               break   							
		 			  }
		}


        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;

					var newobject = new api.objects.newobjectdata();
					newobject.data = formWizardData;
					newobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/commerce');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект успешно создан</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editsuburbian', ['datatables','ngResource','angularFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_editsuburbian', {
            url    : '/objects/edit/suburbian/{id:int}',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/editobject/editsuburbian/editsuburbian.html',
                    controller : 'EditSuburbianController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }




})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editsuburbian')
        .controller('EditSuburbianController', EditSuburbianController);

    /** @ngInject */
    function EditSuburbianController($rootScope, $scope, $mdDialog, $location, GetStreetService, $resource, FileUploader, api)
    {
        var vm = this;
        // Data
        vm.formWizard = {};

		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
		//типы населенных пунктов
        vm.city_types = [{'socr': 'г', 'name': 'город'},
						{'socr': 'г.о.', 'name': 'городской округ'},
						{'socr': 'п', 'name': 'поселение/поселок'},
						{'socr': 'дп', 'name': 'дачный поселок'},
						{'socr': 'кп', 'name': 'курортный поселок'},
						{'socr': 'пгт', 'name': 'поселок городского типа'},
						{'socr': 'рп', 'name': 'рабочий поселок'},
						{'socr': 'с/п', 'name': 'сельское поселение'},
						{'socr': 'д', 'name': 'деревня'},
						{'socr': 'с', 'name': 'село'},
						{'socr': 'сл', 'name': 'слобода'},
						{'socr': 'снт', 'name': 'СНТ'},
						{'socr': 'жилрайон', 'name': 'жилой район'},
						{'socr': 'кв-л', 'name': 'квартал'},
						{'socr': 'мкр', 'name': 'микрорайон'},
						{'socr': 'нп', 'name': 'населенный пункт'},
						{'socr': 'тер', 'name': 'территория'},
						{'socr': 'промзона', 'name': 'промышленная зона'}];

		//названия нас.пунктов и улицы подгружаем после выбора
		vm.districts = {};
		vm.cities = {};
		vm.streets = {};

    api.objects.directions.query({}, function(data) {
				vm.directions = data;
				});

		//тип объекта
		vm.object_types = [{'name': 'cottage', 'rusname': 'Дом (коттедж)'},
						{'name': 'country_house', 'rusname': 'Дача'},
						{'name': 'townhouse', 'rusname': 'Таунхаус'},
            {'name': 'production_land', 'rusname': 'Пром. земля'},
						{'name': 'parcel', 'rusname': 'Участок'},
            {'name': 'zsn', 'rusname': 'Участок - ЗСН'},
            {'name': 'znp', 'rusname': 'Участок - ЗНП'},
            {'name': 'zoot', 'rusname': 'Участок - ЗООТ'},
            {'name': 'zwilf', 'rusname': 'Участок - ЗВИЛФ'},
            {'name': 'zemli_zapasa', 'rusname': 'Участок - Земли запаса'}];


    //Целевое назначение земель
    vm.land_types = [{'name': 'snt', 'rusname': 'СНТ'},
            {'name': 'igs', 'rusname': 'ИЖС'},
            {'name': 'farm', 'rusname': 'Фермерское хозяйство'},
            {'name': 'dnp', 'rusname': 'ДНП'}];
    //тип объекта 2
		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'},
						{'name': 'hog-wash', 'rusname': 'Утка'},
						{'name': 'auction', 'rusname': 'Аукцион'}];

		//источник
		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'},
						{'id': '2', 'rusname': 'Расклейка'},
						{'id': '3', 'rusname': 'Баннер'},
						{'id': '4', 'rusname': 'Рекомендация'},
						{'id': '5', 'rusname': 'База собственников'},
						{'id': '6', 'rusname': 'База заявок'},
						{'id': '7', 'rusname': 'Диспетчерская'},
						{'id': '8', 'rusname': 'Avito'},
						{'id': '9', 'rusname': 'Другие сайты'},
						{'id': '10', 'rusname': 'Сам нашел'}];

		//тип комиссии
		vm.commission_types = [{'name': 'percent', 'rusname': '%'},
						{'name': 'sum', 'rusname': 'руб.'}];

		//типы сделок
		vm.deal_types = [{'name': 'rent', 'rusname': 'Аренда'},
						{'name': 'sale', 'rusname': 'Продажа'}];

        vm.rent_durations = [{'name': 'short', 'rusname': 'Несколько месяцев'},
						{'name': 'long', 'rusname': 'Длительный срок'},
						{'name': 'day', 'rusname': 'Посуточно'}];

		vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'},
						{'name': '2', 'rusname': 'Двухкомнатная'},
						{'name': '3', 'rusname': 'Трехкомнатная'},
						{'name': '4', 'rusname': 'Четырехкомнатная'},
						{'name': '5', 'rusname': 'Пятикомнатная'},
						{'name': 'm', 'rusname': 'Многокомнатная'},
						{'name': 'studio', 'rusname': 'Студия'}];


    vm.int_cian_array = [{'name': '0', 'rusname': 'Нет'},
      {'name': '1', 'rusname': 'Да'},
    {'name': '2', 'rusname': 'Highlight'},
    {'name': '3', 'rusname': 'Premium'},
    {'name': '4', 'rusname': 'Top3'}];
    
    vm.tech_8_array = [{'name': '1', 'rusname': '1'},
    {'name': '2', 'rusname': '2'},
    {'name': '3', 'rusname': '3'},
    {'name': '4', 'rusname': '4'}];

    vm.int_avito_array = [{'name': '0', 'rusname': 'Нет'},
      {'name': '1', 'rusname': 'Package'},
    {'name': '2', 'rusname': 'PackageSingle'},
  {'name': '3', 'rusname': 'Single'}];

  vm.int_avitoserv_array = [{'name': '0', 'rusname': 'Нет'},
    {'name': '2', 'rusname': 'Free'},
  {'name': '3', 'rusname': 'Premium'},
  {'name': '4', 'rusname': 'VIP'},
  {'name': '5', 'rusname': 'PushUp'},
  {'name': '6', 'rusname': 'Highlight'},
  {'name': '1', 'rusname': 'TurboSale'},
  {'name': '7', 'rusname': 'QuickSale'},
  {'name': '8', 'rusname': 'x2_1'},
  {'name': '9', 'rusname': 'x2_7'},
  {'name': '10', 'rusname': 'x5_1'},
  {'name': '11', 'rusname': 'x5_7'},
  {'name': '12', 'rusname': 'x10_1'},
  {'name': '13', 'rusname': 'x10_7'}];



			//Коммуникации в гараже
      vm.energi_garage_types = [{'name': 'elect-heat', 'rusname': 'Эл-во и отопление'},
          {'name': 'heating', 'rusname': 'Отопление'},
          {'name': 'electricity', 'rusname': 'Электричество'}];

          //массив - да / нет
    vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'},
				{'name': 'no', 'rusname': 'Нет'}];
		vm.int_yes_no_array = [{'name': '1', 'rusname': 'Есть'},
							{'name': '0', 'rusname': 'Нет'}];

		//мебель
		vm.furniture_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'old', 'rusname': 'Есть'}];
		//ремонт
		vm.repairs_types = [{'name': 'no', 'rusname': 'Без ремонта'},
						{'name': 'cosmetic', 'rusname': 'Косметический'},
						{'name': 'euro', 'rusname': 'Евро'}];

    //газ
    vm.gas_types = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'no', 'rusname': 'Нет'},
						{'name': 'project', 'rusname': 'Оплачен проект'},
            {'name': 'autonomous', 'rusname': 'Автономная газ-я'},
						{'name': 'border', 'rusname': 'По границе участка'}];
    //электричество
    vm.enegi_types = [{'name': 'yes', 'rusname': 'Есть'},
            {'name': 'request', 'rusname': 'Подана заявка'},
            {'name': 'unknown', 'rusname': 'Возможность подключения неизвестна'},
            {'name': 'possible', 'rusname': 'Возможно подключить'}];
    //отопление
    vm.heating_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'central', 'rusname': 'Центральное'},
            {'name': 'autonomous', 'rusname': 'Автономное'}];
    //Водоснабжение
    vm.water_types = [{'name': 'cesspool', 'rusname': 'Есть'},
						{'name': 'well', 'rusname': 'Скважина'},
            {'name': 'centra', 'rusname': 'Центральное'},
						{'name': 'spring', 'rusname': 'Колодец/колонка'},
            {'name': 'no', 'rusname': 'Отсутствует'},
						{'name': 'border', 'rusname': 'По границе участка'}];

    //Канализация
    vm.sewage_types = [{'name': 'yes', 'rusname': 'Есть'},
  					{'name': 'no', 'rusname': 'Нет'},
  					{'name': 'cesspool', 'rusname': 'Выгребная яма'},
            {'name': 'bio', 'rusname': 'Устройства биоочистки'},
            {'name': 'autonomous', 'rusname': 'Автономная'},
            {'name': 'central', 'rusname': 'Центральная'},
  					{'name': 'septic', 'rusname': 'Септики'}];

		//право собственности
		vm.ownership_types = [{'name': 'primary', 'rusname': 'Первичная приватизация'},
						{'name': 'contract-sales', 'rusname': 'Договор купли/продажи'},
						{'name': 'contract-donat', 'rusname': 'Договор дарения'},
						{'name': 'contract-rent', 'rusname': 'Договор ренты'},
						{'name': 'paid', 'rusname': 'ЖСК, выплаченный пай'},
						{'name': 'legacy', 'rusname': 'Наследство'},
						{'name': 'court', 'rusname': 'Решение суда'},
						{'name': 'mortgage', 'rusname': 'Залог (ипотека)'},
						{'name': 'invest', 'rusname': 'По договору инвестирования'}];
		//Тип дома
		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
						{'name': 'brick', 'rusname': 'Кирпичный'},
						{'name': 'wood', 'rusname': 'Деревянный'},
						{'name': 'brus', 'rusname': 'Брус'},
						{'name': 'brevno', 'rusname': 'Бревно'},
						{'name': 'monolith', 'rusname': 'Монолит'}];


      //получаем id своей учетной записи для сверки собственности на объект
      /*api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
        vm.userid = data.user_id;
      });*/
      vm.users_in_group = [];
      //узнаем свою должность
      //api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
        //vm.positionid = data.position_id;
        //console.log(vm.positionid);

        //Если НОП, то подгружаем список своих
        //if (vm.positionid == 1 || )
        //если есть право редактировать агента в объекте
        if ($rootScope.checkRule(59,'all')) {
          //получаем id своего отдела
          api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
            vm.groupid = data.group_id;
            //получаем список
            api.contacts.usersbygroup.get({id:vm.groupid}, function(data) {
              for (var i=0;i<data.data.length;i++) {
                vm.users_in_group.push(data.data[i]);
              }
              //console.log('i am nop of '+vm.groupid);
              //console.log(vm.users_in_group);
            });
          });
        }
      //});

      //добавляем в список агентов текущего агента по объекту (если для НОПа уже подгружен список, то не добавляем)
      if (vm.users_in_group.length>0) {
        var checkInArray = false;

        for (var i=0;i<vm.users_in_group.length;i++) {
          //TODO эта часть кода выполняется по факту после загрузки данных
          //странный реверс - рахобраться в причинах
          vm.users_in_group[i].id = parseInt(vm.users_in_group[i].id);
          if (vm.users_in_group[i].id == vm.formWizard.owner_id) {
            checkInArray = true;
            //break;
          }
        }
        if (!checkInArray) {
          api.contacts.usernamebyid.get({id:vm.formWizard.owner_id}, function(data) {
            //vm.object_agent = data.name;
            //console.log(data);
            vm.users_in_group.push({'id': vm.formWizard.owner_id, 'name': data.data });
          });

        }
      }
      vm.formWizard.owner_id = vm.formWizard.owner_id;
      //console.log(vm.users_in_group);

        //получаем id объекта, который будем редактировать
        vm.objectId = $location.path().split('/');
        vm.objectId = vm.objectId[vm.objectId.length-1];
        //id главного изображения
        vm.mainImage = 0;
        //информацию по объекту
		api.objects.objectbyid.query({'id':vm.objectId}, function(data) {
				//console.log(data);
				vm.formWizard.region = parseInt(data.region);
				vm.formWizard.district = parseInt(data.district);
				vm.formWizard.city_type = data.city_type;
				vm.formWizard.city = data.city;

        vm.selectedItem = data.street;
				vm.formWizard.street = data.street;
				vm.formWizard.house_number = data.house_number;
        vm.formWizard.country_land_type = data.country_land_type;

				//загружаем адрес полностью
				loadAddress();
				//id главного изображения
				vm.mainImage = (parseInt(data.image)==0)?0:data.image;

				vm.formWizard.object_type = data.object_type;
				vm.formWizard.object_type_2 = data.object_type_2;
				vm.formWizard.direction = data.direction;
				vm.formWizard.deal_type = data.deal_type;
				vm.formWizard.source_id = data.source_id;
				vm.formWizard.rentcost = parseInt(data.rentcost);
				vm.formWizard.rent_duration = data.rent_duration;
				vm.formWizard.pay_duration = data.pay_duration;
				vm.formWizard.cost = parseInt(data.cost);
				vm.formWizard.commission = parseFloat(data.commission);
				vm.formWizard.commission_type = data.commission_type;
				vm.formWizard.rooms_number = data.rooms_number;
				vm.formWizard.story_count = parseInt(data.story_count);
				vm.formWizard.tech_4 = data.tech_4;
        vm.formWizard.from_mcad = parseInt(data.from_mcad);
				vm.formWizard.tech_8 = data.tech_8;
				vm.formWizard.furniture = data.furniture;
				vm.formWizard.repairs = data.repairs;
				vm.formWizard.balcony = data.balcony;
				vm.formWizard.type_bild = data.type_bild;
				vm.formWizard.inet = data.inet;
				vm.formWizard.phone = data.phone;
				vm.formWizard.square_land = parseFloat(data.square_land);
				vm.formWizard.square_living = parseFloat(data.square_living);
				vm.formWizard.description = data.description;
				vm.formWizard.description_en = data.description_en;
				vm.formWizard.creator_id = data.creator_id;
				vm.formWizard.owner_id = parseInt(data.owner_id);
        vm.formWizard.client_id = parseInt(data.client_id);
				vm.formWizard.avito = parseInt(data.avito);


                vm.formWizard.auction = parseInt(data.auction);
                vm.formWizard.auction_title = data.auction_title;
                vm.formWizard.xml_cian = parseInt(data.xml_cian);
                vm.formWizard.xml_yandex = parseInt(data.xml_yandex);
                vm.formWizard.xml_domclick = parseInt(data.xml_domclick);
                vm.formWizard.only_winner = parseInt(data.only_winner);
                vm.formWizard.only_cian = parseInt(data.only_cian);
				vm.formWizard.cian_prem = parseInt(data.cian_prem);
				vm.formWizard.avito_turbo = parseInt(data.avito_turbo);


        vm.formWizard.only_winner = parseInt(data.only_winner);
        vm.formWizard.only_cian = parseInt(data.only_cian);
				vm.formWizard.avito_turbo = parseInt(data.avito_turbo);
        vm.formWizard.linktour = data.linktour;


        vm.formWizard.bathhouse = data.bathhouse;
        vm.formWizard.socle = data.socle;
        vm.formWizard.erker = data.erker;
        vm.formWizard.garret = data.garret;
        vm.formWizard.count_garage = data.count_garage;
        vm.formWizard.pool = data.pool;
        vm.formWizard.energi_garage = data.energi_garage;
        vm.formWizard.garage_type = data.garage_type;
        vm.formWizard.enegi = data.enegi;
        vm.formWizard.heating = data.heating;
        vm.formWizard.type_bathroom = data.type_bathroom;
        vm.formWizard.water_on_item = data.water_on_item;
        vm.formWizard.gas_item = data.gas_item
        vm.formWizard.sewage_item = data.sewage_item;
        vm.formWizard.earthsq = parseInt(data.earthsq);

        //выносим, чтобы получить полный список клиентов (свои + клиент по объекту)
        api.contacts.my_clients.query({'id':vm.objectId}, function(data) {
          vm.my_clients = data;
        });
		});

		vm.table = {
		  columns: [
			{
			  "title": "Фотография"
			},
			{
			  "title": "Размер"
			},
			{
			  "title": ""
			}
		  ],
		  dtOptions: {
				dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
				pagingType: 'simple',
				autoWidth : false,
				responsive: true,
				pageLength: 100,
				searching: false,
				oLanguage: {
					sUrl:"/assets/datatables.lang"
				},
				"columns": [
					{ "orderable": false },
					{ "orderable": false }
				  ],
				  "order": [0, "desc"]
		  }
		};

		updatePhotos(false);

        // Methods
        vm.sendForm = sendForm;
		vm.loadDistricts = loadDistricts;
		vm.loadCities = loadCities;
		//vm.loadStreets = loadStreets;
		vm.loadAddress = loadAddress;
		vm.updatePhotos = updatePhotos;
		vm.successLoadPhotosMessage = successLoadPhotosMessage;
		vm.removePhoto = removePhoto;
		vm.setMainPhoto = setMainPhoto;

		vm.total = 0;
		vm.dtInstance = {};

    vm.dtIntanceCallback = function (instance) {
			vm.dtInstance = instance;
		}

		//устанавливаем фотографию главной
		function setMainPhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var mainphoto = new api.objects.mainphoto();
					mainphoto.id = id;
					mainphoto.$save();

					vm.mainImage = id;

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография помечена как главная</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//////////удаление фотографии
		function removePhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var archivephoto = new api.objects.archivephoto();
					archivephoto.id = id;
					archivephoto.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        //обновляем список фотографий и таблицу сразу после загрузки
			                  updatePhotos();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография удалена</h1><div>Она исчезнет в таблице фотографий после сохранения изменений в объекте</div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//////////обновление таблицы фотографий
    //////////обновление таблицы фотографий
    function updatePhotos(rotated)
        {
        rotated = typeof rotated !== 'undefined' ? rotated : 1;

        api.objects.objectphotosbyid.query({'id':vm.objectId}, function(data) {
            vm.photos = data.data;
            vm.total = vm.photos.length;
            //меняем адреса изображений
            for(var i=0; i < vm.photos.length;i++){
              //замена на адреса, как на сервере
              if (vm.photos[i].rotated == 1 || rotated==1) {
                  vm.photos[i].filename = api.domain_name + api.domain_images + vm.photos[i].filename + '?rand=' + Math.round(Math.random() * (1000 - 1) + 1);
              } else {
                  vm.photos[i].filename = api.domain_name + api.domain_images + vm.photos[i].filename;
              }
            }
        });
    }
		//Сообщение, что фото загружены
		function successLoadPhotosMessage()
        {
			$mdDialog.show({
					controller         : function ($scope, $mdDialog)
					{
						$scope.closeDialog = function ()
						{
							$mdDialog.hide();
							//обновляем список фотографий и таблицу сразу после загрузки
							updatePhotos();
						}
					},
					template: '<md-dialog>' +
					'  <md-dialog-content><h1>Фотографии успешно добавлены</h1></md-dialog-content>' +
					'  <md-dialog-actions>' +
					'    <md-button ng-click="closeDialog()" class="md-primary">' +
					'      Закрыть' +
					'    </md-button>' +
					'  </md-dialog-actions>' +
					'</md-dialog>',
					parent             : angular.element('body'),
					clickOutsideToClose: true
				});
		}
        //////////первоначальная загрузка адреса редактируемого объекта
        function loadAddress()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
				vm.districts = data;
				//vm.formWizard.district = id;
					var index_district = 0;
					//определяем реальный порядковый номер в массиве
					for (var i = 0; i < vm.districts.length; i++)
						if (vm.districts[i]['id'] == vm.formWizard.district) {
							index_district = i;
							api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
								vm.cities = data;
                //при загрузке страницы (только при редактировании) узнаем обязательна ли улица
                vm.isStreetRequired();
							});
					}
				});
		}
    //////////оставляем те же функции, что и при создании
    function loadDistricts()
    {
  api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
    vm.districts = data;
    //обнуляем все, что ниже иерархически
    vm.cities = {};
    vm.streets = {};
    //делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
    vm.formWizard.district = null;
    vm.formWizard.city = null;
    //очищаем улицу
    vm.formWizard.street = null;
    vm.searchStreet = '';

    vm.formWizard.house_number = null;
    //для Москвы выбираем любой район, так как район города необязателен
    if (vm.formWizard.region == 1) {
      vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
      loadCities();
      }
    });
}

function loadCities()
  {
  //делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
    vm.formWizard.city = null;
    //очищаем улицу
    vm.formWizard.street = '';
    vm.searchStreet = '';

    vm.formWizard.house_number = null;

  if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
    vm.cities = {};
  } else {
    var index_district = 0;
    //определяем реальный порядковый номер в массиве
    for (var i = 0; i < vm.districts.length; i++)
      if (vm.districts[i]['id'] == vm.formWizard.district) {
        index_district = i;
        api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
          vm.cities = data;
          });
    }
  }
  vm.streets = {};
}

    ////////////////////////
    //Поворот фотографий
    vm.rotatePhoto  = function (filename,angle) {
      var rotatephoto = new api.objects.rotatephoto();
      rotatephoto.name = filename;
      rotatephoto.angle = angle;
      rotatephoto.$save();
      //обновляем список
      updatePhotos(1);
    }

    ///////////////////////
    vm.searchStreet = "";

    //функция вывода списка улиц
    vm.searchStreetResult = function (str) {
      //ищем хотя бы после 3 введенных символов, чтобы не показывать большие объемы улиц
      if (vm.searchStreet.length>2) {
        var index_city = 0;
        //так как города из КЛАДР и внутренних идентификаторов в массиве нет,
        //то ищем номер в массиве и узнаем его код КЛАДР

        for (var i = 0; i < vm.cities.length; i++)
          if (vm.cities[i]['name'] == vm.formWizard.city) {
            index_city = i;
            //стандартная загрузка через resource/http в контроллере не возвращает результат сразу же
            //dropdown обновляется на шаг позже - решено при помощи создания фабрики в модуле
            return GetStreetService.getStreets(vm.cities[index_city].code, str);
        }
      }
    }

    //если в директиве слушать напрямую изменение выбранной улицы, то
    //функция срабатывает до изменения параметра в этой функции
    //selectedItemChange() срабатывает позже непосредственной замены vm.selectedItem
    //поэтому Blur срабатывает один раз даже когда введена улица из списка

    //если объект создается
    //vm.streetFromListWhenSelected = false;
    //если объект редактируется - улица уже введена
    vm.streetFromListWhenSelected = true;

    //при выборе нового значения изменяем значение в модели для отправки
    vm.selectedItemChange = function () {
      if (typeof(vm.selectedItem)=='object' && vm.selectedItem!=null) {

        vm.formWizard.street = vm.selectedItem.value;
        //улица выбрана из списка
        //так как в formWizard не работают ngMessages, то проверка идет после потери
        //фокуса поля Улица
        vm.streetFromListWhenSelected = true;
      } else {
        //улица не из списка
      }
    }

    vm.searchStringChange = function (text) {
      //если текст вообще введен
      if (text!==null) {
        //при любом изменении вводимого в улицу текста помечаем, что улица выбрана не из списка
        vm.streetFromList = false;
        vm.streetFromListWhenSelected = false;
      }
    }

    //делает поле обязательным, если в нас. пункте есть улицы по базе КЛАДР
    vm.isStreetRequired = function () {
      var index_city = 0;
      //так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
      //его код КЛАДР
      for (var i = 0; i < vm.cities.length; i++)
        if (vm.cities[i]['name'] == vm.formWizard.city) {
          index_city = i;
          api.objects.count_streets.query({'code':vm.cities[index_city].code}, function(data) {
            vm.street_qty = data[0].qty;
            //console.log('В данном населенном пункте '+vm.street_qty+' улиц');
          });
      }
      //очищаем улицу
      vm.formWizard.street = null;
    }


        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;

					var editobject = new api.objects.editobjectdata();
					editobject.data = formWizardData;
					editobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/suburbian');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект успешно изменен</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}

	///////////////////////Загрузка фотографий
	var hideUpload = false; //переменная для сокрытия кнопки загрузки после одной загрузки (чтобы не заливали одно и то же, пока нет онлайн обновления таблицы)
	var uploader = $scope.uploader = new FileUploader({
			//инкапсулируем скрипт загрузки в общий модуль, чтобы проверять авторизацию
            url: api.localhost_backend + 'upload',
            removeAfterUpload: true,
			formData: {'id':vm.objectId}
        });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 21;
            }
        });


        // File must not be larger then some size
        uploader.filters.push({ name: 'sizeFilter', fn: function(item) {
           return item.size < 1024*1024*2.5;
        }});


        //События Callbacks
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
            alert("Один или несколько файлов имеют размер больше 2.5 Мб!");
        };
        uploader.onAfterAddingFile = function(fileItem) {
            console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
			hideUpload = true;
            console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function(item) {
            console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            console.info('onCompleteAll');
            updatePhotos();
        };
        console.info('uploader', uploader);

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editflatrent', ['datatables','ngResource','angularFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_editflatrent', {
            url    : '/objects/edit/flatrent/{id:int}',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/editobject/editflatrent/editflatrent.html',
                    controller : 'EditFlatRentController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }




})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editflatrent')
        .controller('EditFlatRentController', EditFlatRentController);

    /** @ngInject */
    function EditFlatRentController($rootScope, $scope, $mdDialog, $location, GetStreetService, $resource, FileUploader, api)
    {
        var vm = this;
        // Data
        vm.formWizard = {};


		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
		//типы населенных пунктов
        vm.city_types = [{'socr': 'г', 'name': 'город'},
						{'socr': 'г.о.', 'name': 'городской округ'},
						{'socr': 'п', 'name': 'поселение/поселок'},
						{'socr': 'дп', 'name': 'дачный поселок'},
						{'socr': 'кп', 'name': 'курортный поселок'},
						{'socr': 'пгт', 'name': 'поселок городского типа'},
						{'socr': 'рп', 'name': 'рабочий поселок'},
						{'socr': 'с/п', 'name': 'сельское поселение'},
						{'socr': 'д', 'name': 'деревня'},
						{'socr': 'с', 'name': 'село'},
						{'socr': 'сл', 'name': 'слобода'},
						{'socr': 'снт', 'name': 'СНТ'},
						{'socr': 'жилрайон', 'name': 'жилой район'},
						{'socr': 'кв-л', 'name': 'квартал'},
						{'socr': 'мкр', 'name': 'микрорайон'},
						{'socr': 'нп', 'name': 'населенный пункт'},
						{'socr': 'тер', 'name': 'территория'},
						{'socr': 'промзона', 'name': 'промышленная зона'}];

		//названия нас.пунктов и улицы подгружаем после выбора
		vm.districts = {};
		vm.cities = {};
		vm.streets = {};

		//Список метро и направлений
		api.objects.metrostations.query({}, function(data) {
				vm.metrostations = data;
        //страховка
        vm.loadMetrostationsName();
				});

		api.objects.directions.query({}, function(data) {
				vm.directions = data;
				});

		vm.metro_time_list = [{'name': 'f_2', 'rusname': '2 минуты пешком'},
						{'name': 'f_5', 'rusname': '5 минут пешком'},
						{'name': 'f_7', 'rusname': '7 минут пешком'},
						{'name': 'f_10', 'rusname': '10 минут пешком'},
						{'name': 'f_15', 'rusname': '15 минут пешком'},
						{'name': 'f_20', 'rusname': '20 минут пешком'},
						{'name': 't_5', 'rusname': '5 минут транспортом'},
						{'name': 't_10', 'rusname': '10 минут транспортом'},
						{'name': 't_15', 'rusname': '15 минут транспортом'},
						{'name': 't_20', 'rusname': '20 минут транспортом'}];

		//тип объекта
		vm.object_types = [{'name': 'flat', 'rusname': 'Квартира'},
            {'name': 'apartments', 'rusname': 'Апартаменты'},
						{'name': 'flat_new_building', 'rusname': 'Квартира в новостройке'},
						{'name': 'room', 'rusname': 'Комната'},
						{'name': 'part', 'rusname': 'Доля в квартире'},
						{'name': 'penthouse', 'rusname': 'Пентхаус'}];

    //тип объекта 2
		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'},
						{'name': 'hog-wash', 'rusname': 'Утка'},
						{'name': 'auction', 'rusname': 'Аукцион'},
						{'name': 'invest', 'rusname': 'Инвестиционный'}];

		//источник
		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'},
						{'id': '2', 'rusname': 'Расклейка'},
						{'id': '3', 'rusname': 'Баннер'},
						{'id': '4', 'rusname': 'Рекомендация'},
						{'id': '5', 'rusname': 'База собственников'},
						{'id': '6', 'rusname': 'База заявок'},
						{'id': '7', 'rusname': 'Диспетчерская'},
						{'id': '8', 'rusname': 'Avito'},
						{'id': '9', 'rusname': 'Другие сайты'},
						{'id': '10', 'rusname': 'Сам нашел'}];

        // Предоплата, от 1 до 12 месяцев
		vm.class_bilds = [{'name': '1', 'rusname': '1'},
						{'name': '2', 'rusname': '2'},
						{'name': '3', 'rusname': '3'},
						{'name': '4', 'rusname': '4'},
						{'name': '5', 'rusname': '5'},
						{'name': '6', 'rusname': '6'},
						{'name': '7', 'rusname': '7'},
						{'name': '8', 'rusname': '8'},
						{'name': '9', 'rusname': '9'},
						{'name': '10', 'rusname': '10'},
						{'name': '11', 'rusname': '11'},
						{'name': '12', 'rusname': '12'}];
		vm.formWizard.class_bild = '1';

		//тип комиссии
		vm.commission_types = [{'name': 'percent', 'rusname': '%'},
						{'name': 'sum', 'rusname': 'руб.'}];


		//типы сделок
		vm.deal_types = [{'name': 'rent', 'rusname': 'Аренда'},
						{'name': 'change', 'rusname': 'Альтернатива'},
						{'name': 'sale', 'rusname': 'Продажа'},
            {'name': 'dupt', 'rusname': 'Переуступка'}];

        vm.rent_durations = [{'name': 'short', 'rusname': 'Несколько месяцев'},
						{'name': 'long', 'rusname': 'Длительный срок'},
						{'name': 'day', 'rusname': 'Посуточно'}];

		vm.pay_durations = [{'name': 'month', 'rusname': 'ежемесячно'},
							{'name': 'day', 'rusname': 'посуточно'}];

        //типы комнат для квартиры
        vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'},
						{'name': '2', 'rusname': 'Двухкомнатная'},
						{'name': '3', 'rusname': 'Трехкомнатная'},
						{'name': '4', 'rusname': 'Четырехкомнатная'},
						{'name': '5', 'rusname': 'Пятикомнатная'},
						{'name': 'm', 'rusname': 'Многокомнатная'},
						{'name': 'studio', 'rusname': 'Студия'},
			            {'name': '1_2', 'rusname': 'Комната в двухкомнатной'},
						{'name': '1_3', 'rusname': 'Комната в трехкомнатной'},
						{'name': '1_4', 'rusname': 'Комната в четырехкомнатной'},
						{'name': '1_5', 'rusname': 'Комната в пятикомнатной'},
						{'name': '2_3', 'rusname': '2 комнаты в трехкомнатной'},
						{'name': '2_4', 'rusname': '2 комнаты в четырехкомнатной'},
						{'name': '2_5', 'rusname': '2 комнаты в пятикомнатной'},
						{'name': '3_4', 'rusname': '3 комнаты в четырехкомнатной'},
						{'name': '3_5', 'rusname': '3 комнаты в пятикомнатной'}];


    vm.int_cian_array = [{'name': '0', 'rusname': 'Нет'},
      {'name': '1', 'rusname': 'Да'},
    {'name': '2', 'rusname': 'Highlight'},
    {'name': '3', 'rusname': 'Premium'},
    {'name': '4', 'rusname': 'Top3'}];
    
    vm.tech_8_array = [{'name': '1', 'rusname': '1'},
    {'name': '2', 'rusname': '2'},
    {'name': '3', 'rusname': '3'},
    {'name': '4', 'rusname': '4'}];

    vm.int_avito_array = [{'name': '0', 'rusname': 'Нет'},
      {'name': '1', 'rusname': 'Package'},
    {'name': '2', 'rusname': 'PackageSingle'},
  {'name': '3', 'rusname': 'Single'}];

  vm.int_avitoserv_array = [{'name': '0', 'rusname': 'Нет'},
    {'name': '2', 'rusname': 'Free'},
  {'name': '3', 'rusname': 'Premium'},
  {'name': '4', 'rusname': 'VIP'},
  {'name': '5', 'rusname': 'PushUp'},
  {'name': '6', 'rusname': 'Highlight'},
  {'name': '1', 'rusname': 'TurboSale'},
  {'name': '7', 'rusname': 'QuickSale'},
  {'name': '8', 'rusname': 'x2_1'},
  {'name': '9', 'rusname': 'x2_7'},
  {'name': '10', 'rusname': 'x5_1'},
  {'name': '11', 'rusname': 'x5_7'},
  {'name': '12', 'rusname': 'x10_1'},
  {'name': '13', 'rusname': 'x10_7'}];

		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'no', 'rusname': 'Нет'}];
		vm.int_yes_no_array = [{'name': '1', 'rusname': 'Есть'},
							{'name': '0', 'rusname': 'Нет'}];
		//телефон
		vm.phone_types = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'para', 'rusname': 'Спаренный'},
						{'name': 'possible', 'rusname': 'Возможно подключить'},
						{'name': 'no', 'rusname': 'Нет'}];

        //окна
		vm.windows_type = [{'name': 'yard', 'rusname': 'Двор'},
						{'name': 'street', 'rusname': 'Улица'},
						{'name': 'both', 'rusname': 'Двор и улица'}];

		//кондиционер
		vm.furniture_types = [{'name': 'yes', 'rusname': 'Да'},
						{'name': 'no', 'rusname': 'Нет'}];
		vm.formWizard.furniture = 'no';



		//ремонт // Капитальный
		vm.repairs_types = [{'name': 'no', 'rusname': 'Без ремонта'},
						{'name': 'cosmetic', 'rusname': 'Косметический'},
						{'name': 'capital', 'rusname': 'Дизайнерский'},
						{'name': 'euro', 'rusname': 'Евро'}];

		vm.formWizard.repairs = 'cosmetic';

		//типы санузла
		vm.types_bathroom = [{'name': 'separated', 'rusname': 'Раздельный'},
						{'name': 'combined', 'rusname': 'Совмещенный'}];

		//парковка
		vm.types_parking = [{'name': 'ground', 'rusname': 'Наземная'},
	                    	{'name': 'multilevel', 'rusname': 'Многоуровневая'},
	                    	{'name': 'open', 'rusname': 'Открытая'},
		                    {'name': 'roof', 'rusname': 'На крыше'},
				    		{'name': 'underground', 'rusname': 'Подземная'}];

		//право собственности
		vm.ownership_types = [{'name': 'primary', 'rusname': 'Первичная приватизация'},
						{'name': 'contract-sales', 'rusname': 'Договор купли/продажи'},
						{'name': 'contract-donat', 'rusname': 'Договор дарения'},
						{'name': 'contract-rent', 'rusname': 'Договор ренты'},
						{'name': 'paid', 'rusname': 'ЖСК, выплаченный пай'},
						{'name': 'legacy', 'rusname': 'Наследство'},
						{'name': 'court', 'rusname': 'Решение суда'},
						{'name': 'mortgage', 'rusname': 'Залог (ипотека)'},
						{'name': 'invest', 'rusname': 'По договору инвестирования'},
						{'name': 'contract-meni', 'rusname': 'Договор мены'}];
		//Тип дома
		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
						{'name': 'panel', 'rusname': 'Панельный'},
						{'name': 'brick', 'rusname': 'Кирпичный'},
						{'name': 'wood', 'rusname': 'Деревянный'},
						{'name': 'stalin', 'rusname': 'Сталинский'},
						{'name': 'monolith', 'rusname': 'Монолит'},
						{'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'}];

    // Ипотека (Статус)
		vm.flat_status_types = [{'name': 'yes', 'rusname': 'Да'},
					          	{'name': 'no', 'rusname': 'Нет'}];
					//	{'name': 'patrol', 'rusname': 'Расселение/разъед'},
						//  {'name': 'alternate', 'rusname': 'Альтернатива'},
          //  {'name': 'courtdesicion', 'rusname': 'Прописан по решению суда'}];


		//Лифт
		vm.lift_types = [{'name': 'pass', 'rusname': 'Пассажирский'},
						{'name': 'serv', 'rusname': 'Грузовой'},
						{'name': 'passserv', 'rusname': 'Пасс. + груз.'},
            {'name': '2pass1serv', 'rusname': '2 Пасс. + груз.'},
            {'name': '1pass2serv', 'rusname': 'Пасс. + 2 груз.'},
            {'name': '2pass2serv', 'rusname': '2 пасс. + 2 груз.'},
            {'name': '2pass', 'rusname': '2 пассажирских'},
						{'name': '2serv', 'rusname': '2 грузовых'},
						{'name': 'no', 'rusname': 'Нет'}];
		//Балкон
		vm.balcony_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'loggia', 'rusname': 'Лоджия'},
						{'name': '2balcon', 'rusname': '2 балкона'},
						{'name': '2loggia', 'rusname': '2 лоджии'}];
		//В собственности
		vm.years_own_types = [{'name': 'less3', 'rusname': 'Менее 3 лет'},
						{'name': 'more3', 'rusname': 'Более 3 лет'}];


      //получаем id своей учетной записи для сверки собственности на объект
      /*api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
        vm.userid = data.user_id;
      });*/
      vm.users_in_group = [];
      //узнаем свою должность
      //api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
        //vm.positionid = data.position_id;
        //console.log(vm.positionid);

        //Если НОП, то подгружаем список своих
        //if (vm.positionid == 1 || )
        //если есть право редактировать агента в объекте
        if ($rootScope.checkRule(59,'all')) {
          //получаем id своего отдела
          api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
            vm.groupid = data.group_id;
            //получаем список
            api.contacts.usersbygroup.get({id:vm.groupid}, function(data) {
              for (var i=0;i<data.data.length;i++) {
                vm.users_in_group.push(data.data[i]);
              }
              //console.log('i am nop of '+vm.groupid);
              //console.log(vm.users_in_group);
            });
          });
        }
      //});

      //добавляем в список агентов текущего агента по объекту (если для НОПа уже подгружен список, то не добавляем)
      if (vm.users_in_group.length>0) {
        var checkInArray = false;

        for (var i=0;i<vm.users_in_group.length;i++) {
          //TODO эта часть кода выполняется по факту после загрузки данных
          //странный реверс - рахобраться в причинах
          vm.users_in_group[i].id = parseInt(vm.users_in_group[i].id);
          if (vm.users_in_group[i].id == vm.formWizard.owner_id) {
            checkInArray = true;
            //break;
          }
        }
        if (!checkInArray) {
          api.contacts.usernamebyid.get({id:vm.formWizard.owner_id}, function(data) {
            //vm.object_agent = data.name;
            //console.log(data);
            vm.users_in_group.push({'id': vm.formWizard.owner_id, 'name': data.data });
          });
        }
      }
      vm.formWizard.owner_id = vm.formWizard.owner_id;
      //console.log(vm.users_in_group);

        //получаем id объекта, который будем редактировать
        vm.objectId = $location.path().split('/');
        vm.objectId = vm.objectId[vm.objectId.length-1];
        //id главного изображения
        vm.mainImage = 0;
        //информацию по объекту
		api.objects.objectbyid.query({'id':vm.objectId}, function(data) {
				//console.log(data);
				vm.formWizard.region = parseInt(data.region);
				vm.formWizard.district = parseInt(data.district);
				vm.formWizard.city_type = data.city_type;
				vm.formWizard.city = data.city;

        vm.selectedItem = data.street;
				vm.formWizard.street = data.street;
				vm.formWizard.house_number = data.house_number;
        vm.formWizard.flat_number = data.flat_number;
				//загружаем адрес полностью
				loadAddress();
				//id главного изображения
				vm.mainImage = (parseInt(data.image)==0)?0:data.image;

				vm.formWizard.object_type = data.object_type;
				vm.formWizard.object_type_2 = data.object_type_2;
				vm.formWizard.direction = parseInt(data.direction);
        vm.formWizard.flats_apartmentscomplex = data.flats_apartmentscomplex;
				vm.formWizard.metro_1 = data.metro_1;
				vm.formWizard.metro_2 = data.metro_2;
				vm.formWizard.metro_3 = data.metro_3;
				vm.formWizard.metro_1_time = data.metro_1_time;
				vm.formWizard.metro_2_time = data.metro_2_time;
				vm.formWizard.metro_3_time = data.metro_3_time;
        vm.loadMetrostationsName();

				vm.formWizard.deal_type = data.deal_type;
				vm.formWizard.source_id = data.source_id;
				vm.formWizard.part_percent = data.part_percent;
				vm.formWizard.rentcost = parseInt(data.rentcost);
				vm.formWizard.rent_duration = data.rent_duration;
				vm.formWizard.pay_duration = data.pay_duration;
				vm.formWizard.cost = parseInt(data.cost);
				vm.formWizard.commission = parseFloat(data.commission);
				vm.formWizard.commission_type = data.commission_type;
				vm.formWizard.rooms_number = data.rooms_number;
				vm.formWizard.story = parseInt(data.story);
				vm.formWizard.story_count = parseInt(data.story_count);
				vm.formWizard.tech_4 = data.tech_4;
        vm.formWizard.from_mcad = parseInt(data.from_mcad);
				vm.formWizard.tech_8 = data.tech_8;
				vm.formWizard.furniture = data.furniture;
				vm.formWizard.repairs = data.repairs;
				vm.formWizard.flat_status = data.flat_status;
				vm.formWizard.years_own = data.years_own;
				vm.formWizard.balcony = data.balcony;
				vm.formWizard.ownership = data.ownership;
				vm.formWizard.type_bild = data.type_bild;
				vm.formWizard.lift = data.lift;
				vm.formWizard.type_bathroom = data.type_bathroom;
				vm.formWizard.count_bathroom_flat = data.count_bathroom_flat;
				vm.formWizard.inet = data.inet;
				vm.formWizard.phone = data.phone;

				vm.formWizard.officesq_stock = data.officesq_stock;
				vm.formWizard.class_bild = data.class_bild;
				vm.formWizard.usefulsq_stock = data.usefulsq_stock;
				vm.formWizard.bordersq_stock = data.bordersq_stock;
				vm.formWizard.tv = data.tv;

        vm.formWizard.windows = data.windows;
				vm.formWizard.square_all = parseFloat(data.square_all);
				vm.formWizard.square_living = parseFloat(data.square_living);
				vm.formWizard.square_kitchen = parseFloat(data.square_kitchen);
				vm.formWizard.square_rooms = data.square_rooms;
				vm.formWizard.description = data.description;
				vm.formWizard.description_en = data.description_en;
				vm.formWizard.creator_id = data.creator_id;
				vm.formWizard.owner_id = parseInt(data.owner_id);
        vm.formWizard.client_id = parseInt(data.client_id);
				vm.formWizard.avito = parseInt(data.avito);
        vm.formWizard.auction = parseInt(data.auction);
        vm.formWizard.auction_title = data.auction_title;
        vm.formWizard.xml_cian = parseInt(data.xml_cian);
        vm.formWizard.xml_yandex = parseInt(data.xml_yandex);
        vm.formWizard.xml_domclick = parseInt(data.xml_domclick);
        vm.formWizard.only_winner = parseInt(data.only_winner);
        vm.formWizard.only_cian = parseInt(data.only_cian);
				vm.formWizard.cian_prem = parseInt(data.cian_prem);
				vm.formWizard.avito_turbo = parseInt(data.avito_turbo);
        vm.formWizard.linktour = data.linktour;

        //выносим, чтобы получить полный список клиентов (свои + клиент по объекту)
        api.contacts.my_clients.query({'id':vm.objectId}, function(data) {
          vm.my_clients = data;
        });
		});

		vm.table = {
		  columns: [
			{
			  "title": "Фотография"
			},
			{
			  "title": "Размер"
			}
		  ],
		  dtOptions: {
				dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
				pagingType: 'simple',
				autoWidth : false,
				responsive: true,
				pageLength: 100,
				searching: false,
				oLanguage: {
					sUrl:"/assets/datatables.lang"
				},
				"columns": [
					{ "orderable": false },
					{ "orderable": false }
				  ],
				  "order": [0, "desc"]
		  }
		};
		updatePhotos();

        // Methods
    vm.sendForm = sendForm;
		vm.loadDistricts = loadDistricts;
		vm.loadCities = loadCities;
		//vm.loadStreets = loadStreets;
		vm.changeRoomTypes = changeRoomTypes;
		vm.changeFlatStatuses = changeFlatStatuses;
		vm.loadAddress = loadAddress;
		vm.updatePhotos = updatePhotos;
		vm.successLoadPhotosMessage = successLoadPhotosMessage;
		vm.removePhoto = removePhoto;
		vm.setMainPhoto = setMainPhoto;

    changeFlatStatuses();

  	vm.total = 0;
		vm.dtInstance = {};

    vm.dtIntanceCallback = function (instance) {
			vm.dtInstance = instance;
		}
		
    vm.upPhoto  = function (photo) {
      var photoIndex = photo.position - 1;
      var tempPhotos = vm.photos.slice();

      var UpPhoto = vm.photos[photoIndex];
      var DownPhoto = vm.photos[photoIndex - 1];
      UpPhoto.position = UpPhoto.position - 1;
      DownPhoto.position = DownPhoto.position + 1;

      delete tempPhotos[photoIndex];
      delete tempPhotos[photoIndex - 1];

      tempPhotos[photoIndex] = DownPhoto;
      tempPhotos[photoIndex - 1] = UpPhoto;

      /*
      // меняем текуший элемент на предыдущий и устанавливаем ему позицию переданного
      tempPhotos[photo.position - 1] = tempPhotos[photo.position - 2];
      tempPhotos[photo.position - 1].position = photo.position;
      // меняем предыдущий элемент на переданный и устанавливаем ему позицию на 1 меньше
      tempPhotos[photo.position - 2] = vm.photos[photo.position - 1];
      tempPhotos[photo.position - 2].position = photo.position - 1;
      console.log('upPhoto', photo, vm.photos, tempPhotos);
      */
      vm.photos = tempPhotos;

      var spp = new api.objects.setpositionphoto();
      spp.positions = tempPhotos.map(function(x) { return {id: x.id, position: x.position};});
      spp.$save();
    }

    vm.downPhoto  = function (photo) {
      var photoIndex = photo.position - 1;
      var tempPhotos = vm.photos.slice();

      var DownPhoto = vm.photos[photoIndex];
      var UpPhoto = vm.photos[photoIndex + 1];
      UpPhoto.position = UpPhoto.position - 1;
      DownPhoto.position = DownPhoto.position + 1;

      delete tempPhotos[photoIndex];
      delete tempPhotos[photoIndex + 1];

      tempPhotos[photoIndex] = UpPhoto;
      tempPhotos[photoIndex + 1] = DownPhoto;

      vm.photos = tempPhotos;
      var spp = new api.objects.setpositionphoto();
      spp.positions = tempPhotos.map(function(x) { return {id: x.id, position: x.position};});
      spp.$save();
    }
		
		
		
		
		

		//устанавливаем фотографию главной
		function setMainPhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var mainphoto = new api.objects.mainphoto();
					mainphoto.id = id;
					mainphoto.$save();

					vm.mainImage = id;

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография помечена как главная</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//////////удаление фотографии
		function removePhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var archivephoto = new api.objects.archivephoto();
					archivephoto.id = id;
					archivephoto.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        //обновляем список фотографий и таблицу сразу после загрузки
	                      updatePhotos();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография удалена</h1><div>Она исчезнет в таблице фотографий после сохранения изменений в объекте</div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//////////обновление таблицы фотографий
    function updatePhotos(rotated)
        {
        rotated = typeof rotated !== 'undefined' ? rotated : 1;

        api.objects.objectphotosbyid.query({'id':vm.objectId}, function(data) {
            vm.photos = data.data;
            vm.total = vm.photos.length;
            //меняем адреса изображений
            for(var i=0; i < vm.photos.length;i++){
              //замена на адреса, как на сервере
              if (vm.photos[i].rotated == 1 || rotated==1) {
                  vm.photos[i].filename = api.domain_name + api.domain_images + vm.photos[i].filename + '?rand=' + Math.round(Math.random() * (1000 - 1) + 1);
              } else {
                  vm.photos[i].filename = api.domain_name + api.domain_images + vm.photos[i].filename;
              }
            }
        });
    }
		//Сообщение, что фото загружены
		function successLoadPhotosMessage()
        {
			$mdDialog.show({
					controller         : function ($scope, $mdDialog)
					{
						$scope.closeDialog = function ()
						{
							$mdDialog.hide();
							//обновляем список фотографий и таблицу сразу после загрузки
							updatePhotos();
						}
					},
					template: '<md-dialog>' +
					'  <md-dialog-content><h1>Фотографии успешно добавлены</h1></md-dialog-content>' +
					'  <md-dialog-actions>' +
					'    <md-button ng-click="closeDialog()" class="md-primary">' +
					'      Закрыть' +
					'    </md-button>' +
					'  </md-dialog-actions>' +
					'</md-dialog>',
					parent             : angular.element('body'),
					clickOutsideToClose: true
				});
		}
        //////////первоначальная загрузка адреса редактируемого объекта
        function loadAddress()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
				vm.districts = data;
				//vm.formWizard.district = id;
					var index_district = 0;
					//определяем реальный порядковый номер в массиве
					for (var i = 0; i < vm.districts.length; i++)
						if (vm.districts[i]['id'] == vm.formWizard.district) {
							index_district = i;
							api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
								vm.cities = data;
                //при загрузке страницы (только при редактировании) узнаем обязательна ли улица
                vm.isStreetRequired();
								/*var index_city = 0;
								//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
								//его код КЛАДР
								for (var i = 0; i < vm.cities.length; i++)
									if (vm.cities[i]['name'] == vm.formWizard.city) {
										index_city = i;*/

										//TODO оптимизировать загрузку улиц
										/*api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {
											vm.streets = data;
										});*/
								//}
							});
					}
				});
		}
        //////////оставляем те же функции, что и при создании
        function loadDistricts()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
				vm.districts = data;
				//обнуляем все, что ниже иерархически
				vm.cities = {};
				vm.streets = {};
				//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.district = null;
				vm.formWizard.city = null;
        //очищаем улицу
        vm.formWizard.street = null;
        vm.searchStreet = '';

				vm.formWizard.house_number = null;
        vm.formWizard.flat_number = null;
				//для Москвы выбираем любой район, так как район города необязателен
				if (vm.formWizard.region == 1) {
					vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
					loadCities();
					}
				});
		}

		function loadCities()
      {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.city = null;
        //очищаем улицу
        vm.formWizard.street = '';
        vm.searchStreet = '';

				vm.formWizard.house_number = null;
        vm.formWizard.flat_number = null;

			if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
				vm.cities = {};
			} else {
				var index_district = 0;
				//определяем реальный порядковый номер в массиве
				for (var i = 0; i < vm.districts.length; i++)
					if (vm.districts[i]['id'] == vm.formWizard.district) {
						index_district = i;
						api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
							vm.cities = data;
							});
				}
			}
			vm.streets = {};
		}


    ////////////////////////
    //Поворот фотографий
    vm.rotatePhoto  = function (filename,angle) {
      var rotatephoto = new api.objects.rotatephoto();
      rotatephoto.name = filename;
      rotatephoto.angle = angle;
      rotatephoto.$save();
      //обновляем список
      updatePhotos(1);
    }

    ///////////////////////
    vm.searchStreet = "";

    //функция вывода списка улиц
    vm.searchStreetResult = function (str) {
      //ищем хотя бы после 3 введенных символов, чтобы не показывать большие объемы улиц
      if (vm.searchStreet.length>2) {
        var index_city = 0;
        //так как города из КЛАДР и внутренних идентификаторов в массиве нет,
        //то ищем номер в массиве и узнаем его код КЛАДР

        for (var i = 0; i < vm.cities.length; i++)
          if (vm.cities[i]['name'] == vm.formWizard.city) {
            index_city = i;
            //стандартная загрузка через resource/http в контроллере не возвращает результат сразу же
            //dropdown обновляется на шаг позже - решено при помощи создания фабрики в модуле
            return GetStreetService.getStreets(vm.cities[index_city].code, str);
        }
      }
    }

    //если в директиве слушать напрямую изменение выбранной улицы, то
    //функция срабатывает до изменения параметра в этой функции
    //selectedItemChange() срабатывает позже непосредственной замены vm.selectedItem
    //поэтому Blur срабатывает один раз даже когда введена улица из списка

    //если объект создается
    //vm.streetFromListWhenSelected = false;
    //если объект редактируется - улица уже введена
    vm.streetFromListWhenSelected = true;

    //при выборе нового значения изменяем значение в модели для отправки
    vm.selectedItemChange = function () {
      if (typeof(vm.selectedItem)=='object' && vm.selectedItem!=null) {

        vm.formWizard.street = vm.selectedItem.value;
        //улица выбрана из списка
        //так как в formWizard не работают ngMessages, то проверка идет после потери
        //фокуса поля Улица
        vm.streetFromListWhenSelected = true;
      } else {
        //улица не из списка
      }
    }

    vm.searchStringChange = function (text) {
      //если текст вообще введен
      if (text!==null) {
        //при любом изменении вводимого в улицу текста помечаем, что улица выбрана не из списка
        vm.streetFromList = false;
        vm.streetFromListWhenSelected = false;
      }
    }

    //делает поле обязательным, если в нас. пункте есть улицы по базе КЛАДР
    vm.isStreetRequired = function () {
      var index_city = 0;
      //так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
      //его код КЛАДР
      for (var i = 0; i < vm.cities.length; i++)
        if (vm.cities[i]['name'] == vm.formWizard.city) {
          index_city = i;
          api.objects.count_streets.query({'code':vm.cities[index_city].code}, function(data) {
            vm.street_qty = data[0].qty;
            //console.log('В данном населенном пункте '+vm.street_qty+' улиц');
          });
      }
      //очищаем улицу
      vm.formWizard.street = null;
    }

    //автозаполнение поля метро
    vm.metroQuerySearch = function (query) {
      var lowercaseQuery = angular.lowercase(query);
      query = lowercaseQuery[0].toUpperCase() + lowercaseQuery.substr(1);

      var results = lowercaseQuery ? vm.metrostations.filter( createFilterFor(query) ) : vm.metrostations;
      return results;
    }
    //фильтр
    function createFilterFor(query) {
      return function filterFn(metro) {
        return (metro.name.indexOf(query) === 0);
      };
    }

    vm.loadMetrostationsName = function() {
      //определяем реальный порядковый номер в массиве
      //заполняем поля автозаполнения по метро
      var index_metro1 = 0;

      if (undefined !== vm.metrostations) {
        for (var i = 0; i < vm.metrostations.length; i++)
          if (vm.metrostations[i]['id'] == vm.formWizard.metro_1) {
            index_metro1 = i;
            vm.searchMetro_1 = vm.metrostations[i]['name'];
            break;
        }
        var index_metro2 = 0;
        for (var i = 0; i < vm.metrostations.length; i++)
          if (vm.metrostations[i]['id'] == vm.formWizard.metro_2) {
            index_metro2 = i;
            vm.searchMetro_2 = vm.metrostations[i]['name'];
            break;
        }

        var index_metro3 = 0;
        for (var i = 0; i < vm.metrostations.length; i++)
          if (vm.metrostations[i]['id'] == vm.formWizard.metro_3) {
            index_metro3 = i;
            vm.searchMetro_3 = vm.metrostations[i]['name'];
            break;
        }
      }
    }


    /*
    vm.selectMetro = function (item, field) {

      switch (field) {
        case 1: vm.formWizard.metro_1 = item; break;
        case 2: vm.formWizard.metro_2 = item; break;
        case 3: vm.formWizard.metro_3 = item; break;
        default:
        break;
      }
    }*/



    /*
		function loadStreets()
    {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
			vm.formWizard.street = null;
			vm.formWizard.house_number = null;

			if (!vm.formWizard.city) {
				vm.streets = {};
			} else {
				var index_city = 0;
				//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
				//его код КЛАДР
				for (var i = 0; i < vm.cities.length; i++)
					if (vm.cities[i]['name'] == vm.formWizard.city) {
						index_city = i;
						//TODO оптимизировать загрузку улиц
						api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {
							vm.streets = data;
						});
				}
			}
		}*/

		function changeFlatStatuses() {
		 if (vm.formWizard.deal_type == 'change') {
			 vm.flat_status_types = [{'name': 'yes', 'rusname': 'Да'},
		                        		{'name': 'no', 'rusname': 'Нет'}
                 ];
			  vm.formWizard.flat_status = 'alternate';
			} else {
			 vm.flat_status_types = [{'name': 'yes', 'rusname': 'Да'},
				{'name': 'no', 'rusname': 'Нет'}];
			}
		}


		//		function changeFlatStatuses() {
	//	 if (vm.formWizard.deal_type == 'change') {
	//		 vm.flat_status_types = [{'name': 'patrol', 'rusname': 'Расселение/разъед'},
									 //{'name': 'alternate', 'rusname': 'Альтернатива'}
     //            ];
	//		  vm.formWizard.flat_status = 'alternate';
	//		} else {
	//		 vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
	//			{'name': 'free', 'rusname': 'Свободна'},
	//			{'name': 'patrol', 'rusname': 'Расселение/разъед'},
     //   {'name': 'courtdesicion', 'rusname': 'Прописан по решению суда'}];
	//		}
	//	}

		function changeRoomTypes() {
			switch (vm.formWizard.object_type) {
				//типы комнат для квартиры, новостройки, пентхауса
				case 'flat_new_building': //doNothing
				case 'penthouse': //doNothing
				case 'flat': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'},
										{'name': '2', 'rusname': 'Двухкомнатная'},
										{'name': '3', 'rusname': 'Трехкомнатная'},
										{'name': '4', 'rusname': 'Четырехкомнатная'},
										{'name': '5', 'rusname': 'Пятикомнатная'},
										{'name': 'm', 'rusname': 'Многокомнатная'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
        case 'apartments': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатные'},
										{'name': '2', 'rusname': 'Двухкомнатные'},
										{'name': '3', 'rusname': 'Трехкомнатные'},
										{'name': '4', 'rusname': 'Четырехкомнатные'},
										{'name': '5', 'rusname': 'Пятикомнатные'},
										{'name': 'm', 'rusname': 'Многокомнатные'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
				case 'part': vm.rooms_type_list = [{'name': 'd_1', 'rusname': 'Доля в однокомнатной'},
										{'name': 'd_2', 'rusname': 'Доля в двухкомнатной'},
										{'name': 'd_3', 'rusname': 'Доля в трехкомнатной'},
										{'name': 'd_4', 'rusname': 'Доля в четырехкомнатной'},
										{'name': 'd_5', 'rusname': 'Доля в пятикомнатной'}];
										break
				case 'room': vm.rooms_type_list = [{'name': '1_2', 'rusname': 'Комната в двухкомнатной'},
										{'name': '1_3', 'rusname': 'Комната в трехкомнатной'},
										{'name': '1_4', 'rusname': 'Комната в четырехкомнатной'},
										{'name': '1_5', 'rusname': 'Комната в пятикомнатной'},
										{'name': '2_3', 'rusname': '2 комнаты в трехкомнатной'},
										{'name': '2_4', 'rusname': '2 комнаты в четырехкомнатной'},
										{'name': '2_5', 'rusname': '2 комнаты в пятикомнатной'},
										{'name': '3_4', 'rusname': '3 комнаты в четырехкомнатной'},
										{'name': '3_5', 'rusname': '3 комнаты в пятикомнатной'}];
										break
					  }
		}

        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;

					var editobject = new api.objects.editobjectdata();
					editobject.data = formWizardData;
					editobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flatsrent');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект успешно изменен</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}

	///////////////////////Загрузка фотографий
	var hideUpload = false; //переменная для сокрытия кнопки загрузки после одной загрузки (чтобы не заливали одно и то же, пока нет онлайн обновления таблицы)
	var uploader = $scope.uploader = new FileUploader({
			//инкапсулируем скрипт загрузки в общий модуль, чтобы проверять авторизацию
            url: api.localhost_backend + 'upload',
            removeAfterUpload: true,
			formData: {'id':vm.objectId}
        });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 20;
            }
        });

        // File must not be larger then some size
        uploader.filters.push({ name: 'sizeFilter', fn: function(item) {
           return item.size < 1024*1024*2.5;
        }});


        //События Callbacks
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
            alert("Один или несколько файлов имеют размер больше 2.5 Мб!");
        };
        uploader.onAfterAddingFile = function(fileItem) {
            console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
			      hideUpload = true;
            console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function(item) {
            console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            console.info('onCompleteAll');
            updatePhotos();
        };
        console.info('uploader', uploader);

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editflat')
        .controller('EditFlatController', EditFlatController);

    /** @ngInject */
    function EditFlatController($rootScope, $scope, $mdDialog, $location, GetStreetService, $resource, FileUploader, api)
    {
        var vm = this;
        // Data
        vm.formWizard = {};


		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
		//типы населенных пунктов
        vm.city_types = [{'socr': 'г', 'name': 'город'},
						{'socr': 'г.о.', 'name': 'городской округ'},
						{'socr': 'п', 'name': 'поселение/поселок'},
						{'socr': 'дп', 'name': 'дачный поселок'},
						{'socr': 'кп', 'name': 'курортный поселок'},
						{'socr': 'пгт', 'name': 'поселок городского типа'},
						{'socr': 'рп', 'name': 'рабочий поселок'},
						{'socr': 'с/п', 'name': 'сельское поселение'},
						{'socr': 'д', 'name': 'деревня'},
						{'socr': 'с', 'name': 'село'},
						{'socr': 'сл', 'name': 'слобода'},
						{'socr': 'снт', 'name': 'СНТ'},
						{'socr': 'жилрайон', 'name': 'жилой район'},
						{'socr': 'кв-л', 'name': 'квартал'},
						{'socr': 'мкр', 'name': 'микрорайон'},
						{'socr': 'нп', 'name': 'населенный пункт'},
						{'socr': 'тер', 'name': 'территория'},
						{'socr': 'промзона', 'name': 'промышленная зона'}];

		//названия нас.пунктов и улицы подгружаем после выбора
		vm.districts = {};
		vm.cities = {};
		vm.streets = {};

		//Список метро и направлений
		api.objects.metrostations.query({}, function(data) {
				vm.metrostations = data;
        //страховка
        vm.loadMetrostationsName();
				});

		api.objects.directions.query({}, function(data) {
				vm.directions = data;
				});

		vm.metro_time_list = [{'name': 'f_2', 'rusname': '2 минуты пешком'},
						{'name': 'f_5', 'rusname': '5 минут пешком'},
						{'name': 'f_7', 'rusname': '7 минут пешком'},
						{'name': 'f_10', 'rusname': '10 минут пешком'},
						{'name': 'f_15', 'rusname': '15 минут пешком'},
						{'name': 'f_20', 'rusname': '20 минут пешком'},
						{'name': 't_5', 'rusname': '5 минут транспортом'},
						{'name': 't_10', 'rusname': '10 минут транспортом'},
						{'name': 't_15', 'rusname': '15 минут транспортом'},
						{'name': 't_20', 'rusname': '20 минут транспортом'}];

		//тип объекта
		vm.object_types = [{'name': 'flat', 'rusname': 'Квартира'},
            {'name': 'apartments', 'rusname': 'Апартаменты'},
						{'name': 'flat_new_building', 'rusname': 'Квартира в новостройке'},
						{'name': 'room', 'rusname': 'Комната'},
						{'name': 'part', 'rusname': 'Доля в квартире'},
						{'name': 'penthouse', 'rusname': 'Пентхаус'}];

    //тип объекта 2
		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'},
						{'name': 'hog-wash', 'rusname': 'Утка'},
						{'name': 'auction', 'rusname': 'Аукцион'},
						{'name': 'invest', 'rusname': 'Инвестиционный'}];

		//источник
		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'},
						{'id': '2', 'rusname': 'Расклейка'},
						{'id': '3', 'rusname': 'Баннер'},
						{'id': '4', 'rusname': 'Рекомендация'},
						{'id': '5', 'rusname': 'База собственников'},
						{'id': '6', 'rusname': 'База заявок'},
						{'id': '7', 'rusname': 'Диспетчерская'},
						{'id': '8', 'rusname': 'Avito'},
						{'id': '9', 'rusname': 'Другие сайты'},
						{'id': '10', 'rusname': 'Сам нашел'}];

        // Предоплата, от 1 до 12 месяцев
		vm.class_bilds = [{'name': '1', 'rusname': '1'},
						{'name': '2', 'rusname': '2'},
						{'name': '3', 'rusname': '3'},
						{'name': '4', 'rusname': '4'},
						{'name': '5', 'rusname': '5'},
						{'name': '6', 'rusname': '6'},
						{'name': '7', 'rusname': '7'},
						{'name': '8', 'rusname': '8'},
						{'name': '9', 'rusname': '9'},
						{'name': '10', 'rusname': '10'},
						{'name': '11', 'rusname': '11'},
						{'name': '12', 'rusname': '12'}];
		vm.formWizard.class_bild = '1';

		//тип комиссии
		vm.commission_types = [{'name': 'percent', 'rusname': '%'},
						{'name': 'sum', 'rusname': 'руб.'}];


		//типы сделок
		vm.deal_types = [{'name': 'rent', 'rusname': 'Аренда'},
						{'name': 'change', 'rusname': 'Альтернатива'},
						{'name': 'sale', 'rusname': 'Продажа'},
            {'name': 'dupt', 'rusname': 'Переуступка'}];

        vm.rent_durations = [{'name': 'short', 'rusname': 'Несколько месяцев'},
						{'name': 'long', 'rusname': 'Длительный срок'},
						{'name': 'day', 'rusname': 'Посуточно'}];

		vm.pay_durations = [{'name': 'month', 'rusname': 'ежемесячно'},
							{'name': 'day', 'rusname': 'посуточно'}];

        //типы комнат для квартиры
        vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'},
						{'name': '2', 'rusname': 'Двухкомнатная'},
						{'name': '3', 'rusname': 'Трехкомнатная'},
						{'name': '4', 'rusname': 'Четырехкомнатная'},
						{'name': '5', 'rusname': 'Пятикомнатная'},
						{'name': 'm', 'rusname': 'Многокомнатная'},
						{'name': 'studio', 'rusname': 'Студия'},
			            {'name': '1_2', 'rusname': 'Комната в двухкомнатной'},
						{'name': '1_3', 'rusname': 'Комната в трехкомнатной'},
						{'name': '1_4', 'rusname': 'Комната в четырехкомнатной'},
						{'name': '1_5', 'rusname': 'Комната в пятикомнатной'},
						{'name': '2_3', 'rusname': '2 комнаты в трехкомнатной'},
						{'name': '2_4', 'rusname': '2 комнаты в четырехкомнатной'},
						{'name': '2_5', 'rusname': '2 комнаты в пятикомнатной'},
						{'name': '3_4', 'rusname': '3 комнаты в четырехкомнатной'},
						{'name': '3_5', 'rusname': '3 комнаты в пятикомнатной'}];



    vm.int_cian_array = [{'name': '0', 'rusname': 'Нет'},
      {'name': '1', 'rusname': 'Да'},
    {'name': '2', 'rusname': 'Highlight'},
    {'name': '3', 'rusname': 'Premium'},
    {'name': '4', 'rusname': 'Top3'}];
    
        vm.tech_8_array = [{'name': '1', 'rusname': '1'},
    {'name': '2', 'rusname': '2'},
    {'name': '3', 'rusname': '3'},
    {'name': '4', 'rusname': '4'}];

    vm.int_avito_array = [{'name': '0', 'rusname': 'Нет'},
      {'name': '1', 'rusname': 'Package'},
    {'name': '2', 'rusname': 'PackageSingle'},
  {'name': '3', 'rusname': 'Single'}];

  vm.int_avitoserv_array = [{'name': '0', 'rusname': 'Нет'},
    {'name': '2', 'rusname': 'Free'},
  {'name': '3', 'rusname': 'Premium'},
  {'name': '4', 'rusname': 'VIP'},
  {'name': '5', 'rusname': 'PushUp'},
  {'name': '6', 'rusname': 'Highlight'},
  {'name': '1', 'rusname': 'TurboSale'},
  {'name': '7', 'rusname': 'QuickSale'},
  {'name': '8', 'rusname': 'x2_1'},
  {'name': '9', 'rusname': 'x2_7'},
  {'name': '10', 'rusname': 'x5_1'},
  {'name': '11', 'rusname': 'x5_7'},
  {'name': '12', 'rusname': 'x10_1'},
  {'name': '13', 'rusname': 'x10_7'}];

		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'no', 'rusname': 'Нет'}];
		vm.int_yes_no_array = [{'name': '1', 'rusname': 'Есть'},
							{'name': '0', 'rusname': 'Нет'}];
		//телефон
		vm.phone_types = [{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'para', 'rusname': 'Спаренный'},
						{'name': 'possible', 'rusname': 'Возможно подключить'},
						{'name': 'no', 'rusname': 'Нет'}];

	 	//Бонус агенту
		vm.bordersq_stocks = [{'name': '0', 'rusname': '0'},
				        {'name': '0,1', 'rusname': '0,1'},
				        {'name': '0,25', 'rusname': '0,25'},
		                {'name': '0,5', 'rusname': '0,5'},
						{'name': '1', 'rusname': '1'},
						{'name': '1,5', 'rusname': '1,5'}];

        //окна
		vm.windows_type = [{'name': 'yard', 'rusname': 'Двор'},
						{'name': 'street', 'rusname': 'Улица'},
						{'name': 'both', 'rusname': 'Двор и улица'}];

		//Тип комнат
		vm.furniture_types = [{'name': 'separate', 'rusname': 'Изолированные'},
						{'name': 'combined', 'rusname': 'Смежные'},
						{'name': 'both', 'rusname': 'Оба варианта'}];

		//ремонт // Капитальный
		vm.repairs_types = [{'name': 'no', 'rusname': 'Без ремонта'},
						{'name': 'cosmetic', 'rusname': 'Косметический'},
						{'name': 'capital', 'rusname': 'Дизайнерский'},
						{'name': 'euro', 'rusname': 'Евро'}];
		//типы санузла
		vm.types_bathroom = [{'name': 'separated', 'rusname': 'Раздельный'},
						{'name': 'combined', 'rusname': 'Совмещенный'}];

		//парковка
		vm.types_parking = [{'name': 'ground', 'rusname': 'Наземная'},
	                    	{'name': 'multilevel', 'rusname': 'Многоуровневая'},
	                    	{'name': 'open', 'rusname': 'Открытая'},
		                    {'name': 'roof', 'rusname': 'На крыше'},
				    		{'name': 'underground', 'rusname': 'Подземная'}];

		//право собственности
		vm.ownership_types = [{'name': 'primary', 'rusname': 'Приватизация'},
						{'name': 'contract-sales', 'rusname': 'Договор купли/продажи'},
						{'name': 'contract-donat', 'rusname': 'Договор дарения'},
						{'name': 'contract-rent', 'rusname': 'Договор ренты'},
						{'name': 'paid', 'rusname': 'ЖСК, выплаченный пай'},
						{'name': 'legacy', 'rusname': 'Наследство'},
						{'name': 'court', 'rusname': 'Решение суда'},
						{'name': 'mortgage', 'rusname': 'Залог (ипотека)'},
						{'name': 'invest', 'rusname': 'ДДУ'},
						{'name': 'contract-meni', 'rusname': 'Договор мены'}];
		//Тип дома
		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
						{'name': 'panel', 'rusname': 'Панельный'},
						{'name': 'brick', 'rusname': 'Кирпичный'},
						{'name': 'wood', 'rusname': 'Деревянный'},
						{'name': 'stalin', 'rusname': 'Сталинский'},
						{'name': 'monolith', 'rusname': 'Монолит'},
						{'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'}];

    // Ипотека (Статус)
		vm.flat_status_types = [{'name': 'yes', 'rusname': 'Да'},
					          	{'name': 'no', 'rusname': 'Нет'}];
					//	{'name': 'patrol', 'rusname': 'Расселение/разъед'},
						//  {'name': 'alternate', 'rusname': 'Альтернатива'},
          //  {'name': 'courtdesicion', 'rusname': 'Прописан по решению суда'}];


		//Лифт
		vm.lift_types = [{'name': 'pass', 'rusname': 'Пассажирский'},
						{'name': 'serv', 'rusname': 'Грузовой'},
						{'name': 'passserv', 'rusname': 'Пасс. + груз.'},
            {'name': '2pass1serv', 'rusname': '2 Пасс. + груз.'},
            {'name': '1pass2serv', 'rusname': 'Пасс. + 2 груз.'},
            {'name': '2pass2serv', 'rusname': '2 пасс. + 2 груз.'},
            {'name': '2pass', 'rusname': '2 пассажирских'},
						{'name': '2serv', 'rusname': '2 грузовых'},
						{'name': 'no', 'rusname': 'Нет'}];
		//Балкон
		vm.balcony_types = [{'name': 'no', 'rusname': 'Нет'},
						{'name': 'yes', 'rusname': 'Есть'},
						{'name': 'loggia', 'rusname': 'Лоджия'},
						{'name': '2balcon', 'rusname': '2 балкона'},
						{'name': '2loggia', 'rusname': '2 лоджии'}];

		//Стоимость
		vm.inet_types = [{'name': 'full', 'rusname': 'Полная'},
						{'name': 'partial', 'rusname': 'Неполная'},
						{'name': 'discussed', 'rusname': 'Обсуждается'}];

		//В собственности
		vm.years_own_types = [{'name': 'less3', 'rusname': 'Менее 3 лет'},
						{'name': 'more3', 'rusname': 'Более 3 лет'},
					    {'name': 'more5', 'rusname': 'Более 5 лет'}];


      //получаем id своей учетной записи для сверки собственности на объект
      /*api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
        vm.userid = data.user_id;
      });*/
      vm.users_in_group = [];
      //узнаем свою должность
      //api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
        //vm.positionid = data.position_id;
        //console.log(vm.positionid);

        //Если НОП, то подгружаем список своих
        //if (vm.positionid == 1 || )
        //если есть право редактировать агента в объекте
        if ($rootScope.checkRule(59,'all')) {
          //получаем id своего отдела
          api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
            vm.groupid = data.group_id;
            //получаем список
            api.contacts.usersbygroup.get({id:vm.groupid}, function(data) {
              for (var i=0;i<data.data.length;i++) {
                vm.users_in_group.push(data.data[i]);
              }
              //console.log('i am nop of '+vm.groupid);
              //console.log(vm.users_in_group);
            });
          });
        }
      //});

      //добавляем в список агентов текущего агента по объекту (если для НОПа уже подгружен список, то не добавляем)
      if (vm.users_in_group.length>0) {
        var checkInArray = false;

        for (var i=0;i<vm.users_in_group.length;i++) {
          //TODO эта часть кода выполняется по факту после загрузки данных
          //странный реверс - рахобраться в причинах
          vm.users_in_group[i].id = parseInt(vm.users_in_group[i].id);
          if (vm.users_in_group[i].id == vm.formWizard.owner_id) {
            checkInArray = true;
            //break;
          }
        }
        if (!checkInArray) {
          api.contacts.usernamebyid.get({id:vm.formWizard.owner_id}, function(data) {
            //vm.object_agent = data.name;
            //console.log(data);
            vm.users_in_group.push({'id': vm.formWizard.owner_id, 'name': data.data });
          });
        }
      }
      vm.formWizard.owner_id = vm.formWizard.owner_id;
      //console.log(vm.users_in_group);

        //получаем id объекта, который будем редактировать
        vm.objectId = $location.path().split('/');
        vm.objectId = vm.objectId[vm.objectId.length-1];
        //id главного изображения
        vm.mainImage = 0;
        //информацию по объекту
		api.objects.objectbyid.query({'id':vm.objectId}, function(data) {
				//console.log(data);
				vm.formWizard.region = parseInt(data.region);
				vm.formWizard.district = parseInt(data.district);
				vm.formWizard.city_type = data.city_type;
				vm.formWizard.city = data.city;

        vm.selectedItem = data.street;
				vm.formWizard.street = data.street;
				vm.formWizard.house_number = data.house_number;
        vm.formWizard.flat_number = data.flat_number;
				//загружаем адрес полностью
				loadAddress();
				//id главного изображения
				vm.mainImage = (parseInt(data.image)==0)?0:data.image;

				vm.formWizard.object_type = data.object_type;
				vm.formWizard.object_type_2 = data.object_type_2;
				vm.formWizard.direction = parseInt(data.direction);
        vm.formWizard.flats_apartmentscomplex = data.flats_apartmentscomplex;
				vm.formWizard.metro_1 = data.metro_1;
				vm.formWizard.metro_2 = data.metro_2;
				vm.formWizard.metro_3 = data.metro_3;
				vm.formWizard.metro_1_time = data.metro_1_time;
				vm.formWizard.metro_2_time = data.metro_2_time;
				vm.formWizard.metro_3_time = data.metro_3_time;
        vm.loadMetrostationsName();

				vm.formWizard.deal_type = data.deal_type;
				vm.formWizard.source_id = data.source_id;
				vm.formWizard.part_percent = data.part_percent;
				vm.formWizard.rentcost = parseInt(data.rentcost);
				vm.formWizard.rent_duration = data.rent_duration;
				vm.formWizard.pay_duration = data.pay_duration;
				vm.formWizard.cost = parseInt(data.cost);
				vm.formWizard.commission = parseFloat(data.commission);
				vm.formWizard.commission_type = data.commission_type;
				vm.formWizard.rooms_number = data.rooms_number;
				vm.formWizard.story = parseInt(data.story);
				vm.formWizard.story_count = parseInt(data.story_count);
				vm.formWizard.tech_4 = data.tech_4;
        vm.formWizard.from_mcad = parseInt(data.from_mcad);
				vm.formWizard.tech_8 = data.tech_8;
				vm.formWizard.furniture = data.furniture;
				vm.formWizard.repairs = data.repairs;
				vm.formWizard.flat_status = data.flat_status;
				vm.formWizard.years_own = data.years_own;
				vm.formWizard.balcony = data.balcony;
				vm.formWizard.ownership = data.ownership;
				vm.formWizard.type_bild = data.type_bild;
				vm.formWizard.lift = data.lift;
				vm.formWizard.type_bathroom = data.type_bathroom;
				vm.formWizard.count_bathroom_flat = data.count_bathroom_flat;
				vm.formWizard.inet = data.inet;
				vm.formWizard.phone = data.phone;
				vm.formWizard.bordersq_stock = data.bordersq_stock;
				vm.formWizard.usefulsq_stock = data.usefulsq_stock;
				vm.formWizard.officesq_stock = data.officesq_stock;

			    vm.formWizard.tv = data.tv;
                vm.formWizard.windows = data.windows;
				vm.formWizard.square_all = parseFloat(data.square_all);
				vm.formWizard.square_living = parseFloat(data.square_living);
				vm.formWizard.square_kitchen = parseFloat(data.square_kitchen);
				vm.formWizard.square_rooms = data.square_rooms;
				vm.formWizard.description = data.description;
				vm.formWizard.description_en = data.description_en;
				vm.formWizard.creator_id = data.creator_id;
				vm.formWizard.owner_id = parseInt(data.owner_id);
        vm.formWizard.client_id = parseInt(data.client_id);
				vm.formWizard.avito = parseInt(data.avito);
        vm.formWizard.auction = parseInt(data.auction);
        vm.formWizard.auction_title = data.auction_title;
        vm.formWizard.xml_cian = parseInt(data.xml_cian);
        vm.formWizard.xml_yandex = parseInt(data.xml_yandex);
        vm.formWizard.xml_domclick = parseInt(data.xml_domclick);
        vm.formWizard.only_winner = parseInt(data.only_winner);
        vm.formWizard.only_cian = parseInt(data.only_cian);
				vm.formWizard.cian_prem = parseInt(data.cian_prem);
				vm.formWizard.avito_turbo = parseInt(data.avito_turbo);
        vm.formWizard.linktour = data.linktour;

        //выносим, чтобы получить полный список клиентов (свои + клиент по объекту)
        api.contacts.my_clients.query({'id':vm.objectId}, function(data) {
          vm.my_clients = data;
        });
		});

		vm.table = {
		  columns: [
			{
			  "title": "Фотография"
			},
			{
			  "title": "Размер"
			}
		  ],
		  dtOptions: {
				dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
				pagingType: 'simple',
				autoWidth : false,
				responsive: true,
				pageLength: 100,
				searching: false,
				oLanguage: {
					sUrl:"/assets/datatables.lang"
				},
				"columns": [
					{ "orderable": false },
					{ "orderable": false }
				  ],
				  "order": [0, "desc"]
		  }
		};
		updatePhotos();

        // Methods
    vm.sendForm = sendForm;
		vm.loadDistricts = loadDistricts;
		vm.loadCities = loadCities;
		//vm.loadStreets = loadStreets;
		vm.changeRoomTypes = changeRoomTypes;
		vm.changeFlatStatuses = changeFlatStatuses;
		vm.loadAddress = loadAddress;
		vm.updatePhotos = updatePhotos;
		vm.successLoadPhotosMessage = successLoadPhotosMessage;
		vm.removePhoto = removePhoto;
		vm.setMainPhoto = setMainPhoto;

    changeFlatStatuses();

  	vm.total = 0;
		vm.dtInstance = {};

    vm.dtIntanceCallback = function (instance) {
			vm.dtInstance = instance;
		}


    vm.upPhoto  = function (photo) {
      var photoIndex = photo.position - 1;
      var tempPhotos = vm.photos.slice();

      var UpPhoto = vm.photos[photoIndex];
      var DownPhoto = vm.photos[photoIndex - 1];
      UpPhoto.position = UpPhoto.position - 1;
      DownPhoto.position = DownPhoto.position + 1;

      delete tempPhotos[photoIndex];
      delete tempPhotos[photoIndex - 1];

      tempPhotos[photoIndex] = DownPhoto;
      tempPhotos[photoIndex - 1] = UpPhoto;

      /*
      // меняем текуший элемент на предыдущий и устанавливаем ему позицию переданного
      tempPhotos[photo.position - 1] = tempPhotos[photo.position - 2];
      tempPhotos[photo.position - 1].position = photo.position;
      // меняем предыдущий элемент на переданный и устанавливаем ему позицию на 1 меньше
      tempPhotos[photo.position - 2] = vm.photos[photo.position - 1];
      tempPhotos[photo.position - 2].position = photo.position - 1;
      console.log('upPhoto', photo, vm.photos, tempPhotos);
      */
      vm.photos = tempPhotos;

      var spp = new api.objects.setpositionphoto();
      spp.positions = tempPhotos.map(function(x) { return {id: x.id, position: x.position};});
      spp.$save();
    }

    vm.downPhoto  = function (photo) {
      var photoIndex = photo.position - 1;
      var tempPhotos = vm.photos.slice();

      var DownPhoto = vm.photos[photoIndex];
      var UpPhoto = vm.photos[photoIndex + 1];
      UpPhoto.position = UpPhoto.position - 1;
      DownPhoto.position = DownPhoto.position + 1;

      delete tempPhotos[photoIndex];
      delete tempPhotos[photoIndex + 1];

      tempPhotos[photoIndex] = UpPhoto;
      tempPhotos[photoIndex + 1] = DownPhoto;

      vm.photos = tempPhotos;
      var spp = new api.objects.setpositionphoto();
      spp.positions = tempPhotos.map(function(x) { return {id: x.id, position: x.position};});
      spp.$save();
    }

		//устанавливаем фотографию главной
		function setMainPhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var mainphoto = new api.objects.mainphoto();
					mainphoto.id = id;
					mainphoto.$save();

					vm.mainImage = id;

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография помечена как главная</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//////////удаление фотографии
		function removePhoto(id)
        {
			$mdDialog.show({
                controller: function ($scope, $mdDialog)
                {
                    var archivephoto = new api.objects.archivephoto();
					archivephoto.id = id;
					archivephoto.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        //обновляем список фотографий и таблицу сразу после загрузки
	                      updatePhotos();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Фотография удалена</h1><div>Она исчезнет в таблице фотографий после сохранения изменений в объекте</div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//////////обновление таблицы фотографий
    function updatePhotos(rotated)
        {
        rotated = typeof rotated !== 'undefined' ? rotated : 1;

        api.objects.objectphotosbyid.query({'id':vm.objectId}, function(data) {
            vm.photos = data.data;
            vm.total = vm.photos.length;
            //меняем адреса изображений
            for(var i=0; i < vm.photos.length;i++){
              vm.photos[i].position = i + 1;
              //замена на адреса, как на сервере
              if (vm.photos[i].rotated == 1 || rotated==1) {
                  vm.photos[i].filename = api.domain_name + api.domain_images + vm.photos[i].filename + '?rand=' + Math.round(Math.random() * (1000 - 1) + 1);
              } else {
                  vm.photos[i].filename = api.domain_name + api.domain_images + vm.photos[i].filename;
              }
            }
        });
    }
		//Сообщение, что фото загружены
		function successLoadPhotosMessage()
        {
			$mdDialog.show({
					controller         : function ($scope, $mdDialog)
					{
						$scope.closeDialog = function ()
						{
							$mdDialog.hide();
							//обновляем список фотографий и таблицу сразу после загрузки
							updatePhotos();
						}
					},
					template: '<md-dialog>' +
					'  <md-dialog-content><h1>Фотографии успешно добавлены</h1></md-dialog-content>' +
					'  <md-dialog-actions>' +
					'    <md-button ng-click="closeDialog()" class="md-primary">' +
					'      Закрыть' +
					'    </md-button>' +
					'  </md-dialog-actions>' +
					'</md-dialog>',
					parent             : angular.element('body'),
					clickOutsideToClose: true
				});
		}
        //////////первоначальная загрузка адреса редактируемого объекта
        function loadAddress()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
				vm.districts = data;
				//vm.formWizard.district = id;
					var index_district = 0;
					//определяем реальный порядковый номер в массиве
					for (var i = 0; i < vm.districts.length; i++)
						if (vm.districts[i]['id'] == vm.formWizard.district) {
							index_district = i;
							api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
								vm.cities = data;
                //при загрузке страницы (только при редактировании) узнаем обязательна ли улица
                vm.isStreetRequired();
								/*var index_city = 0;
								//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
								//его код КЛАДР
								for (var i = 0; i < vm.cities.length; i++)
									if (vm.cities[i]['name'] == vm.formWizard.city) {
										index_city = i;*/

										//TODO оптимизировать загрузку улиц
										/*api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {
											vm.streets = data;
										});*/
								//}
							});
					}
				});
		}
        //////////оставляем те же функции, что и при создании
        function loadDistricts()
        {
			api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
				vm.districts = data;
				//обнуляем все, что ниже иерархически
				vm.cities = {};
				vm.streets = {};
				//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.district = null;
				vm.formWizard.city = null;
        //очищаем улицу
        vm.formWizard.street = null;
        vm.searchStreet = '';

				vm.formWizard.house_number = null;
        vm.formWizard.flat_number = null;
				//для Москвы выбираем любой район, так как район города необязателен
				if (vm.formWizard.region == 1) {
					vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
					loadCities();
					}
				});
		}

		function loadCities()
      {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
				vm.formWizard.city = null;
        //очищаем улицу
        vm.formWizard.street = '';
        vm.searchStreet = '';

				vm.formWizard.house_number = null;
        vm.formWizard.flat_number = null;

			if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
				vm.cities = {};
			} else {
				var index_district = 0;
				//определяем реальный порядковый номер в массиве
				for (var i = 0; i < vm.districts.length; i++)
					if (vm.districts[i]['id'] == vm.formWizard.district) {
						index_district = i;
						api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
							vm.cities = data;
							});
				}
			}
			vm.streets = {};
		}


    ////////////////////////
    //Поворот фотографий
    vm.rotatePhoto  = function (filename,angle) {
      var rotatephoto = new api.objects.rotatephoto();
      rotatephoto.name = filename;
      rotatephoto.angle = angle;
      rotatephoto.$save();
      //обновляем список
      updatePhotos(1);
    }

    ///////////////////////
    vm.searchStreet = "";

    //функция вывода списка улиц
    vm.searchStreetResult = function (str) {
      //ищем хотя бы после 3 введенных символов, чтобы не показывать большие объемы улиц
      if (vm.searchStreet.length>2) {
        var index_city = 0;
        //так как города из КЛАДР и внутренних идентификаторов в массиве нет,
        //то ищем номер в массиве и узнаем его код КЛАДР

        for (var i = 0; i < vm.cities.length; i++)
          if (vm.cities[i]['name'] == vm.formWizard.city) {
            index_city = i;
            //стандартная загрузка через resource/http в контроллере не возвращает результат сразу же
            //dropdown обновляется на шаг позже - решено при помощи создания фабрики в модуле
            return GetStreetService.getStreets(vm.cities[index_city].code, str);
        }
      }
    }

    //если в директиве слушать напрямую изменение выбранной улицы, то
    //функция срабатывает до изменения параметра в этой функции
    //selectedItemChange() срабатывает позже непосредственной замены vm.selectedItem
    //поэтому Blur срабатывает один раз даже когда введена улица из списка

    //если объект создается
    //vm.streetFromListWhenSelected = false;
    //если объект редактируется - улица уже введена
    vm.streetFromListWhenSelected = true;

    //при выборе нового значения изменяем значение в модели для отправки
    vm.selectedItemChange = function () {
      if (typeof(vm.selectedItem)=='object' && vm.selectedItem!=null) {

        vm.formWizard.street = vm.selectedItem.value;
        //улица выбрана из списка
        //так как в formWizard не работают ngMessages, то проверка идет после потери
        //фокуса поля Улица
        vm.streetFromListWhenSelected = true;
      } else {
        //улица не из списка
      }
    }

    vm.searchStringChange = function (text) {
      //если текст вообще введен
      if (text!==null) {
        //при любом изменении вводимого в улицу текста помечаем, что улица выбрана не из списка
        vm.streetFromList = false;
        vm.streetFromListWhenSelected = false;
      }
    }

    //делает поле обязательным, если в нас. пункте есть улицы по базе КЛАДР
    vm.isStreetRequired = function () {
      var index_city = 0;
      //так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
      //его код КЛАДР
      for (var i = 0; i < vm.cities.length; i++)
        if (vm.cities[i]['name'] == vm.formWizard.city) {
          index_city = i;
          api.objects.count_streets.query({'code':vm.cities[index_city].code}, function(data) {
            vm.street_qty = data[0].qty;
            //console.log('В данном населенном пункте '+vm.street_qty+' улиц');
          });
      }
      //очищаем улицу
      vm.formWizard.street = null;
    }

    //автозаполнение поля метро
    vm.metroQuerySearch = function (query) {
      var lowercaseQuery = angular.lowercase(query);
      query = lowercaseQuery[0].toUpperCase() + lowercaseQuery.substr(1);

      var results = lowercaseQuery ? vm.metrostations.filter( createFilterFor(query) ) : vm.metrostations;
      return results;
    }
    //фильтр
    function createFilterFor(query) {
      return function filterFn(metro) {
        return (metro.name.indexOf(query) === 0);
      };
    }

    vm.loadMetrostationsName = function() {
      //определяем реальный порядковый номер в массиве
      //заполняем поля автозаполнения по метро
      var index_metro1 = 0;

      if (undefined !== vm.metrostations) {
        for (var i = 0; i < vm.metrostations.length; i++)
          if (vm.metrostations[i]['id'] == vm.formWizard.metro_1) {
            index_metro1 = i;
            vm.searchMetro_1 = vm.metrostations[i]['name'];
            break;
        }
        var index_metro2 = 0;
        for (var i = 0; i < vm.metrostations.length; i++)
          if (vm.metrostations[i]['id'] == vm.formWizard.metro_2) {
            index_metro2 = i;
            vm.searchMetro_2 = vm.metrostations[i]['name'];
            break;
        }

        var index_metro3 = 0;
        for (var i = 0; i < vm.metrostations.length; i++)
          if (vm.metrostations[i]['id'] == vm.formWizard.metro_3) {
            index_metro3 = i;
            vm.searchMetro_3 = vm.metrostations[i]['name'];
            break;
        }
      }
    }


    /*
    vm.selectMetro = function (item, field) {

      switch (field) {
        case 1: vm.formWizard.metro_1 = item; break;
        case 2: vm.formWizard.metro_2 = item; break;
        case 3: vm.formWizard.metro_3 = item; break;
        default:
        break;
      }
    }*/



    /*
		function loadStreets()
    {
			//делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
			vm.formWizard.street = null;
			vm.formWizard.house_number = null;

			if (!vm.formWizard.city) {
				vm.streets = {};
			} else {
				var index_city = 0;
				//так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
				//его код КЛАДР
				for (var i = 0; i < vm.cities.length; i++)
					if (vm.cities[i]['name'] == vm.formWizard.city) {
						index_city = i;
						//TODO оптимизировать загрузку улиц
						api.objects.streets.query({'code':vm.cities[index_city].code}, function(data) {
							vm.streets = data;
						});
				}
			}
		}*/

		function changeFlatStatuses() {
		 if (vm.formWizard.deal_type == 'change') {
			 vm.flat_status_types = [{'name': 'yes', 'rusname': 'Да'},
		                        		{'name': 'no', 'rusname': 'Нет'}
                 ];
			  vm.formWizard.flat_status = 'alternate';
			} else {
			 vm.flat_status_types = [{'name': 'yes', 'rusname': 'Да'},
				{'name': 'no', 'rusname': 'Нет'}];
			}
		}


		//		function changeFlatStatuses() {
	//	 if (vm.formWizard.deal_type == 'change') {
	//		 vm.flat_status_types = [{'name': 'patrol', 'rusname': 'Расселение/разъед'},
									 //{'name': 'alternate', 'rusname': 'Альтернатива'}
     //            ];
	//		  vm.formWizard.flat_status = 'alternate';
	//		} else {
	//		 vm.flat_status_types = [{'name': 'no', 'rusname': 'Никто не прописан'},
	//			{'name': 'free', 'rusname': 'Свободна'},
	//			{'name': 'patrol', 'rusname': 'Расселение/разъед'},
     //   {'name': 'courtdesicion', 'rusname': 'Прописан по решению суда'}];
	//		}
	//	}

		function changeRoomTypes() {
			switch (vm.formWizard.object_type) {
				//типы комнат для квартиры, новостройки, пентхауса
				case 'flat_new_building': //doNothing
				case 'penthouse': //doNothing
				case 'flat': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатная'},
										{'name': '2', 'rusname': 'Двухкомнатная'},
										{'name': '3', 'rusname': 'Трехкомнатная'},
										{'name': '4', 'rusname': 'Четырехкомнатная'},
										{'name': '5', 'rusname': 'Пятикомнатная'},
										{'name': 'm', 'rusname': 'Многокомнатная'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
        case 'apartments': vm.rooms_type_list = [{'name': '1', 'rusname': 'Однокомнатные'},
										{'name': '2', 'rusname': 'Двухкомнатные'},
										{'name': '3', 'rusname': 'Трехкомнатные'},
										{'name': '4', 'rusname': 'Четырехкомнатные'},
										{'name': '5', 'rusname': 'Пятикомнатные'},
										{'name': 'm', 'rusname': 'Многокомнатные'},
										{'name': 'studio', 'rusname': 'Студия'}];
										break
				case 'part': vm.rooms_type_list = [{'name': 'd_1', 'rusname': 'Доля в однокомнатной'},
										{'name': 'd_2', 'rusname': 'Доля в двухкомнатной'},
										{'name': 'd_3', 'rusname': 'Доля в трехкомнатной'},
										{'name': 'd_4', 'rusname': 'Доля в четырехкомнатной'},
										{'name': 'd_5', 'rusname': 'Доля в пятикомнатной'}];
										break
				case 'room': vm.rooms_type_list = [{'name': '1_2', 'rusname': 'Комната в двухкомнатной'},
										{'name': '1_3', 'rusname': 'Комната в трехкомнатной'},
										{'name': '1_4', 'rusname': 'Комната в четырехкомнатной'},
										{'name': '1_5', 'rusname': 'Комната в пятикомнатной'},
										{'name': '2_3', 'rusname': '2 комнаты в трехкомнатной'},
										{'name': '2_4', 'rusname': '2 комнаты в четырехкомнатной'},
										{'name': '2_5', 'rusname': '2 комнаты в пятикомнатной'},
										{'name': '3_4', 'rusname': '3 комнаты в четырехкомнатной'},
										{'name': '3_5', 'rusname': '3 комнаты в пятикомнатной'}];
										break
					  }
		}

        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    if (vm.searchMetro_1 == '') {
                      formWizardData.metro_1 = '';
                    	formWizardData.metro_1_time = '';
                    }
                    if (vm.searchMetro_2 == '') {
                      formWizardData.metro_2 = '';
                    	formWizardData.metro_2_time = '';
                    }
                    if (vm.searchMetro_3 == '') {
                      formWizardData.metro_3 = '';
                    	formWizardData.metro_3_time = '';
                    }
                    //console.log('sendForm 2', vm.searchMetro_2, formWizardData);//metroQuerySearch
                    $scope.formWizardData = formWizardData;

          					var editobject = new api.objects.editobjectdata();
          					editobject.data = formWizardData;
          					editobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flats');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект успешно изменен</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}

	///////////////////////Загрузка фотографий
	var hideUpload = false; //переменная для сокрытия кнопки загрузки после одной загрузки (чтобы не заливали одно и то же, пока нет онлайн обновления таблицы)
	var uploader = $scope.uploader = new FileUploader({
			//инкапсулируем скрипт загрузки в общий модуль, чтобы проверять авторизацию
            url: api.localhost_backend + 'upload',
            removeAfterUpload: true,
		        formData: {'id':vm.objectId}
        });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 20;
            }
        });

        // File must not be larger then some size
        uploader.filters.push({ name: 'sizeFilter', fn: function(item) {
           return item.size < 1024*1024*2.5;
        }});


        //События Callbacks
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
            alert("Один или несколько файлов имеют размер больше 2.5 Мб!");
        };
        uploader.onAfterAddingFile = function(fileItem) {
            console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
			      hideUpload = true;
            console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function(item) {
            console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            console.info('onCompleteAll');
            updatePhotos();
        };
        console.info('uploader', uploader);

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editcommerce', ['datatables','ngResource','angularFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_editcommerce', {
            url    : '/objects/edit/commerce/{id:int}',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/editobject/editcommerce/editcommerce.html',
                    controller : 'EditCommerceController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }




})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject.editcommerce')
        .controller('EditCommerceController', EditCommerceController);

    /** @ngInject */
    function EditCommerceController($rootScope, $scope, $mdDialog, $location, GetStreetService, $resource, FileUploader, api)
    {
      var vm = this;
      // Data
      vm.formWizard = {};

      //Список регионов и изначально установленный
  		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];
  		vm.formWizard.region = 1;

  		//типы населенных пунктов
          vm.city_types = [{'socr': 'г', 'name': 'город'},
  						{'socr': 'г.о.', 'name': 'городской округ'},
  						{'socr': 'п', 'name': 'поселение/поселок'},
  						{'socr': 'дп', 'name': 'дачный поселок'},
  						{'socr': 'кп', 'name': 'курортный поселок'},
  						{'socr': 'пгт', 'name': 'поселок городского типа'},
  						{'socr': 'рп', 'name': 'рабочий поселок'},
  						{'socr': 'с/п', 'name': 'сельское поселение'},
  						{'socr': 'д', 'name': 'деревня'},
  						{'socr': 'с', 'name': 'село'},
  						{'socr': 'сл', 'name': 'слобода'},
  						{'socr': 'снт', 'name': 'СНТ'},
  						{'socr': 'жилрайон', 'name': 'жилой район'},
  						{'socr': 'кв-л', 'name': 'квартал'},
  						{'socr': 'мкр', 'name': 'микрорайон'},
  						{'socr': 'нп', 'name': 'населенный пункт'},
  						{'socr': 'тер', 'name': 'территория'},
  						{'socr': 'промзона', 'name': 'промышленная зона'}];

  		//названия нас.пунктов и улицы подгружаем после выбора
      vm.districts = {};
  		vm.cities = {};
  		vm.streets = {};
  		//Список метро и направлений
  		api.objects.metrostations.query({}, function(data) {
  				vm.metrostations = data;
          //страховка
          vm.loadMetrostationsName();
  				});
  		api.objects.directions.query({}, function(data) {
  				vm.directions = data;
  				});

  		vm.metro_time_list = [{'name': 'f_2', 'rusname': '2 минуты пешком'},
  						{'name': 'f_5', 'rusname': '5 минут пешком'},
  						{'name': 'f_7', 'rusname': '7 минут пешком'},
  						{'name': 'f_10', 'rusname': '10 минут пешком'},
  						{'name': 'f_15', 'rusname': '15 минут пешком'},
  						{'name': 'f_20', 'rusname': '20 минут пешком'},
  						{'name': 't_5', 'rusname': '5 минут транспортом'},
  						{'name': 't_10', 'rusname': '10 минут транспортом'},
  						{'name': 't_15', 'rusname': '15 минут транспортом'},
  						{'name': 't_20', 'rusname': '20 минут транспортом'}];

  		//тип объекта
  		vm.object_types = [{'name': 'office', 'rusname': 'Офис'},
  						{'name': 'garage', 'rusname': 'Гараж'},
  			     	    {'name': 'parkingPlace', 'rusname': 'Машиноместо'},
  						{'name': 'stock', 'rusname': 'Склад'},
  						{'name': 'commercial_premises', 'rusname': 'Торговое помещение'},
                        {'name': 'psn', 'rusname': 'ПСН'},
                        {'name': 'production_room', 'rusname': 'Производственное помещение'},
  						{'name': 'ready_business', 'rusname': 'Готовый бизнес'}];

          //тип объекта 2
  		vm.object_types_2 = [{'name': 'real', 'rusname': 'Реальный объект'}];

  		//источник
  		vm.sources = [{'id': '1', 'rusname': 'SmartAgent'},
  						{'id': '2', 'rusname': 'Расклейка'},
  						{'id': '3', 'rusname': 'Баннер'},
  						{'id': '4', 'rusname': 'Рекомендация'},
  						{'id': '5', 'rusname': 'База собственников'},
  						{'id': '6', 'rusname': 'База заявок'},
  						{'id': '7', 'rusname': 'Диспетчерская'},
  						{'id': '8', 'rusname': 'Avito'},
  						{'id': '9', 'rusname': 'Другие сайты'},
  						{'id': '10', 'rusname': 'Сам нашел'}];

  		//тип комиссии
  		vm.commission_types = [{'name': 'percent', 'rusname': '%'},
  						{'name': 'sum', 'rusname': 'руб.'}];

  		//типы сделок
  		vm.deal_types = [{'name': 'rent', 'rusname': 'Прямая аренда'},
  						{'name': 'subrent', 'rusname': 'Субаренда'},
              {'name': 'ppa', 'rusname': 'Переуступка права аренды'},
              {'name': 'dsd', 'rusname': 'Договор совместной деятельности'},
  						{'name': 'sale', 'rusname': 'Продажа объекта'}];

          vm.pay_types = [{'name': 'object', 'rusname': 'За весь объект'},
  						{'name': 'squarem', 'rusname': 'За м2'}];

  		vm.pay_durations = [{'name': 'month', 'rusname': 'в месяц'},
  							{'name': 'year', 'rusname': 'в год'}];



    vm.int_cian_array = [{'name': '0', 'rusname': 'Нет'},
      {'name': '1', 'rusname': 'Да'},
    {'name': '2', 'rusname': 'Highlight'},
    {'name': '3', 'rusname': 'Premium'},
    {'name': '4', 'rusname': 'Top3'}];

    vm.int_avito_array = [{'name': '0', 'rusname': 'Нет'},
      {'name': '1', 'rusname': 'Package'},
    {'name': '2', 'rusname': 'PackageSingle'},
  {'name': '3', 'rusname': 'Single'}];

  vm.int_avitoserv_array = [{'name': '0', 'rusname': 'Нет'},
    {'name': '2', 'rusname': 'Free'},
  {'name': '3', 'rusname': 'Premium'},
  {'name': '4', 'rusname': 'VIP'},
  {'name': '5', 'rusname': 'PushUp'},
  {'name': '6', 'rusname': 'Highlight'},
  {'name': '1', 'rusname': 'TurboSale'},
  {'name': '7', 'rusname': 'QuickSale'},
  {'name': '8', 'rusname': 'x2_1'},
  {'name': '9', 'rusname': 'x2_7'},
  {'name': '10', 'rusname': 'x5_1'},
  {'name': '11', 'rusname': 'x5_7'},
  {'name': '12', 'rusname': 'x10_1'},
  {'name': '13', 'rusname': 'x10_7'}];


  		//массив - да / нет
  		// Эксплуатационные расходы
          vm.yes_no_array = [{'name': 'yes', 'rusname': 'Есть'},
  						{'name': 'no', 'rusname': 'Нет'}];
          vm.yes_no_array_living = [{'name': 'shoppingFloorSpace', 'rusname': 'Торговая площадь'},
                                    {'name': 'publicCatering', 'rusname': 'Общепит'},
                                    {'name': 'restaurant', 'rusname': 'Ресторан'},
                                    {'name': 'rentalBusiness', 'rusname': 'Арендный бизнес'},
                                    {'name': 'readyMadeBusiness', 'rusname': 'Готовый бизнес'},
                                    {'name': 'flexiblePurpose', 'rusname': 'Свободное назначение'},
                                    {'name': 'streetRetail', 'rusname': 'Стрит ритейл'},
                                    {'name': 'products', 'rusname': 'Продукты'},
                                    {'name': 'other', 'rusname': 'Другое'},];
          vm.yes_no_array_enter = [{'name': 'yes', 'rusname': 'Предоставляется'},
    					{'name': 'no', 'rusname': 'Не предоставляется'}];
          vm.int_yes_no_array = [{'name': '1', 'rusname': 'Есть'},
      							{'name': '0', 'rusname': 'Нет'}];
      //типы планировок
      vm.plan_bild_types = [{'name': 'cabinet', 'rusname': 'Кабинетная'},
  						{'name': 'corridorplan', 'rusname': 'Коридорная'},
  						{'name': 'mixed', 'rusname': 'Смешанная'},
  						{'name': 'openSpace', 'rusname': 'Открытая'}];
  		//Коммунальные платежи    (телефон)
  		vm.phone_types = [{'name': 'yes', 'rusname': 'Включены'},
  					//	{'name': 'para', 'rusname': 'Спаренный'},
  					//	{'name': 'possible', 'rusname': 'Возможно подключить'},
  						{'name': 'no', 'rusname': 'Не включены'}];
      //отопление и электричество
      vm.heating_types = [{'name': 'central', 'rusname': 'Центральное'},
  						{'name': 'autonomous', 'rusname': 'Автономное'},
  						{'name': 'no', 'rusname': 'Нет'}];
      vm.enegi_types = [{'name': 'yes', 'rusname': 'Есть'},
    					{'name': 'unknown', 'rusname': 'Неизвестно'},
    					{'name': 'possible', 'rusname': 'Возможно подключить'}];
  		//мебель
  		vm.furniture_types = [{'name': 'true', 'rusname': 'Да'},
  						{'name': 'false', 'rusname': 'Нет'}];
  		//ремонт
  		vm.repairs_types = [{'name': 'cosmetic', 'rusname': 'Типовой'},
  						{'name': 'capital', 'rusname': 'Дизайнерский'},
              {'name': 'standard-office', 'rusname': 'Офисная отделка'},
              {'name': 'ready-for-final', 'rusname': 'Готово под чистовую отделку'},
              {'name': 'needcapital', 'rusname': 'Требуется капитальный'},
              {'name': 'needcosmetic', 'rusname': 'Требуется косметический'}
            ];

      //типы гаражей
      vm.garage_types = [{'name': 'shell', 'rusname': 'Ракушка'},
              {'name': 'detached', 'rusname': 'Отдельно стоящий'},
              {'name': 'secure-outdoors', 'rusname': 'Место на охраняемой наружной стоянке'},
              {'name': 'secure-underground', 'rusname': 'Место в подземном охраняемом гараже'},
              {'name': 'high-bay', 'rusname': 'Место в многоярусном охраняемом гараже'},
              {'name': 'cooperative', 'rusname': 'Гараж в гаражном кооперативе'},
              {'name': 'capital', 'rusname': 'Капитальный'}]
  		//типы санузла
  		vm.types_bathroom = [{'name': 'separated', 'rusname': 'Раздельный'},
  						{'name': 'combined', 'rusname': 'Совмещенный'}];

  		//Тип дома
  		vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
  						{'name': 'panel', 'rusname': 'Панельный'},
  						{'name': 'brick', 'rusname': 'Кирпичный'},
  						{'name': 'wood', 'rusname': 'Деревянный'},
  						{'name': 'stalin', 'rusname': 'Сталинский'},
  						{'name': 'monolith', 'rusname': 'Монолит'},
  						{'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'},
              {'name': 'business_center', 'rusname': 'Бизнес-центр'},
  						{'name': 'office_building', 'rusname': 'Офисное здание'},
  						{'name': 'office_complex', 'rusname': 'Комплекс офисных зданий'},
  						{'name': 'mansion', 'rusname': 'Особняк'},
  						{'name': 'retail_office_complex', 'rusname': 'Торгово-офисный комплекс'},
  						{'name': 'office_residential_complex', 'rusname': 'Офисно-жилой комплекс'},
  						{'name': 'administrative_building', 'rusname': 'Административное зданиие'},
              {'name': 'mall', 'rusname': 'Торгово-развлекательный центр'},
              {'name': 'business_park', 'rusname': 'Бизнес-парк'},
              {'name': 'multifuctional_complex', 'rusname': 'Многофункциональный комплекс'}];

      //Статус бизнес центра
  		vm.bcenterstatus_list = [{'name': 'included', 'rusname': 'НДС включен'},
  						{'name': 'notIncluded', 'rusname': 'НДС не включен'},
  						{'name': 'usn', 'rusname': 'УСН '},
  						{'name': 'wvat', 'rusname': 'Без налога'}];

  		//Лифт
  		vm.lift_types = [{'name': 'rur', 'rusname': 'Рубль'},
  						{'name': 'eur', 'rusname': 'Евро'},
  						{'name': 'usd', 'rusname': 'Доллар'}];

    //получаем id своей учетной записи для сверки собственности на объект
    /*api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
      vm.userid = data.user_id;
    });*/
    vm.users_in_group = [];
    //узнаем свою должность
    //api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
      //vm.positionid = data.position_id;
      //console.log(vm.positionid);

      //Если НОП, то подгружаем список своих
      //if (vm.positionid == 1 || )
      //если есть право редактировать агента в объекте
      if ($rootScope.checkRule(59,'all')) {
        //получаем id своего отдела
        api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
          vm.groupid = data.group_id;
          //получаем список
          api.contacts.usersbygroup.get({id:vm.groupid}, function(data) {
            for (var i=0;i<data.data.length;i++) {
              vm.users_in_group.push(data.data[i]);
            }
            //console.log('i am nop of '+vm.groupid);
            //console.log(vm.users_in_group);
          });
        });
      }
    //});

    //добавляем в список агентов текущего агента по объекту (если для НОПа уже подгружен список, то не добавляем)
    if (vm.users_in_group.length>0) {
      var checkInArray = false;

      for (var i=0;i<vm.users_in_group.length;i++) {
        //TODO эта часть кода выполняется по факту после загрузки данных
        //странный реверс - рахобраться в причинах
        vm.users_in_group[i].id = parseInt(vm.users_in_group[i].id);
        if (vm.users_in_group[i].id == vm.formWizard.owner_id) {
          checkInArray = true;
          //break;
        }
      }
      if (!checkInArray) {
        api.contacts.usernamebyid.get({id:vm.formWizard.owner_id}, function(data) {
          //vm.object_agent = data.name;
          //console.log(data);
          vm.users_in_group.push({'id': vm.formWizard.owner_id, 'name': data.data });
        });

      }
    }
    vm.formWizard.owner_id = vm.formWizard.owner_id;
    //console.log(vm.users_in_group);

      //получаем id объекта, который будем редактировать
      vm.objectId = $location.path().split('/');
      vm.objectId = vm.objectId[vm.objectId.length-1];
      //id главного изображения
      vm.mainImage = 0;
      //информацию по объекту
  api.objects.objectbyid.query({'id':vm.objectId}, function(data) {
      //console.log(data);
      vm.formWizard.region = parseInt(data.region);
      vm.formWizard.district = parseInt(data.district);
      vm.formWizard.city_type = data.city_type;
      vm.formWizard.city = data.city;

      vm.selectedItem = data.street;
      vm.formWizard.street = data.street;
      vm.formWizard.house_number = data.house_number;
      //загружаем адрес полностью
      loadAddress();
      //id главного изображения
      vm.mainImage = (parseInt(data.image)==0)?0:data.image;

      vm.formWizard.object_type = data.object_type;
      vm.formWizard.object_type_2 = data.object_type_2;
      vm.formWizard.direction = data.direction;

      vm.formWizard.metro_1 = data.metro_1;
      vm.formWizard.metro_2 = data.metro_2;
      vm.formWizard.metro_3 = data.metro_3;
      vm.formWizard.metro_1_time = data.metro_1_time;
      vm.formWizard.metro_2_time = data.metro_2_time;
      vm.formWizard.metro_3_time = data.metro_3_time;
      vm.loadMetrostationsName();

      vm.formWizard.deal_type = data.deal_type;
      vm.formWizard.source_id = data.source_id;
      vm.formWizard.part_percent = data.part_percent;
      vm.formWizard.rentcost = parseInt(data.rentcost);
      vm.formWizard.rent_duration = data.rent_duration;
      vm.formWizard.pay_duration = data.pay_duration;
      vm.formWizard.pay_type = data.pay_type;
      vm.formWizard.cost = parseInt(data.cost);
      vm.formWizard.commission = parseFloat(data.commission);
      vm.formWizard.commission_type = data.commission_type;
      vm.formWizard.rooms_number = data.rooms_number;
      vm.formWizard.story = parseInt(data.story);
      vm.formWizard.story_count = parseInt(data.story_count);
      vm.formWizard.countroom_office = parseInt(data.countroom_office);
      vm.formWizard.square_land = parseFloat(data.square_land);
      vm.formWizard.furniture = data.furniture;
      vm.formWizard.repairs = data.repairs;
      vm.formWizard.flat_status = data.flat_status;
      vm.formWizard.garage_type = data.garage_type;
      vm.formWizard.enegi = data.enegi;
      vm.formWizard.heating = data.heating;
      vm.formWizard.type_bild = data.type_bild;
      vm.formWizard.lift = data.lift;
      vm.formWizard.type_bathroom = data.type_bathroom;
      vm.formWizard.water_on_item = data.water_on_item;
      vm.formWizard.sewage_item = data.sewage_item;
      vm.formWizard.infra1 = data.infra1;
      vm.formWizard.infra2 = data.infra2;
      vm.formWizard.infra3 = data.infra3;
      vm.formWizard.spec1 = data.spec1;
      vm.formWizard.spec2 = data.spec2;
      vm.formWizard.spec3 = data.spec3;
      vm.formWizard.class_bild = data.class_bild;
      vm.formWizard.plan_bild = data.plan_bild;
      vm.formWizard.commerce_living_type = data.commerce_living_type;
      vm.formWizard.commerce_enter = data.commerce_enter;
      vm.formWizard.commerce_businesscenter = data.commerce_businesscenter;
      vm.formWizard.buildlevelh = parseFloat(data.buildlevelh);
      vm.formWizard.gas_item = data.gas_item;
      vm.formWizard.showcase = data.showcase;
      vm.formWizard.basement = data.basement;
      vm.formWizard.sub_place = data.sub_place;
      vm.formWizard.yearprofit = data.yearprofit;
      vm.formWizard.inet = data.inet;
      vm.formWizard.phone = data.phone;
      vm.formWizard.from_mcad = parseInt(data.from_mcad);
      vm.formWizard.tech_8 = data.tech_8;
      vm.formWizard.tech_4 = data.tech_4;
      vm.formWizard.square_all = parseFloat(data.square_all);
      vm.formWizard.officesq_stock = parseFloat(data.officesq_stock);
      vm.formWizard.usefulsq_stock = parseFloat(data.usefulsq_stock);
      vm.formWizard.bordersq_stock = parseFloat(data.bordersq_stock);
      vm.formWizard.workssq = parseFloat(data.workssq);
      vm.formWizard.shopsq = parseFloat(data.shopsq);

      vm.formWizard.description = data.description;
      vm.formWizard.description_en = data.description_en;
      vm.formWizard.creator_id = data.creator_id;
      vm.formWizard.owner_id = parseInt(data.owner_id);
      vm.formWizard.client_id = parseInt(data.client_id);
      vm.formWizard.avito = parseInt(data.avito);
      vm.formWizard.cian_prem = parseInt(data.cian_prem);
      vm.formWizard.xml_cian = parseInt(data.xml_cian);
      vm.formWizard.only_winner = parseInt(data.only_winner);
      vm.formWizard.only_cian = parseInt(data.only_cian);
      vm.formWizard.avito_turbo = parseInt(data.avito_turbo);
      vm.formWizard.linktour = data.linktour;

      //выносим, чтобы получить полный список клиентов (свои + клиент по объекту)
      api.contacts.my_clients.query({'id':vm.objectId}, function(data) {
        vm.my_clients = data;
      });
  });

  vm.table = {
    columns: [
    {
      "title": "Фотография"
    },
    {
      "title": "Размер"
    },
    {
      "title": ""
    }
    ],
    dtOptions: {
      dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth : false,
      responsive: true,
      pageLength: 100,
      searching: false,
      oLanguage: {
        sUrl:"/assets/datatables.lang"
      },
      "columns": [
        { "orderable": false },
        { "orderable": false }
        ],
        "order": [0, "desc"]
    }
  };

  updatePhotos(false);

  // Methods
  vm.sendForm = sendForm;
vm.loadDistricts = loadDistricts;
vm.loadCities = loadCities;
//vm.loadStreets = loadStreets;
vm.changeBildTypes = changeBildTypes;
  vm.loadAddress = loadAddress;
  vm.updatePhotos = updatePhotos;
  vm.successLoadPhotosMessage = successLoadPhotosMessage;
  vm.removePhoto = removePhoto;
  vm.setMainPhoto = setMainPhoto;

  vm.total = 0;
  vm.dtInstance = {};

  vm.dtIntanceCallback = function (instance) {
    vm.dtInstance = instance;
  }

  //устанавливаем фотографию главной
  function setMainPhoto(id)
      {
    $mdDialog.show({
              controller: function ($scope, $mdDialog)
              {
                  var mainphoto = new api.objects.mainphoto();
        mainphoto.id = id;
        mainphoto.$save();

        vm.mainImage = id;

                  $scope.closeDialog = function ()
                  {
                      $mdDialog.hide();
                  }
              },
              template: '<md-dialog>' +
              '  <md-dialog-content><h1>Фотография помечена как главная</h1></md-dialog-content>' +
              '  <md-dialog-actions>' +
              '    <md-button ng-click="closeDialog()" class="md-primary">' +
              '      Закрыть' +
              '    </md-button>' +
              '  </md-dialog-actions>' +
              '</md-dialog>',
              parent             : angular.element('body'),
              clickOutsideToClose: true
          });
  }

  //////////удаление фотографии
  function removePhoto(id)
      {
    $mdDialog.show({
              controller: function ($scope, $mdDialog)
              {
                  var archivephoto = new api.objects.archivephoto();
        archivephoto.id = id;
        archivephoto.$save();

                  $scope.closeDialog = function ()
                  {
                      $mdDialog.hide();
                      //обновляем список фотографий и таблицу сразу после загрузки
                      updatePhotos();
                  }
              },
              template: '<md-dialog>' +
              '  <md-dialog-content><h1>Фотография удалена</h1><div>Она исчезнет в таблице фотографий после сохранения изменений в объекте</div></md-dialog-content>' +
              '  <md-dialog-actions>' +
              '    <md-button ng-click="closeDialog()" class="md-primary">' +
              '      Закрыть' +
              '    </md-button>' +
              '  </md-dialog-actions>' +
              '</md-dialog>',
              parent             : angular.element('body'),
              clickOutsideToClose: true
          });
  }
  //////////обновление таблицы фотографий
  function updatePhotos(rotated)
      {
      rotated = typeof rotated !== 'undefined' ? rotated : 1;

      api.objects.objectphotosbyid.query({'id':vm.objectId}, function(data) {
          vm.photos = data.data;
          vm.total = vm.photos.length;
          //меняем адреса изображений
          for(var i=0; i < vm.photos.length;i++){
            //замена на адреса, как на сервере
            if (vm.photos[i].rotated == 1 || rotated==1) {
                vm.photos[i].filename = api.domain_name + api.domain_images + vm.photos[i].filename + '?rand=' + Math.round(Math.random() * (1000 - 1) + 1);
            } else {
                vm.photos[i].filename = api.domain_name + api.domain_images + vm.photos[i].filename;
            }
          }
      });
  }
  //Сообщение, что фото загружены
  function successLoadPhotosMessage()
      {
    $mdDialog.show({
        controller         : function ($scope, $mdDialog)
        {
          $scope.closeDialog = function ()
          {
            $mdDialog.hide();
            //обновляем список фотографий и таблицу сразу после загрузки
            updatePhotos();
          }
        },
        template: '<md-dialog>' +
        '  <md-dialog-content><h1>Фотографии успешно добавлены</h1></md-dialog-content>' +
        '  <md-dialog-actions>' +
        '    <md-button ng-click="closeDialog()" class="md-primary">' +
        '      Закрыть' +
        '    </md-button>' +
        '  </md-dialog-actions>' +
        '</md-dialog>',
        parent             : angular.element('body'),
        clickOutsideToClose: true
      });
  }
      //////////первоначальная загрузка адреса редактируемого объекта
      function loadAddress()
      {
    api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
      vm.districts = data;
      //vm.formWizard.district = id;
        var index_district = 0;
        //определяем реальный порядковый номер в массиве
        for (var i = 0; i < vm.districts.length; i++)
          if (vm.districts[i]['id'] == vm.formWizard.district) {
            index_district = i;
            api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
              vm.cities = data;
              //при загрузке страницы (только при редактировании) узнаем обязательна ли улица
              vm.isStreetRequired();
            });
        }
      });
  }
  //////////оставляем те же функции, что и при создании
  function loadDistricts()
  {
    api.objects.districts.query({'id':vm.formWizard.region}, function(data) {
      vm.districts = data;
      //обнуляем все, что ниже иерархически
      vm.cities = {};
      vm.streets = {};
      //делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
      vm.formWizard.district = null;
      vm.formWizard.city = null;
      //очищаем улицу
      vm.formWizard.street = null;
      vm.searchStreet = '';

      vm.formWizard.house_number = null;
      //для Москвы выбираем любой район, так как район города необязателен
      if (vm.formWizard.region == 1) {
        vm.formWizard.district = parseInt(vm.districts[vm.districts.length-1].id);
        loadCities();
        }
      });
}

function loadCities()
{
    //делаем невозможность перейти дальше по форме, не заполнив (если после заполнения сменили регион/район/...)
      vm.formWizard.city = null;
      //очищаем улицу
      vm.formWizard.street = '';
      vm.searchStreet = '';

      vm.formWizard.house_number = null;

    if (!vm.formWizard.city_type || (!vm.formWizard.district && vm.formWizard.region==2)) {
      vm.cities = {};
    } else {
      var index_district = 0;
      //определяем реальный порядковый номер в массиве
      for (var i = 0; i < vm.districts.length; i++)
        if (vm.districts[i]['id'] == vm.formWizard.district) {
          index_district = i;
          api.objects.cities.query({'code':vm.districts[index_district].code, 'socr': vm.formWizard.city_type}, function(data) {
            vm.cities = data;
            });
      }
    }
    vm.streets = {};
}

////////////////////////
//Поворот фотографий
vm.rotatePhoto  = function (filename,angle) {
  var rotatephoto = new api.objects.rotatephoto();
  rotatephoto.name = filename;
  rotatephoto.angle = angle;
  rotatephoto.$save();
  //обновляем список
  updatePhotos(1);
}

///////////////////////
vm.searchStreet = "";

//функция вывода списка улиц
vm.searchStreetResult = function (str) {
  //ищем хотя бы после 3 введенных символов, чтобы не показывать большие объемы улиц
  if (vm.searchStreet.length>2) {
    var index_city = 0;
    //так как города из КЛАДР и внутренних идентификаторов в массиве нет,
    //то ищем номер в массиве и узнаем его код КЛАДР

    for (var i = 0; i < vm.cities.length; i++)
      if (vm.cities[i]['name'] == vm.formWizard.city) {
        index_city = i;
        //стандартная загрузка через resource/http в контроллере не возвращает результат сразу же
        //dropdown обновляется на шаг позже - решено при помощи создания фабрики в модуле
        return GetStreetService.getStreets(vm.cities[index_city].code, str);
    }
  }
}

//если в директиве слушать напрямую изменение выбранной улицы, то
//функция срабатывает до изменения параметра в этой функции
//selectedItemChange() срабатывает позже непосредственной замены vm.selectedItem
//поэтому Blur срабатывает один раз даже когда введена улица из списка

//если объект создается
//vm.streetFromListWhenSelected = false;
//если объект редактируется - улица уже введена
vm.streetFromListWhenSelected = true;

//при выборе нового значения изменяем значение в модели для отправки
vm.selectedItemChange = function () {
  if (typeof(vm.selectedItem)=='object' && vm.selectedItem!=null) {

    vm.formWizard.street = vm.selectedItem.value;
    //улица выбрана из списка
    //так как в formWizard не работают ngMessages, то проверка идет после потери
    //фокуса поля Улица
    vm.streetFromListWhenSelected = true;
  } else {
    //улица не из списка
  }
}

vm.searchStringChange = function (text) {
  //если текст вообще введен
  if (text!==null) {
    //при любом изменении вводимого в улицу текста помечаем, что улица выбрана не из списка
    vm.streetFromList = false;
    vm.streetFromListWhenSelected = false;
  }
}

//делает поле обязательным, если в нас. пункте есть улицы по базе КЛАДР
vm.isStreetRequired = function () {
  var index_city = 0;
  //так как города из КЛАДР и внутренних идентификаторов в массиве нет, то ищем номер в массиве и узнаем
  //его код КЛАДР
  for (var i = 0; i < vm.cities.length; i++)
    if (vm.cities[i]['name'] == vm.formWizard.city) {
      index_city = i;
      api.objects.count_streets.query({'code':vm.cities[index_city].code}, function(data) {
        vm.street_qty = data[0].qty;
        //console.log('В данном населенном пункте '+vm.street_qty+' улиц');
      });
  }
  //очищаем улицу
  vm.formWizard.street = null;
}

//автозаполнение поля метро
vm.metroQuerySearch = function (query) {
  var lowercaseQuery = angular.lowercase(query);
  query = lowercaseQuery[0].toUpperCase() + lowercaseQuery.substr(1);

  var results = lowercaseQuery ? vm.metrostations.filter( createFilterFor(query) ) : vm.metrostations;
  return results;
}
//фильтр
function createFilterFor(query) {
  return function filterFn(metro) {
    return (metro.name.indexOf(query) === 0);
  };
}

  vm.loadMetrostationsName = function() {
    //определяем реальный порядковый номер в массиве
    //заполняем поля автозаполнения по метро
    var index_metro1 = 0;

    if (undefined !== vm.metrostations) {
      for (var i = 0; i < vm.metrostations.length; i++)
        if (vm.metrostations[i]['id'] == vm.formWizard.metro_1) {
          index_metro1 = i;
          vm.searchMetro_1 = vm.metrostations[i]['name'];
          break;
      }
      var index_metro2 = 0;
      for (var i = 0; i < vm.metrostations.length; i++)
        if (vm.metrostations[i]['id'] == vm.formWizard.metro_2) {
          index_metro2 = i;
          vm.searchMetro_2 = vm.metrostations[i]['name'];
          break;
      }

      var index_metro3 = 0;
      for (var i = 0; i < vm.metrostations.length; i++)
        if (vm.metrostations[i]['id'] == vm.formWizard.metro_3) {
          index_metro3 = i;
          vm.searchMetro_3 = vm.metrostations[i]['name'];
          break;
      }
    }
  }

  function changeBildTypes() {
    switch (vm.formWizard.object_type) {
      //типы зданий
      case 'office': //doNothing
      case 'stock': //doNothing
      case 'psn': //doNothing
      case 'production_room': //doNothing
      case 'ready_business': //doNothing
      case 'commercial_premises':
          vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
              {'name': 'panel', 'rusname': 'Панельный'},
              {'name': 'brick', 'rusname': 'Кирпичный'},
              {'name': 'wood', 'rusname': 'Деревянный'},
              {'name': 'stalin', 'rusname': 'Сталинский'},
              {'name': 'monolith', 'rusname': 'Монолит'},
              {'name': 'brickmonolith', 'rusname': 'Монолитно-кирпичный'},
              {'name': 'business_center', 'rusname': 'Бизнес-центр'},
              {'name': 'office_building', 'rusname': 'Офисное здание'},
              {'name': 'office_complex', 'rusname': 'Комплекс офисных зданий'},
              {'name': 'mansion', 'rusname': 'Особняк'},
              {'name': 'retail_office_complex', 'rusname': 'Торгово-офисный комплекс'},
              {'name': 'office_residential_complex', 'rusname': 'Офисно-жилой комплекс'},
              {'name': 'administrative_building', 'rusname': 'Административное зданиие'},
              {'name': 'mall', 'rusname': 'Торгово-развлекательный центр'},
              {'name': 'business_park', 'rusname': 'Бизнес-парк'},
              {'name': 'multifuctional_complex', 'rusname': 'Многофункциональный комплекс'}];
              break
      case 'garage':
          vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
              {'name': 'brick', 'rusname': 'Кирпичный'},
              {'name': 'iron', 'rusname': 'Железный каркас'},
              {'name': 'shell', 'rusname': 'Ракушка'}];
              break
      case 'parkingPlace':
          vm.type_bild_list = [{'name': 'block', 'rusname': 'Блочный'},
              {'name': 'brick', 'rusname': 'Кирпичный'},
              {'name': 'iron', 'rusname': 'Железный каркас'},
              {'name': 'shell', 'rusname': 'Ракушка'}];
              break             
          }
  }

 



      function sendForm(ev)
      {
          $mdDialog.show({
              controller         : function ($scope, $mdDialog, formWizardData)
              {
                  $scope.formWizardData = formWizardData;

        var editobject = new api.objects.editobjectdata();
        editobject.data = formWizardData;
        editobject.$save();

                  $scope.closeDialog = function ()
                  {
                      $mdDialog.hide();
                      $location.path('/objects/commerce');
                  }
              },
              template: '<md-dialog>' +
              '  <md-dialog-content><h1>Объект успешно изменен</h1></md-dialog-content>' +
              '  <md-dialog-actions>' +
              '    <md-button ng-click="closeDialog()" class="md-primary">' +
              '      Закрыть' +
              '    </md-button>' +
              '  </md-dialog-actions>' +
              '</md-dialog>',
              parent             : angular.element('body'),
              targetEvent        : ev,
              locals             : {
                  formWizardData: vm.formWizard
              },
              clickOutsideToClose: true
          });
          vm.formWizard = {};
}

///////////////////////Загрузка фотографий
var hideUpload = false; //переменная для сокрытия кнопки загрузки после одной загрузки (чтобы не заливали одно и то же, пока нет онлайн обновления таблицы)
var uploader = $scope.uploader = new FileUploader({
    //инкапсулируем скрипт загрузки в общий модуль, чтобы проверять авторизацию
          url: api.localhost_backend + 'upload',
          removeAfterUpload: true,
    formData: {'id':vm.objectId}
      });

      // FILTERS
      uploader.filters.push({
          name: 'customFilter',
          fn: function(item /*{File|FileLikeObject}*/, options) {
              return this.queue.length < 10;
          }
      });

      // File must not be larger then some size
      uploader.filters.push({ name: 'sizeFilter', fn: function(item) {
         return item.size < 1024*1024*2.5;
      }});


      //События Callbacks
      uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
          console.info('onWhenAddingFileFailed', item, filter, options);
          alert("Один или несколько файлов имеют размер больше 2.5 Мб!");
      };
      uploader.onAfterAddingFile = function(fileItem) {
          console.info('onAfterAddingFile', fileItem);
      };
      uploader.onAfterAddingAll = function(addedFileItems) {
    hideUpload = true;
          console.info('onAfterAddingAll', addedFileItems);
      };
      uploader.onBeforeUploadItem = function(item) {
          console.info('onBeforeUploadItem', item);
      };
      uploader.onProgressItem = function(fileItem, progress) {
          console.info('onProgressItem', fileItem, progress);
      };
      uploader.onProgressAll = function(progress) {
          console.info('onProgressAll', progress);
      };
      uploader.onSuccessItem = function(fileItem, response, status, headers) {
          console.info('onSuccessItem', fileItem, response, status, headers);
      };
      uploader.onErrorItem = function(fileItem, response, status, headers) {
          console.info('onErrorItem', fileItem, response, status, headers);
      };
      uploader.onCancelItem = function(fileItem, response, status, headers) {
          console.info('onCancelItem', fileItem, response, status, headers);
      };
      uploader.onCompleteItem = function(fileItem, response, status, headers) {
          console.info('onCompleteItem', fileItem, response, status, headers);
      };
      uploader.onCompleteAll = function() {
          console.info('onCompleteAll');
          updatePhotos();
      };
      console.info('uploader', uploader);

}

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.requests.editrequest',[])
        .controller('EditRequestController', EditRequestController);

    /** @ngInject */
    function EditRequestController($mdDialog, $location, api)
    {
        var vm = this;

        // Data
        vm.basicForm = {};

        vm.requestId = $location.path().split('/');
        //получаем id заявки, которую смотрим
        vm.requestId = vm.requestId[vm.requestId.length-1];

		//Список регионов и изначально установленный
		vm.regions = [{'id':1, 'name': 'Москва'}, {'id':2, 'name': 'Московская область'}];

    vm.basicForm.wantclient = false;

		//получаем информацию по заявке
		api.requests.requestbyid.query({'id':vm.requestId}, function(data) {
			data = data.data;
			//console.log(data[0]);
			vm.basicForm.name = data[0].name;
			vm.basicForm.region = parseInt(data[0].region);
			vm.basicForm.text = data[0].text;
			vm.basicForm.phone = data[0].phone;
			vm.basicForm.user_comment = data[0].user_comment;

			if (data[0].active=='yes') vm.basicForm.active = true;
			 else vm.basicForm.active = false;

			if (data[0].success=='yes') vm.basicForm.success = true;
			 else vm.basicForm.success = false;

			vm.basicForm.date = data[0].date;

			///////////////////////////////////////////
			//человекопонятное название
			switch(data[0].type) {
				case 'vacancy': vm.basicForm.type = 'Заявка на собеседование'; break
				case 'call': vm.basicForm.type = 'Заявка на звонок'; break
				case 'purchase': vm.basicForm.type = 'Заявка на покупку';
								 switch(data[0].object) {
									case 'flat': vm.basicForm.type = vm.basicForm.type + ' квартиры'; break
									case 'room': vm.basicForm.type = vm.basicForm.type + ' комнаты'; break
									case 'house': vm.basicForm.type = vm.basicForm.type + ' дома'; break
								 }
								 break
				case 'sale': vm.basicForm.type = 'Заявка на продажу';
							 switch(data[0].object) {
									case 'flat': vm.basicForm.type = vm.basicForm.type + ' квартиры'; break
									case 'room': vm.basicForm.type = vm.basicForm.type + ' комнаты'; break
									case 'house': vm.basicForm.type = vm.basicForm.type + ' дома'; break
							 }
							 break

			}

		});
        // Methods
        vm.sendForm = sendForm;
        vm.addClient = addClient;
        vm.getRequestData4Client = getRequestData4Client;

          function getRequestData4Client() {
            //для создания клиента
            if (vm.basicForm.wantclient==true) {
              vm.basicForm.firstname = (vm.basicForm.name).charAt(0).toUpperCase() + (vm.basicForm.name).substr(1);
              vm.basicForm.phone_1 = vm.basicForm.phone;
              vm.hideCreateClient = 0;
            }
          }

          function addClient() {
      			$mdDialog.show({
                      controller         : function ($scope, $mdDialog)
                      {
                        var newclient = new api.contacts.newclientdata();
                        newclient.firstname = vm.basicForm.firstname;
                        newclient.phone_1 = vm.basicForm.phone_1;
                        newclient.type = 'person';
                        newclient.status = 'work';
                        newclient.$save();
                        vm.hideCreateClient = 1;
      					////////////////////////////////
                          $scope.closeDialog = function ()
                          {
                              $mdDialog.hide();
                          }
                      },
                      template: '<md-dialog>' +
                      '  <md-dialog-content><h1>Клиент создан</h1><div>Пометьте заявку как обработанную. После этого Вы сможете найти своего клиента в соответствующем разделе контактов</div></md-dialog-content>' +
                      '  <md-dialog-actions>' +
                      '    <md-button ng-click="closeDialog()" class="md-primary">' +
                      '      Закрыть' +
                      '    </md-button>' +
                      '  </md-dialog-actions>' +
                      '</md-dialog>',
                      parent             : angular.element('body'),
                      clickOutsideToClose: true
                  });
      		}

        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, basicFormData)
                {
          $scope.basicForm = basicFormData;

					switch($scope.basicForm.active) {
						case true: $scope.basicForm.active = 'yes'; break
						case false: $scope.basicForm.active = 'no'; break
					}

					switch($scope.basicForm.success) {
						case true: $scope.basicForm.success = 'yes'; break
						case false: $scope.basicForm.success = 'no'; break
					}

					$scope.basicForm.id = vm.requestId;

					var editrequest = new api.requests.editrequest();
					editrequest.data = basicFormData;
					editrequest.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/requests');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Заявка обработана и отправлена в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    basicFormData: vm.basicForm
                },
                clickOutsideToClose: true
            });
            vm.basicForm = {};
        }
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.deals.newdeal',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.deals_newdeal', {
            url    : '/deal/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/modules/deals/newdeal/newdeal.html',
                    controller : 'NewDealController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }
    

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.deals.newdeal')
        .controller('NewDealController', NewDealController);

    /** @ngInject */
    function NewDealController($scope, $mdDialog, $location, api)
    {
        var vm = this;
        // Data
        vm.formWizard = {};

		//типы сделок
		vm.deal_types = [{'name': 'sell', 'rusname': 'Продажа'},
						{'name': 'buy', 'rusname': 'Покупка'},
						{'name': 'alternative', 'rusname': 'Альтернатива'},
						{'name': 'consultation', 'rusname': 'Консультационная'},
						{'name': 'auction', 'rusname': 'Аукцион'},
						{'name': 'rent', 'rusname': 'Аренда от собственника'},
						{'name': 'hire', 'rusname': 'Аренда - поиск'}];
		vm.formWizard.deal_type = 'sell';

		//тип объекта
		vm.object_types = [{'name': 'flat', 'rusname': 'Квартира/доля/комната'},
						{'name': 'house', 'rusname': 'Дом/дача/участок'},
						{'name': 'commerce', 'rusname': 'Коммерческое помещение'}];
		vm.formWizard.object_type = 'flat';

        //статусы сделок
        vm.status_types = [{'id': '1', 'rusname': 'Активная'},
						{'id': '2', 'rusname': 'Открытая'},
						{'id': '3', 'rusname': 'Проведенная'},
						{'id': '4', 'rusname': 'Закрытая'},
						{'id': '5', 'rusname': 'Развал'}];

		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Да'},
						{'name': 'no', 'rusname': 'Нет'}];

        // Methods
        vm.sendForm = sendForm;
		vm.loadObjectAddress = loadObjectAddress;
		vm.loadClientName = loadClientName;
		vm.loadSellerName = loadSellerName;
		vm.loadAgentName = loadAgentName;
        //////////
        function loadObjectAddress(id)
        {
			if (id==null) id = vm.formWizard.object_id;

			api.objects.objectbyid.query({'id': id}, function(data) {

  				if (data.city!=null) {
            vm.formWizard.object_address = data.city_type + '.' + data.city;
            if (data.street!=null && data.street!=' ') {
              vm.formWizard.object_address += ', ' + data.street;
              if (data.house_number!=null) {
                vm.formWizard.object_address += ', ' + data.house_number;
              }
            }
          }

			});
		}

		function loadClientName(id)
        {
			if (id==null) id = vm.formWizard.client_id;

			api.contacts.clientbyid.query({'id':id}, function(data) {
				if (data[0].firstname!=null) {
          vm.formWizard.client_name = data[0].firstname;
          if (data[0].lastname!=null) {
            vm.formWizard.client_name += ' ' + data[0].lastname;
          }
        }
			});
		}

		function loadSellerName(id)
        {
			if (id==null) id = vm.formWizard.seller_id;

			api.contacts.clientbyid.query({'id':id}, function(data) {
				vm.formWizard.seller_name = data[0].firstname + ' ' + data[0].lastname;
        if (data[0].firstname!=null) {
          vm.formWizard.seller_name = data[0].firstname;
          if (data[0].lastname!=null) {
            vm.formWizard.seller_name += ' ' + data[0].lastname;
          }
        }
			});
		}

		function loadAgentName(id)
        {
			var userid;
			switch(id) {
				case 1: userid = vm.formWizard.access_user_id; break
				case 2: userid = vm.formWizard.access_subagent1_id; break
				case 3: userid = vm.formWizard.access_subagent2_id; break
			}

			api.contacts.userbyid.query({'id': userid}, function(data) {
				switch(id) {
					case 1: vm.formWizard.agent1name = (data[0].lastname==null)?data[0].firstname:data[0].firstname + ' ' + data[0].lastname; break
					case 2: vm.formWizard.agent2name = (data[0].lastname==null)?data[0].firstname:data[0].firstname + ' ' + data[0].lastname; break
					case 3: vm.formWizard.agent3name = (data[0].lastname==null)?data[0].firstname:data[0].firstname + ' ' + data[0].lastname; break
				}
			});
		}

        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;

					var newdeal = new api.deals.newdeal();
					newdeal.data = formWizardData;
					newdeal.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/deals');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Сделка успешно создана</h1><div>Теперь агент может редактировать ее, загрузить нужные документы. Номер Вы увидите в общем списке</div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.deals.editdeal', ['datatables','ngResource','angularFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.deals_editdeal', {
            url    : '/deal/edit/{id:int}',
            views  : {
                'content@app': {
                    templateUrl: 'app/modules/deals/editdeal/editdeal.html',
                    controller : 'EditDealController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }
    
    
    

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.deals.editdeal')
        .controller('EditDealController', EditDealController);

    /** @ngInject */
    function EditDealController($rootScope, $scope, $mdDialog, $location, $resource, FileUploader, api)
    {
    var vm = this;
    // Data
    vm.formWizard = {};


		//типы сделок
		vm.deal_types = [{'name': 'sell', 'rusname': 'Продажа'},
						{'name': 'buy', 'rusname': 'Покупка'},
						{'name': 'alternative', 'rusname': 'Альтернатива'},
						{'name': 'consultation', 'rusname': 'Консультационная'},
						{'name': 'auction', 'rusname': 'Аукцион'},
						{'name': 'rent', 'rusname': 'Аренда от собственника'},
						{'name': 'hire', 'rusname': 'Аренда - поиск'}];

		//тип объекта
		vm.object_types = [{'name': 'flat', 'rusname': 'Квартира/доля/комната'},
						{'name': 'house', 'rusname': 'Дом/дача/участок'},
						{'name': 'commerce', 'rusname': 'Коммерческое помещение'}];
		vm.formWizard.object_type = 'flat';

        //статусы сделок
        vm.status_types = [{'id': '1', 'rusname': 'Активная'},
						{'id': '2', 'rusname': 'Открытая'},
						{'id': '3', 'rusname': 'Проведенная'},
						{'id': '4', 'rusname': 'Закрытая'},
						{'id': '5', 'rusname': 'Развал'}];

		//массив - да / нет
        vm.yes_no_array = [{'name': 'yes', 'rusname': 'Да'},
						{'name': 'no', 'rusname': 'Нет'}];

		//Список категорий для документов
		api.deals.docdirectories.query({}, function(data) {
			vm.directories = data.data;
			vm.directories1 = [];
			for(var i=0; i < vm.directories.length-1;i++) {
				vm.directories1[parseInt(vm.directories[i].id)] = {'id': vm.directories[i].id, 'name': vm.directories[i].name};
			}
			console.log(vm.directories1);
		});
		vm.formWizard.directory = 3;

        //получаем id сделки, которую будем редактировать
        vm.dealId = $location.path().split('/');
        vm.dealId = vm.dealId[vm.dealId.length-1];
        vm.dealName = '';

        //информацию по объекту
		api.deals.dealbyid.query({'id':vm.dealId}, function(data) {
				vm.formWizard.client_id = parseInt(data.client_id);
				vm.formWizard.seller_id = parseInt(data.seller_id);
				vm.formWizard.object_id = parseInt(data.object_id);
				vm.formWizard.request_id = parseInt(data.request_id);
				vm.formWizard.deal_type = data.deal_type;
				vm.formWizard.object_address = data.object_address;
				vm.formWizard.object_type = data.object_type;
				vm.formWizard.about = data.about;
				vm.dealName = data.deal_name;
				vm.formWizard.cost = parseInt(data.cost);
				vm.formWizard.comission = parseInt(data.comission);
				vm.formWizard.fee_sub0 = parseInt(data.fee_sub0);
				vm.formWizard.fee_sub1 = parseInt(data.fee_sub1);
				vm.formWizard.fee_sub2 = parseInt(data.fee_sub2);
				vm.formWizard.access_user_id = parseInt(data.access_user_id);
				vm.formWizard.access_subagent1_id = parseInt(data.access_subagent1_id);
				vm.formWizard.access_subagent2_id = parseInt(data.access_subagent2_id);

				vm.formWizard.status = data.status;
				//vm.formWizard.pay_duration = data.pay_duration;
				vm.formWizard.creation_date = data.creation_date;
				vm.formWizard.invest = data.invest;
				//vm.formWizard.active = data.active;

				//загружаем адреса и имена по id
				if (parseInt(data.object_id)>0) loadObjectAddress(parseInt(data.object_id));
				loadClientName(parseInt(data.client_id));
				loadSellerName(parseInt(data.seller_id));
				loadAgentName(1);
				if (data.access_subagent1_id) loadAgentName(2);
				if (data.access_subagent2_id) loadAgentName(3);

        vm.deal_group_id = data.group_id;

        if (data.active == 'yes') {
          vm.archive = false;
        } else {
          vm.archive = true;
        }
		});

    //получаем id своей учетной записи для сверки собственности на сделку
    api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
			vm.userid = data.user_id;
		});
		//получаем id своего отдела
    api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
			vm.groupid = data.group_id;
		});

		vm.table = {
		  columns: [
			{
			  "title": "Документ"
			},
			{
			  "title": "Категория"
			},
			{
			  "title": "Размер"
			},
			{
			  "title": ""
			}
		  ],
		  dtOptions: {
				dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
				pagingType: 'simple',
				autoWidth : false,
				responsive: true,
				pageLength: 100,
				searching: false,
				oLanguage: {
					sUrl:"/assets/datatables.lang"
				},
				"columns": [
					{ "orderable": false },
					{ "orderable": false },
					{ "orderable": false },
          { "orderable": false }
				  ],
				  "order": [1, "asc"]
		  }
		};
		//загружаем список документов
		updateDocs();

        // Methods
        vm.sendForm = sendForm;
		vm.updateDocs = updateDocs;
		vm.successLoadDocMessage = successLoadDocMessage;
		vm.removeDoc = removeDoc;
		vm.loadObjectAddress = loadObjectAddress;
		vm.loadClientName = loadClientName;
		vm.loadSellerName = loadSellerName;
		vm.loadAgentName = loadAgentName
    //проверка на архив и установка переменной на архив
    //vm.Arch = changeArchiveStatus;
    vm.isArch = checkArchiveStatus;
		vm.archivedeal = archivedeal;
		vm.restoredeal = restoredeal;
		vm.restore_archivedeal = restore_archivedeal;

        // Methods
        //////////////////////////////

        function restore_archivedeal(id) {
    			if (vm.archive == true) {
    				restoredeal(id);
    			}
    			else {
    				archivedeal(id);
    			}
    		}
    		//удаление сделки
    		function archivedeal(id) {
    			$mdDialog.show({
                    controller         : function ($scope, $mdDialog)
                    {
                        var archivedeal = new api.deals.archivedeal();
    					archivedeal.id = id;
    					archivedeal.$save();

                        $scope.closeDialog = function ()
                        {
                            $mdDialog.hide();
                            $location.path('/deals/archive');
                        }
                    },
                    template: '<md-dialog>' +
                    '  <md-dialog-content><h1>Сделка {{id}} отправлена в архив</h1></md-dialog-content>' +
                    '  <md-dialog-actions>' +
                    '    <md-button ng-click="closeDialog()" class="md-primary">' +
                    '      Закрыть' +
                    '    </md-button>' +
                    '  </md-dialog-actions>' +
                    '</md-dialog>',
                    parent             : angular.element('body'),
                    clickOutsideToClose: true
                });
    		}
    		//восстановление сделки
    		function restoredeal(id) {
    			$mdDialog.show({
                    controller         : function ($scope, $mdDialog)
                    {
                        var restoredeal = new api.deals.restoredeal();
    					restoredeal.id = id;
    					restoredeal.$save();

                        $scope.closeDialog = function ()
                        {
                            $mdDialog.hide();
                            $location.path('/deals');
                        }
                    },
                    template: '<md-dialog>' +
                    '  <md-dialog-content><h1>Сделка {{id}} восстановлена из архива</h1></md-dialog-content>' +
                    '  <md-dialog-actions>' +
                    '    <md-button ng-click="closeDialog()" class="md-primary">' +
                    '      Закрыть' +
                    '    </md-button>' +
                    '  </md-dialog-actions>' +
                    '</md-dialog>',
                    parent             : angular.element('body'),
                    clickOutsideToClose: true
                });
    		}

        ///////////////////////////////
    function checkArchiveStatus() {
      if (vm.archive == true) {
        return 'Восстановить';
      } else if (vm.archive == false) {
        return 'В архив';
      }
    }
        //////////
        function loadObjectAddress(id)
        {
			if (id==null) id = vm.formWizard.object_id;

			api.objects.objectbyid.query({'id': id}, function(data) {

  				if (data.city!=null) {
            vm.formWizard.object_address = data.city_type + '.' + data.city;
            if (data.street!=null && data.street!=' ') {
              vm.formWizard.object_address += ', ' + data.street;
              if (data.house_number!=null) {
                vm.formWizard.object_address += ', ' + data.house_number;
              }
            }
          }

			});
		}

		function loadClientName(id)
        {
			if (id==null) id = vm.formWizard.client_id;

			api.contacts.clientbyid.query({'id':id}, function(data) {
				if (data[0].firstname!=null) {
          vm.formWizard.client_name = data[0].firstname;
          if (data[0].lastname!=null) {
            vm.formWizard.client_name += ' ' + data[0].lastname;
          }
        }
			});
		}

		function loadSellerName(id)
        {
			if (id==null) id = vm.formWizard.seller_id;

			api.contacts.clientbyid.query({'id':id}, function(data) {
				vm.formWizard.seller_name = data[0].firstname + ' ' + data[0].lastname;
        if (data[0].firstname!=null) {
          vm.formWizard.seller_name = data[0].firstname;
          if (data[0].lastname!=null) {
            vm.formWizard.seller_name += ' ' + data[0].lastname;
          }
        }
			});
		}

		function loadAgentName(id)
        {
			var userid;
			switch(id) {
				case 1: userid = vm.formWizard.access_user_id; break
				case 2: userid = vm.formWizard.access_subagent1_id; break
				case 3: userid = vm.formWizard.access_subagent2_id; break
			}

			api.contacts.userbyid.query({'id': userid}, function(data) {
				switch(id) {
					case 1: vm.formWizard.agent1name = (data[0].lastname==null)?data[0].firstname:data[0].firstname + ' ' + data[0].lastname; break
					case 2: vm.formWizard.agent2name = (data[0].lastname==null)?data[0].firstname:data[0].firstname + ' ' + data[0].lastname; break
					case 3: vm.formWizard.agent3name = (data[0].lastname==null)?data[0].firstname:data[0].firstname + ' ' + data[0].lastname; break
				}
			});
		}

		///////////////////обновление таблицы документов после загрузки
		vm.total = 0;
		vm.dtInstance = {};

    vm.dtIntanceCallback = function (instance) {
			vm.dtInstance = instance;
		}

		//////////удаление документа
		function removeDoc(id)
        {
          var archivedoc = new api.deals.archivedoc();
          archivedoc.id = id;
          archivedoc.$save();
          //обновляем список документов и таблицу сразу после загрузки
          vm.documents.splice(0, 1);
          updateDocs();
		}
		//////////обновление таблицы документов
		function updateDocs()
        {
			var filename = '';
			api.deals.dealdocsbyid.query({'id':vm.dealId}, function(data) {
				vm.documents = data.data;
				vm.total = vm.documents.length;
				//console.log(vm.total);
				//меняем адреса
				for(var i=0; i < vm.documents.length;i++) {
					filename = vm.documents[i].filename_original;
					filename = filename.split('.');

					vm.documents[i].icon = filename[filename.length - 1];
					filename.splice(filename.length - 1, 1);
					//если было несколько точек в имени
					vm.documents[i].filename_original = filename.join('.');
					//отображаем директорию текстом
					vm.documents[i].directory = vm.directories1[vm.documents[i].directory].name;
					//подставляем иконку
					switch (vm.documents[i].icon) {
						case 'jpg': vm.documents[i].icon = 'icon-file-image'; break
						case 'jpeg': vm.documents[i].icon = 'icon-file-image'; break
						case 'png': vm.documents[i].icon = 'icon-file-image'; break
						case 'xls': vm.documents[i].icon = 'icon-file-excel'; break
						case 'xlsx': vm.documents[i].icon = 'icon-file-excel'; break
						case 'doc': vm.documents[i].icon = 'icon-file-word'; break
						case 'docx': vm.documents[i].icon = 'icon-file-word'; break
						case 'pdf': vm.documents[i].icon = 'icon-file-pdf'; break
						default: vm.documents[i].icon = 'icon-file-document'; break
					}
vm.documents[i].download_filename = api.localhost_backend + 'document/download/' + vm.documents[i].filename;
					vm.documents[i].filename = api.localhost_backend + 'document/view/' + vm.documents[i].filename;
				}
			});
		}
		//Сообщение, что документы загружены
		function successLoadDocMessage()
        {
			$mdDialog.show({
					controller         : function ($scope, $mdDialog)
					{
						$scope.closeDialog = function ()
						{
							$mdDialog.hide();
							//обновляем список документов и таблицу сразу после загрузки
							//updateDocs();
						}
					},
					template: '<md-dialog>' +
					'  <md-dialog-content><h1>Документы успешно добавлены</h1></md-dialog-content>' +
					'  <md-dialog-actions>' +
					'    <md-button ng-click="closeDialog()" class="md-primary">' +
					'      Закрыть' +
					'    </md-button>' +
					'  </md-dialog-actions>' +
					'</md-dialog>',
					parent             : angular.element('body'),
					clickOutsideToClose: true
				});
		}

        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;

          					var editdeal = new api.deals.editdeal();
          					editdeal.data = formWizardData;
          					editdeal.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/deals');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Сделка успешно изменена</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
	}

	///////////////////////Загрузка документов
	var hideUpload = false; //переменная для сокрытия кнопки загрузки после одной загрузки (чтобы не заливали одно и то же, пока нет онлайн обновления таблицы)
	var uploader = $scope.uploader = new FileUploader({
			//инкапсулируем скрипт загрузки в общий модуль, чтобы проверять авторизацию
            url: api.localhost_backend + 'uploaddocs/' + vm.formWizard.directory,
            removeAfterUpload: true,
			      formData: {'id':vm.dealId}
        });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        //События Callbacks
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
        };
        uploader.onAfterAddingFile = function(fileItem) {
            console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
		        hideUpload = true;
            console.info('onAfterAddingAll', addedFileItems);
        };
        /*uploader.onBeforeUploadItem = function(item) {
            console.info('onBeforeUploadItem', item);
        };*/
        uploader.onBeforeUploadItem = function(item) {
                item.url = api.localhost_backend + 'uploaddocs/' + vm.formWizard.directory;
        };
        uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            console.info('onCompleteAll');
            //обновляем список документов
            vm.documents.splice(0, 1);
            updateDocs();
        };
        console.info('uploader', uploader);
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.typography', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_typography', {
            url      : '/ui/typography',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/typography/typography.html',
                    controller : 'TypographyController as vm'
                }
            },
            bodyClass: 'typography'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography')
        .controller('TypographyController', TypographyController);

    /** @ngInject */
    function TypographyController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('ThemeColorsController', ThemeColorsController);

    /** @ngInject */
    function ThemeColorsController(fuseTheming, $mdDialog, $document)
    {
        var vm = this;
        // Data
        vm.themes = fuseTheming.themes;

        // Methods
        vm.createTheme = createTheme;
        //////////

        function createTheme(ev)
        {
            $mdDialog.show({
                controller         : 'CustomThemeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_material-colors', {
            url  : '/ui/material-colors',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/material-colors/material-colors.html',
                    controller : 'MaterialColorsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors')
        .controller('MaterialColorsController', MaterialColorsController);

    /** @ngInject */
    function MaterialColorsController($mdColorPalette)
    {
        var vm = this;

        // Data
        vm.palettes = $mdColorPalette;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_icons', {
            url      : '/ui/icons',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/icons/icons.html',
                    controller : 'IconsController as vm'
                }
            },
            resolve  : {
                Icons: function (apiResolver)
                {
                    return apiResolver.resolve('icons@get');
                }
            },
            bodyClass: 'icons'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons')
        .controller('IconsController', IconsController);

    /** @ngInject */
    function IconsController(Icons)
    {
        var vm = this;

        // Data
        vm.icons = Icons.icons;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_forms', {
            url      : '/ui/forms',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/forms/forms.html',
                    controller : 'FormsController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms')
        .controller('FormsController', FormsController);

    /** @ngInject */
    function FormsController($mdDialog)
    {
        var vm = this;

        // Data
        vm.basicForm = {};
        vm.formWizard = {};

        vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
        'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
        'WY').split(' ').map(function (state)
        {
            return {abbrev: state};
        });

        // Methods
        vm.sendForm = sendForm;

        //////////

        /**
         * Send form
         */
        function sendForm(ev)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });

            // Clear the form data
            vm.formWizard = {};
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_timeline', {
                url      : '/pages/timeline',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (apiResolver)
                    {
                        return apiResolver.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline'
            })
            .state('app.pages_timeline_left', {
                url      : '/pages/timeline-left',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-left.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (apiResolver)
                    {
                        return apiResolver.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-left'
            })
            .state('app.pages_timeline_right', {
                url      : '/pages/timeline-right',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-right.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (apiResolver)
                    {
                        return apiResolver.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-right'
            });

        // Navigation
        msNavigationServiceProvider.saveItem('pages.timeline', {
            title : 'Timeline',
            icon  : 'icon-view-stream',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('pages.timeline.default', {
            title: 'Default',
            state: 'app.pages_timeline'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.left-aligned', {
            title: 'Left Aligned',
            state: 'app.pages_timeline_left'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.right-aligned', {
            title: 'Right Aligned',
            state: 'app.pages_timeline_right'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline')
        .controller('TimelineController', TimelineController);

    /** @ngInject */
    function TimelineController($q, api, Timeline)
    {
        var vm = this;

        // Data
        vm.timeline = Timeline.data;
        vm.currentPage = 1;
        vm.totalPages = 3;
        vm.pauseScroll = false;

        // Methods
        vm.loadNextPage = loadNextPage;

        //////////

        /**
         * Load next page
         * @returns promise
         */
        function loadNextPage()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Increase the current page number
            vm.currentPage = vm.currentPage + 1;

            // Check if we still have pages that we can load
            if ( vm.currentPage > vm.totalPages )
            {
                // Reject the promise
                deferred.reject('No more pages');
            }
            else
            {
                // Emulate the api call and load new timeline items in
                var pageName = 'page' + vm.currentPage;

                api.timeline[pageName].get({},

                    // SUCCESS
                    function (response)
                    {
                        for ( var i = 0; i < response.data.length; i++ )
                        {
                            vm.timeline.push(response.data[i]);
                        }

                        // Resolve the promise
                        deferred.resolve(response);
                    },

                    // ERROR
                    function (response)
                    {
                        // Reject the promise
                        deferred.reject(response);
                    }
                );
            }

            return deferred.promise;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.search', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_search', {
            url      : '/pages/search',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/search/search.html',
                    controller : 'SearchController as vm'
                }
            },
            resolve  : {
                Classic : function (apiResolver)
                {
                    return apiResolver.resolve('search.classic@get');
                },
                Mails   : function (apiResolver)
                {
                    return apiResolver.resolve('search.mails@get');
                },
                Users   : function (apiResolver)
                {
                    return apiResolver.resolve('search.users@get');
                },
                Contacts: function (apiResolver)
                {
                    return apiResolver.resolve('search.contacts@get');
                }
            },
            bodyClass: 'search'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/search');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.search', {
            title : 'Search',
            icon  : 'icon-magnify',
            state : 'app.pages_search',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController(Classic, Mails, Users, Contacts)
    {
        var vm = this;

        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.classic = Classic.data;
        vm.mails = Mails.data;
        vm.users = Users.data;
        vm.contacts = Contacts.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.pages_profile', {
            url      : '/pages/profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            resolve  : {
                Timeline    : function (apiResolver)
                {
                    return apiResolver.resolve('profile.timeline@get');
                },
                About       : function (apiResolver)
                {
                    return apiResolver.resolve('profile.about@get');
                },
                PhotosVideos: function (apiResolver)
                {
                    return apiResolver.resolve('profile.photosVideos@get');
                }
            },
            bodyClass: 'profile'
        });

        $translatePartialLoaderProvider.addPart('app/main/pages/profile');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.profile', {
            title : 'Profile',
            icon  : 'icon-account',
            state : 'app.pages_profile',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController(Timeline, About, PhotosVideos)
    {
        var vm = this;

        // Data
        vm.posts = Timeline.posts;
        vm.activities = Timeline.activities;
        vm.about = About.data;
        vm.photosVideos = PhotosVideos.data;

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/pages/maintenance',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/main/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/maintenance');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.maintenance', {
            title : 'Maintenance',
            icon  : 'icon-oil',
            state : 'app.pages_maintenance',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_invoice', {
            url      : '/pages/invoice',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/invoice/invoice.html',
                    controller : 'InvoiceController as vm'
                }
            },
            resolve  : {
                Invoice: function (apiResolver)
                {
                    return apiResolver.resolve('invoice@get');
                }
            },
            bodyClass: 'invoice printable'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/invoice');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.invoice', {
            title : 'Invoice',
            icon  : 'icon-receipt',
            state : 'app.pages_invoice',
            weight: 4
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice')
        .controller('InvoiceController', InvoiceController);

    /** @ngInject */
    function InvoiceController(Invoice)
    {
        var vm = this;

        // Data
        vm.invoice = Invoice.data;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_coming-soon', {
            url      : '/pages/coming-soon',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_coming-soon': {
                    templateUrl: 'app/main/pages/coming-soon/coming-soon.html',
                    controller : 'ComingSoonController as vm'
                }
            },
            bodyClass: 'coming-soon'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/coming-soon');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.coming-soon', {
            title : 'Coming Soon',
            icon  : 'icon-alarm-check',
            state : 'app.pages_coming-soon',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon')
        .controller('ComingSoonController', ComingSoonController);

    /** @ngInject */
    function ComingSoonController()
    {
        var vm = this;

        // Data
        vm.endTime = 1472975790000;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.widgets', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_widgets', {
            url  : '/components/widgets',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/widgets/widgets.html',
                    controller : 'WidgetsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.widgets')
        .controller('WidgetsController', WidgetsController);

    /** @ngInject */
    function WidgetsController()
    {
        var vm = this;

        // Data
        vm.widget1 = {
            title        : 'WEEKLY TRANSACTIONS',
            value        : 30342,
            lastWeekValue: 30002,
            lastWeekDiff : '+ 1,12%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget2 = {
            title        : 'SALES QUOTA',
            value        : 40,
            lastWeekValue: 85,
            lastWeekDiff : '- 45%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget3 = {
            title : 'BOUNCE RATE',
            value : 80,
            detail: 'This is the back side. You can show detailed information here.'
        };

        vm.widget4 = {
            title        : 'STOCK COUNT',
            value        : 5583,
            lastWeekValue: 5583,
            lastWeekDiff : '- 0%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget5 = {
            title: 'USERS ONLINE',
            value: 658
        };

        vm.widget6 = {
            title: 'WASTELANDERS',
            value: 358
        };

        vm.widget7 = {
            title: 'VAULTS SEALED',
            value: 24
        };

        vm.widget8 = {
            title: 'VAULTS OPEN',
            value: 62
        };

        vm.widget9 = {
            title: 'SONGS',
            value: 210
        };

        vm.widget10 = {
            title: 'VIDEOS',
            value: 54
        };

        vm.widget11 = {
            title: 'DOCUMENTS',
            value: 1252
        };

        vm.widget12 = {
            date       : 'June 27, Saturday',
            temperature: 28,
            event      : 'Sunny',
            icon       : 'icon-weather-cloudy',
            location   : 'New York, NY',
            detail     : [
                {
                    day        : 'Sun',
                    icon       : 'icon-weather-rainy',
                    temperature: 24,
                    event      : 'Rainy'
                },
                {
                    day        : 'Mon',
                    icon       : 'icon-weather-pouring',
                    temperature: 23,
                    event      : 'Rainy'
                },
                {
                    day        : 'Tue',
                    icon       : 'icon-weather-cloudy',
                    temperature: 29,
                    event      : 'Overcast'
                },
                {
                    day        : 'Wed',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 28,
                    event      : 'Sunny'
                },
                {
                    day        : 'Thu',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 31,
                    event      : 'Sunny'
                }
            ]
        };

        vm.widget13 = {
            date       : 'June 28, Saturday',
            temperature: 16,
            event      : 'Rainy',
            icon       : 'icon-weather-rainy',
            location   : 'Moscow',
            detail     : [
                {
                    day        : 'Sun',
                    icon       : 'icon-weather-rainy',
                    temperature: 24,
                    event      : 'Rainy'
                },
                {
                    day        : 'Mon',
                    icon       : 'icon-weather-pouring',
                    temperature: 23,
                    event      : 'Rainy'
                },
                {
                    day        : 'Tue',
                    icon       : 'icon-weather-cloudy',
                    temperature: 29,
                    event      : 'Overcast'
                },
                {
                    day        : 'Wed',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 28,
                    event      : 'Sunny'
                },
                {
                    day        : 'Thu',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 31,
                    event      : 'Sunny'
                }
            ]
        };

        vm.widget14 = {
            title: 'Visitor Demographics',
            tabs : [
                {
                    label : '30 days',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 40
                                },
                                {
                                    title: 'Female',
                                    value: 41
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 32
                                },
                                {
                                    title: '35 - 44',
                                    value: 85
                                }
                            ]
                        }
                    ]
                },
                {
                    label : '10 days',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 32
                                },
                                {
                                    title: 'Female',
                                    value: 49
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 85
                                },
                                {
                                    title: '35 - 44',
                                    value: 60
                                }
                            ]
                        }
                    ]
                },
                {
                    label : '1 day',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 28
                                },
                                {
                                    title: 'Female',
                                    value: 60
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 17
                                },
                                {
                                    title: '35 - 44',
                                    value: 64
                                }
                            ]
                        }
                    ]
                }
            ]
        };

        vm.widget15 = {
            title: 'CPU USAGE',
            value: 200,
            chart: {
                columns: [
                    {
                        id    : 'CPU',
                        name  : 'CPU',
                        color : 'white',
                        values: '30,200,100,400,150,250',
                        type  : 'spline'
                    }
                ]
            }
        };

        vm.widget16 = {
            title        : 'STOCK COUNT',
            value        : 5583,
            lastWeekValue: 5583,
            lastWeekDiff : '- 0%',
            chart        : {
                columns: [
                    {
                        id    : 'STOCK',
                        name  : 'STOCK',
                        color : 'purple',
                        values: '30,200,100,400,150,250',
                        type  : 'area'
                    }
                ]
            }
        };

        vm.widget17 = {
            title   : 'IO RATE',
            subtitle: 'Showing last 5 hours',
            chart   : {
                columns: [
                    {
                        id    : 'Input',
                        name  : 'Input',
                        color : 'green',
                        values: '30,75,290,400,150,250',
                        type  : 'spline'
                    },
                    {
                        id    : 'Output',
                        name  : 'Output',
                        color : 'blue',
                        values: '500,300,120,600,50,80',
                        type  : 'spline'
                    }
                ]
            }
        };

        vm.widget18 = {
            title        : 'WEEKLY VISITORS',
            value        : 30342,
            lastWeekValue: 30002,
            lastWeekDiff : '1.12%',
            chart        : {
                columns: [
                    {
                        id    : 'Visitors',
                        name  : 'Visitors',
                        color : 'steelblue',
                        values: '30,75,290,400,150,250,75,210,125,92,30,75,290,400',
                        type  : 'bar'
                    }
                ]
            }
        };

        vm.widget19 = {
            title   : 'Google Inc.',
            subtitle: 'NASDAQ: GOOG',
            value   : '531.69',
            diff    : '2.29%',
            chart   : {
                columns: [
                    {
                        id    : 'GOOG',
                        name  : 'GOOG',
                        color : 'white',
                        values: '30,75,290,400,150,250,75,210,125,92,30,75,290,400',
                        type  : 'bar'
                    }
                ]
            }
        };

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.price-tables', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_price-tables', {
            url  : '/components/price-tables',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/price-tables/price-tables.html'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.price-tables')
        .controller('PriceTablesController', PriceTablesController);

    /** @ngInject */
    function PriceTablesController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .controller('DocTemplateController', DocTemplateController);

    /** @ngInject */
    function DocTemplateController(DEMOS, COMPONENTS, $state, $http, $templateCache)
    {
        var vm = this;
        var component = $state.current.data;
        vm.materialVersion = '1.0.0-rc7';

        vm.componentName = component.name;

        vm.component = getComponent(component.moduleName);

        if ( !component.excludeDemo )
        {
            vm.demo = getDemo(component.moduleName);
        }

        if ( vm.component )
        {
            vm.docs = vm.component.docs;
        }

        if ( vm.demo )
        {
            vm.demos = [];

            angular.forEach(vm.demo.demos, function (demo)
            {
                // Get displayed contents (un-minified)
                var files = [demo.index]
                    .concat(demo.js || [])
                    .concat(demo.css || [])
                    .concat(demo.html || []);
                files.forEach(function (file)
                {
                    file.httpPromise = $http.get('app/main/components/material-docs/' + file.outputPath, {cache: $templateCache})
                        .then(function (response)
                        {
                            file.contents = response.data
                                .replace('<head/>', '');
                            return file.contents;
                        });
                });
                demo.$files = files;
                vm.demos.push(demo);
            });

            vm.demos = vm.demos.sort(function (a, b)
            {
                return a.name > b.name ? 1 : -1;
            });
        }

        // Data

        // Methods

        //////////

        function getDemo(value)
        {
            return DEMOS.filter(function (x)
            {
                return x.moduleName === value;
            })[0];
        }

        function getComponent(value)
        {
            return COMPONENTS.filter(function (x)
            {
                return x.name === value;
            })[0];
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.components_maps', {
                url  : '/components/maps',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/components/maps/maps.html',
                        controller : 'MapsController as vm'
                    },
                    'tabContent@app.components_maps': {
                        templateUrl: 'app/main/components/maps/tabs/simple.html'
                    }
                }
            })

            .state('app.components_maps.satellite', {
                url  : '/satellite',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/satellite.html'
                    }
                }
            })

            .state('app.components_maps.terrain', {
                url  : '/terrain',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/terrain.html'
                    }
                }
            })

            .state('app.components_maps.simple-marker', {
                url  : '/simple-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/simple-marker.html'
                    }
                }
            })

            .state('app.components_maps.custom-marker', {
                url  : '/custom-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/custom-marker.html'
                    }
                }
            })

            .state('app.components_maps.info-window', {
                url  : '/info-window',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/info-window.html'
                    }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps')
        .controller('MapsController', MapsController);

    /** @ngInject */
    function MapsController($state, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        var currentState = $state.current.name;

        switch ( currentState )
        {
            case 'app.components_maps':
                vm.selectedIndex = 0;
                break;

            case 'app.components_maps.satellite':
                vm.selectedIndex = 1;
                break;

            case 'app.components_maps.terrain':
                vm.selectedIndex = 2;
                break;

            case 'app.components_maps.simple-marker':
                vm.selectedIndex = 3;
                break;

            case 'app.components_maps.custom-marker':
                vm.selectedIndex = 4;
                break;

            case 'app.components_maps.info-window':
                vm.selectedIndex = 5;
                break;

            default:
                vm.selectedIndex = 0;
        }

        // Methods

        //////////

        uiGmapGoogleMapApi.then(function (maps)
        {
            vm.simpleMap = {
                center: {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom  : 8
            };

            vm.satelliteMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.SATELLITE
                }
            };

            vm.terrainMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.TERRAIN
                }
            };

            vm.simpleMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id    : 0,
                    coords: {
                        latitude : -25.363882,
                        longitude: 131.044922
                    }
                }
            };

            vm.customMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id     : 0,
                    coords : {
                        latitude : -25.363882,
                        longitude: 131.044922
                    },
                    options: {
                        icon: {
                            anchor: new maps.Point(36, 36),
                            origin: new maps.Point(0, 0),
                            url   : '//google-developers.appspot.com/maps/documentation/javascript/examples/full/images/beachflag.png'
                        }
                    }
                }
            };

        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.cards', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_cards', {
            url    : '/components/cards',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/cards/cards.html',
                    controller : 'CardsController as vm'
                }
            },
            resolve: {
                Cards: function (apiResolver)
                {
                    return apiResolver.resolve('cards@get');
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.cards')
        .controller('CardsController', CardsController);

    /** @ngInject */
    function CardsController(Cards)
    {
        var vm = this;

        // Data
        vm.cards = Cards.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TodoController', TodoController);

    /** @ngInject */
    function TodoController($document, $mdDialog, $mdSidenav, Tasks, Tags)
    {
        var vm = this;

        // Data
        vm.tasks = Tasks.data;
        vm.tags = Tags.data;
        vm.completed = [];
        vm.colors = ['blue', 'blue-grey', 'orange', 'pink', 'purple'];
        vm.projects = {
            'creapond'    : 'Project Creapond',
            'withinpixels': 'Project Withinpixels'
        };
        vm.selectedFilter = {
            filter : 'Start Date',
            dueDate: 'Next 3 days'
        };
        vm.selectedProject = 'creapond';

        // Tasks will be filtered against these models
        vm.taskFilters = {
            search   : '',
            tags     : [],
            completed: '',
            deleted  : false,
            important: '',
            starred  : '',
            startDate: '',
            dueDate  : ''
        };
        vm.taskFiltersDefaults = angular.copy(vm.taskFilters);
        vm.showAllTasks = true;

        vm.taskOrder = '';
        vm.taskOrderDescending = false;

        vm.sortableOptions = {
            handle        : '.handle',
            forceFallback : true,
            ghostClass    : 'todo-item-placeholder',
            fallbackClass : 'todo-item-ghost',
            fallbackOnBody: true,
            sort          : true
        };
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.preventDefault = preventDefault;
        vm.openTaskDialog = openTaskDialog;
        vm.toggleCompleted = toggleCompleted;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleFilter = toggleFilter;
        vm.toggleFilterWithEmpty = toggleFilterWithEmpty;
        vm.filterByStartDate = filterByStartDate;
        vm.filterByDueDate = filterByDueDate;
        vm.resetFilters = resetFilters;
        vm.toggleTagFilter = toggleTagFilter;
        vm.isTagFilterExists = isTagFilterExists;

        init();

        //////////

        /**
         * Initialize the controller
         */
        function init()
        {
            angular.forEach(vm.tasks, function (task)
            {
                if ( task.startDate )
                {
                    task.startDate = new Date(task.startDate);
                    task.startDateTimestamp = task.startDate.getTime();
                }

                if ( task.dueDate )
                {
                    task.dueDate = new Date(task.dueDate);
                    task.dueDateTimestamp = task.dueDate.getTime();
                }
            });
        }

        /**
         * Prevent default
         *
         * @param e
         */
        function preventDefault(e)
        {
            e.preventDefault();
            e.stopPropagation();
        }

        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openTaskDialog(ev, task)
        {
            $mdDialog.show({
                controller         : 'TaskDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/todo/dialogs/task/task-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Task : task,
                    Tasks: vm.tasks,
                    event: ev
                }
            });
        }

        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function toggleCompleted(task, event)
        {
            event.stopPropagation();
            task.completed = !task.completed;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggles filter with true or false
         *
         * @param filter
         */
        function toggleFilter(filter)
        {
            vm.taskFilters[filter] = !vm.taskFilters[filter];

            checkFilters();
        }

        /**
         * Toggles filter with true or empty string
         * @param filter
         */
        function toggleFilterWithEmpty(filter)
        {
            if ( vm.taskFilters[filter] === '' )
            {
                vm.taskFilters[filter] = true;
            }
            else
            {
                vm.taskFilters[filter] = '';
            }

            checkFilters();
        }

        /**
         * Reset filters
         */
        function resetFilters()
        {
            vm.showAllTasks = true;
            vm.taskFilters = angular.copy(vm.taskFiltersDefaults);
        }

        /**
         * Check filters and mark showAllTasks
         * as true if no filters selected
         */
        function checkFilters()
        {
            vm.showAllTasks = !!angular.equals(vm.taskFiltersDefaults, vm.taskFilters);
        }

        /**
         * Filter by startDate
         *
         * @param item
         * @returns {boolean}
         */
        function filterByStartDate(item)
        {
            if ( vm.taskFilters.startDate === true )
            {
                return item.startDate === new Date();
            }

            return true;
        }

        /**
         * Filter Due Date
         *
         * @param item
         * @returns {boolean}
         */
        function filterByDueDate(item)
        {
            if ( vm.taskFilters.dueDate === true )
            {
                return !(item.dueDate === null || item.dueDate.length === 0);
            }

            return true;
        }

        /**
         * Toggles tag filter
         *
         * @param tag
         */
        function toggleTagFilter(tag)
        {
            var i = vm.taskFilters.tags.indexOf(tag);

            if ( i > -1 )
            {
                vm.taskFilters.tags.splice(i, 1);
            }
            else
            {
                vm.taskFilters.tags.push(tag);
            }

            checkFilters();
        }

        /**
         * Returns if tag exists in the tagsFilter
         *
         * @param tag
         * @returns {boolean}
         */
        function isTagFilterExists(tag)
        {
            return vm.taskFilters.tags.indexOf(tag) > -1;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardController', ScrumboardController);

    /** @ngInject */
    function ScrumboardController($window, $mdSidenav, BoardService, BoardList, CardFilters)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.boardSelectorVisible = false;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.updateBoardUri = updateBoardUri;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // IE list-content max-height hack
            if ( angular.element('html').hasClass('explorer') )
            {
                // Calculate the height for the first time
                calculateListContentHeight();

                // Attach calculateListContentHeight function to window resize
                $window.onresize = function ()
                {
                    calculateListContentHeight();
                }
            }
        }

        /**
         * IE ONLY
         * Calculate the list-content height
         * IE ONLY
         */
        function calculateListContentHeight()
        {
            // Get the required heights for calculations
            var listWrapperEl = angular.element('#board .list-wrapper').first(),
                listWrapperElHeight = listWrapperEl.height(),
                listHeaderElHeight = listWrapperEl.find('.list-header').height(),
                listFooterElHeight = listWrapperEl.find('.list-footer').height();

            // Calculate the max height
            var maxHeight = listWrapperElHeight - listHeaderElHeight - listFooterElHeight;

            // Add the max height
            angular.element('#board .list-content').css({'max-height': maxHeight});
        }

        /**
         * Update Board Uri
         *
         * Once you connect your app to your server,
         * you would do this on your API server.
         */
        function updateBoardUri()
        {
            if ( vm.boardList.getById(vm.board.id) )
            {
                vm.boardList.getById(vm.board.id).name = vm.board.name;
                vm.boardList.getById(vm.board.id).uri = vm.board.uri = encodeURIComponent(vm.board.name).replace(/%20/g, '-').toLowerCase();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('MailController', MailController);

    /** @ngInject */
    function MailController($scope, $document, $timeout, $mdDialog, $mdMedia, $mdSidenav, Inbox)
    {
        var vm = this;

        // Data
        vm.accounts = {
            'creapond'    : 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.checked = [];
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';
        vm.selectedMail = {};
        vm.toggleSidenav = toggleSidenav;

        vm.responsiveReadPane = undefined;
        vm.activeMailPaneIndex = 0;
        vm.dynamicHeight = false;

        vm.scrollPos = 0;
        vm.scrollEl = angular.element('#content');

        vm.inbox = Inbox.data;
        vm.selectedMail = vm.inbox[0];
        vm.selectedMailShowDetails = false;

        // Methods
        vm.checkAll = checkAll;
        vm.closeReadPane = closeReadPane;
        vm.composeDialog = composeDialog;
        vm.isChecked = isChecked;
        vm.replyDialog = replyDialog;
        vm.selectMail = selectMail;
        vm.toggleStarred = toggleStarred;
        vm.toggleCheck = toggleCheck;

        //////////

        // Watch screen size to activate responsive read pane
        $scope.$watch(function ()
        {
            return $mdMedia('gt-md');
        }, function (current)
        {
            vm.responsiveReadPane = !current;
        });

        // Watch screen size to activate dynamic height on tabs
        $scope.$watch(function ()
        {
            return $mdMedia('xs');
        }, function (current)
        {
            vm.dynamicHeight = current;
        });

        /**
         * Select mail
         *
         * @param mail
         */
        function selectMail(mail)
        {
            vm.selectedMail = mail;

            $timeout(function ()
            {
                // If responsive read pane is
                // active, navigate to it
                if ( angular.isDefined(vm.responsiveReadPane) && vm.responsiveReadPane )
                {
                    vm.activeMailPaneIndex = 1;
                }

                // Store the current scrollPos
                vm.scrollPos = vm.scrollEl.scrollTop();

                // Scroll to the top
                vm.scrollEl.scrollTop(0);
            });
        }

        /**
         * Close read pane
         */
        function closeReadPane()
        {
            if ( angular.isDefined(vm.responsiveReadPane) && vm.responsiveReadPane )
            {
                vm.activeMailPaneIndex = 0;

                $timeout(function ()
                {
                    vm.scrollEl.scrollTop(vm.scrollPos);
                }, 650);
            }
        }

        /**
         * Toggle starred
         *
         * @param mail
         * @param event
         */
        function toggleStarred(mail, event)
        {
            event.stopPropagation();
            mail.starred = !mail.starred;
        }

        /**
         * Toggle checked status of the mail
         *
         * @param mail
         * @param event
         */
        function toggleCheck(mail, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.checked.indexOf(mail);

            if ( idx > -1 )
            {
                vm.checked.splice(idx, 1);
            }
            else
            {
                vm.checked.push(mail);
            }
        }

        /**
         * Return checked status of the mail
         *
         * @param mail
         * @returns {boolean}
         */
        function isChecked(mail)
        {
            return vm.checked.indexOf(mail) > -1;
        }

        /**
         * Check all
         */
        function checkAll()
        {
            if ( vm.allChecked )
            {
                vm.checked = [];
                vm.allChecked = false;
            }
            else
            {
                angular.forEach(vm.inbox, function (mail)
                {
                    if ( !isChecked(mail) )
                    {
                        toggleCheck(mail);
                    }
                });

                vm.allChecked = true;
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */
        function composeDialog(ev)
        {
            $mdDialog.show({
                controller         : 'ComposeDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: undefined
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Open reply dialog
         *
         * @param ev
         */
        function replyDialog(ev)
        {
            $mdDialog.show({
                controller         : 'ComposeDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: vm.selectedMail
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.file-manager', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.file-manager', {
            url      : '/file-manager',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/file-manager/file-manager.html',
                    controller : 'FileManagerController as vm'
                }
            },
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
            bodyClass: 'file-manager'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/file-manager');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.file-manager', {
            title : 'File Manager',
            icon  : 'icon-folder',
            state : 'app.file-manager',
            weight: 4
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.file-manager')
        .controller('FileManagerController', FileManagerController);

    /** @ngInject */
    function FileManagerController($mdSidenav, Documents)
    {
        var vm = this;

        // Data
        vm.accounts = {
            'creapond'    : 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.selectedAccount = 'creapond';
        vm.currentView = 'list';
        vm.showDetails = true;

        vm.path = Documents.data.path;
        vm.folders = Documents.data.folders;
        vm.files = Documents.data.files;
        vm.selected = vm.files[0];

        // Methods
        vm.select = select;
        vm.toggleDetails = toggleDetails;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleView = toggleView;

        //////////

        /**
         * Select an item
         *
         * @param item
         */
        function select(item)
        {
            vm.selected = item;
        }

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('details-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle view
         */
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController($mdDialog, $document, api)
    {
        var vm = this;

        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();


		//api.calendar.events.get({}, function(data) {
			//vm.events = data;
			//alert(vm.events);
			
		//});
		
        vm.events = [
            [
                {
                    id   : 1,
                    title: 'All Day Event',
                    start: '2016-04-02T17:00+0400',
                    end  : null
                },
                {
                    id   : 2,
                    title: 'Календарь находится в разработке',
                    start: new Date(y, m, 8),
                    end  : new Date(y, m, 10)
                }
            ]
        ];/**/
        
        console.log(vm.events);
        

        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                firstDay		  : 1,
                timeFormat		  : 'HH:MM',
                dayNames          : ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница','Суббота'],
                dayNamesShort     : ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт','Сб'],
                monthNames		  : ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                monthNamesShort	  : ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
                monthNamesClass	  : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                    //для отображения картинок в шаблоне
                    vm.currentMonthClass = vm.calendarUiConfig.calendar.monthNamesClass[vm.calendar.getDate().format('M') - 1];
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            $mdDialog.show({
                controller         : 'EventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                if ( response.type === 'add' )
                {
                    // Add new
                    vm.events[0].push({
                        id   : vm.events[0].length + 20,
                        title: response.calendarEvent.title,
                        start: response.calendarEvent.start,
                        end  : response.calendarEvent.end
                    });
                }
                else
                {
                    for ( var i = 0; i < vm.events[0].length; i++ )
                    {
                        // Update
                        if ( vm.events[0][i].id === response.calendarEvent.id )
                        {
                            vm.events[0][i] = {
                                title: response.calendarEvent.title,
                                start: response.calendarEvent.start,
                                end  : response.calendarEvent.end
                            };

                            break;
                        }
                    }
                }
            });
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'angular-chartist',
                'chart.js',
                'datatables',
                'gridshore.c3js.chart',
                'nvd3',
                'pascalprecht.translate',
                'timer',
                'ui.router',
                'uiGmapgoogle-maps',
                'textAngular',
                'ui.sortable',
                'ng-sortable',
                'xeditable',
                'moment-picker'
            ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toString(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            vm.selectedIndex++;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === vm.forms.length - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean|*}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts.users.newuser', ['angular-md5'])
        .controller('NewUserController', NewUserController);

    /** @ngInject */
    function NewUserController($scope, $mdDialog, $location, md5, api)
    {
        var vm = this;
	///contacts/users/new
        // Data
        vm.formWizard = {};
        //vm.formWizard.birthdate = new Date();

        vm.sex_array = [{'db_name': 'male-female', 'name': 'Не указан'},
						{'db_name': 'male', 'name': 'Мужской'},
						{'db_name': 'female', 'name': 'Женский'}];
        vm.formWizard.sex = 'male-female';

        api.contacts.groups.query({}, function(data) {
				vm.groups = data;
				});

		api.contacts.positions.query({}, function(data) {
				vm.positions = data;
				});

        // Methods
        vm.sendForm = sendForm;
        vm.generatePassword = generatePassword;


        ///генерация пароля
        function generatePassword() {
            var length = 8,
                charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_-+#$!",
                retVal = "";
            for (var i = 0, n = charset.length; i < length; ++i) {
                retVal += charset.charAt(Math.floor(Math.random() * n));
            }
            vm.formWizard.password = retVal;
            $mdDialog.show({
                      controller: function ($scope, $mdDialog)
                      {
                          $scope.closeDialog = function ()
                          {
                              $mdDialog.hide();
                          }
                      },
                      template: '<md-dialog>' +
                      '  <md-dialog-content><h1>Генерация пароля</h1><p>Скопируйте пароль в безопасное место или запомните, так как после шифрования восстановить его будет невозможно</p>' +
                      '<h2>' + retVal + '</h2></md-dialog-content>' +
                      '  <md-dialog-actions>' +
                      '    <md-button ng-click="closeDialog()" class="md-primary">' +
                      '      Закрыть' +
                      '    </md-button>' +
                      '  </md-dialog-actions>' +
                      '</md-dialog>',
                      parent             : angular.element('body'),
                      clickOutsideToClose: true
                  });
        }
        /**
         * Send form
         */
        function sendForm(ev)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.


            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                  var newuser = new api.contacts.newuserdata();
                  $scope.formWizardData = formWizardData;
                  formWizardData.password = md5.createHash(md5.createHash(formWizardData.password));
                  newuser.data = formWizardData;
                  newuser.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/users');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Пользователь {{formWizardData.login}} успешно создан</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
        }
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.users.edituser', ['angular-md5'])//,'ngResource','angularFileUpload'
        .controller('EditUserController', EditUserController);

    /** @ngInject */
    function EditUserController($mdDialog, $scope, FileUploader, $location, md5, api)//$resource,
    {
        var vm = this;
        // Data
        vm.formWizard = {};

        vm.sex_array = [{'db_name': 'male-female', 'name': 'Не указан'},
						{'db_name': 'male', 'name': 'Мужской'},
						{'db_name': 'female', 'name': 'Женский'}];

        api.contacts.groups.query({}, function(data) {
				vm.groups = data;
		});

		api.contacts.positions.query({}, function(data) {
			vm.positions = data;
		});

		//получаем аватар
		api.contacts.userphotobyid.query({'id':vm.objectId}, function(data) {
			vm.photos = data.data;
			//меняем адреса изображений
			if (vm.photos !== null) {
				for(var i=0; i < vm.photos.length;i++){
					//vm.photos[i].filename = api.localhost_backend + api.localhost_images + vm.photos[i].filename;
          vm.photos[i].filename = api.domain_name + api.domain_images + vm.photos[i].filename;
				}
			}
			//console.log(vm.dtInstance);
			//if(reRend) {
			 //TODO разобраться почему не обновляется таблица с фотографиями как нужно
			 //vm.dtInstance.rerender();
			//}
		});

        //получаем id сотрудника, которого будем редактировать
        vm.userId = $location.path().split('/');
        vm.userId = vm.userId[vm.userId.length-1];

		//получаем информацию по сотрудника
		api.contacts.userbyid.query({'id':vm.userId}, function(data) {
				vm.formWizard.firstname = data[0].firstname;
				vm.formWizard.middlename = data[0].middlename;
				vm.formWizard.lastname = data[0].lastname;

				vm.formWizard.group_id = data[0].group_id;

				vm.formWizard.sex = data[0].sex;

				if (data[0].active==1) vm.formWizard.active = true;
				 else vm.formWizard.active = false;

				vm.formWizard.position_id = data[0].position_id;

				vm.formWizard.login = data[0].login;
				vm.formWizard.birthdate = new Date(data[0].birthdate);
				vm.formWizard.email = data[0].email;
				vm.formWizard.phone_1 = data[0].phone_1;
				vm.formWizard.phone_2 = data[0].phone_2;
				vm.formWizard.address = data[0].address;
				vm.formWizard.passport = data[0].passport;
			});



        // Methods
        vm.sendForm = sendForm;

        //////////

        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;

                    $scope.formWizardData.id = vm.userId;

                    switch($scope.formWizardData.active) {
						case true: $scope.formWizardData.active = 1; break
						case false: $scope.formWizardData.active = 0; break
					}

					var edituser = new api.contacts.edituser();
					//formWizardData.password = md5.createHash(md5.createHash(formWizardData.password));
					edituser.data = formWizardData;
					edituser.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/users');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Пользователь {{formWizardData.login}} успешно изменен</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
        }

        ///////////////////////Загрузка фотографий
		var hideUpload = false; //переменная для сокрытия кнопки загрузки после одной загрузки (чтобы не заливали одно и то же, пока нет онлайн обновления таблицы)
		var uploader = $scope.uploader = new FileUploader({
				//инкапсулируем скрипт загрузки в общий модуль, чтобы проверять авторизацию
				url: api.localhost_backend + 'upload',
				removeAfterUpload: true,
				formData: {'id':vm.userId}
		});

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        //События Callbacks
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
        };
        uploader.onAfterAddingFile = function(fileItem) {
            console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
			hideUpload = true;
            console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function(item) {
            console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            console.info('onCompleteAll');
        };
        console.info('uploader', uploader);
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.groups.newgroup',[])
        .controller('NewGroupController', NewGroupController);
  
    /** @ngInject */
    function NewGroupController($mdDialog, $location, api)
    {
        var vm = this;

        // Data
        vm.basicForm = {};     
        
        api.contacts.offices.query({}, function(data) {			
				vm.offices = data;
				});	
		vm.basicForm.office_id = 1;
		
        // Methods
        vm.sendForm = sendForm;

        //////////

        /**
         * Send form
         */
        function sendForm(ev)
        {
            // You can do an API call here to send the form to your server
            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, basicFormData)
                {
                    $scope.basicForm = basicFormData;
		
					var newgroup = new api.contacts.newgroupdata();					
					newgroup.data = basicFormData;
					newgroup.$save();
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/groups');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Отдел {{basicForm.name}} успешно создан</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    basicFormData: vm.basicForm
                },
                clickOutsideToClose: true
            });
            vm.basicForm = {};
        }
    }
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.groups.editgroup',[])
        .controller('EditGroupController', EditGroupController);
  
    /** @ngInject */
    function EditGroupController($mdDialog, $location, api)
    {
        var vm = this;

        // Data
        vm.basicForm = {};   
        
        vm.groupId = $location.path().split('/');
        //получаем id отдела, который будем редактировать
        vm.groupId = vm.groupId[vm.groupId.length-1];

        api.contacts.offices.query({}, function(data) {			
				vm.offices = data;
				});
		//получаем информацию по отделу
		api.contacts.groupbyid.query({'id':vm.groupId}, function(data) {		
				vm.basicForm.office_id = data[0].office_id;
				vm.basicForm.name = data[0].name;
				if (data[0].active==1) vm.basicForm.active = true;
				 else vm.basicForm.active = false;
				vm.basicForm.date = data[0].date;
				});
        // Methods
        vm.sendForm = sendForm;

        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, basicFormData)
                {
                    $scope.basicForm = basicFormData;
					
					switch($scope.basicForm.active) {
						case true: $scope.basicForm.active = 1; break
						case false: $scope.basicForm.active = 0; break
					}
					
					$scope.basicForm.id = vm.groupId;
					
					var editgroup = new api.contacts.editgroup();					
					editgroup.data = basicFormData;
					editgroup.$save();
					
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/groups');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Отдел успешно отредактирован</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    basicFormData: vm.basicForm
                },
                clickOutsideToClose: true
            });
            vm.basicForm = {};
        }
    }
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients_contragents.newclient',[])
        .controller('NewCClientController', NewCClientController);

    /** @ngInject */
    function NewCClientController($mdDialog, $location, api)
    {
        var vm = this;

        // Data
        vm.formWizard = {};

        vm.types = 		[
                {'name': 'buyer', 'rusname': 'Покупатель'},
                {'name': 'seller', 'rusname': 'Продавец'}
                // {'name': 'person', 'rusname': 'Физ.лицо'},
    						// {'name': 'firm', 'rusname': 'Юр.лицо'}
              ];

    		vm.statuses = [ {'name': 'work', 'rusname': 'Идет работа'},
    						{'name': 'talks', 'rusname': 'Переговоры'},
    						{'name': 'completed', 'rusname': 'Работа завершена'}
    						];

        // Methods
        vm.sendForm = sendForm;

        if ($location.search().isBuyer == 'Y') {
          vm.formWizard.type = 'buyer';
          vm.formWizard.status = 'work';
        }

        if (typeof($location.search().objectN) !== "undefined" && $location.search().objectN !== null) {
          vm.formWizard.object_id = parseInt($location.search().objectN);
        }

        //////////

        /**
         * Send form
         */
        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizard = formWizardData;

					var newclient = new api.contacts.newclientdata();
          formWizardData.contragent = 1;
					newclient.data = formWizardData;
					newclient.$save();

                    $scope.closeDialog = function ()
                    {
                      $mdDialog.hide();
                      if ($location.search().isBuyer == 'Y') {
                        $location.path('/contacts/contragents_buyers');
                      } else {
                        $location.path('/contacts/contragents');
                      }
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Контрагент успешно создан</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
        }
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients_contragents.editclient',[])
        .controller('EditCClientController', EditCClientController);

    /** @ngInject */
    function EditCClientController($mdDialog, $location, api)
    {
        var vm = this;

        // Data
        vm.formWizard = {};
		//получаем id клиента, которого будем редактировать
        vm.clientId = $location.path().split('/');
        vm.clientId = vm.clientId[vm.clientId.length-1];

        vm.types = 		[
                {'name': 'buyer', 'rusname': 'Покупатель'},
                {'name': 'seller', 'rusname': 'Продавец'}
                // {'name': 'person', 'rusname': 'Физ.лицо'},
                // {'name': 'firm', 'rusname': 'Юр.лицо'}
              ];

		vm.statuses = [{'name': 'work', 'rusname': 'Идет работа'},
						{'name': 'talks', 'rusname': 'Переговоры'},
						{'name': 'completed', 'rusname': 'Работа завершена'}
						];
		//получаем информацию по клиенту
		api.contacts.clientbyid.query({'id':vm.clientId}, function(data) {
				vm.formWizard.firstname = data[0].firstname;
				vm.formWizard.middlename = data[0].middlename;
				vm.formWizard.lastname = data[0].lastname;

				vm.formWizard.type = data[0].type;
        vm.formWizard.object_id = parseInt(data[0].object_id);
				vm.formWizard.status = data[0].status;
				vm.formWizard.birthdate = new Date(data[0].birthdate);
				vm.formWizard.email = data[0].email;
				vm.formWizard.phone_1 = data[0].phone_1;
				vm.formWizard.phone_2 = data[0].phone_2;
				vm.formWizard.description = data[0].description;
				vm.formWizard.contacts_description = data[0].contacts_description;
		});

        // Methods
        vm.sendForm = sendForm;

        //////////

        /**
         * Send form
         */
        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;

                    $scope.formWizardData.id = vm.clientId;

					var editclient = new api.contacts.editclient();

					editclient.data = formWizardData;
					editclient.$save();

                  $scope.closeDialog = function ()
                  {
                    $mdDialog.hide();
                    if ($location.search().isBuyer == 'Y') {
                      $location.path('/contacts/contragents_buyers');
                    } else {
                      $location.path('/contacts/contragents');
                    }
                  }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Контрагент {{formWizardData.login}} успешно изменен</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
        }
   }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients.newclient',[])
        .controller('NewClientController', NewClientController);

    /** @ngInject */
    function NewClientController($mdDialog, $location, api)
    {
        var vm = this;

        // Data
        vm.formWizard = {};

		vm.types = 		[
            {'name': 'buyer', 'rusname': 'Покупатель'},
            {'name': 'seller', 'rusname': 'Продавец'}
            // {'name': 'person', 'rusname': 'Физ.лицо'},
						// {'name': 'firm', 'rusname': 'Юр.лицо'},
						// {'name': 'mort_broker', 'rusname': 'Ипотечные брокеры'},
						// {'name': 'evaluation', 'rusname': 'Оценочные компании'},
						// {'name': 'insurance', 'rusname': 'Страховые компании'},
						// {'name': 'transactionsbanks', 'rusname': 'Банки для проведения сделок, Центры оформления сделок'},
						// {'name': 'rentalagents', 'rusname': 'Риелторы по аренде'},
						// {'name': 'realtorsagency', 'rusname': 'Риелторы (Агентства)'},
						// {'name': 'transportcompanies', 'rusname': 'Переезд (транспортные компании)'},
						// {'name': 'storage', 'rusname': 'Хранилища вещей'},
						// {'name': 'cleaning', 'rusname': 'Предпродажная подготовка (чистка, уборка)'},
						// {'name': 'repairs', 'rusname': 'Бригады по ремонту'},
						// {'name': 'notaries', 'rusname': 'Нотариусы'},
						// {'name': 'sticker', 'rusname': 'Расклейщики'},
						// {'name': 'medexamination', 'rusname': 'Медицинское освидетельствование'},
						// {'name': 'notary_home', 'rusname': 'Выезд нотариуса на дом'},
						// {'name': 'guardianship', 'rusname': 'Органы опеки и попечительства'},
						// {'name': 'lawyer', 'rusname': 'Адвокат (прописка, выписка, суды)'},
						// {'name': 'banks', 'rusname': 'Банки (аккредитивные сделки)'},
						// {'name': 'references', 'rusname': 'Справки о не сносе дома и справки из ДЖП (ускорение)'},
						// {'name': 'taxes_consultation', 'rusname': 'Консультация по налогам'}
          ];

		vm.statuses = [ {'name': 'work', 'rusname': 'Идет работа'},
						//{'name': 'potential', 'rusname': 'Потенциальный'},
						{'name': 'talks', 'rusname': 'Переговоры'},
						//{'name': 'disclaimer', 'rusname': 'Отказ'},
						{'name': 'completed', 'rusname': 'Работа завершена'}
						//{'name': 'blacklist', 'rusname': 'Черный список'}
						];

        //console.log($location.search());

        if ($location.search().fromObjects == 'Y') {
          vm.formWizard.type = 'seller';
          vm.formWizard.status = 'work';
        }
        // Methods
        vm.sendForm = sendForm;

        //////////

        /**
         * Send form
         */
        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizard = formWizardData;

					var newclient = new api.contacts.newclientdata();
					newclient.data = formWizardData;
					newclient.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        if ($location.search().fromObjects == 'Y') {
                          $location.path('/objects/new/flat');
                        } else {
                          $location.path('/contacts/clients');
                        }
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Клиент успешно создан</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
        }
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients.editclient',[])
        .controller('EditClientController', EditClientController);

    /** @ngInject */
    function EditClientController($mdDialog, $location, api)
    {
        var vm = this;

        // Data
        vm.formWizard = {};
		//получаем id клиента, которого будем редактировать
        vm.clientId = $location.path().split('/');
        vm.clientId = vm.clientId[vm.clientId.length-1];

		vm.types = 		[
            {'name': 'buyer', 'rusname': 'Покупатель'},
            {'name': 'seller', 'rusname': 'Продавец'}
            // {'name': 'person', 'rusname': 'Физ.лицо'},
						// {'name': 'firm', 'rusname': 'Юр.лицо'},
						// {'name': 'mort_broker', 'rusname': 'Ипотечные брокеры'},
						// {'name': 'evaluation', 'rusname': 'Оценочные компании'},
						// {'name': 'insurance', 'rusname': 'Страховые компании'},
						// {'name': 'transactionsbanks', 'rusname': 'Банки для проведения сделок, Центры оформления сделок'},
						// {'name': 'rentalagents', 'rusname': 'Риелторы по аренде'},
						// {'name': 'realtorsagency', 'rusname': 'Риелторы (Агентства)'},
						// {'name': 'transportcompanies', 'rusname': 'Переезд (транспортные компании)'},
						// {'name': 'storage', 'rusname': 'Хранилища вещей'},
						// {'name': 'cleaning', 'rusname': 'Предпродажная подготовка (чистка, уборка)'},
						// {'name': 'repairs', 'rusname': 'Бригады по ремонту'},
						// {'name': 'notaries', 'rusname': 'Нотариусы'},
						// {'name': 'sticker', 'rusname': 'Расклейщики'},
						// {'name': 'medexamination', 'rusname': 'Медицинское освидетельствование'},
						// {'name': 'notary_home', 'rusname': 'Выезд нотариуса на дом'},
						// {'name': 'guardianship', 'rusname': 'Органы опеки и попечительства'},
						// {'name': 'lawyer', 'rusname': 'Адвокат (прописка, выписка, суды)'},
						// {'name': 'banks', 'rusname': 'Банки (аккредитивные сделки)'},
						// {'name': 'references', 'rusname': 'Справки о не сносе дома и справки из ДЖП (ускорение)'},
						// {'name': 'taxes_consultation', 'rusname': 'Консультация по налогам'}
          ];

		vm.statuses = [ {'name': 'work', 'rusname': 'Идет работа'},
						// {'name': 'potential', 'rusname': 'Потенциальный'},
						{'name': 'talks', 'rusname': 'Переговоры'},
						// {'name': 'disclaimer', 'rusname': 'Отказ'},
						{'name': 'completed', 'rusname': 'Работа завершена'}
						// {'name': 'blacklist', 'rusname': 'Черный список'}
						];
		//получаем информацию по клиенту
		api.contacts.clientbyid.query({'id':vm.clientId}, function(data) {
				vm.formWizard.firstname = data[0].firstname;
				vm.formWizard.middlename = data[0].middlename;
				vm.formWizard.lastname = data[0].lastname;

				vm.formWizard.type = data[0].type;
				vm.formWizard.status = data[0].status;
				vm.formWizard.birthdate = new Date(data[0].birthdate);
				vm.formWizard.email = data[0].email;
				vm.formWizard.phone_1 = data[0].phone_1;
				vm.formWizard.phone_2 = data[0].phone_2;
				vm.formWizard.description = data[0].description;
				vm.formWizard.contacts_description = data[0].contacts_description;
		});

        // Methods
        vm.sendForm = sendForm;

        //////////

        /**
         * Send form
         */
        function sendForm(ev)
        {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;

                    $scope.formWizardData.id = vm.clientId;

					var editclient = new api.contacts.editclient();

					editclient.data = formWizardData;
					editclient.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/clients');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Клиент {{formWizardData.login}} успешно изменен</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });
            vm.formWizard = {};
        }
   }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.suburbian', ['app.objects.suburbian.archive'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_suburbian', {
            url    : '/objects/suburbian',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/suburbian/suburbian.html',
                    controller : 'SuburbianController as vm'
                }
            },
            resolve: {
                Houses: function (apiResolver)
                {
                    return apiResolver.resolve('objects.houses@get',{'my':'true','first':'true'});
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.suburbian')
        .controller('SuburbianController', SuburbianController);

    /** @ngInject */
    function SuburbianController($scope, $rootScope, $location, $mdDialog, Houses, api)
    {
        var vm = this;

        // Data
        vm.houses = Houses.data;
        processObjects();

        //получаем id своей должности
        api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
          vm.positionid = data.position_id;
          //получаем список объектов через функцию
          //только для риэлторов и их начальников изначально только свои
          if (vm.positionid==1 || vm.positionid==7) {
            vm.onlyMy = true;
            //для риэлторов помечаем галку
          } else {
            //для избежания подрагивания при дозагрузке объектов
            //загружаем в модуле и меняем только, если это необходимо
            vm.onlyMy = false;
          }
        });


    //получаем id своей учетной записи для сверки собственности на объект
    api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
			vm.userid = data.user_id;
		});
		//получаем id своего отдела
    api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
			vm.groupid = data.group_id;
		});

        if ($location.path() == '/objects/suburbian') {
			vm.archive = false;
		} else if ($location.path() == '/objects/suburbian/archive') {
			vm.archive = true;
		}

    ///////////////////обновление таблицы документов после загрузки
    vm.total = 0;
    vm.dtInstance = {};

    vm.dtIntanceCallback = function (instance) {
      vm.dtInstance = instance;
    }

        vm.dtOptions = {
            dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            rowCallback: rowCallback,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
      "columns": [
				null,
        { "orderable": false },
				//null,
				null,
				null,
				null,
				//null,
				null
			  ],
        "buttons": [
          {
             extend: "print",
             text: "Печать",
             title:  "Список объектов",
             className: "DTBblack",
             exportOptions: {
                 columns: ':visible'
             }
           },
          {
             extend: "excel",
             text: "Сохранить таблицу",
             className: "DTBblack",
             //fileName:  "Список клиентов.xls",
             title:"Список объектов",
             exportOptions: {
                 columns: ':visible'
             }
         },
         {
            text: '↻',
            className: "DTBblackNormal",
            action: function () {
                updateObjectsTable();
            }
          }
        ],
			  "order": [0, "desc"]
        };

        // Methods
		vm.addObject = addObject;
		vm.editObject = editObject;
    vm.viewObject = viewObject;
		vm.archiveObject = archiveObject;
		vm.restoreObject = restoreObject;
		vm.restore_archiveObject = restore_archiveObject;
    vm.editObjectAgentDescription = editObjectAgentDescription;
    vm.showObjectCostHistory = showObjectCostHistory;
		vm.showSetListingError = showSetListingError;
		vm.showSetVisaError = showSetVisaError;
		vm.showSetVisaPError = showSetVisaPError;
		vm.changeVisa = changeVisa;
		vm.changeListing = changeListing;
		vm.changeVisaP = changeVisaP;
		//проверка на архив и установка переменной на архив
		vm.Arch = changeArchiveStatus;
		vm.isArch = checkArchiveStatus;
    vm.updateObjectsTable = updateObjectsTable;
    vm.copyObject = copyObject;


    //диалог о копировании объекта
      function copyObject(id) {
        $mdDialog.show({
                  controller         : function ($scope, $mdDialog)
                  {
                      ////////////
                      $scope.copyWithArchive = function ()
                      {
                          //alert(id);
                          var copyobject = new api.objects.copyobject_witharchive();
                          copyobject.id = id;
                          copyobject.$save();

                          $scope.closeDialog();
                          updateObjectsTable();
                      }
                      ////////////
                      $scope.copyWithoutArchive = function ()
                      {
                          var copyobject = new api.objects.copyobject_withoutarchive();
                          copyobject.id = id;
                          copyobject.$save();

                          $scope.closeDialog();
                          updateObjectsTable();
                      }
                      ////////////
                      $scope.closeDialog = function ()
                      {
                          $mdDialog.hide();
                          //$location.path('/objects/flats');
                          //$route.reload();
                      }
                  },
                  template: '<md-dialog>' +
                  '  <md-dialog-content><h1>Копирование объекта</h1>Отправить в архив объект {{id}}?</md-dialog-content>' +
                  '  <md-dialog-actions>' +
                  '    <md-button ng-click="copyWithArchive()" class="md-warn">' +
                  '      Да' +
                  '    </md-button>' +
                  '    <md-button ng-click="copyWithoutArchive()" class="md-primary">' +
                  '      Нет' +
                  '    </md-button>' +
                  '    <md-button ng-click="closeDialog()" class="md-primary">' +
                  '      Отмена' +
                  '    </md-button>' +
                  '  </md-dialog-actions>' +
                  '</md-dialog>',
                  parent             : angular.element('body'),
                  clickOutsideToClose: true
              });
      }

        // Methods
        //////////////////////////////

        //////////обновление таблицы
        function updateObjectsTable()
          {
            //в зависимости от страницы, где мы находимся - отдаем нужный запрос
            //архив в переспективе можно превратить в параметр, как onlyMy, сохраняя ссылку
            //TODO унификация в бэкэнде в одну функцию?
            //////////////////////////////
            //обновляем подгруженному списку некоторые столбцы
            if ($location.path()=='/objects/suburbian') {
              api.objects.houses.query({'my':vm.onlyMy}, function(data) {
                vm.houses = data.data;
                vm.total = vm.houses.length;
                processObjects();
              });
            } else if ($location.path()=='/objects/suburbian/archive') {
              api.objects.housesarchive.query({'my':vm.onlyMy}, function(data) {
                vm.houses = data.data;
                vm.total = vm.houses.length;
                processObjects();
              });
            }
          }

          //редактирование поля заметок агента по объекту
      		function editObjectAgentDescription(id) {
      		$mdDialog.show({
      					controller         : function ($scope, $mdDialog)
      						{
                    var viewobject = new api.objects.notebyobjectid.query({'id':id},
                      function(note) {
                      //получаем текст заметки, если есть
                      var data = [];
                      data.id = id;
                      data.agent_descr = note.agent_description;
                      $scope.object_data = data;
                    });

      							$scope.closeDialog = function ()
      							{
      								$mdDialog.hide();
      							}
                    //сохранить заметку
                    $scope.changeAgentDescription = function (id,text)
      							{
                      var changeagentdescription = new api.objects.changeAgentDescription();
                      changeagentdescription.id = id;
                      changeagentdescription.agent_description = text;
                      changeagentdescription.$save();
      								$mdDialog.hide();
      							}
      						},
                  templateUrl: 'app/objects/objectEditAgentDescriptionDialog.html',
                  parent             : angular.element('body'),
                  locals: {
                    object_data : $scope.object_data
                  },
                  clickOutsideToClose: true
              });
      		}

          //редактирование поля заметок агента по объекту
      		function showObjectCostHistory(id) {
            $mdDialog.show({
                  controller         : function ($scope, $mdDialog)
                    {
                      $scope.object_id = id;
                      var object_cost = new api.objects.costhistorybyobjectid.query({'id':id},
                        function(data) {
                        $scope.cost_data = data;
                      });

                      $scope.closeDialog = function ()
                      {
                        $mdDialog.hide();
                      }
                    },
                    templateUrl: 'app/objects/objectCostHistoryDialog.html',
                    parent             : angular.element('body'),
                    locals: {
                      cost_data : $scope.cost_data,
                      object_id : $scope.object_id
                    },
                    clickOutsideToClose: true
                });
            }

          function processObjects() {
            vm.houses_by_id = {};

            //составляем новый массив объектов с индексами = id объектов
        		for (var i=0;i<vm.houses.length;i++) {
        			vm.houses_by_id[vm.houses[i].id] = {'group': vm.houses[i].group_id, 'owner': vm.houses[i].owner_id};
        			//подменяем статусы визы и листинга, чтобы выводить нужную иконку
        			switch(vm.houses[i].visa_status) {
        				case 'yes': vm.houses[i].visastatus = ''; break
        				case 'no': vm.houses[i].visastatus = '-outline'; break
        			}
        			switch(vm.houses[i].listing_status) {
        				case 'yes': vm.houses[i].listingstatus = ''; break
        				case 'no': vm.houses[i].listingstatus = '-outline'; break
        			}
        			switch(vm.houses[i].visa_publish) {
        				case 'yes': vm.houses[i].visapublish = ''; break
        				case 'no': vm.houses[i].visapublish = '-outline'; break
        			}
              if (vm.houses[i].cost == 0 || vm.houses[i].cost == null) {
                vm.houses[i].cost = vm.houses[i].rentcost;
                vm.houses[i].cost += ' руб.';
                  if (vm.houses[i].pay_duration == 'month') vm.houses[i].cost += '/месяц';
                  if (vm.houses[i].pay_duration == 'day') vm.houses[i].cost += '/сутки';
              } else {
                vm.houses[i].cost += ' руб.';
              }
        		}
          }

                //просмотр объекта
            		function viewObject(id, ev) {
            			$mdDialog.show({
                      controller         : function ($scope, $mdDialog)
                      {
                      var viewobject = new api.objects.objectbyid.query({'id':id},
                          function(data) {
                            //собираем адрес
                            /*if (data.district!=1000) {
                              api.objects.district.query({'id':data.district,'r_id':data.region}, function(distr) {
                        				data.district = distr.name;
                              });
                            } else {
                              data.district = '';
                            }*/
                          //фотографии
                          api.objects.objectphotosbyid.query({'id':id}, function(data) {
                              $scope.photos = data.data;
                      				vm.total = $scope.photos.length;
                      				//меняем адреса изображений
                      				for(var i=0; i < vm.total;i++){
                                //замена на адреса, как на сервере
                                $scope.photos[i].filename = api.domain_name + api.domain_images + $scope.photos[i].filename;
                                //$scope.photos[i].filename = '/functions/images/' + $scope.photos[i].filename;
                      				}
                    			});

                          //направление
                          if (data.direction!=null && data.direction>0) {
                            api.objects.direction.query({'id':data.direction}, function(direct) {
                              data.direction_name = '(' + direct.name + ' направление - ' + data.from_mcad + ' км)';
                            });
                          } else {
                            data.direction_name = '';
                          }

                          switch (parseInt(data.region)) {
                            case 1: data.region = 'Москва, '; break
                            case 2: data.region = 'Моск.обл., '; break
                          }

                          if (data.city_type!=null) data.region += data.city_type + '. ';
                          if (data.city!=null) data.region += data.city;

                          //тип объекта
                          switch (data.object_type) {
                            case 'production_land': data.object_type = 'Пром. земля '; break
                            case 'townhouse': data.object_type = 'Таунхаус '; break
                            case 'zsn': data.object_type = 'Участок - ЗСН '; break
                            case 'znp': data.object_type = 'Участок - ЗНП '; break
                            case 'zoot': data.object_type = 'Участок - ЗООТ '; break
                            case 'zwilf': data.object_type = 'Участок - ЗВИЛФ '; break
                            case 'zemli_zapasa': data.object_type = 'Участок - Земли запаса '; break
                            case 'cottage': data.object_type = 'Коттедж '; break
                            case 'country_house': data.object_type = 'Дача '; break
                            case 'parcel': data.object_type = 'Участок '; break
                          }

                          //Целевое назначение земель
                          switch (data.country_land_type) {
                            case 'snt': data.object_type += '(СНТ)'; break
                            case 'igs': data.object_type += '(ИЖС)'; break
                            case 'farm': data.object_type += '(Фермерское хозяйство)'; break
                            case 'dnp': data.object_type += '(ДНП)'; break
                          }

                          switch (data.object_type_2) {
                            case 'real': data.object_type_2 = ''; break
                            case 'hog-wash': data.object_type_2 = '(утка)'; break
                            case 'invest': data.object_type_2 = '(инвестиционный)'; break
                            case 'auction': data.object_type_2 = '(аукцион)'; break
                          }
                          //сделка и цена
                          if (data.deal_id==null) data.deal_id = 'Номер не присвоен'

                          switch (data.pay_duration) {
                            case 'day': data.pay_duration = '/день'; break
                            case 'month': data.pay_duration = '/месяц'; break
                            case 'year': data.pay_duration = '/год'; break
                          }

                          switch (data.pay_type) {
                            case 'object': data.pay_type = '/объект'; break
                            case 'squarem': data.pay_type = '/м2'; break
                          }

                          switch (data.deal_type) {
                            case 'rent':
                            case 'subrent':
                            case 'ppa':
                            case 'dsd': data.cost = data.rentcost + " руб." + data.pay_duration; break// + data.pay_type; break
                            case 'sale':
                            case 'change': data.cost = data.cost + " руб."; break
                          }

                          switch (data.deal_type) {
                            case 'rent': data.deal_type = 'Аренда'; break
                            case 'subrent': data.deal_type = 'Субаренда'; break
                            case 'ppa': data.deal_type = 'Продажа права аренды'; break
                            case 'dsd': data.deal_type = 'Договор совместной деятельности'; break
                            case 'sale': data.deal_type = 'Продажа'; break
                            case 'change': data.deal_type = 'Альтернатива'; break
                          }

                          if (!parseInt(data.story)>0) {
                            data.story = '-';
                          }
                          if (!parseInt(data.story_count)>0) {
                            data.story_count = '-';
                          }

                          //визы и листинг
                          switch(data.visa_status) {
                            case 'yes': data.visa_status = 'icon-label'; break
                            case 'no': data.visa_status = 'icon-label-outline'; break
                          }
                          switch(data.listing_status) {
                            case 'yes': data.listing_status = 'icon-note'; break
                            case 'no': data.listing_status = 'icon-note-outline'; break
                          }
                          switch(data.visa_publish) {
                            case 'yes': data.visa_publish = 'icon-star'; break
                            case 'no': data.visa_publish = 'icon-star-outline'; break
                          }

                          //площади
                          if (parseInt(data.square_land)>0) {
                            data.square_land = 'Площадь участка: ' + data.square_land + ' соток';
                          } else {
                            data.square_land = 'Площадь участка: -';
                          }
                          if (parseInt(data.square_living)>0) {
                            data.square_living = 'Площадь дома: ' + data.square_living + ' м2';
                            if (parseInt(data.story_count)>0) {
                              data.story_count = 'Этажность: ' + data.story_count;
                            } else {
                              data.story_count = '';
                            }
                            if (parseInt(data.earthsq)>0) {
                              data.earthsq = 'Площадь участка: ' + data.earthsq + ' м2';
                            } else {
                              data.earthsq = 'Площадь участка: -';
                            }
                          } else {
                            data.square_living = 'Площадь дома: -';
                          }

                          //холодильник
                          switch(data.tech_4) {
                            case 'yes': data.tech_4 = 'Есть'; break
                            case 'no': data.tech_4 = 'Нет'; break
                            default: data.tech_4 = '-'; break
                          }
                          //стиральная машина
						  switch(data.tech_8) {
							case 'yes': data.tech_8 = 'Есть'; break
							case 'no': data.tech_8 = 'Нет'; break
							case '1': data.tech_8 = '1'; break
							case '2': data.tech_8 = '2'; break
							case '3': data.tech_8 = '3'; break
							case '4': data.tech_8 = '4'; break
						  default: data.tech_8 = '-'; break
                          }
                          //Эркер
                          switch(data.erker) {
                            case 'yes': data.erker = 'Есть'; break
                            case 'no': data.erker = 'Нет'; break
                            default: data.erker = '-'; break
                          }
                          //Мансарда
                          switch(data.garret) {
                            case 'yes': data.garret = 'Есть'; break
                            case 'no': data.garret = 'Нет'; break
                            default: data.garret = '-'; break
                          }
                          //Цоколь
                          switch(data.socle) {
                            case 'yes': data.socle = 'Есть'; break
                            case 'no': data.socle = 'Нет'; break
                            default: data.socle = '-'; break
                          }
                          //Баня Сауна
                          switch(data.bath_house) {
                            case 'yes': data.bath_house = 'Есть'; break
                            case 'no': data.bath_house = 'Нет'; break
                            default: data.bath_house = '-'; break
                          }
                          switch(data.sauna) {
                            case 'yes': data.sauna = 'Есть'; break
                            case 'no': data.sauna = 'Нет'; break
                            default: data.sauna = '-'; break
                          }
                          //Телевизор
                          switch(data.tv) {
                            case 'yes': data.tv = 'Есть'; break
                            case 'no': data.tv = 'Нет'; break
                            default: data.tv = '-'; break
                          }
                          //Бассейн
                          switch(data.pool) {
                            case 'yes': data.pool = 'Есть'; break
                            case 'no': data.pool = 'Нет'; break
                            default: data.pool = '-'; break
                          }
                          //Газ
                          switch(data.gas_item) {
                            case 'yes': data.gas_item = 'Есть'; break
                            case 'no': data.gas_item = 'Нет'; break
                            case 'project': data.gas_item = 'Оплачен проект'; break
                            case 'autonomous': data.gas_item = 'Автономная газ-я'; break
                            case 'border': data.gas_item = 'По границе участка'; break
                            default: data.gas_item = '-'; break
                          }
                          //электричество
                          switch(data.enegi) {
                            case 'yes': data.enegi = 'Есть'; break
                            case 'request': data.enegi = 'Подана заявка'; break
                            case 'unknown': data.enegi = 'Возможность подключения неизвестна'; break
                            case 'possible': data.enegi = 'Возможно подключить'; break
                            default: data.enegi = '-'; break
                          }
                          //отопление
                          switch(data.heating) {
                            case 'central': data.heating = 'Центральное'; break
                            case 'no': data.heating = 'Нет'; break
                            case 'autonomous': data.heating = 'Автономное'; break
                            default: data.heating = '-'; break
                          }
                          //Водоснабжение
                          switch(data.water_on_item) {
                            case 'yes': data.water_on_item = 'Есть'; break
                            case 'cesspool': data.water_on_item = 'Скважина'; break
                            case 'centra': data.water_on_item = 'Центральное'; break
                            case 'spring': data.water_on_item = 'Колодец/колонка'; break
                            case 'no': data.water_on_item = 'Отсутствует'; break
                            case 'border': data.water_on_item = 'По границе участка'; break
                            default: data.water_on_item = '-'; break
                          }
                          //Канализация
                          switch(data.sewage_item) {
                            case 'yes': data.sewage_item = 'Есть'; break
                            case 'cesspool': data.sewage_item = 'Выгребная яма'; break
                            case 'bio': data.sewage_item = 'Устройства биоочистки'; break
                            case 'autonomous': data.sewage_item = 'Автономная'; break
                            case 'no': data.sewage_item = 'Нет'; break
                            case 'central': data.sewage_item = 'Центральная'; break
                            case 'septic': data.sewage_item = 'Септики'; break
                            default: data.sewage_item = '-'; break
                          }
                          //мебель
                          switch(data.furniture) {
                            case 'old': data.furniture = 'Есть'; break
                            case 'no': data.furniture = 'Нет'; break
                            default: data.furniture = '-'; break
                          }
                          //телефон/интернет
                          switch(data.phone) {
                            case 'yes': data.phone = 'Есть'; break
                            case 'no': data.phone = 'Нет'; break
                            default: data.phone = '-'; break
                          }
                          switch(data.inet) {
                            case 'yes': data.inet = 'Есть'; break
                            case 'no': data.inet = 'Нет'; break
                            default: data.inet = '-'; break
                          }
                          //Гараж
                          switch(data.count_garage) {
                            case 'yes': data.count_garage = 'Есть'; break
                            case 'no': data.count_garage = 'Нет'; break
                            default: data.count_garage = '-'; break
                          }
                          //Коммуникации в гараже
                          switch(data.energi_garage) {
                            case 'elect-heat': data.count_garage += ' (Эл-во и отопление)'; break
                            case 'heating': data.count_garage += ' (Отопление)'; break
                            case 'electricity': data.count_garage += ' (Электричество)'; break
                          }
                          //ремонт
                          switch(data.repairs) {
                            case 'euro': data.repairs = 'Евро'; break
                            case 'cosmetic': data.repairs = 'Косметический'; break
                            case 'no': data.repairs = 'Без ремонта'; break
                            default: data.repairs = '-'; break
                          }
                          //право собственности
                          switch(data.ownership) {
                            case 'primary': data.ownership = 'Первичная приватизация'; break
                            case 'contract-sales': data.ownership = 'Договор купли/продажи'; break
                            case 'contract-donat': data.ownership = 'Договор дарения'; break
                            case 'contract-rent': data.ownership = 'Договор ренты'; break
                            case 'paid': data.ownership = 'ЖСК, выплаченный пай'; break
                            case 'legacy': data.ownership = 'Наследство'; break
                            case 'court': data.ownership = 'Решение суда'; break
                            case 'mortgage': data.ownership = 'Залог (ипотека)'; break
                            case 'invest': data.ownership = 'По договору инвестирования'; break
                            default: data.ownership = '-'; break
                          }
                          //Тип дома
                          switch(data.type_bild) {
                            case 'block': data.type_bild = 'Блочный'; break
                            case 'panel': data.type_bild = 'Панельный'; break
                            case 'brick': data.type_bild = 'Кирпичный'; break
                            case 'wood': data.type_bild = 'Деревянный'; break
                            case 'stalin': data.type_bild = 'Сталинский'; break
                            case 'monolith': data.type_bild = 'Монолит'; break
                            case 'brickmonolith': data.type_bild = 'Монолитно-кирпичный'; break
                            default: data.type_bild = '-'; break
                          }
                          //Балкон
                          switch(data.balcony) {
                            case '2loggia': data.balcony = '2 лоджии'; break
                            case '2balcon': data.balcony = '2 балкона'; break
                            case 'loggia': data.balcony = 'Лоджия'; break
                            case 'yes': data.balcony = 'Есть'; break
                            case 'no': data.balcony = 'Нет'; break
                            default: data.balcony = '-'; break
                          }
                          //присваиваем полученные и отредактированные данные
                          $scope.object_data = data;
                          $scope.markers = [
                            {coordinates:[data.longitude, data.latitude], properties: {balloonContent: 'Объект '+data.id}, options: {preset: 'islands#icon', iconColor: '#2e2bff'}},

                          ];
                          //настройки положения карты
                          $scope.map = {
                              center: [data.longitude, data.latitude], zoom: 17
                          };

                          data.domain_name = api.domain_name;
                  		});
                      //////////////////////////////////////
                          $scope.closeDialog = function ()
                          {
                              $mdDialog.hide();
                          }
                      },
                            templateUrl: 'app/objects/suburbian/objectViewDialog.html',
                            parent             : angular.element('body'),
                            locals: {
                              object_data : $scope.object_data,
                              markers: $scope.markers,
                              map: $scope.map
                            },
                            clickOutsideToClose: true
                        });
            		}

        //смена состояния визы
		function changeVisa(id,param_value) {
      var changevisa = new api.objects.changeVisaStatus();
      changevisa.id = id;
      changevisa.param_value = param_value;
      changevisa.$save();

      for(var i = 0; i < vm.houses.length; i++) {
         if(vm.houses[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.houses[i].visastatus = '-outline';
             vm.houses[i].visa_status = 'no';
             angular.element($('#object_visa_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_visa_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.houses[i].visastatus = '';
             vm.houses[i].visa_status = "yes";
             angular.element($('#object_visa_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_visa_'+id)).addClass('visa_listing_green');
           }
           break;
         }
      }
		}
		//смена состояния листинга
		function changeListing(id,param_value) {
      var changelisting = new api.objects.changeListingStatus();
      changelisting.id = id;
      changelisting.param_value = param_value;
      changelisting.$save();

      for(var i = 0; i < vm.houses.length; i++) {
         if(vm.houses[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.houses[i].listingstatus = '-outline';
             vm.houses[i].listing_status = 'no';
             angular.element($('#object_listing_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_listing_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.houses[i].listingstatus = '';
             vm.houses[i].listing_status = 'yes';
             angular.element($('#object_listing_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_listing_'+id)).addClass('visa_listing_green');
           }
           break;
         }
       }
		}
		//смена состояния визы на публикацию
		function changeVisaP(id,param_value) {
      var changevisap = new api.objects.changeVisaPStatus();
      changevisap.id = id;
      changevisap.param_value = param_value;
      changevisap.$save();

      for(var i = 0; i < vm.houses.length; i++) {
         if(vm.houses[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.houses[i].visapublish = '-outline';
             vm.houses[i].visa_publish = 'no';
             angular.element($('#object_visap_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_visap_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.houses[i].visapublish = '';
             vm.houses[i].visa_publish = 'yes';
             angular.element($('#object_visap_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_visap_'+id)).addClass('visa_listing_green');
           }
           break;
         }
       }
		}
        function changeArchiveStatus(n) {
			switch(n) {
				case 0: vm.archive = false; break
				case 1: vm.archive = true;	break
			}
		}
        ///////////////////////////////
        function checkArchiveStatus(n) {
			switch(n) {
				case 'icon':
				if (vm.archive == true) {
					return 'icon-arrow-right-bold-circle';
					}
				else {
					return 'icon-delete';
					}
			break
			default:
				if (vm.archive == true) {
					return true;
					}
				else {
					return false;
					}
			break
			}
		}

        //создание объекта
        function addObject() {
			$location.path('/objects/new/suburbian');
		}
		//редактирование объекта
		function editObject(id,type) {
			//для клика по иконке и для двойного клика
			switch(type){
				case 1:	$location.path('/objects/edit/suburbian/'+id); break
				case 2: $rootScope.$apply(function() {
							$location.path('/objects/edit/suburbian/'+id);
						});
						break
			}
		}
		function restore_archiveObject(id) {
			if (vm.archive == true) {
				restoreObject(id);
			}
			else {
				archiveObject(id);
			}
		}

    //диалог с предупреждением об удалении объекта
    function archiveObject(id,ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Отправить объект в архив?',
                parent             : '#content',
                textContent        : '',
                ariaLabel          : 'remove object',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Удалить',
                cancel             : 'Отмена'
            });

            $mdDialog.show(confirm).then(function ()
            {
              archiveObject_object(id);
            }, function ()
            {
              //
            });
        }

		//удаление объекта
		function archiveObject_object(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var archiveobject = new api.objects.archiveobject();
					archiveobject.id = id;
					archiveobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/suburbian');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект {{id}} отправлен в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//восстановление объекта
		function restoreObject(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var restoreobject = new api.objects.restoreobject();
					restoreobject.id = id;
					restoreobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/suburbian/archive');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект {{id}} восстановлен из архива</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//нет прав
		function showSetListingError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия листинга обратитесь к листинг-менеджеру</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}
		function showSetVisaError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия визы обратитесь к начальнику отдела</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}
		function showSetVisaPError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия визы на публикацию на сайте обратитесь к начальнику отдела</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}

		//двойнок клик на строку
		function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			$('td', nRow).unbind('dblclick');
			$('td', nRow).bind('dblclick', function() {
				//если есть право на редакцию
				if (($rootScope.checkRule(19,vm.houses_by_id[aData[0]].group,'group')) || ((vm.houses_by_id[aData[0]].owner == vm.userid) && $rootScope.checkRule(19,'my') && vm.archive == false) || $rootScope.checkRule(19,'all')) {
					//(vm.houses_by_id[aData[0]].group == vm.groupid) &&
					editObject(aData[0],2);
				} else {
				console.log('id '+aData[0]+' group: '+vm.houses_by_id[aData[0]].group);
				$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Нет прав на редактирование этого объекта</h1></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
				}
			});
			return nRow;
		}
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.newobject', ['app.objects.newobject.newflat','app.objects.newobject.newflatrent','app.objects.newobject.newsuburbian','app.objects.newobject.newcommerce']);

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.newobject')
        .controller('NewObjectController', NewObjectController);
  
    /** @ngInject */
    function NewObjectController($mdDialog, $location, api)
    {
        var vm = this;      					
		//все вынесено в частные контроллеры
		//на сервере принимаются данные единообразно
	}    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.flats', ['app.objects.flats.archive','ymaps'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_flats', {
            url    : '/objects/flats',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/flats/flats.html',
                    controller : 'FlatController as vm'
                }
            },
            resolve: {
                Flats: function (apiResolver)
                {                  
                    return apiResolver.resolve('objects.flats@get',{'my':'true','first':'true'});
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.flats')
        .controller('FlatController', FlatController);

    /** @ngInject */
    function FlatController($scope, $rootScope, $location, $mdDialog, Flats, api)
    {
        var vm = this;

        vm.flats = Flats.data;

        vm.room_filter = 0;

        processObjects();

        //получаем id своей должности
        api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
          vm.positionid = data.position_id;
          //получаем список объектов через функцию
          //только для риэлторов и их начальников изначально только свои
          if (vm.positionid==1 || vm.positionid==7 || vm.positionid==10) {
            vm.onlyMy = true;
            //для риэлторов помечаем галку
          } else {
            //загружаем в модуле и меняем только, если это необходимо
            vm.onlyMy = false;
          }
        });

    //получаем id своей учетной записи для сверки собственности на объект
    api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
			vm.userid = data.user_id;
		});
		//получаем id своего отдела
    api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
			vm.groupid = data.group_id;
		});

    //для квартир разделение на продажу и аренду --- выясняем адрес, который будем выводить для кнопок актуал/архив
    if (['/objects/flats','/objects/flats/archive'].indexOf($location.path())>=0) {
      vm.actuallink = '/objects/flats';
      vm.archivelink = '/objects/flats/archive';
    } else {
      vm.actuallink = '/objects/flatsrent';
      vm.archivelink = '/objects/flatsrent/archive';
      vm.ifRent = ' (аренда)'
    }

    if (['/objects/flats','/objects/flatsrent'].indexOf($location.path())>=0) {
			vm.archive = false;
		} else if (['/objects/flats/archive','/objects/flatsrent/archive'].indexOf($location.path())>=0) {
			vm.archive = true;
		}


      ///////////////////обновление таблицы документов после загрузки
      vm.total = 0;
      vm.dtInstance = {};

      vm.dtIntanceCallback = function (instance) {
        vm.dtInstance = instance;
      }

      vm.dtOptions = {
          dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          pagingType: 'simple',
          autoWidth : false,
          responsive: true,
          pageLength: 100,
          rowCallback: rowCallback,
          oLanguage: {
			sUrl:"/assets/datatables.lang"
			},
			"columns": [
				null,
        { "orderable": false },
				null,
				null,
				null,
				//null,
        null,
				//{"type": 'num-fmt'}
				//null
        { "orderable": false }, //фото
        { "orderable": false }, //телефон
        { "orderable": false }, //параметры
        { "orderable": true }
			  ],
        "buttons": [
          {
             extend: "print",
             text: "Печать",
             title:  "Список квартир",
             className: "DTBblack",
             exportOptions: {
                columns: [0,6,8,5,7],
             },
             autoPrint: false,
             customize: function (w) {
                console.log('custom print', vm.flats);
                var visibleId = 1;
                //$(w.document.body).find('tbody tr').css('font-size', '18px');
                $(w.document.body).find('tbody tr').each(function(index){
                    for (var i=0;i<vm.flats.length;i++) {
                      if ($(this).find('td:first-child').text() == vm.flats[i].id) {
                        if (!vm.flats[i].printstatus) {
                          $(this).css('visibility','hidden').css('display','none');
                          continue;
                        } else {
                          //console.log('visible ', i, vm.flats[i].id, visibleId);
                          //$(this).find('td:first-child').text(visibleId);
                          visibleId = visibleId + 1;
                          $(this).find('td:nth-child(3)').html($(this).find('td:nth-child(3)').text().replace(new RegExp('brbr', 'g'), '<br>'));
                          //console.log('custom print ::: ',$(this),$(this).find('td:nth-child(3)').text());

                        }
                      }
                    }
                    // if (vm.flats[index] !== undefined && !vm.flats[index].printstatus) {
                    //   console.log($(this), index, $(this).find('td:first-child').text(), vm.flats[index].id);
                    //   $(this).css('visibility','hidden').css('display','none');
                    // }
                });
                $(w.document.body).find('h1').css('text-align','center');
                $(w.document.body).find('tr:visible:nth-child(odd) td').each(function(index){
                    $(this).css('background-color','#f0f0f0');
                });
            },
             // https://www.datatables.net/reference/button/print
            //  action: function () {
            //    console.log('custom print', vm.flats);
            //    vm.flats = vm.flats.filter(function(f) { return f.printstatus;});
            //    console.log('custom print', vm.flats.filter(function(f) { return f.printstatus;}));
            //    //////////////
            //    var myWindow = window.open("", "MsgWindow", "width=1000px,height=800px");
             //
            //    myWindow.document.write("<h1>Список квартир</h1>");
            //    myWindow.document.write("<table><thead><tr><th>ID</th><th>Действия</th><th>В/Л/П</th><th>Агент</th><th>Адрес</th><th>Цена</th></tr></thead><tbody>");
            //    myWindow.document.write("<tr><td>292</td><td>292</td><td>292</td><td>292</td><td>292</td><td>292</td></tr>");
            //    myWindow.document.write("</tbody></table>");
            //   //  vm.flats = vm.flats.filter(function(f) { return f.printstatus;});
            //   //  window.print();
            //    myWindow.onunload = function() {
            //      vm.flats = Flats.data;
            //    };
            //  }
           },
          {
             extend: "excel",
             text: "Сохранить таблицу",
             className: "DTBblack",
             //fileName:  "Список клиентов.xls",
             title:"Список квартир",
             exportOptions: {
                 columns: ':visible'
             }
         },
         {
            text: '↻',
            className: "DTBblackNormal",
            action: function () {
                updateObjectsTable();
            }
          }
        ],
			  "order": [0, "desc"]
        };

        // Methods
		vm.addObject = addObject;
		vm.editObject = editObject;
    vm.viewObject = viewObject;
		vm.archiveObject = archiveObject;
		vm.restoreObject = restoreObject;
		vm.restore_archiveObject = restore_archiveObject;
		vm.showSetListingError = showSetListingError;
    vm.editObjectAgentDescription = editObjectAgentDescription;
    vm.showObjectCostHistory = showObjectCostHistory;
		vm.showSetVisaError = showSetVisaError;
		vm.showSetVisaPError = showSetVisaPError;
		vm.changeVisa = changeVisa;
		vm.changeListing = changeListing;
		vm.changeVisaP = changeVisaP;
    vm.changeMeet = changeMeet;
    vm.changePrint = changePrint;
    vm.isPrint = isPrint;
		//проверка на архив и установка переменной на архив
		vm.Arch = changeArchiveStatus;
		vm.isArch = checkArchiveStatus;
    vm.updateObjectsTable = updateObjectsTable;
    vm.addBuyer = addBuyer;
    vm.callToObject = callToObject;
    vm.filter_room = filter_room;
    vm.getFirstPhoto = getFirstPhoto;
		vm.copyObject = copyObject;



        // Methods
        //////////////////////////////

        function getFirstPhoto(flat) {
          // if ((flat.filename === null)) {
          //   return 'Нет фотографии';
          // } else {
          //   if (!window.DOMParser) return false;
          // 	var parser = new DOMParser();
          // 	try {
          //     console.log('parser ', parser, '<img style="width:250px;" src="http://srd-rieltor.ru/images/' + flat.filename + '">');
          //     return parser.parseFromString('<img style="width:250px;" src="http://srd-rieltor.ru/images/' + flat.filename + '">', 'text/html');
          // 	} catch(err) {
          // 		return false;
          // 	}
          // }
          return (flat.filename === null) ? 'Нет фотографии' : ('<img style="height:125px;" src="https://first-online.ru/images/' + flat.filename + '">');
        }

        //редактирование поля звонка
        function callToObject(id) {
        $mdDialog.show({
              controller         : function ($scope, $mdDialog)
                {
                  var viewobject = new api.objects.notebyobjectid.query({'id':id},
                    function(note) {
                    //получаем текст заметки, если есть
                    var data = [];
                    data.id = id;
                    data.calldate_string = note.call_deadline;
                    console.log(data.calldate_string);
                    console.log(note);
                    $scope.object_data = data;
                  });

                  $scope.closeDialog = function ()
                  {
                    $mdDialog.hide();
                  }
                  //сохранить заметку
                  $scope.changeCallDate = function (id,date,minutes,agent_description)
                  {
                    //console.log(date);
                    if (minutes>0) {
                      var datet = minutes;
                    } else {
                      var datet = Date.parse(date);
                      datet = Math.round(datet/1000);
                    }

                    if (typeof(agent_description) !== "undefined" && agent_description.length>0) {
                      var concatagentdescription = new api.objects.concatAgentDescription();
                      concatagentdescription.id = id;
                      concatagentdescription.agent_description = agent_description; //datet + ": " +
                      concatagentdescription.$save();
                    }

                    //console.log(Math.round(datet/1000));
                    //console.log(datet.getFullYear());
                    var changecalldate = new api.objects.changecalldate();
                    changecalldate.id = id;
                    changecalldate.date = datet;
                    changecalldate.$save();
                    $mdDialog.hide();
                  }
                },
                templateUrl: 'app/modules/my_ownerbase/favownerEditCallTimeDialog.html',
                parent             : angular.element('body'),
                locals: {
                  object_data : $scope.object_data
                },
                clickOutsideToClose: true
            });
        }

        //////////обновление таблицы
        function updateObjectsTable()
          {
            vm.room_filter = 0; //сброс фильтра
            //в зависимости от страницы, где мы находимся - отдаем нужный запрос
            //архив в переспективе можно превратить в параметр, как onlyMy, сохраняя ссылку
            //TODO унификация в бэкэнде в одну функцию?
            //////////////////////////////
            //обновляем подгруженному списку некоторые столбцы
            if ($location.path()=='/objects/flats') {
              api.objects.flats.query({'my':vm.onlyMy}, function(data) {
                vm.flats = data.data;
                vm.total = vm.flats.length;
                processObjects();
              });
            } else if ($location.path()=='/objects/flatsrent') {
              api.objects.flatsrent.query({'my':vm.onlyMy}, function(data) {
                vm.flats = data.data;
                vm.total = vm.flats.length;
                processObjects();
              });
        		} else if ($location.path()=='/objects/flats/archive') {
              api.objects.flatsarchive.query({'my':vm.onlyMy}, function(data) {
                vm.flats = data.data;
                vm.total = vm.flats.length;
                processObjects();
              });
            } else if ($location.path()=='/objects/flatsrent/archive') {
              api.objects.flatsrentarchive.query({'my':vm.onlyMy}, function(data) {
                vm.flats = data.data;
                vm.total = vm.flats.length;
                processObjects();
              });
        		}
          }

          function processObjects() {
            vm.flats_by_id = {};

            //если показывать только один - напоминание
            if ($location.search().showId) {
              console.log('show only one object: '+$location.search().showId);
              //console.log(vm.flats);
              //console.log();
              api.objects.flats.query({'showId': $location.search().showId}, function(data) {
                vm.flats = data.data;
                vm.total = vm.flats.length;
              });
            }

            //составляем новый массив объектов с индексами = id объектов
        		for (var i=0;i<vm.flats.length;i++) {
        			vm.flats_by_id[vm.flats[i].id] = {'group': vm.flats[i].group_id, 'owner': vm.flats[i].owner_id};
        			//подменяем статусы визы и листинга, чтобы выводить нужную иконку
        			switch(vm.flats[i].visa_status) {
        				case 'yes': vm.flats[i].visastatus = ''; break
        				case 'no': vm.flats[i].visastatus = '-outline'; break
        			}
        			switch(vm.flats[i].listing_status) {
        				case 'yes': vm.flats[i].listingstatus = ''; break
        				case 'no': vm.flats[i].listingstatus = '-outline'; break
        			}
        			switch(vm.flats[i].visa_publish) {
        				case 'yes': vm.flats[i].visapublish = ''; break
        				case 'no': vm.flats[i].visapublish = '-outline'; break
        			}
              //Тип дома
              switch(vm.flats[i].type_bild) {
                case 'block': vm.flats[i].type_bild = 'Блочный'; break
                case 'panel': vm.flats[i].type_bild = 'Панельный'; break
                case 'brick': vm.flats[i].type_bild = 'Кирпичный'; break
                case 'wood': vm.flats[i].type_bild = 'Деревянный'; break
                case 'stalin': vm.flats[i].type_bild = 'Сталинский'; break
                case 'monolith': vm.flats[i].type_bild = 'Монолит'; break
                case 'brickmonolith': vm.flats[i].type_bild = 'Монолитно-кирпичный'; break
                default: vm.flats[i].type_bild = '-'; break
              }

               switch(vm.flats[i].xml_cian) {
                case '1': vm.flats[i].xml_cian = 'Платное'; break
                case '4': vm.flats[i].xml_cian = ''; break

                default: vm.flats[i].xml_cian = '-'; break
              }

              //default
              vm.flats[i].printstatus = false;
              vm.flats[i].printicon = 'icon-checkbox-blank-outline';

              vm.flats[i].meetstatus = 'icon-checkbox-blank-circle-outline';
              switch(vm.flats[i].meet) {
                case 'yes': vm.flats[i].meetstatus = 'icon-brightness-1'; break
                case 'no': vm.flats[i].meetstatus = 'icon-checkbox-blank-circle-outline'; break
              }

              if (vm.flats[i].cost == 0 || vm.flats[i].cost == null) {
                vm.flats[i].cost = vm.flats[i].rentcost;
                vm.flats[i].cost += ' руб.';
                  if (vm.flats[i].pay_type == 'squarem') vm.flats[i].cost += '/м2';
                  if (vm.flats[i].pay_duration == 'month') vm.flats[i].cost += '/месяц';
                  if (vm.flats[i].pay_duration == 'year') vm.flats[i].cost += '/год';
              } else {
                vm.flats[i].cost += ' руб.';
              }





              vm.flats[i].rooms_number_int = parseInt(vm.flats[i].rooms_number);
              //комнаты
              switch (vm.flats[i].rooms_number) {
                case '1': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Однокомнатные':'Однокомнатная'; break
                case '2': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Двухкомнатные':'Двухкомнатная'; break
                case '3': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Трехкомнатные':'Трехкомнатная'; break
                case '4': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Четырехкомнатные':'Четырехкомнатная'; break
                case '5': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Пятикомнатные':'Пятикомнатная'; break
                case 'm': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Многокомнатные':'Многокомнатная'; break
                case 'studio': vm.flats[i].rooms_number = 'Студия'; break

                case 'd_1': vm.flats[i].rooms_number = 'Доля в однокомнатной'; break
                case 'd_2': vm.flats[i].rooms_number = 'Доля в двухкомнатной'; break
                case 'd_3': vm.flats[i].rooms_number = 'Доля в трехкомнатной'; break
                case 'd_4': vm.flats[i].rooms_number = 'Доля в четырехкомнатной'; break
                case 'd_5': vm.flats[i].rooms_number = 'Доля в пятикомнатной'; break
                case '1_2': vm.flats[i].rooms_number = 'Комната в двухкомнатной'; break
                case '1_3': vm.flats[i].rooms_number = 'Комната в трехкомнатной'; break
                case '1_4': vm.flats[i].rooms_number = 'Комната в четырехкомнатной'; break
                case '1_5': vm.flats[i].rooms_number = 'Комната в пятикомнатной'; break
                case '2_3': vm.flats[i].rooms_number = '2 комнаты в трехкомнатной'; break
                case '2_4': vm.flats[i].rooms_number = '2 комнаты в четырехкомнатной'; break
                case '2_5': vm.flats[i].rooms_number = '2 комнаты в пятикомнатной'; break
                case '3_4': vm.flats[i].rooms_number = '3 комнаты в четырехкомнатной'; break
                case '3_5': vm.flats[i].rooms_number = '3 комнаты в пятикомнатной'; break
              }
        		}
          }

        //просмотр объекта
    		function viewObject(id, ev) {
    			$mdDialog.show({
              controller         : function ($scope, $mdDialog)
              {
              var viewobject = new api.objects.objectbyid.query({'id':id},
                  function(data) {

                  //фотографии
                  api.objects.objectphotosbyid.query({'id':id}, function(data) {
                      $scope.photos = data.data;
              				vm.total = $scope.photos.length;
              				//меняем адреса изображений
              				for(var i=0; i < vm.total;i++){
                        //замена на адреса, как на сервере
                        $scope.photos[i].filename = api.domain_name + api.domain_images + $scope.photos[i].filename;
                        //$scope.photos[i].filename = '/functions/images/' + $scope.photos[i].filename;
              				}
            			});

                  switch (parseInt(data.region)) {
                    case 1: data.region = 'Москва, '; break
                    case 2: data.region = 'Моск.обл., '; break
                  }

                  if (data.city_type!=null) data.region += data.city_type + '. ';
                  if (data.city!=null) data.region += data.city;
              //    if ((data.street).length>1) data.region += ', ' + data.street;
                  if ((data.street).length!=null) data.region += ', ' + data.street;
                  if (data.house_number!=null) data.region += ', ' + data.house_number;

                  //тип объекта
                  switch (data.object_type) {
                    case 'flat_new_building': data.object_type = 'Новостройка '; break
                    case 'flat': data.object_type = 'Квартира '; break
                    case 'apartments': data.object_type = 'Апартаменты '; break
                    case 'room': data.object_type = 'Комната '; break
                    case 'part': data.object_type = 'Доля (' + data.part_percent + ')'; break
                    case 'penthouse': data.object_type = 'Пентхаус '; break
                    //case 'townhouse': data.object_type = 'Таунхаус '; break
                    /*case 'garage': data.object_type = 'Гараж '; break
                    case 'office': data.object_type = 'Офис '; break
                    case 'commercial_premises': data.object_type = 'Торговое помещение '; break
                    case 'stock': data.object_type = 'Склад '; break
                    case 'ready_business': data.object_type = 'Готовый бизнес '; break
                    case 'psn': data.object_type = 'ПСН '; break
                    case 'production_room': data.object_type = 'Производственное помещение '; break
                    case 'production_land': data.object_type = 'Пром. земля '; break
                    case 'zsn': data.object_type = 'Участок - ЗСН '; break
                    case 'znp': data.object_type = 'Участок - ЗНП '; break
                    case 'zoot': data.object_type = 'Участок - ЗООТ '; break
                    case 'zwilf': data.object_type = 'Участок - ЗВИЛФ '; break
                    case 'zemli_zapasa': data.object_type = 'Участок - Земли запаса '; break
                    case 'cottage': data.object_type = 'Коттедж '; break
                    case 'country_house': data.object_type = 'Дача '; break
                    case 'parcel': data.object_type = 'Участок '; break*/
                  }
                  //console.log('x'+data.object_type+'x');
                  //комнаты
                  switch (data.rooms_number) {
                    case '1': data.rooms_number = (data.object_type == 'Апартаменты ')?'Однокомнатные':'Однокомнатная'; break
                    case '2': data.rooms_number = (data.object_type == 'Апартаменты ')?'Двухкомнатные':'Двухкомнатная'; break
                    case '3': data.rooms_number = (data.object_type == 'Апартаменты ')?'Трехкомнатные':'Трехкомнатная'; break
                    case '4': data.rooms_number = (data.object_type == 'Апартаменты ')?'Четырехкомнатные':'Четырехкомнатная'; break
                    case '5': data.rooms_number = (data.object_type == 'Апартаменты ')?'Пятикомнатные':'Пятикомнатная'; break
                    case 'm': data.rooms_number = (data.object_type == 'Апартаменты ')?'Многокомнатные':'Многокомнатная'; break
                    case 'studio': data.rooms_number = 'Студия'; break

                    case 'd_1': data.rooms_number = 'Доля в однокомнатной'; break
                    case 'd_2': data.rooms_number = 'Доля в двухкомнатной'; break
                    case 'd_3': data.rooms_number = 'Доля в трехкомнатной'; break
                    case 'd_4': data.rooms_number = 'Доля в четырехкомнатной'; break
                    case 'd_5': data.rooms_number = 'Доля в пятикомнатной'; break
                    case '1_2': data.rooms_number = 'Комната в двухкомнатной'; break
                    case '1_3': data.rooms_number = 'Комната в трехкомнатной'; break
                    case '1_4': data.rooms_number = 'Комната в четырехкомнатной'; break
                    case '1_5': data.rooms_number = 'Комната в пятикомнатной'; break
                    case '2_3': data.rooms_number = '2 комнаты в трехкомнатной'; break
                    case '2_4': data.rooms_number = '2 комнаты в четырехкомнатной'; break
                    case '2_5': data.rooms_number = '2 комнаты в пятикомнатной'; break
                    case '3_4': data.rooms_number = '3 комнаты в четырехкомнатной'; break
                    case '3_5': data.rooms_number = '3 комнаты в пятикомнатной'; break
                  }
                  /*
                  switch (data.country_land_type) {
                    case 'snt': data.object_type += '(СНТ)'; break
                    case 'igs': data.object_type += '(ИЖС)'; break
                    case 'farm': data.object_type += '(Фермерское хозяйство)'; break
                    case 'dnp': data.object_type += '(Участок)'; break
                  }
                  */
                  switch (data.object_type_2) {
                    case 'real': data.object_type_2 = ''; break
                    case 'hog-wash': data.object_type_2 = '(утка)'; break
                    case 'invest': data.object_type_2 = '(инвестиционный)'; break
                    case 'auction': data.object_type_2 = '(аукцион)'; break
                  }
                  //сделка и цена
                  if (data.deal_id==null) data.deal_id = 'Номер не присвоен'

                  switch (data.pay_duration) {
                    case 'day': data.pay_duration = '/день'; break
                    case 'month': data.pay_duration = '/месяц'; break
                    case 'year': data.pay_duration = '/год'; break
                  }

                  switch (data.pay_type) {
                    case 'object': data.pay_type = '/объект'; break
                    case 'squarem': data.pay_type = '/м2'; break
                  }

                  switch (data.deal_type) {
                    case 'rent':
                    case 'subrent':
                    case 'ppa':
                    case 'dsd': data.cost = data.rentcost + " руб." + data.pay_duration; break// + data.pay_type; break
                    case 'dupt':
                    case 'sale':
                    case 'change': data.cost = data.cost + " руб."; break
                  }

                  switch (data.deal_type) {
                    case 'rent': data.deal_type = 'Аренда'; break
                    case 'subrent': data.deal_type = 'Субаренда'; break
                    case 'ppa': data.deal_type = 'Продажа права аренды'; break
                    case 'dsd': data.deal_type = 'Договор совместной деятельности'; break
                    case 'sale': data.deal_type = 'Продажа'; break
                    case 'change': data.deal_type = 'Альтернатива'; break
                    case 'dupt': data.deal_type = 'Переуступка'; break
                  }



                  if (!parseInt(data.story)>0) {
                    data.story = '-';
                  }
                  if (!parseInt(data.story_count)>0) {
                    data.story_count = '-';
                  }

                  //визы и листинг
                  switch(data.visa_status) {
                    case 'yes': data.visa_status = 'icon-label'; break
                    case 'no': data.visa_status = 'icon-label-outline'; break
                  }
                  switch(data.listing_status) {
                    case 'yes': data.listing_status = 'icon-note'; break
                    case 'no': data.listing_status = 'icon-note-outline'; break
                  }
                  switch(data.visa_publish) {
                    case 'yes': data.visa_publish = 'icon-star'; break
                    case 'no': data.visa_publish = 'icon-star-outline'; break
                  }
                  //метро и направление
                  if (data.direction!=null && data.direction>0) {
                    api.objects.direction.query({'id':data.direction}, function(direct) {
                      data.direction = 'Направление: ' + direct.name + ' (' + data.from_mcad + ' км)';
                    });
                  } else {
                    data.direction = '';
                  }
                  if (data.metro_1!=null && data.metro_1>0) {
                    api.objects.metrostation.query({'id':data.metro_1}, function(metro) {
                      data.metro_1 = metro.name;
                      switch (data.metro_1_time) {
                        case 'f_2': data.metro_1_time = '(2 минуты пешком)'; break
                        case 'f_5': data.metro_1_time = '(5 минут пешком)'; break
                        case 'f_7': data.metro_1_time = '(7 минут пешком)'; break
                        case 'f_10': data.metro_1_time = '(10 минут пешком)'; break
                        case 'f_15': data.metro_1_time = '(15 минут пешком)'; break
                        case 'f_20': data.metro_1_time = '(20 минут пешком)'; break
                        case 't_5': data.metro_1_time = '(5 минут транспортом)'; break
                        case 't_10': data.metro_1_time = '(10 минут транспортом)'; break
                        case 't_15': data.metro_1_time = '(15 минут транспортом)'; break
                        case 't_20': data.metro_1_time = '(20 минут транспортом)'; break
                      }
                    });
                  } else {
                    data.metro_1 = '-';
                  }
                  if (data.metro_2!=null && data.metro_2>0) {
                    api.objects.metrostation.query({'id':data.metro_2}, function(metro) {
                      data.metro_2 = metro.name;
                      switch (data.metro_2_time) {
                        case 'f_2': data.metro_2_time = '((2 минуты пешком)'; break
                        case 'f_5': data.metro_2_time = '(5 минут пешком)'; break
                        case 'f_7': data.metro_2_time = '(7 минут пешком)'; break
                        case 'f_10': data.metro_2_time = '(10 минут пешком)'; break
                        case 'f_15': data.metro_2_time = '(15 минут пешком)'; break
                        case 'f_20': data.metro_2_time = '(20 минут пешком)'; break
                        case 't_5': data.metro_2_time = '(5 минут транспортом)'; break
                        case 't_10': data.metro_2_time = '(10 минут транспортом)'; break
                        case 't_15': data.metro_2_time = '(15 минут транспортом)'; break
                        case 't_20': data.metro_2_time = '(20 минут транспортом)'; break
                      }
                    });
                  } else {
                    data.metro_2 = '';
                  }
                  if (data.metro_3!=null && data.metro_3>0) {
                    api.objects.metrostation.query({'id':data.metro_3}, function(metro) {
                      data.metro_3 = metro.name;
                      switch (data.metro_3_time) {
                        case 'f_2': data.metro_3_time = '(2 минуты пешком)'; break
                        case 'f_5': data.metro_3_time = '(5 минут пешком)'; break
                        case 'f_7': data.metro_3_time = '(7 минут пешком)'; break
                        case 'f_10': data.metro_3_time = '(10 минут пешком)'; break
                        case 'f_15': data.metro_3_time = '(15 минут пешком)'; break
                        case 'f_20': data.metro_3_time = '(20 минут пешком)'; break
                        case 't_5': data.metro_3_time = '(5 минут транспортом)'; break
                        case 't_10': data.metro_3_time = '(10 минут транспортом)'; break
                        case 't_15': data.metro_3_time = '(15 минут транспортом)'; break
                        case 't_20': data.metro_3_time = '(20 минут транспортом)'; break
                      }
                    });
                  } else {
                    data.metro_3 = '';
                  }
                  //холодильник
                  switch(data.tech_4) {
                    case 'yes': data.tech_4 = 'Есть'; break
                    case 'no': data.tech_4 = 'Нет'; break
                    default: data.tech_4 = '-'; break
                  }
                  //стиральная машина
                  switch(data.tech_8) {
                   case 'yes': data.tech_8 = 'Есть'; break
                   case 'no': data.tech_8 = 'Нет'; break
                   case '1': data.tech_8 = '1'; break
                   case '2': data.tech_8 = '2'; break
                   case '3': data.tech_8 = '3'; break
                   default: data.tech_8 = '-'; break
                 }
                  //мебель
                  switch(data.furniture) {
                    case 'old': data.furniture = 'Старая'; break
                    case '90s': data.furniture = 'Мебель 90-х'; break
                    case 'modern': data.furniture = 'Современная'; break
                    case 'no': data.furniture = 'Нет'; break
                    default: data.furniture = '-'; break
                  }
                  //телефон/интернет
                  switch(data.phone) {
                    case 'yes': data.phone = 'Есть'; break
                    case 'para': data.phone = 'Спаренный'; break
                    case 'possible': data.phone = 'Возможно подключить'; break
                    case 'no': data.phone = 'Нет'; break
                    default: data.phone = '-'; break
                  }
                  switch(data.inet) {
                    case 'yes': data.inet = 'Есть'; break
                    case 'no': data.inet = 'Нет'; break
                    case 'full': data.inet = 'Полная'; break
                    case 'partial': data.inet = 'Неполная'; break
                    case 'discussed': data.inet = 'Обсуждается'; break
                    default: data.inet = '-'; break
                  }
                  //ремонт
                  switch(data.repairs) {
                    case 'euro': data.repairs = 'Евро'; break
                    case 'capital': data.repairs = 'Дизайнерский'; break
                    case 'cosmetic': data.repairs = 'Косметический'; break
                    case 'no': data.repairs = 'Без ремонта'; break
                    default: data.repairs = '-'; break
                  }
                  //типы санузла
                  switch(data.type_bathroom) {
                    case 'separated': data.type_bathroom = 'Раздельный'; break
                    case 'combined': data.type_bathroom = 'Совмещенный'; break
                    default: data.type_bathroom = '-'; break
                  }
                  //право собственности
                  switch(data.ownership) {
                    case 'primary': data.ownership = 'Приватизация'; break
                    case 'contract-sales': data.ownership = 'Договор купли/продажи'; break
                    case 'contract-donat': data.ownership = 'Договор дарения'; break
                    case 'contract-rent': data.ownership = 'Договор ренты'; break
                    case 'paid': data.ownership = 'ЖСК, выплаченный пай'; break
                    case 'legacy': data.ownership = 'Наследство'; break
                    case 'court': data.ownership = 'Решение суда'; break
                    case 'mortgage': data.ownership = 'Залог (ипотека)'; break
                    case 'invest': data.ownership = 'ДДУ'; break
                    case 'contract-meni': data.ownership = 'Договор мены'; break
                    default: data.ownership = '-'; break
                  }
                  //Тип дома
                  switch(data.type_bild) {
                    case 'block': data.type_bild = 'Блочный'; break
                    case 'panel': data.type_bild = 'Панельный'; break
                    case 'brick': data.type_bild = 'Кирпичный'; break
                    case 'wood': data.type_bild = 'Деревянный'; break
                    case 'stalin': data.type_bild = 'Сталинский'; break
                    case 'monolith': data.type_bild = 'Монолит'; break
                    case 'brickmonolith': data.type_bild = 'Монолитно-кирпичный'; break
                    default: data.type_bild = '-'; break
                  }
                  //Статус
                  switch(data.flat_status) {
                    case 'free': data.flat_status = 'Свободна'; break
                    case 'patrol': data.flat_status = 'Расселение/разъед'; break
                    case 'alternate': data.flat_status = 'Альтернатива'; break
                    case 'no': data.flat_status = 'Никто не прописан'; break
                    default: data.flat_status = '-'; break
                  }
                  //Лифт
                  switch(data.lift) {
                    case 'pass': data.lift = 'Пассажирский'; break
                    case 'serv': data.lift = 'Грузовой'; break
                    case 'passserv': data.lift = 'Пасс. + груз.'; break
                    case '2pass1serv': data.lift = '2 пасс. + груз.'; break
                    case '1pass2serv': data.lift = 'Пасс. + 2 груз.'; break
                    case '2pass2serv': data.lift = '2 пасс. + 2 груз.'; break
                    case '2pass': data.lift = '2 пассажирских'; break
                    case '2serv': data.lift = '2 грузовых'; break
                    case 'no': data.lift = 'Нет'; break
                    default: data.lift = '-'; break
                  }
                  //Балкон
                  switch(data.balcony) {
                    case '2loggia': data.balcony = '2 лоджии'; break
                    case '2balcon': data.balcony = '2 балкона'; break
                    case 'loggia': data.balcony = 'Лоджия'; break
                    case 'yes': data.balcony = 'Есть'; break
                    case 'no': data.balcony = 'Нет'; break
                    default: data.balcony = '-'; break
                  }
                  //в собственности
                  switch(data.years_own) {
                    case 'less3': data.years_own = 'Менее 3 лет'; break
                    case 'more3': data.years_own = 'Более 3 лет'; break
                    case 'more5': data.years_own = 'Более 5 лет'; break
                    default: data.years_own = '-'; break
                  }
                  switch(data.windows) {
                    case 'yard': data.windows = 'Двор'; break
                    case 'street': data.windows = 'Улица'; break
                    case 'both': data.windows = 'Двор и улица'; break
                    default: data.windows = '-'; break
                  }
                  //присваиваем полученные и отредактированные данные
                  $scope.object_data = data;

                  //карта
                  $scope.markers = [
                    {coordinates:[data.longitude, data.latitude], properties: {balloonContent: 'Объект '+data.id}, options: {preset: 'islands#icon', iconColor: '#2e2bff'}},

                  ];
                  //настройки положения карты
                  $scope.map = {
                      center: [data.longitude, data.latitude], zoom: 17
                  };

                  data.domain_name = api.domain_name;
          		});
              //////////////////////////////////////
                  $scope.closeDialog = function ()
                  {
                      $mdDialog.hide();
                  }
              },
                    templateUrl: 'app/objects/flats/objectViewDialog.html',
                    parent             : angular.element('body'),
                    locals: {
                      object_data : $scope.object_data,
                      markers: $scope.markers,
                      photos: $scope.photos,
                      map: $scope.map
                    },
                    clickOutsideToClose: true
                });
    		}

        //смена состояния визы
		function changeVisa(id,param_value) {

      var changevisa = new api.objects.changeVisaStatus();
      changevisa.id = id;
      changevisa.param_value = param_value;
      changevisa.$save();

      for(var i = 0; i < vm.flats.length; i++) {
         if(vm.flats[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.flats[i].visastatus = '-outline';
             vm.flats[i].visa_status = 'no';
             angular.element($('#object_visa_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_visa_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.flats[i].visastatus = '';
             vm.flats[i].visa_status = "yes";
             angular.element($('#object_visa_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_visa_'+id)).addClass('visa_listing_green');
           }
           break;
         }
      }/*
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var changevisa = new api.objects.changeVisaStatus();
					changevisa.id = id;
					changevisa.param_value = param_value;
					changevisa.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Статус визы изменен</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });*/
		}
		//смена состояния листинга
		function changeListing(id,param_value) {

      var changelisting = new api.objects.changeListingStatus();
      changelisting.id = id;
      changelisting.param_value = param_value;
      changelisting.$save();

      for(var i = 0; i < vm.flats.length; i++) {
         if(vm.flats[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.flats[i].listingstatus = '-outline';
             vm.flats[i].listing_status = 'no';
             angular.element($('#object_listing_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_listing_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.flats[i].listingstatus = '';
             vm.flats[i].listing_status = 'yes';
             angular.element($('#object_listing_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_listing_'+id)).addClass('visa_listing_green');
           }
           break;
         }
       }
      /*
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var changelisting = new api.objects.changeListingStatus();
					changelisting.id = id;
					changelisting.param_value = param_value;
					changelisting.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Статус листинга изменен</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });*/
		}



    function changePrint(id, param_value) {
      //console.log('changePrint', id, param_value);
      for(var i = 0; i < vm.flats.length; i++) {
         if(vm.flats[i].id == id) {
           vm.flats[i].printstatus = !param_value;
           //hack
           angular.element($('#object_print_'+vm.flats[i].id)).removeClass(vm.flats[i].printicon)
           vm.flats[i].printicon = vm.isPrint(vm.flats[i].printstatus);
           angular.element($('#object_print_'+vm.flats[i].id)).addClass(vm.flats[i].printicon)
           //console.log(vm.flats[i].id, vm.flats[i].printicon, angular.element($('#object_print_'+vm.flats[i].id)));
           break;
         }
       }
    }

    function isPrint(param_value) {
      // можно убрать
      return (param_value ? 'icon-checkbox-blank' : 'icon-checkbox-blank-outline');
    }

    //смена состояния визы на публикацию
		function changeMeet(id,param_value) {

      var changemeet = new api.objects.changeMeetStatus();
      changemeet.id = id;
      changemeet.param_value = param_value;
      changemeet.$save();

      for(var i = 0; i < vm.flats.length; i++) {
         if(vm.flats[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.flats[i].meetstatus = 'icon-checkbox-blank-circle-outline';
             vm.flats[i].meet = 'no';
             angular.element($('#object_meet_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_meet_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.flats[i].meetstatus = 'icon-brightness-1';
             vm.flats[i].meet = 'yes';
             angular.element($('#object_meet_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_meet_'+id)).addClass('visa_listing_green');
           }
           break;
         }
       }
		}
		//смена состояния визы на публикацию
		function changeVisaP(id,param_value) {

      var changevisap = new api.objects.changeVisaPStatus();
      changevisap.id = id;
      changevisap.param_value = param_value;
      changevisap.$save();

      for(var i = 0; i < vm.flats.length; i++) {
         if(vm.flats[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.flats[i].visapublish = '-outline';
             vm.flats[i].visa_publish = 'no';
             angular.element($('#object_visap_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_visap_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.flats[i].visapublish = '';
             vm.flats[i].visa_publish = 'yes';
             angular.element($('#object_visap_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_visap_'+id)).addClass('visa_listing_green');
           }
           break;
         }
       }

			/*$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var changevisap = new api.objects.changeVisaPStatus();
					changevisap.id = id;
					changevisap.param_value = param_value;
					changevisap.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Статус визы на публикацию изменен</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });*/
		}
    function changeArchiveStatus(n) {
			switch(n) {
				case 0: vm.archive = false; break
				case 1: vm.archive = true;	break
			}
		}
        ///////////////////////////////
    function checkArchiveStatus(n) {
			switch(n) {
				case 'icon':
				if (vm.archive == true) {
					return 'icon-arrow-right-bold-circle';
					}
				else {
					return 'icon-delete';
					}
			break
			default:
				if (vm.archive == true) {
					return true;
					}
				else {
					return false;
					}
			break
			}
		}

    function addBuyer(object_id) {
      $location.path('/contacts/contragents/new').search({isBuyer:'Y', objectN:object_id});
    }

        //создание объекта
    function addObject() {
      $mdDialog.show({
            controller         : function ($scope, $mdDialog)
              {
                // $scope.object_id = id;
                // var object_cost = new api.objects.costhistorybyobjectid.query({'id':id},
                //   function(data) {
                //   $scope.cost_data = data;
                // });
                $scope.createClient = function ()
                {
                  $mdDialog.hide();
                  $location.path('/contacts/clients/new').search({fromObjects:'Y'});
                }

                $scope.createObject = function ()
                {
                  $mdDialog.hide();
                  $location.path('/objects/new/flat');
                }

              },
              templateUrl: 'app/objects/objectCreateSellerDialog.html',
              parent             : angular.element('body'),
              locals: {
                // cost_data : $scope.cost_data,
                // object_id : $scope.object_id
              },
              clickOutsideToClose: true
          });
          //$location.path('/objects/new/flat');
		}

		//редактирование объекта
		function editObject(id,type) {
			//для клика по иконке и для двойного клика
			switch(type){
				case 1:	$location.path('/objects/edit/flat/'+id); break
				case 2: $rootScope.$apply(function() {
							$location.path('/objects/edit/flat/'+id);
						});
						break
			}
		}

    //редактирование поля заметок агента по объекту
		function editObjectAgentDescription(id) {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
              var viewobject = new api.objects.notebyobjectid.query({'id':id},
                function(note) {
                //получаем текст заметки, если есть
                var data = [];
                data.id = id;
                data.agent_descr = note.agent_description;
                $scope.object_data = data;
              });

							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
              //сохранить заметку
              $scope.changeAgentDescription = function (id,text)
							{
                var changeagentdescription = new api.objects.changeAgentDescription();
                changeagentdescription.id = id;
                changeagentdescription.agent_description = text;
                changeagentdescription.$save();
								$mdDialog.hide();
							}
						},
            templateUrl: 'app/objects/objectEditAgentDescriptionDialog.html',
            parent             : angular.element('body'),
            locals: {
              object_data : $scope.object_data
            },
            clickOutsideToClose: true
        });
		}

    //редактирование поля заметок агента по объекту
		function showObjectCostHistory(id) {
      $mdDialog.show({
            controller         : function ($scope, $mdDialog)
              {
                $scope.object_id = id;
                var object_cost = new api.objects.costhistorybyobjectid.query({'id':id},
                  function(data) {
                  $scope.cost_data = data;
                });

                $scope.closeDialog = function ()
                {
                  $mdDialog.hide();
                }
              },
              templateUrl: 'app/objects/objectCostHistoryDialog.html',
              parent             : angular.element('body'),
              locals: {
                cost_data : $scope.cost_data,
                object_id : $scope.object_id
              },
              clickOutsideToClose: true
          });
      }


    //диалог о копировании объекта
      function copyObject(id) {
  			$mdDialog.show({
                  controller         : function ($scope, $mdDialog)
                  {
                      ////////////
                      $scope.copyWithArchive = function ()
                      {
                          //alert(id);
                          var copyobject = new api.objects.copyobject_witharchive();
                					copyobject.id = id;
                					copyobject.$save();

                          $scope.closeDialog();
                          updateObjectsTable();
                      }
                      ////////////
                      $scope.copyWithoutArchive = function ()
                      {
                          var copyobject = new api.objects.copyobject_withoutarchive();
                					copyobject.id = id;
                					copyobject.$save();

                          $scope.closeDialog();
                          updateObjectsTable();
                      }
                      ////////////
                      $scope.closeDialog = function ()
                      {
                          $mdDialog.hide();
                          //$location.path('/objects/flats');
                          //$route.reload();
                      }
                  },
                  template: '<md-dialog>' +
                  '  <md-dialog-content><h1>Копирование объекта</h1>Отправить в архив объект {{id}}?</md-dialog-content>' +
                  '  <md-dialog-actions>' +
                  '    <md-button ng-click="copyWithArchive()" class="md-warn">' +
                  '      Да' +
                  '    </md-button>' +
                  '    <md-button ng-click="copyWithoutArchive()" class="md-primary">' +
                  '      Нет' +
                  '    </md-button>' +
                  '    <md-button ng-click="closeDialog()" class="md-primary">' +
                  '      Отмена' +
                  '    </md-button>' +
                  '  </md-dialog-actions>' +
                  '</md-dialog>',
                  parent             : angular.element('body'),
                  clickOutsideToClose: true
              });
  		}

		function restore_archiveObject(id) {
			if (vm.archive == true) {
				restoreObject(id);
			}
			else {
				archiveObject(id);
			}
		}

    //диалог с предупреждением об удалении объекта
    function archiveObject(id,ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Отправить объект в архив?',
                parent             : '#flat'+id,
                textContent        : '',
                ariaLabel          : 'remove object',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                //ok                 : 'Удалить',
                //cancel             : 'Отмена'
                ok                 : 'Да',
                cancel             : 'Нет'
            });

            $mdDialog.show(confirm).then(function ()
            {
              archiveObjectIsSell(id,ev);
            }, function ()
            {
              //
            });
        }

      //диалог с предупреждением об удалении объекта
      function archiveObjectIsSell(id,ev)
          {
              /*var confirm = $mdDialog.confirm({
                  title              : 'Объект продан?',
                  parent             : '#flat'+id,
                  textContent        : '',
                  ariaLabel          : 'remove object',
                  targetEvent        : ev,
                  clickOutsideToClose: true,
                  escapeToClose      : true,
                  ok                 : 'Да',
                  cancel             : 'Нет'
              });*/

              $mdDialog.show({
                        controller         : function ($scope, $mdDialog)
                        {
                          $scope.closeDialogYes = function ()
                          {
                              archiveObject_object(id, true);
                          }

                          $scope.closeDialogNo = function ()
                          {
                              archiveObject_object(id, false);
                          }
                        },
                        template: '<md-dialog>' +
                        '  <md-dialog-content><h1>Объект продан?</h1></md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="closeDialogNo()" class="md-primary">' +
                        '      Нет' +
                        '    </md-button>' +
                        '    <md-button ng-click="closeDialogYes()" class="md-primary">' +
                        '      Да' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                        parent             : angular.element('body'),
                        clickOutsideToClose: true
                    });

              // $mdDialog.show(confirm).then(function ()
              // {
              //   archiveObject_object(id);
              // }, function ()
              // {
              //   //
              // });
          }

		//удаление объекта
		function archiveObject_object(id, is_sell) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var archiveobject = new api.objects.archiveobject();
					archiveobject.id = id;
          if (is_sell) {
              archiveobject.deal_type = 1;
          }
					archiveobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flats');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект {{id}} отправлен в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//восстановление объекта
		function restoreObject(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var restoreobject = new api.objects.restoreobject();
					restoreobject.id = id;
					restoreobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flats/archive');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект {{id}} восстановлен из архива</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//нет прав
		function showSetListingError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия листинга обратитесь к листинг-менеджеру</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}
    function showSetMeetError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для отметки встречи с клиентом обратитесь к начальнику отдела</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}

		function showSetVisaError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия визы обратитесь к начальнику отдела</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}
		function showSetVisaPError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия визы на публикацию на сайте обратитесь к начальнику отдела</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}

      //фильтр по числу комнат
  		function filter_room(n, ev) {
  			vm.room_filter = n;
        //console.log('filter', n, vm.userid, Flats.data);
        var flats = Flats.data;
        //////////////
        if (vm.onlyMy) {
          flats = flats.filter(function(f) { return parseInt(f.owner_id) == parseInt(vm.userid);});
        }
        //////////////////
        if (n > 0) {
          if (n == 4) {
            vm.flats = flats.filter(function(f) { return f.rooms_number_int >= n;});
          } else {
            vm.flats = flats.filter(function(f) { return f.rooms_number_int == n;});
          }
        } else {
          if (n == 0) {
            //все
            vm.flats = flats;
          } else {
            //только проданные
            vm.flats = flats.filter(function(f) { return f.deal_type == 'selled';});
          }
        }
  		}


		//двойнок клик на строку
		function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			$('td', nRow).unbind('dblclick');
			$('td', nRow).bind('dblclick', function() {
				//если есть право на редакцию
				if (($rootScope.checkRule(19,vm.flats_by_id[aData[0]].group,'group')) || ((vm.flats_by_id[aData[0]].owner == vm.userid) && $rootScope.checkRule(19,'my') && vm.archive == false) || $rootScope.checkRule(19,'all')) {
					//(vm.flats_by_id[aData[0]].group == vm.groupid) &&
					editObject(aData[0],2);
				} else {
				console.log('id '+aData[0]+' group: '+vm.flats_by_id[aData[0]].group);
				$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Нет прав на редактирование этого объекта</h1></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
				}
			});
			return nRow;
		}
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.flatsrent', ['app.objects.flatsrent.archive','ymaps'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_flatsrent', {
            url    : '/objects/flatsrent',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/flatsrent/flatsrent.html',
                    controller : 'FlatRentController as vm'
                }
            },
            resolve: {
                Flats: function (apiResolver)
                {
                    return apiResolver.resolve('objects.flatsrent@get',{'my':'true','first':'true'});
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.flatsrent')
        .controller('FlatRentController', FlatRentController);

    /** @ngInject */
    function FlatRentController($scope, $rootScope, $location, $mdDialog, Flats, api)
    {
        var vm = this;

        vm.flats = Flats.data;

        vm.room_filter = 0;

        processObjects();

        //получаем id своей должности
        api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
          vm.positionid = data.position_id;
          //получаем список объектов через функцию
          //только для риэлторов и их начальников изначально только свои
          if (vm.positionid==1 || vm.positionid==7 || vm.positionid==10) {
            vm.onlyMy = true;
            //для риэлторов помечаем галку
          } else {
            //загружаем в модуле и меняем только, если это необходимо
            vm.onlyMy = false;
          }
        });

    //получаем id своей учетной записи для сверки собственности на объект
    api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
			vm.userid = data.user_id;
		});
		//получаем id своего отдела
    api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
			vm.groupid = data.group_id;
		});

    //для квартир разделение на продажу и аренду --- выясняем адрес, который будем выводить для кнопок актуал/архив
    if (['/objects/flats','/objects/flats/archive'].indexOf($location.path())>=0) {
      vm.actuallink = '/objects/flats';
      vm.archivelink = '/objects/flats/archive';
    } else {
      vm.actuallink = '/objects/flatsrent';
      vm.archivelink = '/objects/flatsrent/archive';
      vm.ifRent = ' (аренда)'
    }

    if (['/objects/flats','/objects/flatsrent'].indexOf($location.path())>=0) {
			vm.archive = false;
		} else if (['/objects/flats/archive','/objects/flatsrent/archive'].indexOf($location.path())>=0) {
			vm.archive = true;
		}


      ///////////////////обновление таблицы документов после загрузки
      vm.total = 0;
      vm.dtInstance = {};

      vm.dtIntanceCallback = function (instance) {
        vm.dtInstance = instance;
      }

      vm.dtOptions = {
          dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          pagingType: 'simple',
          autoWidth : false,
          responsive: true,
          pageLength: 100,
          rowCallback: rowCallback,
          oLanguage: {
			sUrl:"/assets/datatables.lang"
			},
			"columns": [
				null,
        { "orderable": false },
				null,
				null,
				null,
				//null,
        null,
				//{"type": 'num-fmt'}
				//null
        { "orderable": false }, //фото
        { "orderable": false }, //телефон
        { "orderable": false }, //параметры
			  ],
        "buttons": [
          {
             extend: "print",
             text: "Печать",
             title:  "Список квартир",
             className: "DTBblack",
             exportOptions: {
                columns: [0,6,8,5,7],
             },
             autoPrint: false,
             customize: function (w) {
                console.log('custom print', vm.flats);
                var visibleId = 1;
                //$(w.document.body).find('tbody tr').css('font-size', '18px');
                $(w.document.body).find('tbody tr').each(function(index){
                    for (var i=0;i<vm.flats.length;i++) {
                      if ($(this).find('td:first-child').text() == vm.flats[i].id) {
                        if (!vm.flats[i].printstatus) {
                          $(this).css('visibility','hidden').css('display','none');
                          continue;
                        } else {
                          //console.log('visible ', i, vm.flats[i].id, visibleId);
                          //$(this).find('td:first-child').text(visibleId);
                          visibleId = visibleId + 1;
                          $(this).find('td:nth-child(3)').html($(this).find('td:nth-child(3)').text().replace(new RegExp('brbr', 'g'), '<br>'));
                          //console.log('custom print ::: ',$(this),$(this).find('td:nth-child(3)').text());

                        }
                      }
                    }
                    // if (vm.flats[index] !== undefined && !vm.flats[index].printstatus) {
                    //   console.log($(this), index, $(this).find('td:first-child').text(), vm.flats[index].id);
                    //   $(this).css('visibility','hidden').css('display','none');
                    // }
                });
                $(w.document.body).find('h1').css('text-align','center');
                $(w.document.body).find('tr:visible:nth-child(odd) td').each(function(index){
                    $(this).css('background-color','#f0f0f0');
                });
            },
             // https://www.datatables.net/reference/button/print
            //  action: function () {
            //    console.log('custom print', vm.flats);
            //    vm.flats = vm.flats.filter(function(f) { return f.printstatus;});
            //    console.log('custom print', vm.flats.filter(function(f) { return f.printstatus;}));
            //    //////////////
            //    var myWindow = window.open("", "MsgWindow", "width=1000px,height=800px");
             //
            //    myWindow.document.write("<h1>Список квартир</h1>");
            //    myWindow.document.write("<table><thead><tr><th>ID</th><th>Действия</th><th>В/Л/П</th><th>Агент</th><th>Адрес</th><th>Цена</th></tr></thead><tbody>");
            //    myWindow.document.write("<tr><td>292</td><td>292</td><td>292</td><td>292</td><td>292</td><td>292</td></tr>");
            //    myWindow.document.write("</tbody></table>");
            //   //  vm.flats = vm.flats.filter(function(f) { return f.printstatus;});
            //   //  window.print();
            //    myWindow.onunload = function() {
            //      vm.flats = Flats.data;
            //    };
            //  }
           },
          {
             extend: "excel",
             text: "Сохранить таблицу",
             className: "DTBblack",
             //fileName:  "Список клиентов.xls",
             title:"Список квартир",
             exportOptions: {
                 columns: ':visible'
             }
         },
         {
            text: '↻',
            className: "DTBblackNormal",
            action: function () {
                updateObjectsTable();
            }
          }
        ],
			  "order": [0, "desc"]
        };

        // Methods
		vm.addObject = addObject;
		vm.editObject = editObject;
    vm.viewObject = viewObject;
		vm.archiveObject = archiveObject;
		vm.restoreObject = restoreObject;
		vm.restore_archiveObject = restore_archiveObject;
		vm.showSetListingError = showSetListingError;
    vm.editObjectAgentDescription = editObjectAgentDescription;
    vm.showObjectCostHistory = showObjectCostHistory;
		vm.showSetVisaError = showSetVisaError;
		vm.showSetVisaPError = showSetVisaPError;
		vm.changeVisa = changeVisa;
		vm.changeListing = changeListing;
		vm.changeVisaP = changeVisaP;
    vm.changeMeet = changeMeet;
    vm.changePrint = changePrint;
    vm.isPrint = isPrint;
		//проверка на архив и установка переменной на архив
		vm.Arch = changeArchiveStatus;
		vm.isArch = checkArchiveStatus;
    vm.updateObjectsTable = updateObjectsTable;
    vm.addBuyer = addBuyer;
    vm.callToObject = callToObject;
    vm.filter_room = filter_room;
    vm.getFirstPhoto = getFirstPhoto;
		vm.copyObject = copyObject;



        // Methods
        //////////////////////////////

        //диалог с предупреждением об удалении объекта
          function copyObject(id) {
      			$mdDialog.show({
                      controller         : function ($scope, $mdDialog)
                      {
                          ////////////
                          $scope.copyWithArchive = function ()
                          {
                              //alert(id);
                              var copyobject = new api.objects.copyobject_witharchive();
                    					copyobject.id = id;
                    					copyobject.$save();

                              $scope.closeDialog();
                              updateObjectsTable();
                          }
                          ////////////
                          $scope.copyWithoutArchive = function ()
                          {
                              var copyobject = new api.objects.copyobject_withoutarchive();
                    					copyobject.id = id;
                    					copyobject.$save();

                              $scope.closeDialog();
                              updateObjectsTable();
                          }
                          ////////////
                          $scope.closeDialog = function ()
                          {
                              $mdDialog.hide();
                              //$location.path('/objects/flats');
                              //$route.reload();
                          }
                      },
                      template: '<md-dialog>' +
                      '  <md-dialog-content><h1>Копирование объекта</h1>Отправить в архив объект {{id}}?</md-dialog-content>' +
                      '  <md-dialog-actions>' +
                      '    <md-button ng-click="copyWithArchive()" class="md-warn">' +
                      '      Да' +
                      '    </md-button>' +
                      '    <md-button ng-click="copyWithoutArchive()" class="md-primary">' +
                      '      Нет' +
                      '    </md-button>' +
                      '    <md-button ng-click="closeDialog()" class="md-primary">' +
                      '      Отмена' +
                      '    </md-button>' +
                      '  </md-dialog-actions>' +
                      '</md-dialog>',
                      parent             : angular.element('body'),
                      clickOutsideToClose: true
                  });
      		}

        function getFirstPhoto(flat) {
          // if ((flat.filename === null)) {
          //   return 'Нет фотографии';
          // } else {
          //   if (!window.DOMParser) return false;
          // 	var parser = new DOMParser();
          // 	try {
          //     console.log('parser ', parser, '<img style="width:250px;" src="http://srd-rieltor.ru/images/' + flat.filename + '">');
          //     return parser.parseFromString('<img style="width:250px;" src="http://srd-rieltor.ru/images/' + flat.filename + '">', 'text/html');
          // 	} catch(err) {
          // 		return false;
          // 	}
          // }
          return (flat.filename === null) ? 'Нет фотографии' : ('<img style="height:125px;" src="https://first-online.ru/images/' + flat.filename + '">');
        }

        //редактирование поля звонка
        function callToObject(id) {
        $mdDialog.show({
              controller         : function ($scope, $mdDialog)
                {
                  var viewobject = new api.objects.notebyobjectid.query({'id':id},
                    function(note) {
                    //получаем текст заметки, если есть
                    var data = [];
                    data.id = id;
                    data.calldate_string = note.call_deadline;
                    console.log(data.calldate_string);
                    console.log(note);
                    $scope.object_data = data;
                  });

                  $scope.closeDialog = function ()
                  {
                    $mdDialog.hide();
                  }
                  //сохранить заметку
                  $scope.changeCallDate = function (id,date,minutes,agent_description)
                  {
                    //console.log(date);
                    if (minutes>0) {
                      var datet = minutes;
                    } else {
                      var datet = Date.parse(date);
                      datet = Math.round(datet/1000);
                    }

                    if (typeof(agent_description) !== "undefined" && agent_description.length>0) {
                      var concatagentdescription = new api.objects.concatAgentDescription();
                      concatagentdescription.id = id;
                      concatagentdescription.agent_description = agent_description; //datet + ": " +
                      concatagentdescription.$save();
                    }

                    //console.log(Math.round(datet/1000));
                    //console.log(datet.getFullYear());
                    var changecalldate = new api.objects.changecalldate();
                    changecalldate.id = id;
                    changecalldate.date = datet;
                    changecalldate.$save();
                    $mdDialog.hide();
                  }
                },
                templateUrl: 'app/modules/my_ownerbase/favownerEditCallTimeDialog.html',
                parent             : angular.element('body'),
                locals: {
                  object_data : $scope.object_data
                },
                clickOutsideToClose: true
            });
        }

        //////////обновление таблицы
        function updateObjectsTable()
          {
            vm.room_filter = 0; //сброс фильтра
            //в зависимости от страницы, где мы находимся - отдаем нужный запрос
            //архив в переспективе можно превратить в параметр, как onlyMy, сохраняя ссылку
            //TODO унификация в бэкэнде в одну функцию?
            //////////////////////////////
            //обновляем подгруженному списку некоторые столбцы
            if ($location.path()=='/objects/flats') {
              api.objects.flats.query({'my':vm.onlyMy}, function(data) {
                vm.flats = data.data;
                vm.total = vm.flats.length;
                processObjects();
              });
            } else if ($location.path()=='/objects/flatsrent') {
              api.objects.flatsrent.query({'my':vm.onlyMy}, function(data) {
                vm.flats = data.data;
                vm.total = vm.flats.length;
                processObjects();
              });
        		} else if ($location.path()=='/objects/flats/archive') {
              api.objects.flatsarchive.query({'my':vm.onlyMy}, function(data) {
                vm.flats = data.data;
                vm.total = vm.flats.length;
                processObjects();
              });
            } else if ($location.path()=='/objects/flatsrent/archive') {
              api.objects.flatsrentarchive.query({'my':vm.onlyMy}, function(data) {
                vm.flats = data.data;
                vm.total = vm.flats.length;
                processObjects();
              });
        		}
          }

          function processObjects() {
            vm.flats_by_id = {};

            //если показывать только один - напоминание
            if ($location.search().showId) {
              console.log('show only one object: '+$location.search().showId);
              //console.log(vm.flats);
              //console.log();
              api.objects.flats.query({'showId': $location.search().showId}, function(data) {
                vm.flats = data.data;
                vm.total = vm.flats.length;
              });
            }

            //составляем новый массив объектов с индексами = id объектов
        		for (var i=0;i<vm.flats.length;i++) {
        			vm.flats_by_id[vm.flats[i].id] = {'group': vm.flats[i].group_id, 'owner': vm.flats[i].owner_id};
        			//подменяем статусы визы и листинга, чтобы выводить нужную иконку
        			switch(vm.flats[i].visa_status) {
        				case 'yes': vm.flats[i].visastatus = ''; break
        				case 'no': vm.flats[i].visastatus = '-outline'; break
        			}
        			switch(vm.flats[i].listing_status) {
        				case 'yes': vm.flats[i].listingstatus = ''; break
        				case 'no': vm.flats[i].listingstatus = '-outline'; break
        			}
        			switch(vm.flats[i].visa_publish) {
        				case 'yes': vm.flats[i].visapublish = ''; break
        				case 'no': vm.flats[i].visapublish = '-outline'; break
        			}
              //Тип дома
              switch(vm.flats[i].type_bild) {
                case 'block': vm.flats[i].type_bild = 'Блочный'; break
                case 'panel': vm.flats[i].type_bild = 'Панельный'; break
                case 'brick': vm.flats[i].type_bild = 'Кирпичный'; break
                case 'wood': vm.flats[i].type_bild = 'Деревянный'; break
                case 'stalin': vm.flats[i].type_bild = 'Сталинский'; break
                case 'monolith': vm.flats[i].type_bild = 'Монолит'; break
                case 'brickmonolith': vm.flats[i].type_bild = 'Монолитно-кирпичный'; break
                default: vm.flats[i].type_bild = '-'; break
              }
              //default
              vm.flats[i].printstatus = false;
              vm.flats[i].printicon = 'icon-checkbox-blank-outline';

              vm.flats[i].meetstatus = 'icon-checkbox-blank-circle-outline';
              switch(vm.flats[i].meet) {
                case 'yes': vm.flats[i].meetstatus = 'icon-brightness-1'; break
                case 'no': vm.flats[i].meetstatus = 'icon-checkbox-blank-circle-outline'; break
              }

              if (vm.flats[i].cost == 0 || vm.flats[i].cost == null) {
                vm.flats[i].cost = vm.flats[i].rentcost;
                vm.flats[i].cost += ' руб.';
                  if (vm.flats[i].pay_type == 'squarem') vm.flats[i].cost += '/м2';
                  if (vm.flats[i].pay_duration == 'month') vm.flats[i].cost += '/месяц';
                  if (vm.flats[i].pay_duration == 'year') vm.flats[i].cost += '/год';
              } else {
                vm.flats[i].cost += ' руб.';
              }
              vm.flats[i].rooms_number_int = parseInt(vm.flats[i].rooms_number);
              //комнаты
              switch (vm.flats[i].rooms_number) {
                case '1': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Однокомнатные':'Однокомнатная'; break
                case '2': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Двухкомнатные':'Двухкомнатная'; break
                case '3': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Трехкомнатные':'Трехкомнатная'; break
                case '4': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Четырехкомнатные':'Четырехкомнатная'; break
                case '5': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Пятикомнатные':'Пятикомнатная'; break
                case 'm': vm.flats[i].rooms_number = (vm.flats[i].object_type == 'apartments')?'Многокомнатные':'Многокомнатная'; break
                case 'studio': vm.flats[i].rooms_number = 'Студия'; break

                case 'd_1': vm.flats[i].rooms_number = 'Доля в однокомнатной'; break
                case 'd_2': vm.flats[i].rooms_number = 'Доля в двухкомнатной'; break
                case 'd_3': vm.flats[i].rooms_number = 'Доля в трехкомнатной'; break
                case 'd_4': vm.flats[i].rooms_number = 'Доля в четырехкомнатной'; break
                case 'd_5': vm.flats[i].rooms_number = 'Доля в пятикомнатной'; break
                case '1_2': vm.flats[i].rooms_number = 'Комната в двухкомнатной'; break
                case '1_3': vm.flats[i].rooms_number = 'Комната в трехкомнатной'; break
                case '1_4': vm.flats[i].rooms_number = 'Комната в четырехкомнатной'; break
                case '1_5': vm.flats[i].rooms_number = 'Комната в пятикомнатной'; break
                case '2_3': vm.flats[i].rooms_number = '2 комнаты в трехкомнатной'; break
                case '2_4': vm.flats[i].rooms_number = '2 комнаты в четырехкомнатной'; break
                case '2_5': vm.flats[i].rooms_number = '2 комнаты в пятикомнатной'; break
                case '3_4': vm.flats[i].rooms_number = '3 комнаты в четырехкомнатной'; break
                case '3_5': vm.flats[i].rooms_number = '3 комнаты в пятикомнатной'; break
              }
        		}
          }

        //просмотр объекта
    		function viewObject(id, ev) {
    			$mdDialog.show({
              controller         : function ($scope, $mdDialog)
              {
              var viewobject = new api.objects.objectbyid.query({'id':id},
                  function(data) {

                  //фотографии
                  api.objects.objectphotosbyid.query({'id':id}, function(data) {
                      $scope.photos = data.data;
              				vm.total = $scope.photos.length;
              				//меняем адреса изображений
              				for(var i=0; i < vm.total;i++){
                        //замена на адреса, как на сервере
                        $scope.photos[i].filename = api.domain_name + api.domain_images + $scope.photos[i].filename;
                        //$scope.photos[i].filename = '/functions/images/' + $scope.photos[i].filename;
              				}
            			});

                  switch (parseInt(data.region)) {
                    case 1: data.region = 'Москва, '; break
                    case 2: data.region = 'Моск.обл., '; break
                  }

                  if (data.city_type!=null) data.region += data.city_type + '. ';
                  if (data.city!=null) data.region += data.city;
                  if ((data.street).length>1) data.region += ', ' + data.street;
                  if (data.house_number!=null) data.region += ', ' + data.house_number;

                  //тип объекта
                  switch (data.object_type) {
                    case 'flat_new_building': data.object_type = 'Новостройка '; break
                    case 'flat': data.object_type = 'Квартира '; break
                    case 'apartments': data.object_type = 'Апартаменты '; break
                    case 'room': data.object_type = 'Комната '; break
                    case 'part': data.object_type = 'Доля (' + data.part_percent + ')'; break
                    case 'penthouse': data.object_type = 'Пентхаус '; break
                    //case 'townhouse': data.object_type = 'Таунхаус '; break
                    /*case 'garage': data.object_type = 'Гараж '; break
                    case 'office': data.object_type = 'Офис '; break
                    case 'commercial_premises': data.object_type = 'Торговое помещение '; break
                    case 'stock': data.object_type = 'Склад '; break
                    case 'ready_business': data.object_type = 'Готовый бизнес '; break
                    case 'psn': data.object_type = 'ПСН '; break
                    case 'production_room': data.object_type = 'Производственное помещение '; break
                    case 'production_land': data.object_type = 'Пром. земля '; break
                    case 'zsn': data.object_type = 'Участок - ЗСН '; break
                    case 'znp': data.object_type = 'Участок - ЗНП '; break
                    case 'zoot': data.object_type = 'Участок - ЗООТ '; break
                    case 'zwilf': data.object_type = 'Участок - ЗВИЛФ '; break
                    case 'zemli_zapasa': data.object_type = 'Участок - Земли запаса '; break
                    case 'cottage': data.object_type = 'Коттедж '; break
                    case 'country_house': data.object_type = 'Дача '; break
                    case 'parcel': data.object_type = 'Участок '; break*/
                  }
                  //console.log('x'+data.object_type+'x');
                  //комнаты
                  switch (data.rooms_number) {
                    case '1': data.rooms_number = (data.object_type == 'Апартаменты ')?'Однокомнатные':'Однокомнатная'; break
                    case '2': data.rooms_number = (data.object_type == 'Апартаменты ')?'Двухкомнатные':'Двухкомнатная'; break
                    case '3': data.rooms_number = (data.object_type == 'Апартаменты ')?'Трехкомнатные':'Трехкомнатная'; break
                    case '4': data.rooms_number = (data.object_type == 'Апартаменты ')?'Четырехкомнатные':'Четырехкомнатная'; break
                    case '5': data.rooms_number = (data.object_type == 'Апартаменты ')?'Пятикомнатные':'Пятикомнатная'; break
                    case 'm': data.rooms_number = (data.object_type == 'Апартаменты ')?'Многокомнатные':'Многокомнатная'; break
                    case 'studio': data.rooms_number = 'Студия'; break

                    case 'd_1': data.rooms_number = 'Доля в однокомнатной'; break
                    case 'd_2': data.rooms_number = 'Доля в двухкомнатной'; break
                    case 'd_3': data.rooms_number = 'Доля в трехкомнатной'; break
                    case 'd_4': data.rooms_number = 'Доля в четырехкомнатной'; break
                    case 'd_5': data.rooms_number = 'Доля в пятикомнатной'; break
                    case '1_2': data.rooms_number = 'Комната в двухкомнатной'; break
                    case '1_3': data.rooms_number = 'Комната в трехкомнатной'; break
                    case '1_4': data.rooms_number = 'Комната в четырехкомнатной'; break
                    case '1_5': data.rooms_number = 'Комната в пятикомнатной'; break
                    case '2_3': data.rooms_number = '2 комнаты в трехкомнатной'; break
                    case '2_4': data.rooms_number = '2 комнаты в четырехкомнатной'; break
                    case '2_5': data.rooms_number = '2 комнаты в пятикомнатной'; break
                    case '3_4': data.rooms_number = '3 комнаты в четырехкомнатной'; break
                    case '3_5': data.rooms_number = '3 комнаты в пятикомнатной'; break
                  }
                  /*
                  switch (data.country_land_type) {
                    case 'snt': data.object_type += '(СНТ)'; break
                    case 'igs': data.object_type += '(ИЖС)'; break
                    case 'farm': data.object_type += '(Фермерское хозяйство)'; break
                    case 'dnp': data.object_type += '(Участок)'; break
                  }
                  */
                  switch (data.object_type_2) {
                    case 'real': data.object_type_2 = ''; break
                    case 'hog-wash': data.object_type_2 = '(утка)'; break
                    case 'invest': data.object_type_2 = '(инвестиционный)'; break
                    case 'auction': data.object_type_2 = '(аукцион)'; break
                  }
                  //сделка и цена
                  if (data.deal_id==null) data.deal_id = 'Номер не присвоен'

                  switch (data.pay_duration) {
                    case 'day': data.pay_duration = '/день'; break
                    case 'month': data.pay_duration = '/месяц'; break
                    case 'year': data.pay_duration = '/год'; break
                  }

                  switch (data.pay_type) {
                    case 'object': data.pay_type = '/объект'; break
                    case 'squarem': data.pay_type = '/м2'; break
                  }

                  switch (data.deal_type) {
                    case 'rent':
                    case 'subrent':
                    case 'ppa':
                    case 'dsd': data.cost = data.rentcost + " руб." + data.pay_duration; break// + data.pay_type; break
                    case 'dupt':
                    case 'sale':
                    case 'change': data.cost = data.cost + " руб."; break
                  }

                  switch (data.deal_type) {
                    case 'rent': data.deal_type = 'Аренда'; break
                    case 'subrent': data.deal_type = 'Субаренда'; break
                    case 'ppa': data.deal_type = 'Продажа права аренды'; break
                    case 'dsd': data.deal_type = 'Договор совместной деятельности'; break
                    case 'sale': data.deal_type = 'Продажа'; break
                    case 'change': data.deal_type = 'Альтернатива'; break
                    case 'dupt': data.deal_type = 'Переуступка'; break
                  }

                  if (!parseInt(data.story)>0) {
                    data.story = '-';
                  }
                  if (!parseInt(data.story_count)>0) {
                    data.story_count = '-';
                  }

                  //визы и листинг
                  switch(data.visa_status) {
                    case 'yes': data.visa_status = 'icon-label'; break
                    case 'no': data.visa_status = 'icon-label-outline'; break
                  }
                  switch(data.listing_status) {
                    case 'yes': data.listing_status = 'icon-note'; break
                    case 'no': data.listing_status = 'icon-note-outline'; break
                  }
                  switch(data.visa_publish) {
                    case 'yes': data.visa_publish = 'icon-star'; break
                    case 'no': data.visa_publish = 'icon-star-outline'; break
                  }
                  //метро и направление
                  if (data.direction!=null && data.direction>0) {
                    api.objects.direction.query({'id':data.direction}, function(direct) {
                      data.direction = 'Направление: ' + direct.name + ' (' + data.from_mcad + ' км)';
                    });
                  } else {
                    data.direction = '';
                  }
                  if (data.metro_1!=null && data.metro_1>0) {
                    api.objects.metrostation.query({'id':data.metro_1}, function(metro) {
                      data.metro_1 = metro.name;
                      switch (data.metro_1_time) {
                        case 'f_2': data.metro_1_time = '(2 минуты пешком)'; break
                        case 'f_5': data.metro_1_time = '(5 минут пешком)'; break
                        case 'f_7': data.metro_1_time = '(7 минут пешком)'; break
                        case 'f_10': data.metro_1_time = '(10 минут пешком)'; break
                        case 'f_15': data.metro_1_time = '(15 минут пешком)'; break
                        case 'f_20': data.metro_1_time = '(20 минут пешком)'; break
                        case 't_5': data.metro_1_time = '(5 минут транспортом)'; break
                        case 't_10': data.metro_1_time = '(10 минут транспортом)'; break
                        case 't_15': data.metro_1_time = '(15 минут транспортом)'; break
                        case 't_20': data.metro_1_time = '(20 минут транспортом)'; break
                      }
                    });
                  } else {
                    data.metro_1 = '-';
                  }
                  if (data.metro_2!=null && data.metro_2>0) {
                    api.objects.metrostation.query({'id':data.metro_2}, function(metro) {
                      data.metro_2 = metro.name;
                      switch (data.metro_2_time) {
                        case 'f_2': data.metro_2_time = '((2 минуты пешком)'; break
                        case 'f_5': data.metro_2_time = '(5 минут пешком)'; break
                        case 'f_7': data.metro_2_time = '(7 минут пешком)'; break
                        case 'f_10': data.metro_2_time = '(10 минут пешком)'; break
                        case 'f_15': data.metro_2_time = '(15 минут пешком)'; break
                        case 'f_20': data.metro_2_time = '(20 минут пешком)'; break
                        case 't_5': data.metro_2_time = '(5 минут транспортом)'; break
                        case 't_10': data.metro_2_time = '(10 минут транспортом)'; break
                        case 't_15': data.metro_2_time = '(15 минут транспортом)'; break
                        case 't_20': data.metro_2_time = '(20 минут транспортом)'; break
                      }
                    });
                  } else {
                    data.metro_2 = '';
                  }
                  if (data.metro_3!=null && data.metro_3>0) {
                    api.objects.metrostation.query({'id':data.metro_3}, function(metro) {
                      data.metro_3 = metro.name;
                      switch (data.metro_3_time) {
                        case 'f_2': data.metro_3_time = '(2 минуты пешком)'; break
                        case 'f_5': data.metro_3_time = '(5 минут пешком)'; break
                        case 'f_7': data.metro_3_time = '(7 минут пешком)'; break
                        case 'f_10': data.metro_3_time = '(10 минут пешком)'; break
                        case 'f_15': data.metro_3_time = '(15 минут пешком)'; break
                        case 'f_20': data.metro_3_time = '(20 минут пешком)'; break
                        case 't_5': data.metro_3_time = '(5 минут транспортом)'; break
                        case 't_10': data.metro_3_time = '(10 минут транспортом)'; break
                        case 't_15': data.metro_3_time = '(15 минут транспортом)'; break
                        case 't_20': data.metro_3_time = '(20 минут транспортом)'; break
                      }
                    });
                  } else {
                    data.metro_3 = '';
                  }
                  //холодильник
                  switch(data.tech_4) {
                    case 'yes': data.tech_4 = 'Есть'; break
                    case 'no': data.tech_4 = 'Нет'; break
                    default: data.tech_4 = '-'; break
                  }
                  //стиральная машина
                  switch(data.tech_8) {
                    case 'yes': data.tech_8 = 'Есть'; break
                    case 'no': data.tech_8 = 'Нет'; break
                    default: data.tech_8 = '-'; break
                  }
                  //мебель
                  switch(data.furniture) {
                    case 'old': data.furniture = 'Старая'; break
                    case '90s': data.furniture = 'Мебель 90-х'; break
                    case 'modern': data.furniture = 'Современная'; break
                    case 'no': data.furniture = 'Нет'; break
                    default: data.furniture = '-'; break
                  }
                  //телефон/интернет
                  switch(data.phone) {
                    case 'yes': data.phone = 'Есть'; break
                    case 'para': data.phone = 'Спаренный'; break
                    case 'possible': data.phone = 'Возможно подключить'; break
                    case 'no': data.phone = 'Нет'; break
                    default: data.phone = '-'; break
                  }
                  switch(data.inet) {
                    case 'yes': data.inet = 'Есть'; break
                    case 'no': data.inet = 'Нет'; break
                    default: data.inet = '-'; break
                  }
                  //ремонт
                  switch(data.repairs) {
                    case 'euro': data.repairs = 'Евро'; break
                    case 'capital': data.repairs = 'Капитальный'; break
                    case 'cosmetic': data.repairs = 'Косметический'; break
                    case 'no': data.repairs = 'Без ремонта'; break
                    default: data.repairs = '-'; break
                  }
                  //типы санузла
                  switch(data.type_bathroom) {
                    case 'separated': data.type_bathroom = 'Раздельный'; break
                    case 'combined': data.type_bathroom = 'Совмещенный'; break
                    default: data.type_bathroom = '-'; break
                  }
                  //право собственности
                  switch(data.ownership) {
                    case 'primary': data.ownership = 'Первичная приватизация'; break
                    case 'contract-sales': data.ownership = 'Договор купли/продажи'; break
                    case 'contract-donat': data.ownership = 'Договор дарения'; break
                    case 'contract-rent': data.ownership = 'Договор ренты'; break
                    case 'paid': data.ownership = 'ЖСК, выплаченный пай'; break
                    case 'legacy': data.ownership = 'Наследство'; break
                    case 'court': data.ownership = 'Решение суда'; break
                    case 'mortgage': data.ownership = 'Залог (ипотека)'; break
                    case 'invest': data.ownership = 'По договору инвестирования'; break
                    default: data.ownership = '-'; break
                  }
                  //Тип дома
                  switch(data.type_bild) {
                    case 'block': data.type_bild = 'Блочный'; break
                    case 'panel': data.type_bild = 'Панельный'; break
                    case 'brick': data.type_bild = 'Кирпичный'; break
                    case 'wood': data.type_bild = 'Деревянный'; break
                    case 'stalin': data.type_bild = 'Сталинский'; break
                    case 'monolith': data.type_bild = 'Монолит'; break
                    case 'brickmonolith': data.type_bild = 'Монолитно-кирпичный'; break
                    default: data.type_bild = '-'; break
                  }
                  //Статус
                  switch(data.flat_status) {
                    case 'free': data.flat_status = 'Свободна'; break
                    case 'patrol': data.flat_status = 'Расселение/разъед'; break
                    case 'alternate': data.flat_status = 'Альтернатива'; break
                    case 'no': data.flat_status = 'Никто не прописан'; break
                    default: data.flat_status = '-'; break
                  }
                  //Лифт
                  switch(data.lift) {
                    case 'pass': data.lift = 'Пассажирский'; break
                    case 'serv': data.lift = 'Грузовой'; break
                    case 'passserv': data.lift = 'Пасс. + груз.'; break
                    case '2pass1serv': data.lift = '2 пасс. + груз.'; break
                    case '1pass2serv': data.lift = 'Пасс. + 2 груз.'; break
                    case '2pass2serv': data.lift = '2 пасс. + 2 груз.'; break
                    case '2pass': data.lift = '2 пассажирских'; break
                    case '2serv': data.lift = '2 грузовых'; break
                    case 'no': data.lift = 'Нет'; break
                    default: data.lift = '-'; break
                  }
                  //Балкон
                  switch(data.balcony) {
                    case '2loggia': data.balcony = '2 лоджии'; break
                    case '2balcon': data.balcony = '2 балкона'; break
                    case 'loggia': data.balcony = 'Лоджия'; break
                    case 'yes': data.balcony = 'Есть'; break
                    case 'no': data.balcony = 'Нет'; break
                    default: data.balcony = '-'; break
                  }
                  //в собственности
                  switch(data.years_own) {
                    case 'less3': data.years_own = 'Менее 3 лет'; break
                    case 'more3': data.years_own = 'Более 3 лет'; break
                    default: data.years_own = '-'; break
                  }
                  //присваиваем полученные и отредактированные данные
                  $scope.object_data = data;

                  //карта
                  $scope.markers = [
                    {coordinates:[data.longitude, data.latitude], properties: {balloonContent: 'Объект '+data.id}, options: {preset: 'islands#icon', iconColor: '#2e2bff'}},

                  ];
                  //настройки положения карты
                  $scope.map = {
                      center: [data.longitude, data.latitude], zoom: 17
                  };

                  data.domain_name = api.domain_name;
          		});
              //////////////////////////////////////
                  $scope.closeDialog = function ()
                  {
                      $mdDialog.hide();
                  }
              },
                    templateUrl: 'app/objects/flats/objectViewDialog.html',
                    parent             : angular.element('body'),
                    locals: {
                      object_data : $scope.object_data,
                      markers: $scope.markers,
                      photos: $scope.photos,
                      map: $scope.map
                    },
                    clickOutsideToClose: true
                });
    		}

        //смена состояния визы
		function changeVisa(id,param_value) {

      var changevisa = new api.objects.changeVisaStatus();
      changevisa.id = id;
      changevisa.param_value = param_value;
      changevisa.$save();

      for(var i = 0; i < vm.flats.length; i++) {
         if(vm.flats[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.flats[i].visastatus = '-outline';
             vm.flats[i].visa_status = 'no';
             angular.element($('#object_visa_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_visa_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.flats[i].visastatus = '';
             vm.flats[i].visa_status = "yes";
             angular.element($('#object_visa_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_visa_'+id)).addClass('visa_listing_green');
           }
           break;
         }
      }/*
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var changevisa = new api.objects.changeVisaStatus();
					changevisa.id = id;
					changevisa.param_value = param_value;
					changevisa.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Статус визы изменен</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });*/
		}
		//смена состояния листинга
		function changeListing(id,param_value) {

      var changelisting = new api.objects.changeListingStatus();
      changelisting.id = id;
      changelisting.param_value = param_value;
      changelisting.$save();

      for(var i = 0; i < vm.flats.length; i++) {
         if(vm.flats[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.flats[i].listingstatus = '-outline';
             vm.flats[i].listing_status = 'no';
             angular.element($('#object_listing_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_listing_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.flats[i].listingstatus = '';
             vm.flats[i].listing_status = 'yes';
             angular.element($('#object_listing_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_listing_'+id)).addClass('visa_listing_green');
           }
           break;
         }
       }
      /*
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var changelisting = new api.objects.changeListingStatus();
					changelisting.id = id;
					changelisting.param_value = param_value;
					changelisting.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Статус листинга изменен</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });*/
		}



    function changePrint(id, param_value) {
      //console.log('changePrint', id, param_value);
      for(var i = 0; i < vm.flats.length; i++) {
         if(vm.flats[i].id == id) {
           vm.flats[i].printstatus = !param_value;
           //hack
           angular.element($('#object_print_'+vm.flats[i].id)).removeClass(vm.flats[i].printicon)
           vm.flats[i].printicon = vm.isPrint(vm.flats[i].printstatus);
           angular.element($('#object_print_'+vm.flats[i].id)).addClass(vm.flats[i].printicon)
           //console.log(vm.flats[i].id, vm.flats[i].printicon, angular.element($('#object_print_'+vm.flats[i].id)));
           break;
         }
       }
    }

    function isPrint(param_value) {
      // можно убрать
      return (param_value ? 'icon-checkbox-blank' : 'icon-checkbox-blank-outline');
    }

    //смена состояния визы на публикацию
		function changeMeet(id,param_value) {

      var changemeet = new api.objects.changeMeetStatus();
      changemeet.id = id;
      changemeet.param_value = param_value;
      changemeet.$save();

      for(var i = 0; i < vm.flats.length; i++) {
         if(vm.flats[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.flats[i].meetstatus = 'icon-checkbox-blank-circle-outline';
             vm.flats[i].meet = 'no';
             angular.element($('#object_meet_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_meet_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.flats[i].meetstatus = 'icon-brightness-1';
             vm.flats[i].meet = 'yes';
             angular.element($('#object_meet_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_meet_'+id)).addClass('visa_listing_green');
           }
           break;
         }
       }
		}
		//смена состояния визы на публикацию
		function changeVisaP(id,param_value) {

      var changevisap = new api.objects.changeVisaPStatus();
      changevisap.id = id;
      changevisap.param_value = param_value;
      changevisap.$save();

      for(var i = 0; i < vm.flats.length; i++) {
         if(vm.flats[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.flats[i].visapublish = '-outline';
             vm.flats[i].visa_publish = 'no';
             angular.element($('#object_visap_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_visap_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.flats[i].visapublish = '';
             vm.flats[i].visa_publish = 'yes';
             angular.element($('#object_visap_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_visap_'+id)).addClass('visa_listing_green');
           }
           break;
         }
       }

			/*$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var changevisap = new api.objects.changeVisaPStatus();
					changevisap.id = id;
					changevisap.param_value = param_value;
					changevisap.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Статус визы на публикацию изменен</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });*/
		}
    function changeArchiveStatus(n) {
			switch(n) {
				case 0: vm.archive = false; break
				case 1: vm.archive = true;	break
			}
		}
        ///////////////////////////////
    function checkArchiveStatus(n) {
			switch(n) {
				case 'icon':
				if (vm.archive == true) {
					return 'icon-arrow-right-bold-circle';
					}
				else {
					return 'icon-delete';
					}
			break
			default:
				if (vm.archive == true) {
					return true;
					}
				else {
					return false;
					}
			break
			}
		}

    function addBuyer(object_id) {
      $location.path('/contacts/contragents/new').search({isBuyer:'Y', objectN:object_id});
    }

        //создание объекта
    function addObject() {
      $mdDialog.show({
            controller         : function ($scope, $mdDialog)
              {
                // $scope.object_id = id;
                // var object_cost = new api.objects.costhistorybyobjectid.query({'id':id},
                //   function(data) {
                //   $scope.cost_data = data;
                // });
                $scope.createClient = function ()
                {
                  $mdDialog.hide();
                  $location.path('/contacts/clients/new').search({fromObjects:'Y'});
                }

                $scope.createObject = function ()
                {
                  $mdDialog.hide();
                  $location.path('/objects/new/flatrent');
                }

              },
              templateUrl: 'app/objects/objectCreateSellerDialog.html',
              parent             : angular.element('body'),
              locals: {
                // cost_data : $scope.cost_data,
                // object_id : $scope.object_id
              },
              clickOutsideToClose: true
          });
          //$location.path('/objects/new/flat');
		}

		//редактирование объекта
		function editObject(id,type) {
			//для клика по иконке и для двойного клика
			switch(type){
				case 1:	$location.path('/objects/edit/flatrent/'+id); break
				case 2: $rootScope.$apply(function() {
							$location.path('/objects/edit/flatrent/'+id);
						});
						break
			}
		}

    //редактирование поля заметок агента по объекту
		function editObjectAgentDescription(id) {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
              var viewobject = new api.objects.notebyobjectid.query({'id':id},
                function(note) {
                //получаем текст заметки, если есть
                var data = [];
                data.id = id;
                data.agent_descr = note.agent_description;
                $scope.object_data = data;
              });

							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
              //сохранить заметку
              $scope.changeAgentDescription = function (id,text)
							{
                var changeagentdescription = new api.objects.changeAgentDescription();
                changeagentdescription.id = id;
                changeagentdescription.agent_description = text;
                changeagentdescription.$save();
								$mdDialog.hide();
							}
						},
            templateUrl: 'app/objects/objectEditAgentDescriptionDialog.html',
            parent             : angular.element('body'),
            locals: {
              object_data : $scope.object_data
            },
            clickOutsideToClose: true
        });
		}

    //редактирование поля заметок агента по объекту
		function showObjectCostHistory(id) {
      $mdDialog.show({
            controller         : function ($scope, $mdDialog)
              {
                $scope.object_id = id;
                var object_cost = new api.objects.costhistorybyobjectid.query({'id':id},
                  function(data) {
                  $scope.cost_data = data;
                });

                $scope.closeDialog = function ()
                {
                  $mdDialog.hide();
                }
              },
              templateUrl: 'app/objects/objectCostHistoryDialog.html',
              parent             : angular.element('body'),
              locals: {
                cost_data : $scope.cost_data,
                object_id : $scope.object_id
              },
              clickOutsideToClose: true
          });
      }


		function restore_archiveObject(id) {
			if (vm.archive == true) {
				restoreObject(id);
			}
			else {
				archiveObject(id);
			}
		}
    //диалог с предупреждением об удалении объекта
    function archiveObject(id,ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Отправить объект в архив?',
                parent             : '#content',
                textContent        : '',
                ariaLabel          : 'remove object',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Удалить',
                cancel             : 'Отмена'
            });

            $mdDialog.show(confirm).then(function ()
            {
              archiveObject_object(id);
            }, function ()
            {
              //
            });
        }

		//удаление объекта
		function archiveObject_object(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var archiveobject = new api.objects.archiveobject();
					archiveobject.id = id;
					archiveobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flats');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект {{id}} отправлен в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//восстановление объекта
		function restoreObject(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var restoreobject = new api.objects.restoreobject();
					restoreobject.id = id;
					restoreobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/flats/archive');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект {{id}} восстановлен из архива</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//нет прав
		function showSetListingError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия листинга обратитесь к листинг-менеджеру</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}
    function showSetMeetError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для отметки встречи с клиентом обратитесь к начальнику отдела</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}

		function showSetVisaError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия визы обратитесь к начальнику отдела</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}
		function showSetVisaPError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия визы на публикацию на сайте обратитесь к начальнику отдела</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}

      //фильтр по числу комнат
  		function filter_room(n, ev) {
  			vm.room_filter = n;
        //console.log('filter', n, vm.userid, Flats.data);
        var flats = Flats.data;
        //////////////
        if (vm.onlyMy) {
          flats = flats.filter(function(f) { return parseInt(f.owner_id) == parseInt(vm.userid);});
        }
        //////////////////
        if (n > 0) {
          if (n == 4) {
            vm.flats = flats.filter(function(f) { return f.rooms_number_int >= n;});
          } else {
            vm.flats = flats.filter(function(f) { return f.rooms_number_int == n;});
          }
        } else {
          vm.flats = flats;
        }
  		}


		//двойнок клик на строку
		function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			$('td', nRow).unbind('dblclick');
			$('td', nRow).bind('dblclick', function() {
				//если есть право на редакцию
				if (($rootScope.checkRule(19,vm.flats_by_id[aData[0]].group,'group')) || ((vm.flats_by_id[aData[0]].owner == vm.userid) && $rootScope.checkRule(19,'my') && vm.archive == false) || $rootScope.checkRule(19,'all')) {
					//(vm.flats_by_id[aData[0]].group == vm.groupid) &&
					editObject(aData[0],2);
				} else {
				console.log('id '+aData[0]+' group: '+vm.flats_by_id[aData[0]].group);
				$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Нет прав на редактирование этого объекта</h1></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
				}
			});
			return nRow;
		}
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.commerce', ['app.objects.commerce.archive'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_commerce', {
            url    : '/objects/commerce',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/commerce/commerce.html',
                    controller : 'CommerceController as vm'
                }
            },
            resolve: {
                Commobjs: function (apiResolver)
                {
                    return apiResolver.resolve('objects.commobjs@get',{'my':'true','first':'true'});
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.commerce')
        .controller('CommerceController', CommerceController);

    /** @ngInject */
    function CommerceController($scope, $rootScope, $location, $mdDialog, Commobjs, api)
    {
        var vm = this;

        vm.type_filter = 0;

        // Data
        vm.commobjects = Commobjs.data;
        processObjects();

        //получаем id своей должности
        api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
          vm.positionid = data.position_id;
          //получаем список объектов через функцию
          //только для риэлторов и их начальников изначально только свои
          if (vm.positionid==1 || vm.positionid==7 || vm.positionid==10) {
            vm.onlyMy = true;
            //для риэлторов помечаем галку
          } else {
            //для избежания подрагивания при дозагрузке объектов
            //загружаем в модуле и меняем только, если это необходимо
            vm.onlyMy = false;
            /*vm.commobjects = {};
            updateObjectsTable();*/
          }
        });


    //получаем id своей учетной записи для сверки собственности на объект
    api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
			vm.userid = data.user_id;
		});
		//получаем id своего отдела
    api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
			vm.groupid = data.group_id;
		});

    if ($location.path() == '/objects/commerce') {
			vm.archive = false;
		} else if ($location.path() == '/objects/commerce/archive') {
			vm.archive = true;
		}

    ///////////////////обновление таблицы документов после загрузки
    vm.total = 0;
    vm.dtInstance = {};

    vm.dtIntanceCallback = function (instance) {
      vm.dtInstance = instance;
    }

        vm.dtOptions = {
            dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            rowCallback: rowCallback,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				null,
        { "orderable": false },
				//null,
				null,
				null,
				null,
				null,
        null,
        null,
        null,
				null
			  ],
        "buttons": [
          {
             extend: "print",
             text: "Печать",
             title:  "Список объектов",
             className: "DTBblack",
             exportOptions: {
                columns: [8,9,5,6,7,3],
             },
             autoPrint: false,
             customize: function (w) {
                //console.log('custom print', vm.commobjects);
                var visibleId = 1;
                $(w.document.body).find('tbody tr').each(function(index){
                    //console.log('>custom print', $(this), index);
                    for (var i=0;i<vm.commobjects.length;i++) {
                      //console.log('>>custom print', $(this).find('td:first-child'), $(this).find('td:first-child').attr('data-object-id'));
                      if ($(this).find('td:first-child').attr('data-object-id') == vm.commobjects[i].id ||
                          $(this).find('td:first-child').text() == vm.commobjects[i].id) {
                        if (!vm.commobjects[i].printstatus) {
                          $(this).css('visibility','hidden').css('display','none');
                          continue;
                        } else {
                          //console.log('visible ', i, vm.commobjects[i].id, visibleId);
                          //$(this).find('td:first-child').text(visibleId);
                          $(this).find('td:nth-child(2)').html($(this).find('td:nth-child(2)').text().replace(new RegExp('brbr', 'g'), '<br>'));
                          visibleId = visibleId + 1;
                        }
                      }
                    }
                });
                $(w.document.body).find('h1').css('text-align','center');
                $(w.document.body).find('tr:visible:nth-child(odd) td').each(function(index){
                    $(this).css('background-color','#f0f0f0');
                });
            },
           },
          // {
          //    extend: "print",
          //    text: "Печать",
          //    title:  "Список объектов",
          //    className: "DTBblack",
          //    exportOptions: {
          //        columns: ':visible'
          //    }
          //  },
          {
             extend: "excel",
             text: "Сохранить таблицу",
             className: "DTBblack",
             //fileName:  "Список клиентов.xls",
             title:"Список объектов",
             exportOptions: {
                 columns: ':visible'
             }
         },
         {
            text: '↻',
            className: "DTBblackNormal",
            action: function () {
                updateObjectsTable();
            }
          }
        ],
			  "order": [0, "desc"]
        };

        // Methods
		vm.addObject = addObject;
		vm.editObject = editObject;
    vm.viewObject = viewObject;
		vm.archiveObject = archiveObject;
		vm.restoreObject = restoreObject;
		vm.restore_archiveObject = restore_archiveObject;
    vm.editObjectAgentDescription = editObjectAgentDescription;
    vm.showObjectCostHistory = showObjectCostHistory;
		vm.showSetListingError = showSetListingError;
		vm.showSetVisaError = showSetVisaError;
		vm.showSetVisaPError = showSetVisaPError;
		vm.changeVisa = changeVisa;
		vm.changeListing = changeListing;
		vm.changeVisaP = changeVisaP;
		//проверка на архив и установка переменной на архив
		vm.Arch = changeArchiveStatus;
		vm.isArch = checkArchiveStatus;
    vm.updateObjectsTable = updateObjectsTable;
    vm.changePrint = changePrint;
    vm.isPrint = isPrint;
    vm.addBuyer = addBuyer;
    vm.filter_type = filter_type;
    vm.copyObject = copyObject;


    //диалог о копировании объекта
      function copyObject(id) {
        $mdDialog.show({
                  controller         : function ($scope, $mdDialog)
                  {
                      ////////////
                      $scope.copyWithArchive = function ()
                      {
                          //alert(id);
                          var copyobject = new api.objects.copyobject_witharchive();
                          copyobject.id = id;
                          copyobject.$save();

                          $scope.closeDialog();
                          updateObjectsTable();
                      }
                      ////////////
                      $scope.copyWithoutArchive = function ()
                      {
                          var copyobject = new api.objects.copyobject_withoutarchive();
                          copyobject.id = id;
                          copyobject.$save();

                          $scope.closeDialog();
                          updateObjectsTable();
                      }
                      ////////////
                      $scope.closeDialog = function ()
                      {
                          $mdDialog.hide();
                          //$location.path('/objects/flats');
                          //$route.reload();
                      }
                  },
                  template: '<md-dialog>' +
                  '  <md-dialog-content><h1>Копирование объекта</h1>Отправить в архив объект {{id}}?</md-dialog-content>' +
                  '  <md-dialog-actions>' +
                  '    <md-button ng-click="copyWithArchive()" class="md-warn">' +
                  '      Да' +
                  '    </md-button>' +
                  '    <md-button ng-click="copyWithoutArchive()" class="md-primary">' +
                  '      Нет' +
                  '    </md-button>' +
                  '    <md-button ng-click="closeDialog()" class="md-primary">' +
                  '      Отмена' +
                  '    </md-button>' +
                  '  </md-dialog-actions>' +
                  '</md-dialog>',
                  parent             : angular.element('body'),
                  clickOutsideToClose: true
              });
      }

        // Methods
        //////////////////////////////

        function addBuyer(object_id) {
          $location.path('/contacts/contragents/new').search({isBuyer:'Y', objectN:object_id});
        }

        function changePrint(id, param_value) {
          //console.log('changePrint', id, param_value);
          for(var i = 0; i < vm.commobjects.length; i++) {
             if(vm.commobjects[i].id == id) {
               vm.commobjects[i].printstatus = !param_value;
               //hack
               angular.element($('#object_print_'+vm.commobjects[i].id)).removeClass(vm.commobjects[i].printicon)
               vm.commobjects[i].printicon = vm.isPrint(vm.commobjects[i].printstatus);
               angular.element($('#object_print_'+vm.commobjects[i].id)).addClass(vm.commobjects[i].printicon)
               //console.log(vm.commobjects[i].id, vm.commobjects[i].printicon, angular.element($('#object_print_'+vm.commobjects[i].id)));
               break;
             }
           }
        }

        function isPrint(param_value) {
          // можно убрать
          return (param_value ? 'icon-checkbox-blank' : 'icon-checkbox-blank-outline');
        }

        //фильтр по аренде-продаже
    		function filter_type(n, ev) {
    			vm.type_filter = n;
          console.log('filter', n, vm.userid, Commobjs.data);
          var commobjects = Commobjs.data;
          //////////////
          if (vm.onlyMy) {
            commobjects = commobjects.filter(function(f) { return parseInt(f.owner_id) == parseInt(vm.userid);});
          }
          //////////////////
          if (n == 1) {
            vm.commobjects = commobjects.filter(function(f) { /*console.log(f.deal_type);*/ return ['rent', 'subrent', 'ppa', 'dsd'].indexOf(f.deal_type) >= 0;});
          } else if (n == 2){
            vm.commobjects = commobjects.filter(function(f) { return ['sale', 'change'].indexOf(f.deal_type) >= 0;});
          } else {
            vm.commobjects = commobjects;
          }
    		}

        //////////обновление таблицы
        function updateObjectsTable()
          {
            vm.type_filter = 0; //сброс фильтра
            //в зависимости от страницы, где мы находимся - отдаем нужный запрос
            //архив в переспективе можно превратить в параметр, как onlyMy, сохраняя ссылку
            //TODO унификация в бэкэнде в одну функцию?
            //////////////////////////////
            //обновляем подгруженному списку некоторые столбцы
            if ($location.path()=='/objects/commerce') {
              api.objects.commobjs.query({'my':vm.onlyMy}, function(data) {
                vm.commobjects = data.data;
                vm.total = vm.commobjects.length;
                processObjects();
              });
            } else if ($location.path()=='/objects/commerce/archive') {
              api.objects.commobjsarchive.query({'my':vm.onlyMy}, function(data) {
                vm.commobjects = data.data;
                vm.total = vm.commobjects.length;
                processObjects();
              });
            }
          }

          function processObjects() {
            vm.commobjects_by_id = {};

                //составляем новый массив объектов с индексами = id объектов
        		for (var i=0;i<vm.commobjects.length;i++) {
              //console.log(i, vm.commobjects[i]);
              ///////////////////////////////////////////////////////////////////////////////////
        			vm.commobjects_by_id[vm.commobjects[i].id] = {'group': vm.commobjects[i].group_id, 'owner': vm.commobjects[i].owner_id};
        			//подменяем статусы визы и листинга, чтобы выводить нужную иконку
        			switch(vm.commobjects[i].visa_status) {
        				case 'yes': vm.commobjects[i].visastatus = ''; break
        				case 'no': vm.commobjects[i].visastatus = '-outline'; break
        			}
        			switch(vm.commobjects[i].listing_status) {
        				case 'yes': vm.commobjects[i].listingstatus = ''; break
        				case 'no': vm.commobjects[i].listingstatus = '-outline'; break
        			}
        			switch(vm.commobjects[i].visa_publish) {
        				case 'yes': vm.commobjects[i].visapublish = ''; break
        				case 'no': vm.commobjects[i].visapublish = '-outline'; break
        			}
              //////////////////адрес
              if (typeof(vm.commobjects[i].metro)=='string') {
                //vm.commobjects[i].address_str = vm.commobjects[i].metro + ', ';
                //оставляем строку метро
                vm.commobjects[i].address_str = '';
                vm.commobjects[i].metro = 'м.'+vm.commobjects[i].metro;
              } else {
                vm.commobjects[i].address_str = '';
                vm.commobjects[i].metro = '';
              }
              //if (vm.commobjects[i].region==2) {
                //angular.isUndefined(vm.commobjects[i].city) &&
                if (typeof(vm.commobjects[i].city)=='string') {
                    vm.commobjects[i].address_str += vm.commobjects[i].city_type+'.'+vm.commobjects[i].city;
                }
              //}
              if (vm.commobjects[i].street!==null) vm.commobjects[i].address_str += ', '+ vm.commobjects[i].street;
              if (vm.commobjects[i].house_number!==null)vm.commobjects[i].address_str += ', '+ vm.commobjects[i].house_number;

              if (vm.commobjects[i].cost == 0 || vm.commobjects[i].cost == null) {
                vm.commobjects[i].cost = vm.commobjects[i].rentcost;
                vm.commobjects[i].cost += ' руб.';
                  if (vm.commobjects[i].pay_type == 'squarem') vm.commobjects[i].cost += '/м2';
                  if (vm.commobjects[i].pay_duration == 'month') vm.commobjects[i].cost += '/месяц';
                  if (vm.commobjects[i].pay_duration == 'year') vm.commobjects[i].cost += '/год';
              } else {
                vm.commobjects[i].cost += ' руб. / объект';
              }
              //////////////////////////////////////////////////////////////////////////
              if (parseInt(vm.commobjects[i].square_all)>0) {
                vm.commobjects[i].square_list = vm.commobjects[i].square_all;
              }
              vm.commobjects[i].printstatus = false;
              vm.commobjects[i].printicon = 'icon-checkbox-blank-outline';

              switch (vm.commobjects[i].object_type) {
                case 'garage': vm.commobjects[i].object_type = 'Гараж '; break
                case 'parkingPlace': vm.commobjects[i].object_type = 'Машиноместо '; break
                case 'office': vm.commobjects[i].object_type = 'Офис '; break
                case 'commercial_premises': vm.commobjects[i].object_type = 'Торговое помещение';
                  ////////////////////////////////
                  if (parseInt(vm.commobjects[i].shopsq)>0) {
                    vm.commobjects[i].square_list = vm.commobjects[i].shopsq;
                  }
                  break
                case 'stock': vm.commobjects[i].object_type = 'Склад ';
                  /////////////////////////////////
                  if (parseInt(vm.commobjects[i].officesq_stock)>0) {
                    vm.commobjects[i].square_list = vm.commobjects[i].officesq_stock + '/';
                  } else {
                    vm.commobjects[i].square_list = '-/';
                  }
                  if (parseInt(vm.commobjects[i].usefulsq_stock)>0) {
                    vm.commobjects[i].square_list += vm.commobjects[i].usefulsq_stock + '/';
                  } else {
                    vm.commobjects[i].square_list += '-/'
                  }
                  if (parseInt(vm.commobjects[i].workssq)>0) {
                    vm.commobjects[i].square_list += vm.commobjects[i].workssq + '/';
                  } else {
                    vm.commobjects[i].square_list += '-/'
                  }
                  if (parseInt(vm.commobjects[i].bordersq_stock)>0) {
                    vm.commobjects[i].square_list += vm.commobjects[i].bordersq_stock;
                  } else {
                    vm.commobjects[i].square_list += '-'
                  }
                  vm.commobjects[i].square_list += ' (' + vm.commobjects[i].square_all + ')';
                  break
                case 'ready_business': vm.commobjects[i].object_type = 'Готовый бизнес'; break
                case 'psn': vm.commobjects[i].object_type = 'ПСН '; break
                case 'production_room': vm.commobjects[i].object_type = 'Производственное помещение '; break
                case 'production_land': vm.commobjects[i].object_type = 'Пром. земля '; break
              }
        		}
          }


          //редактирование поля заметок агента по объекту
      		function editObjectAgentDescription(id) {
      		$mdDialog.show({
      					controller         : function ($scope, $mdDialog)
      						{
                    var viewobject = new api.objects.notebyobjectid.query({'id':id},
                      function(note) {
                      //получаем текст заметки, если есть
                      var data = [];
                      data.id = id;
                      data.agent_descr = note.agent_description;
                      $scope.object_data = data;
                    });

      							$scope.closeDialog = function ()
      							{
      								$mdDialog.hide();
      							}
                    //сохранить заметку
                    $scope.changeAgentDescription = function (id,text)
      							{
                      var changeagentdescription = new api.objects.changeAgentDescription();
                      changeagentdescription.id = id;
                      changeagentdescription.agent_description = text;
                      changeagentdescription.$save();
      								$mdDialog.hide();
      							}
      						},
                  templateUrl: 'app/objects/objectEditAgentDescriptionDialog.html',
                  parent             : angular.element('body'),
                  locals: {
                    object_data : $scope.object_data
                  },
                  clickOutsideToClose: true
              });
      		}

          //редактирование поля заметок агента по объекту
      		function showObjectCostHistory(id) {
            $mdDialog.show({
                  controller         : function ($scope, $mdDialog)
                    {
                      $scope.object_id = id;
                      var object_cost = new api.objects.costhistorybyobjectid.query({'id':id},
                        function(data) {
                        $scope.cost_data = data;
                      });

                      $scope.closeDialog = function ()
                      {
                        $mdDialog.hide();
                      }
                    },
                    templateUrl: 'app/objects/objectCostHistoryDialog.html',
                    parent             : angular.element('body'),
                    locals: {
                      cost_data : $scope.cost_data,
                      object_id : $scope.object_id
                    },
                    clickOutsideToClose: true
                });
            }

        //просмотр объекта
    		function viewObject(id, mode, ev) {
          // mode rent/sale
          switch (mode) {
            case 'rent':
            case 'subrent':
            case 'ppa':
            case 'dsd': mode = 'Rent'; break;
            case 'sale':
            case 'change':  mode = 'Sale'; break;
          }
          //console.log($scope.mode, mode);

    			$mdDialog.show({
              controller         : function ($scope, $mdDialog)
              {
                //$scope.mode = mode;
                //console.log($scope.mode, mode);
              var viewobject = new api.objects.objectbyid.query({'id':id},
                  function(data) {

                    //фотографии
                    api.objects.objectphotosbyid.query({'id':id}, function(data) {
                        $scope.photos = data.data;
                				vm.total = $scope.photos.length;
                				//меняем адреса изображений
                				for(var i=0; i < vm.total;i++){
                          //замена на адреса, как на сервере
                          $scope.photos[i].filename = api.domain_name + api.domain_images + $scope.photos[i].filename;
                          //$scope.photos[i].filename = '/functions/images/' + $scope.photos[i].filename;
                				}
              			});

                    switch (parseInt(data.region)) {
                      case 1: data.region = 'Москва, '; break
                      case 2: data.region = 'Моск.обл., '; break
                    }

                    if (data.city_type!=null) data.region += data.city_type + '. ';
                    if (data.city!=null) data.region += data.city;
                    if ((data.street).length>1) data.region += ', ' + data.street;
                    if (data.house_number!=null) data.region += ', ' + data.house_number;


                  if (parseInt(data.square_all)>0) {
                    data.square_list = 'Общая площадь: '+ data.square_all + ' м2 ';
                  }

                  //тип объекта
                  switch (data.object_type) {
                    case 'garage': data.object_type = 'Гараж ';
                      switch (data.garage_type) {
                        case 'shell': data.object_type += 'Ракушка'; break
                        case 'detached': data.object_type += 'Отдельно стоящий'; break
                        case 'secure-outdoors': data.object_type += 'Место на охраняемой наружной стоянке'; break
                        case 'secure-underground': data.object_type += 'Место в подземном охраняемом гараже'; break
                        case 'high-bay': data.object_type += 'Место в многоярусном охраняемом гараже'; break
                        case 'cooperative': data.object_type += 'Гараж в гаражном кооперативе'; break
                        case 'capital': data.object_type += 'Капитальный'; break
                      }
                      break
                    case 'parkingPlace': data.object_type = 'Машиноместо ';
                      switch (data.garage_type) {
                        case 'secure-outdoors': data.object_type += 'Место на охраняемой наружной стоянке'; break
                        case 'secure-underground': data.object_type += 'Место в подземном охраняемом гараже'; break
                        case 'high-bay': data.object_type += 'Место в многоярусном охраняемом гараже'; break
                      }
                      break                      
                    case 'office': data.object_type = 'Офис '; break
                    case 'commercial_premises': data.object_type = 'Торговое помещение (';
                      switch (data.showcase) {
                        case 'yes': data.object_type += 'с витриной'; break
                        case 'no': break
                      }
                      switch (data.basement) {
                        case 'yes': if (data.showcase!=='no') {
                                      data.object_type += ', подвалом';
                                    } else {
                                      data.object_type += 'с подвалом';
                                    }
                                    break
                        case 'no': break
                      }
                      switch (data.sub_place) {
                        case 'yes': if (data.showcase=='no' && data.basement=='no') {
                                      data.object_type += 'с подсобными помещениями';
                                    } else {
                                      data.object_type += ', подсобными помещениями';
                                    }
                                    break
                        case 'no': break
                      }
                      data.object_type += ')';
                      ////////////////////////////////
                      if (parseInt(data.shopsq)>0) {
                        data.square_list += 'Торговая площадь: '+ data.shopsq + ' м2 ';
                      }
                      break
                    case 'stock': data.object_type = 'Склад ';
                      /////////////////////////////////
                      if (parseInt(data.officesq_stock)>0) {
                        data.square_list += 'Площадь офисной части: '+ data.officesq_stock + ' м2 ';
                      }
                      if (parseInt(data.usefulsq_stock)>0) {
                        data.square_list += 'Площадь производственной части: '+ data.usefulsq_stock + ' м2 ';
                      }
                      if (parseInt(data.workssq)>0) {
                        data.square_list += 'Площадь складской части: '+ data.workssq + ' м2 ';
                      }
                      if (parseInt(data.bordersq_stock)>0) {
                        data.square_list += 'Площадь прилегающей территории: '+ data.bordersq_stock + ' Га ';
                      }
                      break
                    case 'ready_business': data.object_type = 'Готовый бизнес ('+data.part_percent+'%)'; break
                    case 'psn': data.object_type = 'ПСН '; break
                    case 'production_room': data.object_type = 'Производственное помещение '; break
                    case 'production_land': data.object_type = 'Пром. земля '; break
                  }

                  switch (data.showcase) {
                    case 'yes': data.showcase = 'Да'; break
                    case 'no': data.showcase = 'Нет'; break
                  }

                  switch (data.object_type_2) {
                    case 'real': data.object_type_2 = ''; break
                    case 'hog-wash': data.object_type_2 = '(утка)'; break
                    case 'invest': data.object_type_2 = '(инвестиционный)'; break
                    case 'auction': data.object_type_2 = '(аукцион)'; break
                  }
                  //сделка и цена
                  if (data.deal_id==null) data.deal_id = 'Номер не присвоен'

                  switch (data.pay_duration) {
                    case 'day': data.pay_duration = '/день'; break
                    case 'month': data.pay_duration = '/месяц'; break
                    case 'year': data.pay_duration = '/год'; break
                  }

                  switch (data.pay_type) {
                    case 'object': data.pay_type = '/объект'; break
                    case 'squarem': data.pay_type = '/м2'; break
                  }



                  switch (data.deal_type) {
                    case 'rent':
                    case 'subrent':
                    case 'ppa':
                    case 'dsd': data.cost = data.rentcost + " руб." + data.pay_duration; break// + data.pay_type; break
                    case 'sale':
                    case 'change': data.cost = data.cost + " руб."; break
                  }

                  switch (data.deal_type) {
                    case 'rent': data.deal_type = 'Аренда'; break
                    case 'subrent': data.deal_type = 'Субаренда'; break
                    case 'ppa': data.deal_type = 'Продажа права аренды'; break
                    case 'dsd': data.deal_type = 'Договор совместной деятельности'; break
                    case 'sale': data.deal_type = 'Продажа'; break
                    case 'change': data.deal_type = 'Альтернатива'; break
                  }

                  if (!parseInt(data.story)>0) {
                    data.story = '-';
                  }
                  if (!parseInt(data.story_count)>0) {
                    data.story_count = '-';
                  }

                  //визы и листинг
                  switch(data.visa_status) {
                    case 'yes': data.visa_status = 'icon-label'; break
                    case 'no': data.visa_status = 'icon-label-outline'; break
                  }
                  switch(data.listing_status) {
                    case 'yes': data.listing_status = 'icon-note'; break
                    case 'no': data.listing_status = 'icon-note-outline'; break
                  }
                  switch(data.visa_publish) {
                    case 'yes': data.visa_publish = 'icon-star'; break
                    case 'no': data.visa_publish = 'icon-star-outline'; break
                  }

                  switch(data.sewage_item) {
                    case 'yes': data.sewage_item = 'Есть'; break
                    case 'no': data.sewage_item = 'Нет'; break
                    default: data.sewage_item = '-'; break
                  }
                  switch(data.gas_item) {
                    case 'yes': data.gas_item = 'Есть'; break
                    case 'no': data.gas_item = 'Нет'; break
                    default: data.gas_item = '-'; break
                  }
                  switch(data.water_on_item) {
                    case 'yes': data.water_on_item = 'Есть'; break
                    case 'no': data.water_on_item = 'Нет'; break
                    default: data.water_on_item = '-'; break
                  }

                  if (!(parseInt(data.buildlevelh)>0)) {
                    data.buildlevelh = 'Не указано';
                  }


                  //метро и направление
                  if (data.direction!==null && data.direction>0) {
                    api.objects.direction.query({'id':data.direction}, function(direct) {
                      data.direction = 'Направление: ' + direct.name + ' (' + data.from_mcad + ' км)';
                    });
                  } else {
                    data.direction = '';
                  }
                  if (data.metro_1!==null && data.metro_1>0) {
                    api.objects.metrostation.query({'id':data.metro_1}, function(metro) {
                      data.metro_1 = metro.name;
                      switch (data.metro_1_time) {
                        case 'f_2': data.metro_1_time = '(2 минуты пешком)'; break
                        case 'f_5': data.metro_1_time = '(5 минут пешком)'; break
                        case 'f_7': data.metro_1_time = '(7 минут пешком)'; break
                        case 'f_10': data.metro_1_time = '(10 минут пешком)'; break
                        case 'f_15': data.metro_1_time = '(15 минут пешком)'; break
                        case 'f_20': data.metro_1_time = '(20 минут пешком)'; break
                        case 't_5': data.metro_1_time = '(5 минут транспортом)'; break
                        case 't_10': data.metro_1_time = '(10 минут транспортом)'; break
                        case 't_15': data.metro_1_time = '(15 минут транспортом)'; break
                        case 't_20': data.metro_1_time = '(20 минут транспортом)'; break
                      }
                    });
                  } else {
                    data.metro_1 = '-';
                  }
                  if (data.metro_2!==null && data.metro_2>0) {
                    api.objects.metrostation.query({'id':data.metro_2}, function(metro) {
                      data.metro_2 = metro.name;
                      switch (data.metro_2_time) {
                        case 'f_2': data.metro_2_time = '((2 минуты пешком)'; break
                        case 'f_5': data.metro_2_time = '(5 минут пешком)'; break
                        case 'f_7': data.metro_2_time = '(7 минут пешком)'; break
                        case 'f_10': data.metro_2_time = '(10 минут пешком)'; break
                        case 'f_15': data.metro_2_time = '(15 минут пешком)'; break
                        case 'f_20': data.metro_2_time = '(20 минут пешком)'; break
                        case 't_5': data.metro_2_time = '(5 минут транспортом)'; break
                        case 't_10': data.metro_2_time = '(10 минут транспортом)'; break
                        case 't_15': data.metro_2_time = '(15 минут транспортом)'; break
                        case 't_20': data.metro_2_time = '(20 минут транспортом)'; break
                      }
                    });
                  } else {
                    data.metro_2 = '';
                  }
                  if (data.metro_3!==null && data.metro_3>0) {
                    api.objects.metrostation.query({'id':data.metro_3}, function(metro) {
                      data.metro_3 = metro.name;
                      switch (data.metro_3_time) {
                        case 'f_2': data.metro_3_time = '(2 минуты пешком)'; break
                        case 'f_5': data.metro_3_time = '(5 минут пешком)'; break
                        case 'f_7': data.metro_3_time = '(7 минут пешком)'; break
                        case 'f_10': data.metro_3_time = '(10 минут пешком)'; break
                        case 'f_15': data.metro_3_time = '(15 минут пешком)'; break
                        case 'f_20': data.metro_3_time = '(20 минут пешком)'; break
                        case 't_5': data.metro_3_time = '(5 минут транспортом)'; break
                        case 't_10': data.metro_3_time = '(10 минут транспортом)'; break
                        case 't_15': data.metro_3_time = '(15 минут транспортом)'; break
                        case 't_20': data.metro_3_time = '(20 минут транспортом)'; break
                      }
                    });
                  } else {
                    data.metro_3 = '';
                  }

                  //холодильник
                  switch(data.tech_4) {
                    case 'yes': data.tech_4 = 'Есть'; break
                    case 'no': data.tech_4 = 'Нет'; break
                    default: data.tech_4 = '-'; break
                  }
                  //стиральная машина
                  switch(data.tech_8) {
                    case 'yes': data.tech_8 = 'Есть'; break
                    case 'no': data.tech_8 = 'Нет'; break
                    default: data.tech_8 = '-'; break
                  }
                  //мебель
                  switch(data.furniture) {
                    case 'old': data.furniture = 'Старая'; break
                    case '90s': data.furniture = 'Мебель 90-х'; break
                    case 'modern': data.furniture = 'Современная'; break
                    case 'no': data.furniture = 'Нет'; break
                    case 'true': data.furniture = 'Да'; break
                    case 'false': data.furniture = 'Нет'; break
                    default: data.furniture = '-'; break
                  }
                  //телефон/интернет
                  switch(data.phone) {
                 //   case 'yes': data.phone = 'Есть'; break
                    case 'para': data.phone = 'Спаренный'; break
                    case 'possible': data.phone = 'Возможно подключить'; break
               //    case 'no': data.phone = 'Нет'; break
                    case 'yes': data.phone = 'Включены'; break
                    case 'no': data.phone = 'Не включены'; break
                    default: data.phone = '-'; break
                  }



                  switch(data.inet) {
               //     case 'yes': data.inet = 'Есть'; break
              //      case 'no': data.inet = 'Нет'; break
                    case 'yes': data.inet = 'Включены'; break
                    case 'no': data.inet = 'Не включены'; break
                    default: data.inet = '-'; break
                  }
                  //ремонт
                  switch(data.repairs) {
                    case 'euro': data.repairs = 'Евро'; break
                    case 'capital': data.repairs = 'Дизайнерский'; break
                    case 'cosmetic': data.repairs = 'Типовой'; break
                    case 'no': data.repairs = 'Без ремонта'; break
                    case 'quality': data.repairs = 'Качественная и дорогая отделка'; break
                    case 'standard-office': data.repairs = 'Офисная отделка'; break
                    case 'ready-for-final': data.repairs = 'Готово под чистовую отделку'; break
                    case 'needcapital': data.repairs = 'Требуется капитальный'; break
                    case 'needcosmetic': data.repairs = 'Требуется косметический'; break
                    case 'needreconstruction': data.repairs = 'Требуется реконструкция'; break
                    default: data.repairs = '-'; break
                  }

                  //типы санузла
                  switch(data.type_bathroom) {
                    case 'separated': data.type_bathroom = 'Раздельный'; break
                    case 'combined': data.type_bathroom = 'Совмещенный'; break
                    default: data.type_bathroom = '-'; break
                  }
                  //право собственности
                  switch(data.commobjectship) {
                    case 'primary': data.commobjectship = 'Первичная приватизация'; break
                    case 'contract-sales': data.commobjectship = 'Договор купли/продажи'; break
                    case 'contract-donat': data.commobjectship = 'Договор дарения'; break
                    case 'contract-rent': data.commobjectship = 'Договор ренты'; break
                    case 'paid': data.commobjectship = 'ЖСК, выплаченный пай'; break
                    case 'legacy': data.commobjectship = 'Наследство'; break
                    case 'court': data.commobjectship = 'Решение суда'; break
                    case 'mortgage': data.commobjectship = 'Залог (ипотека)'; break
                    case 'invest': data.commobjectship = 'По договору инвестирования'; break
                    default: data.commobjectship = '-'; break
                  }
                  //Тип дома
                  switch(data.type_bild) {
                    case 'block': data.type_bild = 'Блочный'; break
                    case 'panel': data.type_bild = 'Панельный'; break
                    case 'brick': data.type_bild = 'Кирпичный'; break
                    case 'wood': data.type_bild = 'Деревянный'; break
                    case 'stalin': data.type_bild = 'Сталинский'; break
                    case 'monolith': data.type_bild = 'Монолит'; break
                    case 'business_center': data.type_bild = 'Бизнес-центр'; break
                    case 'office_building': data.type_bild = 'Офисное здание'; break
                    case 'office_complex': data.type_bild = 'Комплекс офисных зданий'; break
                    case 'retail_office_complex': data.type_bild = 'Торгово-офисный комплекс'; break
                    case 'office_residential_complex': data.type_bild = 'Офисно-жилой комплекс'; break
                    case 'administrative_building': data.type_bild = 'Административное зданиие'; break
                    case 'mall': data.type_bild = 'Торгово-развлекательный центр'; break
                    case 'mansion': data.type_bild = 'Особняк'; break
                    case 'business_park': data.type_bild = 'Бизнес-парк'; break
                    case 'multifuctional_complex': data.type_bild = 'Многофункциональный комплекс'; break
                    default: data.type_bild = '-'; break
                  }
                  //Статус
                  switch(data.flat_status) {
                    case 'free': data.flat_status = 'Свободна'; break
                    case 'patrol': data.flat_status = 'Расселение/разъед'; break
                    case 'alternate': data.flat_status = 'Альтернатива'; break
                    case 'no': data.flat_status = 'Никто не прописан'; break
                    default: data.flat_status = '-'; break
                  }
                  //электричество
                  switch(data.enegi) {
                    case 'yes': data.enegi = 'Есть'; break
                    case 'unknown': data.enegi = 'Неизвестно'; break
                    case 'possible': data.enegi = 'Возможно подключить'; break
                    default: data.enegi = '-'; break
                  }
                  //отопление
                  switch(data.heating) {
                    case 'central': data.heating = 'Центральное'; break
                    case 'no': data.heating = 'Нет'; break
                    case 'autonomous': data.heating = 'Автономное'; break
                    default: data.heating = '-'; break
                  }
                  //Лифт
                  switch(data.lift) {
                    case 'pass': data.lift = 'Пассажирский'; break
                    case 'serv': data.lift = 'Грузовой'; break
                    case 'passserv': data.lift = 'Пасс. + груз.'; break
                    case '2pass1serv': data.lift = '2 Пасс. + груз.'; break
                    case '1pass2serv': data.lift = 'Пасс. + 2 груз.'; break
                    case '2pass': data.lift = '2 пассажирских'; break
                    case '2serv': data.lift = '2 грузовых'; break
                    case 'no': data.lift = 'Нет'; break
                    case 'rur': data.lift = 'Рубль'; break
                    case 'eur': data.lift = 'Евро'; break
                    case 'usd': data.lift = 'Доллар'; break
                    default: data.lift = '-'; break
                  }


                  //типы планировок
                  switch(data.plan_bild) {
                    case 'open': data.plan_bild = 'Свободная'; break
                    case 'corridor': data.plan_bild = 'Коридорно-кабинетная'; break
                    case 'mix': data.plan_bild = 'Смешанная'; break
                    case 'cabinet ': data.plan_bild = 'Кабинетная'; break
                    case 'corridorplan': data.plan_bild = 'Коридорная'; break
                    case 'mixed': data.plan_bild = 'Смешанная'; break
                    case 'openSpace': data.plan_bild = 'Открытая'; break
                    default: data.plan_bild = '-'; break
                  }
                  //в собственности
                  switch(data.years_own) {
                    case 'less3': data.years_own = 'Менее 3 лет'; break
                    case 'more3': data.years_own = 'Более 3 лет'; break
                    default: data.balcony = '-'; break
                  }
                  //  Назначение  (жилое)
                  switch(data.commerce_living_type) {
                    case 'yes': data.commerce_living_type = 'Жилое'; break
                    case 'no': data.commerce_living_type = 'Нежилое'; break
                    case 'shoppingFloorSpace': data.commerce_living_type = 'Торговая площадь'; break
                    case 'publicCatering': data.commerce_living_type = 'Общепит'; break
                    case 'restaurant': data.commerce_living_type = 'Ресторан'; break
                    case 'rentalBusiness': data.commerce_living_type = 'Арендный бизнес'; break
                    case 'readyMadeBusiness': data.commerce_living_type = 'Готовый бизнес'; break
                    case 'flexiblePurpose': data.commerce_living_type = 'Свободное назначение'; break
                    case 'streetRetail': data.commerce_living_type = 'Стрит ритейл'; break
                    case 'products': data.commerce_living_type = 'Продукты'; break
                    case 'other': data.commerce_living_type = 'Другое'; break
                    default: data.commerce_living_type = '-'; break
                  }


                  //въезд
                  switch(data.commerce_enter) {
                    case 'free': data.commerce_enter = 'Свободный'; break
                    case 'kpp': data.commerce_enter = 'КПП'; break
                    case 'yes': data.commerce_enter = 'Предоставляется'; break
                    case 'no': data.commerce_enter = 'Не предоставляется'; break
                    default: data.commerce_enter = '-'; break
                  }
                  //Статус бизнес центра
                  switch(data.class_bild) {
                    case 'A': data.class_bild = 'A'; break
                    case 'A+': data.class_bild = 'A+'; break
                    case 'B': data.class_bild = 'B'; break
                    case 'B+': data.class_bild = 'B+'; break
                    case 'C': data.class_bild = 'C'; break
                    case 'C+': data.class_bild = 'C+'; break
                    case 'D': data.class_bild = 'D'; break
                    case 'included': data.class_bild = 'НДС включен'; break
                    case 'notIncluded': data.class_bild = 'НДС не включен'; break
                    case 'usn': data.class_bild = 'УСН'; break
                    default: data.class_bild = '-'; break
                  }


                  //присваиваем полученные и отредактированные данные
                  $scope.object_data = data;
                  $scope.markers = [
                    {coordinates:[data.latitude, data.longitude], properties: {balloonContent: 'Объект '+data.id}, options: {preset: 'islands#icon', iconColor: '#2e2bff'}},

                  ];
                  //настройки положения карты
                  $scope.map = {
                      center: [data.latitude, data.longitude], zoom: 17
                  };

                  data.domain_name = api.domain_name;
          		});
              //////////////////////////////////////
                  $scope.closeDialog = function ()
                  {
                      $mdDialog.hide();
                  }
              },
                    templateUrl: 'app/objects/commerce/object' + mode + 'ViewDialog.html',
                    //templateUrl: 'app/objects/commerce/objectViewDialog.html',
                    parent             : angular.element('body'),
                    locals: {
                      object_data : $scope.object_data,
                      markers: $scope.markers,
                      map: $scope.map
                    },
                    clickOutsideToClose: true
                });
    		}

        //смена состояния визы
		function changeVisa(id,param_value) {
      var changevisa = new api.objects.changeVisaStatus();
      changevisa.id = id;
      changevisa.param_value = param_value;
      changevisa.$save();

      for(var i = 0; i < vm.commobjects.length; i++) {
         if(vm.commobjects[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.commobjects[i].visastatus = '-outline';
             vm.commobjects[i].visa_status = 'no';
             angular.element($('#object_visa_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_visa_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.commobjects[i].visastatus = '';
             vm.commobjects[i].visa_status = "yes";
             angular.element($('#object_visa_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_visa_'+id)).addClass('visa_listing_green');
           }
           break;
         }
      }
		}
		//смена состояния листинга
		function changeListing(id,param_value) {
      var changelisting = new api.objects.changeListingStatus();
      changelisting.id = id;
      changelisting.param_value = param_value;
      changelisting.$save();

      for(var i = 0; i < vm.commobjects.length; i++) {
         if(vm.commobjects[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.commobjects[i].listingstatus = '-outline';
             vm.commobjects[i].listing_status = 'no';
             angular.element($('#object_listing_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_listing_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.commobjects[i].listingstatus = '';
             vm.commobjects[i].listing_status = 'yes';
             angular.element($('#object_listing_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_listing_'+id)).addClass('visa_listing_green');
           }
           break;
         }
       }
		}
		//смена состояния визы на публикацию
		function changeVisaP(id,param_value) {
      var changevisap = new api.objects.changeVisaPStatus();
      changevisap.id = id;
      changevisap.param_value = param_value;
      changevisap.$save();

      for(var i = 0; i < vm.commobjects.length; i++) {
         if(vm.commobjects[i].id == id) {
           if (param_value=='yes') {
             //была виза-листинг, меняем на нет визы-листинга
             vm.commobjects[i].visapublish = '-outline';
             vm.commobjects[i].visa_publish = 'no';
             angular.element($('#object_visap_'+id)).removeClass('visa_listing_green');
             angular.element($('#object_visap_'+id)).addClass('visa_listing_red');
           } else if (param_value=='no') {
             vm.commobjects[i].visapublish = '';
             vm.commobjects[i].visa_publish = 'yes';
             angular.element($('#object_visap_'+id)).removeClass('visa_listing_red');
             angular.element($('#object_visap_'+id)).addClass('visa_listing_green');
           }
           break;
         }
       }
		}
        function changeArchiveStatus(n) {
			switch(n) {
				case 0: vm.archive = false; break
				case 1: vm.archive = true;	break
			}
		}
        ///////////////////////////////
        function checkArchiveStatus(n) {
			switch(n) {
				case 'icon':
				if (vm.archive == true) {
					return 'icon-arrow-right-bold-circle';
					}
				else {
					return 'icon-delete';
					}
			break
			default:
				if (vm.archive == true) {
					return true;
					}
				else {
					return false;
					}
			break
			}
		}

        //создание объекта
        function addObject() {
			$location.path('/objects/new/commerce');
		}
		//редактирование объекта
		function editObject(id,type) {
			//для клика по иконке и для двойного клика
			switch(type){
				case 1:	$location.path('/objects/edit/commerce/'+id); break
				case 2: $rootScope.$apply(function() {
							$location.path('/objects/edit/commerce/'+id);
						});
						break
			}
		}
		function restore_archiveObject(id) {
			if (vm.archive == true) {
				restoreObject(id);
			}
			else {
				archiveObject(id);
			}
		}
    //диалог с предупреждением об удалении объекта
    function archiveObject(id,ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Отправить объект в архив?',
                parent             : '#content',
                textContent        : '',
                ariaLabel          : 'remove object',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Удалить',
                cancel             : 'Отмена'
            });

            $mdDialog.show(confirm).then(function ()
            {
              archiveObject_object(id);
            }, function ()
            {
              //
            });
        }

		//удаление объекта
		function archiveObject_object(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var archiveobject = new api.objects.archiveobject();
					archiveobject.id = id;
					archiveobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/commerce');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект {{id}} отправлен в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//восстановление объекта
		function restoreObject(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var restoreobject = new api.objects.restoreobject();
					restoreobject.id = id;
					restoreobject.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/objects/commerce/archive');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект {{id}} восстановлен из архива</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//нет прав
		function showSetListingError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия листинга обратитесь к листинг-менеджеру</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}
		function showSetVisaError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия визы обратитесь к начальнику отдела</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}
		function showSetVisaPError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия визы на публикацию на сайте обратитесь к начальнику отдела</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}

		//двойнок клик на строку
		function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			$('td', nRow).unbind('dblclick');
			$('td', nRow).bind('dblclick', function() {
				//если есть право на редакцию
				if (($rootScope.checkRule(35,vm.commobjects_by_id[aData[0]].group,'group')) || ((vm.commobjects_by_id[aData[0]].owner == vm.userid) && $rootScope.checkRule(35,'my') && vm.archive == false) || $rootScope.checkRule(35,'all')) {
					//(vm.commobjects_by_id[aData[0]].group == vm.groupid) &&
					editObject(aData[0],2);
				} else {
				console.log('id '+aData[0]+' group: '+vm.commobjects_by_id[aData[0]].group);
				$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Нет прав на редактирование этого объекта</h1></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
				}
			});
			return nRow;
		}
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.requests', ['app.modules.requests.requestsarchive',
										 'app.modules.requests.editrequest'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {        
        $stateProvider.state('app.modules_requests', {
            url    : '/requests',
            views  : {
                'content@app': {
                    templateUrl: 'app/modules/requests/requests.html',
                    controller : 'RequestsController as vm'
                }
            },
            resolve: {
                Requests: function (apiResolver)
                {
                    return apiResolver.resolve('requests.list@get');
                }
            }
        });
        
        msNavigationServiceProvider.saveItem('apps.requests', {
            title : 'Заявки',
            icon  : 'icon-currency-rub',
            state : 'app.modules_requests',
            weight: 6
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.requests')
        .controller('RequestsController', RequestsController);

    /** @ngInject */
    function RequestsController($rootScope, $location, $mdDialog, api, Requests)
    {
        var vm = this;

        // Data
        vm.requests = Requests.data;

		//определяем в архиве мы находимся или нет
		if ($location.path() == '/requests') {
			vm.archive = false;
		} else if ($location.path() == '/requests/archive') {
			vm.archive = true;
		}

        //получаем id своей учетной записи для сверки на ком установлена бронь
        api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
			vm.userid = data.user_id;
		});
		//пишем нормальные типы заявок для пользователей
		for (var i=0;i<vm.requests.length;i++) {
			switch(vm.requests[i].type) {
				case 'vacancy': vm.requests[i].type = 'Собеседование'; break
				case 'call': vm.requests[i].type = 'Звонок'; break
				case 'purchase': vm.requests[i].type = 'Покупка'; break
				case 'sale': vm.requests[i].type = 'Продажа'; break
				case 'rent': vm.requests[i].type = 'Аренда'; break
			}
			switch(vm.requests[i].object) {
				case 'flat': vm.requests[i].type = vm.requests[i].type + ' квартиры'; break
				case 'room': vm.requests[i].type = vm.requests[i].type + ' комнаты'; break
				case 'house': vm.requests[i].type = vm.requests[i].type + ' дома'; break
			}
		}
		//опции таблицы
        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				{ "order": "desc" },
				null,
        { "orderable": false },
				null,
				null
			  ],
			  "order": [0, "desc"]
        };
        // Methods
		vm.viewRequest = viewRequest;
		vm.bookRequest = bookRequest;
		vm.unbookRequest = unbookRequest;
		vm.archiveRequest = archiveRequest;
		//проверка на архив и установка переменной на архив
		vm.Arch = changeArchiveStatus;
		vm.isArch = checkArchiveStatus;
    
        // Methods
        //////////////////////////////
        function changeArchiveStatus(n) {
			switch(n) {
				case 0: vm.archive = false; break
				case 1: vm.archive = true;	break
			}
		}
        ///////////////////////////////
        function checkArchiveStatus(n) {
			switch(n) {
				case 'icon':
				if (vm.archive == true) {
					return 'icon-chevron-double-up';
					}
				else {
					return 'icon-chevron-double-right';
					}
			break
			default:
				if (vm.archive == true) {
					return true;
					}
				else {
					return false;
					}
			break
			}
		}

		//просмотр и редактирование
		function viewRequest(id) {
			$location.path('/request/view/'+id);
		}
		/*function viewRequest(id,ev,request_data_by_id()) {
            var confirm = $mdDialog.confirm({
                //title              : '',
                //textContent        : 'Если Вы не хотите сейчас обрабатывать заявку, то просто щелкните вне окна заявки, чтобы закрыть ее' +
				//					 '<br>Данные заявки:{{request_data_by_id(id) | json}}'+ request_data,
				template: '<md-dialog>' +
                '  <md-dialog-content><h1>Данные заявки</h1><div>Если Вы не хотите сейчас обрабатывать заявку, то просто щелкните вне окна заявки, чтобы закрыть ее. {{request_data_by_id(id) | json}}</div></md-dialog-content>' +
                '  <md-dialog-actions>' + request_data_by_id(id) +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                ariaLabel          : 'archive request',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Успешно',
                cancel             : 'Неудачно'
            });

            $mdDialog.show(confirm).then(function ()
            {
				//успешная обработка
				var requestbyid = new api.requests.requestbyid();
				requestbyid.id = id;
				requestbyid.my_id = vm.userid;
				requestbyid.$save();//
            }, function ()
            {
                //неудачная обработка

            });
		}*/

		function request_data_by_id(id) {
			api.requests.requestbyid.get({id:id}, function(data) {
				return data.data;
			});
		}

		//Бронирование заявки
		function bookRequest(id) {

			var server_answer;
			var header_dialog;
			var text_dialog;

			var bookrequest = new api.requests.bookrequest();
			bookrequest.id = id;
			bookrequest.my_id = vm.userid;
			bookrequest.$save(bookrequest, function(responseData) {
				server_answer = responseData.answer;
				//console.log(server_answer);
				if (server_answer=='false') {
					//Неудачное бронирование заявки
					header_dialog = "Заявка не забронирована";
					text_dialog = "Кто-то забронировал ее до Вас. Обновите страницу и выберите другую";
				} else {
					header_dialog = "Заявка забронирована";
					text_dialog = "Вы забронировали эту заявку. Теперь свяжитесь с клиентом";
				}
				//вызываем нужный диалог
				un_success_dialog_bookRequest(id, header_dialog, text_dialog, server_answer);
			  }
			);
		}

		//Бронирование заявки / диалог об успехе
		function un_success_dialog_bookRequest(id, header_dialog,text_dialog,server_answer) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
					////////////////////////////////
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        //$location.path('/requests');
                        if (server_answer=='true') viewRequest(id);
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>'+header_dialog+'</h1><div>'+text_dialog+'</div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//Снятие брони с заявки
		function unbookRequest(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var unbookrequest = new api.requests.unbookrequest();
					unbookrequest.id = id;
					unbookrequest.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/requests');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Бронь снята</h1><div>Теперь заявка доступна для бронирования другими агентами</div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//удаление
		function archiveRequest(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var archiveRequest = new api.requests.archiverequest();
					archiverequest.id = id;
					archiverequest.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/requests');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Отдел отправлен в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.ownerbase', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.ownerbase', {
            url    : '/owners',
            views  : {
                'content@app': {
                    templateUrl: 'app/modules/ownerbase/ownerbase.html',
                    controller : 'OwnerbaseController as vm'
                }
            },
            resolve: {
                Owners: function (apiResolver)
                {
                    return apiResolver.resolve('owners.list@get');
                }
            }
        });
        /*
        msNavigationServiceProvider.saveItem('apps.ownerbase', {
            title : 'База собственников',
            icon  : 'icon-account-search',
            state : 'app.ownerbase',
            weight: 4
        });
        */
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.ownerbase')
        .controller('OwnerbaseController', OwnerbaseController);

    /** @ngInject */
    function OwnerbaseController($rootScope, $scope, $location, $mdDialog, api, Owners)
    {
    var vm = this;

    // Data
    vm.room_filter = 0;

    //свежие (1000) или последние 30 дней
    vm.last1000 = 500;

    //линия метро
    vm.metro_line_filter = 0;
    vm.metrostations_by_line = []

    api.objects.metrostations_lines.query({}, function(data) {
        vm.metro_lines = data;
        });

    vm.owners = Owners.data.filter(function (owner) {


    //     vm.metro_line_filter = 1;
    //     //console.log(vm.metro_line_filter);
    //     api.objects.metrostations_by_lines.get({id:vm.metro_line_filter}, function(data) {
    //         vm.metrostations_by_line = [];
    //         for (var i=0;i<data.data.length;i++) {
    //             vm.metrostations_by_line.push(data.data[i].name);
    //         }
    //         //console.log(data);
    //         //фильтр по числу комнат и станции метро
    //         vm.owners = Owners.data.filter(function (owner) {
    //
    //                 return (owner.rooms > vm.room_filter && vm.metrostations_by_line.indexOf(owner.metro)>=1)
    //
    //         });
    //
    //     });
    // });

        return (owner.rooms > vm.room_filter);
    });

    vm.owners = vm.owners.slice(vm.owners.length-vm.last1000);

    //получаем id своей учетной записи для сверки на ком установлена бронь
    api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
			vm.userid = data.user_id;
		});

		for (var i=0;i<vm.owners.length;i++) {
			if (vm.owners[i].from_metro!='') {
        vm.owners[i].from_metro = "(" + vm.owners[i].from_metro.substr(1) + ")";
      }
		}

    // vm.total = 0;
    // vm.dtInstance = {};
    //
    // vm.dtInstanceCallback = function (instance) {
    //   vm.dtInstance = instance;
    // }

		//опции таблицы
        vm.dtOptions = {
            dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				{ "order": "desc" },
        {"width":"135px"},
				null,
				null,
        null,
        null,
        null,
				null
			  ],
        "buttons": [
          {
             extend: "print",
             text: "Печать",
             title:  "База собственников",
             className: "DTBblack",
             exportOptions: {
                columns: [0,2,3,4,5,6,7],
             },
             autoPrint: false
           },
          // {
          //    extend: "print",
          //    text: "Печать",
          //    title:  "Список собственников",
          //    className: "DTBblack",
          //    exportOptions: {
          //        columns: ':visible'
          //    }
          //  },
          {
             extend: "excel",
             text: "Сохранить таблицу",
             className: "DTBblack",
             //fileName:  "Список клиентов.xls",
             title:"Список собственников",
             exportOptions: {
                 columns: ':visible'
             }
         },
         /*{
            text: "1",
            className: "DTBblack",
            title:"Только однокомнатные",
            action: function (e, dt, node, config) {
                alert('Button 1');
            },
         },
         {
            text: "2",
            className: "DTBblack",
            title:"Только двухкомнатные"
         },
         {
            text: "3",
            className: "DTBblack",
            title:"Только трехкомнатные"
         },
         {
            text: "4",
            className: "DTBblack",
            title:"Только 4+ комнатные"
         },*/
        ],
			  "order": [0, "desc"]
        };


    // Methods
		vm.viewOwner = viewOwner;
		vm.editOwner = editOwner;
    vm.bookOwner = bookOwner;
		vm.unbookOwner = unbookOwner;
    vm.addFavorite = addFavorite;
    vm.filter_room = filter_room;

    //в избранное
		// function addFavorite(id, myfav) {
    //   if (myfav==null) {
    //     $mdDialog.show({
    //               controller         : function ($scope, $mdDialog)
    //               {
    //                   var favowner = new api.owners.favowner();
  	// 				favowner.id = id;
    //         favowner.my_id = vm.userid;
  	// 				favowner.$save();
    //
    //                   $scope.closeDialog = function ()
    //                   {
    //                       $mdDialog.hide();
    //                       $location.path('/owners');
    //                   }
    //               },
    //               template: '<md-dialog>' +
    //               '  <md-dialog-content><h1>Собственник добавлен в избранное</h1><div>Теперь он доступен для работы на странице Моя база собственников</div></md-dialog-content>' +
    //               '  <md-dialog-actions>' +
    //               '    <md-button ng-click="closeDialog()" class="md-primary">' +
    //               '      Закрыть' +
    //               '    </md-button>' +
    //               '  </md-dialog-actions>' +
    //               '</md-dialog>',
    //               parent             : angular.element('body'),
    //               clickOutsideToClose: true
    //           });
    //   } else {
    //     console.log("Уже есть в избранном");
    //   }
		// }

    //в мою БС, сразу добавив напоминание
    function addFavorite(id, myfav) {
      if (myfav==null) {
        $mdDialog.show({
              controller         : function ($scope, $mdDialog)
                {
                  var data = [];
                  data.id = id;
                  $scope.object_data = data;

                  $scope.closeDialog = function ()
                  {
                    $mdDialog.hide();
                  }
                  //сохранить заметку
                  $scope.changeCallDate = function (id,date,minutes,agent_description)
                  {
                    //console.log(date);
                    if (minutes>0) {
                      var datet = minutes;
                    } else {
                      var datet = Date.parse(date);
                      datet = Math.round(datet/1000);
                    }

                    var description = agent_description;

                    $mdDialog.hide();
                    $scope.showResult(datet, description);
                  }

                  $scope.showResult = function (datet, description) {
                    $mdDialog.show({
                              controller         : function ($scope, $mdDialog)
                              {
                                  var favowner = new api.owners.favowner();
                        					favowner.id = id;
                                  favowner.my_id = vm.userid;
                                  favowner.note = description;
                                  favowner.date = datet;
                        					favowner.$save();

                                  $scope.closeDialog = function ()
                                  {
                                      $mdDialog.hide();
                                      $location.path('/owners');
                                  }
                              },
                              template: '<md-dialog>' +
                              '  <md-dialog-content><h1>Собственник добавлен в избранное</h1><div>Теперь он доступен для работы на странице Моя база собственников</div></md-dialog-content>' +
                              '  <md-dialog-actions>' +
                              '    <md-button ng-click="closeDialog()" class="md-primary">' +
                              '      Закрыть' +
                              '    </md-button>' +
                              '  </md-dialog-actions>' +
                              '</md-dialog>',
                              parent             : angular.element('body'),
                              clickOutsideToClose: true
                          });
                  }


                },
                templateUrl: 'app/modules/my_ownerbase/favownerEditCallTimeDialog.html',
                parent             : angular.element('body'),
                locals: {
                  object_data : $scope.object_data
                },
                clickOutsideToClose: true
            });

      } else {
        console.log("Уже есть в избранном");
      }
		}



    //фильтр по числу комнат
		function filter_room(n, line, limit, ev) {
			vm.room_filter = n;
      if (line>0) {
        vm.metro_line_filter = line;
        //console.log(vm.metro_line_filter);
        api.objects.metrostations_by_lines.get({id:vm.metro_line_filter}, function(data) {
              vm.metrostations_by_line = [];
              for (var i=0;i<data.data.length;i++) {
                vm.metrostations_by_line.push(data.data[i].name);
              }
              //console.log(data);
              //фильтр по числу комнат и станции метро
              vm.owners = Owners.data.filter(function (owner) {
                 if (n>0 && n <4) {
                   //return (parseInt(owner.rooms) == vm.room_filter && vm.metrostations_by_line.indexOf(owner.metro)>=0)
                   return (owner.rooms == vm.room_filter && vm.metrostations_by_line.indexOf(owner.metro)>=0);
                 } else {
                   return (owner.rooms > vm.room_filter && vm.metrostations_by_line.indexOf(owner.metro)>=0);
                 }
              });
              if (limit<5000) {
                vm.owners = vm.owners.slice(vm.owners.length-limit);
              }
            });

      } else {
      //console.log(vm.metrostations_by_line);
      //console.log(vm.owners);
      //только фильтр по числу комнат
      vm.metro_line_filter = 1;
      //console.log(vm.metro_line_filter);
      api.objects.metrostations_by_lines.get({id:vm.metro_line_filter}, function(data) {
            vm.metrostations_by_line = [];
            for (var i=0;i<data.data.length;i++) {
              vm.metrostations_by_line.push(data.data[i].name);
            }
            //console.log(data);
            //фильтр по числу комнат и станции метро
            vm.owners = Owners.data.filter(function (owner) {
               if (n>0 && n <4) {
                 //return (parseInt(owner.rooms) == vm.room_filter && vm.metrostations_by_line.indexOf(owner.metro)>=0)
                 return (owner.rooms == vm.room_filter && vm.metrostations_by_line.indexOf(owner.metro)>=0);
               } else {
                 return (owner.rooms > vm.room_filter && vm.metrostations_by_line.indexOf(owner.metro)>=0);
               }
            });
            if (limit<5000) {
              vm.owners = vm.owners.slice(vm.owners.length-limit);
            }
          });
      }
		}

    //просмотр объекта
		function viewOwner(id, ev) {
			$mdDialog.show({
          controller         : function ($scope, $mdDialog)
          {
          var viewowner = new api.owners.ownerbyid.query({'id':id},
              function(data) {
              //присваиваем полученные данные
              $scope.owner_data = data;
      		});
          //////////////////////////////////////
              $scope.bookOwner = function ()
              {
                  bookOwner(id);
                  $mdDialog.hide();
              }
              $scope.closeDialog = function ()
              {
                  $mdDialog.hide();
              }
          },
                templateUrl: 'app/modules/ownerbase/ownerViewDialog.html',
                parent             : angular.element('body'),
                locals: {
                  owner_data : $scope.owner_data
                },
                //scope: this,
                clickOutsideToClose: true
            });
		}

    //редактирование-обработка
		function editOwner(id, ev) {
      $mdDialog.show({
          controller         : function ($scope, $mdDialog)
          {
          var viewowner = new api.owners.ownerbyid.query({'id':id},
              function(data) {
              //присваиваем полученные данные
              $scope.owner_data = data;
      		});
          //////////////////////////////////////
              $scope.owner_archive = function (owner_id, object_id)
              {
                  $mdDialog.hide();
                  owner_archive(owner_id, object_id);
              }
              $scope.closeDialog = function ()
              {
                  $mdDialog.hide();
              }
          },
                templateUrl: 'app/modules/ownerbase/b_ownerViewDialog.html',
                parent             : angular.element('body'),
                locals: {
                  owner_data : $scope.owner_data
                },
                //scope: this,
                clickOutsideToClose: true
            });
		}

    function owner_archive(id, object_number) {
      var archiveowner = new api.owners.archiveowner();
      archiveowner.id = id;
      archiveowner.object_number = object_number;
      archiveowner.$save();

      header_dialog = "Объект отправлен в архив";
      text_dialog = "Теперь он недоступен для просмотра в базе собственников";
      //вызываем нужный диалог
      un_success_dialog_bookOwner(id, header_dialog, text_dialog);
		}

/*
		function owner_data_by_id(id) {
			api.owners.ownerbyid.get({id:id}, function(data) {
				return data.data;
			});
		}
*/
		//Бронирование
		function bookOwner(id) {
			var server_answer;
			var header_dialog;
			var text_dialog;

			var bookowner = new api.owners.bookowner();
			bookowner.id = id;
			bookowner.my_id = vm.userid;
			bookowner.$save(bookowner, function(responseData) {
				server_answer = responseData.answer;
				//console.log(server_answer);
				if (server_answer=='false') {
					//Неудачное бронирование
					header_dialog = "Объект не забронирован";
					text_dialog = "Кто-то забронировал его до Вас. Обновите таблицу и выберите другой";
				} else {
					header_dialog = "Объект забронирован";
					text_dialog = "Вы забронировали этот объект. Теперь свяжитесь с клиентом и договоритесь о встречи. Если за 3 суток Вы не обработаете бронь, то она будет автоматически снята";
				}
				//вызываем нужный диалог
				un_success_dialog_bookOwner(id, header_dialog, text_dialog, server_answer);
			  }
			);
		}

		//Бронирование / диалог об успехе
		function un_success_dialog_bookOwner(id, header_dialog,text_dialog) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
					////////////////////////////////
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        if (server_answer=='true') editOwner(id);
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>'+header_dialog+'</h1><div>'+text_dialog+'</div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//Снятие брони
		function unbookOwner(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var unbookowner = new api.owners.unbookowner();
					unbookowner.id = id;
					unbookowner.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/owners');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Бронь снята</h1><div>Теперь объект доступен для бронирования другими агентами</div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}



        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.my_ownerbase', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.my_ownerbase', {
            url    : '/my_owners',
            views  : {
                'content@app': {
                    templateUrl: 'app/modules/my_ownerbase/ownerbase.html',
                    controller : 'MyOwnerbaseController as vm'
                }
            },
            resolve: {
                Owners: function (apiResolver)
                {
                    return apiResolver.resolve('owners.favorites@get');
                }
            }
        });

        msNavigationServiceProvider.saveItem('apps.owners', {
            title : 'База собственников',
            icon  : 'icon-account-search',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('apps.owners.ownerbase', {
          icon  : 'icon-account-box',
                title: 'База собственников',
                state: 'app.ownerbase'
            });

        msNavigationServiceProvider.saveItem('apps.owners.my_ownerbase', {
            title : 'Моя база собств.',
            icon  : 'icon-phone-log',
            state : 'app.my_ownerbase',
            weight: 4
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.my_ownerbase')
        .controller('MyOwnerbaseController', MyOwnerbaseController);

    /** @ngInject */
    function MyOwnerbaseController($rootScope, $scope, $location, $mdDialog, api, Owners)
    {
    var vm = this;

    // Data
    vm.room_filter = 0;

    //линия метро
    vm.metro_line_filter = 0;
    vm.metrostations_by_line = []

    api.objects.metrostations_lines.query({}, function(data) {
        vm.metro_lines = data;
        });

    vm.owners = Owners.data.filter(function (owner) {
        return (owner.rooms > vm.room_filter);
    });

    //если показывать только один - напоминание
    if ($location.search().showId) {
      console.log('show only one object: '+$location.search().showId);
      //console.log(vm.owners);
      //console.log();
      vm.owners = Owners.data.filter(function (owner) {
          return (owner.id == $location.search().showId);
      });
    }

    //получаем id своей учетной записи для сверки на ком установлена бронь
    api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
			vm.userid = data.user_id;
		});

		for (var i=0;i<vm.owners.length;i++) {
			if (vm.owners[i].from_metro!='') {
        vm.owners[i].from_metro = "(" + vm.owners[i].from_metro.substr(1) + ")";
      }
      //checkbox
      vm.owners[i].printstatus = false;
      vm.owners[i].printicon = 'icon-checkbox-blank-outline';

		}

		//опции таблицы
        vm.dtOptions = {
            dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				{ "order": "desc" },
        {"width":"135px"},
				null,
				null,
        null,
        null,
        null,
        null,
        null,
				null
			  ],
        "buttons": [
          {
             extend: "print",
             text: "Печать",
             title:  "Список объектов",
             className: "DTBblack",
             exportOptions: {
                columns: [8,3,4,5,9,6,7],
             },
             autoPrint: false,
             customize: function (w) {
                //console.log('custom print', vm.owners);
                var visibleId = 1;
                $(w.document.body).find('tbody tr').each(function(index){
                    //console.log('>custom print', $(this), index);
                    for (var i=0;i<vm.owners.length;i++) {
                      //console.log('>>custom print', $(this).find('td:first-child'), $(this).find('td:first-child').attr('data-owner-id'));
                      if ($(this).find('td:first-child').attr('data-owner-id') == vm.owners[i].id ||
                          $(this).find('td:first-child').text() == vm.owners[i].id) {
                        if (!vm.owners[i].printstatus) {
                          $(this).css('visibility','hidden').css('display','none');
                          continue;
                        } else {
                          //console.log('visible ', i, vm.owners[i].id, visibleId);
                          //$(this).find('td:first-child').text(visibleId);
                          visibleId = visibleId + 1;
                        }
                      }
                    }
                });
                $(w.document.body).find('h1').css('text-align','center');
                $(w.document.body).find('tr:visible:nth-child(odd) td').each(function(index){
                    $(this).css('background-color','#f0f0f0');
                });
            },
           },
          // {
          //    extend: "print",
          //    text: "Печать",
          //    title:  "Список объектов",
          //    className: "DTBblack",
          //    exportOptions: {
          //        columns: ':visible'
          //    }
          //  },
          {
             extend: "excel",
             text: "Сохранить таблицу",
             className: "DTBblack",
             //fileName:  "Список клиентов.xls",
             title:"Список собственников",
             exportOptions: {
                 columns: ':visible'
             }
         },
         /*{
            text: "1",
            className: "DTBblack",
            title:"Только однокомнатные",
            action: function (e, dt, node, config) {
                alert('Button 1');
            },
         },
         {
            text: "2",
            className: "DTBblack",
            title:"Только двухкомнатные"
         },
         {
            text: "3",
            className: "DTBblack",
            title:"Только трехкомнатные"
         },
         {
            text: "4",
            className: "DTBblack",
            title:"Только 4+ комнатные"
         },*/
        ],
			  "order": [0, "desc"]
        };


    // Methods
		vm.viewOwner = viewOwner;
		vm.editOwner = editOwner;
    vm.bookOwner = bookOwner;
		vm.unbookOwner = unbookOwner;
    vm.filter_room = filter_room;
    vm.notesFavOwner = notesFavOwner;
    vm.archiveFavOwner = archiveFavOwner;
    vm.callFavOwner = callFavOwner;
    vm.changePrint = changePrint;
    vm.isPrint = isPrint;
		vm.editFavOwner = editFavOwner;


    //редактирование поля описания и цены
    function editFavOwner(id) {
      $mdDialog.show({
  					controller         : function ($scope, $mdDialog)
  						{
                var viewobject = new api.owners.paramsbyownerid.query({'id':id},
                  function(fawowner) {
                  //получаем текст заметки, если есть
                  var data = [];
                  data.id = id;
                  data.price = fawowner.price;
                  data.description = fawowner.description;
                  $scope.object_data = data;
                });

  							$scope.closeDialog = function ()
  							{
  								$mdDialog.hide();
  							}
                //сохранить заметку
                $scope.changeFavOwnerParams = function (id,price,text)
  							{
                  var changeagentdescription = new api.owners.changeFavOwnerParams();
                  changeagentdescription.id = id;
                  changeagentdescription.favowner_price = price;
                  changeagentdescription.favowner_description = text;
                  changeagentdescription.$save();
  								$mdDialog.hide();
  							}
  						},
              templateUrl: 'app/modules/my_ownerbase/favownerEditParamsDialog.html',
              parent             : angular.element('body'),
              locals: {
                object_data : $scope.object_data
              },
              clickOutsideToClose: true
          });
    }

    function changePrint(id, param_value) {
      //console.log('changePrint', id, param_value);
      for(var i = 0; i < vm.owners.length; i++) {
         if(vm.owners[i].id == id) {
           vm.owners[i].printstatus = !param_value;
           //hack
           angular.element($('#object_print_'+vm.owners[i].id)).removeClass(vm.owners[i].printicon)
           vm.owners[i].printicon = vm.isPrint(vm.owners[i].printstatus);
           angular.element($('#object_print_'+vm.owners[i].id)).addClass(vm.owners[i].printicon)
           //console.log(vm.owners[i].id, vm.owners[i].printicon, angular.element($('#object_print_'+vm.owners[i].id)));
           break;
         }
       }
    }


    function isPrint(param_value) {
      // можно убрать
      return (param_value ? 'icon-checkbox-blank' : 'icon-checkbox-blank-outline');
    }

    //фильтр по числу комнат
		function filter_room(n, line, ev) {
			vm.room_filter = n;
      if (line>0) {
        vm.metro_line_filter = line;
        //console.log(vm.metro_line_filter);
        api.objects.metrostations_by_lines.get({id:vm.metro_line_filter}, function(data) {
              vm.metrostations_by_line = [];
              for (var i=0;i<data.data.length;i++) {
                vm.metrostations_by_line.push(data.data[i].name);
              }
              //console.log(data);
              //фильтр по числу комнат и станции метро
              vm.owners = Owners.data.filter(function (owner) {
                 if (n>0 && n <=4) {
                   return (owner.rooms == vm.room_filter && vm.metrostations_by_line.indexOf(owner.metro)>=0)
                 } else {
                   return (owner.rooms > vm.room_filter && vm.metrostations_by_line.indexOf(owner.metro)>=0)
                 }
              });
            });

      } else {
      //console.log(vm.metrostations_by_line);
      //console.log(vm.owners);
      //только фильтр по числу комнат
      vm.owners = Owners.data.filter(function (owner) {
         if (n>0 && n <=4) {
           return (owner.rooms == vm.room_filter);
         } else {
           return (owner.rooms > vm.room_filter);
         }
      });
      //console.log(vm.owners);
      }
		}

    //просмотр объекта
		function viewOwner(id, ev) {
			$mdDialog.show({
          controller         : function ($scope, $mdDialog)
          {
          var viewowner = new api.owners.favownerbyid.query({'id':id},
              function(data) {
              //присваиваем полученные данные
              $scope.owner_data = data;
      		});
          //////////////////////////////////////
              $scope.bookOwner = function ()
              {
                  bookOwner(id);
                  $mdDialog.hide();
              }
              $scope.closeDialog = function ()
              {
                  $mdDialog.hide();
              }
          },
                templateUrl: 'app/modules/my_ownerbase/ownerViewDialog.html',
                parent             : angular.element('body'),
                locals: {
                  owner_data : $scope.owner_data
                },
                //scope: this,
                clickOutsideToClose: true
            });
		}

    //редактирование-обработка
		function editOwner(id, ev) {
      $mdDialog.show({
          controller         : function ($scope, $mdDialog)
          {
          var viewowner = new api.owners.ownerbyid.query({'id':id},
              function(data) {
              //присваиваем полученные данные
              $scope.owner_data = data;
      		});
          //////////////////////////////////////
              $scope.owner_archive = function (owner_id, object_id)
              {
                  $mdDialog.hide();
                  owner_archive(owner_id, object_id);
              }
              $scope.closeDialog = function ()
              {
                  $mdDialog.hide();
              }
          },
                templateUrl: 'app/modules/ownerbase/b_ownerViewDialog.html',
                parent             : angular.element('body'),
                locals: {
                  owner_data : $scope.owner_data
                },
                //scope: this,
                clickOutsideToClose: true
            });
		}

    function archiveFavOwner(id) {
      var archivefavowner = new api.owners.archivefavowner();
      archivefavowner.id = id;
      archivefavowner.$save();

      $mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/my_owners');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Объект скрыт</h1>Теперь он недоступен для просмотра в моей базе собственников</md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
      //вызываем нужный диалог
      //un_success_dialog_bookOwner(id, header_dialog, text_dialog);
		}

    //редактирование поля звонка
    function callFavOwner(id) {
    $mdDialog.show({
          controller         : function ($scope, $mdDialog)
            {
              var viewobject = new api.owners.notebyownerid.query({'id':id},
                function(note) {
                //получаем текст заметки, если есть
                var data = [];
                data.id = id;
                data.calldate_string = note.call_deadline;
                console.log(data.calldate_string);
                console.log(note);
                $scope.object_data = data;
              });

              $scope.closeDialog = function ()
              {
                $mdDialog.hide();
              }
              //сохранить заметку
              $scope.changeCallDate = function (id,date,minutes,agent_description)
              {
                //console.log(date);
                if (minutes>0) {
                  var datet = minutes;
                } else {
                  var datet = Date.parse(date);
                  datet = Math.round(datet/1000);
                }

                if (typeof(agent_description) !== "undefined" && agent_description.length>0) {
                  var concatagentdescription = new api.owners.concatAgentDescription();
                  concatagentdescription.id = id;
                  concatagentdescription.agent_description = agent_description; //datet + ": " +
                  concatagentdescription.$save();
                }

                //console.log(Math.round(datet/1000));
                //console.log(datet.getFullYear());
                var changecalldate = new api.owners.changecalldate();
                changecalldate.id = id;
                changecalldate.date = datet;
                changecalldate.$save();
                $mdDialog.hide();
              }
            },
            templateUrl: 'app/modules/my_ownerbase/favownerEditCallTimeDialog.html',
            parent             : angular.element('body'),
            locals: {
              object_data : $scope.object_data
            },
            clickOutsideToClose: true
        });
    }


    //редактирование поля заметок агента
		function notesFavOwner(id) {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
              var viewobject = new api.owners.notebyownerid.query({'id':id},
                function(note) {
                //получаем текст заметки, если есть
                var data = [];
                data.id = id;
                data.note = note.note;
                // console.log(data);
                // console.log(note);
                $scope.object_data = data;
              });

							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
              //сохранить заметку
              $scope.changeAgentDescription = function (id,text)
							{
                var changeagentdescription = new api.owners.changeAgentDescription();
                changeagentdescription.id = id;
                changeagentdescription.agent_description = text;
                changeagentdescription.$save();
								$mdDialog.hide();
							}
						},
            templateUrl: 'app/modules/my_ownerbase/favownerEditAgentDescriptionDialog.html',
            parent             : angular.element('body'),
            locals: {
              object_data : $scope.object_data
            },
            clickOutsideToClose: true
        });
		}

/*
		function owner_data_by_id(id) {
			api.owners.ownerbyid.get({id:id}, function(data) {
				return data.data;
			});
		}
*/
		//Бронирование
		function bookOwner(id) {
			var server_answer;
			var header_dialog;
			var text_dialog;

			var bookowner = new api.owners.bookowner();
			bookowner.id = id;
			bookowner.my_id = vm.userid;
			bookowner.$save(bookowner, function(responseData) {
				server_answer = responseData.answer;
				//console.log(server_answer);
				if (server_answer=='false') {
					//Неудачное бронирование
					header_dialog = "Объект не забронирован";
					text_dialog = "Кто-то забронировал его до Вас. Обновите таблицу и выберите другой";
				} else {
					header_dialog = "Объект забронирован";
					text_dialog = "Вы забронировали этот объект. Теперь свяжитесь с клиентом и договоритесь о встречи. Если за 3 суток Вы не обработаете бронь, то она будет автоматически снята";
				}
				//вызываем нужный диалог
				un_success_dialog_bookOwner(id, header_dialog, text_dialog, server_answer);
			  }
			);
		}

		//Бронирование / диалог об успехе
		function un_success_dialog_bookOwner(id, header_dialog,text_dialog) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
					////////////////////////////////
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        if (server_answer=='true') editOwner(id);
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>'+header_dialog+'</h1><div>'+text_dialog+'</div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//Снятие брони
		function unbookOwner(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var unbookowner = new api.owners.unbookowner();
					unbookowner.id = id;
					unbookowner.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/owners');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Бронь снята</h1><div>Теперь объект доступен для бронирования другими агентами</div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.deals', ['app.modules.deals.archive','app.modules.deals.newdeal','app.modules.deals.editdeal'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
		$stateProvider.state('app.deals', {
            url    : '/deals',
            views  : {
                'content@app': {
                    templateUrl: 'app/modules/deals/deals.html',
                    controller : 'DealsbaseController as vm'
                }
            },
            resolve: {
                Deals: function (apiResolver)
                {
                    return apiResolver.resolve('deals.deals@get');
                }
            }
        });
        
        msNavigationServiceProvider.saveItem('apps.deals', {
            title : 'Сделки',
            icon  : 'icon-currency-rub',
            state : 'app.deals',
            weight: 6
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.deals')
        .controller('DealsbaseController', DealsbaseController);

    /** @ngInject */
    function DealsbaseController($rootScope, $location, $mdDialog, Deals, api)
    {
        var vm = this;

        // Data
        vm.deals = Deals.data;

        //составляем новый массив объектов с индексами = id объектов
		for (var i=0;i<vm.deals.length;i++) {
			switch(vm.deals[i].status) {
				case '1': vm.deals[i].status = 'Активная'; break
				case '2': vm.deals[i].status = 'Открытая'; break
				case '3': vm.deals[i].status = 'Проведенная'; break
				case '4': vm.deals[i].status = 'Закрытая'; break
				case '5': vm.deals[i].status = 'Развал'; break
			}
		}

    //получаем id своей учетной записи для сверки собственности на объект
    api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
			vm.userid = data.user_id;
		});
		//получаем id своего отдела
        api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
			vm.groupid = data.group_id;
		});

    if ($location.path() == '/deals') {
			vm.archive = false;
		} else if ($location.path() == '/deals/archive') {
			vm.archive = true;
		}

        vm.dtOptions = {
            dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            //rowCallback: rowCallback,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				null,
        { "orderable": false },
				null,
				null,
				null,
				null
			  ],
        "buttons": [
          {
             extend: "print",
             text: "Печать",
             title:  "Список сделок",
             className: "DTBblack",
             exportOptions: {
                 columns: ':visible'
             }
           },
          {
             extend: "excel",
             text: "Сохранить таблицу",
             className: "DTBblack",
             //fileName:  "Список клиентов.xls",
             title:"Список сделок",
             exportOptions: {
                 columns: ':visible'
             }
         },
        ],
			  "order": [0, "desc"]
        };

        // Methods
		vm.adddeal = adddeal;
		vm.editdeal = editdeal;
		vm.archivedeal = archivedeal;
		vm.restoredeal = restoredeal;
		vm.restore_archivedeal = restore_archivedeal;

		//проверка на архив и установка переменной на архив
		vm.Arch = changeArchiveStatus;
		vm.isArch = checkArchiveStatus;


        // Methods
        //////////////////////////////

        function changeArchiveStatus(n) {
			switch(n) {
				case 0: vm.archive = false; break
				case 1: vm.archive = true;	break
			}
		}
        ///////////////////////////////
        function checkArchiveStatus(n) {
			switch(n) {
				case 'icon':
				if (vm.archive == true) {
					return 'icon-arrow-right-bold-circle';
					}
				else {
					return 'icon-delete';
					}
			break
			default:
				if (vm.archive == true) {
					return true;
					}
				else {
					return false;
					}
			break
			}
		}

        //создание сделки
        function adddeal() {
			$location.path('/deal/new');
		}
		//редактирование сделки
		function editdeal(id,type) {
			//для клика по иконке и для двойного клика
			switch(type){
				case 1:	$location.path('/deal/edit/'+id); break
				case 2: $rootScope.$apply(function() {
							$location.path('/deal/edit/'+id);
						});
						break
			}
		}
		function restore_archivedeal(id) {
			if (vm.archive == true) {
				restoredeal(id);
			}
			else {
				archivedeal(id);
			}
		}
		//удаление сделки
		function archivedeal(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var archivedeal = new api.deals.archivedeal();
					archivedeal.id = id;
					archivedeal.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/deals');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Сделка {{id}} отправлена в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//восстановление сделки
		function restoredeal(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var restoredeal = new api.deals.restoredeal();
					restoredeal.id = id;
					restoredeal.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/deals/archive');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Сделка {{id}} восстановлена из архива</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//двойнок клик на строку
		function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			//TODO
			$('td', nRow).unbind('dblclick');
			$('td', nRow).bind('dblclick', function() {
				//если есть право на редакцию
				if (($rootScope.checkRule(19,vm.deals_by_id[aData[0]].group,'group')) || ((vm.deals_by_id[aData[0]].owner == vm.userid) && $rootScope.checkRule(19,'my') && vm.archive == false) || $rootScope.checkRule(19,'all')) {
					editdeal(aData[0],2);
				} else {
				console.log('id '+aData[0]+' group: '+vm.deals_by_id[aData[0]].group);
				$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Нет прав на редактирование этого объекта</h1></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
				}
			});
			return nRow;
		}
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '='
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Edge",
                    versionSearch: "Edge",
                    identity     : "Edge"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Chrome",
                    identity : "Chrome"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "OmniWeb",
                    versionSearch: "OmniWeb/",
                    identity     : "OmniWeb"
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : "Apple",
                    versionSearch: "Version",
                    identity     : "Safari"
                },
                {
                    prop    : $window.opera,
                    identity: "Opera"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "iCab",
                    identity : "iCab"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "KDE",
                    identity : "Konqueror"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Firefox",
                    identity : "Firefox"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "Camino",
                    identity : "Camino"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Netscape",
                    identity : "Netscape"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "MSIE",
                    identity     : "Explorer",
                    versionSearch: "MSIE"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Trident/7",
                    identity     : "Explorer",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Gecko",
                    identity     : "Mozilla",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Mozilla",
                    identity     : "Netscape",
                    versionSearch: "Mozilla"
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: "Win",
                    identity : "Windows"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Mac",
                    identity : "Mac"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Linux",
                    identity : "Linux"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPhone",
                    identity : "iPhone"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPod",
                    identity : "iPod"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPad",
                    identity : "iPad"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Android",
                    identity : "Android"
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) != -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index == -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || "unknown-browser";
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || "unknown-version";
            var os = searchString(osData) || "unknown-os";

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) == -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts.users', ['app.contacts.users.usersarchive','app.contacts.users.newuser', 'app.contacts.users.edituser'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_users', {
            url    : '/contacts/users',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/users/users.html',
                    controller : 'UsersController as vm'
                }
            },
            resolve: {
                Users: function (apiResolver)
                {
                    return apiResolver.resolve('contacts.users@get');
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.users')
        .controller('UsersController', UsersController);

    /** @ngInject */
    function UsersController($rootScope, $scope, $mdDialog, $location, Users, api)
    {
        var vm = this;

        // Data
        vm.users = Users.data;

        //регулярка по отделам
        //$scope.byGroup = '^3 отдел$';


        //составляем новый массив объектов с индексами = id объектов
		for (var i=0;i<vm.users.length;i++) {
			switch(vm.users[i].visa_publish) {
				case 'yes': vm.users[i].visapublish = ''; break
				case 'no': vm.users[i].visapublish = '-outline'; break
			}
		}

        if ($location.path() == '/contacts/users') {
			vm.archive = false;
		} else if ($location.path() == '/contacts/users/archive') {
			vm.archive = true;
		}

        vm.dtOptions = {
            dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            searching: true,
            //rowCallback: rowCallback,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				null,
				null,
				//null,
				//null,
				{ "orderable": false },
				null,
				null,
				null,
				null,
				null
			  ],
        "buttons": [
          {
             extend: "print",
             text: "Печать",
             title:  "Список сотрудников",
             className: "DTBblack",
             exportOptions: {
                 columns: ':visible'
             }
           },
          {
             extend: "excel",
             text: "Сохранить таблицу",
             className: "DTBblack",
             //fileName:  "Список клиентов.xls",
             title:"Список сотрудников",
             exportOptions: {
                 columns: ':visible'
             }
         },
        ]
        };

        // Methods
        vm.addUser = addUser;
		vm.editUser = editUser;
		vm.archiveUser = archiveUser;
		vm.restoreUser = restoreUser;
		vm.restore_archiveUser = restore_archiveUser;
		vm.showSetVisaPError = showSetVisaPError;
		vm.changeVisaP = changeVisaP;
		//проверка на архив и установка переменной на архив
		vm.Arch = changeArchiveStatus;
		vm.isArch = checkArchiveStatus
    //vm.hui = hui;

    /*function hui(){
      console.log($scope.byGroup);$scope.byGroup = '^3 отдел$';console.log($scope.byGroup);
    }

    $scope.weDontLike = function(input, field, regex) {
        var patt = new RegExp(regex);
        var out = [];
        for (var i = 0; i < input.length; i++) {
          console.log(input[i][field]);
          if (patt.test(input[i][field]))
            out.push(input[i]);
        }
        return out;
      };*/


        // Methods
        //////////////////////////////
        //смена состояния визы на публикацию
		function changeVisaP(id,param_value) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var changevisap = new api.contacts.changeVisaPStatus();
					changevisap.id = id;
					changevisap.param_value = param_value;
					changevisap.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Статус визы на публикацию изменен</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		function showSetVisaPError() {
		$mdDialog.show({
					controller         : function ($scope, $mdDialog)
						{
							$scope.closeDialog = function ()
							{
								$mdDialog.hide();
							}
						},
						template: '<md-dialog>' +
						'  <md-dialog-content><h1>Недостаточно прав</h1><div>Для получения или снятия визы на публикацию на сайте обратитесь к начальнику отдела</div></md-dialog-content>' +
						'  <md-dialog-actions>' +
						'    <md-button ng-click="closeDialog()" class="md-primary">' +
						'      Закрыть' +
						'    </md-button>' +
						'  </md-dialog-actions>' +
						'</md-dialog>',
						parent             : angular.element('body'),
						clickOutsideToClose: true
					});
		}

        function changeArchiveStatus(n) {
			switch(n) {
				case 0: vm.archive = false; break
				case 1: vm.archive = true;	break
			}
		}
        ///////////////////////////////
        function checkArchiveStatus(n) {
			switch(n) {
				case 'icon':
				if (vm.archive == true) {
					return 'icon-arrow-right-bold-circle';
					}
				else {
					return 'icon-delete';
					}
			break
			default:
				if (vm.archive == true) {
					return true;
					}
				else {
					return false;
					}
			break
			}
		}

        //создание объекта
        function addUser() {
			$location.path('/contacts/users/new');
		}
		//редактирование объекта
		function editUser(id, type) {
			//для клика по иконке и для двойного клика
			switch(type){
				case 1:	$location.path('/contacts/edit/user/'+id); break
				case 2: $rootScope.$apply(function() {
							$location.path('/contacts/edit/user/'+id);
						});
						break
			}
		}

		function restore_archiveUser(id) {
			if (vm.archive == true) {
				restoreUser(id);
			} else {
				archiveUser(id);
			}
		}

    //диалог с предупреждением об удалении сотрудника
    function archiveUser(id,ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Отправить сотрудника в архив?',
                parent             : '#content',
                textContent        : 'Вместе с сотрудником будут удалены и все его объекты. Убедитесь, что перенесли все необходимое',
                ariaLabel          : 'remove user',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Удалить',
                cancel             : 'Отмена'
            });

            $mdDialog.show(confirm).then(function ()
            {
              archiveUser_action(id);
            }, function ()
            {
              //
            });
        }

		//удаление сотрудника
		function archiveUser_action(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var archiveUser = new api.contacts.archiveUser();
					archiveUser.id = id;
					archiveUser.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/users');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Сотрудник отправлен в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//восстановление сотрудника
		function restoreUser(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var restoreUser = new api.contacts.restoreUser();
					restoreUser.id = id;
					restoreUser.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/users/archive');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Сотрудник восстановлен из архива</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//двойнок клик на строку
		function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			$('td', nRow).unbind('dblclick');
			$('td', nRow).bind('dblclick', function() {
				editUser(aData[0],2);
			});
			return nRow;
		}
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.groups', ['app.contacts.groups.groupsarchive','app.contacts.groups.newgroup', 'app.contacts.groups.editgroup'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_groups', {
            url    : '/contacts/groups',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/groups/groups.html',
                    controller : 'GroupsController as vm'
                }
            },
            resolve: {
                Groups: function (apiResolver)
                {
                    return apiResolver.resolve('contacts.grouplist@get');
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.groups')
        .controller('GroupsController', GroupsController);

    /** @ngInject */
    function GroupsController($rootScope, $location, $mdDialog, api, Groups)
    {
        var vm = this;

        // Data
        vm.groups = Groups.data;

		if ($location.path() == '/contacts/groups') {
			vm.archive = false;
		} else if ($location.path() == '/contacts/groups/archive') {
			vm.archive = true;
		}

        vm.dtOptions = {
            dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            //rowCallback: rowCallback,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				null,
				null,
        { "orderable": false },
				null,
				null
			  ],
        "buttons": [
          {
             extend: "print",
             text: "Печать",
             title:  "Список отделов",
             className: "DTBblack",
             exportOptions: {
                 columns: ':visible'
             }
           },
          {
             extend: "excel",
             text: "Сохранить таблицу",
             className: "DTBblack",
             //fileName:  "Список клиентов.xls",
             title:"Список отделов",
             exportOptions: {
                 columns: ':visible'
             }
         },
        ]
        };
        // Methods
		vm.addGroup = addGroup;
		vm.editGroup = editGroup;
		vm.archiveGroup = archiveGroup;
		vm.restoreGroup = restoreGroup;
		vm.restore_archiveGroup = restore_archiveGroup;
		//проверка на архив и установка переменной на архив
		vm.Arch = changeArchiveStatus;
		vm.isArch = checkArchiveStatus


        // Methods
        //////////////////////////////
        function changeArchiveStatus(n) {
			switch(n) {
				case 0: vm.archive = false; break
				case 1: vm.archive = true;	break
			}
		}
        ///////////////////////////////
        function checkArchiveStatus(n) {
			switch(n) {
				case 'icon':
				if (vm.archive == true) {
					return 'icon-arrow-right-bold-circle';
					}
				else {
					return 'icon-delete';
					}
			break
			default:
				if (vm.archive == true) {
					return true;
					}
				else {
					return false;
					}
			break
			}
		}

        //создание объекта
        function addGroup() {
			$location.path('/contacts/groups/new');
		}
		//редактирование объекта
		function editGroup(id,type) {
			//для клика по иконке и для двойного клика
			switch(type){
				case 1:	$location.path('/contacts/groups/edit/'+id); break
				case 2: $rootScope.$apply(function() {
							$location.path('/contacts/groups/edit/'+id);
						});
						break
				}
		}
		function restore_archiveGroup(id) {
			if (vm.archive == true) {
				restoreGroup(id);
			}
			else {
				archiveGroup(id);
			}
		}
		//удаление объекта
		function archiveGroup(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var archivegroup = new api.contacts.archivegroup();
					archivegroup.id = id;
					archivegroup.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/groups');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Отдел отправлен в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//восстановление объекта
		function restoreGroup(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var restoregroup = new api.contacts.restoregroup();
					restoregroup.id = id;
					restoregroup.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/groups/archive');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Отдел восстановлен из архива</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//двойнок клик на строку
		function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			$('td', nRow).unbind('dblclick');
			$('td', nRow).bind('dblclick', function() {
				editGroup(aData[0],2);
			});
			return nRow;
		}
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients_contragents', ['app.contacts.clients_contragents.clientsarchive','app.contacts.clients_contragents.newclient', 'app.contacts.clients_contragents.editclient'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_contragents', {
            url    : '/contacts/contragents',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/clients_contragents/clients.html',
                    controller : 'CClientsController as vm'
                }
            },
            resolve: {
                Clients: function (apiResolver)
                {
                    return apiResolver.resolve('contacts.contragentslist@get');
                }
            }
        });

        $stateProvider.state('app.contacts_contragents_buyers', {
            url    : '/contacts/contragents_buyers',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/clients_contragents/buyers.html',
                    controller : 'CBuyersController as vm'
                }
            },
            resolve: {
                Clients: function (apiResolver)
                {
                    return apiResolver.resolve('contacts.buyercontragentslist@get', {'my':'true','first':'true', 'isarray':false});
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients_contragents')
        .controller('CClientsController', CClientsController);

    /** @ngInject */
    function CClientsController($rootScope, $location, $mdDialog, api, Clients)
    {
        var vm = this;

        // Data
        vm.clients = Clients.data;

    //function generalClientFunction() {}
    //TODO подумать над тем, стоит ли вынести весь этот функционал в отдельные глобальные функции
    //получаем id своей учетной записи для сверки собственности на объект
    /*
    api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
      vm.userid = data.user_id;
    });

    //получаем id своего отдела
    api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
			vm.groupid = data.group_id;
		});
    //узнаем свою должность
    api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
			vm.positionid = data.position_id;
		});
    */
		//пишем нормальные типы заявок для пользователей
		for (var i=0;i<vm.clients.length;i++) {
			switch(vm.clients[i].type) {
				case 'person': vm.clients[i].type = 'Физ.лицо';
                      //если не свой объект или не своего подчинненого, то не показываем телефон
                      //if ((vm.userid == vm.clients[i].access_id) || (vm.clients[i].group_id == vm.groupid && vm.positionid==1)) {
                      /*if ((vm.userid == vm.clients[i].access_id && $rootScope.checkRule(41,'my')) || (vm.clients[i].group_id == vm.groupid && $rootScope.checkRule(41,'my','group')) || $rootScope.checkRule(41,'all')) {
                          //ничего не делаем
                      } else {
                        //alert(vm.userid + " " + vm.clients[i].access_id);
                        vm.clients[i].phone_1 = '---';
                        vm.clients[i].email = '---';
                      }*/
                      break
				case 'firm': vm.clients[i].type = 'Юр.лицо';
                      //если не свой объект или не своего подчинненого, то не показываем телефон
                      /*if ((vm.userid == vm.clients[i].access_id && $rootScope.checkRule(41,'my')) || (vm.clients[i].group_id == vm.groupid && $rootScope.checkRule(41,'my','group')) || $rootScope.checkRule(41,'all')) {
                          //ничего не делаем
                      } else {
                        vm.clients[i].phone_1 = '---';
                        vm.clients[i].email = '---';
                      }*/
                      break
				case 'mort_broker': vm.clients[i].type = 'Ипотечные брокеры'; break
				case 'evaluation': vm.clients[i].type = 'Оценочные компании'; break
				case 'insurance': vm.clients[i].type = 'Страховые компании'; break
				case 'transactionsbanks': vm.clients[i].type = 'Центры оформления сделок'; break
				case 'rentalagents': vm.clients[i].type = 'Риелторы по аренде'; break
				case 'realtorsagency': vm.clients[i].type = 'Риелторы (Агентства)'; break
				case 'transportcompanies': vm.clients[i].type = 'Переезд (транспортные компании)'; break
				case 'storage': vm.clients[i].type = 'Хранилища вещей'; break
				case 'cleaning': vm.clients[i].type = 'Предпродажная подготовка (чистка, уборка)'; break
				case 'repairs': vm.clients[i].type = 'Бригады по ремонту'; break
				case 'notaries': vm.clients[i].type = 'Нотариусы'; break
				case 'sticker': vm.clients[i].type = 'Расклейщики'; break
				case 'medexamination': vm.clients[i].type = 'Медицинское освидетельствование'; break
				case 'notary_home': vm.clients[i].type = 'Выезд нотариуса на дом'; break
				case 'guardianship': vm.clients[i].type = 'Органы опеки и попечительства'; break
				case 'lawyer': vm.clients[i].type = 'Адвокат (прописка, выписка, суды)'; break
				case 'banks': vm.clients[i].type = 'Банки (аккредитивные сделки)'; break
				case 'references': vm.clients[i].type = 'Справки о не сносе дома и справки из ДЖП (ускорение)'; break
				case 'taxes_consultation': vm.clients[i].type = 'Консультация по налогам'; break
        case 'buyer': vm.clients[i].type = 'Покупатель'; break
				case 'seller': vm.clients[i].type = 'Продавец'; break
			}
			switch(vm.clients[i].status) {
				case 'work': vm.clients[i].status = 'Идет работа'; break
				case 'potential': vm.clients[i].status = 'Потенциальный'; break
				case 'talks': vm.clients[i].status = 'Переговоры'; break
				case 'disclaimer': vm.clients[i].status = 'Отказ'; break
				case 'completed': vm.clients[i].status = 'Работа завершена'; break
				case 'blacklist': vm.clients[i].status = 'Черный список'; break
			}
		}

		if ($location.path() == '/contacts/contragents') {
			vm.archive = false;
		} else if ($location.path() == '/contacts/contragents/archive') {
			vm.archive = true;
		}

        vm.dtOptions = {
            dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            //rowCallback: rowCallback,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				null,
				null,
        { "orderable": false },
				null,
				null,
				null,
				null,
				null
			  ],
        "buttons": [
          {
             extend: "print",
             text: "Печать",
             title:  "Список контрагентов",
             className: "DTBblack",
             exportOptions: {
                 columns: ':visible'
             }
           },
          {
             extend: "excel",
             text: "Сохранить таблицу",
             className: "DTBblack",
             //fileName:  "Список контрагентов.xls",
             title:"Список контрагентов",
             exportOptions: {
                 columns: ':visible'
             }
         },
        ]
        };
        // Methods
		vm.addClient = addClient;
		vm.editClient = editClient;
		vm.archiveClient = archiveClient;
		vm.restoreClient = restoreClient;
		vm.restore_archiveClient = restore_archiveClient;
		//проверка на архив и установка переменной на архив
		vm.Arch = changeArchiveStatus;
		vm.isArch = checkArchiveStatus


        // Methods
        //////////////////////////////
        function changeArchiveStatus(n) {
			switch(n) {
				case 0: vm.archive = false; break
				case 1: vm.archive = true;	break
			}
		}
        ///////////////////////////////
        function checkArchiveStatus(n) {
			switch(n) {
				case 'icon':
				if (vm.archive == true) {
					return 'icon-arrow-right-bold-circle';
					}
				else {
					return 'icon-delete';
					}
			break
			default:
				if (vm.archive == true) {
					return true;
					}
				else {
					return false;
					}
			break
			}
		}

        //создание объекта
        function addClient() {
			$location.path('/contacts/contragents/new');
		}
		//редактирование объекта
		function editClient(id,type) {
			//для клика по иконке и для двойного клика
			switch(type){
				case 1:	$location.path('/contacts/contragents/edit/'+id); break
				case 2: $rootScope.$apply(function() {
							$location.path('/contacts/contragents/edit/'+id);
						});
						break
				}
		}
		function restore_archiveClient(id) {
			if (vm.archive == true) {
				restoreClient(id);
			}
			else {
				archiveClient(id);
			}
		}
		//удаление объекта
		function archiveClient(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var archiveclient = new api.contacts.archiveclient();
					archiveclient.id = id;
					archiveclient.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/contragents');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Контрагент отправлен в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//восстановление объекта
		function restoreClient(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var restoreclient = new api.contacts.restoreclient();
					restoreclient.id = id;
					restoreclient.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/contragents/archive');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Контрагент восстановлен из архива</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//двойнок клик на строку
		function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			$('td', nRow).unbind('dblclick');
			$('td', nRow).bind('dblclick', function() {
				editClient(aData[0],2);
			});
			return nRow;
		}
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients_contragents')
        .controller('CBuyersController', CBuyersController);

    /** @ngInject */
    function CBuyersController($rootScope, $location, $scope, $mdDialog, api, Clients)
    {
        var vm = this;

        // Data
        vm.clients = Clients.data;
        vm.onlyMy = true;
        // if ($location.path() == '/contacts/contragents_buyers') {
    		// 	vm.archive = false;
    		// } else if ($location.path() == '/contacts/contragents_buyers/archive') {
    		// 	vm.archive = true;
    		// }

      //получаем id своей должности
      // api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
      //   vm.positionid = data.position_id;
      //   //получаем список объектов через функцию
      //   //только для риэлторов и их начальников изначально только свои
      //   if (vm.positionid==1 || vm.positionid==7) {
      //     vm.onlyMy = true;
      //     //для риэлторов помечаем галку
      //   } else {
      //     //загружаем в модуле и меняем только, если это необходимо
      //     vm.onlyMy = false;
      //   }
      // });

      //получаем id своей учетной записи для сверки чей клиент
      api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
  			vm.userid = data.user_id;
  		});

    //function generalClientFunction() {}
    //TODO подумать над тем, стоит ли вынести весь этот функционал в отдельные глобальные функции
    //получаем id своей учетной записи для сверки собственности на объект
    /*
    api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
      vm.userid = data.user_id;
    });

    //получаем id своего отдела
    api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
			vm.groupid = data.group_id;
		});
    //узнаем свою должность
    api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
			vm.positionid = data.position_id;
		});
    */
		//пишем нормальные типы заявок для пользователей
		for (var i=0;i<vm.clients.length;i++) {
			switch(vm.clients[i].type) {
				case 'person': vm.clients[i].type = 'Физ.лицо';
                      //если не свой объект или не своего подчинненого, то не показываем телефон
                      //if ((vm.userid == vm.clients[i].access_id) || (vm.clients[i].group_id == vm.groupid && vm.positionid==1)) {
                      /*if ((vm.userid == vm.clients[i].access_id && $rootScope.checkRule(41,'my')) || (vm.clients[i].group_id == vm.groupid && $rootScope.checkRule(41,'my','group')) || $rootScope.checkRule(41,'all')) {
                          //ничего не делаем
                      } else {
                        //alert(vm.userid + " " + vm.clients[i].access_id);
                        vm.clients[i].phone_1 = '---';
                        vm.clients[i].email = '---';
                      }*/
                      break
				case 'firm': vm.clients[i].type = 'Юр.лицо';
                      //если не свой объект или не своего подчинненого, то не показываем телефон
                      /*if ((vm.userid == vm.clients[i].access_id && $rootScope.checkRule(41,'my')) || (vm.clients[i].group_id == vm.groupid && $rootScope.checkRule(41,'my','group')) || $rootScope.checkRule(41,'all')) {
                          //ничего не делаем
                      } else {
                        vm.clients[i].phone_1 = '---';
                        vm.clients[i].email = '---';
                      }*/
                      break
				case 'mort_broker': vm.clients[i].type = 'Ипотечные брокеры'; break
				case 'evaluation': vm.clients[i].type = 'Оценочные компании'; break
				case 'insurance': vm.clients[i].type = 'Страховые компании'; break
				case 'transactionsbanks': vm.clients[i].type = 'Центры оформления сделок'; break
				case 'rentalagents': vm.clients[i].type = 'Риелторы по аренде'; break
				case 'realtorsagency': vm.clients[i].type = 'Риелторы (Агентства)'; break
				case 'transportcompanies': vm.clients[i].type = 'Переезд (транспортные компании)'; break
				case 'storage': vm.clients[i].type = 'Хранилища вещей'; break
				case 'cleaning': vm.clients[i].type = 'Предпродажная подготовка (чистка, уборка)'; break
				case 'repairs': vm.clients[i].type = 'Бригады по ремонту'; break
				case 'notaries': vm.clients[i].type = 'Нотариусы'; break
				case 'sticker': vm.clients[i].type = 'Расклейщики'; break
				case 'medexamination': vm.clients[i].type = 'Медицинское освидетельствование'; break
				case 'notary_home': vm.clients[i].type = 'Выезд нотариуса на дом'; break
				case 'guardianship': vm.clients[i].type = 'Органы опеки и попечительства'; break
				case 'lawyer': vm.clients[i].type = 'Адвокат (прописка, выписка, суды)'; break
				case 'banks': vm.clients[i].type = 'Банки (аккредитивные сделки)'; break
				case 'references': vm.clients[i].type = 'Справки о не сносе дома и справки из ДЖП (ускорение)'; break
				case 'taxes_consultation': vm.clients[i].type = 'Консультация по налогам'; break
        case 'buyer': vm.clients[i].type = 'Покупатель'; break
				case 'seller': vm.clients[i].type = 'Продавец'; break
			}
			switch(vm.clients[i].status) {
				case 'work': vm.clients[i].status = 'Идет работа'; break
				case 'potential': vm.clients[i].status = 'Потенциальный'; break
				case 'talks': vm.clients[i].status = 'Переговоры'; break
				case 'disclaimer': vm.clients[i].status = 'Отказ'; break
				case 'completed': vm.clients[i].status = 'Работа завершена'; break
				case 'blacklist': vm.clients[i].status = 'Черный список'; break
			}
		}

		if ($location.path() == '/contacts/contragents_buyers') {
			vm.archive = false;
		} else if ($location.path() == '/contacts/contragents_buyers/archive') {
			vm.archive = true;
		}

        vm.dtOptions = {
            dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            //rowCallback: rowCallback,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				null,
				null,
        null,
        { "orderable": false },
				null,
				null,
				null,
				null,
        null,
        null,
				null
			  ],
        "buttons": [
          {
             extend: "print",
             text: "Печать",
             title:  "Список покупателей",
             className: "DTBblack",
             exportOptions: {
                 columns: ':visible'
             }
           },
          {
             extend: "excel",
             text: "Сохранить таблицу",
             className: "DTBblack",
             //fileName:  "Список контрагентов.xls",
             title:"Список контрагентов",
             exportOptions: {
                 columns: ':visible'
             }
         },
         {
            text: '↻',
            className: "DTBblackNormal",
            action: function () {
                updateObjectsTable();
            }
          }
        ]
        };
        // Methods
		vm.addClient = addClient;
		vm.editClient = editClient;
		vm.archiveClient = archiveClient;
		vm.restoreClient = restoreClient;
		vm.restore_archiveClient = restore_archiveClient;
		//проверка на архив и установка переменной на архив
		vm.Arch = changeArchiveStatus;
		vm.isArch = checkArchiveStatus
    vm.updateObjectsTable = updateObjectsTable;
    vm.notesClient = notesClient;


        // Methods
        //////////////////////////////

        //////////обновление таблицы
        function updateObjectsTable()
          {
            //в зависимости от страницы, где мы находимся - отдаем нужный запрос
            //архив в переспективе можно превратить в параметр, как onlyMy, сохраняя ссылку
            //TODO унификация в бэкэнде в одну функцию?
            //////////////////////////////
            //обновляем подгруженному списку некоторые столбцы
            if ($location.path()=='/contacts/contragents_buyers') {
              api.contacts.buyercontragentslist.get({'my':vm.onlyMy, 'isarray':false}, function(data) {
                for (var i=0;i<data.data.length;i++) {
                  //console.log(data.data[i]);
                  switch(data.data[i].type) {
                    case 'person': data.data[i].type = 'Физ.лицо';
                                  break
                    case 'firm': data.data[i].type = 'Юр.лицо';
                                  break
                    case 'mort_broker': data.data[i].type = 'Ипотечные брокеры'; break
                    case 'evaluation': data.data[i].type = 'Оценочные компании'; break
                    case 'insurance': data.data[i].type = 'Страховые компании'; break
                    case 'transactionsbanks': data.data[i].type = 'Центры оформления сделок'; break
                    case 'rentalagents': data.data[i].type = 'Риелторы по аренде'; break
                    case 'realtorsagency': data.data[i].type = 'Риелторы (Агентства)'; break
                    case 'transportcompanies': data.data[i].type = 'Переезд (транспортные компании)'; break
                    case 'storage': data.data[i].type = 'Хранилища вещей'; break
                    case 'cleaning': data.data[i].type = 'Предпродажная подготовка (чистка, уборка)'; break
                    case 'repairs': data.data[i].type = 'Бригады по ремонту'; break
                    case 'notaries': data.data[i].type = 'Нотариусы'; break
                    case 'sticker': data.data[i].type = 'Расклейщики'; break
                    case 'medexamination': data.data[i].type = 'Медицинское освидетельствование'; break
                    case 'notary_home': data.data[i].type = 'Выезд нотариуса на дом'; break
                    case 'guardianship': data.data[i].type = 'Органы опеки и попечительства'; break
                    case 'lawyer': data.data[i].type = 'Адвокат (прописка, выписка, суды)'; break
                    case 'banks': data.data[i].type = 'Банки (аккредитивные сделки)'; break
                    case 'references': data.data[i].type = 'Справки о не сносе дома и справки из ДЖП (ускорение)'; break
                    case 'taxes_consultation': data.data[i].type = 'Консультация по налогам'; break
                    case 'buyer': data.data[i].type = 'Покупатель'; break
                    case 'seller': data.data[i].type = 'Продавец'; break
                  }
                  switch(data.data[i].status) {
                    case 'work': data.data[i].status = 'Идет работа'; break
                    case 'potential': data.data[i].status = 'Потенциальный'; break
                    case 'talks': data.data[i].status = 'Переговоры'; break
                    case 'disclaimer': data.data[i].status = 'Отказ'; break
                    case 'completed': data.data[i].status = 'Работа завершена'; break
                    case 'blacklist': data.data[i].status = 'Черный список'; break
                  }
                }
                vm.clients = data.data;
                vm.total = vm.clients.length;
              });
            } else if ($location.path()=='/contacts/contragents_buyers/archive') {
              api.contacts.buyercontragentslistarchive.get({'my':vm.onlyMy, 'isarray':false}, function(data) {
                for (var i=0;i<data.data.length;i++) {
                  //console.log(data.data[i]);
                  switch(data.data[i].type) {
                    case 'person': data.data[i].type = 'Физ.лицо';
                                  break
                    case 'firm': data.data[i].type = 'Юр.лицо';
                                  break
                    case 'mort_broker': data.data[i].type = 'Ипотечные брокеры'; break
                    case 'evaluation': data.data[i].type = 'Оценочные компании'; break
                    case 'insurance': data.data[i].type = 'Страховые компании'; break
                    case 'transactionsbanks': data.data[i].type = 'Центры оформления сделок'; break
                    case 'rentalagents': data.data[i].type = 'Риелторы по аренде'; break
                    case 'realtorsagency': data.data[i].type = 'Риелторы (Агентства)'; break
                    case 'transportcompanies': data.data[i].type = 'Переезд (транспортные компании)'; break
                    case 'storage': data.data[i].type = 'Хранилища вещей'; break
                    case 'cleaning': data.data[i].type = 'Предпродажная подготовка (чистка, уборка)'; break
                    case 'repairs': data.data[i].type = 'Бригады по ремонту'; break
                    case 'notaries': data.data[i].type = 'Нотариусы'; break
                    case 'sticker': data.data[i].type = 'Расклейщики'; break
                    case 'medexamination': data.data[i].type = 'Медицинское освидетельствование'; break
                    case 'notary_home': data.data[i].type = 'Выезд нотариуса на дом'; break
                    case 'guardianship': data.data[i].type = 'Органы опеки и попечительства'; break
                    case 'lawyer': data.data[i].type = 'Адвокат (прописка, выписка, суды)'; break
                    case 'banks': data.data[i].type = 'Банки (аккредитивные сделки)'; break
                    case 'references': data.data[i].type = 'Справки о не сносе дома и справки из ДЖП (ускорение)'; break
                    case 'taxes_consultation': data.data[i].type = 'Консультация по налогам'; break
                    case 'buyer': data.data[i].type = 'Покупатель'; break
                    case 'seller': data.data[i].type = 'Продавец'; break
                  }
                  switch(data.data[i].status) {
                    case 'work': data.data[i].status = 'Идет работа'; break
                    case 'potential': data.data[i].status = 'Потенциальный'; break
                    case 'talks': data.data[i].status = 'Переговоры'; break
                    case 'disclaimer': data.data[i].status = 'Отказ'; break
                    case 'completed': data.data[i].status = 'Работа завершена'; break
                    case 'blacklist': data.data[i].status = 'Черный список'; break
                  }
                }
                vm.clients = data.data;
                vm.total = vm.clients.length;
              });
              // console.log(vm.total);
              // console.log(vm.clients.length);

            }
          }


          //редактирование поля заметок по покупателю
          function notesClient(id) {
          $mdDialog.show({
                controller         : function ($scope, $mdDialog)
                  {
                    var viewobject = new api.contacts.notebyclientid.query({'id':id},
                      function(note) {
                      //получаем текст заметки, если есть
                      var data = [];
                      data.id = id;
                      data.description = note.description;
                      // console.log(data);
                      // console.log(note);
                      $scope.object_data = data;
                    });

                    $scope.closeDialog = function ()
                    {
                      $mdDialog.hide();
                    }
                    //сохранить заметку
                    $scope.changeAgentDescription = function (id,text)
                    {
                      var changeagentdescription = new api.contacts.changeAgentDescription();
                      changeagentdescription.id = id;
                      changeagentdescription.description = text;
                      changeagentdescription.$save();
                      $mdDialog.hide();
                    }
                  },
                  templateUrl: 'app/contacts/clients_contragents/clientEditAgentDescriptionDialog.html',
                  parent             : angular.element('body'),
                  locals: {
                    object_data : $scope.object_data
                  },
                  clickOutsideToClose: true
              });
          }

        // Methods
        //////////////////////////////
        function changeArchiveStatus(n) {
			switch(n) {
				case 0: vm.archive = false; break
				case 1: vm.archive = true;	break
			}
		}
        ///////////////////////////////
        function checkArchiveStatus(n) {
			switch(n) {
				case 'icon':
				if (vm.archive == true) {
					return 'icon-arrow-right-bold-circle';
					}
				else {
					return 'icon-delete';
					}
			break
			default:
				if (vm.archive == true) {
					return true;
					}
				else {
					return false;
					}
			break
			}
		}

    //создание объекта
    function addClient() {
			$location.path('/contacts/contragents/new').search({isBuyer:"Y"});
		}
		//редактирование объекта
		function editClient(id,type) {
			//для клика по иконке и для двойного клика
			switch(type){
				case 1:	$location.path('/contacts/contragents/edit/'+id).search({isBuyer:"Y"}); break
				case 2: $rootScope.$apply(function() {
							$location.path('/contacts/contragents/edit/'+id).search({isBuyer:"Y"});
						});
						break
				}
		}
		function restore_archiveClient(id) {
			if (vm.archive == true) {
				restoreClient(id);
			}
			else {
				archiveClient(id);
			}
		}
		//удаление объекта
		function archiveClient(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var archiveclient = new api.contacts.archiveclient();
					archiveclient.id = id;
					archiveclient.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/contragents_buyers');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Контрагент отправлен в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//восстановление объекта
		function restoreClient(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var restoreclient = new api.contacts.restoreclient();
					restoreclient.id = id;
					restoreclient.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/contragents_buyers/archive');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Контрагент восстановлен из архива</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//двойнок клик на строку
		function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			$('td', nRow).unbind('dblclick');
			$('td', nRow).bind('dblclick', function() {
				editClient(aData[0],2);
			});
			return nRow;
		}
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients', ['app.contacts.clients.clientsarchive','app.contacts.clients.newclient', 'app.contacts.clients.editclient'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_clients', {
            url    : '/contacts/clients',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/clients/clients.html',
                    controller : 'ClientsController as vm'
                }
            },
            resolve: {
                Clients: function (apiResolver)
                {
                    return apiResolver.resolve('contacts.clientslist@get');
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients')
        .controller('ClientsController', ClientsController);

    /** @ngInject */
    function ClientsController($rootScope, $location, $mdDialog, api, Clients)
    {
        var vm = this;

        // Data
        vm.clients = Clients.data;

    //function generalClientFunction() {}
    //TODO подумать над тем, стоит ли вынести весь этот функционал в отдельные глобальные функции
    //получаем id своей учетной записи для сверки собственности на объект

    api.toolbar.userid.get({username:$rootScope.cookies_username}, function(data) {
      vm.userid = data.user_id;
    });

    //получаем id своего отдела
    api.toolbar.groupid.get({username:$rootScope.cookies_username}, function(data) {
			vm.groupid = data.group_id;
		});
    /*
    //узнаем свою должность
    api.toolbar.positionid.get({username:$rootScope.cookies_username}, function(data) {
			vm.positionid = data.position_id;
		});
    */
		//пишем нормальные типы заявок для пользователей
		for (var i=0;i<vm.clients.length;i++) {
			switch(vm.clients[i].type) {
				case 'person': vm.clients[i].type = 'Физ.лицо';
                      //если не свой объект или не своего подчинненого, то не показываем телефон
                      //if ((vm.userid == vm.clients[i].access_id) || (vm.clients[i].group_id == vm.groupid && vm.positionid==1)) {
                      /*if ((vm.userid == vm.clients[i].access_id && $rootScope.checkRule(41,'my')) || (vm.clients[i].group_id == vm.groupid && $rootScope.checkRule(41,'my','group')) || $rootScope.checkRule(41,'all')) {
                          //ничего не делаем
                      } else {
                        //alert(vm.userid + " " + vm.clients[i].access_id);
                        vm.clients[i].phone_1 = '---';
                        vm.clients[i].email = '---';
                      }*/
                      break
				case 'firm': vm.clients[i].type = 'Юр.лицо';
                      //если не свой объект или не своего подчинненого, то не показываем телефон
                      /*if ((vm.userid == vm.clients[i].access_id && $rootScope.checkRule(41,'my')) || (vm.clients[i].group_id == vm.groupid && $rootScope.checkRule(41,'my','group')) || $rootScope.checkRule(41,'all')) {
                          //ничего не делаем
                      } else {
                        vm.clients[i].phone_1 = '---';
                        vm.clients[i].email = '---';
                      }*/
                      break
				case 'mort_broker': vm.clients[i].type = 'Ипотечные брокеры'; break
				case 'evaluation': vm.clients[i].type = 'Оценочные компании'; break
				case 'insurance': vm.clients[i].type = 'Страховые компании'; break
				case 'transactionsbanks': vm.clients[i].type = 'Центры оформления сделок'; break
				case 'rentalagents': vm.clients[i].type = 'Риелторы по аренде'; break
				case 'realtorsagency': vm.clients[i].type = 'Риелторы (Агентства)'; break
				case 'transportcompanies': vm.clients[i].type = 'Переезд (транспортные компании)'; break
				case 'storage': vm.clients[i].type = 'Хранилища вещей'; break
				case 'cleaning': vm.clients[i].type = 'Предпродажная подготовка (чистка, уборка)'; break
				case 'repairs': vm.clients[i].type = 'Бригады по ремонту'; break
				case 'notaries': vm.clients[i].type = 'Нотариусы'; break
				case 'sticker': vm.clients[i].type = 'Расклейщики'; break
				case 'medexamination': vm.clients[i].type = 'Медицинское освидетельствование'; break
				case 'notary_home': vm.clients[i].type = 'Выезд нотариуса на дом'; break
				case 'guardianship': vm.clients[i].type = 'Органы опеки и попечительства'; break
				case 'lawyer': vm.clients[i].type = 'Адвокат (прописка, выписка, суды)'; break
				case 'banks': vm.clients[i].type = 'Банки (аккредитивные сделки)'; break
				case 'references': vm.clients[i].type = 'Справки о не сносе дома и справки из ДЖП (ускорение)'; break
				case 'taxes_consultation': vm.clients[i].type = 'Консультация по налогам'; break
        case 'buyer': vm.clients[i].type = 'Покупатель'; break
				case 'seller': vm.clients[i].type = 'Продавец'; break
			}
			switch(vm.clients[i].status) {
				case 'work': vm.clients[i].status = 'Идет работа'; break
				case 'potential': vm.clients[i].status = 'Потенциальный'; break
				case 'talks': vm.clients[i].status = 'Переговоры'; break
				case 'disclaimer': vm.clients[i].status = 'Отказ'; break
				case 'completed': vm.clients[i].status = 'Работа завершена'; break
				case 'blacklist': vm.clients[i].status = 'Черный список'; break
			}
		}

		if ($location.path() == '/contacts/clients') {
			vm.archive = false;
		} else if ($location.path() == '/contacts/clients/archive') {
			vm.archive = true;
		}

        vm.dtOptions = {
            dom       : '<"top"Bf>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            //dom       : 'Bfrtip',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true,
            pageLength: 100,
            //rowCallback: rowCallback,
            oLanguage: {
				sUrl:"/assets/datatables.lang"
			},
			"columns": [
				null,
				null,
        { "orderable": false },
				null,
				null,
				null,
				null,
				null
      ],
      "buttons": [
        {
           extend: "print",
           text: "Печать",
           title:  "Список клиентов",
           className: "DTBblack",
           exportOptions: {
               columns: ':visible'
           }
         },
        {
           extend: "excel",
           text: "Сохранить таблицу",
           className: "DTBblack",
           //fileName:  "Список клиентов.xls",
           title:"Список клиентов",
           exportOptions: {
               columns: ':visible'
           }
       },
      ]
        };
        // Methods
		vm.addClient = addClient;
		vm.editClient = editClient;
		vm.archiveClient = archiveClient;
		vm.restoreClient = restoreClient;
		vm.restore_archiveClient = restore_archiveClient;
		//проверка на архив и установка переменной на архив
		vm.Arch = changeArchiveStatus;
		vm.isArch = checkArchiveStatus


        // Methods
        //////////////////////////////
        function changeArchiveStatus(n) {
			switch(n) {
				case 0: vm.archive = false; break
				case 1: vm.archive = true;	break
			}
		}
        ///////////////////////////////
        function checkArchiveStatus(n) {
			switch(n) {
				case 'icon':
				if (vm.archive == true) {
					return 'icon-arrow-right-bold-circle';
					}
				else {
					return 'icon-delete';
					}
			break
			default:
				if (vm.archive == true) {
					return true;
					}
				else {
					return false;
					}
			break
			}
		}

        //создание объекта
        function addClient() {
			$location.path('/contacts/clients/new');
		}
		//редактирование объекта
		function editClient(id,type) {
			//для клика по иконке и для двойного клика
			switch(type){
				case 1:	$location.path('/contacts/clients/edit/'+id); break
				case 2: $rootScope.$apply(function() {
							$location.path('/contacts/clients/edit/'+id);
						});
						break
				}
		}
		function restore_archiveClient(id) {
			if (vm.archive == true) {
				restoreClient(id);
			}
			else {
				archiveClient(id);
			}
		}
		//удаление объекта
		function archiveClient(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var archiveclient = new api.contacts.archiveclient();
					archiveclient.id = id;
					archiveclient.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/clients');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Клиент отправлен в архив</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}
		//восстановление объекта
		function restoreClient(id) {
			$mdDialog.show({
                controller         : function ($scope, $mdDialog)
                {
                    var restoreclient = new api.contacts.restoreclient();
					restoreclient.id = id;
					restoreclient.$save();

                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                        $location.path('/contacts/clients/archive');
                    }
                },
                template: '<md-dialog>' +
                '  <md-dialog-content><h1>Клиент восстановлен из архива</h1></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Закрыть' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                clickOutsideToClose: true
            });
		}

		//двойнок клик на строку
		function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			$('td', nRow).unbind('dblclick');
			$('td', nRow).bind('dblclick', function() {
				editClient(aData[0],2);
			});
			return nRow;
		}
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($httpProvider, $stateProvider, $translatePartialLoaderProvider)
    {        
        $httpProvider.defaults.useXDomain = true;

        // Translation
        $translatePartialLoaderProvider.addPart('app/toolbar');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($http, $location, $rootScope, $scope, $mdSidenav, $mdDialog, $translate, $mdToast, $timeout, api)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

		api.toolbar.username.get({username:$rootScope.cookies_username}, function(data) {
			vm.username = data.username;
		});

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            ru: {
                'title'      : 'Русский',
                'translation': 'TOOLBAR.RUSSIAN',
                'code'       : 'ru',
                'flag'       : 'ru'
            },
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'en'
            }

        };

        // vm.remindersList = [];
        //
        // console.log('Check is need u to call client...');
        // //заодно проверяем не нужно ли совершить звонок и вывести напоминание
        // api.owners.checkReminders.get({username:$rootScope.cookies_username}, function(data) {
        //   if (data.calls.length>0) {
        //     for (var iter=0; iter<data.calls.length;iter++) {
        //     //console.log('RemindCallDialog', data.calls[iter]);
        //     vm.remindersList.push(data.calls[iter]);
        //       }
        //   }
        // });
        // api.objects.checkReminders.get({username:$rootScope.cookies_username}, function(data) {
        //   //$rootScope.access_rules = data.answer;
        //   //отладочная информация
        //   //console.log(data.calls.length);
        //   if (data.calls.length>0) {
        //     for (var iter=0; iter<data.calls.length;iter++) {
        //     //console.log('RemindCallDialog', data.calls[iter]);
        //     vm.remindersList.push(data.calls[iter]);
        //     }
        //   }
        // });

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        //vm.ifExistsReminders = checkReminders;


        //////////

        init();

        //список напоминаний в главном скоупе
        vm.showReminders = function showReminders() {
          $mdDialog.show({
                controller         : function ($scope, $mdDialog)
                  {
                    //console.log($rootScope.remindersList.length);
                    $scope.remindersList = $rootScope.remindersList;
                    $scope.closeDialog = function ()
                    {
                      $mdDialog.hide();
                    }

                    $scope.searchReminder = function (reminder) {
                      //console.log(a);
                      $scope.closeDialog();
                      if (reminder.remindType == 'object') {
                        if ($location.path()=='/objects/flats') {
                          //kostyl
                          $location.path('/calendar');
                          $timeout(function() {
                            $location.path('/objects/flats').search({showId:reminder.id});
                          }, 500);
                        } else {
                          $location.path('/objects/flats').search({showId:reminder.id});
                        }
                      } else  {
                        if ($location.path()=='/my_owners') {
                          //kostyl
                          $location.path('/calendar');
                          $timeout(function() {
                            $location.path('/my_owners').search({showId:reminder.owner_id});
                          }, 500);
                        } else {
                          $location.path('/my_owners').search({showId:reminder.owner_id});
                        }
                      }
                    }
                  },
                  templateUrl: 'app/objects/objectsRemindersDialog.html',
                  parent             : angular.element('body'),
                  locals: {
                    remindersList : $scope.remindersList
                  },
                  clickOutsideToClose: true
              });
        }


        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
        //удаляем куки
        var $cookies;

  			  angular.injector(['ngCookies']).invoke([
  				 '$cookies', function (_$cookies)
  			 	 {
  				 	$cookies = _$cookies;
  				 }
  			  ]);

          $location.path('/login');
    			$cookies.remove('username');
    			$cookies.remove('password');
          $cookies.remove('loginhash');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            /*if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }*/

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(api)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        api.quickPanel.activities.get({}, function (response)
        {
            vm.activities = response.data;
        });

        api.quickPanel.events.get({}, function (response)
        {
            vm.events = response.data;
        });

        api.quickPanel.notes.get({}, function (response)
        {
            vm.notes = response.data;
        });

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active')
        })
    }

})();
(function ()
{
    'use strict';

  //  var rCabinet = function() {

      /**
       * Main module of the Fuse
       */
      angular
          .module('fuse', [
              // Core
              'app.core',

              // Navigation
              'app.navigation',

              // Toolbar
              'app.toolbar',

              // Quick panel
              //'app.quick-panel',

              // Apps
              'app.calendar',
              'app.mail',
              'app.loginpage',
              'app.objects',
              //'app.ownerbase',
              'app.modules',
              //папки сами по себе проблемно работали. сделки, заявки, база собственников внесены в modules
              //'app.deals',
              'app.contacts',
              //'app.dashboards',
              //'app.file-manager',
              //'app.scrumboard',
              //'app.todo',
  			//позже отчеты должны быть
              // Pages
              //'app.pages',

              // User Interface
              //'app.ui',

              // Components
              //'app.components'
              'ngRoute',
              'angular-md5'
          ]).config(config)
  		  .run(['$rootScope', '$location', '$http', '$resource', 'md5', 'api', '$mdDialog', runBlock])
        .filter('regex', function() {
          return function(input, field, regex) {
            var patt = new RegExp(regex);
            var out = [];
            for (var i = 0; i < input.length; i++) {
              if (patt.test(input[i][field]))
                out.push(input[i]);
            }
            return out;
          };
        });

    /** @ngInject */
    function config()
    {

  	}

  	function runBlock($rootScope, $location, $http, $resource, md5, api, $mdDialog) {
  		var check_auth_status = false;
  		//по умолчанию права пустые
  		$rootScope.access_rules = {};

  		var $cookies;
  			angular.injector(['ngCookies']).invoke([
  				'$cookies', function (_$cookies)
  				{
  					$cookies = _$cookies;
  				}
  			]);

  		//записываем кукис в глобальную переменную
  		$rootScope.cookies_username = $cookies.get('username') || {};
  		$rootScope.cookies_password = $cookies.get('password') || {};
      $rootScope.cookies_loginhash = $cookies.get('loginhash') || {};

          //в главном модуле проверяем куки пользователя при попытке сменить состояние
          //если нет правильных кукисов - редиректим на страницу логина
          $rootScope.$on('$locationChangeStart', function (event, next, current) {

  			//кукис не пусты
  			if (!angular.equals({}, $rootScope.cookies_username) && !angular.equals({}, $rootScope.cookies_password)) {
  				console.log('Auth cookies exists. Checking...');

          //при смене состояния проверяем правильность
          //делаем локальную проверку, чтобы не нагружать излишне браузер и сервер
          if ($rootScope.cookies_loginhash == md5.createHash($rootScope.cookies_username + api.domain_name + $rootScope.cookies_password)) {
              //////////////////
              console.log('Local cookies check... ok');
              check_auth_status = true;
              //при смене состояния получаем права пользователя
              api.auth_info.checkRules.get({username:$rootScope.cookies_username}, function(data) {
                console.log('Access Rules was loaded');
                $rootScope.access_rules = data.answer;
                //отладочная информация
                console.log($rootScope.access_rules);
              });

              //если залогинен, но просто зашел (например, с вкладки) на главную страницу
    					if ($location.path() == '/login') {
    						console.log('You are login yet! Redirect');
    						$location.path('/calendar');
    					}
              ////////////////
          } else {
    				//если нет локального отпечатка, то проверяем на сервере
    				api.auth_info.checkAccess.get({username:$rootScope.cookies_username, password:$rootScope.cookies_password}, function(data) {
    				if (data.answer!=='true') {
    					//логин-пароль не верны
    					//если существующие кукис не проходят проверку, то редиректим назад на логин
    					//попытка взлома или в этот момент сменили пароль
    					console.log('Wrong auth cookies! Redirect');
    					if ($location.path() !== '/login') {
    						$location.path('/login');
    					}
    				} else if (data.answer==='true') {
    					//
    					check_auth_status = true;
    					//при смене состояния получаем права пользователя
    					api.auth_info.checkRules.get({username:$rootScope.cookies_username}, function(data) {
    						console.log('Access Rules was loaded');
    						$rootScope.access_rules = data.answer;
    						//отладочная информация
    						console.log($rootScope.access_rules);
    					});
    					//если залогинен, но просто зашел (например, с вкладки) на главную страницу
    					if ($location.path() == '/login') {
    						console.log('You are login yet! Redirect');
    						$location.path('/calendar');
    					}

              //заодно проверяем не нужно ли совершить звонок и вывести напоминание
              // api.owners.checkReminders.get({username:$rootScope.cookies_username}, function(data) {
              //   console.log('Check is need u to call client...');
              //   //$rootScope.access_rules = data.answer;
              //   //отладочная информация
              //   //console.log(data.calls.length);
              //   if (data.calls.length>0) {
              //     for (var iter=0; iter<data.calls.length;iter++) {
              //
              //     var fav_owner = data.calls[iter];
              //     //console.log('RemindCallDialog', data.calls[iter]);
              //
              //     alert("Напоминание! Позвоните собственнику #"+fav_owner.owner_id+". Телефон: "+fav_owner.phone+". Подробнее в Моя база собственников");
              //       }
              //   }
              // });
              // api.objects.checkReminders.get({username:$rootScope.cookies_username}, function(data) {
              //   console.log('Check is need u to call client...');
              //   //$rootScope.access_rules = data.answer;
              //   //отладочная информация
              //   //console.log(data.calls.length);
              //   if (data.calls.length>0) {
              //     for (var iter=0; iter<data.calls.length;iter++) {
              //
              //     var object_call = data.calls[iter];
              //     //console.log('RemindCallDialog', data.calls[iter]);
              //
              //     alert("Напоминание! Позвоните клиенту по объекту #"+object_call.id+". Телефон: +7"+object_call.phone+". Подробнее в разделе Квартиры");
              //     }
              //   }
              // });
    				}
    				});
          //конец локальной проверки
          }
  			} else {
  				//кукис нет - редиректим, заставляем ввести логин-пароль
  				console.log('Auth cookies doesn\'t exists. Enter login/password');
  				if ($location.path() !== '/login') {
  					$location.path('/login');
  				}
  			}
  		});

      $rootScope.remindersList = [];

      console.log('Check is need u to call client...');
      //заодно проверяем не нужно ли совершить звонок и вывести напоминание
      api.owners.checkReminders.get({username:$rootScope.cookies_username}, function(data) {
        if (data.calls !== undefined && data.calls !== null && data.calls.length>0) {
          for (var iter=0; iter<data.calls.length;iter++) {
          //console.log('RemindCallDialog', data.calls[iter]);
          data.calls[iter].remindType = 'owner';
          $rootScope.remindersList.push(data.calls[iter]);
          }
        }
      });



      api.objects.checkReminders.get({username:$rootScope.cookies_username}, function(data) {
        //$rootScope.access_rules = data.answer;
        //отладочная информация
        //console.log(data.calls.length);
        if (data.calls !== undefined && data.calls !== null && data.calls.length>0) {
          for (var iter=0; iter<data.calls.length;iter++) {
          //console.log('RemindCallDialog', data.calls[iter]);
          data.calls[iter].remindType = 'object';
          $rootScope.remindersList.push(data.calls[iter]);
          }
        }
      });

      $rootScope.ifExistsReminders = function checkReminders(n) {
        // console.log($rootScope.remindersList);
        // console.log($rootScope.remindersList.length);
        switch(n) {
          case 'icon':
          if ($rootScope.remindersList.length > 0) {
            return 'icon-phone-forward';
            }
          else {
            return 'icon-phone-paused';
            }
        break
        case 'color':
        if ($rootScope.remindersList.length > 0) {
          return 'md-warn';
          }
        else {
          return '';
          }
      breakd
      case 'phrase':
      if ($rootScope.remindersList.length > 0) {
        return 'Есть новые задачи';
        }
      else {
        return '';
        }
    break
        default:
        break
        }
      };

  		//функция для удобства пользования правами
      $rootScope.checkRule = function(rule_id, object_to, object_type) {
        var answer = false;

        if (rule_id in $rootScope.access_rules && check_auth_status==true) {
          //кросс-права и разбор массива прав
          for (var i=0; i<$rootScope.access_rules[rule_id].length;i++) {
            if (object_type=='group') {
              //преобразуем свою группу в ее id
              //if (object_to=='my')
              if ($rootScope.access_rules[rule_id][i]['object_to_type']=='group' && $rootScope.access_rules[rule_id][i]['object_to']==object_to) {
                answer = true;
                break;
              }
            } else {
              if ($rootScope.access_rules[rule_id][i]['object_to']==object_to) {
                answer = true;
                break;
              }
            }
          }
        } else {
            //console.log('No rule '+rule_id);
        }
        return answer;
      }
      /*
  		$rootScope.checkRule = function(rule_id, object_to, object_type) {
  			var answer = false;

  			if (rule_id in $rootScope.access_rules && check_auth_status==true) {
  				if (object_type=='group') {
  					//TODO несколько прав одного типа. Кросс-права
  					if ($rootScope.access_rules[rule_id]['object_to_type']=='group' && $rootScope.access_rules[rule_id]['object_to']==object_to) answer = true;
  				} else {
  					if ($rootScope.access_rules[rule_id]['object_to']==object_to) answer = true;
  				}
  			} else {
  			    //console.log('No rule '+rule_id);
  			}

  			return answer;
  		}*/

  		////////////////////
  		//если обновили страницу и еще не меняли состояние, но залогинен
  		//получаем права
  		/*if (check_auth_status==true) {
  			api.auth_info.checkRules.get({username:$rootScope.cookies_username}, function(data) {
  							console.log('Access Rules was loaded');
  							$rootScope.access_rules = data.answer;
  							//отладочная информация
  							console.log($rootScope.access_rules);
  						});
  	   }*/


      }


//};
 //window.onload = rCabinet;



})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.loginpage', ['angular-md5'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.loginpage', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.loginpage': {
                    templateUrl: 'app/loginpage/loginpage.html',
                    controller : 'LoginController as vm'
                }
            },            
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/loginpage');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.loginpage')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($http, $scope, $rootScope, $mdSidenav, $translate, $mdToast, $location, md5, api)
    {
        // Data
		var vm = this;
		vm.do_login = do_login;
        // Methods
        function do_login(email,password, rememberme) {
      		 var $cookies;
               angular.injector(['ngCookies']).invoke([
                  '$cookies', function (_$cookies)
                  {
                      $cookies = _$cookies;
                  }
               ]);
              //создание кукис из ангуляр
              //создаем куки для проверки авторизации

              ///////////////////////
              //запомнить меня
              if (rememberme===true) {
                var expireDate = new Date();
                expireDate.setDate(expireDate.getDate() + 7);

                $cookies.put('username', email, {'expires':expireDate});
                //(2x)md5
                $cookies.put('password', md5.createHash(md5.createHash(password)), {'expires':expireDate});
                //для локальной проверки авторизации
                $cookies.put('loginhash', md5.createHash(email + api.domain_name + md5.createHash(md5.createHash(password))), {'expires':expireDate});
                /////////////////////////
              } else {
                $cookies.put('username', email);
                //(2x)md5
                $cookies.put('password', md5.createHash(md5.createHash(password)));
                //для локальной проверки авторизации
                $cookies.put('loginhash', md5.createHash(email + api.domain_name + md5.createHash(md5.createHash(password))));
              }

              //записываем кукис в глобальную переменную
      		$rootScope.cookies_username = $cookies.get('username') || {};
      		$rootScope.cookies_password = $cookies.get('password') || {};

      		api.auth_info.checkAccess.get({username:$rootScope.cookies_username, password:$rootScope.cookies_password}, function(data) {
      			if (data.answer=='true') {
      				//логин-пароль верны
      				//просто редирект на календарь
      				$location.path('/calendar');
      			} else {
        				//показываем ошибку
        				$scope.loginForm.password.$error = {
        				  "wrongpassword": true
        				}
      				}
      		});
		}

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, uiGmapGoogleMapApiProvider, $translateProvider, $provide, fuseConfigProvider)
    {
        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Enable debug logging
        $logProvider.debugEnabled(true);

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            //    key: 'your api key',
            v        : '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('ru');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.quote.iconclass = 'icon-format-quote';

                return taTools;
            }
        ]);

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });
    }
})();

(function ()
{
    'use strict';

    // var rCabinet = function() {

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        })
    }
  // };
  //  window.onload = rCabinet;

})();

(function ()
{
    'use strict';

    // var rCabinet = function() {

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }/*,
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }*/
                }
            });
    }

  // };
  //  window.onload = rCabinet;

})();

(function ()
{
    'use strict';

  //  var rCabinet = function() {

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, md5, api)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }

//  };
//   window.onload = rCabinet;

})();

(function ()
{
    'use strict';

  //  var rCabinet = function() {

    angular
        .module('fuse');

//      };
  //     window.onload = rCabinet;


})();

(function ()
{
    'use strict';

//    var rCabinet = function() {

    angular
        .module('fuse').config(config);

    /** @ngInject */
    function config()
    {
        // Put your custom configurations here

    }

//  };
//   window.onload = rCabinet;

})();

(function ()
{
    'use strict';

  //  var rCabinet = function() {

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allows you to
         * add hardcoded parameters to your API calls that you want them to be sent every
         * time you make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *          list     : $resource('http://api.example.com/blog);
         *          getById  : $resource('http://api.example.com/blog/:id', {id: '@id'});
         *          getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'},
         *              'get': {method: 'GET', params: {getByDate: true}}
         *          );
         *      }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource servive, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';
        api.localhost_backend = 'functions/'; //server.js gulp - proxy
        api.localhost_uploads = 'uploads/';
        api.localhost_images = 'images/';
        //фотографии хранятся не в папке с CRM
        //nginx выдает их по адресу домен/images
        //переменные для вывода фотографий
        //api.domain_name = 'http://s-r-dom.ru/';
        api.domain_name = 'https://1fo.ru/';
        //api.domain_name = 'http://192.168.242.133:3000/';
        //api.domain_images = 'functions/images/';
        api.domain_images = 'images/';
        //$resource('http://localhost:port/functions/', {port:3000}
        //заменить на (проблемы с прокси и htaccess при разработке)
        //$resource(api.localhost_backend, {}

        api.dashboard = {
            project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
            server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
            analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
        };

        api.cards = $resource(api.baseUrl + 'cards/cards.json');

        api.fileManager = {
            documents: $resource(api.baseUrl + 'file-manager/documents.json')
        };

        api.icons = $resource('assets/icons/selection.json');

        api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

        api.mail = {
            //inbox: $resource(api.baseUrl + 'mail/inbox.json')
            inbox: $resource(api.localhost_backend + 'messages', {}, {query: {method: 'POST'}})
        };

        api.profile = {
            timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
            about       : $resource(api.baseUrl + 'profile/about.json'),
            photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
        };

        api.quickPanel = {
            activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
            contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
            events    : $resource(api.baseUrl + 'quick-panel/events.json'),
            notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
        };

        api.search = {
            classic : $resource(api.baseUrl + 'search/classic.json'),
            mails   : $resource(api.baseUrl + 'search/mails.json'),
            users   : $resource(api.baseUrl + 'search/users.json'),
            contacts: $resource(api.baseUrl + 'search/contacts.json')
        };

        api.scrumboard = {
            boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
            board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
        };

        api.tables = {
            employees   : $resource(api.baseUrl + 'tables/employees.json'),
            employees100: $resource(api.baseUrl + 'tables/employees100.json')
        };

        api.timeline = {
            page1: $resource(api.baseUrl + 'timeline/page-1.json'),
            page2: $resource(api.baseUrl + 'timeline/page-2.json'),
            page3: $resource(api.baseUrl + 'timeline/page-3.json')
        };

        api.todo = {
            tasks: $resource(api.baseUrl + 'todo/tasks.json'),
            tags : $resource(api.baseUrl + 'todo/tags.json')
        };

        api.toolbar = {
            username: $resource(api.localhost_backend + 'myname', {}, {query: {method: 'POST'}}),
            userid: $resource(api.localhost_backend + 'myid', {}, {query: {method: 'POST'}}),
            groupid: $resource(api.localhost_backend + 'mygroup', {}, {query: {method: 'POST'}}),
            positionid: $resource(api.localhost_backend + 'myposition', {}, {query: {method: 'POST'}}),
        };

        api.auth_info = {
            checkAccess: $resource(api.localhost_backend + 'user/login', {}, {query: {method: 'POST'}}),
            checkRules: $resource(api.localhost_backend + 'user/access', {}, {query: {method: 'POST'}})
        };

        api.calendar = {
            events: $resource(api.localhost_backend + 'calendar', {}, {query: {method: 'GET'}})
        };


    api.requests = {
			list: $resource(api.localhost_backend + 'requests/list', {}, {query: {method: 'POST'}}),
			listarchive: $resource(api.localhost_backend + 'requests/list/archive', {}, {query: {method: 'POST'}}),
			requestbyid: $resource(api.localhost_backend + 'requestbyid', {}, {query: {method: 'GET'}}),
			editrequest: $resource(api.localhost_backend + 'request/archive'),
			bookrequest: $resource(api.localhost_backend + 'requests/book'),
			unbookrequest: $resource(api.localhost_backend + 'requests/unbook'),
		}

    api.owners = {
			list: $resource(api.localhost_backend + 'owners/list', {}, {query: {method: 'POST'}}),
      favorites: $resource(api.localhost_backend + 'owners/favorites', {}, {query: {method: 'POST'}}),
			ownerbyid: $resource(api.localhost_backend + 'ownerbyid', {}, {query: {method: 'GET'}}),
      favownerbyid: $resource(api.localhost_backend + 'favownerbyid', {}, {query: {method: 'GET'}}),
			archiveowner: $resource(api.localhost_backend + 'owner/archive'),
			bookowner: $resource(api.localhost_backend + 'owner/book'),
			unbookowner: $resource(api.localhost_backend + 'owner/unbook'),
      favowner: $resource(api.localhost_backend + 'owner/to_fav'),
      notebyownerid: $resource(api.localhost_backend + 'owner/notebyownerid', {}, {query: {method: 'POST'}}),
      paramsbyownerid: $resource(api.localhost_backend + 'owner/paramsbyownerid', {}, {query: {method: 'POST'}}),
      changeFavOwnerParams: $resource(api.localhost_backend + 'owner/changefavownerparams'),
      changeAgentDescription: $resource(api.localhost_backend + 'owner/changeagentdescription'),
      concatAgentDescription: $resource(api.localhost_backend + 'owner/concatagentdescription'),
      archivefavowner: $resource(api.localhost_backend + 'owner/fav_to_archive'),
      changecalldate: $resource(api.localhost_backend + 'owner/changecalldate'),
      checkReminders: $resource(api.localhost_backend + 'owner/call_remind', {}, {query: {method: 'POST'}}),
    }

		api.deals = {
            deals   : $resource(api.localhost_backend + 'deals', {}, {query: {method: 'POST'}}),
            dealsarchive: $resource(api.localhost_backend + 'deals/archive', {}, {query: {method: 'POST'}}),
            archivedeal: $resource(api.localhost_backend + 'deal/archive'),
            restoredeal: $resource(api.localhost_backend + 'deal/restore'),
            newdeal: $resource(api.localhost_backend + 'deal/newdeal'),
            editdeal: $resource(api.localhost_backend + 'deal/edit'),
            dealbyid: $resource(api.localhost_backend + 'deal/', {}, {query: {method: 'POST'}}),
            dealdocsbyid: $resource(api.localhost_backend + 'deals/documents', {}, {query: {method: 'POST'}}),
            archivedoc: $resource(api.localhost_backend + '/document/archive', {}, {query: {method: 'POST'}}),
            docdirectories: $resource(api.localhost_backend + 'docs/dirs', {}, {query: {method: 'POST'}})
        };

        api.objects = {
            flats   : $resource(api.localhost_backend + 'objects/flats', {}, {query: {method: 'GET'}}),
            flatsrent   : $resource(api.localhost_backend + 'objects/flatsrent', {}, {query: {method: 'GET'}}),
            flatsarchive: $resource(api.localhost_backend + 'objects/flats/archive', {}, {query: {method: 'GET'}}),
            flatsrentarchive   : $resource(api.localhost_backend + 'objects/flatsrent/archive', {}, {query: {method: 'GET'}}),
            houses   : $resource(api.localhost_backend + 'objects/houses', {}, {query: {method: 'GET'}}),
            housesarchive: $resource(api.localhost_backend + 'objects/houses/archive', {}, {query: {method: 'GET'}}),
            commobjs   : $resource(api.localhost_backend + 'objects/commerce', {}, {query: {method: 'GET'}}),
            commobjsarchive: $resource(api.localhost_backend + 'objects/commerce/archive', {}, {query: {method: 'GET'}}),
            copyobject_witharchive: $resource(api.localhost_backend + 'objects/copyobject_witharchive'),
            copyobject_withoutarchive: $resource(api.localhost_backend + 'objects/copyobject_withoutarchive'),
            archiveobject: $resource(api.localhost_backend + 'objects/archive'),
            restoreobject: $resource(api.localhost_backend + 'objects/restore'),
            changeVisaStatus: $resource(api.localhost_backend + 'objects/changevisa'),
            changeListingStatus: $resource(api.localhost_backend + 'objects/changelisting'),
            changeVisaPStatus: $resource(api.localhost_backend + 'objects/changevisapublish'),
            changeAgentDescription: $resource(api.localhost_backend + 'objects/changeagentdescription'),
            concatAgentDescription: $resource(api.localhost_backend + 'objects/concatagentdescription'),
            districts: $resource(api.localhost_backend + 'districts'),
            district: $resource(api.localhost_backend + 'district'),
            cities: $resource(api.localhost_backend + 'cities'),
            streets: $resource(api.localhost_backend + 'streets'),
            streets_link: api.localhost_backend + 'streets',
            count_streets: $resource(api.localhost_backend + 'streets_qty', {}, {query: {method: 'GET', isArray:true}}),
            metrostations: $resource(api.localhost_backend + 'metrostations'),
            metrostations_lines: $resource(api.localhost_backend + 'metrostations_lines'),
            metrostations_by_lines: $resource(api.localhost_backend + 'metrostations_by_lines', {}, {query: {method: 'GET', isArray:true}}),
            metrostation: $resource(api.localhost_backend + 'metrostation', {}, {query: {method: 'GET', isArray:false}}),
            directions: $resource(api.localhost_backend + 'directions'),
            direction: $resource(api.localhost_backend + 'direction', {}, {query: {method: 'GET', isArray:false}}),
            newobjectdata: $resource(api.localhost_backend + 'objects/newobject'),
            editobjectdata: $resource(api.localhost_backend + 'objects/editobject'),
            objectbyid: $resource(api.localhost_backend + 'object/', {}, {query: {method: 'POST'}}),
            notebyobjectid: $resource(api.localhost_backend + 'object/notebyobjectid', {}, {query: {method: 'POST'}}),
            costhistorybyobjectid: $resource(api.localhost_backend + 'object/costhistorybyobjectid', {}, {query: {method: 'POST', isArray:true}}),
            objectphotosbyid: $resource(api.localhost_backend + 'object/photos', {}, {query: {method: 'POST'}}),
            archivephoto: $resource(api.localhost_backend + 'object/photo/remove'),
            rotatephoto: $resource(api.localhost_backend + 'rotate'),
            setpositionphoto: $resource(api.localhost_backend + 'setposition'),
            mainphoto: $resource(api.localhost_backend + 'object/photo/setmain'),
            changecalldate: $resource(api.localhost_backend + 'object/changecalldate'),
            checkReminders: $resource(api.localhost_backend + 'object/call_remind', {}, {query: {method: 'POST'}}),
            changeMeetStatus: $resource(api.localhost_backend + 'objects/changemetstatus'),
            employees100: $resource(api.baseUrl + 'tables/employees100.json')
        };

        api.contacts = {
            users: $resource(api.localhost_backend + 'contacts/users', {}, {query: {method: 'POST'}}),
            usersbygroup: $resource(api.localhost_backend + 'contacts/usersbygroup', {}, {query: {method: 'POST'}}),
            usersarchive: $resource(api.localhost_backend + 'contacts/users/archive', {}, {query: {method: 'POST'}}),
            newuserdata: $resource(api.localhost_backend + 'contacts/newuser'),
            newgroupdata: $resource(api.localhost_backend + 'contacts/newgroup'),
            newclientdata: $resource(api.localhost_backend + 'contacts/newclient'),
            newclientdataGET: $resource(api.localhost_backend + 'contacts/newclient', {}, {query: {method: 'GET', isArray:true}}),
            archiveUser: $resource(api.localhost_backend + 'contacts/archive_user'),
            restoreUser: $resource(api.localhost_backend + 'contacts/restore_user'),
            archivegroup: $resource(api.localhost_backend + 'contacts/archive_group'),
            restoregroup: $resource(api.localhost_backend + 'contacts/restore_group'),
            archiveclient: $resource(api.localhost_backend + 'contacts/archive_client'),
            restoreclient: $resource(api.localhost_backend + 'contacts/restore_client'),
            groups: $resource(api.localhost_backend + 'contacts/groups', {}, {query: {method: 'POST', isArray:true}}),
            positions: $resource(api.localhost_backend + 'contacts/positions', {}, {query: {method: 'POST', isArray:true}}),
            groupbyid: $resource(api.localhost_backend + 'contacts/group'),
            editgroup: $resource(api.localhost_backend + 'contacts/group/edit'),
            userbyid: $resource(api.localhost_backend + 'contacts/user'),
            usernamebyid: $resource(api.localhost_backend + 'contacts/username'),
            edituser: $resource(api.localhost_backend + 'contacts/user/edit'),
            offices: $resource(api.localhost_backend + 'contacts/offices', {}, {query: {method: 'POST', isArray:true}}),
            grouplist: $resource(api.localhost_backend + 'contacts/groups', {'isarray':false}, {query: {method: 'POST'}}),
            grouplistarchive: $resource(api.localhost_backend + 'contacts/groups/archive', {}, {query: {method: 'POST'}}),
            clientslist: $resource(api.localhost_backend + 'contacts/clients/all', {'isarray':false}, {query: {method: 'POST'}}),
            clientslistarchive: $resource(api.localhost_backend + 'contacts/clients/archive', {}, {query: {method: 'POST'}}),
            contragentslist: $resource(api.localhost_backend + 'contacts/clients/all/1', {'isarray':false}, {query: {method: 'POST'}}),
            buyercontragentslist: $resource(api.localhost_backend + 'contacts/clients/all/3', {}, {query: {method: 'POST'}}),
            contragentslistarchive: $resource(api.localhost_backend + 'contacts/clients/archive/1', {}, {query: {method: 'POST'}}),
            buyercontragentslistarchive: $resource(api.localhost_backend + 'contacts/clients/archive/3', {}, {query: {method: 'POST'}}),
            clientbyid: $resource(api.localhost_backend + 'contacts/client'),
            clientbyphone: $resource(api.localhost_backend + 'contacts/clientbyphone'),
            editclient: $resource(api.localhost_backend + 'contacts/client/edit'),
            my_clients: $resource(api.localhost_backend + 'contacts/clients/my', {}, {query: {method: 'GET', isArray:true}}),
            changeVisaPStatus: $resource(api.localhost_backend + 'objects/changeuservisapublish'),
            userphotobyid: $resource(api.localhost_backend + 'contacts/photo', {}, {query: {method: 'POST'}}),
            notebyclientid: $resource(api.localhost_backend + 'contacts/notebyclientid', {}, {query: {method: 'POST'}}),
            changeAgentDescription: $resource(api.localhost_backend + 'client/changeagentdescription')
        };

        return api;
    }

//  };
//   window.onload = rCabinet;

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login-v2', {
            url      : '/pages/auth/login-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login-v2': {
                    templateUrl: 'app/main/pages/auth/login-v2/login-v2.html',
                    controller : 'LoginV2Controller as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login-v2');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.login-v2', {
            title : 'Login v2',
            state : 'app.pages_auth_login-v2',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.objects.suburbian.archive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_suburbianarchive', {
            url    : '/objects/suburbian/archive',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/suburbian/suburbian.html',
                    controller : 'SuburbianController as vm'
                }
            },
            resolve: {
                Houses: function (apiResolver)
                {
                    return apiResolver.resolve('objects.housesarchive@get',{'my':'true','first':'true'});
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.newobject.newsuburbian')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_newsuburbian', {
            url    : '/objects/new/suburbian',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/newobject/newsuburbian/newsuburbian.html',
                    controller : 'NewSuburbianController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.newobject.newflatrent')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_newflatrent', {
            url    : '/objects/new/flatrent',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/newobject/newflatrent/newflatrent.html',
                    controller : 'NewFlatRentController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.newobject.newflat')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_newflat', {
            url    : '/objects/new/flat',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/newobject/newflat/newflat.html',
                    controller : 'NewFlatController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.newobject.newcommerce')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_newcommerce', {
            url    : '/objects/new/commerce',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/newobject/newcommerce/newcommerce.html',
                    controller : 'NewCommerceController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.flats.archive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_flatsarchive', {
            url    : '/objects/flats/archive',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/flats/flats.html',
                    controller : 'FlatController as vm'
                }
            },
            resolve: {
                Flats: function (apiResolver)
                {
                    return apiResolver.resolve('objects.flatsarchive@get',{'my':'true','first':'true'});
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.flatsrent.archive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_flatsrentarchive', {
            url    : '/objects/flatsrent/archive',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/flats/flats.html',
                    controller : 'FlatController as vm'
                }
            },
            resolve: {
                Flats: function (apiResolver)
                {
                    return apiResolver.resolve('objects.flatsrentarchive@get',{'my':'true','first':'true'});
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.commerce.archive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.objects_commercearchive', {
            url    : '/objects/commerce/archive',
            views  : {
                'content@app': {
                    templateUrl: 'app/objects/commerce/commerce.html',
                    controller : 'CommerceController as vm'
                }
            },
            resolve: {
                Commobjs: function (apiResolver)
                {
                    return apiResolver.resolve('objects.commobjsarchive@get',{'my':'true','first':'true'});
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.requests.requestsarchive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.modules_requestsarchive', {
            url    : '/requests/archive',
            views  : {
                'content@app': {
                    templateUrl: 'app/modules/requests/requests.html',
                    controller : 'RequestsController as vm'
                }
            },
            resolve: {
                Requests: function (apiResolver)
                {
                    return apiResolver.resolve('requests.listarchive@get');
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.requests.editrequest')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.requests_editrequest', {
            url    : '/request/view/{id:int}',
            views  : {
                'content@app': {
                    templateUrl: 'app/modules/requests/editrequest/editrequest.html',
                    controller : 'EditRequestController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }
    

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules.deals.archive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
		$stateProvider.state('app.deals_archive', {
            url    : '/deals/archive',
            views  : {
                'content@app': {
                    templateUrl: 'app/modules/deals/deals.html',
                    controller : 'DealsbaseController as vm'
                }
            },
            resolve: {
                Deals: function (apiResolver)
                {
                    return apiResolver.resolve('deals.dealsarchive@get');
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboards', [
            'app.dashboards.project',
            'app.dashboards.server',
            'app.dashboards.analytics'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        /*msNavigationServiceProvider.saveItem('apps', {
            title : 'Недвижимость',
            group : true,
            weight: 2
        });*/

        msNavigationServiceProvider.saveItem('apps.dashboards', {
            title : 'Dashboards',
            icon  : 'icon-tile-four',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.project', {
            title: 'Project',
            state: 'app.dashboards_project'
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.server', {
            title: 'Server',
            state: 'app.dashboards_server'
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.analytics', {
            title: 'Analytics',
            state: 'app.dashboards_analytics'
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.users.usersarchive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_usersarchive', {
            url    : '/contacts/users/archive',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/users/users.html',
                    controller : 'UsersController as vm'
                }
            },
            resolve: {
                Users: function (apiResolver)
                {
                    return apiResolver.resolve('contacts.usersarchive@get');
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.users.newuser')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_newuser', {
            url    : '/contacts/users/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/users/newuser/newuser.html',
                    controller : 'NewUserController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }
    

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.users.edituser')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_edituser', {
            url    : '/contacts/edit/user/{id:int}',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/users/edituser/edituser.html',
                    controller : 'EditUserController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }
    

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.groups.newgroup')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_newgroup', {
            url    : '/contacts/groups/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/groups/newgroup/newgroup.html',
                    controller : 'NewGroupController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }
    

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.groups.groupsarchive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_groupsarchive', {
            url    : '/contacts/groups/archive',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/groups/groups.html',
                    controller : 'GroupsController as vm'
                }
            },
            resolve: {
                Groups: function (apiResolver)
                {
                    return apiResolver.resolve('contacts.grouplistarchive@get');
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.groups.editgroup')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_editgroup', {
            url    : '/contacts/groups/edit/{id:int}',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/groups/editgroup/editgroup.html',
                    controller : 'EditGroupController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }
    

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients_contragents.newclient')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.clients_contragents_newclient', {
            url    : '/contacts/contragents/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/clients_contragents/newclient/newclient.html',
                    controller : 'NewCClientController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients_contragents.editclient')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.clients_contragents_editclient', {
            url    : '/contacts/contragents/edit/{id:int}',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/clients_contragents/editclient/editclient.html',
                    controller : 'EditCClientController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients_contragents.clientsarchive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.clients_contragents_clientsarchive', {
            url    : '/contacts/contragents/archive',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/clients_contragents/clients.html',
                    controller : 'CClientsController as vm'
                }
            },
            resolve: {
                Clients: function (apiResolver)
                {
                    return apiResolver.resolve('contacts.contragentslistarchive@get');
                }
            }
        });

        $stateProvider.state('app.clients_contragents_buyers_clientsarchive', {
            url    : '/contacts/contragents_buyers/archive',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/clients_contragents/buyers.html',
                    controller : 'CBuyersController as vm'
                }
            },
            resolve: {
                Clients: function (apiResolver)
                {
                    return apiResolver.resolve('contacts.buyercontragentslistarchive@get', {'my':'true','first':'true', 'isarray':false});
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients.newclient')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_newclient', {
            url    : '/contacts/clients/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/clients/newclient/newclient.html',
                    controller : 'NewClientController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }
    

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients.editclient')
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_editclient', {
            url    : '/contacts/clients/edit/{id:int}',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/clients/editclient/editclient.html',
                    controller : 'EditClientController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }
    

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.clients.clientsarchive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.contacts_clientsarchive', {
            url    : '/contacts/clients/archive',
            views  : {
                'content@app': {
                    templateUrl: 'app/contacts/clients/clients.html',
                    controller : 'ClientsController as vm'
                }
            },
            resolve: {
                Clients: function (apiResolver)
                {
                    return apiResolver.resolve('contacts.clientslistarchive@get');
                }
            }
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.objects.editobject', ['app.objects.editobject.editflat','app.objects.editobject.editsuburbian','app.objects.editobject.editcommerce','app.objects.editobject.editflatrent']);       

})();

(function ()
{
    'use strict';

    angular
        .module('app.ui', [
            'app.ui.forms',
            'app.ui.icons',
            'app.ui.material-colors',
            'app.ui.page-layouts.blank',
            'app.ui.page-layouts.carded.fullwidth',
            'app.ui.page-layouts.carded.fullwidth-ii',
            'app.ui.page-layouts.carded.left-sidenav',
            'app.ui.page-layouts.carded.left-sidenav-ii',
            'app.ui.page-layouts.carded.right-sidenav',
            'app.ui.page-layouts.carded.right-sidenav-ii',
            'app.ui.page-layouts.simple.fullwidth',
            'app.ui.page-layouts.simple.left-sidenav',
            'app.ui.page-layouts.simple.left-sidenav-ii',
            'app.ui.page-layouts.simple.right-sidenav',
            'app.ui.page-layouts.simple.right-sidenav-ii',
            'app.ui.page-layouts.simple.tabbed',
            'app.ui.theme-colors',
            'app.ui.typography'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('ui', {
            title : 'USER INTERFACE',
            group : true,
            weight: 3
        });

        msNavigationServiceProvider.saveItem('ui.forms', {
            title: 'Forms',
            icon : 'icon-window-restore',
            state: 'app.ui_forms'
        });

        msNavigationServiceProvider.saveItem('ui.icons', {
            title: 'Icons',
            icon : 'icon-file-image-box',
            state: 'app.ui_icons'
        });

        msNavigationServiceProvider.saveItem('ui.typography', {
            title: 'Typography',
            icon : 'icon-format-size',
            state: 'app.ui_typography'
        });

        msNavigationServiceProvider.saveItem('ui.theme-colors', {
            title: 'Theme Colors',
            icon : 'icon-palette-advanced',
            state: 'app.ui_theme-colors'
        });

        msNavigationServiceProvider.saveItem('ui.material-colors', {
            title: 'Material Colors',
            icon : 'icon-palette',
            state: 'app.ui_material-colors'
        });


        msNavigationServiceProvider.saveItem('ui.page-layouts', {
            title: 'Page Layouts',
            icon : 'icon-view-quilt'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded', {
            title: 'Carded'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_carded_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth-ii', {
            title: 'Full Width (II)',
            state: 'app.ui_page-layouts_carded_fullwidth-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_carded_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_carded_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_carded_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_carded_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple', {
            title: 'Simple'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_simple_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_simple_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_simple_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_simple_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_simple_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.tabbed', {
            title: 'Tabbed',
            state: 'app.ui_page-layouts_simple_tabbed'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.blank', {
            title: 'Blank',
            state: 'app.ui_page-layouts_blank'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            'app.pages.auth.login-v2',
            'app.pages.auth.register',
            'app.pages.auth.register-v2',
            'app.pages.auth.forgot-password',
            'app.pages.auth.reset-password',
            'app.pages.auth.lock',
            'app.pages.coming-soon',
            'app.pages.error-404',
            'app.pages.error-500',
            'app.pages.invoice',
            'app.pages.maintenance',
            'app.pages.profile',
            'app.pages.search',
            'app.pages.timeline'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('pages', {
            title : 'PAGES',
            group : true,
            weight: 2
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components', [
            'app.components.cards',
            'app.components.charts.c3',
            'app.components.charts.chartist',
            'app.components.charts.chart-js',
            'app.components.charts.nvd3',
            'app.components.maps',
            'app.components.price-tables',
            'app.components.tables.simple-table',
            'app.components.tables.datatable',
            'app.components.widgets',
            'app.components.material-docs'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('components', {
            title : 'COMPONENTS',
            group : true,
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.cards', {
            title : 'Cards',
            icon  : 'icon-content-copy',
            state : 'app.components_cards'
        });

        msNavigationServiceProvider.saveItem('components.charts', {
            title: 'Charts',
            icon : 'icon-poll'
        });

        msNavigationServiceProvider.saveItem('components.charts.c3', {
            title: 'C3',
            state: 'app.components_charts_c3'
        });

        msNavigationServiceProvider.saveItem('components.charts.chart-js', {
            title: 'Chart.js',
            state: 'app.components_charts_chart-js'
        });

        msNavigationServiceProvider.saveItem('components.charts.chartist', {
            title: 'Chartist',
            state: 'app.components_charts_chartist'
        });

        msNavigationServiceProvider.saveItem('components.charts.nvd3', {
            title: 'nvD3',
            state: 'app.components_charts_nvd3'
        });

        msNavigationServiceProvider.saveItem('components.maps', {
            title: 'Maps',
            icon : 'icon-map-marker',
            state: 'app.components_maps'
        });

        msNavigationServiceProvider.saveItem('components.price-tables', {
            title: 'Price Tables',
            icon : 'icon-view-carousel',
            state: 'app.components_price-tables'
        });

        msNavigationServiceProvider.saveItem('components.tables', {
            title: 'Tables',
            icon : 'icon-table-large'
        });

        msNavigationServiceProvider.saveItem('components.tables.simple-table', {
            title: 'Simple Table',
            state: 'app.components_tables_simple-table'
        });

        msNavigationServiceProvider.saveItem('components.tables.datatable', {
            title: 'Datatable',
            state: 'app.components_tables_datatable'
        });

        msNavigationServiceProvider.saveItem('components.widgets', {
            title: 'Widgets',
            icon : 'icon-apps',
            state: 'app.components_widgets'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.objects', [
								'app.objects.flats',
                                'app.objects.flatsrent',
								'app.objects.suburbian',
								'app.objects.commerce',
								'app.objects.newobject',
								'app.objects.editobject',
								'datatables',
                'ngSanitize'
							])
						.config(config)
            .directive('galleryRepeatDirective', function() {
                return function(scope, element, attrs) {
                  if (scope.$last){
                    lightGallery(document.getElementById('lightgallery'));
                  }
                };
            })
            .filter('trusted', ['$sce', function ($sce) {
                return function(url) {
                    return $sce.trustAsResourceUrl(url);
                };
            }])
            .factory('GetStreetService', function ($http, $q, api) {
            return {
                getStreets: function(code,str) {
                  //ссылка хранится в общем файле, описывающем взаимодействие с бэкэндом
                  var url = api.objects.streets_link;
                          return $http.get(url, {params:{'code':code,'like':str}})
                              .then(function(response) {
                                  if (typeof response.data === 'object') {
                                      return response.data;
                                  } else {
                                      //неверный ответ
                                      return $q.reject(response.data);
                                  }

                              }, function(response) {
                                  //что-то пошло не так
                                  return $q.reject(response.data);
                              });
                }
            };
          })
          .directive('autocompleteBlur', function($mdDialog, $timeout){//$mdDialog,
              return{
                  link: function($scope,element,attrs, ctrl){
                    /*слушаем изменения атрибута mdSelectedAttr для улицы*/
                    $scope.$watch(attrs.mdSelectedAttr,function(value){

                        if ((typeof(value)=='boolean' && value==true)) { // || attrs.mdBlurTimes==1
                            console.log('Улица выбрана из выпадающего списка или загружена из БД');
                        } else {
                            console.log('Улица введена с клавиатуры');
                            $timeout(clearInputBoxOnBlur, 2500);
                        }
                    });
                    //событие при потере фокуса с улицы
                    function clearInputBoxOnBlur(){
                        //unbind("blur") -- unbind это обязательный элемент, так как
                        //иначе "копятся" навешанные на поле события, которые срабатывают пачками
                        //В ИТОГЕ: ничего не выводим. unbind убирает заодно и события закрытия dropdown списка
                        //пользователю приходится выбирать из списка, так как остальные действия до этого недоступны
                        element.find("#street-autocomplete-id").unbind("blur").bind("blur", function(){
                              //если пользователь ввел улицу вручную, а не выбрал из списка, то стираем
                              //так как нестандартные ошибки не работают в md-autocomplete, то сработает required
                              //выводим диалог
                              /*$mdDialog.show({
                                  controller         : function ($scope,$mdDialog)
                                  {
                                      $scope.closeDialog = function ()
                                      {
                                          $mdDialog.hide();
                                      }
                                  },
                                  template: '<md-dialog>' +
                                  '  <md-dialog-content><h1>Улица введена неверно</h1><div>Воспользуйтесь вспылавающими подсказками и выберите улицу из списка</div></md-dialog-content>' +
                                  '  <md-dialog-actions>' +
                                  '    <md-button ng-click="closeDialog()" class="md-primary">' +
                                  '      Закрыть' +
                                  '    </md-button>' +
                                  '  </md-dialog-actions>' +
                                  '</md-dialog>',
                                  parent             : angular.element('body'),
                                  clickOutsideToClose: true
                              });
                              angular.element(this).val('');*/
                        });
                    }
                  }
              }
          })
          .directive('autocompleteMetroBlur', function($mdDialog, $timeout){//$mdDialog,
              return{
                  link: function($scope,element,attrs, ctrl){
                    /*слушаем изменения атрибута mdSelectedAttr для улицы*/
                    $scope.$watch(attrs.mdSelectedItem,function(value){

                        if ((typeof(value)=='number')) {
                            console.log('Станция метро выбрана из выпадающего списка или загружена из БД');
                        } else {
                            console.log('Станция метро введена с клавиатуры');
                            $timeout(clearInputBoxOnBlur, 2500);
                        }
                    });
                    //событие при потере фокуса с улицы
                    function clearInputBoxOnBlur(){
                        element.find("#metro1-autocomplete-id").unbind("blur").bind("blur", function(){

                        });
                    }
                  }
              }
          });


    /** @ngInject */
    function config(msNavigationServiceProvider)
    {

        msNavigationServiceProvider.saveItem('apps.objects', {
            title : 'Объекты',
            icon  : 'icon-tile-four',
            weight: 3
        });

		msNavigationServiceProvider.saveItem('apps.objects.flats', {
			icon  : 'icon-city',
            title: 'Квартиры',
            state: 'app.objects_flats'
        });

    msNavigationServiceProvider.saveItem('apps.objects.flatsrent', {
			icon  : 'icon-cash-multiple',
            title: 'Квартиры - аренда',
            state: 'app.objects_flatsrent'
        });

        msNavigationServiceProvider.saveItem('apps.objects.suburbian', {
			icon  : 'icon-cow',
            title: 'Дома/земля',
            state: 'app.objects_suburbian'
        });

        msNavigationServiceProvider.saveItem('apps.objects.commerce', {
			icon  : 'icon-square-inc-cash',
            title: 'Комм. помещения',
            state: 'app.objects_commerce'
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.modules', [
								'app.modules.deals',
								'app.modules.requests',
								'app.modules.ownerbase',
                'app.modules.my_ownerbase',
								'datatables'
							])
        .config(config);

    /** @ngInject */
    function config()
    {



    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts', [
								'app.contacts.users',
								'app.contacts.groups',
								'app.contacts.clients',
                'app.contacts.clients_contragents',
								'datatables'
							])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {

      msNavigationServiceProvider.saveItem('apps.contacts_contragents_buyers', {
          title : 'База покупателей',
          icon  : 'icon-account-key',
          state: 'app.contacts_contragents_buyers',
          weight: 4
      });

        msNavigationServiceProvider.saveItem('apps.contacts', {
            title : 'Контакты',
            icon  : 'icon-pencil',
            weight: 7
        });

		msNavigationServiceProvider.saveItem('apps.contacts.users', {
			icon  : 'icon-people',
            title: 'Сотрудники',
            state: 'app.contacts_users'
        });

        msNavigationServiceProvider.saveItem('apps.contacts.groups', {
			icon  : 'icon-tag-multiple',
            title: 'Отделы',
            state: 'app.contacts_groups'
        });

        msNavigationServiceProvider.saveItem('apps.contacts.clients', {
			icon  : 'icon-walk',
            title: 'Клиенты',
            state: 'app.contacts_clients'
        });

        msNavigationServiceProvider.saveItem('apps.contacts.clients_scontragents', {
			icon  : 'icon-account-key',
            title: 'Контрагенты',
            state: 'app.contacts_contragents'
        });


    }

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/loginpage/loginpage.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>R</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" ng-submit=\"vm.do_login(vm.form.email,vm.form.password,vm.form.rememberme)\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"text\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Username\" translate=\"\" translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+$/\" required=\"\"><div ng-messages=\"loginForm.email.$error\" ng-show=\"loginForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"LOGIN.PASSWORD\" required=\"\"><div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"wrongpassword\"><span translate=\"LOGIN.ERRORS.BADPASSWORD\">Wrong password</span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" name=\"rememberme\" ng-model=\"vm.form.rememberme\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span></md-checkbox></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form></div></div></div>");
$templateCache.put("app/objects/objectCostHistoryDialog.html","<md-dialog><md-dialog-content><h1><md-icon md-font-icon=\"icon-home-modern\" class=\"ng-isolate-scope material-icons\"></md-icon>История изменения цен по объекту № {{object_id}}</h1><p><table class=\"objectViewTable\"><tr ng-repeat=\"cost_item in cost_data\"><td colspan=\"3\" class=\"allRow\" style=\"font-size: 20px;\"><b>{{cost_item.date | date:\'HH:mm:ss dd.MM.yyyy\'}}:</b> {{cost_item.cost}} руб.</td></tr></table></p>Если цена не изменялась более месяца, то она будет выделена зеленым цветом в таблице объектов<br>Более 2 месяцев - красным</md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/objects/objectCreateSellerDialog.html","<md-dialog><md-dialog-content><h1><md-icon md-font-icon=\"icon-plus\" class=\"ng-isolate-scope material-icons\"></md-icon>Создание клиента</h1><p>Хотите ли Вы предварительно создать продавца? Если клиент уже создан, то нажмите Нет</p></md-dialog-content><md-dialog-actions><md-button ng-click=\"createClient()\" class=\"md-primary\">Да</md-button><md-button ng-click=\"createObject()\" class=\"md-primary\">Нет</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/objects/objectEditAgentDescriptionDialog.html","<md-dialog aria-label=\"Edit object\'s agent description\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>Заметки</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div>Здесь Вы можете в свободной форме вести заметки по этому объекту: звонки, встречи, даты и т.п.</div><textarea scroll-glue=\"\" style=\"width: 100%; height: 200px; border: 1px solid #a3a3a3;\" ng-model=\"object_data.agent_descr\"></textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"changeAgentDescription(object_data.id,object_data.agent_descr)\" class=\"md-primary\">Сохранить</md-button><md-button ng-click=\"closeDialog()\">Закрыть</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/objects/objectsRemindersDialog.html","<md-dialog><md-dialog-content><h1><md-icon md-font-icon=\"icon-home-modern\" class=\"ng-isolate-scope material-icons\"></md-icon>Список напоминаний</h1><p><table class=\"objectViewTable\">Ниже представлен список напоминаний о звонках.<tr ng-repeat=\"reminder in remindersList\"><td colspan=\"3\" class=\"allRow\" style=\"font-size: 20px;\"><md-button class=\"md-primary md-icon-button\" ng-click=\"searchReminder(reminder)\" aria-label=\"view object\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><b>{{(reminder.remindType==\'object\')?\'Клиент по объекту\':\'Собственник\'}}:</b> #{{(reminder.remindType==\'object\')?reminder.id: reminder.owner_id}} / +7{{(reminder.phone.length==10)?reminder.phone:reminder.phone.substring(1)}}</td></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination=\"\" md-swipe-content=\"\" md-stretch-tabs=\"always\"><md-tab><md-tab-label translate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll=\"\" ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll=\"\" ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" ms-scroll=\"\" ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" ui-view=\"navigation\"></div><div id=\"content-container\" flex=\"\" layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div class=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" class=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div class=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button><md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button value=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">Wide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\"><md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" ng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" ng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\"></md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/contacts/clients/addClientDialog.html","<md-dialog><md-dialog-content><h1>Создание клиента</h1><p>Это простая форма создания клиента. Пожалуйста, после создания объекта зайдите в раздел Клиенты и дополните информацию.<br><form name=\"addClientForm\" class=\"md-inline-form\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"dialog.firstname\" placeholder=\"Имя\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"2\" required=\"\"><div ng-messages=\"addClientForm.firstname.$error\" ng-show=\"addClientForm.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Имя должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое имя</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основной телефон</label> <input name=\"phone_1\" ng-model=\"dialog.phone_1\" placeholder=\"Основной телефон\" required=\"\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"addClientForm.phone_1.$error\" ng-show=\"addClientForm.phone_1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести основной телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container></div><md-button ng-click=\"createClient()\" aria-label=\"add client\" ng-disabled=\"addClientForm.$invalid\"><md-icon md-font-icon=\"icon-account-check\"></md-icon>Создать</md-button></form></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/contacts/clients/clients.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span></div><div class=\"title\">Список клиентов</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"/contacts/clients\" aria-label=\"Clients\" ng-class=\"{\'md-primary\':!vm.isArch()}\" ng-click=\"vm.Arch(0)\"><md-icon md-font-icon=\"icon-account-check\"></md-icon><span>Актуальные</span></md-button><md-button class=\"md-raised reference-button\" href=\"/contacts/clients/archive\" aria-label=\"Archive\" ng-class=\"{\'md-primary\':vm.isArch()}\" ng-click=\"vm.Arch(1)\"><md-icon md-font-icon=\"icon-account-minus\"></md-icon><span>Архив</span></md-button></div><md-button ng-show=\"checkRule(40,\'all\')\" class=\"add-object-button md-fab md-warn\" ng-click=\"vm.addClient()\" aria-label=\"Add client\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div ng-hide=\"checkRule(61, \'my\')\" class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Тип</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Имя / Название</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Телефон</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">E-mail</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Статус</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Создатель</span></div></th></tr></thead><tbody><tr ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"client in ::vm.clients\"><td>{{ client.id }}</td><td>{{ client.type }}</td><td><md-button ng-show=\"(vm.userid == client.access_id && checkRule(41,\'my\')) || (client.group_id == vm.groupid && checkRule(41,\'my\',\'group\')) || (checkRule(41,client.group_id,\'group\')) || checkRule(41,\'all\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editClient(client.id,1)\" aria-label=\"Add object\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><br><md-button ng-show=\"(!vm.isArch() && checkRule(42,\'all\')) || (vm.isArch() && checkRule(43,\'all\'))\" class=\"md-warn md-icon-button\" ng-click=\"vm.restore_archiveClient(client.id)\" aria-label=\"Delete object\"><md-icon md-font-icon=\"{{vm.isArch(\'icon\')}}\"></md-icon></md-button></td><td>{{ client.lastname }} {{ client.firstname }} {{ client.middlename }}</td><td>{{ client.phone_1 }}</td><td>{{ client.email }}</td><td>{{ client.status }}</td><td>{{ client.access_name }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/contacts/clients_contragents/buyers.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span></div><div class=\"title\">База покупателей</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"/contacts/contragents_buyers\" aria-label=\"Clients\" ng-class=\"{\'md-primary\':!vm.isArch()}\" ng-click=\"vm.Arch(0)\"><md-icon md-font-icon=\"icon-account-check\"></md-icon><span>Актуальные</span></md-button><md-button class=\"md-raised reference-button\" href=\"/contacts/contragents_buyers/archive\" aria-label=\"Archive\" ng-class=\"{\'md-primary\':vm.isArch()}\" ng-click=\"vm.Arch(1)\"><md-icon md-font-icon=\"icon-account-minus\"></md-icon><span>Архив</span></md-button></div><md-button ng-show=\"checkRule(40,\'all\')\" class=\"add-object-button md-fab md-warn\" ng-click=\"vm.addClient()\" aria-label=\"Add client\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-checkbox ng-hide=\"checkRule(61, \'my\')\" class=\"my-objects-checkbox md-primary\" ng-model=\"vm.onlyMy\" ng-change=\"vm.updateObjectsTable()\">Только мои</md-checkbox></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Дата создания</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Имя / Название</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Телефон</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Метро</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Кол-во комнат / Тип</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Площадь</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Бюджет</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Статус</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Агент</span></div></th></tr></thead><tbody><tr ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"client in vm.clients\"><td>{{ client.id }}</td><td><md-button ng-show=\"(vm.userid == client.access_id && checkRule(41,\'my\')) || (client.group_id == vm.groupid && checkRule(41,\'my\',\'group\')) || checkRule(41,\'all\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editClient(client.id,1)\" aria-label=\"Add object\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><br><md-button ng-show=\"(!vm.isArch() && checkRule(42,\'all\')) || (vm.isArch() && checkRule(43,\'all\'))\" class=\"md-warn md-icon-button\" ng-click=\"vm.restore_archiveClient(client.id)\" aria-label=\"Delete object\"><md-icon md-font-icon=\"{{vm.isArch(\'icon\')}}\"></md-icon></md-button><br><md-button ng-show=\"(vm.userid == client.access_id && checkRule(41,\'my\')) || (client.group_id == vm.groupid && checkRule(41,\'my\',\'group\')) || checkRule(41,\'all\')\" class=\"md-primary md-icon-button\" aria-label=\"See notes\" ng-click=\"vm.notesClient(client.id)\"><md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon></md-button></td><td>{{ client.create_date }}</td><td>{{ client.lastname }} {{ client.firstname }} {{ client.middlename }}</td><td>{{ client.phone_1 }}</td><td>{{ client.metro }}</td><td>{{ client.rooms_or_type }}</td><td>{{ client.square_all }} м<sup>2</sup></td><td>{{ client.cost }}</td><td>{{ client.status }}</td><td>{{ client.access_name }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/contacts/clients_contragents/clientEditAgentDescriptionDialog.html","<md-dialog aria-label=\"Edit client\'s agent description\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>Заметки</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div>Здесь Вы можете в свободной форме вести заметки по этому клиенту: звонки, встречи, даты и т.п.</div><textarea scroll-glue=\"\" style=\"width: 100%; height: 200px; border: 1px solid #a3a3a3;\" ng-model=\"object_data.description\"></textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"changeAgentDescription(object_data.id,object_data.description)\" class=\"md-primary\">Сохранить</md-button><md-button ng-click=\"closeDialog()\">Закрыть</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/contacts/clients_contragents/clients.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span></div><div class=\"title\">Список контрагентов</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"/contacts/contragents\" aria-label=\"Clients\" ng-class=\"{\'md-primary\':!vm.isArch()}\" ng-click=\"vm.Arch(0)\"><md-icon md-font-icon=\"icon-account-check\"></md-icon><span>Актуальные</span></md-button><md-button class=\"md-raised reference-button\" href=\"/contacts/contragents/archive\" aria-label=\"Archive\" ng-class=\"{\'md-primary\':vm.isArch()}\" ng-click=\"vm.Arch(1)\"><md-icon md-font-icon=\"icon-account-minus\"></md-icon><span>Архив</span></md-button></div><md-button ng-show=\"checkRule(40,\'all\')\" class=\"add-object-button md-fab md-warn\" ng-click=\"vm.addClient()\" aria-label=\"Add client\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Тип</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Имя / Название</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Телефон</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">E-mail</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Статус</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Создатель</span></div></th></tr></thead><tbody><tr ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"client in ::vm.clients\"><td>{{ client.id }}</td><td>{{ client.type }}</td><td><md-button ng-show=\"(vm.userid == client.access_id && checkRule(41,\'my\')) || (client.group_id == vm.groupid && checkRule(41,\'my\',\'group\')) || checkRule(41,\'all\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editClient(client.id,1)\" aria-label=\"Add object\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><br><md-button ng-show=\"(!vm.isArch() && checkRule(42,\'all\')) || (vm.isArch() && checkRule(43,\'all\'))\" class=\"md-warn md-icon-button\" ng-click=\"vm.restore_archiveClient(client.id)\" aria-label=\"Delete object\"><md-icon md-font-icon=\"{{vm.isArch(\'icon\')}}\"></md-icon></md-button></td><td>{{ client.lastname }} {{ client.firstname }} {{ client.middlename }}</td><td>{{ client.phone_1 }}</td><td>{{ client.email }}</td><td>{{ client.status }}</td><td>{{ client.access_name }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/contacts/users/users.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span></div><div class=\"title\">Список сотрудников</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"/contacts/users\" aria-label=\"Users\" ng-click=\"vm.Arch(0)\" ng-class=\"{\'md-primary\':!vm.isArch()}\"><md-icon md-font-icon=\"icon-account-check\"></md-icon><span>Актуальные</span></md-button><md-button class=\"md-raised reference-button\" href=\"/contacts/users/archive\" aria-label=\"Archive\" ng-click=\"vm.Arch(1)\" ng-class=\"{\'md-primary\':vm.isArch()}\"><md-icon md-font-icon=\"icon-account-minus\"></md-icon><span>Архив</span></md-button></div><md-button ng-show=\"!vm.isArch() && checkRule(1,\'all\')\" class=\"add-object-button md-fab md-warn\" ng-click=\"vm.addUser()\" aria-label=\"Add user\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div ng-hide=\"checkRule(61, \'my\')\" class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ФИО</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Публикация</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Отдел</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Должность</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Телефон</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">E-mail</span></div></th></tr></thead><tbody><tr ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"user in ::vm.users\"><td>{{ user.id }}</td><td>{{ user.firstname }} {{ user.middlename}} {{ user.lastname }}</td><td><span><md-button class=\"md-primary md-icon-button\" ng-show=\"checkRule(3,\'all\')\" ng-click=\"vm.editUser(user.id,1)\" aria-label=\"Add object\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button></span> <span><md-button class=\"md-warn md-icon-button\" ng-show=\"(!vm.isArch() && checkRule(2,\'all\')) || (vm.isArch() && checkRule(4,\'all\'))\" ng-click=\"vm.restore_archiveUser(user.id)\" aria-label=\"Delete object\"><md-icon md-font-icon=\"{{vm.isArch(\'icon\')}}\"></md-icon></md-button></span></td><td><span><md-button ng-show=\"checkRule(58,\'all\') || checkRule(58,user.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeVisaP(user.id,user.visa_publish)\" aria-label=\"Set visa publish\"><md-icon md-font-icon=\"icon-star{{user.visapublish}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(58,\'all\') || checkRule(58,user.group_id,\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetVisaPError()\" aria-label=\"See visa publish\"><md-icon md-font-icon=\"icon-star{{user.visapublish}}\"></md-icon></md-button></span></td><td>{{ user.group }}</td><td>{{ user.position_id }}</td><td>{{ user.phone_1 }}</td><td>{{ user.email }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/contacts/groups/groups.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span></div><div class=\"title\">Список отделов</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"/contacts/groups\" aria-label=\"Groups\" ng-class=\"{\'md-primary\':!vm.isArch()}\" ng-click=\"vm.Arch(0)\"><md-icon md-font-icon=\"icon-account-check\"></md-icon><span>Актуальные</span></md-button><md-button class=\"md-raised reference-button\" href=\"/contacts/groups/archive\" aria-label=\"Archive\" ng-class=\"{\'md-primary\':vm.isArch()}\" ng-click=\"vm.Arch(1)\"><md-icon md-font-icon=\"icon-account-minus\"></md-icon><span>Архив</span></md-button></div><md-button ng-show=\"!vm.isArch() && checkRule(11,\'all\')\" class=\"add-object-button md-fab md-warn\" ng-click=\"vm.addGroup()\" aria-label=\"Add group\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div ng-hide=\"checkRule(61, \'my\')\" class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Название</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Число сотрудников</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Начальник</span></div></th></tr></thead><tbody><tr ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"group in ::vm.groups\"><td>{{ group.id }}</td><td>{{ group.name }}</td><td><md-button ng-show=\"checkRule(12,\'all\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editGroup(group.id,1)\" aria-label=\"Add object\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><br><md-button ng-show=\"(!vm.isArch() && checkRule(13,\'all\')) || (vm.isArch() && checkRule(14,\'all\'))\" class=\"md-warn md-icon-button\" ng-click=\"vm.restore_archiveGroup(group.id)\" aria-label=\"Delete object\"><md-icon md-font-icon=\"{{vm.isArch(\'icon\')}}\"></md-icon></md-button></td><td>{{ group.qty }}</td><td>{{ group.leader }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/deals/deals.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">Сделки</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':!vm.isArch()}\" href=\"/deals\" ng-click=\"vm.Arch(0)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span>Актуальные</span></md-button><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':vm.isArch()}\" href=\"/deals/archive\" ng-click=\"vm.Arch(1)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span>Архив</span></md-button></div><md-button ng-show=\"!vm.isArch() && checkRule(45,\'all\')\" class=\"add-object-button md-fab md-warn\" ng-click=\"vm.adddeal()\" aria-label=\"Add deal\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">№</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Дата создания</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Статус</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Объект</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Агент</span></div></th></tr></thead><tbody><tr ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"deal in ::vm.deals\"><td>{{ deal.deal_name }}</td><td><md-button ng-show=\"(deal.group_id == vm.groupid && (checkRule(46,\'my\',\'group\') || checkRule(46,deal.group_id,\'group\'))) || checkRule(46,\'all\') || (deal.agent_id == vm.userid && vm.archive == false)\" class=\"md-primary md-icon-button\" ng-click=\"vm.editdeal(deal.id,1)\" aria-label=\"edit deal\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><br><md-button ng-show=\"(vm.userid == deal.agent_id && checkRule(47,\'my\') && vm.archive == false) || (vm.userid == deal.agent_id && checkRule(48,\'my\') && vm.archive == true) || (checkRule(47,deal.group_id,\'group\') && vm.archive == false) || (checkRule(48,deal.group_id,\'group\') && vm.archive == true) || (checkRule(47,\'all\') && vm.archive == false) || (checkRule(48,\'all\') && vm.archive == true)\" class=\"md-warn md-icon-button\" ng-click=\"vm.restore_archivedeal(deal.id)\" aria-label=\"Delete deal\"><md-icon md-font-icon=\"{{vm.isArch(\'icon\')}}\"></md-icon></md-button></td><td>{{ deal.creation_date }}</td><td>{{ deal.status }}</td><td>{{ deal.object_adress }}</td><td>{{ deal.agent_name }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/my_ownerbase/RemindCallDialog.html","<md-dialog><md-dialog-content><h1>Позвоните собственнику № {{owner_data.id}}</h1><p><table class=\"objectViewTable\"><tr><td colspan=\"3\" class=\"allRow\"><b>Вы устанавливали напоминание на {{owner_data.call_deadline}} и пришла пора совершить звонок. Ниже информация об объекте.<br><br></b></td></tr><tr></tr><tr><td><b>Адрес:</b> {{owner_data.street}} (м.{{owner_data.metro}}{{owner_data.from_metro}})</td><td><b>Комнат:</b> {{owner_data.rooms}}</td><td><b>Этаж:</b> {{owner_data.floor}}/{{owner_data.floors}}</td></tr><tr><td><b>Площадь:</b> {{owner_data.square}}</td><td><b>Цена:</b> {{owner_data.price}} руб.</td><td><b>Телефон:</b> {{owner_data.phone}} <span ng-show=\"owner_data.link.length > 0\"><a target=\"_blank\" href=\"{{owner_data.link}}\">Источник</a></span></td></tr><tr><td colspan=\"3\" class=\"allRow\"><b>Описание:</b> {{owner_data.description}}<br><br><md-button class=\"md-warn\" ng-click=\"closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon>Закрыть</md-button></td></tr><tr></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/my_ownerbase/b_ownerViewDialog.html","<md-dialog><md-dialog-content><h1>Собственник № {{owner_data.id}}</h1><p><table class=\"objectViewTable\"><tr><td colspan=\"3\" class=\"allRow\"><b>Если встреча с клиентом прошла успешно, то укажите номер введеного в базу объекта и отправьте эту бронь в архив<br><br></b></td></tr><tr></tr><tr><td><b>Адрес:</b> {{owner_data.street}} (м.{{owner_data.metro}}{{owner_data.from_metro}})</td><td><b>Комнат:</b> {{owner_data.rooms}}</td><td colspan=\"2\"><b>Этаж:</b> {{owner_data.floor}}/{{owner_data.floors}}</td></tr><tr><td><b>Площадь:</b> {{owner_data.square}}</td><td><b>Цена:</b> {{owner_data.price}} руб.</td><td><b>Телефон:</b> {{owner_data.phone}}</td><td><b>Ссылка:</b> {{owner_data.link}}</td></tr><tr><td colspan=\"3\" class=\"allRow\"><b>Описание:</b> {{owner_data.description}}<br><br><input type=\"number\" name=\"object_id\" ng-model=\"object_id\" placeholder=\"Номер объекта\" required=\"\"><md-button class=\"md-primary\" ng-disabled=\"object_id == null\" ng-click=\"owner_archive(owner_data.id, object_id);\" aria-label=\"Book\"><md-icon md-font-icon=\"icon-content-paste\"></md-icon>Архивировать</md-button><md-button class=\"md-warn\" ng-click=\"closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon>Закрыть</md-button></td></tr><tr></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/my_ownerbase/favownerEditAgentDescriptionDialog.html","<md-dialog aria-label=\"Edit object\'s agent description\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>Заметки</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div>Здесь Вы можете в свободной форме вести заметки по этому собственнику: звонки, встречи, даты и т.п.</div><textarea scroll-glue=\"\" style=\"width: 100%; height: 200px; border: 1px solid #a3a3a3;\" ng-model=\"object_data.note\"></textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"changeAgentDescription(object_data.id,object_data.note)\" class=\"md-primary\">Сохранить</md-button><md-button ng-click=\"closeDialog()\">Закрыть</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/my_ownerbase/favownerEditCallTimeDialog.html","<md-dialog aria-label=\"Edit call description\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>Напоминание о звонке</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div>Если вы договорились о звонке, то можете настроить напоминание.</div><br><span ng-show=\"object_data.calldate_string.length>0\"><b>Выбранная дата напоминания:</b> {{object_data.calldate_string}}<br><br></span><md-datepicker flex=\"200\" flex-gt-xs=\"60\" ng-model=\"object_data.calldate\" md-placeholder=\"Дата звонка\"></md-datepicker>&nbsp; Либо: &nbsp;<md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"true\"><label>Сегодня через</label><md-select ng-model=\"object_data.minutes\"><md-option value=\"20\">20 минут</md-option><md-option value=\"60\">1 час</md-option></md-select></md-input-container><br><br><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"true\">Причина звонка: <textarea ng-model=\"object_data.agent_description\" columns=\"1\" md-maxlength=\"500\" rows=\"2\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"changeCallDate(object_data.id,object_data.calldate,object_data.minutes, object_data.agent_description)\" class=\"md-primary\">Сохранить</md-button><md-button ng-click=\"closeDialog()\">Закрыть</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/my_ownerbase/favownerEditParamsDialog.html","<md-dialog aria-label=\"Edit object\'s agent description\" ng-cloak=\"\"><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>Изменение цены и описания</h2><span flex=\"\"></span></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><div>Здесь Вы можете изменить описание и цену объекта в своей базе собственников. Оригинальная запись не изменится.</div><input type=\"text\" style=\"width: 100%; height: 30px; border: 1px solid #a3a3a3;\" ng-model=\"object_data.price\"> <textarea scroll-glue=\"\" style=\"width: 100%; height: 200px; border: 1px solid #a3a3a3;\" ng-model=\"object_data.description\"></textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"changeFavOwnerParams(object_data.id,object_data.price,object_data.description)\" class=\"md-primary\">Сохранить</md-button><md-button ng-click=\"closeDialog()\">Закрыть</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/my_ownerbase/ownerViewDialog.html","<md-dialog><md-dialog-content><h1>Собственник № {{owner_data.id}}</h1><p><table class=\"objectViewTable\"><tr><td colspan=\"3\" class=\"allRow\"><b>Если Вы совершили звонок и договорились с клиентом о встрече, то обязательно забронируйте объект за собой (в общем списке Базы собственников), чтобы Ваши коллеги не повторяли предложения клиенту от нашего агентства.<br><br></b></td></tr><tr></tr><tr><td><b>Адрес:</b> {{owner_data.street}} (м.{{owner_data.metro}}{{owner_data.from_metro}})</td><td><b>Комнат:</b> {{owner_data.rooms}}</td><td><b>Этаж:</b> {{owner_data.floor}}/{{owner_data.floors}}</td></tr><tr><td><b>Площадь:</b> {{owner_data.square}}</td><td><b>Цена:</b> {{owner_data.price}} руб.</td><td><b>Телефон:</b> {{owner_data.phone}} <span ng-show=\"owner_data.link.length > 0\"><a target=\"_blank\" href=\"{{owner_data.link}}\">Источник</a></span></td></tr><tr><td colspan=\"3\" class=\"allRow\"><b>Описание:</b> {{owner_data.description}}<br><br><md-button class=\"md-warn\" ng-click=\"closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon>Закрыть</md-button></td></tr><tr></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/my_ownerbase/ownerbase.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">Моя база собственников</div></div><div layout=\"row\" layout-align=\"start center\"><md-button ng-show=\"true\" class=\"md-fab\" ng-click=\"vm.filter_room(0, vm.metro_line_filter)\" aria-label=\"All\">Все</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-click=\"vm.filter_room(1, vm.metro_line_filter)\" aria-label=\"1\">1</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-click=\"vm.filter_room(2, vm.metro_line_filter)\" aria-label=\"2\">2</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-click=\"vm.filter_room(3, vm.metro_line_filter)\" aria-label=\"3\">3</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-click=\"vm.filter_room(4, vm.metro_line_filter)\" aria-label=\"4+\">4+</md-button></div></div><div class=\"content\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Линия метро</label><md-select ng-model=\"vm.metro_line_filter\" ng-change=\"vm.filter_room(vm.room_filter, vm.metro_line_filter)\"><md-option value=\"0\">Любая</md-option><md-option ng-repeat=\"metro_line in vm.metro_lines\" value=\"{{metro_line.id}}\">{{metro_line.line_name}}</md-option></md-select></md-input-container><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Дата</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Метро</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Адрес</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Комнат/Этаж</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Цена</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Площадь</span></div></th><th style=\"display: none;\" class=\"secondary-text\"><div class=\"table-header\"></div></th><th style=\"display: none;\" class=\"secondary-text\"><div class=\"table-header\">Описание</div></th></tr></thead><tbody><tr ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"owner in vm.owners\"><td>{{ owner.id }}</td><td><span><md-button class=\"md-primary md-icon-button\" ng-click=\"vm.viewOwner(owner.id)\" aria-label=\"View\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-button class=\"md-primary md-icon-button\" ng-click=\"vm.changePrint(owner.id,owner.printstatus)\" aria-label=\"Set print checkbox\"><md-icon id=\"object_print_{{owner.id}}\" md-font-icon=\"{{owner.printicon}}\"></md-icon></md-button><br><md-button ng-show=\"true\" class=\"md-primary md-icon-button\" aria-label=\"See notes\" ng-click=\"vm.notesFavOwner(owner.fav_id)\"><md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon></md-button><md-button ng-show=\"true\" class=\"md-icon-button\" ng-class=\"owner.callll==1?\'md-warn\':\'md-primary\'\" aria-label=\"Call reminder\" ng-click=\"vm.callFavOwner(owner.fav_id)\"><md-icon md-font-icon=\"icon-phone-outgoing\"></md-icon></md-button><br><md-button ng-show=\"true\" class=\"md-warn md-icon-button\" ng-click=\"vm.archiveFavOwner(owner.fav_id)\" aria-label=\"Delete favorite\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button class=\"md-primary md-icon-button\" ng-click=\"vm.editFavOwner(owner.fav_id)\" aria-label=\"edit owner\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button></span></td><td>{{ owner.NominalDate }}</td><td>{{owner.metro}}<br ng-if=\"owner.from_metro!=\'\'\">{{owner.from_metro}}</td><td>{{ owner.street }}</td><td>{{ owner.rooms }} ({{ owner.floor }} из {{ owner.floors }})</td><td>{{ owner.price }}</td><td>{{ owner.square }}</td><td data-owner-id=\"{{ owner.id }}\" style=\"display: none\">{{ owner.id }}</td><td style=\"display: none;\">{{ owner.description }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/ownerbase/b_ownerViewDialog.html","<md-dialog><md-dialog-content><h1>Собственник № {{owner_data.id}}</h1><p><table class=\"objectViewTable\"><tr><td colspan=\"3\" class=\"allRow\"><b>Если встреча с клиентом прошла успешно, то укажите номер введеного в базу объекта и отправьте эту бронь в архив<br><br></b></td></tr><tr></tr><tr><td><b>Адрес:</b> {{owner_data.street}} (м.{{owner_data.metro}}{{owner_data.from_metro}})</td><td><b>Комнат:</b> {{owner_data.rooms}}</td><td colspan=\"2\"><b>Этаж:</b> {{owner_data.floor}}/{{owner_data.floors}}</td></tr><tr><td><b>Площадь:</b> {{owner_data.square}}</td><td><b>Цена:</b> {{owner_data.price}} руб.</td><td><b>Телефон:</b> {{owner_data.phone}}</td><td><b>Ссылка:</b> {{owner_data.link}}</td></tr><tr><td colspan=\"3\" class=\"allRow\"><b>Описание:</b> {{owner_data.description}}<br><br><input type=\"number\" name=\"object_id\" ng-model=\"object_id\" placeholder=\"Номер объекта\" required=\"\"><md-button class=\"md-primary\" ng-disabled=\"object_id == null\" ng-click=\"owner_archive(owner_data.id, object_id);\" aria-label=\"Book\"><md-icon md-font-icon=\"icon-content-paste\"></md-icon>Архивировать</md-button><md-button class=\"md-warn\" ng-click=\"closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon>Закрыть</md-button></td></tr><tr></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/ownerbase/ownerViewDialog.html","<md-dialog><md-dialog-content><h1>Собственник № {{owner_data.id}}</h1><p><table class=\"objectViewTable\"><tr><td colspan=\"3\" class=\"allRow\"><b>Если Вы совершили звонок и договорились с клиентом о встрече, то обязательно забронируйте объект за собой, чтобы Ваши коллеги не повторяли предложения клиенту от нашего агентства. Бронь будет действительна в течение трех дней<br><br></b></td></tr><tr></tr><tr><td><b>Адрес:</b> {{owner_data.street}} (м.{{owner_data.metro}}{{owner_data.from_metro}})</td><td><b>Комнат:</b> {{owner_data.rooms}}</td><td><b>Этаж:</b> {{owner_data.floor}}/{{owner_data.floors}}</td></tr><tr><td><b>Площадь:</b> {{owner_data.square}}</td><td><b>Цена:</b> {{owner_data.price}} руб.</td><td><b>Телефон:</b> {{owner_data.phone}} <span ng-show=\"owner_data.link.length > 0\"><a target=\"_blank\" href=\"{{owner_data.link}}\">Источник</a></span></td></tr><tr><td colspan=\"3\" class=\"allRow\"><b>Описание:</b> {{owner_data.description}}<br><br><md-button class=\"md-warn\" ng-click=\"closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon>Закрыть</md-button></td></tr><tr></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/ownerbase/ownerbase.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">База собственников</div></div><div layout=\"row\" layout-align=\"start center\"><md-button ng-show=\"true\" class=\"md-fab\" ng-click=\"vm.filter_room(0, vm.metro_line_filter, vm.last1000)\" aria-label=\"All\">Все</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-click=\"vm.filter_room(1, vm.metro_line_filter, vm.last1000)\" aria-label=\"1\">1</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-click=\"vm.filter_room(2, vm.metro_line_filter, vm.last1000)\" aria-label=\"2\">2</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-click=\"vm.filter_room(3, vm.metro_line_filter, vm.last1000)\" aria-label=\"3\">3</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-click=\"vm.filter_room(4, vm.metro_line_filter, vm.last1000)\" aria-label=\"4+\">4+</md-button></div></div><div class=\"content\" ng-show=\"checkRule(53,\'all\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Линия метро</label><md-select ng-model=\"vm.metro_line_filter\" ng-change=\"vm.filter_room(vm.room_filter, vm.metro_line_filter, vm.last1000)\"><md-option value=\"0\">Любая</md-option><md-option ng-repeat=\"metro_line in vm.metro_lines\" value=\"{{metro_line.id}}\">{{metro_line.line_name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':vm.last1000==500}\" ng-click=\"vm.last1000 = (vm.last1000==500)?2000:500; vm.filter_room(vm.room_filter, vm.metro_line_filter, vm.last1000);\"><md-icon md-font-icon=\"icon-check\"></md-icon><span>{{(vm.last1000==500?\'Свежие\':\'За весь период\')}}</span></md-button></md-input-container><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Дата</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Метро</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Адрес</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Комнат/Этаж</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Цена</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Площадь</span></div></th></tr></thead><tbody><tr ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"owner in vm.owners\"><td>{{ owner.id }}<br></td><td><md-button class=\"md-primary md-icon-button\" ng-click=\"vm.viewOwner(owner.id)\" aria-label=\"View\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><br><md-button class=\"md-primary md-icon-button\" ng-click=\"vm.addFavorite(owner.id, owner.my_fav)\" aria-label=\"Add to favorite\"><md-icon md-font-icon=\"icon-star{{(owner.my_fav==null)?\'-outline\':\'\'}}\"></md-icon></md-button><br><span ng-show=\"owner.bookUser_id == vm.userid && checkRule(53,\'all\')\">Просмотр:<md-button class=\"md-warn md-icon-button\" ng-click=\"vm.editOwner(owner.id)\" aria-label=\"Edit owner\"><md-icon md-font-icon=\"icon-chevron-double-right\"></md-icon></md-button>Снять бронь:<md-button class=\"md-warn md-icon-button\" ng-click=\"vm.unbookOwner(owner.id)\" aria-label=\"Unbook\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button><br></span> <a href=\"tel:{{(owner.phone.indexOf(\'+\')>=0 || owner.phone[0]==\'8\')?owner.phone:\'+\'+owner.phone}}\"><md-button class=\"md-primary md-icon-button\" aria-label=\"Call\"><md-icon md-font-icon=\"icon-phone-hangup\"></md-icon></md-button></a></td><td>{{ owner.NominalDate }}</td><td>{{owner.metro}}<br ng-if=\"owner.from_metro!=\'\'\">{{owner.from_metro}}</td><td>{{ owner.street }}</td><td>{{ owner.rooms }} ({{ owner.floor }} из {{ owner.floors }})</td><td>{{ owner.price }}</td><td>{{ owner.square }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/requests/requests.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">Заявки</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':!vm.isArch()}\" href=\"/requests\" ng-click=\"vm.Arch(0)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span>Актуальные</span></md-button><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':vm.isArch()}\" href=\"/requests/archive\" ng-click=\"vm.Arch(1)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span>Архив</span></md-button></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Бронь / Исполнитель</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Тип заявки</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Имя</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Дата</span></div></th></tr></thead><tbody><tr ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"request in ::vm.requests\"><td>{{ request.id }}</td><td><span ng-show=\"request.user_id && request.user_id!=0 && (request.bookTill>0 && !(request.user_id == vm.userid)) && vm.archive == false\"><md-icon md-font-icon=\"icon-account\"></md-icon>{{request.user_name}}</span> <span ng-show=\"(!request.user_id || request.user_id==0 || (request.bookTill<=0 || request.bookTill==null)) && vm.archive == false && checkRule(8,\'all\')\">Забронировать:<md-button class=\"md-primary md-icon-button\" ng-click=\"vm.bookRequest(request.id)\" aria-label=\"Booking\"><md-icon md-font-icon=\"icon-content-paste\"></md-icon></md-button></span> <span ng-show=\"request.user_id == vm.userid && (request.bookTill>0 || request.bookTill==null) && vm.archive == false && checkRule(8,\'all\')\">Обработайте заявку (осталось {{request.bookTill}} ч.):<md-button class=\"md-warn md-icon-button\" ng-click=\"vm.viewRequest(request.id)\" aria-label=\"View request\"><md-icon md-font-icon=\"icon-chevron-double-right\"></md-icon></md-button>Снять бронь:<md-button class=\"md-warn md-icon-button\" ng-click=\"vm.unbookRequest(request.id)\" aria-label=\"Delete object\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></span> <span ng-show=\"vm.archive == true && checkRule(8,\'all\')\">Посмотреть в архиве:<md-button class=\"md-warn md-icon-button\" ng-click=\"vm.viewRequest(request.id)\" aria-label=\"View request\"><md-icon md-font-icon=\"icon-chevron-double-up\"></md-icon></md-button></span></td><td>{{ request.type }}</td><td>{{ request.name }}</td><td>{{ request.date }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/objects/commerce/commerce.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span></div><div class=\"title\">Коммерческие помещения</div></div><div layout=\"row\" layout-align=\"start center\"><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.type_filter == 0}\" ng-click=\"vm.filter_type(0)\" aria-label=\"All\">Все</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.type_filter == 1}\" ng-click=\"vm.filter_type(1)\" aria-label=\"Rent\">А</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.type_filter == 2}\" ng-click=\"vm.filter_type(2)\" aria-label=\"Sale\">П</md-button><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':!vm.isArch()}\" href=\"/objects/commerce\" ng-click=\"vm.Arch(0)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span>Актуальные</span></md-button><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':vm.isArch()}\" href=\"/objects/commerce/archive\" ng-click=\"vm.Arch(1)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span>Архив</span></md-button></div><md-button ng-show=\"!vm.isArch() && checkRule(31,\'all\')\" class=\"add-object-button md-fab md-warn\" ng-click=\"vm.addObject()\" aria-label=\"Add object\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-checkbox ng-hide=\"checkRule(61,\'my\')\" class=\"my-objects-checkbox md-primary\" ng-model=\"vm.onlyMy\" ng-change=\"vm.updateObjectsTable()\">Только мои</md-checkbox></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtIntanceCallback\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" title=\"Виза/Листинг/Публикация\">В/Л/П</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Агент</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Адрес</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Тип объекта</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Площадь</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Цена</span></div></th><th style=\"display: none;\" class=\"secondary-text\"><div class=\"table-header\"></div></th><th class=\"secondary-text\" style=\"display: none;\"><div class=\"table-header\"><span class=\"column-title\">Адрес</span></div></th></tr></thead><tbody><tr ng-show=\"((comobj.group_id == vm.groupid) && checkRule(35,\'my\',\'group\')) || ((comobj.owner_id == vm.userid) && checkRule(35,\'my\') && vm.archive == false) || checkRule(35,\'all\') || checkRule(35,comobj.owner_id,\'user\')\" ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"comobj in vm.commobjects\"><td>{{ comobj.id }}</td><td><md-button ng-show=\"checkRule(36,\'all\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.viewObject(comobj.id, comobj.deal_type)\" aria-label=\"view object\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-button ng-show=\"checkRule(16,\'all\') || checkRule(16,comobj.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changePrint(comobj.id,comobj.printstatus)\" aria-label=\"Set meet status\"><md-icon id=\"object_print_{{comobj.id}}\" md-font-icon=\"{{comobj.printicon}}\"></md-icon></md-button><br><md-button ng-show=\"((comobj.group_id == vm.groupid) && checkRule(35,\'my\',\'group\')) || ((comobj.owner_id == vm.userid) && checkRule(35,\'my\') && vm.archive == false) || checkRule(35,\'all\') || checkRule(35,comobj.owner_id,\'user\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editObject(comobj.id,1)\" aria-label=\"edit object\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button class=\"md-primary md-icon-button\" aria-label=\"pdf\"><a href=\"/functions/get-pdf/commerce/{{ comobj.id }}\" class=\"link-pdf\" style=\"text-decoration: none;color: #000;\" target=\"_blank\">PDF</a></md-button><br><md-button ng-show=\"((comobj.group_id == vm.groupid) && checkRule(34,comobj.group_id,\'group\') && vm.archive == false) || ((comobj.group_id == vm.groupid) && checkRule(37,comobj.group_id,\'group\') && vm.archive == true) || (checkRule(34,\'all\') && vm.archive == false) || (checkRule(37,\'all\') && vm.archive == true) || (checkRule(37,comobj.owner_id,\'user\') && vm.archive == true) || (checkRule(34,comobj.owner_id,\'user\') && vm.archive == false) || (comobj.owner_id == vm.userid && checkRule(37,\'my\') && vm.archive == true) || (comobj.owner_id == vm.userid && checkRule(34,\'my\') && vm.archive == false)\" class=\"md-warn md-icon-button\" ng-click=\"vm.restore_archiveObject(comobj.id)\" aria-label=\"Delete object\"><md-icon md-font-icon=\"{{vm.isArch(\'icon\')}}\"></md-icon></md-button><md-button ng-show=\"(comobj.owner_id == vm.userid || checkRule(35,\'all\'))\" class=\"md-icon-button\" ng-click=\"vm.copyObject(comobj.id)\" aria-label=\"Copy object\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon></md-button></td><td><span style=\"width:110px;display:block\"><md-button ng-show=\"checkRule(32,\'all\') || checkRule(32,comobj.group_id,\'group\') || (comobj.group_id == vm.groupid && checkRule(16,\'my\',\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeVisa(comobj.id,comobj.visa_status)\" aria-label=\"Set visa\"><md-icon id=\"object_visa_{{comobj.id}}\" md-font-icon=\"icon-label{{comobj.visastatus}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(32,\'all\') || checkRule(32,comobj.group_id,\'group\') || (comobj.group_id == vm.groupid && checkRule(16,\'my\',\'group\')))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetVisaError()\" aria-label=\"See visa\"><md-icon md-font-icon=\"icon-label{{comobj.visastatus}}\"></md-icon></md-button><br><md-button ng-show=\"checkRule(33,\'all\') || checkRule(33,comobj.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeListing(comobj.id,comobj.listing_status)\" aria-label=\"Set listing\"><md-icon id=\"object_listing_{{comobj.id}}\" md-font-icon=\"icon-note{{comobj.listingstatus}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(33,\'all\') || checkRule(33,comobj.group_id,\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetListingError()\" aria-label=\"See listing\"><md-icon md-font-icon=\"icon-note{{comobj.listingstatus}}\"></md-icon></md-button><md-button ng-show=\"(checkRule(60,comobj.group_id,\'group\')) || ((comobj.owner_id == vm.userid) && checkRule(60,\'my\') && vm.archive == false) || checkRule(60,\'all\') || checkRule(60,comobj.owner_id,\'user\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editObjectAgentDescription(comobj.id)\" aria-label=\"See listing\"><md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon></md-button><br><md-button ng-show=\"checkRule(57,\'all\') || checkRule(57,comobj.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeVisaP(comobj.id,comobj.visa_publish)\" aria-label=\"Set visa publish\"><md-icon id=\"object_visap_{{comobj.id}}\" md-font-icon=\"icon-star{{comobj.visapublish}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(57,\'all\') || checkRule(57,comobj.group_id,\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetVisaPError()\" aria-label=\"See visa publish\"><md-icon md-font-icon=\"icon-star{{comobj.visapublish}}\"></md-icon></md-button><md-button ng-show=\"(checkRule(19,comobj.group_id,\'group\')) || ((comobj.owner_id == vm.userid) && checkRule(19,\'my\') && vm.archive == false) || checkRule(19,\'all\') || checkRule(19,comobj.owner_id,\'user\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.addBuyer(comobj.id)\" aria-label=\"add client\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></span></td><td>{{ comobj.owner_name }}</td><td>{{ comobj.metro }}<br>{{ comobj.address_str }}</td><td>{{ comobj.object_type }}</td><td>{{ comobj.square_list }}</td><td style=\"color:{{ comobj.cost_color }}\"><span style=\"width:110px;display:block\">{{ comobj.cost }}<md-button ng-show=\"true\" class=\"md-primary md-icon-button\" ng-click=\"vm.showObjectCostHistory(comobj.id)\" aria-label=\"See cost changes\"><md-icon md-font-icon=\"icon-format-list-numbers\"></md-icon></md-button></span></td><td data-object-id=\"{{ comobj.id }}\" style=\"display: none\">{{ comobj.id }}</td><td style=\"display: none\">{{ comobj.metro }}brbr{{ comobj.address_str }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/objects/commerce/objectRentViewDialog.html","<md-dialog><md-dialog-content><p><table class=\"objectViewTable\"><tr><td><img src=\"/logo.jpg\" width=\"224px\" height=\"108px\"></td><td><h3>84957675882<br>first-online.ru<br>info@first-online.ru<br></h3></td><td><h3>Объектом занимается<br><md-icon md-font-icon=\"icon-account-box\" class=\"ng-isolate-scope material-icons\"></md-icon>{{object_data.agent_name}}<br><md-icon md-font-icon=\"icon-phone\" class=\"ng-isolate-scope material-icons\"></md-icon>+7{{object_data.phone_1}}</h3></td></tr></table></p><p><table class=\"objectViewTable\"><tr><td class=\"allRow\"><b>АРЕНДА (Номер объекта:</b> {{object_data.id}})</td></tr><tr><td><b>Адрес:</b><br>{{object_data.region}}</td><td><b>Цена:</b> {{object_data.cost}} ({{object_data.class_bild}})<br><b>Общая площадь:</b> {{object_data.square_all}}<br><b>Цена за 1м2:</b> {{object_data.cost_by_m2}}</td><td><b>Тип объекта:</b> {{object_data.object_type}}</td></tr><tr><td colspan=\"3\" class=\"allRow\">{{object_data.direction}} <b>Станции метро:</b> {{object_data.metro_1}} {{object_data.metro_1_time}} {{object_data.metro_2}} {{object_data.metro_2_time}} {{object_data.metro_3}} {{object_data.metro_3_time}}</td></tr><tr><td><b>Количество помещений:</b> {{object_data.countroom_office}}</td><td><b>Планировка:</b> {{object_data.plan_bild}}</td><td><b>Этаж:</b> {{object_data.story}}/{{object_data.story_count}}</td></tr><tr><td><b>Назначение:</b> {{object_data.commerce_living_type}}</td><td><b>Юридический адрес:</b> {{object_data.commerce_enter}}</td><td><b>Ремонт:</b> {{object_data.repairs}}</td></tr><tr><td><b>Тип дома:</b> {{object_data.type_bild}}</td><td><b>Витрина:</b> {{object_data.showcase}}</td><td><b>Электричество:</b> {{object_data.enegi}}</td></tr><tr><td><b>Эксплуатационные расходы:</b> {{object_data.inet}}</td><td><b>Коммунальные платежи:</b> {{object_data.phone}}</td><td><b>Электрическая мощность:</b> {{object_data.commerce_businesscenter}}</td></tr><tr><td class=\"objectViewDescrRow\"><b>Описание:</b> {{object_data.description}}</td></tr><tr><td colspan=\"3\" class=\"galleryRow\"><div class=\"lightPhotoGallery\"><ul lightgallery=\"\" id=\"lightgallery\" class=\"list-unstyled row\"><li ng-repeat=\"photo in photos\" gallery-repeat-directive=\"\" class=\"col-xs-6 col-sm-4 col-md-3 ng-scope\" data-src=\"{{photo.filename | trusted}}\"><a href=\"\"><img class=\"img-responsive\" ng-src=\"{{photo.filename | trusted}}\" style=\"height: 200px; width: {{photo.width*200/photo.height}}px\"></a></li></ul></div></td></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/objects/commerce/objectSaleViewDialog.html","<md-dialog><md-dialog-content><p><table class=\"objectViewTable\"><tr><td><img src=\"/logo.jpg\" width=\"224px\" height=\"108px\"></td><td><h3>84957675882<br>first-online.ru<br>info@first-online.ru<br></h3></td><td><h3>Объектом занимается<br><md-icon md-font-icon=\"icon-account-box\" class=\"ng-isolate-scope material-icons\"></md-icon>{{object_data.agent_name}}<br><md-icon md-font-icon=\"icon-phone\" class=\"ng-isolate-scope material-icons\"></md-icon>+7{{object_data.phone_1}}</h3></td></tr></table></p><p><table class=\"objectViewTable\"><tr><td class=\"allRow\"><b>ПРОДАЖА (Номер объекта:</b> {{object_data.id}})</td></tr><tr><td><b>Адрес:</b><br>{{object_data.region}}</td><td><b>Цена:</b> {{object_data.cost}} ({{object_data.class_bild}})<br><b>Общая площадь:</b> {{object_data.square_all}}<br><b>Цена за 1м2:</b> {{object_data.cost_by_m2}}</td><td><b>Тип объекта:</b> {{object_data.object_type}}</td></tr><tr><td colspan=\"3\" class=\"allRow\">{{object_data.direction}} <b>Станции метро:</b> {{object_data.metro_1}} {{object_data.metro_1_time}} {{object_data.metro_2}} {{object_data.metro_2_time}} {{object_data.metro_3}} {{object_data.metro_3_time}}</td></tr><tr><td><b>Количество помещений:</b> {{object_data.countroom_office}}</td><td><b>Планировка:</b> {{object_data.plan_bild}}</td><td><b>Этаж:</b> {{object_data.story}}/{{object_data.story_count}}</td></tr><tr><td><b>Назначение:</b> {{object_data.commerce_living_type}}</td><td><b>Юридический адрес:</b> {{object_data.commerce_enter}}</td><td><b>Ремонт:</b> {{object_data.repairs}}</td></tr><tr><td><b>Тип дома:</b> {{object_data.type_bild}}</td><td><b>Витрина:</b> {{object_data.showcase}}</td><td><b>Электричество:</b> {{object_data.enegi}}</td></tr><tr><td><b>Эксплуатационные расходы:</b> {{object_data.inet}}</td><td><b>Коммунальные платежи:</b> {{object_data.phone}}</td><td><b>Электрическая мощность:</b> {{object_data.commerce_businesscenter}}</td></tr><tr><td class=\"objectViewDescrRow\"><b>Описание:</b> {{object_data.description}}</td></tr><tr><td colspan=\"3\" class=\"galleryRow\"><div class=\"lightPhotoGallery\"><ul lightgallery=\"\" id=\"lightgallery\" class=\"list-unstyled row\"><li ng-repeat=\"photo in photos\" gallery-repeat-directive=\"\" class=\"col-xs-6 col-sm-4 col-md-3 ng-scope\" data-src=\"{{photo.filename | trusted}}\"><a href=\"\"><img class=\"img-responsive\" ng-src=\"{{photo.filename | trusted}}\" style=\"height: 200px; width: {{photo.width*200/photo.height}}px\"></a></li></ul></div></td></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/objects/commerce/objectViewDialog.html","<md-dialog><md-dialog-content><p><table class=\"objectViewTable\"><tr><td><h3><md-icon md-font-icon=\"icon-home-modern\" class=\"ng-isolate-scope material-icons\"></md-icon>Логотип</h3></td><td><h3>84957675882<br>first-online.ru<br>info@first-online.ru<br></h3></td><td><h3>Объектом занимается<br><md-icon md-font-icon=\"icon-account-box\" class=\"ng-isolate-scope material-icons\"></md-icon>{{object_data.agent_name}}<br><md-icon md-font-icon=\"icon-phone\" class=\"ng-isolate-scope material-icons\"></md-icon>+7{{object_data.phone_1}}</h3></td></tr></table></p><p><table class=\"objectViewTable\"><tr><td class=\"allRow\"><b>АРЕНДА (Номер объекта:</b> {{object_data.id}})</td></tr><tr><td><b>Адрес:</b><br>{{object_data.region}}</td><td><b>Арендная ставка:</b> {{object_data.rentcost}} ({{object_data.class_bild}})<br><b>Общая площадь:</b> {{object_data.square_all}}<br><b>Цена за 1м2</b> ЗДЕСЬ ЦЕНА</td><td><b>Тип объекта:</b> {{object_data.object_type}}</td></tr><tr><td colspan=\"3\" class=\"allRow\">{{object_data.direction}} <b>Станции метро:</b> {{object_data.metro_1}} {{object_data.metro_1_time}} {{object_data.metro_2}} {{object_data.metro_2_time}} {{object_data.metro_3}} {{object_data.metro_3_time}}</td></tr><tr><td><b>Количество помещений:</b> {{object_data.countroom_office}}</td><td><b>Планировка:</b> {{object_data.plan_bild}}</td><td><b>Этаж:</b> {{object_data.story}}/{{object_data.story_count}}</td></tr><tr><td><b>Назначение:</b> {{object_data.commerce_living_type}}</td><td><b>Юридический адрес:</b> {{object_data.commerce_enter}}</td><td><b>Ремонт:</b> {{object_data.repairs}}</td></tr><tr><td><b>Тип дома:</b> {{object_data.type_bild}}</td><td><b>Витрина:</b> {{object_data.showcase}}</td><td><b>Электричество:</b> {{object_data.enegi}}</td></tr><tr><td><b>Эксплуатационные расходы:</b> {{object_data.inet}}</td><td><b>Коммунальные платежи:</b> {{object_data.phone}}</td><td><b>Электрическая мощность:</b> {{object_data.commerce_businesscenter}}</td></tr><tr><td class=\"objectViewDescrRow\"><b>Описание:</b> {{object_data.description}}</td></tr><tr><td colspan=\"3\" class=\"galleryRow\"><div class=\"lightPhotoGallery\"><ul lightgallery=\"\" id=\"lightgallery\" class=\"list-unstyled row\"><li ng-repeat=\"photo in photos\" gallery-repeat-directive=\"\" class=\"col-xs-6 col-sm-4 col-md-3 ng-scope\" data-src=\"{{photo.filename | trusted}}\"><a href=\"\"><img class=\"img-responsive\" ng-src=\"{{photo.filename | trusted}}\" style=\"height: 200px; width: {{photo.width*200/photo.height}}px\"></a></li></ul></div></td></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/objects/flats/flats.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span></div><div class=\"title\">Квартиры{{vm.ifRent}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button ng-show=\"vm.isArch()\" class=\"md-fab\" style=\"font-size: 10px;width: 75px;border-radius:0;\" ng-class=\"{\'md-primary\':vm.room_filter == -1}\" ng-click=\"vm.filter_room(-1)\" aria-label=\"All\">Проданные</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.room_filter == 0}\" ng-click=\"vm.filter_room(0)\" aria-label=\"All\">Все</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.room_filter == 1}\" ng-click=\"vm.filter_room(1)\" aria-label=\"1\">1</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.room_filter == 2}\" ng-click=\"vm.filter_room(2)\" aria-label=\"2\">2</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.room_filter == 3}\" ng-click=\"vm.filter_room(3)\" aria-label=\"3\">3</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.room_filter == 4}\" ng-click=\"vm.filter_room(4)\" aria-label=\"4+\">4+</md-button><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':!vm.isArch()}\" ng-href=\"{{vm.actuallink}}\" ng-click=\"vm.Arch(0)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span>Актуальные</span></md-button><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':vm.isArch()}\" ng-href=\"{{vm.archivelink}}\" ng-click=\"vm.Arch(1)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span>Архив</span></md-button></div><md-button ng-show=\"!vm.isArch() && checkRule(15,\'all\')\" class=\"add-object-button md-fab md-warn\" ng-click=\"vm.addObject()\" aria-label=\"Add object\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-checkbox ng-hide=\"checkRule(61,\'my\')\" class=\"my-objects-checkbox md-primary\" ng-model=\"vm.onlyMy\" ng-change=\"vm.updateObjectsTable()\">Только мои</md-checkbox></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtIntanceCallback\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" title=\"Виза/Листинг/Публикация\">В/Л/П</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Агент</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Адрес</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Цена</span></div></th><th class=\"secondary-text\" style=\"display: none\"><div class=\"table-header\"><span class=\"column-title\">Фотография</span></div></th><th class=\"secondary-text\" style=\"display: none\"><div class=\"table-header\"><span class=\"column-title\">Агент</span></div></th><th class=\"secondary-text\" style=\"display: none\"><div class=\"table-header\"><span class=\"column-title\">Адрес</span></div></th><th class=\"secondary-text\" ng-show=\"vm.archive == true\"><div class=\"table-header\"><span class=\"column-title\">В архиве с</span></div></th></tr></thead><tbody><tr href=\"#flat{{ flat.id }}\" ng-show=\"(checkRule(19,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(19,\'my\') && vm.archive == false) || checkRule(19,\'all\') || checkRule(19,flat.owner_id,\'user\')\" ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"flat in vm.flats\"><td>{{ flat.id }}</td><td><md-button ng-show=\"checkRule(20,\'all\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.viewObject(flat.id)\" aria-label=\"view object\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-button ng-show=\"checkRule(16,\'all\') || checkRule(16,flat.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changePrint(flat.id,flat.printstatus)\" aria-label=\"Set meet status\"><md-icon id=\"object_print_{{flat.id}}\" md-font-icon=\"{{flat.printicon}}\"></md-icon></md-button><br><md-button ng-show=\"(checkRule(19,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(19,\'my\') && vm.archive == false) || checkRule(19,\'all\') || checkRule(19,flat.owner_id,\'user\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editObject(flat.id,1)\" aria-label=\"edit object\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button ng-show=\"(checkRule(19,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(19,\'my\') && vm.archive == false) || checkRule(19,\'all\') || checkRule(19,flat.owner_id,\'user\')\" class=\"md-primary md-icon-button\" aria-label=\"edit object\"><a href=\"/functions/get-pdf/flat/{{ flat.id }}\" class=\"link-pdf\" style=\"text-decoration: none;color: #000;\" target=\"_blank\">PDF</a></md-button><br><md-button ng-show=\"((flat.group_id == vm.groupid) && checkRule(18,flat.group_id,\'group\') && vm.archive == false) || ((flat.group_id == vm.groupid) && checkRule(21,flat.group_id,\'group\') && vm.archive == true) || (checkRule(18,\'all\') && vm.archive == false) || (checkRule(21,\'all\') && vm.archive == true) || (checkRule(21,flat.owner_id,\'user\') && vm.archive == true) || (checkRule(18,flat.owner_id,\'user\') && vm.archive == false) || (flat.owner_id == vm.userid && checkRule(21,\'my\') && vm.archive == true) || (flat.owner_id == vm.userid && checkRule(18,\'my\') && vm.archive == false)\" class=\"md-warn md-icon-button\" ng-click=\"vm.restore_archiveObject(flat.id)\" aria-label=\"Delete object\"><md-icon md-font-icon=\"{{vm.isArch(\'icon\')}}\"></md-icon></md-button><md-button ng-show=\"(flat.owner_id == vm.userid || checkRule(19,\'all\'))\" class=\"md-icon-button\" ng-click=\"vm.copyObject(flat.id)\" aria-label=\"Copy object\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon></md-button></td><td><span><md-button ng-show=\"checkRule(16,\'all\') || checkRule(16,flat.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeVisa(flat.id,flat.visa_status)\" aria-label=\"Set visa\"><md-icon id=\"object_visa_{{flat.id}}\" md-font-icon=\"icon-label{{flat.visastatus}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(16,\'all\') || checkRule(16,flat.group_id,\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetVisaError()\" aria-label=\"See visa\"><md-icon md-font-icon=\"icon-label{{flat.visastatus}}\"></md-icon></md-button><md-button ng-show=\"(checkRule(19,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(19,\'my\') && vm.archive == false) || checkRule(19,\'all\') || checkRule(19,flat.owner_id,\'user\')\" class=\"md-icon-button\" ng-class=\"flat.callll==1?\'md-warn\':\'md-primary\'\" aria-label=\"Call reminder\" ng-click=\"vm.callToObject(flat.id)\"><md-icon md-font-icon=\"icon-phone-outgoing\"></md-icon></md-button><br><md-button ng-show=\"checkRule(17,\'all\') || checkRule(17,flat.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeListing(flat.id,flat.listing_status)\" aria-label=\"Set listing\"><md-icon id=\"object_listing_{{flat.id}}\" md-font-icon=\"icon-note{{flat.listingstatus}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(17,\'all\') || checkRule(17,flat.group_id,\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetListingError()\" aria-label=\"See listing\"><md-icon md-font-icon=\"icon-note{{flat.listingstatus}}\"></md-icon></md-button><md-button ng-show=\"(checkRule(60,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(60,\'my\') && vm.archive == false) || checkRule(60,\'all\') || checkRule(60,flat.owner_id,\'user\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editObjectAgentDescription(flat.id)\" aria-label=\"See listing\"><md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon></md-button><br><md-button ng-show=\"checkRule(16,\'all\') || checkRule(16,flat.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeMeet(flat.id,flat.meet)\" aria-label=\"Set meet status\"><md-icon id=\"object_meet_{{flat.id}}\" md-font-icon=\"{{flat.meetstatus}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(16,\'all\') || checkRule(16,flat.group_id,\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetMeetError()\" aria-label=\"Set meet status\"><md-icon id=\"object_meet_{{flat.id}}\" md-font-icon=\"{{flat.meetstatus}}\"></md-icon></md-button><md-button ng-show=\"(checkRule(19,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(19,\'my\') && vm.archive == false) || checkRule(19,\'all\') || checkRule(19,flat.owner_id,\'user\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.addBuyer(flat.id)\" aria-label=\"add client\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></span></td><td>{{ flat.owner_name }}</td><td>м.{{ flat.metro }}<br>{{ flat.street }}, {{ flat.house_number }}<br><b>{{ flat.rooms_number }}</b><br>ТОП: <b>{{ flat.tech_8 }} {{ flat.xml_cian }}</b><br>Бонус агенту {{ flat.bordersq_stock }}%<br>Домклик: {{ flat.xml_domclick }} Авито: {{ flat.avito }}<br>Кв: {{flat.flat_number}}</td><td style=\"color:{{ flat.cost_color }}\">{{ flat.cost }}<md-button ng-show=\"true\" class=\"md-primary md-icon-button\" ng-click=\"vm.showObjectCostHistory(flat.id)\" aria-label=\"See cost changes\"><md-icon md-font-icon=\"icon-format-list-numbers\"></md-icon></md-button></td><td style=\"display: none\">{{vm.getFirstPhoto(flat)}}</td><td style=\"display: none\">+7{{flat.phone_1}} ({{ flat.owner_name }})</td><td style=\"display: none\">м.{{ flat.metro }}brbr<br>{{ flat.street }}, {{ flat.house_number }}brbr<br><b>{{ flat.rooms_number }}</b>brbr<br>{{ flat.square_all }} м<sup>2</sup>/ {{ flat.square_living }} м<sup>2</sup> / {{ flat.square_kitchen }} м<sup>2</sup>brbr<br>{{ flat.type_bild }}</td><td ng-show=\"vm.archive == true\">{{flat.archive_date_sort}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/objects/flats/objectViewDialog.html","<md-dialog><md-dialog-content><p><table class=\"objectViewTable\"><tr><td><img src=\"/logo.jpg\" width=\"224px\" height=\"108px\"></td><td><h3>84957675882<br>first-online.ru<br>info@first-online.ru<br></h3></td><td><h3>Объектом занимается<br><md-icon md-font-icon=\"icon-account-box\" class=\"ng-isolate-scope material-icons\"></md-icon>{{object_data.agent_name}}<br><md-icon md-font-icon=\"icon-phone\" class=\"ng-isolate-scope material-icons\"></md-icon>+7{{object_data.phone_1}}</h3></td></tr></table></p><p><table class=\"objectViewTable\"><tr><td class=\"allRow\"><b>ПРОДАЖА (Номер объекта:</b> {{object_data.id}})</td></tr><tr><td colspan=\"3\" class=\"allRow\"></td><td><b>Ютюб:</b> {{object_data.linktour}}</td></tr><tr><td colspan=\"3\" class=\"allRow\">{{object_data.direction}} <b>Станции метро:</b> {{object_data.metro_1}} {{object_data.metro_1_time}} {{object_data.metro_2}} {{object_data.metro_2_time}}</td></tr><tr><td><b>Тип объекта:</b> {{object_data.object_type}}</td><td><b>Адрес:</b><br>{{object_data.region}}</td><td><b>Цена:</b> {{object_data.cost}}</td></tr><tr><td><b>Комнат:</b> {{object_data.rooms_number}}</td><td><b>Общая площадь:</b> {{object_data.square_all}} м<sup>2</sup></td><td><b>Жилая площадь:</b> {{object_data.square_living}} м<sup>2</sup></td></tr><tr><td><b>Тип дома:</b> {{object_data.type_bild}}</td><td><b>Площадь кухни:</b> {{object_data.square_kitchen}} м<sup>2</sup></td><td><b>Площадь комнат:</b> {{object_data.square_rooms}}</td></tr><tr><td><b>Лифт:</b> {{object_data.lift}}</td><td><b>Этаж:</b> {{object_data.story}}/{{object_data.story_count}} <b>Кв:</b> {{object_data.flat_number}}</td><td><b>Ремонт:</b> {{object_data.repairs}}</td></tr><tr><td><b>Балкон:</b> {{object_data.balcony}}</td><td><b>Санузел:</b> {{object_data.type_bathroom}}</td><td><b>Вид из окна:</b> {{object_data.windows}}</td></tr><tr><td><b>Стоимость:</b> {{object_data.inet}}</td><td><b>В собственности:</b> {{object_data.years_own}}</td><td><b>Право собственности:</b> {{object_data.ownership}}</td></tr><tr><td colspan=\"3\" class=\"allRow\"><b>Описание:</b> {{object_data.description}}</td></tr><tr><td colspan=\"3\" class=\"galleryRow\"><div class=\"lightPhotoGallery\"><ul lightgallery=\"\" id=\"lightgallery\" class=\"list-unstyled row\"><li ng-repeat=\"photo in photos\" gallery-repeat-directive=\"\" class=\"col-xs-6 col-sm-4 col-md-3 ng-scope\" data-src=\"{{photo.filename | trusted}}\"><a href=\"\"><img class=\"img-responsive\" ng-src=\"{{photo.filename | trusted}}\" style=\"height: 200px; width: {{photo.width*200/photo.height}}px\"></a></li></ul></div></td></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/objects/flatsrent/flatsrent.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span></div><div class=\"title\">Квартиры{{vm.ifRent}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.room_filter == 0}\" ng-click=\"vm.filter_room(0)\" aria-label=\"All\">Все</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.room_filter == 1}\" ng-click=\"vm.filter_room(1)\" aria-label=\"1\">1</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.room_filter == 2}\" ng-click=\"vm.filter_room(2)\" aria-label=\"2\">2</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.room_filter == 3}\" ng-click=\"vm.filter_room(3)\" aria-label=\"3\">3</md-button><md-button ng-show=\"true\" class=\"md-fab\" ng-class=\"{\'md-primary\':vm.room_filter == 4}\" ng-click=\"vm.filter_room(4)\" aria-label=\"4+\">4+</md-button><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':!vm.isArch()}\" ng-href=\"{{vm.actuallink}}\" ng-click=\"vm.Arch(0)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span>Актуальные</span></md-button><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':vm.isArch()}\" ng-href=\"{{vm.archivelink}}\" ng-click=\"vm.Arch(1)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span>Архив</span></md-button></div><md-button ng-show=\"!vm.isArch() && checkRule(15,\'all\')\" class=\"add-object-button md-fab md-warn\" ng-click=\"vm.addObject()\" aria-label=\"Add object\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-checkbox ng-hide=\"checkRule(61,\'my\')\" class=\"my-objects-checkbox md-primary\" ng-model=\"vm.onlyMy\" ng-change=\"vm.updateObjectsTable()\">Только мои</md-checkbox></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtIntanceCallback\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" title=\"Виза/Листинг/Публикация\">В/Л/П</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Агент</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Адрес</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Цена</span></div></th><th class=\"secondary-text\" style=\"display: none\"><div class=\"table-header\"><span class=\"column-title\">Фотография</span></div></th><th class=\"secondary-text\" style=\"display: none\"><div class=\"table-header\"><span class=\"column-title\">Агент</span></div></th><th class=\"secondary-text\" style=\"display: none\"><div class=\"table-header\"><span class=\"column-title\">Адрес</span></div></th></tr></thead><tbody><tr ng-show=\"(checkRule(19,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(19,\'my\') && vm.archive == false) || checkRule(19,\'all\') || checkRule(19,flat.owner_id,\'user\')\" ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"flat in vm.flats\"><td>{{ flat.id }}</td><td><md-button ng-show=\"checkRule(20,\'all\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.viewObject(flat.id)\" aria-label=\"view object\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-button ng-show=\"checkRule(16,\'all\') || checkRule(16,flat.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changePrint(flat.id,flat.printstatus)\" aria-label=\"Set meet status\"><md-icon id=\"object_print_{{flat.id}}\" md-font-icon=\"{{flat.printicon}}\"></md-icon></md-button><br><md-button ng-show=\"(checkRule(19,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(19,\'my\') && vm.archive == false) || checkRule(19,\'all\') || checkRule(19,flat.owner_id,\'user\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editObject(flat.id,1)\" aria-label=\"edit object\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button ng-show=\"(checkRule(19,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(19,\'my\') && vm.archive == false) || checkRule(19,\'all\') || checkRule(19,flat.owner_id,\'user\')\" class=\"md-primary md-icon-button\" aria-label=\"edit object\"><a href=\"/functions/get-pdf/flat/{{ flat.id }}\" class=\"link-pdf\" style=\"text-decoration: none;color: #000;\" target=\"_blank\">PDF</a></md-button><br><md-button ng-show=\"((flat.group_id == vm.groupid) && checkRule(18,flat.group_id,\'group\') && vm.archive == false) || ((flat.group_id == vm.groupid) && checkRule(21,flat.group_id,\'group\') && vm.archive == true) || (checkRule(18,\'all\') && vm.archive == false) || (checkRule(21,\'all\') && vm.archive == true) || (checkRule(21,flat.owner_id,\'user\') && vm.archive == true) || (checkRule(18,flat.owner_id,\'user\') && vm.archive == false) || (flat.owner_id == vm.userid && checkRule(21,\'my\') && vm.archive == true) || (flat.owner_id == vm.userid && checkRule(18,\'my\') && vm.archive == false)\" class=\"md-warn md-icon-button\" ng-click=\"vm.restore_archiveObject(flat.id)\" aria-label=\"Delete object\"><md-icon md-font-icon=\"{{vm.isArch(\'icon\')}}\"></md-icon></md-button><md-button ng-show=\"(flat.owner_id == vm.userid || checkRule(19,\'all\'))\" class=\"md-icon-button\" ng-click=\"vm.copyObject(flat.id)\" aria-label=\"Copy object\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon></md-button></td><td><span><md-button ng-show=\"checkRule(16,\'all\') || checkRule(16,flat.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeVisa(flat.id,flat.visa_status)\" aria-label=\"Set visa\"><md-icon id=\"object_visa_{{flat.id}}\" md-font-icon=\"icon-label{{flat.visastatus}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(16,\'all\') || checkRule(16,flat.group_id,\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetVisaError()\" aria-label=\"See visa\"><md-icon md-font-icon=\"icon-label{{flat.visastatus}}\"></md-icon></md-button><md-button ng-show=\"(checkRule(19,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(19,\'my\') && vm.archive == false) || checkRule(19,\'all\') || checkRule(19,flat.owner_id,\'user\')\" class=\"md-icon-button\" ng-class=\"flat.callll==1?\'md-warn\':\'md-primary\'\" aria-label=\"Call reminder\" ng-click=\"vm.callToObject(flat.id)\"><md-icon md-font-icon=\"icon-phone-outgoing\"></md-icon></md-button><br><md-button ng-show=\"checkRule(17,\'all\') || checkRule(17,flat.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeListing(flat.id,flat.listing_status)\" aria-label=\"Set listing\"><md-icon id=\"object_listing_{{flat.id}}\" md-font-icon=\"icon-note{{flat.listingstatus}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(17,\'all\') || checkRule(17,flat.group_id,\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetListingError()\" aria-label=\"See listing\"><md-icon md-font-icon=\"icon-note{{flat.listingstatus}}\"></md-icon></md-button><md-button ng-show=\"(checkRule(60,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(60,\'my\') && vm.archive == false) || checkRule(60,\'all\') || checkRule(60,flat.owner_id,\'user\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editObjectAgentDescription(flat.id)\" aria-label=\"See listing\"><md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon></md-button><br><md-button ng-show=\"checkRule(16,\'all\') || checkRule(16,flat.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeMeet(flat.id,flat.meet)\" aria-label=\"Set meet status\"><md-icon id=\"object_meet_{{flat.id}}\" md-font-icon=\"{{flat.meetstatus}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(16,\'all\') || checkRule(16,flat.group_id,\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetMeetError()\" aria-label=\"Set meet status\"><md-icon id=\"object_meet_{{flat.id}}\" md-font-icon=\"{{flat.meetstatus}}\"></md-icon></md-button><md-button ng-show=\"(checkRule(19,flat.group_id,\'group\')) || ((flat.owner_id == vm.userid) && checkRule(19,\'my\') && vm.archive == false) || checkRule(19,\'all\') || checkRule(19,flat.owner_id,\'user\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.addBuyer(flat.id)\" aria-label=\"add client\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></span></td><td>{{ flat.owner_name }}</td><td>м.{{ flat.metro }},<br>{{ flat.street }}, {{ flat.house_number }}<br><b>{{ flat.rooms_number }}</b><br>ТОП: <b>{{ flat.tech_8 }} {{ flat.xml_cian }}</b></td><td style=\"color:{{ flat.cost_color }}\">{{ flat.rentcost }}<md-button ng-show=\"true\" class=\"md-primary md-icon-button\" ng-click=\"vm.showObjectCostHistory(flat.id)\" aria-label=\"See cost changes\"><md-icon md-font-icon=\"icon-format-list-numbers\"></md-icon></md-button></td><td style=\"display: none\">{{vm.getFirstPhoto(flat)}}</td><td style=\"display: none\">+7{{flat.phone_1}} ({{ flat.owner_name }})</td><td style=\"display: none\">м.{{ flat.metro }}brbr<br>{{ flat.street }}, {{ flat.house_number }}brbr<br><b>{{ flat.rooms_number }}</b>brbr<br>{{ flat.square_all }} м<sup>2</sup>/ {{ flat.square_living }} м<sup>2</sup> / {{ flat.square_kitchen }} м<sup>2</sup>brbr<br>{{ flat.type_bild }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/objects/flatsrent/objectViewDialog.html","<md-dialog><md-dialog-content><p><table class=\"objectViewTable\"><tr><td><img src=\"/logo.jpg\" width=\"224px\" height=\"108px\"></td><td><h3>84957675882<br>first-online.ru<br>info@first-online.ru<br></h3></td><td><h3>Объектом занимается<br><md-icon md-font-icon=\"icon-account-box\" class=\"ng-isolate-scope material-icons\"></md-icon>{{object_data.agent_name}}<br><md-icon md-font-icon=\"icon-phone\" class=\"ng-isolate-scope material-icons\"></md-icon>+7{{object_data.phone_1}}</h3></td></tr></table></p><p><table class=\"objectViewTable\"><tr><td class=\"allRow\"><b>ПРОДАЖА (Номер объекта:</b> {{object_data.id}})</td></tr><tr><td><b>Адрес:</b><br>{{object_data.region}}</td><td><b>Цена:</b> {{object_data.cost}}</td><td><b>Тип объекта:</b> {{object_data.object_type}}</td></tr><tr><td colspan=\"3\" class=\"allRow\">{{object_data.direction}} <b>Станции метро:</b> {{object_data.metro_1}} {{object_data.metro_1_time}} {{object_data.metro_2}} {{object_data.metro_2_time}} {{object_data.metro_3}} {{object_data.metro_3_time}}</td></tr><tr><td><b>Комнат:</b> {{object_data.rooms_number}}</td><td><b>Общая площадь:</b> {{object_data.square_all}} м<sup>2</sup></td><td><b>Жилая площадь:</b> {{object_data.square_living}} м<sup>2</sup></td></tr><tr><td><b>Этаж:</b> {{object_data.story}}/{{object_data.story_count}}</td><td><b>Площадь кухни:</b> {{object_data.square_kitchen}} м<sup>2</sup></td><td><b>Площадь комнат:</b> {{object_data.square_rooms}}</td></tr><tr><td><b>Этажность:</b> {{object_data.story_count}}</td><td><b>Лифт:</b> {{object_data.lift}}</td><td><b>Тип дома:</b> {{object_data.type_bild}}</td></tr><tr><td><b>Ремонт:</b> {{object_data.repairs}}</td><td><b>Балкон:</b> {{object_data.balcony}}</td><td><b>Санузел:</b> {{object_data.type_bathroom}}</td></tr><tr><td><b>Вид из окна:</b> {{object_data.windows}}</td><td><b>В собственности:</b> {{object_data.years_own}}</td><td><b>Право собственности:</b> {{object_data.ownership}}</td></tr><tr><td colspan=\"3\" class=\"allRow\"><b>Описание:</b> {{object_data.description}}</td></tr><tr><td colspan=\"3\" class=\"galleryRow\"><div class=\"lightPhotoGallery\"><ul lightgallery=\"\" id=\"lightgallery\" class=\"list-unstyled row\"><li ng-repeat=\"photo in photos\" gallery-repeat-directive=\"\" class=\"col-xs-6 col-sm-4 col-md-3 ng-scope\" data-src=\"{{photo.filename | trusted}}\"><a href=\"\"><img class=\"img-responsive\" ng-src=\"{{photo.filename | trusted}}\" style=\"height: 200px; width: {{photo.width*200/photo.height}}px\"></a></li></ul></div></td></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/objects/suburbian/objectViewDialog.html","<md-dialog><md-dialog-content><h1><md-icon md-font-icon=\"icon-home\" class=\"ng-isolate-scope material-icons\"></md-icon>Объект № {{object_data.id}} {{object_data.object_type_2}}</h1><h3><md-icon md-font-icon=\"icon-account-box\" class=\"ng-isolate-scope material-icons\"></md-icon>{{object_data.agent_name}}<md-icon md-font-icon=\"icon-phone\" class=\"ng-isolate-scope material-icons\"></md-icon>+7{{object_data.phone_1}}</h3><p><table class=\"objectViewTable\"><tr><td><b>Адрес:</b> {{object_data.region}} {{object_data.direction_name}}</td><td><b>Тип объекта:</b> {{object_data.object_type}}</td><td><b>Тип сделки:</b> {{object_data.deal_id}} ({{object_data.deal_type}})</td></tr><tr><td><b>Виза:</b><md-icon md-font-icon=\"{{object_data.visa_status}}\" class=\"ng-isolate-scope material-icons {{object_data.visa_status}}\"></md-icon>{{object_data.visa_date}}</td><td><b>Листинг:</b><md-icon md-font-icon=\"{{object_data.listing_status}}\" class=\"ng-isolate-scope material-icons {{object_data.listing_status}}\"></md-icon>{{object_data.listing_date}}</td><td><b>Публикация:</b><md-icon md-font-icon=\"{{object_data.listing_status}}\" class=\"ng-isolate-scope material-icons {{object_data.visa_publish}}\"></md-icon><a href=\"{{object_data.domain_name}}object/{{object_data.id}}?preview=1\" target=\"_blank\">Посмотреть на сайте</a></td></tr><tr><td colspan=\"3\" class=\"allRow\"><b>Цена:</b> {{object_data.cost}}</td></tr><tr><td><b>Газоснабжение:</b> {{object_data.gas_item}}</td><td><b>Электроснабжение:</b> {{object_data.enegi}}</td><td><b>Отопление:</b> {{object_data.heating}}</td></tr><tr><td><b>Водоснабжение:</b> {{object_data.water_on_item}}</td><td><b>Канализация:</b> {{object_data.sewage_item}}</td><td></td></tr><td><b>Баня:</b> {{object_data.bath_house}}</td><td><b>Сауна:</b> {{object_data.sauna}}</td><td><b>Бассейн:</b> {{object_data.pool}}</td><tr><td>{{object_data.square_living}}</td><td>{{object_data.story_count}}</td><td>{{object_data.earthsq}}{{object_data.square_land}}</td></tr><tr><td><b>Материал дома:</b> {{object_data.type_bild}}</td><td><b>Ремонт:</b> {{object_data.repairs}}</td><td><b>Гараж:</b> {{object_data.count_garage}} {{energi_garage}}</td></tr><tr><td><b>Балкон:</b> {{object_data.balcony}}</td><td><b>Эркер:</b> {{object_data.erker}}</td><td><b>Мансарда:</b> {{object_data.garret}}</td></tr><tr><td><b>Цоколь:</b> {{object_data.socle}}</td><td><b>Интернет:</b> {{object_data.inet}}</td><td><b>Телефон:</b> {{object_data.phone}}</td></tr><td><b>Холодильник:</b> {{object_data.tech_4}}</td><td><b>Стиральная машина:</b> {{object_data.tech_8}}</td><td><b>Мебель:</b> {{object_data.furniture}}</td><tr><td class=\"objectViewDescrRow\"><b>Описание:</b> {{object_data.description}}</td><td colspan=\"2\" class=\"mapRow\"><div class=\"objectViewMap\"><yandex-map center=\"map.center\" zoom=\"map.zoom\"><ymap-marker ng-repeat=\"marker in markers\" coordinates=\"marker.coordinates\" properties=\"marker.properties\" options=\"marker.options\"></ymap-marker></yandex-map></div></td></tr><tr><td colspan=\"3\" class=\"galleryRow\"><div class=\"lightPhotoGallery\"><ul lightgallery=\"\" id=\"lightgallery\" class=\"list-unstyled row\"><li ng-repeat=\"photo in photos\" gallery-repeat-directive=\"\" class=\"col-xs-6 col-sm-4 col-md-3 ng-scope\" data-src=\"{{photo.filename | trusted}}\"><a href=\"\"><img class=\"img-responsive\" ng-src=\"{{photo.filename | trusted}}\" style=\"height: 200px; width: {{photo.width*200/photo.height}}px\"></a></li></ul></div></td></tr></table></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Закрыть</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/objects/suburbian/suburbian.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span></div><div class=\"title\">Дома/земля</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':!vm.isArch()}\" href=\"/objects/suburbian\" ng-click=\"vm.Arch(0)\"><md-icon md-font-icon=\"icon-check\"></md-icon><span>Актуальные</span></md-button><md-button class=\"md-raised md-reference-button\" ng-class=\"{\'md-primary\':vm.isArch()}\" href=\"/objects/suburbian/archive\" ng-click=\"vm.Arch(1)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span>Архив</span></md-button></div><md-button ng-show=\"!vm.isArch() && checkRule(23,\'all\')\" class=\"add-object-button md-fab md-warn\" ng-click=\"vm.addObject()\" aria-label=\"Add object\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-checkbox ng-hide=\"checkRule(61,\'my\')\" class=\"my-objects-checkbox md-primary\" ng-model=\"vm.onlyMy\" ng-change=\"vm.updateObjectsTable()\">Только мои</md-checkbox></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtIntanceCallback\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Действия</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" title=\"Виза/Листинг/Публикация\">В/Л/П</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Агент</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Адрес</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Цена</span></div></th></tr></thead><tbody><tr ng-class=\"$even?\'oddDataTable\':\'evenDataTable\'\" ng-repeat=\"house in vm.houses\"><td>{{ house.id }}</td><td><md-button ng-show=\"checkRule(28,\'all\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.viewObject(house.id)\" aria-label=\"view object\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><br><md-button ng-show=\"(checkRule(27,house.group_id,\'group\')) || ((house.owner_id == vm.userid) && checkRule(27,\'my\') && vm.archive == false) || checkRule(27,\'all\') || checkRule(27,house.owner_id,\'user\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editObject(house.id,1)\" aria-label=\"edit object\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><br><md-button ng-show=\"(checkRule(26,house.group_id,\'group\') && vm.archive == false) || ((house.group_id == vm.groupid) && checkRule(29,house.group_id,\'group\') && vm.archive == true) || (checkRule(26,\'all\') && vm.archive == false) || (checkRule(29,\'all\') && vm.archive == true) || (checkRule(29,house.owner_id,\'user\') && vm.archive == true) || (checkRule(26,house.owner_id,\'user\') && vm.archive == false) || (house.owner_id == vm.userid && checkRule(29,\'my\') && vm.archive == true) || (house.owner_id == vm.userid && checkRule(26,\'my\') && vm.archive == false)\" class=\"md-warn md-icon-button\" ng-click=\"vm.restore_archiveObject(house.id)\" aria-label=\"Delete object\"><md-icon md-font-icon=\"{{vm.isArch(\'icon\')}}\"></md-icon></md-button><md-button ng-show=\"(house.owner_id == vm.userid || checkRule(27,\'all\'))\" class=\"md-icon-button\" ng-click=\"vm.copyObject(house.id)\" aria-label=\"Copy object\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon></md-button></td><td><span><md-button ng-show=\"checkRule(24,\'all\') || checkRule(24,house.group_id,\'group\') || (house.group_id == vm.groupid && checkRule(16,\'my\',\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeVisa(house.id,house.visa_status)\" aria-label=\"Set visa\"><md-icon id=\"object_visa_{{house.id}}\" md-font-icon=\"icon-label{{house.visastatus}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(24,\'all\') || checkRule(24,house.group_id,\'group\') || (house.group_id == vm.groupid && checkRule(16,\'my\',\'group\')))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetVisaError()\" aria-label=\"See visa\"><md-icon md-font-icon=\"icon-label{{house.visastatus}}\"></md-icon></md-button><br><md-button ng-show=\"checkRule(25,\'all\') || checkRule(25,house.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeListing(house.id,house.listing_status)\" aria-label=\"Set listing\"><md-icon id=\"object_listing_{{house.id}}\" md-font-icon=\"icon-note{{house.listingstatus}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(25,\'all\') || checkRule(25,house.group_id,\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetListingError()\" aria-label=\"See listing\"><md-icon md-font-icon=\"icon-note{{house.listingstatus}}\"></md-icon></md-button><md-button ng-show=\"(checkRule(60,house.group_id,\'group\')) || ((house.owner_id == vm.userid) && checkRule(60,\'my\') && vm.archive == false) || checkRule(60,\'all\') || checkRule(60,house.owner_id,\'user\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.editObjectAgentDescription(house.id)\" aria-label=\"See listing\"><md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon></md-button><br><md-button ng-show=\"checkRule(57,\'all\') || checkRule(57,house.group_id,\'group\')\" class=\"md-primary md-icon-button\" ng-click=\"vm.changeVisaP(house.id,house.visa_publish)\" aria-label=\"Set visa publish\"><md-icon id=\"object_visap_{{house.id}}\" md-font-icon=\"icon-star{{house.visapublish}}\"></md-icon></md-button><md-button ng-show=\"!(checkRule(57,\'all\') || checkRule(57,house.group_id,\'group\'))\" class=\"md-primary md-icon-button\" ng-click=\"vm.showSetVisaPError()\" aria-label=\"See visa publish\"><md-icon md-font-icon=\"icon-star{{house.visapublish}}\"></md-icon></md-button></span></td><td>{{ house.owner_name }}</td><td>{{ house.city}} {{ house.street}} {{ house.house_number}}<br>ТОП: <b>{{ house.tech_8 }} {{ house.xml_cian }}</b></td><td style=\"color:{{ house.cost_color }}\">{{ house.cost }}<md-button ng-show=\"true\" class=\"md-primary md-icon-button\" ng-click=\"vm.showObjectCostHistory(house.id)\" aria-label=\"See cost changes\"><md-icon md-font-icon=\"icon-format-list-numbers\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex=\"\" layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon id=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label> <input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate=\"\" translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex=\"\"></div>");
$templateCache.put("app/contacts/clients/editclient/editclient.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Клиенты</span></div><div class=\"title\">Редактирование клиента</div></div></div><div class=\"content\" layout=\"column\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Личные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" placeholder=\"Имя\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"2\" required=\"\"><div ng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Имя должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое имя</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"middlename\" ng-model=\"vm.formWizard.middlename\" placeholder=\"Отчество\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\"><div ng-messages=\"wizardStep1.middlename.$error\" ng-show=\"wizardStep1.middlename.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Отчество должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое отчество</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Фамилия\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\"><div ng-messages=\"wizardStep1.lastname.$error\" ng-show=\"wizardStep1.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Фамилия должна состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткая фамилия</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип</label><md-select ng-model=\"vm.formWizard.type\" required=\"\"><md-option ng-repeat=\"type in vm.types\" value=\"{{type.name}}\">{{type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Статус</label><md-select ng-model=\"vm.formWizard.status\" required=\"\"><md-option ng-repeat=\"status in vm.statuses\" value=\"{{status.name}}\">{{status.rusname}}</md-option></md-select></md-input-container><md-datepicker flex=\"100\" flex-gt-xs=\"30\" ng-model=\"vm.formWizard.birthdate\" md-placeholder=\"Дата рождения\"></md-datepicker></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Контактные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"E-mail\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"wizardStep2.email.$error\" ng-show=\"wizardStep2.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо указать e-mail</span></div><div ng-message=\"pattern\"><span>Проверьте правильность введенного адреса</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основной телефон</label> <input name=\"phone_1\" ng-model=\"vm.formWizard.phone_1\" placeholder=\"Основной телефон\" required=\"\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_1.$error\" ng-show=\"wizardStep2.phone_1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести основной телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительный телефон</label> <input name=\"phone_2\" ng-model=\"vm.formWizard.phone_2\" placeholder=\"Дополнительный телефон\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_2.$error\" ng-show=\"wizardStep2.phone_2.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести дополнительный телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Прочая информация</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><md-input-container class=\"md-block\"><label>Описание, история взаимодействия</label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"350\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.description.$error\" ng-show=\"wizardStep3.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 350 символов</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Дополнительные контактные данные</label> <textarea ng-model=\"vm.formWizard.contacts_description\" columns=\"1\" md-maxlength=\"250\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.contacts_description.$error\" ng-show=\"wizardStep3.contacts_description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 250 символов</span></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Сохранить изменения</md-button></div></ms-form-wizard></div></div>");
$templateCache.put("app/contacts/clients/newclient/newclient.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Клиенты</span></div><div class=\"title\">Новый клиент</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Личные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" placeholder=\"Имя\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"2\" required=\"\"><div ng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Имя должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое имя</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"middlename\" ng-model=\"vm.formWizard.middlename\" placeholder=\"Отчество\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\"><div ng-messages=\"wizardStep1.middlename.$error\" ng-show=\"wizardStep1.middlename.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Отчество должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое отчество</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Фамилия\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\"><div ng-messages=\"wizardStep1.lastname.$error\" ng-show=\"wizardStep1.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Фамилия должна состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткая фамилия</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип</label><md-select ng-model=\"vm.formWizard.type\" required=\"\"><md-option ng-repeat=\"type in vm.types\" value=\"{{type.name}}\">{{type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Статус</label><md-select ng-model=\"vm.formWizard.status\" required=\"\"><md-option ng-repeat=\"status in vm.statuses\" value=\"{{status.name}}\">{{status.rusname}}</md-option></md-select></md-input-container><md-datepicker flex=\"100\" flex-gt-xs=\"30\" ng-model=\"vm.formWizard.birthdate\" md-placeholder=\"Дата рождения\"></md-datepicker></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Контактные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"E-mail\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"wizardStep2.email.$error\" ng-show=\"wizardStep2.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо указать e-mail</span></div><div ng-message=\"pattern\"><span>Проверьте правильность введенного адреса</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основной телефон</label> <input name=\"phone_1\" ng-model=\"vm.formWizard.phone_1\" placeholder=\"Основной телефон\" required=\"\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_1.$error\" ng-show=\"wizardStep2.phone_1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести основной телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительный телефон</label> <input name=\"phone_2\" ng-model=\"vm.formWizard.phone_2\" placeholder=\"Дополнительный телефон\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_2.$error\" ng-show=\"wizardStep2.phone_2.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести дополнительный телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Прочая информация</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><md-input-container class=\"md-block\"><label>Описание, история взаимодействия</label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"350\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.description.$error\" ng-show=\"wizardStep3.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 350 символов</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Дополнительные контактные данные</label> <textarea ng-model=\"vm.formWizard.contacts_description\" columns=\"1\" md-maxlength=\"250\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.contacts_description.$error\" ng-show=\"wizardStep3.contacts_description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 250 символов</span></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Создать клиента</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/contacts/clients_contragents/editclient/editclient.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Контрагенты</span></div><div class=\"title\">Редактирование контрагента</div></div></div><div class=\"content\" layout=\"column\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Личные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" placeholder=\"Имя\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"2\" required=\"\"><div ng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Имя должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое имя</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"middlename\" ng-model=\"vm.formWizard.middlename\" placeholder=\"Отчество\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\"><div ng-messages=\"wizardStep1.middlename.$error\" ng-show=\"wizardStep1.middlename.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Отчество должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое отчество</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Фамилия\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\"><div ng-messages=\"wizardStep1.lastname.$error\" ng-show=\"wizardStep1.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Фамилия должна состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткая фамилия</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип</label><md-select ng-model=\"vm.formWizard.type\" required=\"\"><md-option ng-repeat=\"type in vm.types\" value=\"{{type.name}}\">{{type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.type == \'buyer\'\"><input type=\"number\" name=\"object_id\" ng-model=\"vm.formWizard.object_id\" placeholder=\"Номер объекта\" ng-required=\"vm.formWizard.type == \'buyer\'\"><div ng-messages=\"wizardStep1.object_id.$error\" ng-show=\"wizardStep1.object_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Статус</label><md-select ng-model=\"vm.formWizard.status\" required=\"\"><md-option ng-repeat=\"status in vm.statuses\" value=\"{{status.name}}\">{{status.rusname}}</md-option></md-select></md-input-container><md-datepicker flex=\"100\" flex-gt-xs=\"30\" ng-model=\"vm.formWizard.birthdate\" md-placeholder=\"Дата рождения\"></md-datepicker></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Контактные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"E-mail\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"wizardStep2.email.$error\" ng-show=\"wizardStep2.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо указать e-mail</span></div><div ng-message=\"pattern\"><span>Проверьте правильность введенного адреса</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основной телефон</label> <input name=\"phone_1\" ng-model=\"vm.formWizard.phone_1\" placeholder=\"Основной телефон\" required=\"\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_1.$error\" ng-show=\"wizardStep2.phone_1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести основной телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительный телефон</label> <input name=\"phone_2\" ng-model=\"vm.formWizard.phone_2\" placeholder=\"Дополнительный телефон\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_2.$error\" ng-show=\"wizardStep2.phone_2.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести дополнительный телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Прочая информация</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><md-input-container class=\"md-block\"><label>Описание, история взаимодействия</label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"350\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.description.$error\" ng-show=\"wizardStep3.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 350 символов</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Дополнительные контактные данные</label> <textarea ng-model=\"vm.formWizard.contacts_description\" columns=\"1\" md-maxlength=\"250\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.contacts_description.$error\" ng-show=\"wizardStep3.contacts_description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 250 символов</span></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Сохранить изменения</md-button></div></ms-form-wizard></div></div>");
$templateCache.put("app/contacts/clients_contragents/newclient/newclient.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Контрагенты</span></div><div class=\"title\">Новый контрагент</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Личные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" placeholder=\"Имя\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"2\" required=\"\"><div ng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Имя должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое имя</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"middlename\" ng-model=\"vm.formWizard.middlename\" placeholder=\"Отчество\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\"><div ng-messages=\"wizardStep1.middlename.$error\" ng-show=\"wizardStep1.middlename.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Отчество должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое отчество</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Фамилия\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\"><div ng-messages=\"wizardStep1.lastname.$error\" ng-show=\"wizardStep1.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Фамилия должна состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткая фамилия</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип</label><md-select ng-model=\"vm.formWizard.type\" required=\"\"><md-option ng-repeat=\"type in vm.types\" value=\"{{type.name}}\">{{type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.type == \'buyer\'\"><input type=\"number\" name=\"object_id\" ng-model=\"vm.formWizard.object_id\" placeholder=\"Номер объекта\" ng-required=\"vm.formWizard.type == \'buyer\'\"><div ng-messages=\"wizardStep1.object_id.$error\" ng-show=\"wizardStep1.object_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Статус</label><md-select ng-model=\"vm.formWizard.status\" required=\"\"><md-option ng-repeat=\"status in vm.statuses\" value=\"{{status.name}}\">{{status.rusname}}</md-option></md-select></md-input-container><md-datepicker flex=\"100\" flex-gt-xs=\"30\" ng-model=\"vm.formWizard.birthdate\" md-placeholder=\"Дата рождения\"></md-datepicker></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Контактные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"E-mail\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"wizardStep2.email.$error\" ng-show=\"wizardStep2.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо указать e-mail</span></div><div ng-message=\"pattern\"><span>Проверьте правильность введенного адреса</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основной телефон</label> <input name=\"phone_1\" ng-model=\"vm.formWizard.phone_1\" placeholder=\"Основной телефон\" required=\"\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_1.$error\" ng-show=\"wizardStep2.phone_1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести основной телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительный телефон</label> <input name=\"phone_2\" ng-model=\"vm.formWizard.phone_2\" placeholder=\"Дополнительный телефон\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_2.$error\" ng-show=\"wizardStep2.phone_2.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести дополнительный телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Прочая информация</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><md-input-container class=\"md-block\"><label>Описание, история взаимодействия</label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"350\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.description.$error\" ng-show=\"wizardStep3.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 350 символов</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Дополнительные контактные данные</label> <textarea ng-model=\"vm.formWizard.contacts_description\" columns=\"1\" md-maxlength=\"250\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.contacts_description.$error\" ng-show=\"wizardStep3.contacts_description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 250 символов</span></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Создать контрагента</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/contacts/users/edituser/edituser.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Сотрудники</span></div><div class=\"title\">Редактирование сотрудника</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Личные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" placeholder=\"Имя\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"2\" required=\"\"><div ng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Имя должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое имя</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"middlename\" ng-model=\"vm.formWizard.middlename\" placeholder=\"Отчество\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"3\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Фамилия\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"2\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Отдел</label><md-select ng-model=\"vm.formWizard.group_id\" required=\"\"><md-option ng-repeat=\"group in vm.groups\" value=\"{{group.id}}\">{{group.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Пол</label><md-select ng-model=\"vm.formWizard.sex\"><md-option ng-repeat=\"sex in vm.sex_array\" value=\"{{sex.db_name}}\">{{sex.name}}</md-option></md-select></md-input-container><md-datepicker flex=\"100\" flex-gt-xs=\"30\" ng-model=\"vm.formWizard.birthdate\" md-placeholder=\"Дата рождения\"></md-datepicker></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"booking_qty\" name=\"booking_qty\" ng-model=\"vm.formWizard.booking_qty\" placeholder=\"Число броней в день\"><div ng-messages=\"wizardStep1.booking_qty.$error\" ng-show=\"wizardStep1.booking_qty.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"owners_clicks\" name=\"owners_clicks\" ng-model=\"vm.formWizard.owners_clicks\" placeholder=\"Просмотров базы собственников в день\"><div ng-messages=\"wizardStep1.owners_clicks.$error\" ng-show=\"wizardStep1.owners_clicks.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-switch name=\"active\" ng-model=\"vm.formWizard.active\" aria-label=\"Active/Archive\">Архивный/Активный</md-switch></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Должность</label><md-select ng-model=\"vm.formWizard.position_id\" required=\"\"><md-option ng-repeat=\"position in vm.positions\" value=\"{{position.id}}\">{{position.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"login\" name=\"login\" ng-model=\"vm.formWizard.login\" placeholder=\"Логин\" ng-pattern=\"/[a-zA-Z0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.login.$error\" ng-show=\"wizardStep1.login.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо указать логин</span></div><div ng-message=\"pattern\"><span>Логин должен состоять из цифр и латинских букв</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Контактные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"E-mail\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"wizardStep2.email.$error\" ng-show=\"wizardStep2.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо указать e-mail</span></div><div ng-message=\"pattern\"><span>Проверьте правильность введенного адреса</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основной телефон</label> <input name=\"phone_1\" ng-model=\"vm.formWizard.phone_1\" placeholder=\"Основной телефон\" required=\"\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_1.$error\" ng-show=\"wizardStep2.phone_1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести основной телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительный телефон</label> <input name=\"phone_2\" ng-model=\"vm.formWizard.phone_2\" placeholder=\"Дополнительный телефон\" required=\"\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_2.$error\" ng-show=\"wizardStep2.phone_2.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести дополнительный телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Документы</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><md-input-container class=\"md-block\"><label>Адрес проживания</label> <textarea ng-model=\"vm.formWizard.address\" columns=\"1\" md-maxlength=\"250\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.address.$error\" ng-show=\"wizardStep3.address.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Адрес не должен быть длиннее 250 символов</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Паспортные данные</label> <textarea ng-model=\"vm.formWizard.passport\" columns=\"1\" md-maxlength=\"250\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.passport.$error\" ng-show=\"wizardStep3.passport.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Данные паспорта не должны быть длиннее 250 символов</span></div></div></md-input-container></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">4</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Аватар</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"pb-16\">Аватар добавляется независимо от других данных пользователя. Если Вы просто добавили фотографию, то можете просто выйти из редактирования пользователя - она уже сохранится.<br><br><img ng-src=\"{{vm.photos[0].filename}}\" style=\"width: 150px; height: {{vm.photos[0].height*150/vm.photos[0].width}}px\"></div><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Выберите фотографию</div></div><md-input-container class=\"md-block\"><div class=\"row\"><div class=\"col-md-3\"><h3><md-icon md-font-icon=\"icon-paperclip\" class=\"s16\"></md-icon>Выберите файл:</h3><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" aria-label=\"Photo\"><br></div><div class=\"col-md-9\" style=\"margin-bottom: 40px\"><div ng-show=\"uploader.queue.length\"><md-button class=\"md-raised md-accent\" ng-click=\"uploader.uploadAll();vm.successLoadPhotosMessage();\" ng-disabled=\"!uploader.getNotUploadedItems().length\" aria-label=\"Download all\" ng-show=\"!hideUpload\">Загрузить</md-button></div></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Изменить данные</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/contacts/users/newuser/newuser.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Сотрудники</span></div><div class=\"title\">Новый пользователь</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Личные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" placeholder=\"Имя\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"2\" required=\"\"><div ng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Имя должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое имя</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"middlename\" ng-model=\"vm.formWizard.middlename\" placeholder=\"Отчество\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"3\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Фамилия\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"2\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Отдел</label><md-select ng-model=\"vm.formWizard.group_id\" required=\"\"><md-option ng-repeat=\"group in vm.groups\" value=\"{{group.id}}\">{{group.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Пол</label><md-select ng-model=\"vm.formWizard.sex\"><md-option ng-repeat=\"sex in vm.sex_array\" value=\"{{sex.db_name}}\">{{sex.name}}</md-option></md-select></md-input-container><md-datepicker flex=\"100\" flex-gt-xs=\"30\" ng-model=\"vm.formWizard.birthdate\" md-placeholder=\"Дата рождения\"></md-datepicker></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Должность</label><md-select ng-model=\"vm.formWizard.position_id\" required=\"\"><md-option ng-repeat=\"position in vm.positions\" value=\"{{position.id}}\">{{position.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"login\" name=\"login\" ng-model=\"vm.formWizard.login\" placeholder=\"Логин\" ng-pattern=\"/[a-zA-Z0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.login.$error\" ng-show=\"wizardStep1.login.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо указать логин</span></div><div ng-message=\"pattern\"><span>Логин должен состоять из цифр и латинских букв</span></div></div></md-input-container><md-input-container flex=\"10\" flex-gt-xs=\"5\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.generatePassword()\" aria-label=\"Generate password\"><md-icon md-font-icon=\"icon-key-variant\"></md-icon></md-button></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"password\" ng-model=\"vm.formWizard.password\" placeholder=\"Пароль\" required=\"\"><div ng-messages=\"wizardStep1.password.$error\" ng-show=\"wizardStep1.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Контактные данные</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"E-mail\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"wizardStep2.email.$error\" ng-show=\"wizardStep2.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо указать e-mail</span></div><div ng-message=\"pattern\"><span>Проверьте правильность введенного адреса</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основной телефон</label> <input name=\"phone_1\" ng-model=\"vm.formWizard.phone_1\" placeholder=\"Основной телефон\" required=\"\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_1.$error\" ng-show=\"wizardStep2.phone_1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести основной телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительный телефон</label> <input name=\"phone_2\" ng-model=\"vm.formWizard.phone_2\" placeholder=\"Дополнительный телефон\" required=\"\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\"><div ng-messages=\"wizardStep2.phone_2.$error\" ng-show=\"wizardStep2.phone_2.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести дополнительный телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Документы</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><md-input-container class=\"md-block\"><label>Адрес проживания</label> <textarea ng-model=\"vm.formWizard.address\" columns=\"1\" md-maxlength=\"250\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.address.$error\" ng-show=\"wizardStep3.address.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Адрес не должен быть длиннее 250 символов</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Паспортные данные</label> <textarea ng-model=\"vm.formWizard.passport\" columns=\"1\" md-maxlength=\"250\" rows=\"5\"></textarea><div ng-messages=\"wizardStep3.passport.$error\" ng-show=\"wizardStep3.passport.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Данные паспорта не должны быть длиннее 250 символов</span></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Создать пользователя</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/contacts/groups/editgroup/editgroup.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Отделы</span></div><div class=\"title\">Редактирование отдела \"{{vm.basicForm.name}}\"</div></div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.basicForm.name\" placeholder=\"Название\" ng-minlength=\"5\" required=\"\"><div ng-messages=\"basicForm.name.$error\" ng-show=\"basicForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Необходимо ввести название отдела</span></div><div ng-message=\"minlength\"><span>Слишком короткое название</span></div></div></md-input-container><md-input-container flex=\"\"><label>Офис</label><md-select ng-model=\"vm.basicForm.office_id\" required=\"\"><md-option ng-repeat=\"office in vm.offices\" value=\"{{office.id}}\" \"=\"\">{{office.name}}</md-option></md-select><div ng-messages=\"basicForm.office_id.$error\" ng-show=\"basicForm.office_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Необходимо указать принадлежность к офису</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"date\" ng-model=\"vm.basicForm.date\" placeholder=\"Дата создания\" ng-disabled=\"true\" required=\"\"></md-input-container><md-switch name=\"active\" ng-model=\"vm.basicForm.active\" aria-label=\"Active/Archive\">Архивный/Активный</md-switch></div><div layout=\"column\" layout-gt-sm=\"row\"></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Edit\" ng-disabled=\"basicForm.$invalid\" ng-click=\"vm.sendForm();\">Изменить</md-button></form></div></div></div>");
$templateCache.put("app/contacts/groups/newgroup/newgroup.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Контакты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Отделы</span></div><div class=\"title\">Новый отдел</div></div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.basicForm.name\" placeholder=\"Название\" ng-minlength=\"5\" required=\"\"><div ng-messages=\"basicForm.name.$error\" ng-show=\"basicForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Необходимо ввести название отдела</span></div><div ng-message=\"minlength\"><span>Слишком короткое название</span></div></div></md-input-container><md-input-container flex=\"\"><label>Офис</label><md-select ng-model=\"vm.basicForm.office_id\" required=\"\"><md-option ng-repeat=\"office in vm.offices\" value=\"{{office.id}}\" \"=\"\">{{office.name}}</md-option></md-select><div ng-messages=\"basicForm.office_id.$error\" ng-show=\"basicForm.office_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Необходимо указать принадлежность к офису</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\" ng-click=\"vm.sendForm();\">Создать</md-button></div></form></div></div></div>");
$templateCache.put("app/main/apps/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" ng-class=\"vm.currentMonthClass\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span> <span class=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate=\"\" translate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"CALENDAR.TODAY\">Today</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate=\"\" translate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span translate=\"CALENDAR.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate=\"\" translate-attr-aria-label=\"CALENDAR.WEEK\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Week</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate=\"\" translate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"CALENDAR.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" aria-label=\"Previous\" translate=\"\" translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate=\"\" translate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate=\"\" translate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/apps/file-manager/file-manager.html","<div id=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/file-manager/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header md-accent-bg\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between\"><md-button class=\"md-icon-button main-sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle Main Sidenav\" translate=\"\" translate-attr-aria-label=\"FILE.TOOGLE_MAIN_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"right-side\" layout=\"row\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate=\"\" translate-attr-aria-label=\"FM.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span translate=\"FM.SEARCH\">Search</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'list\'\" class=\"md-icon-button\" ng-click=\"vm.toggleView()\" aria-label=\"view type\" translate=\"\" translate-attr-aria-label=\"FM.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"FM.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'grid\'\" class=\"md-icon-button\" aria-label=\"view type\" ng-click=\"vm.toggleView()\" translate=\"\" translate-attr-aria-label=\"FM.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span translate=\"FM.LIST_VIEW\">List View</span></md-tooltip></md-button></div></div><div class=\"breadcrumb text-truncate\" layout=\"row\" layout-align=\"start center\"><span data-ng-repeat=\"path in vm.path\">{{path}}<md-icon md-font-icon=\"icon-chevron-right\" class=\"icon separator\"></md-icon></span></div></div><md-button class=\"add-file-button md-fab md-warn\" ng-click=\"vm.addFile($event)\" aria-label=\"Add file\" translate=\"\" translate-attr-aria-label=\"FM.ADD_FILE\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-if=\"vm.currentView === \'grid\'\" ng-include=\"\'app/main/apps/file-manager/views/grid/grid-view.html\'\"></div><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/file-manager/views/list/list-view.html\'\"></div></md-content></div><md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"details-sidenav\" ng-include=\"\'app/main/apps/file-manager/sidenavs/details/details-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav></div>");
$templateCache.put("app/main/apps/mail/mail.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/mail/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle Sidenav\" translate=\"\" translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for an e-mail or contact\" translate=\"\" translate-attr-placeholder=\"MAIL.SEARCH_PLACEHOLDER\"></div></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.activeMailPaneIndex === 1\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeReadPane()\" aria-label=\"Back\" translate=\"\" translate-attr-aria-label=\"MAIL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button></div><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.activeMailPaneIndex === 0\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" aria-label=\"{{vm.allChecked?\'Uncheck All\':\'Check All\'}}\" ng-checked=\"vm.allChecked\" ng-click=\"vm.checkAll()\"></md-checkbox><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Filters\" translate=\"\" translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"All\" translate=\"MAIL.ALL\" translate-attr-aria-label=\"MAIL.ALL\">All</md-button></md-menu-item><md-menu-item><md-button aria-label=\"None\" translate=\"MAIL.NONE\" translate-attr-aria-label=\"MAIL.NONE\">None</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Read\" translate=\"MAIL.READ\" translate-attr-aria-label=\"MAIL.READ\">Read</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Unread\" translate=\"MAIL.UNREAD\" translate-attr-aria-label=\"MAIL.UNREAD\">Unread</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Starred\" translate=\"MAIL.STARRED\" translate-attr-aria-label=\"MAIL.STARRED\">Starred</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Unstarred\" translate=\"MAIL.UNSTARRED\" translate-attr-aria-label=\"MAIL.UNSTARRED\">Unstarred</md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button class=\"md-icon-button\" aria-label=\"Archive\" translate=\"\" translate-attr-aria-label=\"MAIL.ARCHIVE\" hide=\"\" show-gt-sm=\"\"><md-icon md-font-icon=\"icon-archive\"></md-icon><md-tooltip><span translate=\"MAIL.ARCHIVE\">Archive</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Spam\" translate=\"\" translate-attr-aria-label=\"MAIL.SPAM\" hide=\"\" show-gt-sm=\"\"><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><md-tooltip><span translate=\"MAIL.SPAM\">Spam</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"MAIL.DELETE\" hide=\"\" show-gt-sm=\"\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"MAIL.DELETE\">Delete</span></md-tooltip></md-button><div class=\"divider-vertical\"></div><md-button class=\"md-icon-button\" aria-label=\"Move to\" translate=\"\" translate-attr-aria-label=\"MAIL.MOVE_TO\" hide=\"\" show-gt-sm=\"\"><md-icon md-font-icon=\"icon-folder\"></md-icon><md-tooltip><span translate=\"MAIL.MOVE_TO\">Move to</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Labels\" translate=\"\" translate-attr-aria-label=\"MAIL.LABELS\" hide=\"\" show-gt-sm=\"\"><md-icon md-font-icon=\"icon-label\"></md-icon><md-tooltip><span translate=\"MAIL.LABELS\">Labels</span></md-tooltip></md-button><md-menu hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Mail Actions\" translate=\"\" translate-attr-aria-label=\"MAIL.ACTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Archive\" translate-attr-aria-label=\"MAIL.ARCHIVE\"><md-icon md-font-icon=\"icon-archive\"></md-icon><span translate=\"MAIL.ARCHIVE\">Archive</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Spam\" translate-attr-aria-label=\"MAIL.SPAM\"><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><span translate=\"MAIL.SPAM\">Spam</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" translate-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"MAIL.DELETE\">Delete</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Move To\" translate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon><span translate=\"MAIL.MOVE_TO\">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Labels\" translate-attr-aria-label=\"MAIL.LABELS\"><md-icon md-font-icon=\"icon-label\"></md-icon><span translate=\"MAIL.LABELS\">Labels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" layout-align=\"start center\" translate-attr-aria-label=\"MAIL.REFRESH\"><span class=\"page-info\" hide-sm=\"\">1 - 100 of 980</span><md-button class=\"md-icon-button arrow\" aria-label=\"Previous\" translate=\"\" translate-attr-aria-label=\"MAIL.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"MAIL.PREVIOUS\">Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" translate=\"\" translate-attr-aria-label=\"MAIL.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span translate=\"MAIL.NEXT\">Next</span></md-tooltip></md-button></div></div><div class=\"content-wrapper\" layout=\"row\" flex=\"\"><md-tabs md-selected=\"vm.activeMailPaneIndex\" class=\"mail-tabs\" md-dynamic-height=\"{{vm.dynamicHeight}}\" flex=\"\"><md-tab><md-tab-label>Mails</md-tab-label><md-tab-body><div class=\"content mail-list-pane\" ng-include=\"\'app/main/apps/mail/views/list/list-view.html\'\" ms-scroll=\"\"></div></md-tab-body></md-tab><md-tab><md-tab-label>Read Pane</md-tab-label><md-tab-body><div class=\"content mail-read-pane\" ng-include=\"\'app/main/apps/mail/views/read/read-view.html\'\" ms-scroll=\"\"></div></md-tab-body></md-tab></md-tabs></div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/scrumboard.html","<div id=\"scrumboard\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"column\"><div class=\"header-content\" layout=\"row\" layout-align=\"space-between\" layout-wrap=\"\" flex=\"\"><div layout=\"row\" layout-align=\"center center\" flex-order=\"1\" flex-order-xs=\"2\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" ng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" ng-click=\"vm.boardSelectorVisible = !vm.boardSelectorVisible\" aria-label=\"boards button\" translate=\"\" translate-attr-aria-label=\"SB.BOARDS_BUTTON\"><md-icon md-font-icon=\"icon-trello\" class=\"icon\"></md-icon><span translate=\"SB.BOARDS\">BOARDS</span></md-button></div><div class=\"header-board-name\" layout=\"row\" layout-align=\"center center\" flex-order=\"2\" flex-order-xs=\"1\" flex-xs=\"100\"><i ng-if=\"vm.board.settings.subscribed\" class=\"board-subscribe s16 icon-eye\"></i> <span editable-text=\"vm.board.name\" onaftersave=\"vm.updateBoardUri()\">{{vm.board.name}}</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" flex-order=\"3\"><md-button ui-sref-active-eq=\"ng-hide\" class=\"md-icon-button\" ui-sref=\"app.scrumboard.boards.board.calendar\" aria-label=\"Calendar\" translate=\"\" translate-attr-aria-label=\"SB.CALENDAR\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-tooltip><span translate=\"SB.CALENDAR\">Calendar</span></md-tooltip></md-button><md-button ui-sref-active-eq=\"ng-hide\" class=\"md-icon-button\" ui-sref=\"app.scrumboard.boards.board\" aria-label=\"Board\" translate=\"\" translate-attr-aria-label=\"SB.BOARD\"><md-icon md-font-icon=\"icon-trello\"></md-icon><md-tooltip><span translate=\"SB.BOARD\">Board</span></md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" class=\"md-icon-button\" ng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate=\"\" translate-attr-aria-label=\"SB.CLEAR_FILTERS\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip sb.clear_filters=\"\">Clear Filters</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate=\"\" translate-attr-aria-label=\"SB.FILTER_CARDS\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip><span translate=\"SB.FILTER_CARDS\">Filter Cards</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" aria-label=\"Settings\" translate=\"\" translate-attr-aria-label=\"SB.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip><span translate=\"SB.SETTINGS\">Settings</span></md-tooltip></md-button></div></div></div><div ng-show=\"vm.boardSelectorVisible\" id=\"board-selector\" class=\"md-accent-bg animate-slide-down board-list md-whiteframe-3dp\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"row\" layout-align=\"start center\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" ui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" layout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex=\"\" class=\"board-name\">{{board.name}}</div><div class=\"board-options\"><i class=\"icon-dots-horizontal\"></i></div><div ng-if=\"board.id === vm.board.id\" class=\"selected-icon green-bg\"><i class=\"icon-check s24\"></i></div></div><div class=\"board-list-item add-new-board\" ui-sref=\"app.scrumboard.boards.addBoard\" ui-sref-active=\"hidden\" layout=\"column\" layout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex=\"\" class=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add New Board</div></div></div><md-backdrop class=\"board-selector-backdrop md-dialog-backdrop md-opaque\" ng-show=\"vm.boardSelectorVisible\" ng-click=\"vm.boardSelectorVisible = false\" aria-hidden=\"true\"></md-backdrop><md-content class=\"content\" flex=\"\" layout=\"column\" ui-view=\"scrumboardContent\"></md-content><md-sidenav class=\"settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html\'\" ng-controller=\"SettingsSidenavController as vm\" ms-sidenav-helper=\"\"></md-sidenav><md-sidenav class=\"filters-sidenav md-sidenav-right\" md-component-id=\"filters-sidenav\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html\'\" ng-controller=\"FiltersSidenavController as vm\" ms-sidenav-helper=\"\"></md-sidenav></div>");
$templateCache.put("app/main/apps/todo/todo.html","<div id=\"todo\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/todo/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"search-wrapper md-whiteframe-4dp\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\" translate=\"\" translate-attr-aria-label=\"TODO.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.taskFilters.search\" type=\"text\" placeholder=\"Search for a task or tag\" translate=\"\" translate-attr-placeholder=\"TODO.SEARCH\"></div></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified\" ng-model=\"vm.selectedFilter.dueDate\" placeholder=\"Due Date\"><md-option value=\"Next 3 days\" translate=\"TODO.NEXT_3_DAYS\">Next 3 days</md-option><md-option value=\"Next 7 days\" translate=\"TODO.NEXT_7_DAYS\">Next 7 days</md-option><md-option value=\"Next 2 weeks\" translate=\"TODO.NEXT_2_WEEKS\">Next 2 weeks</md-option><md-option value=\"Next month\" translate=\"TODO.NEXT_MONTH\">Next month</md-option></md-select><div layout=\"row\" layout-align=\"start center\"><md-select class=\"simplified\" ng-model=\"vm.taskOrder\" placeholder=\"Order\" ng-change=\"vm.taskOrderDescending = vm.taskOrder === \'\' ? false : vm.taskOrderDescending\"><md-option value=\"startDateTimestamp\" translate=\"TODO.START_DATE\">Start Date</md-option><md-option value=\"dueDateTimestamp\" translate=\"TODO.DUE_DATE\">Due Date</md-option><md-option value=\"\" translate=\"TODO.MANUAL\">Manual</md-option><md-option value=\"title\" translate=\"TODO.TITLE\">Title</md-option></md-select><md-button class=\"md-icon-button\" ng-disabled=\"vm.taskOrder === \'\'\" ng-click=\"vm.taskOrderDescending = !vm.taskOrderDescending\" aria-label=\"Sort Direction\" translate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"vm.taskOrderDescending === false\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"vm.taskOrderDescending === true\"></md-icon></md-button></div></div><div class=\"content\" layout=\"row\" flex=\"\"><md-content class=\"todo-list-pane\" flex=\"\" ng-include=\"\'app/main/apps/todo/views/list/list-view.html\'\" ms-scroll=\"vm.msScrollOptions\"></md-content></div></div></div></div>");
$templateCache.put("app/main/components/cards/cards.html","<div id=\"cards\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div class=\"title\">Cards</div></div></div><div class=\"content\" md-background-bg=\"\"><p>Cards are useful for showing excerpts, quick information or notifications. Using <code>ms-card</code> directive you can easily create different cards compatible with Google\'s Material Design specifications.</p><p><code>ms-card</code> directive templates have pre-defined content areas. The reason for that is to force you to create cards that follows both Google\'s Material Design specifications and Fuse Theme\'s general design rules. But of course you can create your own designs and templates and use them with <code>ms-card</code> directive.</p><div><div class=\"md-title mt-32\">Template 1</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-1/template-1.html\'\" ng-model=\"vm.cards[0]\"></ms-card><div class=\"md-title mt-48\">Template 2</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-2/template-2.html\'\" ng-model=\"vm.cards[1]\"></ms-card><div class=\"md-title mt-48\">Template 3</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-3/template-3.html\'\" ng-model=\"vm.cards[2]\"></ms-card><div class=\"md-title mt-48\">Template 4</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-4/template-4.html\'\" ng-model=\"vm.cards[3]\"></ms-card><div class=\"md-title mt-48\">Template 5</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-5/template-5.html\'\" ng-model=\"vm.cards[4]\"></ms-card><div class=\"md-title mt-48\">Template 6</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-6/template-6.html\'\" ng-model=\"vm.cards[5]\"></ms-card><div class=\"md-title mt-48\">Template 7</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-7/template-7.html\'\" ng-model=\"vm.cards[6]\"></ms-card><div class=\"md-title mt-48\">Template 8</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-8/template-8.html\'\" ng-model=\"vm.cards[7]\"></ms-card><div class=\"md-title mt-48\">Template 9</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-9/template-9.html\'\" ng-model=\"vm.cards[8]\"></ms-card><div class=\"md-title mt-48\">Template 10</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-10/template-10.html\'\" ng-model=\"vm.cards[9]\"></ms-card></div></div></div>");
$templateCache.put("app/main/components/maps/maps.html","<div id=\"maps\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div class=\"title\">Maps</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"http://angular-ui.github.io/angular-google-maps/\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><md-tabs md-stretch-tabs=\"\" md-selected=\"vm.selectedIndex\"><md-tab ui-sref=\"app.components_maps\">Simple Map</md-tab><md-tab ui-sref=\"app.components_maps.satellite\">Satellite Map</md-tab><md-tab ui-sref=\"app.components_maps.terrain\">Terrain Map</md-tab><md-tab ui-sref=\"app.components_maps.simple-marker\">Simple Marker</md-tab><md-tab ui-sref=\"app.components_maps.custom-marker\">Custom Marker</md-tab><md-tab ui-sref=\"app.components_maps.info-window\">Info Window</md-tab></md-tabs><md-content ui-view=\"tabContent\" flex=\"\" class=\"card md-whiteframe-4dp\"></md-content></div></div>");
$templateCache.put("app/main/components/material-docs/material-doc-template.html","<div class=\"doc-page material-docs doc-template page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">ANGULAR MATERIAL ELEMENTS</span></div><div class=\"title\">{{vm.componentName}}</div></div></div><div flex=\"\" class=\"content\"><md-tabs md-selected=\"selectedIndex\" md-dynamic-height=\"\"><md-tab ng-if=\"vm.demo\"><md-tab-label>{{vm.demo.label}} (Demo)</md-tab-label><md-tab-body><a class=\"reference-link md-yellow-200-bg\" href=\"https://material.angularjs.org/{{vm.materialVersion}}/demo/{{vm.demo.name}}\" target=\"_blank\">Go to official Angular Material <b>{{vm.demo.name}}</b> demo page</a><docs-demo ng-repeat=\"demo in vm.demos\" demo-id=\"{{demo.id}}\" demo-title=\"{{demo.label}}\" demo-module=\"{{demo.ngModule.module}}\"><demo-file ng-repeat=\"file in demo.$files\" name=\"{{file.name}}\" contents=\"file.httpPromise\"></demo-file></docs-demo></md-tab-body></md-tab><md-tab ng-repeat=\"doc in vm.docs\"><md-tab-label>{{doc.name}} ({{doc.type}})</md-tab-label><md-tab-body><a class=\"reference-link md-yellow-200-bg\" href=\"https://material.angularjs.org/{{vm.materialVersion}}/api/{{doc.type}}/{{doc.name}}\" target=\"_blank\">Go to official Angular Material <b>{{doc.name}} {{doc.type}}</b> documentation page</a><div class=\"\" ng-include=\"\'app/main/components/material-docs/\'+doc.outputPath\"></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/components/price-tables/price-tables.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">PAGES</span></div><div class=\"title\">Price Tables</div></div></div><div class=\"content\"><div class=\"md-title\">Style 1</div><div class=\"price-tables\" flex=\"\" layout=\"row\" layout-wrap=\"\"><div class=\"price-table style-1 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-primary-bg\"><span>BASIC</span></div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value\">4</div><div class=\"period\">/ month</div></div></div><md-divider></md-divider><div class=\"terms\" layout=\"column\"><div class=\"term\"><span class=\"text-bold\">10</span> Projects</div><div class=\"term\"><span class=\"text-bold\">10</span> Pages</div><div class=\"term\"><span class=\"text-bold\">100</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">BUY NOW</md-button></div><div class=\"price-table style-1 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type md-primary-bg\" layout=\"row\" layout-align=\"space-between center\"><span>STANDARD</span> <span class=\"sale md-accent-color md-hue-1\">Save 15%</span></div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value\">8</div><div class=\"period\">/ month</div></div></div><md-divider></md-divider><div class=\"terms\" layout=\"column\"><div class=\"term\"><span class=\"text-bold\">20</span> Projects</div><div class=\"term\"><span class=\"text-bold\">20</span> Pages</div><div class=\"term\"><span class=\"text-bold\">200</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">BUY NOW</md-button></div><div class=\"price-table style-1 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-primary-bg\" layout=\"row\"><span>ADVANCED</span></div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value\">12</div><div class=\"period\">/ month</div></div></div><md-divider></md-divider><div class=\"terms\" layout=\"column\"><div class=\"term\"><span class=\"text-bold\">40</span> Projects</div><div class=\"term\"><span class=\"text-bold\">40</span> Pages</div><div class=\"term\"><span class=\"text-bold\">500</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">BUY NOW</md-button></div></div><div class=\"md-title\">Style 2</div><div class=\"price-tables\" flex=\"\" layout=\"row\" layout-wrap=\"\"><div class=\"price-table style-2 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-accent-fg\">SILVER PACKAGE</div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">99</div></div><div class=\"period\">PER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\"><span class=\"text-bold\">10</span> Projects</div><div class=\"term\"><span class=\"text-bold\">10</span> Pages</div><div class=\"term\"><span class=\"text-bold\">100</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED</md-button></div><div class=\"price-table style-2 md-whiteframe-8dp\" layout=\"column\"><div class=\"badge md-warn-bg\">BEST VALUE</div><div class=\"package-type md-accent-fg\">GOLD PACKAGE</div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">299</div></div><div class=\"period\">PER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\"><span class=\"text-bold\">20</span> Projects</div><div class=\"term\"><span class=\"text-bold\">20</span> Pages</div><div class=\"term\"><span class=\"text-bold\">200</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED</md-button></div><div class=\"price-table style-2 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-accent-fg\">PLATINUM PACKAGE</div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">499</div></div><div class=\"period\">PER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\"><span class=\"text-bold\">40</span> Projects</div><div class=\"term\"><span class=\"text-bold\">40</span> Pages</div><div class=\"term\"><span class=\"text-bold\">500</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED</md-button></div></div><div class=\"md-title\">Style 3</div><div class=\"price-tables\" flex=\"\" layout=\"row\" layout-align=\"start start\" layout-wrap=\"\"><div class=\"price-table style-3 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">Starter</div><div class=\"subtitle\">For small teams</div></div><div class=\"price md-primary-bg md-hue-3\" layout=\"row\" layout-align=\"center start\"><div class=\"currency md-accent-fg\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value md-accent-fg\">29</div><div class=\"period\">monthly per user</div></div></div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div class=\"term\">Unlimited pages</div><div class=\"term\">Unlimited disk space</div><div class=\"term\">24 / 7 Free support</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED FREE</md-button><div class=\"note\">7 day free trial to start</div></div><div class=\"price-table style-3 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">Pro</div><div class=\"subtitle\">For larger teams</div></div><div class=\"price md-primary-bg\" layout=\"row\" layout-align=\"center start\"><div class=\"currency md-accent-fg\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value md-accent-fg\">59</div><div class=\"period\">monthly per user</div></div></div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div class=\"term\">Unlimited pages</div><div class=\"term\">Unlimited disk space</div><div class=\"term\">24 / 7 Free support</div><div class=\"term md-warn-fg\">Advanced reporting</div><div class=\"term md-warn-fg\">Customizable interface</div><div class=\"term md-warn-fg\">CRM Integration</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED FREE</md-button><div class=\"note\">30 day free trial to start</div></div><div class=\"price-table style-3 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">Enterprise</div><div class=\"subtitle\">For big teams</div></div><div class=\"price md-primary-bg md-hue-3\" layout=\"row\" layout-align=\"center start\"><div class=\"currency md-accent-fg\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value md-accent-fg\">99</div><div class=\"period\">monthly per user</div></div></div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div class=\"term\">Unlimited pages</div><div class=\"term\">Unlimited disk space</div><div class=\"term\">For full feature list, call us</div></div><md-button class=\"cta-button md-raised md-accent\">CALL US</md-button><div class=\"note\">90 day free trial to start</div></div></div></div></div>");
$templateCache.put("app/main/components/widgets/widgets.html","<div id=\"widgets\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div class=\"title\">Widgets</div></div></div><div class=\"content\"><p class=\"h3 m-16\">Here you can see some of the other widget styles. These are just tiny example of what you can do with using <code class=\"no-highlight\">ms-widget</code> directive and helper classes. You are not limited to these styles or widgets, you can easily create wide variety of widgets.</p><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget1.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"md-display-1\" layout=\"row\" layout-align=\"start center\"><span>{{vm.widget1.value | number}}</span><md-icon md-font-icon=\"icon-trending-up\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span>Last week: {{vm.widget1.lastWeekValue | number}}</span> <span class=\"text-boxed-light\">{{vm.widget1.lastWeekDiff}}</span></div></div></ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 green-bg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget2.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div><div class=\"md-display-1 pb-16\">{{vm.widget2.value}}%</div><div class=\"pb-16\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget2.value}}\"></md-progress-linear></div></div><div layout=\"row\" layout-align=\"start center\"><span>Last week: {{vm.widget2.lastWeekValue}}%</span> <span class=\"text-boxed-light\">{{vm.widget2.lastWeekDiff}}</span></div></div></ms-widget-front><ms-widget-back class=\"p-16 green-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 blue-grey-bg white-fg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget3.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex=\"\"><div><div class=\"md-display-1 pb-16\">{{vm.widget3.value}}%</div><div class=\"pb-8\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget3.value}}\"></md-progress-linear></div></div><div>See more details...</div></div></ms-widget-front><ms-widget-back class=\"p-16 blue-grey-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 deep-purple-bg white-fg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget4.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"md-display-1 pb-8\" layout=\"row\" layout-align=\"start center\"><span>{{vm.widget4.value | number}}</span><md-icon md-font-icon=\"icon-trending-down\" class=\"s36 ml-16\"></md-icon></div><div>See more details...</div></div></ms-widget-front><ms-widget-back class=\"p-16 deep-purple-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-1 pb-8\">{{vm.widget5.value}}</div><div class=\"font-weight-500 secondary-text\">{{vm.widget5.title}}</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"font-weight-500 secondary-text pb-8\">{{vm.widget6.title}}</div><div class=\"md-display-1\">{{vm.widget6.value}}</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex=\"\"><div class=\"pl-8\" layout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 pb-8\">{{vm.widget7.value}}</span> <span class=\"font-weight-500 secondary-text\">{{vm.widget7.title}}</span></div><div><md-icon md-font-icon=\"icon-thumb-up\" class=\"s48 hint-text\"></md-icon></div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex=\"\"><div><md-icon md-font-icon=\"icon-lock-unlocked\" class=\"s48 hint-text\"></md-icon></div><div class=\"pr-8\" layout=\"column\" layout-align=\"center end\"><div class=\"md-display-1 pb-8\">{{vm.widget8.value}}</div><div class=\"font-weight-500 secondary-text\">{{vm.widget8.title}}</div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 deep-orange-bg white-fg\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-3 pb-8\">{{vm.widget9.value}}</div><div class=\"h3 font-weight-500\">{{vm.widget9.title}}</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-music-note\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 cyan-bg white-fg\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-3 pb-8\">{{vm.widget10.value}}</div><div class=\"h3 font-weight-500\">{{vm.widget10.title}}</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-filmstrip\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 teal-bg white-fg\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-3 pb-8\">{{vm.widget11.value}}</div><div class=\"h3 font-weight-500\">{{vm.widget11.title}}</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-file-document\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 light-blue-bg\" layout=\"column\" flex=\"\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 secondary-text\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"s16 mr-8\"></md-icon><span class=\"font-weight-500\">{{vm.widget12.date}}</span><md-icon md-font-icon=\"icon-arrow-right\" class=\"s16 ml-8\"></md-icon></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"white-fg\" layout=\"column\" layout-align=\"center center\" flex=\"\"><div><md-icon md-font-icon=\"{{vm.widget12.icon}}\" class=\"s96\"></md-icon></div><div class=\"pt-16\" layout=\"row\" layout-align=\"center center\"><div class=\"md-display-2\">{{vm.widget12.temperature}}&deg;</div><div class=\"pl-16\" layout=\"column\"><div class=\"h1 text-semibold\">{{vm.widget12.event}}</div><div class=\"h4 secondary-text\">{{vm.widget12.location}}</div></div></div><div class=\"pt-32\" layout=\"row\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"s16\"></md-icon><span class=\"pl-8\">22 km/h</span></div><div class=\"pl-16\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-compass\" class=\"s16\"></md-icon><span class=\"pl-8\">NW</span></div></div></div></ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg\" layout=\"column\" flex=\"\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"pt-16 pb-16 white-fg\"><span class=\"h1\">Next 5 days</span></div><div class=\"pl-8 pr-8\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start center\" ng-repeat=\"detail in vm.widget12.detail\"><div class=\"h4 pb-8 black-fg secondary-text\">{{detail.day}}</div><md-icon md-font-icon=\"{{detail.icon}}\" class=\"s36 white-fg\"></md-icon><div class=\"h3 pt-8 white-fg\">{{detail.temperature}}&deg;</div></div></div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" flex=\"\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 secondary-text\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"s16 mr-8\"></md-icon><span class=\"font-weight-500\">{{vm.widget13.date}}</span><md-icon md-font-icon=\"icon-arrow-right\" class=\"s16 ml-8\"></md-icon></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"center center\" flex=\"\"><div><md-icon md-font-icon=\"{{vm.widget13.icon}}\" class=\"s96\"></md-icon></div><div class=\"pt-16\" layout=\"row\" layout-align=\"center center\"><div class=\"md-display-2\">{{vm.widget13.temperature}}&deg;</div><div class=\"pl-16\" layout=\"column\"><div class=\"h1 text-semibold\">{{vm.widget13.event}}</div><div class=\"h4 secondary-text\">{{vm.widget13.location}}</div></div></div><div class=\"pt-32\" layout=\"row\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"s16\"></md-icon><span class=\"pl-8\">22 km/h</span></div><div class=\"pl-16\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-compass\" class=\"s16\"></md-icon><span class=\"pl-8\">NW</span></div></div></div></ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg\" layout=\"column\" flex=\"\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"pt-16 pb-16 white-fg\"><span class=\"h1\">Next 5 days</span></div><div class=\"pl-8 pr-8\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start center\" ng-repeat=\"detail in vm.widget13.detail\"><div class=\"h4 pb-8 black-fg secondary-text\">{{detail.day}}</div><md-icon md-font-icon=\"{{detail.icon}}\" class=\"s36 white-fg\"></md-icon><div class=\"h3 pt-8 white-fg\">{{detail.temperature}}&deg;</div></div></div></ms-widget-back></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-16 pb-8 md-accent-bg\"><div class=\"h3\">{{vm.widget14.title}}</div></div><md-tabs class=\"md-accent no-radius\" md-dynamic-height=\"\"><md-tab label=\"{{tab.label}}\" ng-repeat=\"tab in vm.widget14.tabs\"><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div flex=\"100\" flex-gt-md=\"50\" ng-repeat=\"group in tab.groups\"><div class=\"h2 m-16 pb-16 border-bottom\">{{group.title}}</div><div class=\"p-16 pb-32\" ng-repeat=\"data in group.data\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between start\"><span class=\"h3\">{{data.title}}</span> <span class=\"h3 secondary-text font-weight-500\">{{data.value}}%</span></div><md-progress-linear class=\"{{data.progressColor}}\" md-mode=\"determinate\" value=\"{{data.value}}\"></md-progress-linear></div></div></div></md-tab></md-tabs></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 red-bg white-fg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"pb-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget15.title}}</div><div layout=\"row\" layout-align=\"start center\"><div class=\"pr-8\"><md-icon md-font-icon=\"icon-alert\" class=\"s24 hint-text\"></md-icon></div><div class=\"h1 secondary-text\">{{vm.widget15.value}}%</div></div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"cpu-usage\"><chart-column ng-repeat=\"column in vm.widget15.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis><chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-legend show-legend=\"false\"><chart-size chart-height=\"120\"></chart-size></chart-legend></chart-column></c3chart></div></ms-widget-front></ms-widget><ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"pb-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget16.title}}</div><div layout=\"row\" layout-align=\"start center\"><div class=\"h1 secondary-text\">{{vm.widget16.value}}</div><md-icon md-font-icon=\"icon-trending-up\" class=\"mh-8\"></md-icon></div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"stock\"><chart-column ng-repeat=\"column in vm.widget16.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis><chart-axis-x show=\"false\"></chart-axis-x><chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-legend show-legend=\"false\"><chart-size chart-height=\"120\"></chart-size></chart-legend></chart-column></c3chart></div></ms-widget-front></ms-widget><ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"pb-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget17.title}}</div><div class=\"secondary-text\">{{vm.widget17.subtitle}}</div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"io-rate\"><chart-column ng-repeat=\"column in vm.widget17.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis><chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-size chart-height=\"120\"></chart-size></chart-column></c3chart></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 white-bg\"><div layout=\"row\" layout-align=\"space-between\"><div class=\"mr-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget18.title}}</div><div class=\"h1 secondary-text\">{{vm.widget18.value | number}}</div><div class=\"pt-8\" layout=\"row\" layout-align=\"start center\"><div>LW: {{vm.widget18.lastWeekValue | number}}</div><div class=\"text-boxed\">{{vm.widget18.lastWeekDiff}}</div></div></div><c3chart flex=\"\" bindto-id=\"weekly-visitors\"><chart-column ng-repeat=\"column in vm.widget18.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-legend show-legend=\"false\"><chart-bar width=\"10\"><chart-size chart-height=\"240\"></chart-size></chart-bar></chart-legend></chart-column></c3chart></div></ms-widget-front></ms-widget><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 light-blue-bg white-fg\"><div layout=\"row\" layout-align=\"space-between\"><div class=\"mr-16\"><div class=\"h1 weight-500 pb-8\">{{vm.widget19.title}}</div><div class=\"h4 secondary-text weight-500 pb-8\">{{vm.widget19.subtitle}}</div><div layout=\"row\" layout-align=\"start center\"><div class=\"md-display-1 pr-8\">{{vm.widget19.value}}</div><md-icon md-font-icon=\"icon-trending-up\" class=\"s24\"></md-icon></div></div><c3chart flex=\"\" bindto-id=\"goog-nasdaq\"><chart-column ng-repeat=\"column in vm.widget19.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-legend show-legend=\"false\"><chart-bar width=\"10\"><chart-size chart-height=\"240\"></chart-size></chart-bar></chart-legend></chart-column></c3chart></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/pages/coming-soon/coming-soon.html","<div id=\"coming-soon\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"coming-soon-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"coming-soon-form\" class=\"md-whiteframe-8dp\"><div class=\"top\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"COMINGSOON.TITLE\">Hey! Thank you for checking out our app.</div><div class=\"subtitle\" translate=\"COMINGSOON.SUBTITLE\">It’s not quite ready yet, but we are working hard and it will be ready in approximately:</div><timer end-time=\"vm.endTime\" layout=\"row\" layout-wrap=\"\"><div flex-xs=\"50\"><div class=\"value\">{{days}}</div><div class=\"type\" translate=\"COMINGSOON.DAYS\">days</div></div><div flex-xs=\"50\"><div class=\"value\">{{hours}}</div><div class=\"type\" translate=\"COMINGSOON.HOURS\">hours</div></div><div flex-xs=\"50\"><div class=\"value\">{{minutes}}</div><div class=\"type\" translate=\"COMINGSOON.MINUTES\">minutes</div></div><div flex-xs=\"50\"><div class=\"value\">{{seconds}}</div><div class=\"type\" translate=\"COMINGSOON.SECONDS\">seconds</div></div></timer></div><form><div class=\"message\" translate=\"COMINGSOON.MESSAGE\">If you would like to be notified when the app is ready, you can subscribe to our e-mail list.</div><md-input-container flex=\"\" md-no-float=\"\"><input type=\"email\" placeholder=\"Email address\" translate=\"\" translate-attr-placeholder=\"COMINGSOON.EMAIL_ADRESS\"></md-input-container><md-button class=\"md-raised md-accent\" aria-label=\"SUBSCRIBE\" translate=\"COMINGSOON.SUBSCRIBE\" translate-attr-aria-label=\"COMINGSOON.SUBSCRIBE\">SUBSCRIBE</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/invoice/invoice.html","<div id=\"invoice\" class=\"page-layout blank\" layout=\"row\" ms-scroll=\"\"><div class=\"invoice-container\"><div class=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">{{vm.invoice.from.title}}</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>: {{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\"><span translate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.from.website}}</div></div></div><div layout=\"row\" class=\"client\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" layout-align=\"end center\"><div translate=\"INVOICE.CLIENT\">CLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span translate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.client.website}}</div></div></div></div><table class=\"summary\"><tr class=\"code\"><td class=\"label\" translate=\"INVOICE.INVOICE\">INVOICE</td><td class=\"value\">{{vm.invoice.number}}</td></tr><tr><td class=\"label\" translate=\"INVOICE.INVOICE_DATE\">INVOICE DATE</td><td class=\"value\">{{vm.invoice.date}}</td></tr><tr><td class=\"label\" translate=\"INVOICE.DUE_DATE\">DUE DATE</td><td class=\"value\">{{vm.invoice.dueDate}}</td></tr><tr><td class=\"label\" translate=\"INVOICE.TOTAL_DUE\">TOTAL DUE</td><td class=\"value\">{{vm.invoice.total | currency}}</td></tr></table></div><div class=\"content\"><table class=\"simple invoice-table\"><thead><th translate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" translate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th class=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">{{service.title}}</div><div class=\"detail\">{{service.detail}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | currency}}</td></tr></tbody></table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">SUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>{{vm.invoice.tax | currency}}</td></tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>-{{vm.invoice.discount | currency}}</td></tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" translate=\"INVOICE.NOTE\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" layout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE\">In condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"maintenance-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"MAINTENANCE.TITLE\">Closed for scheduled maintenance!</div><div class=\"subtitle\" translate=\"MAINTENANCE.SUBTITLE\">We\'re sorry for the inconvenience.<br>Please check back later.</div></div></div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img class=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"><div class=\"name\">Katherine Wilson</div></div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" aria-label=\"Follow\" translate=\"PROFILE.FOLLOW\" translate-attr-aria-label=\"PROFILE.FOLLOW\">Follow</md-button><md-button class=\"md-raised md-primary\" translate=\"PROFILE.SEND_MESSAGE\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">Send Message</md-button></div></div><div class=\"content\" flex=\"\"><md-tabs md-dynamic-height=\"\"><md-tab><md-tab-label><span translate=\"PROFILE.TIMELINE\">Timeline</span></md-tab-label><md-tab-body><md-content class=\"timeline-tab\" ng-include=\"\'app/main/pages/profile/tabs/timeline/timeline.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"PROFILE.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" ng-include=\"\'app/main/pages/profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"PROFILE.PHOTOS_VIDEOS\">Photos & Videos</span></md-tab-label><md-tab-body><md-content class=\"photos-videos-tab\" ng-include=\"\'app/main/pages/profile/tabs/photos-videos/photos-videos.html\'\"></md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/search/search.html","<div id=\"search\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.search\" type=\"text\" placeholder=\"Search..\" translate=\"\" translate-attr-placeholder=\"SEARCH.SEARCH\" flex=\"\"></div><md-menu class=\"search-settings\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Search settings\" translate=\"\" translate-attr-aria-label=\"SEARCH.SEARCH_SETTINGS\"><md-icon md-menu-origin=\"\" md-menu-align-target=\"\" md-font-icon=\"icon-cog\" class=\"icon s16\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.dummyFunction()\"><p translate=\"SEARCH.SETTINGS_1\">Settings 1</p></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.dummyFunction()\"><p translate=\"SEARCH.SETTINGS_2\">Settings 2</p></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"content\" flex=\"\"><md-tabs md-dynamic-height=\"\"><md-tab label=\"Classic\"><md-content class=\"classic-tab\" ng-include=\"\'app/main/pages/search/tabs/classic/classic.html\'\"></md-content></md-tab><md-tab label=\"Emails\"><md-content class=\"emails-tab\" ng-include=\"\'app/main/pages/search/tabs/emails/emails.html\'\"></md-content></md-tab><md-tab label=\"Users\"><md-content class=\"users-tab\" ng-include=\"\'app/main/pages/search/tabs/users/users.html\'\"></md-content></md-tab><md-tab label=\"Contacts\"><md-content class=\"contacts-tab\" ng-include=\"\'app/main/pages/search/tabs/contacts/contacts.html\'\"></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-left.html","<div id=\"timeline\" class=\"timeline-left\" ms-timeline=\"\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item=\"\" layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">{{timelineItem.event}}</div></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-right.html","<div id=\"timeline\" class=\"timeline-right\" ms-timeline=\"\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item=\"\" layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">{{timelineItem.event}}</div></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline.html","<div id=\"timeline\" layout-column=\"\" flex=\"\" ms-timeline=\"\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item=\"\" layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">{{timelineItem.event}}</div></div></div></div>");
$templateCache.put("app/main/ui/forms/forms.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Forms</div></div></div><div class=\"content\" layout=\"column\"><div class=\"md-title\">Form Wizard</div><div class=\"pb-16\">Form wizard is a combination of md-tabs and forms that we have created for you. You can have as many steps as you want.</div><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Personal Information</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" placeholder=\"Firstname\" required=\"\"><div ng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Lastname\" required=\"\"><div ng-messages=\"wizardStep1.lastname.$error\" ng-show=\"wizardStep1.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><input type=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"wizardStep1.email.$error\" ng-show=\"wizardStep1.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Email field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div></div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"password\" ng-model=\"vm.formWizard.password\" placeholder=\"Password\" required=\"\"><div ng-messages=\"wizardStep1.password.$error\" ng-show=\"wizardStep1.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.formWizard.passwordConfirm\" placeholder=\"Password (Confirm)\" required=\"\"><div ng-messages=\"wizardStep1.passwordConfirm.$error\" ng-show=\"wizardStep1.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Password (Confirm) field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Address</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label>City</label> <input type=\"text\" name=\"city\" ng-model=\"vm.formWizard.city\"></md-input-container><md-input-container flex=\"\"><label>State</label><md-select ng-model=\"vm.formWizard.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Postal Code</label> <input name=\"postalcode\" ng-model=\"vm.formWizard.postalCode\" placeholder=\"12345\" required=\"\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"wizardStep2.postalcode.$error\" ng-show=\"wizardStep2.postalcode.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>You must supply a postal code.</span></div><div ng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><label>Address</label> <textarea ng-model=\"vm.formWizard.address\" columns=\"1\" md-maxlength=\"150\" rows=\"5\" required=\"\"></textarea><div ng-messages=\"wizardStep2.address.$error\" ng-show=\"wizardStep2.address.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Address field is required.</span></div><div ng-message=\"md-maxlength\"><span>Address can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Payment Method</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" ng-model=\"vm.formWizard.cardholder\" placeholder=\"Card Holder\" required=\"\"><div ng-messages=\"wizardStep3.cardholder.$error\" ng-show=\"wizardStep3.cardholder.$dirty\" role=\"alert\"><div ng-message=\"required\"><span>Card holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" ng-model=\"vm.formWizard.cardnumber\" placeholder=\"Card Number\" required=\"\"><div ng-messages=\"wizardStep3.cardnumber.$error\" ng-show=\"wizardStep3.cardnumber.$dirty\" role=\"alert\"><div ng-message=\"required\"><span>Card number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"CC2\" ng-model=\"vm.formWizard.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required=\"\"><div ng-messages=\"wizardStep3.cc2.$error\" ng-show=\"wizardStep3.cc2.$dirty\" role=\"alert\" multipl=\"\"><div ng-message=\"required\"><span>CC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"expirationDate\" ng-model=\"vm.formWizard.expirationDate\" placeholder=\"Expiration Date\" required=\"\"><div ng-messages=\"wizardStep3.expirationDate.$error\" ng-show=\"wizardStep3.expirationDate.$dirty\" role=\"alert\"><div ng-message=\"required\"><span>Expiration date field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Send</md-button></div></ms-form-wizard></div><div class=\"md-title mt-32\">Basic form with validation</div><div class=\"pb-16\">With this form example, Submit button will only be activated if all the required fields are filled and if there is no error on the form.</div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate=\"\"><div class=\"form-title\">Optional form title</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.basicForm.firstname\" placeholder=\"Firstname\" required=\"\"><div ng-messages=\"basicForm.firstname.$error\" ng-show=\"basicForm.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.basicForm.lastname\" placeholder=\"Lastname\" required=\"\"><div ng-messages=\"basicForm.lastname.$error\" ng-show=\"basicForm.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label>City</label> <input type=\"text\" name=\"city\" ng-model=\"vm.basicForm.city\"></md-input-container><md-input-container flex=\"\"><label>State</label><md-select ng-model=\"vm.basicForm.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Postal Code</label> <input name=\"postalcode\" ng-model=\"vm.basicForm.postalCode\" placeholder=\"12345\" required=\"\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"basicForm.postalcode.$error\" ng-show=\"basicForm.postalcode.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>You must supply a postal code.</span></div><div ng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><label>Biography</label> <textarea ng-model=\"vm.basicForm.biography\" columns=\"1\" md-maxlength=\"150\" rows=\"5\"></textarea></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></form></div><div class=\"form-wrapper form-data-wrapper md-whiteframe-1dp\" flex=\"40\"><div class=\"form-title\">Form ng-model data</div><div class=\"json-data-wrapper\"><pre>{{vm.basicForm | json}}</pre></div></div></div></div></div>");
$templateCache.put("app/main/ui/icons/icons.html","<div id=\"icons\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Icons</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"https://materialdesignicons.com/\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\" layout=\"column\"><div id=\"icons-list\" class=\"card md-whiteframe-1dp\" layout=\"row\" layout-wrap=\"\"><div class=\"item\" ng-repeat=\"icon in ::vm.icons track by icon.properties.id\" layout-align=\"start center\"><i class=\"icon icon-{{::icon.properties.name}} s40\"></i><div class=\"name secondary-text text-center\">icon-{{::icon.properties.name}}</div></div></div></div></div>");
$templateCache.put("app/main/ui/material-colors/material-colors.html","<div id=\"material-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Material Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><md-tabs class=\"color-tabs\" md-dynamic-height=\"\" md-swipe-content=\"\"><md-tab ng-repeat=\"(paletteName, palette) in vm.palettes\" md-on-select=\"vm.selected = paletteName; vm.selectedPalette = palette\"><md-tab-label><span class=\"text-capitalize\">{{paletteName}}</span></md-tab-label></md-tab></md-tabs><md-content class=\"color-tab\"><div class=\"h3 pb-16\">Fuse has classes for every single color from <a href=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" target=\"_blank\">Material Design Color Palette</a> for your convenient. You can use them with pretty much every element except Angular Material directives.</div><div class=\"color-header colored-bg\" ng-class=\"\'md-\'+vm.selected+\'-bg\'\" layout=\"row\" layout-align=\"start start\" layout-wrap=\"\" layout-padding=\"\"><div flex=\"100\"><h3 class=\"text-capitalize\">{{vm.selected}}</h3></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div>500</div><div>rgb({{vm.selectedPalette[\'500\'].value[0]}},{{vm.selectedPalette[\'500\'].value[1]}},{{vm.selectedPalette[\'500\'].value[2]}})</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"colored-bg\" ng-repeat=\"(hue, hueValue) in vm.selectedPalette\" flex=\"100\" layout=\"row\" layout-sm=\"column\" layout-padding=\"\" ng-class=\"vm.selected+\'-\'+hue+\'-bg\'\"><div flex=\"\">{{hue}}</div><div class=\"colored-bg\" ng-class=\"\'md-\'+vm.selected+\'-\'+hue+\'-bg\'\" flex=\"\">.{{\'md-\'+vm.selected+\'-\'+hue+\'-bg\'}}</div><div flex=\"\">.{{vm.selected+\'-\'+hue+\'-bg\'}}</div><div class=\"fg-box white-bg md-whiteframe-2dp\" ng-class=\"vm.selected+\'-\'+hue+\'-fg\'\">.{{vm.selected+\'-\'+hue+\'-fg\'}}</div></div></div></md-content></div></div>");
$templateCache.put("app/main/ui/theme-colors/theme-colors.html","<div id=\"theme-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Theme Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-warn reference-button\" ng-click=\"vm.createTheme($event);\"><md-icon md-font-icon=\"icon-palette\"></md-icon><span>Create Your Own Theme!</span></md-button></div></div><div class=\"content\"><md-tabs class=\"color-tabs\" md-dynamic-height=\"\" md-swipe-content=\"\" md-stretch-tabs=\"always\"><md-tab label=\"Primary Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/primary/primary.html\'\"></md-content></md-tab><md-tab label=\"Accent Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/accent/accent.html\'\"></md-content></md-tab><md-tab label=\"Warn Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/warn/warn.html\'\"></md-content></md-tab><md-tab label=\"Background Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/background/background.html\'\"></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/typography/typography.html","<div id=\"typography\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Typography</div></div><div class=\"content\"><div class=\"md-title\">Material design headings</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">112px</div><span class=\"md-display-4\">Display 4</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-display-4\">Display 4</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">56px</div><span class=\"md-display-3\">Display 3</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-display-3\">Display 3</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">45px</div><span class=\"md-display-2\">Display 2</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-display-2\">Display 2</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">34px</div><span class=\"md-display-1\">Display 1</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-display-1\">Display 1</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">24px</div><span class=\"md-headline\">Headline</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-headline\">Headline</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">20px</div><span class=\"md-title\">Title</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-title\">Title</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">16px</div><span class=\"md-subhead\">Subhead</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-subhead\">Subhead</span></hljs></div></div><div class=\"md-title\">Headings</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">24px</div><h1>Heading 1</h1></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h1>Heading 1</h1><div class=\"h1\">Heading 1</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">20px</div><h2>Heading 2</h2></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h2>Heading 2</h2><div class=\"h2\">Heading 2</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">16px</div><h3>Heading 3</h3></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h3>Heading 3</h3><div class=\"h3\">Heading 3</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">14px</div><h4>Heading 4</h4></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h4>Heading 4</h4><div class=\"h4\">Heading 4</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">13px</div><h5>Heading 5</h5></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h5>Heading 5</h5><div class=\"h5\">Heading 5</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">12px</div><h6>Heading 6</h6></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h6>Heading 6</h6><div class=\"h6\">Heading 6</div></hljs></div></div><div class=\"md-title\">Inline text elements</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is a<mark>marked</mark>text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is a<mark>marked</mark>text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><del>This is a deleted text.</del></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><del>This is a deleted text.</del></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><s>This is a strike-through text.</s></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><s>This is a strike-through text.</s></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><u>This is an underlined text.</u></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><u>This is an underlined text.</u></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><small>This is a small text.</small></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><small>This is a small text.</small></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><strong>This is a strong text.</strong></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scrollx=\"\"><strong>This is a strong text.</strong></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><em>This is an italic text.</em></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><em>This is an italic text.</em></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is a <span class=\"text-super\">super</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is a <span class=\"text-super\">super</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is a <span class=\"text-sub\">sub</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is a <span class=\"text-sub\">sub</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is a <span class=\"text-capitalize\">capitalized</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is a <span class=\"text-capitalized\">capitalized</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is an <span class=\"text-uppercase\">uppercase</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is an <span class=\"text-uppercase\">uppercase</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is a <span class=\"text-lowercase\">LOWERCASE</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is a <span class=\"text-lowercase\">LOWERCASE</span> text.</hljs></div></div><div class=\"md-title\">Abbrevations</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><abbr title=\"Angular JS\">Angular JS</abbr></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><abbr title=\"Angular JS\">Angular JS</abbr></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><abbr title=\"Cascaded Style Sheet\">CSS</abbr></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><abbr title=\"Cascaded Style Sheet\">CSS</abbr></hljs></div></div><div class=\"md-title\">Blockquotes</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer></blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer></blockquote></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><blockquote class=\"reverse\"><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer></blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><blockquote class=\"reverse\"><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer></blockquote></hljs></div></div><div class=\"md-title\">Lists</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><ul><li>Unordered list item</li><li>Unordered list item</li><li>Unordered list item</li><li>Unordered list item</li></ul></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><ul><li>Unordered list item</li><li>Unordered list item</li><li>Unordered list item</li><li>Unordered list item</li></ul></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><ol><li>Ordered list item</li><li>Ordered list item</li><li>Ordered list item</li><li>Ordered list item</li></ol></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><ol><li>Ordered list item</li><li>Ordered list item</li><li>Ordered list item</li><li>Ordered list item</li></ol></hljs></div></div><div class=\"md-title\">Definition lists</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><dl><dt>Definition term</dt><dd>This is the definition description</dd><dt>Another definition term</dt><dd>This is also another definition description</dd></dl></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><dl><dt>Definition term</dt><dd>This is the definition description</dd><dt>Another definition term</dt><dd>This is also another definition description</dd></dl></hljs></div></div><div class=\"md-title\">Other helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"text-left\">Left aligned text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"text-left\">Left aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"text-center\">Center aligned text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"text-center\">Center aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"text-right\">Right aligned text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"text-right\">Right aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><p><span class=\"text-boxed\">Boxed text</span></p></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><p><span class=\"text-boxed\">Boxed text</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><p><span class=\"text-strike\">Strike-through text</span></p></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><p><span class=\"text-strike\">Strike-through text</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"text-italic\">Italic text</div><div class=\"text-semibold\">Semi-bold text</div><div class=\"text-bold\">Bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"text-italic\">Italic text</div><div class=\"text-semibold\">Semi-bold text</div><div class=\"text-bold\">Bold text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"text-truncate\">This is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa fermentum dictum. Aenean mollis molestie felis, ut interdum ex vehicula a.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><span class=\"text-truncate\">This is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa fermentum dictum. Aenean mollis molestie felis, ut interdum ex vehicula a.</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption mb-16\">Font weight helpers from 100 to 900</div><span class=\"font-weight-100\">font-weight: 100</span> <span>...</span> <span class=\"font-weight-900\">font-weight: 900</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><span class=\"font-weight-100\">font-weight: 100</span> ... <span class=\"font-weight-900\">font-weight: 900</span></hljs></div></div></div></div>");
$templateCache.put("app/modules/deals/editdeal/editdeal.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Сделки</span></div><div class=\"title\">Редактирование сделки № {{vm.dealName}}<md-button class=\"md-raised md-primary md-reference-button\" ng-show=\"(vm.userid == deal.agent_id && checkRule(47,\'my\') && vm.archive == false) || (vm.userid == deal.agent_id && checkRule(48,\'my\') && vm.archive == true) || (checkRule(47,deal.group_id,\'group\') && vm.archive == false) || (checkRule(48,deal.group_id,\'group\') && vm.archive == true) || (checkRule(47,\'all\') && vm.archive == false) || (checkRule(48,\'all\') && vm.archive == true)\" ng-click=\"vm.restore_archivedeal(vm.dealId)\" aria-label=\"Delete/Restore deal\"><md-icon md-font-icon=\"icon-archive\"></md-icon><span>{{vm.isArch()}}</span></md-button></div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки</label><md-select ng-model=\"vm.formWizard.deal_type\" required=\"\" ng-disabled=\"!checkRule(45,\'all\')\"><md-option ng-repeat=\"deal_type_var in vm.deal_types\" value=\"{{deal_type_var.name}}\">{{deal_type_var.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта</label><md-select ng-model=\"vm.formWizard.object_type\" required=\"\" ng-disabled=\"!checkRule(45,\'all\')\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select><div ng-messages=\"vm.wizardStep1.object_type.$error\" ng-show=\"vm.wizardStep1.object_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Инвестиционная</label><md-select ng-model=\"vm.formWizard.invest\" ng-disabled=\"!checkRule(45,\'all\')\"><md-option ng-repeat=\"invest in vm.yes_no_array\" value=\"{{invest.name}}\">{{invest.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"object_id\" ng-model=\"vm.formWizard.object_id\" placeholder=\"Номер объекта\" ng-required=\"(vm.formWizard.deal_type==\'sell\')\" ng-disabled=\"(vm.formWizard.deal_type!=\'sell\' || !checkRule(45,\'all\'))\" ng-change=\"vm.loadObjectAddress()\"><div ng-messages=\"vm.wizardStep1.object_id.$error\" ng-show=\"vm.wizardStep1.object_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>При статусе продажа поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"object_address\" ng-model=\"vm.formWizard.object_address\" placeholder=\"Местоположение\" ng-required=\"vm.formWizard.deal_type!=\'sell\'\" ng-disabled=\"vm.formWizard.deal_type==\'sell\' || !checkRule(45,\'all\')\"><div ng-messages=\"vm.wizardStep1.object_address.$error\" ng-show=\"vm.wizardStep1.object_address.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"client_id\" ng-model=\"vm.formWizard.client_id\" placeholder=\"Номер клиента\" ng-disabled=\"!checkRule(45,\'all\')\" ng-pattern=\"/[0-9]$/\" ng-change=\"vm.loadClientName()\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"client_name\" ng-model=\"vm.formWizard.client_name\" placeholder=\"Имя клиента\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"seller_id\" ng-model=\"vm.formWizard.seller_id\" placeholder=\"Номер продавца\" ng-pattern=\"/[0-9]$/\" ng-disabled=\"!checkRule(45,\'all\')\" ng-change=\"vm.loadSellerName()\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"seller_name\" ng-model=\"vm.formWizard.seller_name\" placeholder=\"Имя продавца\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Статус сделки</label><md-select ng-model=\"vm.formWizard.status\" required=\"\" ng-disabled=\"!checkRule(45,\'all\')\"><md-option ng-repeat=\"status in vm.status_types\" value=\"{{status.id}}\">{{status.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"request_id\" ng-model=\"vm.formWizard.request_id\" placeholder=\"Номер заявки (если есть)\" ng-disabled=\"!checkRule(45,\'all\')\" ng-pattern=\"/[0-9]$/\"></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Участники и финансы</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Сумма сделки (руб.)\" ng-disabled=\"!checkRule(45,\'all\')\" required=\"\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"comission\" ng-model=\"vm.formWizard.comission\" placeholder=\"Агентская комиссия (руб.)\" ng-disabled=\"!checkRule(45,\'all\')\" required=\"\"><div ng-messages=\"wizardStep1.comission.$error\" ng-show=\"wizardStep1.comission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"access_user_id\" ng-model=\"vm.formWizard.access_user_id\" placeholder=\"Номер агента\" ng-disabled=\"!checkRule(45,\'all\')\" ng-change=\"vm.loadAgentName(1)\" required=\"\"><div ng-messages=\"wizardStep1.access_user_id.$error\" ng-show=\"wizardStep1.access_user_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Обязательно указать агента</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"agent1name\" ng-model=\"vm.formWizard.agent1name\" placeholder=\"Агент\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"fee_sub0\" ng-model=\"vm.formWizard.fee_sub0\" placeholder=\"Комиссия агента (%)\" ng-pattern=\"/^(0|[1-9]\\d{1,2}?)$/\" min=\"0\" max=\"100\" ng-disabled=\"!checkRule(45,\'all\')\" required=\"\"><div ng-messages=\"wizardStep1.fee_sub0.$error\" ng-show=\"wizardStep1.fee_sub0.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.formWizard.fee_sub0>0\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"access_subagent1_id\" ng-model=\"vm.formWizard.access_subagent1_id\" placeholder=\"Номер субагента\" ng-disabled=\"!checkRule(45,\'all\')\" ng-change=\"vm.loadAgentName(2)\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"agent2name\" ng-model=\"vm.formWizard.agent2name\" placeholder=\"Субгент\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"fee_sub1\" ng-model=\"vm.formWizard.fee_sub1\" placeholder=\"Комиссия субагента (%)\" ng-disabled=\"!checkRule(45,\'all\')\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" min=\"0\" max=\"100\" ng-required=\"vm.formWizard.access_subagent1_id\"><div ng-messages=\"wizardStep1.fee_sub1.$error\" ng-show=\"wizardStep1.fee_sub1.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.formWizard.fee_sub1>0\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"access_subagent2_id\" ng-model=\"vm.formWizard.access_subagent2_id\" placeholder=\"Номер субагента\" ng-disabled=\"!checkRule(45,\'all\')\" ng-change=\"vm.loadAgentName(3)\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"agent3name\" ng-model=\"vm.formWizard.agent3name\" placeholder=\"Субгент\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"fee_sub2\" ng-model=\"vm.formWizard.fee_sub2\" placeholder=\"Комиссия субагента (%)\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" ng-disabled=\"!checkRule(45,\'all\')\" min=\"0\" max=\"100\" ng-required=\"vm.formWizard.access_subagent2_id\"><div ng-messages=\"wizardStep1.fee_sub2.$error\" ng-show=\"wizardStep1.fee_sub2.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><md-input-container class=\"md-block\"><label>Описание сделки <strong>*</strong></label> <textarea ng-model=\"vm.formWizard.about\" columns=\"1\" md-maxlength=\"1000\" rows=\"5\" required=\"\"></textarea><div ng-messages=\"wizardStep2.about.$error\" ng-show=\"wizardStep2.about.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 1000 символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">4</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Документы</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"pb-16\">Документы добавляются независимо от других данных сделки. Если Вы просто добавили документы, то можете просто выйти из редактирования объекта. При следующем посещении этой страницы они уже будут в таблице.<br>Выбрать файлы для загрузки можно ниже.<br></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtIntanceCallback\" dt-options=\"vm.table.dtOptions\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in ::vm.table.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"document in vm.documents\"><td><md-icon md-font-icon=\"{{ document.icon }}\" class=\"s16\"></md-icon><a ng-href=\"{{document.filename}}\" target=\"_blank\">{{ document.filename_original }}</a> &nbsp;&nbsp; <a ng-href=\"{{document.download_filename}}\" target=\"_blank\"><md-button class=\"md-raised md-primary\" aria-label=\"Download document\"><md-icon md-font-icon=\"icon-download\" class=\"s16\"></md-icon></md-button></a></td><td>{{ document.directory }}</td><td>{{ document.size/1024/1024|number:3 }} Мб</td><td><md-button ng-show=\"document.directory!=12 && document.directory!=\'Архив\'\" class=\"md-raised md-warn\" ng-click=\"vm.removeDoc(document.id);\" aria-label=\"Remove this\"><md-icon md-font-icon=\"icon-content-cut\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-input-container class=\"md-block\"><div class=\"row\"><div class=\"col-md-3\"><md-input-container flex=\"200\" flex-gt-xs=\"100\"><h3><md-icon md-font-icon=\"icon-paperclip\" class=\"s16\"></md-icon>Выберите файлы</h3><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" aria-label=\"Documents\"><br></md-input-container><md-input-container flex=\"200\" flex-gt-xs=\"100\"><label>Категория документов</label><md-select ng-model=\"vm.formWizard.directory\"><md-option ng-repeat=\"directory in vm.directories\" value=\"{{directory.id}}\">{{directory.name}}</md-option></md-select></md-input-container></div><div class=\"col-md-9\" style=\"margin-bottom: 40px\"><h3>Выбрано файлов для загрузки: {{ uploader.queue.length }}</h3><br><br><table class=\"table\" ng-show=\"uploader.queue.length\"><thead><tr><th width=\"50%\">Имя</th><th ng-show=\"uploader.isHTML5\">Размер</th><th>Действия</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} Мб</td><td nowrap=\"\"><md-button class=\"md-raised md-accent\" ng-click=\"item.upload();vm.successLoadDocumentsMessage();\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" aria-label=\"Download this\"><md-icon md-font-icon=\"icon-box-download\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"item.remove();\" aria-label=\"Remove this\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><br><div ng-show=\"uploader.queue.length\"><md-button class=\"md-raised md-accent\" ng-click=\"uploader.uploadAll();vm.successLoadDocumentsMessage();\" ng-disabled=\"!uploader.getNotUploadedItems().length\" aria-label=\"Download all\" ng-show=\"!hideUpload\">Загрузить все</md-button><md-button class=\"md-raised md-warn\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\" aria-label=\"Clear download list\">Очистить все</md-button></div></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Сохранить данные</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/modules/deals/newdeal/newdeal.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Сделки</span></div><div class=\"title\">Новая сделка</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки</label><md-select ng-model=\"vm.formWizard.deal_type\" required=\"\"><md-option ng-repeat=\"deal_type_var in vm.deal_types\" value=\"{{deal_type_var.name}}\">{{deal_type_var.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта</label><md-select ng-model=\"vm.formWizard.object_type\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select><div ng-messages=\"vm.wizardStep1.object_type.$error\" ng-show=\"vm.wizardStep1.object_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Инвестиционная</label><md-select ng-model=\"vm.formWizard.invest\"><md-option ng-repeat=\"invest in vm.yes_no_array\" value=\"{{invest.name}}\">{{invest.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"object_id\" ng-model=\"vm.formWizard.object_id\" placeholder=\"Номер объекта\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type==\'sell\'\" ng-show=\"vm.formWizard.deal_type==\'sell\'\" ng-change=\"vm.loadObjectAddress()\"><div ng-messages=\"vm.wizardStep1.object_id.$error\" ng-show=\"vm.wizardStep1.object_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>При статусе продажа поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"object_address\" ng-model=\"vm.formWizard.object_address\" placeholder=\"Местоположение\" ng-required=\"vm.formWizard.deal_type!=\'sell\'\" ng-disabled=\"vm.formWizard.deal_type==\'sell\'\"><div ng-messages=\"vm.wizardStep1.object_address.$error\" ng-show=\"vm.wizardStep1.object_address.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"client_id\" ng-model=\"vm.formWizard.client_id\" placeholder=\"Номер клиента\" ng-pattern=\"/[0-9]$/\" ng-change=\"vm.loadClientName()\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"client_name\" ng-model=\"vm.formWizard.client_name\" placeholder=\"Имя клиента\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"seller_id\" ng-model=\"vm.formWizard.seller_id\" placeholder=\"Номер продавца\" ng-pattern=\"/[0-9]$/\" ng-change=\"vm.loadSellerName()\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"seller_name\" ng-model=\"vm.formWizard.seller_name\" placeholder=\"Имя продавца\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Статус сделки</label><md-select ng-model=\"vm.formWizard.status\" required=\"\"><md-option ng-repeat=\"status in vm.status_types\" value=\"{{status.id}}\">{{status.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"request_id\" ng-model=\"vm.formWizard.request_id\" placeholder=\"Номер заявки (если есть)\" ng-pattern=\"/[0-9]$/\"></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Участники и финансы</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Сумма сделки (руб.)\" required=\"\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"comission\" ng-model=\"vm.formWizard.comission\" placeholder=\"Агентская комиссия (руб.)\" required=\"\"><div ng-messages=\"wizardStep1.comission.$error\" ng-show=\"wizardStep1.comission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"access_user_id\" ng-model=\"vm.formWizard.access_user_id\" placeholder=\"Номер агента\" ng-change=\"vm.loadAgentName(1)\" required=\"\"><div ng-messages=\"wizardStep1.access_user_id.$error\" ng-show=\"wizardStep1.access_user_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Обязательно указать агента</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"agent1name\" ng-model=\"vm.formWizard.agent1name\" placeholder=\"Агент\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"fee_sub0\" ng-model=\"vm.formWizard.fee_sub0\" placeholder=\"Комиссия агента (%)\" ng-pattern=\"/^(0|[1-9]\\d{1,2}?)$/\" min=\"0\" max=\"100\" required=\"\"><div ng-messages=\"wizardStep1.fee_sub0.$error\" ng-show=\"wizardStep1.fee_sub0.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.formWizard.fee_sub0>0\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"access_subagent1_id\" ng-model=\"vm.formWizard.access_subagent1_id\" placeholder=\"Номер субагента\" ng-change=\"vm.loadAgentName(2)\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"agent2name\" ng-model=\"vm.formWizard.agent2name\" placeholder=\"Субгент\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"fee_sub1\" ng-model=\"vm.formWizard.fee_sub1\" placeholder=\"Комиссия субагента (%)\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" min=\"0\" max=\"100\" ng-required=\"vm.formWizard.access_subagent1_id\"><div ng-messages=\"wizardStep1.fee_sub1.$error\" ng-show=\"wizardStep1.fee_sub1.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.formWizard.fee_sub1>0\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"access_subagent2_id\" ng-model=\"vm.formWizard.access_subagent2_id\" placeholder=\"Номер субагента\" ng-change=\"vm.loadAgentName(3)\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"agent3name\" ng-model=\"vm.formWizard.agent3name\" placeholder=\"Субгент\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"fee_sub2\" ng-model=\"vm.formWizard.fee_sub2\" placeholder=\"Комиссия субагента (%)\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" min=\"0\" max=\"100\" ng-required=\"vm.formWizard.access_subagent2_id\"><div ng-messages=\"wizardStep1.fee_sub2.$error\" ng-show=\"wizardStep1.fee_sub2.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><md-input-container class=\"md-block\"><label>Описание сделки <strong>*</strong></label> <textarea ng-model=\"vm.formWizard.about\" columns=\"1\" md-maxlength=\"1000\" rows=\"5\" required=\"\"></textarea><div ng-messages=\"wizardStep2.about.$error\" ng-show=\"wizardStep2.about.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 1000 символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Завести сделку</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/modules/requests/editrequest/editrequest.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Заявки</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Просмотр заявки</span></div><div class=\"title\">{{vm.basicForm.type}}<span ng-show=\"vm.basicForm.active==false\">(архив)</span></div></div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"name\" ng-model=\"vm.basicForm.name\" placeholder=\"Имя\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"phone\" ng-model=\"vm.basicForm.phone\" placeholder=\"Телефон\" ng-disabled=\"true\"></md-input-container><md-input-container flex=\"\"><label>Регион</label><md-select ng-model=\"vm.basicForm.region\" ng-disabled=\"true\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\" \"=\"\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"date\" ng-model=\"vm.basicForm.date\" placeholder=\"Дата подачи\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"md-block\" style=\"width:70%\"><label>Сообщение клиента</label> <textarea aria-label=\"Client\'s comment\" ng-model=\"vm.basicForm.text\" name=\"text\" columns=\"1\" rows=\"5\" ng-disabled=\"true\"></textarea></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"width:70%\">Комментарий по отработке заявки (доступен только внутри компании)</div><div layout=\"column\" layout-gt-sm=\"row\" style=\"width:70%\"><md-input-container class=\"md-block\"><textarea ng-model=\"vm.basicForm.user_comment\" name=\"user_comment\" columns=\"1\" rows=\"5\" aria-label=\"Agent\'s comment\" ng-disabled=\"vm.basicForm.active==false\"></textarea><div ng-messages=\"basicForm.user_comment.$error\" ng-show=\"basicForm.user_comment.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Комментарий - обязательное поле</span></div></div></md-input-container><md-switch name=\"success\" ng-model=\"vm.basicForm.success\" aria-label=\"Unsuccess/success\" ng-disabled=\"vm.basicForm.active==false\">Неудача/Успех</md-switch><md-switch name=\"active\" ng-disabled=\"true\" ng-model=\"vm.basicForm.active\" aria-label=\"Active/Archive\">Архивная/Активная</md-switch></div><div ng-show=\"vm.basicForm.active==true\" layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-switch name=\"wantclient\" ng-model=\"vm.basicForm.wantclient\" aria-label=\"Want create client\" ng-show=\"vm.basicForm.wantclient!=true\" ng-change=\"vm.getRequestData4Client()\" ng-disabled=\"vm.basicForm.active==false\">Хочу создать клиента</md-switch></div><div ng-show=\"vm.basicForm.active==true && vm.basicForm.wantclient==true && vm.hideCreateClient==0\" layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"60\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.basicForm.firstname\" placeholder=\"Имя\" ng-pattern=\"/^([А-ЯЁ]){1}([а-яё])+$/\" ng-minlength=\"2\" ng-required=\"vm.basicForm.wantclient\"><div ng-messages=\"vm.basicForm.firstname.$error\" ng-show=\"vm.basicForm.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Имя должно состоять из букв кириллического алфавита и начинаться с заглавной буквы</span></div><div ng-message=\"minlength\"><span>Слишком короткое имя</span></div></div></md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"50\"><label>Основной телефон</label> <input name=\"phone_1\" ng-model=\"vm.basicForm.phone_1\" placeholder=\"Основной телефон\" ng-pattern=\"/^[0-9]{10}$/\" md-maxlength=\"10\" ng-required=\"vm.basicForm.wantclient\"><div ng-messages=\"vm.basicForm.phone_1.$error\" ng-show=\"vm.basicForm.phone_1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Необходимо ввести основной телефон</span></div><div ng-message=\"pattern\"><span>Введите корректный телефон (без +7)</span></div><div ng-message=\"md-maxlength\"><span>Телефон не должен быть длиннее 10 цифр</span></div></div></md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"50\"><md-button ng-show=\"vm.basicForm.active==true\" ng-click=\"vm.addClient()\" aria-label=\"add client\" ng-disabled=\"basicForm.$invalid || vm.basicForm.wantclient==false\"><md-icon md-font-icon=\"icon-account-check\"></md-icon>Создать</md-button></md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Save request\" ng-disabled=\"basicForm.$invalid || vm.basicForm.active==false\" ng-click=\"vm.sendForm();\">Заявка обработана</md-button></form></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">R</span> <a href=\"https://first-online.ru\" target=\"blank\"><span class=\"logo-text\">Главная</span></a></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/objects/editobject/editcommerce/editcommerce.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Редактирование объекта</span></div><div class=\"title\">Коммерческое помещение</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Авито - пакет</label><md-select ng-model=\"vm.formWizard.avito\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"avito in vm.int_avito_array\" value=\"{{avito.name}}\">{{avito.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.avito>0\"><label>Авито - услуга</label><md-select ng-model=\"vm.formWizard.avito_turbo\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"avito_turbo in vm.int_avitoserv_array\" value=\"{{avito_turbo.name}}\">{{avito_turbo.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Cian</label><md-select ng-model=\"vm.formWizard.xml_cian\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"xml_cian in vm.int_cian_array\" value=\"{{xml_cian.name}}\">{{xml_cian.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать только Winner</label><md-select ng-model=\"vm.formWizard.only_winner\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"only_winner in vm.int_yes_no_array\" value=\"{{only_winner.name}}\">{{only_winner.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать на Яндекс</label><md-select ng-model=\"vm.formWizard.xml_yandex\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"yandex in vm.int_yes_no_array\" value=\"{{yandex.name}}\">{{yandex.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать на Домклик</label><md-select ng-model=\"vm.formWizard.xml_domclick\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"domclick in vm.int_yes_no_array\" value=\"{{domclick.name}}\">{{domclick.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.xml_cian>0\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"auction\" ng-model=\"vm.formWizard.auction\" placeholder=\"Аукцион\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"auction_title\" ng-model=\"vm.formWizard.auction_title\" placeholder=\"Аукцион - заголовок\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"tech_4\" ng-model=\"vm.formWizard.tech_4\" placeholder=\"Координаты\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"tech_8\" ng-model=\"vm.formWizard.tech_8\" placeholder=\"TOP3\" ng-show=\"checkRule(59,\'all\')\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Назначить агента</label><md-select ng-model=\"vm.formWizard.owner_id\" ng-show=\"checkRule(59,\'all\')\" ng-disabled=\"!checkRule(59,\'all\')\"><md-option ng-repeat=\"owner in vm.users_in_group\" value=\"{{owner.id}}\">{{owner.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион*</label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\" required=\"\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район*</label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select><div ng-messages=\"vm.wizardStep1.district.$error\" ng-show=\"vm.wizardStep1.district.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта*</label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта*</label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.loadStreets()\" required=\"\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option><div ng-messages=\"vm.wizardStep1.city.$error\" ng-show=\"vm.wizardStep1.city.$touched\" role=\"alert\"><div ng-message=\"required\"><span></span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица*</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"vm.selectedItem\" md-selected-attr=\"vm.streetFromListWhenSelected\" md-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchStreet\" md-search-text-change=\"vm.searchStringChange(vm.searchStreet)\" md-items=\"item in vm.searchStreetResult(vm.searchStreet)\" md-item-text=\"item.value\" md-autofocus=\"true\" autocomplete-blur=\"\" md-input-id=\"street-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchStreet\" md-highlight-flags=\"^i\">{{item.value}}</span></md-item-template><md-not-found>Улиц с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.street.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Улица обязательно должна быть указана</div><div ng-message=\"vm.streetFromList\">Выберете улицу из списка</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.city_type!=\'г\' || vm.formWizard.region == 2)\"><label>Направление электричек**</label><md-select ng-model=\"vm.formWizard.direction\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option><div ng-messages=\"vm.wizardStep1.direction.$error\" ng-show=\"vm.wizardStep1.direction.$touched\" role=\"alert\"><div ng-message=\"required\"><span>*</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2)\"><input type=\"number\" name=\"from_mcad\" ng-model=\"vm.formWizard.from_mcad\" placeholder=\"От МКАД, км**\" min=\"0\" max=\"150\"><div ng-messages=\"vm.wizardStep1.from_mcad.$error\" ng-show=\"vm.wizardStep1.from_mcad.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"min\"><span>Слишком мало</span></div><div ng-message=\"required\"><span>Слишком далеко</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основное метро**</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"item1.id\" md-selected-item-change=\"vm.formWizard.metro_1 = item1.id;\" md-search-text=\"vm.searchMetro_1\" md-items=\"item1 in vm.metroQuerySearch(vm.searchMetro_1)\" md-item-text=\"item1.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro1-autocomplete-id\" ng-required=\"vm.formWizard.region==1\"><md-item-template><span md-highlight-text=\"vm.searchMetro_1\" md-highlight-flags=\"^i\">{{item1.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_1.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути**</label><md-select ng-model=\"vm.formWizard.metro_1_time\" ng-required=\"vm.formWizard.metro_1\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_1 && vm.formWizard.metro_1_time\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item2.id\" md-selected-item-change=\"vm.formWizard.metro_2 = item2.id;\" md-search-text=\"vm.searchMetro_2\" md-items=\"item2 in vm.metroQuerySearch(vm.searchMetro_2)\" md-item-text=\"item2.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro2-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_2\" md-highlight-flags=\"^i\">{{item2.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_2.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_2_time\" ng-required=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item3.id\" md-selected-item-change=\"vm.formWizard.metro_3 = item3.id;\" md-search-text=\"vm.searchMetro_3\" md-items=\"item3 in vm.metroQuerySearch(vm.searchMetro_3)\" md-item-text=\"item3.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro3-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_3\" md-highlight-flags=\"^i\">{{item3.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_3.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_3_time\" ng-required=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта*</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки*</label><md-select ng-model=\"vm.formWizard.deal_type\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Источник*</label><md-select ng-model=\"vm.formWizard.source_id\" required=\"\"><md-option ng-repeat=\"source in vm.sources\" value=\"{{source.id}}\">{{source.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости*</label><md-select ng-model=\"vm.formWizard.object_type\" ng-change=\"vm.changeBildTypes()\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" ng-show=\"(vm.formWizard.deal_type == \'rent\' || vm.formWizard.deal_type == \'subrent\' || vm.formWizard.deal_type == \'ppa\' || vm.formWizard.deal_type == \'dsd\')\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата*\" ng-pattern=\"/[0-9]$/\" ng-required=\"(vm.formWizard.deal_type == \'rent\' || vm.formWizard.deal_type == \'subrent\' || vm.formWizard.deal_type == \'ppa\' || vm.formWizard.deal_type == \'dsd\')\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>За</label><md-select ng-model=\"vm.formWizard.pay_type\" ng-required=\"(vm.formWizard.deal_type == \'rent\' || vm.formWizard.deal_type == \'subrent\' || vm.formWizard.deal_type == \'ppa\' || vm.formWizard.deal_type == \'dsd\')\"><md-option ng-repeat=\"pay_type in vm.pay_types\" value=\"{{pay_type.name}}\">{{pay_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Период оплаты</label><md-select ng-model=\"vm.formWizard.pay_duration\" ng-required=\"(vm.formWizard.deal_type == \'rent\' || vm.formWizard.deal_type == \'subrent\' || vm.formWizard.deal_type == \'ppa\' || vm.formWizard.deal_type == \'dsd\')\"><md-option ng-repeat=\"pay_duration in vm.pay_durations\" value=\"{{pay_duration.name}}\">{{pay_duration.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственник*</label><md-select ng-model=\"vm.formWizard.client_id\" required=\"\"><md-option ng-repeat=\"client in vm.my_clients\" value=\"{{client.id}}\">{{client.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.deal_type == \'sale\')\"><input type=\"text\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Цена*\" ng-pattern=\"/[0-9]$/\" ng-required=\"(vm.formWizard.deal_type == \'sale\')\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Налог*</label><md-select ng-model=\"vm.formWizard.class_bild\"><md-option ng-repeat=\"class_bild in vm.bcenterstatus_list\" value=\"{{class_bild.name}}\">{{class_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commission\" ng-model=\"vm.formWizard.commission\" placeholder=\"Комиссия*\" ng-pattern=\"/[0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.commission.$error\" ng-show=\"wizardStep1.commission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите комиссию правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комиссии</label><md-select ng-model=\"vm.formWizard.commission_type\"><md-option ng-repeat=\"commission_type in vm.commission_types\" value=\"{{commission_type.name}}\">{{commission_type.rusname}}</md-option></md-select></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"countroom_office\" ng-model=\"vm.formWizard.countroom_office\" placeholder=\"Количество помещений\"><div ng-messages=\"vm.wizardStep1.countroom_office.$error\" ng-show=\"vm.wizardStep1.countroom_office.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type!=\'stock\')\"><input type=\"number\" name=\"story\" ng-model=\"vm.formWizard.story\" placeholder=\"Этаж\" min=\"-2\" max=\"{{vm.formWizard.story_count}}\"><div ng-messages=\"wizardStep2.story.$error\" ng-show=\"wizardStep2.story.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этаж - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этаж правильно</span></div><div ng-message=\"min\"><span>Введите этаж правильно</span></div><div ng-message=\"max\"><span>Этаж не должен быть больше числа этажей</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type!=\'stock\')\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Этажность*\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"100\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этажность - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Планировка</label><md-select ng-model=\"vm.formWizard.plan_bild\"><md-option ng-repeat=\"plan_bild in vm.plan_bild_types\" value=\"{{plan_bild.name}}\">{{plan_bild.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Назначение</label><md-select ng-model=\"vm.formWizard.commerce_living_type\"><md-option ng-repeat=\"commerce_living_type in vm.yes_no_array_living\" value=\"{{commerce_living_type.name}}\">{{commerce_living_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Юридический адрес</label><md-select ng-model=\"vm.formWizard.commerce_enter\"><md-option ng-repeat=\"commerce_enter in vm.yes_no_array_enter\" value=\"{{commerce_enter.name}}\">{{commerce_enter.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commerce_businesscenter\" ng-model=\"vm.formWizard.commerce_businesscenter\" placeholder=\"Электрическая мощность\"><div ng-messages=\"vm.wizardStep1.commerce_businesscenter.$error\" ng-show=\"vm.wizardStep1.commerce_businesscenter.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Скрыть номер дома в рекламе?</label><md-select ng-model=\"vm.formWizard.furniture\"><md-option ng-repeat=\"furniture in vm.furniture_types\" value=\"{{furniture.name}}\">{{furniture.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Валюта (руб)</label><md-select ng-model=\"vm.formWizard.lift\"><md-option ng-repeat=\"lift in vm.lift_types\" value=\"{{lift.name}}\">{{lift.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип здания</label><md-select ng-model=\"vm.formWizard.type_bild\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Санузел (если есть)</label><md-select ng-model=\"vm.formWizard.type_bathroom\"><md-option ng-repeat=\"type_bathroom in vm.types_bathroom\" value=\"{{type_bathroom.name}}\">{{type_bathroom.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><label>Эксплуатационные расходы*</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.yes_no_array\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><label>Коммунальные платежи*</label><md-select ng-model=\"vm.formWizard.phone\"><md-option ng-repeat=\"phone_type in vm.phone_types\" value=\"{{phone_type.name}}\">{{phone_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Электричество</label><md-select ng-model=\"vm.formWizard.enegi\"><md-option ng-repeat=\"enegi in vm.enegi_types\" value=\"{{enegi.name}}\">{{enegi.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Отопление</label><md-select ng-model=\"vm.formWizard.heating\"><md-option ng-repeat=\"heating in vm.heating_types\" value=\"{{heating.name}}\">{{heating.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Канализация</label><md-select ng-model=\"vm.formWizard.sewage_item\"><md-option ng-repeat=\"sewage_item in vm.yes_no_array\" value=\"{{sewage_item.name}}\">{{sewage_item.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Газ</label><md-select ng-model=\"vm.formWizard.gas_item\"><md-option ng-repeat=\"gas_item in vm.yes_no_array\" value=\"{{gas_item.name}}\">{{gas_item.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Водоснабжение</label><md-select ng-model=\"vm.formWizard.water_on_item\"><md-option ng-repeat=\"water_on_item in vm.yes_no_array\" value=\"{{water_on_item.name}}\">{{water_on_item.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.formWizard.object_type == \'garage\' || vm.formWizard.object_type == \'parkingPlace\'\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип гаража**</label><md-select ng-model=\"vm.formWizard.garage_type\"><md-option ng-repeat=\"garage_type in vm.garage_types\" value=\"{{garage_type.name}}\">{{garage_type.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.formWizard.object_type == \'garage\' || vm.formWizard.object_type == \'parkingPlace\'\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>АЗС</label><md-select ng-model=\"vm.formWizard.infra1\"><md-option ng-repeat=\"infra1 in vm.yes_no_array\" value=\"{{infra1.name}}\">{{infra1.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>СТО</label><md-select ng-model=\"vm.formWizard.infra2\"><md-option ng-repeat=\"infra2 in vm.yes_no_array\" value=\"{{infra2.name}}\">{{infra2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Автомойка</label><md-select ng-model=\"vm.formWizard.infra3\"><md-option ng-repeat=\"infra3 in vm.yes_no_array\" value=\"{{infra3.name}}\">{{infra3.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Заасфальтированный подъезд</label><md-select ng-model=\"vm.formWizard.spec3\"><md-option ng-repeat=\"spec3 in vm.yes_no_array\" value=\"{{spec3.name}}\">{{spec3.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.formWizard.object_type == \'stock\'\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь офисной части, м<sup>2</sup> <strong>*</strong></label> <input name=\"officesq_stock\" ng-model=\"vm.formWizard.officesq_stock\" placeholder=\"Площадь офисной части\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.officesq_stock.$error\" ng-show=\"wizardStep2.officesq_stock.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь производственной части, м<sup>2</sup> <strong>*</strong></label> <input name=\"usefulsq_stock\" ng-model=\"vm.formWizard.usefulsq_stock\" placeholder=\"Площадь производственной части\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.usefulsq_stock.$error\" ng-show=\"wizardStep2.usefulsq_stock.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь прилегающей территории, Га <strong>*</strong></label> <input name=\"bordersq_stock\" ng-model=\"vm.formWizard.bordersq_stock\" placeholder=\"Площадь прилегающей территории\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.bordersq_stock.$error\" ng-show=\"wizardStep2.bordersq_stock.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь складской части, м<sup>2</sup> <strong>**</strong></label> <input name=\"workssq\" ng-model=\"vm.formWizard.workssq\" placeholder=\"Площадь складской части\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.workssq.$error\" ng-show=\"wizardStep2.workssq.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Общая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_all\" ng-model=\"vm.formWizard.square_all\" placeholder=\"Общая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_all.$error\" ng-show=\"wizardStep2.square_all.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Витрина</label><md-select ng-model=\"vm.formWizard.showcase\"><md-option ng-repeat=\"showcase in vm.yes_no_array\" value=\"{{showcase.name}}\">{{showcase.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.object_type == \'ready_business\'\"><input type=\"text\" name=\"part_percent\" ng-model=\"vm.formWizard.part_percent\" placeholder=\"Доля бизнеса\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" ng-required=\"vm.formWizard.object_type == \'ready_business\'\"><div ng-messages=\"wizardStep1.part_percent.$error\" ng-show=\"wizardStep1.part_percent.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.object_type == \'ready_business\'\"><input type=\"text\" name=\"yearprofit\" ng-model=\"vm.formWizard.yearprofit\" placeholder=\"Годовая прибыль**\" ng-required=\"vm.formWizard.object_type == \'ready_business\'\"><div ng-messages=\"vm.wizardStep1.yearprofit.$error\" ng-show=\"vm.wizardStep1.yearprofit.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.object_type == \'ready_business\'\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата**\" ng-required=\"vm.formWizard.object_type == \'ready_business\'\"><div ng-messages=\"vm.wizardStep1.rentcost.$error\" ng-show=\"vm.wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"md-title\">Вы приближаетесь к завершению создания объекта!</div><div class=\"pb-16\">Теперь опишите его.<br>Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea style=\"overflow:auto;\" ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"1500\" rows=\"5\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее тысячи символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"md-block\"><input type=\"text\" name=\"linktour\" ng-model=\"vm.formWizard.linktour\" ng-pattern=\"/^(?:([a-z]+):(?:([a-z]*):)?\\/\\/)?(?:([^:@]*)(?::([^:@]*))?@)?((?:[a-z0-9_-]+\\.)+[a-z]{2,}|localhost|(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])))(?::(\\d+))?(?:([^:\\?\\#]+))?(?:\\?([^\\#]+))?(?:\\#([^\\s]+))?$/i\" placeholder=\"Ссылка на 3D-тур\"><div ng-messages=\"wizardStep2.linktour.$error\" ng-show=\"wizardStep2.linktour.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Не похоже на ссылку</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">4</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Фотографии</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"pb-16\">Фотографии добавляются независимо от других данных объекта. Если Вы просто добавили фотографии, то можете просто выйти из редактирования объекта.<br><br>Выбрать файлы для загрузки можно ниже.<br><br>За один раз можно добавить не более 10 фотографий. Фотография не будет загружена если ее размер превышает 1Мб. Минимальный рекомендуемый размер по ширине и высоте не менее 600px<br></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtIntanceCallback\" dt-options=\"vm.table.dtOptions\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in ::vm.table.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"photo in vm.photos\"><td><img ng-src=\"{{photo.filename}}\" style=\"width: 400px; height: {{photo.height*400/photo.width}}px; float:left\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.rotatePhoto(photo.filename,90);\" aria-label=\"Rotate left\" ng-show=\"photo.id!=1\"><md-icon md-font-icon=\"icon-replay\" class=\"s16\"></md-icon></md-button><br><md-button class=\"md-raised md-primary\" ng-click=\"vm.rotatePhoto(photo.filename,270);\" aria-label=\"Rotate right\" ng-show=\"photo.id!=1\"><md-icon md-font-icon=\"icon-reload\" class=\"s16\"></md-icon></md-button><br><md-button alt=\"Установить эту фотографию главной\" class=\"md-raised md-accent\" ng-click=\"vm.setMainPhoto(photo.id);\" aria-label=\"Set this as main photo\" ng-show=\"photo.id!=vm.mainImage && photo.id!=1\"><md-icon md-font-icon=\"icon-flag-variant\" class=\"s16\"></md-icon></md-button><br><md-button class=\"md-raised md-warn\" ng-click=\"vm.removePhoto(photo.id);\" aria-label=\"Remove this\" ng-show=\"photo.id!=vm.mainImage && photo.id!=1\"><md-icon md-font-icon=\"icon-content-cut\" class=\"s16\"></md-icon></md-button></td><td>{{ photo.width }}x{{ photo.height }}px / {{ photo.size/1024/1024|number:1 }} Мб<br><br><span ng-show=\"photo.id==vm.mainImage\">Главная фотография выводится<br>как миниатюра на рекламных порталах.<br>Вы не можете ее удалить</span></td></tr></tbody></table><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Не загружайте фотографии с водяными знаками, номерами телефонов и прочей посторонней информацией.<br>Если Вы хотите использовать чужие фотографии, то предварительно отредактируйте их (например, измените размер)<br>Если не следовать этим правилам, то объект вполне может оказаться заблокированным на некоторых порталах</div></div><md-input-container class=\"md-block\"><div class=\"row\"><div class=\"col-md-3\"><h3><md-icon md-font-icon=\"icon-paperclip\" class=\"s16\"></md-icon>Выберите файлы (каждый файл не более 2.5 Мб)</h3><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" aria-label=\"Photos\"><br></div><div class=\"col-md-9\" style=\"margin-bottom: 40px\"><h3>Выбрано файлов для загрузки: {{ uploader.queue.length }}</h3><br><br><table class=\"table\" ng-show=\"uploader.queue.length\"><thead><tr><th width=\"50%\">Имя</th><th ng-show=\"uploader.isHTML5\">Размер</th><th>Действия</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} Мб</td><td nowrap=\"\"><md-button class=\"md-raised md-accent\" ng-click=\"item.upload();vm.successLoadPhotosMessage();\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" aria-label=\"Download this\"><md-icon md-font-icon=\"icon-box-download\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"item.remove();\" aria-label=\"Remove this\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><br><br><div ng-show=\"uploader.queue.length\"><md-button class=\"md-raised md-accent\" ng-click=\"uploader.uploadAll();vm.successLoadPhotosMessage();\" ng-disabled=\"!uploader.getNotUploadedItems().length\" aria-label=\"Download all\" ng-show=\"!hideUpload\">Загрузить все</md-button><md-button class=\"md-raised md-warn\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\" aria-label=\"Clear download list\">Очистить все</md-button></div></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-disabled=\"msWizard.formsIncomplete()\">Изменить объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/objects/editobject/editflat/editflat.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Редактирование объекта</span></div><div class=\"title\">Квартира</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Авито - пакет</label><md-select ng-model=\"vm.formWizard.avito\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"avito in vm.int_avito_array\" value=\"{{avito.name}}\">{{avito.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.avito>0\"><label>Авито - услуга</label><md-select ng-model=\"vm.formWizard.avito_turbo\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"avito_turbo in vm.int_avitoserv_array\" value=\"{{avito_turbo.name}}\">{{avito_turbo.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Cian</label><md-select ng-model=\"vm.formWizard.xml_cian\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"cian_v in vm.int_cian_array\" value=\"{{cian_v.name}}\">{{cian_v.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать на М2</label><md-select ng-model=\"vm.formWizard.only_winner\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"only_winner in vm.int_yes_no_array\" value=\"{{only_winner.name}}\">{{only_winner.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать на Яндекс</label><md-select ng-model=\"vm.formWizard.xml_yandex\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"yandex in vm.int_yes_no_array\" value=\"{{yandex.name}}\">{{yandex.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать на Домклик</label><md-select ng-model=\"vm.formWizard.xml_domclick\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"domclick in vm.int_yes_no_array\" value=\"{{domclick.name}}\">{{domclick.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"tech_4\" ng-model=\"vm.formWizard.tech_4\" placeholder=\"Координаты\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>выбрать TOP3</label><md-select ng-model=\"vm.formWizard.tech_8\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"tech_8 in vm.tech_8_array\" value=\"{{tech_8.name}}\">{{tech_8.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.xml_cian>0\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"auction\" ng-model=\"vm.formWizard.auction\" placeholder=\"Аукцион\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"auction_title\" ng-model=\"vm.formWizard.auction_title\" placeholder=\"Аукцион - заголовок\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Назначить агента</label><md-select ng-model=\"vm.formWizard.owner_id\" ng-show=\"checkRule(59,\'all\')\" ng-disabled=\"!checkRule(59,\'all\')\"><md-option ng-repeat=\"owner in vm.users_in_group\" value=\"{{owner.id}}\">{{owner.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион*</label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район*</label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта*</label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта*</label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.isStreetRequired();vm.searchStreet = \'\';\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица*</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"vm.selectedItem\" md-selected-attr=\"vm.streetFromListWhenSelected\" md-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchStreet\" md-search-text-change=\"vm.searchStringChange(vm.searchStreet)\" md-items=\"item in vm.searchStreetResult(vm.searchStreet)\" md-item-text=\"item.value\" md-autofocus=\"true\" autocomplete-blur=\"\" md-input-id=\"street-autocomplete-id\" ng-required=\"vm.street_qty>0\"><md-item-template><span md-highlight-text=\"vm.searchStreet\" md-highlight-flags=\"^i\">{{item.value}}</span></md-item-template><md-not-found>Улиц с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.street.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Улица обязательно должна быть указана</div><div ng-message=\"vm.streetFromList\">Выберете улицу из списка</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\" required=\"\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"flat_number\" ng-model=\"vm.formWizard.flat_number\" placeholder=\"Номер кв.\"><div ng-messages=\"vm.wizardStep1.flat_number.$error\" ng-show=\"vm.wizardStep1.flat_number.$touched\" role=\"alert\"></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.city_type!=\'г\' || vm.formWizard.region == 2)\"><label>Направление электричек**</label><md-select ng-model=\"vm.formWizard.direction\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2)\"><input type=\"number\" name=\"from_mcad\" ng-model=\"vm.formWizard.from_mcad\" placeholder=\"От МКАД, км**\" min=\"0\" max=\"150\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"flats_apartmentscomplex\" ng-model=\"vm.formWizard.flats_apartmentscomplex\" placeholder=\"Название ЖК\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основное метро**</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"item1.id\" md-selected-item-change=\"vm.formWizard.metro_1 = item1.id;\" md-search-text=\"vm.searchMetro_1\" md-items=\"item1 in vm.metroQuerySearch(vm.searchMetro_1)\" md-item-text=\"item1.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro1-autocomplete-id\" ng-required=\"vm.formWizard.region==1\"><md-item-template><span md-highlight-text=\"vm.searchMetro_1\" md-highlight-flags=\"^i\">{{item1.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_1.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути**</label><md-select ng-model=\"vm.formWizard.metro_1_time\" ng-required=\"vm.formWizard.metro_1\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_1 && vm.formWizard.metro_1_time\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item2.id\" md-selected-item-change=\"vm.formWizard.metro_2 = item2.id;\" md-search-text=\"vm.searchMetro_2\" md-items=\"item2 in vm.metroQuerySearch(vm.searchMetro_2)\" md-item-text=\"item2.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro2-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_2\" md-highlight-flags=\"^i\">{{item2.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_2_time\" ng-required=\"vm.searchMetro_2.length > 0\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item3.id\" md-selected-item-change=\"vm.formWizard.metro_3 = item3.id;\" md-search-text=\"vm.searchMetro_3\" md-items=\"item3 in vm.metroQuerySearch(vm.searchMetro_3)\" md-item-text=\"item3.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro3-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_3\" md-highlight-flags=\"^i\">{{item3.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_3.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_3_time\" ng-required=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственник *</label><md-select ng-model=\"vm.formWizard.client_id\" required=\"\"><md-option ng-repeat=\"client in vm.my_clients\" value=\"{{client.id}}\">{{client.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта*</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки*</label><md-select ng-model=\"vm.formWizard.deal_type\" ng-change=\"vm.changeFlatStatuses()\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости*</label><md-select ng-model=\"vm.formWizard.object_type\" ng-change=\"vm.changeRoomTypes()\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.formWizard.object_type == \'part\'\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"part_percent\" ng-model=\"vm.formWizard.part_percent\" placeholder=\"Процент доли*\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" ng-required=\"vm.formWizard.object_type == \'part\'\"><div ng-messages=\"wizardStep1.part_percent.$error\" ng-show=\"wizardStep1.part_percent.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Срок аренды</label><md-select ng-model=\"vm.formWizard.rent_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"rent_duration in vm.rent_durations\" value=\"{{rent_duration.name}}\">{{rent_duration.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"officesq_stock\" ng-model=\"vm.formWizard.officesq_stock\" placeholder=\"Депозит\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.officesq_stock.$error\" ng-show=\"wizardStep1.officesq_stock.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Предоплата, в месяцах</label><md-select ng-model=\"vm.formWizard.class_bild\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"class_bild in vm.class_bilds\" value=\"{{class_bild.name}}\">{{class_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"usefulsq_stock\" ng-model=\"vm.formWizard.usefulsq_stock\" placeholder=\"Комиссия от клиента\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.usefulsq_stock.$error\" ng-show=\"wizardStep1.usefulsq_stock.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите комиссию без %</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"bordersq_stock\" ng-model=\"vm.formWizard.bordersq_stock\" placeholder=\"Комиссия от агента\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.bordersq_stock.$error\" ng-show=\"wizardStep1.bordersq_stock.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите комиссию без %</span></div></div></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type != \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.deal_type != \'rent\'\"><input type=\"number\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Цена\" ng-required=\"vm.formWizard.deal_type == \'change\' || vm.formWizard.deal_type == \'sale\'\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commission\" ng-model=\"vm.formWizard.commission\" placeholder=\"Комиссия\" ng-pattern=\"/[0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.commission.$error\" ng-show=\"wizardStep1.commission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите комиссию правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комиссии</label><md-select ng-model=\"vm.formWizard.commission_type\"><md-option ng-repeat=\"commission_type in vm.commission_types\" value=\"{{commission_type.name}}\">{{commission_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Бонус агенту в %</label><md-select ng-model=\"vm.formWizard.bordersq_stock\"><md-option ng-repeat=\"bordersq_stock in vm.bordersq_stocks\" value=\"{{bordersq_stock.name}}\">{{bordersq_stock.rusname}}</md-option></md-select></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Число комнат <strong>*</strong></label><md-select ng-model=\"vm.formWizard.rooms_number\" required=\"\"><md-option ng-repeat=\"rooms_number in vm.rooms_type_list\" value=\"{{rooms_number.name}}\">{{rooms_number.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story\" ng-model=\"vm.formWizard.story\" placeholder=\"Этаж <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"{{vm.formWizard.story_count}}\" required=\"\"><div ng-messages=\"wizardStep2.story.$error\" ng-show=\"wizardStep2.story.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этаж - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этаж правильно</span></div><div ng-message=\"min\"><span>Введите этаж правильно</span></div><div ng-message=\"max\"><span>Этаж не должен быть больше числа этажей</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Этажность <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"100\" required=\"\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этажность - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комнат</label><md-select ng-model=\"vm.formWizard.furniture\"><md-option ng-repeat=\"furniture in vm.furniture_types\" value=\"{{furniture.name}}\">{{furniture.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\" required=\"\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ипотека<strong>*</strong></label><md-select ng-model=\"vm.formWizard.flat_status\" required=\"\"><md-option ng-repeat=\"flat_status in vm.flat_status_types\" value=\"{{flat_status.name}}\">{{flat_status.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Лифт</label><md-select ng-model=\"vm.formWizard.lift\"><md-option ng-repeat=\"lift in vm.lift_types\" value=\"{{lift.name}}\">{{lift.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Балкон</label><md-select ng-model=\"vm.formWizard.balcony\"><md-option ng-repeat=\"balcony in vm.balcony_types\" value=\"{{balcony.name}}\">{{balcony.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Стоимость</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.inet_types\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип дома<strong>*</strong></label><md-select ng-model=\"vm.formWizard.type_bild\" required=\"\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип санузла</label><md-select ng-model=\"vm.formWizard.type_bathroom\"><md-option ng-repeat=\"type_bathroom in vm.types_bathroom\" value=\"{{type_bathroom.name}}\">{{type_bathroom.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"count_bathroom_flat\" ng-model=\"vm.formWizard.count_bathroom_flat\" placeholder=\"Количество сан.узлов\" ng-pattern=\"/^[0-9]{1,2}$/\"><div ng-messages=\"wizardStep2.count_bathroom_flat.$error\" ng-show=\"wizardStep2.count_bathroom_flat.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственность</label><md-select ng-model=\"vm.formWizard.ownership\"><md-option ng-repeat=\"ownership in vm.ownership_types\" value=\"{{ownership.name}}\">{{ownership.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>В собственности</label><md-select ng-model=\"vm.formWizard.years_own\"><md-option ng-repeat=\"years_own in vm.years_own_types\" value=\"{{years_own.name}}\">{{years_own.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Парковка</label><md-select ng-model=\"vm.formWizard.tv\"><md-option ng-repeat=\"tv in vm.types_parking\" value=\"{{tv.name}}\">{{tv.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Вид из окон</label><md-select ng-model=\"vm.formWizard.windows\"><md-option ng-repeat=\"window in vm.windows_type\" value=\"{{window.name}}\">{{window.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Общая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_all\" ng-model=\"vm.formWizard.square_all\" placeholder=\"Общая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_all.$error\" ng-show=\"wizardStep2.square_all.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Жилая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_living\" ng-model=\"vm.formWizard.square_living\" placeholder=\"Жилая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxLiving=vm.formWizard.square_all-vm.formWizard.square_kitchen}}\" min=\"0\" max=\"{{vm.maxLiving}}\"><div ng-messages=\"wizardStep2.square_living.$error\" ng-show=\"wizardStep2.square_living.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь кухни, м<sup>2</sup> <strong>*</strong></label><input name=\"square_kitchen\" ng-model=\"vm.formWizard.square_kitchen\" placeholder=\"Площадь кухни\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxKitchen=vm.formWizard.square_all-vm.formWizard.square_living}}\" min=\"0\" max=\"{{vm.maxKitchen}}\"><div ng-messages=\"wizardStep2.square_kitchen.$error\" ng-show=\"wizardStep2.square_kitchen.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площади комнат через + <strong>*</strong></label> <input name=\"square_rooms\" ng-model=\"vm.formWizard.square_rooms\" placeholder=\"Площади комнат через разделитель\" required=\"\" ng-pattern=\"/^((\\d+(.\\d{1,2})?\\+?)*\\d{1}(.\\d{1,2})?)$/\"><div ng-messages=\"wizardStep2.square_rooms.$error\" ng-show=\"wizardStep2.square_rooms.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь комнат должна быть указана</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea style=\"overflow:auto;\" ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"2500\" rows=\"15\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее двух тысяч символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"md-block\"><input type=\"text\" name=\"linktour\" ng-model=\"vm.formWizard.linktour\" ng-pattern=\"/^(?:([a-z]+):(?:([a-z]*):)?\\/\\/)?(?:([^:@]*)(?::([^:@]*))?@)?((?:[a-z0-9_-]+\\.)+[a-z]{2,}|localhost|(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])))(?::(\\d+))?(?:([^:\\?\\#]+))?(?:\\?([^\\#]+))?(?:\\#([^\\s]+))?$/i\" placeholder=\"Ссылка на 3D-тур\"><div ng-messages=\"wizardStep2.linktour.$error\" ng-show=\"wizardStep2.linktour.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Не похоже на ссылку</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">4</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Фотографии</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"pb-16\">Фотографии добавляются независимо от других данных объекта. Если Вы просто добавили фотографии, то можете просто выйти из редактирования объекта.<br><br>Выбрать файлы для загрузки можно ниже.<br><br>За один раз можно добавить не более 20 фотографий. Фотография не будет загружена если ее размер превышает 1Мб. Минимальный рекомендуемый размер по ширине и высоте не менее 600px<br></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtIntanceCallback\" dt-options=\"vm.table.dtOptions\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in ::vm.table.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"photo in vm.photos\"><td><img ng-src=\"{{photo.filename}}\" style=\"height: 300px; width: auto; float:left\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.upPhoto(photo);\" aria-label=\"Up\" ng-show=\"photo.position!=1\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s16\"></md-icon></md-button><br ng-show=\"photo.position!=1\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.downPhoto(photo);\" aria-label=\"Down\" ng-show=\"photo.position!=vm.photos.length\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s16\"></md-icon></md-button><br ng-show=\"photo.position!=vm.photos.length\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.rotatePhoto(photo.filename,90);\" aria-label=\"Rotate left\" ng-show=\"photo.id!=1\"><md-icon md-font-icon=\"icon-replay\" class=\"s16\"></md-icon></md-button><br><md-button class=\"md-raised md-primary\" ng-click=\"vm.rotatePhoto(photo.filename,270);\" aria-label=\"Rotate right\" ng-show=\"photo.id!=1\"><md-icon md-font-icon=\"icon-reload\" class=\"s16\"></md-icon></md-button><br><md-button alt=\"Установить эту фотографию главной\" class=\"md-raised md-accent\" ng-click=\"vm.setMainPhoto(photo.id);\" aria-label=\"Set this as main photo\" ng-show=\"photo.id!=vm.mainImage && photo.id!=1\"><md-icon md-font-icon=\"icon-flag-variant\" class=\"s16\"></md-icon></md-button><br><md-button class=\"md-raised md-warn\" ng-click=\"vm.removePhoto(photo.id);\" aria-label=\"Remove this\" ng-show=\"photo.id!=vm.mainImage && photo.id!=1\"><md-icon md-font-icon=\"icon-content-cut\" class=\"s16\"></md-icon></md-button></td><td>{{ photo.width }}x{{ photo.height }}px / {{ photo.size/1024/1024|number:1 }} Мб<br><br><span ng-show=\"photo.id==vm.mainImage\">Главная фотография выводится<br>как миниатюра на рекламных порталах.<br>Вы не можете ее удалить</span></td></tr></tbody></table><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Не загружайте фотографии с водяными знаками, номерами телефонов и прочей посторонней информацией.<br>Если Вы хотите использовать чужие фотографии, то предварительно отредактируйте их (например, измените размер)<br>Если не следовать этим правилам, то объект вполне может оказаться заблокированным на некоторых порталах</div></div><md-input-container class=\"md-block\"><div class=\"row\"><div class=\"col-md-3\"><h3><md-icon md-font-icon=\"icon-paperclip\" class=\"s16\"></md-icon>Выберите файлы (каждый файл не более 2.5 Мб)</h3><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" aria-label=\"Photos\"><br></div><div class=\"col-md-9\" style=\"margin-bottom: 40px\"><h3>Выбрано файлов для загрузки: {{ uploader.queue.length }}</h3><br><br><table class=\"table\" ng-show=\"uploader.queue.length\"><thead><tr><th width=\"50%\">Имя</th><th ng-show=\"uploader.isHTML5\">Размер</th><th>Действия</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} Мб</td><td nowrap=\"\"><md-button class=\"md-raised md-accent\" ng-click=\"item.upload();vm.successLoadPhotosMessage();\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" aria-label=\"Download this\"><md-icon md-font-icon=\"icon-box-download\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"item.remove();\" aria-label=\"Remove this\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><br><br><div ng-show=\"uploader.queue.length\"><md-button class=\"md-raised md-accent\" ng-click=\"uploader.uploadAll();vm.successLoadPhotosMessage();\" ng-disabled=\"!uploader.getNotUploadedItems().length\" aria-label=\"Download all\" ng-show=\"!hideUpload\">Загрузить все</md-button><md-button class=\"md-raised md-warn\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\" aria-label=\"Clear download list\">Очистить все</md-button></div></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-disabled=\"msWizard.formsIncomplete()\">Изменить объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/objects/editobject/editflatrent/editflatrent.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Редактирование объекта</span></div><div class=\"title\">Квартира</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Авито - пакет</label><md-select ng-model=\"vm.formWizard.avito\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"avito in vm.int_avito_array\" value=\"{{avito.name}}\">{{avito.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.avito>0\"><label>Авито - услуга</label><md-select ng-model=\"vm.formWizard.avito_turbo\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"avito_turbo in vm.int_avitoserv_array\" value=\"{{avito_turbo.name}}\">{{avito_turbo.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Cian</label><md-select ng-model=\"vm.formWizard.xml_cian\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"cian_v in vm.int_cian_array\" value=\"{{cian_v.name}}\">{{cian_v.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать на М2</label><md-select ng-model=\"vm.formWizard.only_winner\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"only_winner in vm.int_yes_no_array\" value=\"{{only_winner.name}}\">{{only_winner.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать на Яндекс</label><md-select ng-model=\"vm.formWizard.xml_yandex\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"yandex in vm.int_yes_no_array\" value=\"{{yandex.name}}\">{{yandex.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать на Домклик</label><md-select ng-model=\"vm.formWizard.xml_domclick\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"domclick in vm.int_yes_no_array\" value=\"{{domclick.name}}\">{{domclick.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"tech_4\" ng-model=\"vm.formWizard.tech_4\" placeholder=\"Координаты\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>выбрать TOP3</label><md-select ng-model=\"vm.formWizard.tech_8\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"tech_8 in vm.tech_8_array\" value=\"{{tech_8.name}}\">{{tech_8.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.xml_cian>0\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"auction\" ng-model=\"vm.formWizard.auction\" placeholder=\"Аукцион\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"auction_title\" ng-model=\"vm.formWizard.auction_title\" placeholder=\"Аукцион - заголовок\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Назначить агента</label><md-select ng-model=\"vm.formWizard.owner_id\" ng-show=\"checkRule(59,\'all\')\" ng-disabled=\"!checkRule(59,\'all\')\"><md-option ng-repeat=\"owner in vm.users_in_group\" value=\"{{owner.id}}\">{{owner.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион*</label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\" required=\"\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район*</label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select><div ng-messages=\"vm.wizardStep1.district.$error\" ng-show=\"vm.wizardStep1.district.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта*</label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта*</label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.isStreetRequired();vm.searchStreet = \'\';\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица*</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"vm.selectedItem\" md-selected-attr=\"vm.streetFromListWhenSelected\" md-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchStreet\" md-search-text-change=\"vm.searchStringChange(vm.searchStreet)\" md-items=\"item in vm.searchStreetResult(vm.searchStreet)\" md-item-text=\"item.value\" md-autofocus=\"true\" autocomplete-blur=\"\" md-input-id=\"street-autocomplete-id\" ng-required=\"vm.street_qty>0\"><md-item-template><span md-highlight-text=\"vm.searchStreet\" md-highlight-flags=\"^i\">{{item.value}}</span></md-item-template><md-not-found>Улиц с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.street.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Улица обязательно должна быть указана</div><div ng-message=\"vm.streetFromList\">Выберете улицу из списка</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\" required=\"\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"flat_number\" ng-model=\"vm.formWizard.flat_number\" placeholder=\"Номер кв.\"><div ng-messages=\"vm.wizardStep1.flat_number.$error\" ng-show=\"vm.wizardStep1.flat_number.$touched\" role=\"alert\"></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.city_type!=\'г\' || vm.formWizard.region == 2)\"><label>Направление электричек**</label><md-select ng-model=\"vm.formWizard.direction\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2)\"><input type=\"number\" name=\"from_mcad\" ng-model=\"vm.formWizard.from_mcad\" placeholder=\"От МКАД, км**\" min=\"0\" max=\"150\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"flats_apartmentscomplex\" ng-model=\"vm.formWizard.flats_apartmentscomplex\" placeholder=\"Название ЖК\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основное метро**</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"item1.id\" md-selected-item-change=\"vm.formWizard.metro_1 = item1.id;\" md-search-text=\"vm.searchMetro_1\" md-items=\"item1 in vm.metroQuerySearch(vm.searchMetro_1)\" md-item-text=\"item1.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro1-autocomplete-id\" ng-required=\"vm.formWizard.region==1\"><md-item-template><span md-highlight-text=\"vm.searchMetro_1\" md-highlight-flags=\"^i\">{{item1.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_1.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути**</label><md-select ng-model=\"vm.formWizard.metro_1_time\" ng-required=\"vm.formWizard.metro_1\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_1 && vm.formWizard.metro_1_time\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item2.id\" md-selected-item-change=\"vm.formWizard.metro_2 = item2.id;\" md-search-text=\"vm.searchMetro_2\" md-items=\"item2 in vm.metroQuerySearch(vm.searchMetro_2)\" md-item-text=\"item2.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro2-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_2\" md-highlight-flags=\"^i\">{{item2.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_2.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_2_time\" ng-required=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item3.id\" md-selected-item-change=\"vm.formWizard.metro_3 = item3.id;\" md-search-text=\"vm.searchMetro_3\" md-items=\"item3 in vm.metroQuerySearch(vm.searchMetro_3)\" md-item-text=\"item3.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro3-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_3\" md-highlight-flags=\"^i\">{{item3.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_3.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_3_time\" ng-required=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта*</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки*</label><md-select ng-model=\"vm.formWizard.deal_type\" ng-change=\"vm.changeFlatStatuses()\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Источник**</label><md-select ng-model=\"vm.formWizard.source_id\"><md-option ng-repeat=\"source_id in vm.sources\" value=\"{{source_id.id}}\">{{source_id.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости*</label><md-select ng-model=\"vm.formWizard.object_type\" ng-change=\"vm.changeRoomTypes()\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.formWizard.object_type == \'part\'\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"part_percent\" ng-model=\"vm.formWizard.part_percent\" placeholder=\"Процент доли*\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" ng-required=\"vm.formWizard.object_type == \'part\'\"><div ng-messages=\"wizardStep1.part_percent.$error\" ng-show=\"wizardStep1.part_percent.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Срок аренды</label><md-select ng-model=\"vm.formWizard.rent_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"rent_duration in vm.rent_durations\" value=\"{{rent_duration.name}}\">{{rent_duration.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"officesq_stock\" ng-model=\"vm.formWizard.officesq_stock\" placeholder=\"Депозит\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.officesq_stock.$error\" ng-show=\"wizardStep1.officesq_stock.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Предоплата, в месяцах</label><md-select ng-model=\"vm.formWizard.class_bild\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"class_bild in vm.class_bilds\" value=\"{{class_bild.name}}\">{{class_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"usefulsq_stock\" ng-model=\"vm.formWizard.usefulsq_stock\" placeholder=\"Комиссия от клиента\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.usefulsq_stock.$error\" ng-show=\"wizardStep1.usefulsq_stock.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите комиссию без %</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"bordersq_stock\" ng-model=\"vm.formWizard.bordersq_stock\" placeholder=\"Комиссия от агента\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.bordersq_stock.$error\" ng-show=\"wizardStep1.bordersq_stock.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите комиссию без %</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Число комнат <strong>*</strong></label><md-select ng-model=\"vm.formWizard.rooms_number\" required=\"\"><md-option ng-repeat=\"rooms_number in vm.rooms_type_list\" value=\"{{rooms_number.name}}\">{{rooms_number.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story\" ng-model=\"vm.formWizard.story\" placeholder=\"Этаж <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"{{vm.formWizard.story_count}}\" required=\"\"><div ng-messages=\"wizardStep2.story.$error\" ng-show=\"wizardStep2.story.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этаж - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этаж правильно</span></div><div ng-message=\"min\"><span>Введите этаж правильно</span></div><div ng-message=\"max\"><span>Этаж не должен быть больше числа этажей</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Этажность <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"100\" required=\"\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этажность - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Кондиционер</label><md-select ng-model=\"vm.formWizard.furniture\"><md-option ng-repeat=\"furniture in vm.furniture_types\" value=\"{{furniture.name}}\">{{furniture.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\" required=\"\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Посудомоечная машина<strong>*</strong></label><md-select ng-model=\"vm.formWizard.flat_status\"><md-option ng-repeat=\"flat_status in vm.flat_status_types\" value=\"{{flat_status.name}}\">{{flat_status.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Лифт</label><md-select ng-model=\"vm.formWizard.lift\"><md-option ng-repeat=\"lift in vm.lift_types\" value=\"{{lift.name}}\">{{lift.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Балкон</label><md-select ng-model=\"vm.formWizard.balcony\"><md-option ng-repeat=\"balcony in vm.balcony_types\" value=\"{{balcony.name}}\">{{balcony.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип дома<strong>*</strong></label><md-select ng-model=\"vm.formWizard.type_bild\" required=\"\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип санузла</label><md-select ng-model=\"vm.formWizard.type_bathroom\"><md-option ng-repeat=\"type_bathroom in vm.types_bathroom\" value=\"{{type_bathroom.name}}\">{{type_bathroom.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"count_bathroom_flat\" ng-model=\"vm.formWizard.count_bathroom_flat\" placeholder=\"Количество сан.узлов\" ng-pattern=\"/^[0-9]{1,2}$/\"><div ng-messages=\"wizardStep2.count_bathroom_flat.$error\" ng-show=\"wizardStep2.count_bathroom_flat.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Интернет</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.yes_no_array\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Стиральная машина</label><md-select ng-model=\"vm.formWizard.phone\"><md-option ng-repeat=\"phone_type in vm.phone_types\" value=\"{{phone_type.name}}\">{{phone_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телевизор</label><md-select ng-model=\"vm.formWizard.tv\"><md-option ng-repeat=\"tv in vm.yes_no_array\" value=\"{{tv.name}}\">{{tv.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Вид из окон</label><md-select ng-model=\"vm.formWizard.windows\"><md-option ng-repeat=\"window in vm.windows_type\" value=\"{{window.name}}\">{{window.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Общая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_all\" ng-model=\"vm.formWizard.square_all\" placeholder=\"Общая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_all.$error\" ng-show=\"wizardStep2.square_all.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Жилая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_living\" ng-model=\"vm.formWizard.square_living\" placeholder=\"Жилая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxLiving=vm.formWizard.square_all-vm.formWizard.square_kitchen}}\" min=\"0\" max=\"{{vm.maxLiving}}\"><div ng-messages=\"wizardStep2.square_living.$error\" ng-show=\"wizardStep2.square_living.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь кухни, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_kitchen\" ng-model=\"vm.formWizard.square_kitchen\" placeholder=\"Площадь кухни\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxKitchen=vm.formWizard.square_all-vm.formWizard.square_living}}\" min=\"0\" max=\"{{vm.maxKitchen}}\"><div ng-messages=\"wizardStep2.square_kitchen.$error\" ng-show=\"wizardStep2.square_kitchen.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площади комнат через + <strong>*</strong></label> <input name=\"square_rooms\" ng-model=\"vm.formWizard.square_rooms\" placeholder=\"Площади комнат через разделитель\" required=\"\" ng-pattern=\"/^((\\d+(.\\d{1,2})?\\+?)*\\d{1}(.\\d{1,2})?)$/\"><div ng-messages=\"wizardStep2.square_rooms.$error\" ng-show=\"wizardStep2.square_rooms.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь комнат должна быть указана</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea style=\"overflow:auto;\" ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"2500\" rows=\"15\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее двух тысяч символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"md-block\"><input type=\"text\" name=\"linktour\" ng-model=\"vm.formWizard.linktour\" ng-pattern=\"/^(?:([a-z]+):(?:([a-z]*):)?\\/\\/)?(?:([^:@]*)(?::([^:@]*))?@)?((?:[a-z0-9_-]+\\.)+[a-z]{2,}|localhost|(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])))(?::(\\d+))?(?:([^:\\?\\#]+))?(?:\\?([^\\#]+))?(?:\\#([^\\s]+))?$/i\" placeholder=\"Ссылка на 3D-тур\"><div ng-messages=\"wizardStep2.linktour.$error\" ng-show=\"wizardStep2.linktour.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Не похоже на ссылку</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">4</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Фотографии</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"pb-16\">Фотографии добавляются независимо от других данных объекта. Если Вы просто добавили фотографии, то можете просто выйти из редактирования объекта.<br><br>Выбрать файлы для загрузки можно ниже.<br><br>За один раз можно добавить не более 20 фотографий. Фотография не будет загружена если ее размер превышает 1Мб. Минимальный рекомендуемый размер по ширине и высоте не менее 600px<br></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtIntanceCallback\" dt-options=\"vm.table.dtOptions\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in ::vm.table.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"photo in vm.photos\"><td><img ng-src=\"{{photo.filename}}\" style=\"height: 300px; width: auto; float:left\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.upPhoto(photo);\" aria-label=\"Up\" ng-show=\"photo.position!=1\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s16\"></md-icon></md-button><br ng-show=\"photo.position!=1\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.downPhoto(photo);\" aria-label=\"Down\" ng-show=\"photo.position!=vm.photos.length\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s16\"></md-icon></md-button><br ng-show=\"photo.position!=vm.photos.length\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.rotatePhoto(photo.filename,90);\" aria-label=\"Rotate left\" ng-show=\"photo.id!=1\"><md-icon md-font-icon=\"icon-replay\" class=\"s16\"></md-icon></md-button><br><md-button class=\"md-raised md-primary\" ng-click=\"vm.rotatePhoto(photo.filename,270);\" aria-label=\"Rotate right\" ng-show=\"photo.id!=1\"><md-icon md-font-icon=\"icon-reload\" class=\"s16\"></md-icon></md-button><br><md-button alt=\"Установить эту фотографию главной\" class=\"md-raised md-accent\" ng-click=\"vm.setMainPhoto(photo.id);\" aria-label=\"Set this as main photo\" ng-show=\"photo.id!=vm.mainImage && photo.id!=1\"><md-icon md-font-icon=\"icon-flag-variant\" class=\"s16\"></md-icon></md-button><br><md-button class=\"md-raised md-warn\" ng-click=\"vm.removePhoto(photo.id);\" aria-label=\"Remove this\" ng-show=\"photo.id!=vm.mainImage && photo.id!=1\"><md-icon md-font-icon=\"icon-content-cut\" class=\"s16\"></md-icon></md-button></td><td>{{ photo.width }}x{{ photo.height }}px / {{ photo.size/1024/1024|number:1 }} Мб<br><br><span ng-show=\"photo.id==vm.mainImage\">Главная фотография выводится<br>как миниатюра на рекламных порталах.<br>Вы не можете ее удалить</span></td></tr></tbody></table><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Не загружайте фотографии с водяными знаками, номерами телефонов и прочей посторонней информацией.<br>Если Вы хотите использовать чужие фотографии, то предварительно отредактируйте их (например, измените размер)<br>Если не следовать этим правилам, то объект вполне может оказаться заблокированным на некоторых порталах</div></div><md-input-container class=\"md-block\"><div class=\"row\"><div class=\"col-md-3\"><h3><md-icon md-font-icon=\"icon-paperclip\" class=\"s16\"></md-icon>Выберите файлы (каждый файл не более 2.5 Мб)</h3><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" aria-label=\"Photos\"><br></div><div class=\"col-md-9\" style=\"margin-bottom: 40px\"><h3>Выбрано файлов для загрузки: {{ uploader.queue.length }}</h3><br><br><table class=\"table\" ng-show=\"uploader.queue.length\"><thead><tr><th width=\"50%\">Имя</th><th ng-show=\"uploader.isHTML5\">Размер</th><th>Действия</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} Мб</td><td nowrap=\"\"><md-button class=\"md-raised md-accent\" ng-click=\"item.upload();vm.successLoadPhotosMessage();\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" aria-label=\"Download this\"><md-icon md-font-icon=\"icon-box-download\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"item.remove();\" aria-label=\"Remove this\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><br><br><div ng-show=\"uploader.queue.length\"><md-button class=\"md-raised md-accent\" ng-click=\"uploader.uploadAll();vm.successLoadPhotosMessage();\" ng-disabled=\"!uploader.getNotUploadedItems().length\" aria-label=\"Download all\" ng-show=\"!hideUpload\">Загрузить все</md-button><md-button class=\"md-raised md-warn\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\" aria-label=\"Clear download list\">Очистить все</md-button></div></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-disabled=\"msWizard.formsIncomplete()\">Изменить объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/objects/editobject/editsuburbian/editsuburbian.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Редактирование объекта</span></div><div class=\"title\">Дом/земля</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Авито - пакет</label><md-select ng-model=\"vm.formWizard.avito\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"avito in vm.int_avito_array\" value=\"{{avito.name}}\">{{avito.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.avito>0\"><label>Авито - услуга</label><md-select ng-model=\"vm.formWizard.avito_turbo\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"avito_turbo in vm.int_avitoserv_array\" value=\"{{avito_turbo.name}}\">{{avito_turbo.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Cian</label><md-select ng-model=\"vm.formWizard.xml_cian\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"cian_v in vm.int_cian_array\" value=\"{{cian_v.name}}\">{{cian_v.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать на М2</label><md-select ng-model=\"vm.formWizard.only_winner\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"only_winner in vm.int_yes_no_array\" value=\"{{only_winner.name}}\">{{only_winner.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать на Яндекс</label><md-select ng-model=\"vm.formWizard.xml_yandex\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"yandex in vm.int_yes_no_array\" value=\"{{yandex.name}}\">{{yandex.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Выгружать на Домклик</label><md-select ng-model=\"vm.formWizard.xml_domclick\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"domclick in vm.int_yes_no_array\" value=\"{{domclick.name}}\">{{domclick.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"tech_4\" ng-model=\"vm.formWizard.tech_4\" placeholder=\"Координаты\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>выбрать TOP3</label><md-select ng-model=\"vm.formWizard.tech_8\" ng-disabled=\"!checkRule(56,\'all\')\"><md-option ng-repeat=\"tech_8 in vm.tech_8_array\" value=\"{{tech_8.name}}\">{{tech_8.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.xml_cian>0\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"auction\" ng-model=\"vm.formWizard.auction\" placeholder=\"Аукцион\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"auction_title\" ng-model=\"vm.formWizard.auction_title\" placeholder=\"Аукцион - заголовок\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Назначить агента</label><md-select ng-model=\"vm.formWizard.owner_id\" ng-show=\"checkRule(59,\'all\')\" ng-disabled=\"!checkRule(59,\'all\')\"><md-option ng-repeat=\"owner in vm.users_in_group\" value=\"{{owner.id}}\">{{owner.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион*</label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\" required=\"\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район*</label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта*</label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта*</label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.loadStreets()\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица*</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"vm.selectedItem\" md-selected-attr=\"vm.streetFromListWhenSelected\" md-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchStreet\" md-search-text-change=\"vm.searchStringChange(vm.searchStreet)\" md-items=\"item in vm.searchStreetResult(vm.searchStreet)\" md-item-text=\"item.value\" md-autofocus=\"true\" autocomplete-blur=\"\" md-input-id=\"street-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchStreet\" md-highlight-flags=\"^i\">{{item.value}}</span></md-item-template></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2\"><label>Направление электричек**</label><md-select ng-model=\"vm.formWizard.direction\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2\"><input type=\"number\" name=\"from_mcad\" ng-model=\"vm.formWizard.from_mcad\" placeholder=\"От МКАД, км**\" min=\"0\" max=\"150\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта*</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки*</label><md-select ng-model=\"vm.formWizard.deal_type\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Источник**</label><md-select ng-model=\"vm.formWizard.source_id\"><md-option ng-repeat=\"source in vm.sources\" value=\"{{source.id}}\">{{source.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости*</label><md-select ng-model=\"vm.formWizard.object_type\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><label>Целевое назначение земель*</label><md-select ng-model=\"vm.formWizard.country_land_type\" ng-required=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-option ng-repeat=\"country_land_type in vm.land_types\" value=\"{{country_land_type.name}}\">{{country_land_type.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Срок аренды</label><md-select ng-model=\"vm.formWizard.rent_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"rent_duration in vm.rent_durations\" value=\"{{rent_duration.name}}\">{{rent_duration.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственник*</label><md-select ng-model=\"vm.formWizard.client_id\" required=\"\"><md-option ng-repeat=\"client in vm.my_clients\" value=\"{{client.id}}\">{{client.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.deal_type != \'rent\'\"><input type=\"text\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Цена*\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type != \'rent\'\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commission\" ng-model=\"vm.formWizard.commission\" placeholder=\"Комиссия*\" ng-pattern=\"/[0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.commission.$error\" ng-show=\"wizardStep1.commission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите комиссию правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комиссии</label><md-select ng-model=\"vm.formWizard.commission_type\"><md-option ng-repeat=\"commission_type in vm.commission_types\" value=\"{{commission_type.name}}\">{{commission_type.rusname}}</md-option></md-select></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Гараж</label><md-select ng-model=\"vm.formWizard.count_garage\"><md-option ng-repeat=\"count_garage in vm.yes_no_array\" value=\"{{count_garage.name}}\">{{count_garage.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.count_garage == \'yes\')\"><label>Коммуникации в гараже</label><md-select ng-model=\"vm.formWizard.energi_garage\"><md-option ng-repeat=\"energi_garage in vm.energi_garage_types\" value=\"{{energi_garage.name}}\">{{energi_garage.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Количество этажей в доме\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"6\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Материал дома*</label><md-select ng-model=\"vm.formWizard.type_bild\" ng-required=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Число комнат <strong>*</strong></label><md-select ng-model=\"vm.formWizard.rooms_number\"><md-option ng-repeat=\"rooms_type in vm.rooms_type_list\" value=\"{{rooms_type.name}}\">{{rooms_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\" ng-required=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Эркер</label><md-select ng-model=\"vm.formWizard.erker\"><md-option ng-repeat=\"erker in vm.yes_no_array\" value=\"{{erker.name}}\">{{erker.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Мансарда</label><md-select ng-model=\"vm.formWizard.garret\"><md-option ng-repeat=\"garret in vm.yes_no_array\" value=\"{{garret.name}}\">{{garret.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Цоколь</label><md-select ng-model=\"vm.formWizard.socle\"><md-option ng-repeat=\"socle in vm.yes_no_array\" value=\"{{socle.name}}\">{{socle.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Баня</label><md-select ng-model=\"vm.formWizard.bath_house\"><md-option ng-repeat=\"bathhouse in vm.yes_no_array\" value=\"{{bathhouse.name}}\">{{bathhouse.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Сауна</label><md-select ng-model=\"vm.formWizard.sauna\"><md-option ng-repeat=\"sauna in vm.yes_no_array\" value=\"{{sauna.name}}\">{{sauna.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Балкон</label><md-select ng-model=\"vm.formWizard.balcony\"><md-option ng-repeat=\"balcony in vm.yes_no_array\" value=\"{{balcony.name}}\">{{balcony.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Интернет</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.yes_no_array\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телефон</label><md-select ng-model=\"vm.formWizard.phone\"><md-option ng-repeat=\"phone_type in vm.yes_no_array\" value=\"{{phone_type.name}}\">{{phone_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телевизор</label><md-select ng-model=\"vm.formWizard.tv\"><md-option ng-repeat=\"tv in vm.yes_no_array\" value=\"{{tv.name}}\">{{tv.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Бассейн</label><md-select ng-model=\"vm.formWizard.pool\"><md-option ng-repeat=\"pool in vm.yes_no_array\" value=\"{{pool.name}}\">{{pool.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Газ</label><md-select ng-model=\"vm.formWizard.gas_item\"><md-option ng-repeat=\"gas_item in vm.gas_types\" value=\"{{gas_item.name}}\">{{gas_item.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Отопление</label><md-select ng-model=\"vm.formWizard.heating\"><md-option ng-repeat=\"heating in vm.heating_types\" value=\"{{heating.name}}\">{{heating.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Электричество</label><md-select ng-model=\"vm.formWizard.enegi\"><md-option ng-repeat=\"enegi in vm.enegi_types\" value=\"{{enegi.name}}\">{{enegi.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Водоснабжение</label><md-select ng-model=\"vm.formWizard.water_on_item\"><md-option ng-repeat=\"water_on_item in vm.water_types\" value=\"{{water_on_item.name}}\">{{water_on_item.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Канализация</label><md-select ng-model=\"vm.formWizard.sewage_item\"><md-option ng-repeat=\"sewage_item in vm.sewage_types\" value=\"{{sewage_item.name}}\">{{sewage_item.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><label>Площадь дома, м<sup>2</sup> <strong>**</strong></label> <input name=\"square_living\" ng-model=\"vm.formWizard.square_living\" placeholder=\"Площадь дома\" ng-required=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_living.$error\" ng-show=\"wizardStep2.square_living.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><label>Площадь участка, м<sup>2</sup> <strong>*</strong></label> <input name=\"earthsq\" ng-model=\"vm.formWizard.earthsq\" placeholder=\"Площадь участка**\" ng-required=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.earthsq.$error\" ng-show=\"wizardStep2.earthsq.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"[\'cottage\',\'townhouse\',\'country_house\'].indexOf(vm.formWizard.object_type)<0\"><label>Площадь земельного участка, соток <strong>*</strong></label> <input name=\"square_land\" ng-model=\"vm.formWizard.square_land\" placeholder=\"Площадь участка**\" ng-required=\"![\'cottage\',\'townhouse\',\'country_house\'].indexOf(vm.formWizard.object_type)>0\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_land.$error\" ng-show=\"wizardStep2.square_land.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"md-title\">Вы приближаетесь к завершению создания объекта!</div><div class=\"pb-16\">Теперь опишите его.<br>Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea style=\"overflow:auto;\" ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"2500\" rows=\"15\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее тысячи символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"md-block\"><input type=\"text\" name=\"linktour\" ng-model=\"vm.formWizard.linktour\" ng-pattern=\"/^(?:([a-z]+):(?:([a-z]*):)?\\/\\/)?(?:([^:@]*)(?::([^:@]*))?@)?((?:[a-z0-9_-]+\\.)+[a-z]{2,}|localhost|(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])))(?::(\\d+))?(?:([^:\\?\\#]+))?(?:\\?([^\\#]+))?(?:\\#([^\\s]+))?$/i\" placeholder=\"Ссылка на 3D-тур\"><div ng-messages=\"wizardStep2.linktour.$error\" ng-show=\"wizardStep2.linktour.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Не похоже на ссылку</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">4</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Фотографии</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"pb-16\">Фотографии добавляются независимо от других данных объекта. Если Вы просто добавили фотографии, то можете просто выйти из редактирования объекта.<br>Выбрать файлы для загрузки можно ниже.<br></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtIntanceCallback\" dt-options=\"vm.table.dtOptions\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in ::vm.table.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"photo in vm.photos\"><td><img ng-src=\"{{photo.filename}}\" style=\"width: 400px; height: {{photo.height*400/photo.width}}px; float:left\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.rotatePhoto(photo.filename,90);\" aria-label=\"Rotate left\" ng-show=\"photo.id!=1\"><md-icon md-font-icon=\"icon-replay\" class=\"s16\"></md-icon></md-button><br><md-button class=\"md-raised md-primary\" ng-click=\"vm.rotatePhoto(photo.filename,270);\" aria-label=\"Rotate right\" ng-show=\"photo.id!=1\"><md-icon md-font-icon=\"icon-reload\" class=\"s16\"></md-icon></md-button><br><md-button alt=\"Установить эту фотографию главной\" class=\"md-raised md-accent\" ng-click=\"vm.setMainPhoto(photo.id);\" aria-label=\"Set this as main photo\" ng-show=\"photo.id!=vm.mainImage && photo.id!=1\"><md-icon md-font-icon=\"icon-flag-variant\" class=\"s16\"></md-icon></md-button><br><md-button class=\"md-raised md-warn\" ng-click=\"vm.removePhoto(photo.id);\" aria-label=\"Remove this\" ng-show=\"photo.id!=vm.mainImage && photo.id!=1\"><md-icon md-font-icon=\"icon-content-cut\" class=\"s16\"></md-icon></md-button></td><td>{{ photo.width }}x{{ photo.height }}px / {{ photo.size/1024/1024|number:1 }} Мб<br><br><span ng-show=\"photo.id==vm.mainImage\">Главная фотография выводится<br>как миниатюра на рекламных порталах.<br>Вы не можете ее удалить</span></td></tr></tbody></table><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Не загружайте фотографии с водяными знаками, номерами телефонов и прочей посторонней информацией.<br>Если Вы хотите использовать чужие фотографии, то предварительно отредактируйте их (например, измените размер)<br>Если не следовать этим правилам, то объект вполне может оказаться заблокированным на некоторых порталах</div></div><md-input-container class=\"md-block\"><div class=\"row\"><div class=\"col-md-3\"><h3><md-icon md-font-icon=\"icon-paperclip\" class=\"s16\"></md-icon>Выберите файлы (каждый файл не более 2.5 Мб)</h3><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" aria-label=\"Photos\"><br></div><div class=\"col-md-9\" style=\"margin-bottom: 40px\"><h3>Выбрано файлов для загрузки: {{ uploader.queue.length }}</h3><br><br><table class=\"table\" ng-show=\"uploader.queue.length\"><thead><tr><th width=\"50%\">Имя</th><th ng-show=\"uploader.isHTML5\">Размер</th><th>Действия</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} Мб</td><td nowrap=\"\"><md-button class=\"md-raised md-accent\" ng-click=\"item.upload();vm.successLoadPhotosMessage();\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" aria-label=\"Download this\"><md-icon md-font-icon=\"icon-box-download\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"item.remove();\" aria-label=\"Remove this\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><br><br><div ng-show=\"uploader.queue.length\"><md-button class=\"md-raised md-accent\" ng-click=\"uploader.uploadAll();vm.successLoadPhotosMessage();\" ng-disabled=\"!uploader.getNotUploadedItems().length\" aria-label=\"Download all\" ng-show=\"!hideUpload\">Загрузить все</md-button><md-button class=\"md-raised md-warn\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\" aria-label=\"Clear download list\">Очистить все</md-button></div></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-disabled=\"msWizard.formsIncomplete()\">Редактировать объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/objects/newobject/newcommerce/newcommerce.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Новый объект</span></div><div class=\"title\">Коммерческое помещение</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"tech_4\" ng-model=\"vm.formWizard.tech_4\" placeholder=\"Координаты\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"tech_8\" ng-model=\"vm.formWizard.tech_8\" placeholder=\"TOP3\" ng-show=\"checkRule(59,\'all\')\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион<strong>*</strong></label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\" required=\"\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район<strong>*</strong></label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select><div ng-messages=\"vm.wizardStep1.district.$error\" ng-show=\"vm.wizardStep1.district.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта<strong>*</strong></label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта<strong>*</strong></label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.loadStreets()\" required=\"\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option><div ng-messages=\"vm.wizardStep1.city.$error\" ng-show=\"vm.wizardStep1.city.$touched\" role=\"alert\"><div ng-message=\"required\"><span></span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица*</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"vm.selectedItem\" md-selected-attr=\"vm.streetFromListWhenSelected\" md-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchStreet\" md-search-text-change=\"vm.searchStringChange(vm.searchStreet)\" md-items=\"item in vm.searchStreetResult(vm.searchStreet)\" md-item-text=\"item.value\" md-autofocus=\"true\" autocomplete-blur=\"\" md-input-id=\"street-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchStreet\" md-highlight-flags=\"^i\">{{item.value}}</span></md-item-template><md-not-found>Улиц с таким названием не найдено</md-not-found></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.city_type!=\'г\' || vm.formWizard.region == 2)\"><label>Направление электричек**</label><md-select ng-model=\"vm.formWizard.direction\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option><div ng-messages=\"vm.wizardStep1.direction.$error\" ng-show=\"vm.wizardStep1.direction.$touched\" role=\"alert\"><div ng-message=\"required\"><span>*</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2)\"><input type=\"number\" name=\"from_mcad\" ng-model=\"vm.formWizard.from_mcad\" placeholder=\"От МКАД, км**\" min=\"0\" max=\"150\"><div ng-messages=\"vm.wizardStep1.from_mcad.$error\" ng-show=\"vm.wizardStep1.from_mcad.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"min\"><span>Слишком мало</span></div><div ng-message=\"required\"><span>Слишком далеко</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основное метро**</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"item1.id\" md-selected-item-change=\"vm.formWizard.metro_1 = item1.id;\" md-search-text=\"vm.searchMetro_1\" md-items=\"item1 in vm.metroQuerySearch(vm.searchMetro_1)\" md-item-text=\"item1.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro1-autocomplete-id\" ng-required=\"vm.formWizard.region==1\"><md-item-template><span md-highlight-text=\"vm.searchMetro_1\" md-highlight-flags=\"^i\">{{item1.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_1.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути**</label><md-select ng-model=\"vm.formWizard.metro_1_time\" ng-required=\"vm.formWizard.metro_1\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_1 && vm.formWizard.metro_1_time\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item2.id\" md-selected-item-change=\"vm.formWizard.metro_2 = item2.id;\" md-search-text=\"vm.searchMetro_2\" md-items=\"item2 in vm.metroQuerySearch(vm.searchMetro_2)\" md-item-text=\"item2.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro2-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_2\" md-highlight-flags=\"^i\">{{item2.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_2.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_2_time\" ng-required=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item3.id\" md-selected-item-change=\"vm.formWizard.metro_3 = item3.id;\" md-search-text=\"vm.searchMetro_3\" md-items=\"item3 in vm.metroQuerySearch(vm.searchMetro_3)\" md-item-text=\"item3.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro3-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_3\" md-highlight-flags=\"^i\">{{item3.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_3.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_3_time\" ng-required=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта*</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки*</label><md-select ng-model=\"vm.formWizard.deal_type\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Источник*</label><md-select ng-model=\"vm.formWizard.source_id\" required=\"\"><md-option ng-repeat=\"source in vm.sources\" value=\"{{source.id}}\">{{source.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости*</label><md-select ng-model=\"vm.formWizard.object_type\" ng-change=\"vm.changeBildTypes()\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" ng-show=\"(vm.formWizard.deal_type == \'rent\' || vm.formWizard.deal_type == \'dsd\' || vm.formWizard.deal_type == \'subrent\' || vm.formWizard.deal_type == \'ppa\')\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата*\" ng-pattern=\"/[0-9]$/\" ng-required=\"(vm.formWizard.deal_type == \'rent\' || vm.formWizard.deal_type == \'dsd\' || vm.formWizard.deal_type == \'subrent\' || vm.formWizard.deal_type == \'ppa\')\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>За</label><md-select ng-model=\"vm.formWizard.pay_type\" ng-required=\"(vm.formWizard.deal_type == \'rent\' || vm.formWizard.deal_type == \'dsd\' || vm.formWizard.deal_type == \'subrent\' || vm.formWizard.deal_type == \'ppa\')\"><md-option ng-repeat=\"pay_type in vm.pay_types\" value=\"{{pay_type.name}}\">{{pay_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Период оплаты</label><md-select ng-model=\"vm.formWizard.pay_duration\" ng-required=\"(vm.formWizard.deal_type == \'rent\' || vm.formWizard.deal_type == \'dsd\' || vm.formWizard.deal_type == \'subrent\' || vm.formWizard.deal_type == \'ppa\')\"><md-option ng-repeat=\"pay_duration in vm.pay_durations\" value=\"{{pay_duration.name}}\">{{pay_duration.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственник*</label><md-select ng-model=\"vm.formWizard.client_id\" required=\"\"><md-option ng-repeat=\"client in vm.my_clients\" value=\"{{client.id}}\">{{client.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.deal_type == \'sale\')\"><input type=\"text\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Цена*\" ng-pattern=\"/[0-9]$/\" ng-required=\"(vm.formWizard.deal_type == \'sale\')\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Налог*</label><md-select ng-model=\"vm.formWizard.class_bild\"><md-option ng-repeat=\"class_bild in vm.bcenterstatus_list\" value=\"{{class_bild.name}}\">{{class_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commission\" ng-model=\"vm.formWizard.commission\" placeholder=\"Комиссия*\" ng-pattern=\"/[0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.commission.$error\" ng-show=\"wizardStep1.commission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите комиссию правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комиссии</label><md-select ng-model=\"vm.formWizard.commission_type\"><md-option ng-repeat=\"commission_type in vm.commission_types\" value=\"{{commission_type.name}}\">{{commission_type.rusname}}</md-option></md-select></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"countroom_office\" ng-model=\"vm.formWizard.countroom_office\" placeholder=\"Количество помещений\"><div ng-messages=\"vm.wizardStep1.countroom_office.$error\" ng-show=\"vm.wizardStep1.countroom_office.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type!=\'stock\')\"><input type=\"number\" name=\"story\" ng-model=\"vm.formWizard.story\" placeholder=\"Этаж\" min=\"-2\" max=\"{{vm.formWizard.story_count}}\"><div ng-messages=\"wizardStep2.story.$error\" ng-show=\"wizardStep2.story.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этаж - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этаж правильно</span></div><div ng-message=\"min\"><span>Введите этаж правильно</span></div><div ng-message=\"max\"><span>Этаж не должен быть больше числа этажей</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type!=\'stock\')\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Этажность\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"100\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этажность - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Планировка</label><md-select ng-model=\"vm.formWizard.plan_bild\"><md-option ng-repeat=\"plan_bild in vm.plan_bild_types\" value=\"{{plan_bild.name}}\">{{plan_bild.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Назначение</label><md-select ng-model=\"vm.formWizard.commerce_living_type\"><md-option ng-repeat=\"commerce_living_type in vm.yes_no_array_living\" value=\"{{commerce_living_type.name}}\">{{commerce_living_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Юридический адрес</label><md-select ng-model=\"vm.formWizard.commerce_enter\"><md-option ng-repeat=\"commerce_enter in vm.yes_no_array_enter\" value=\"{{commerce_enter.name}}\">{{commerce_enter.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commerce_businesscenter\" ng-model=\"vm.formWizard.commerce_businesscenter\" placeholder=\"Электрическая мощность\"><div ng-messages=\"vm.wizardStep1.commerce_businesscenter.$error\" ng-show=\"vm.wizardStep1.commerce_businesscenter.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Скрыть номер дома в рекламе?</label><md-select ng-model=\"vm.formWizard.furniture\"><md-option ng-repeat=\"furniture in vm.furniture_types\" value=\"{{furniture.name}}\">{{furniture.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Валюта (руб)</label><md-select ng-model=\"vm.formWizard.lift\"><md-option ng-repeat=\"lift in vm.lift_types\" value=\"{{lift.name}}\">{{lift.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип здания</label><md-select ng-model=\"vm.formWizard.type_bild\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Санузел (если есть)</label><md-select ng-model=\"vm.formWizard.type_bathroom\"><md-option ng-repeat=\"type_bathroom in vm.types_bathroom\" value=\"{{type_bathroom.name}}\">{{type_bathroom.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><label>Эксплуатационные расходы*</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.yes_no_array\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><label>Коммунальные платежи*</label><md-select ng-model=\"vm.formWizard.phone\"><md-option ng-repeat=\"phone_type in vm.phone_types\" value=\"{{phone_type.name}}\">{{phone_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Электричество</label><md-select ng-model=\"vm.formWizard.enegi\"><md-option ng-repeat=\"enegi in vm.enegi_types\" value=\"{{enegi.name}}\">{{enegi.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Отопление</label><md-select ng-model=\"vm.formWizard.heating\"><md-option ng-repeat=\"heating in vm.heating_types\" value=\"{{heating.name}}\">{{heating.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type!=\'garage\' && vm.formWizard.object_type!=\'parkingPlace\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Канализация</label><md-select ng-model=\"vm.formWizard.sewage_item\"><md-option ng-repeat=\"sewage_item in vm.yes_no_array\" value=\"{{sewage_item.name}}\">{{sewage_item.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Газ</label><md-select ng-model=\"vm.formWizard.gas_item\"><md-option ng-repeat=\"gas_item in vm.yes_no_array\" value=\"{{gas_item.name}}\">{{gas_item.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Водоснабжение</label><md-select ng-model=\"vm.formWizard.water_on_item\"><md-option ng-repeat=\"water_on_item in vm.yes_no_array\" value=\"{{water_on_item.name}}\">{{water_on_item.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.formWizard.object_type == \'garage\' || vm.formWizard.object_type == \'parkingPlace\'\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип гаража</label><md-select ng-model=\"vm.formWizard.garage_type\"><md-option ng-repeat=\"garage_type in vm.garage_types\" value=\"{{garage_type.name}}\">{{garage_type.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.formWizard.object_type == \'garage\' || vm.formWizard.object_type == \'parkingPlace\'\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>АЗС</label><md-select ng-model=\"vm.formWizard.infra1\"><md-option ng-repeat=\"infra1 in vm.yes_no_array\" value=\"{{infra1.name}}\">{{infra1.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>СТО</label><md-select ng-model=\"vm.formWizard.infra2\"><md-option ng-repeat=\"infra2 in vm.yes_no_array\" value=\"{{infra2.name}}\">{{infra2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Автомойка</label><md-select ng-model=\"vm.formWizard.infra3\"><md-option ng-repeat=\"infra3 in vm.yes_no_array\" value=\"{{infra3.name}}\">{{infra3.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Смотровая яма</label><md-select ng-model=\"vm.formWizard.spec1\"><md-option ng-repeat=\"spec1 in vm.yes_no_array\" value=\"{{spec1.name}}\">{{spec1.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Погреб</label><md-select ng-model=\"vm.formWizard.spec2\"><md-option ng-repeat=\"spec2 in vm.yes_no_array\" value=\"{{spec2.name}}\">{{spec2.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.formWizard.object_type == \'garage\' || vm.formWizard.object_type == \'parkingPlace\'\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Заасфальтированный подъезд</label><md-select ng-model=\"vm.formWizard.spec3\"><md-option ng-repeat=\"spec3 in vm.yes_no_array\" value=\"{{spec3.name}}\">{{spec3.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.formWizard.object_type == \'stock\'\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь офисной части, м<sup>2</sup> <strong>*</strong></label> <input name=\"officesq_stock\" ng-model=\"vm.formWizard.officesq_stock\" placeholder=\"Площадь офисной части\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.officesq_stock.$error\" ng-show=\"wizardStep2.officesq_stock.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь производственной части, м<sup>2</sup> <strong>*</strong></label> <input name=\"usefulsq_stock\" ng-model=\"vm.formWizard.usefulsq_stock\" placeholder=\"Площадь производственной части\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.usefulsq_stock.$error\" ng-show=\"wizardStep2.usefulsq_stock.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь прилегающей территории, Га <strong>*</strong></label> <input name=\"bordersq_stock\" ng-model=\"vm.formWizard.bordersq_stock\" placeholder=\"Площадь прилегающей территории\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.bordersq_stock.$error\" ng-show=\"wizardStep2.bordersq_stock.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь складской части, м<sup>2</sup> <strong>**</strong></label> <input name=\"workssq\" ng-model=\"vm.formWizard.workssq\" placeholder=\"Площадь складской части\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.workssq.$error\" ng-show=\"wizardStep2.workssq.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Общая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_all\" ng-model=\"vm.formWizard.square_all\" placeholder=\"Общая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_all.$error\" ng-show=\"wizardStep2.square_all.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.object_type == \'commercial_premises\'\"><label>Торговая площадь, м<sup>2</sup>**</label> <input name=\"shopsq\" ng-model=\"vm.formWizard.shopsq\" placeholder=\"Торговая площадь**\" ng-required=\"vm.formWizard.object_type == \'commercial_premises\'\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.shopsq.$error\" ng-show=\"wizardStep2.shopsq.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Витрина</label><md-select ng-model=\"vm.formWizard.showcase\"><md-option ng-repeat=\"showcase in vm.yes_no_array\" value=\"{{showcase.name}}\">{{showcase.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.object_type == \'ready_business\'\"><input type=\"text\" name=\"part_percent\" ng-model=\"vm.formWizard.part_percent\" placeholder=\"Доля бизнеса**\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" ng-required=\"vm.formWizard.object_type == \'ready_business\'\"><div ng-messages=\"wizardStep1.part_percent.$error\" ng-show=\"wizardStep1.part_percent.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.object_type == \'ready_business\'\"><input type=\"text\" name=\"yearprofit\" ng-model=\"vm.formWizard.yearprofit\" placeholder=\"Годовая прибыль**\" ng-required=\"vm.formWizard.object_type == \'ready_business\'\"><div ng-messages=\"vm.wizardStep1.yearprofit.$error\" ng-show=\"vm.wizardStep1.yearprofit.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.object_type == \'ready_business\'\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата**\" ng-required=\"vm.formWizard.object_type == \'ready_business\'\"><div ng-messages=\"vm.wizardStep1.rentcost.$error\" ng-show=\"vm.wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"md-title\">Вы приближаетесь к завершению создания объекта!</div><div class=\"pb-16\">Теперь опишите его.<br>Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"1500\" rows=\"5\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее тысячи символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"md-block\"><input type=\"text\" name=\"linktour\" ng-model=\"vm.formWizard.linktour\" ng-pattern=\"/^(?:([a-z]+):(?:([a-z]*):)?\\/\\/)?(?:([^:@]*)(?::([^:@]*))?@)?((?:[a-z0-9_-]+\\.)+[a-z]{2,}|localhost|(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])))(?::(\\d+))?(?:([^:\\?\\#]+))?(?:\\?([^\\#]+))?(?:\\#([^\\s]+))?$/i\" placeholder=\"Ссылка на 3D-тур\"><div ng-messages=\"wizardStep2.linktour.$error\" ng-show=\"wizardStep2.linktour.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Не похоже на ссылку</span></div></div></md-input-container></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Создать объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/objects/newobject/newflat/newflat.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Новый объект</span></div><div class=\"title\">Квартира</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"tech_4\" ng-model=\"vm.formWizard.tech_4\" placeholder=\"Координаты\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Место для TOP3</label></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион*</label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\" required=\"\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район*</label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта*</label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта*</label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.isStreetRequired();vm.searchStreet = \'\';\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица*</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"vm.selectedItem\" md-selected-attr=\"vm.streetFromListWhenSelected\" md-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchStreet\" md-search-text-change=\"vm.searchStringChange(vm.searchStreet)\" md-items=\"item in vm.searchStreetResult(vm.searchStreet)\" md-item-text=\"item.value\" md-autofocus=\"true\" autocomplete-blur=\"\" md-input-id=\"street-autocomplete-id\" ng-required=\"vm.street_qty>0\"><md-item-template><span md-highlight-text=\"vm.searchStreet\" md-highlight-flags=\"^i\">{{item.value}}</span></md-item-template><md-not-found>Улиц с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.street.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Улица обязательно должна быть указана</div><div ng-message=\"vm.streetFromList\">Выберете улицу из списка</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\" required=\"\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"flat_number\" ng-model=\"vm.formWizard.flat_number\" placeholder=\"Номер кв.\"><div ng-messages=\"vm.wizardStep1.flat_number.$error\" ng-show=\"vm.wizardStep1.flat_number.$touched\" role=\"alert\"></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2\"><label>Направление электричек**</label><md-select ng-model=\"vm.formWizard.direction\" ng-required=\"vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2\"><input type=\"number\" name=\"from_mcad\" ng-model=\"vm.formWizard.from_mcad\" placeholder=\"От МКАД, км**\" min=\"0\" max=\"150\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"flats_apartmentscomplex\" ng-model=\"vm.formWizard.flats_apartmentscomplex\" placeholder=\"Название ЖК\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основное метро**</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"item1.id\" md-selected-item-change=\"vm.formWizard.metro_1 = item1.id;\" md-search-text=\"vm.searchMetro_1\" md-items=\"item1 in vm.metroQuerySearch(vm.searchMetro_1)\" md-item-text=\"item1.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro1-autocomplete-id\" ng-required=\"vm.formWizard.region==1\"><md-item-template><span md-highlight-text=\"vm.searchMetro_1\" md-highlight-flags=\"^i\">{{item1.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_1.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути**</label><md-select ng-model=\"vm.formWizard.metro_1_time\" ng-required=\"vm.formWizard.metro_1\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_1 && vm.formWizard.metro_1_time\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item2.id\" md-selected-item-change=\"vm.formWizard.metro_2 = item2.id;\" md-search-text=\"vm.searchMetro_2\" md-items=\"item2 in vm.metroQuerySearch(vm.searchMetro_2)\" md-item-text=\"item2.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro2-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_2\" md-highlight-flags=\"^i\">{{item2.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_2.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_2_time\" ng-required=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item3.id\" md-selected-item-change=\"vm.formWizard.metro_3 = item3.id;\" md-search-text=\"vm.searchMetro_3\" md-items=\"item3 in vm.metroQuerySearch(vm.searchMetro_3)\" md-item-text=\"item3.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro3-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_3\" md-highlight-flags=\"^i\">{{item3.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_3.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_3_time\" ng-required=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственник*</label><md-select ng-model=\"vm.formWizard.client_id\" required=\"\"><md-option ng-repeat=\"client in vm.my_clients\" value=\"{{client.id}}\">{{client.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта*</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки*</label><md-select ng-model=\"vm.formWizard.deal_type\" ng-change=\"vm.changeFlatStatuses()\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости*</label><md-select ng-model=\"vm.formWizard.object_type\" ng-change=\"vm.changeRoomTypes()\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.formWizard.object_type == \'part\'\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"part_percent\" ng-model=\"vm.formWizard.part_percent\" placeholder=\"Процент доли*\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" ng-required=\"vm.formWizard.object_type == \'part\'\"><div ng-messages=\"wizardStep1.part_percent.$error\" ng-show=\"wizardStep1.part_percent.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Срок аренды</label><md-select ng-model=\"vm.formWizard.rent_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"rent_duration in vm.rent_durations\" value=\"{{rent_duration.name}}\">{{rent_duration.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Период оплаты</label><md-select ng-model=\"vm.formWizard.pay_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"pay_duration in vm.pay_durations\" value=\"{{pay_duration.name}}\">{{pay_duration.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Встречались с собственником?**</label><md-select ng-model=\"vm.formWizard.meet\"><md-option ng-repeat=\"meet in vm.yes_no_array\" value=\"{{meet.name}}\">{{meet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.deal_type != \'rent\'\"><input type=\"text\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Цена\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type != \'rent\'\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commission\" ng-model=\"vm.formWizard.commission\" placeholder=\"Комиссия\" ng-pattern=\"/[0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.commission.$error\" ng-show=\"wizardStep1.commission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите комиссию правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комиссии</label><md-select ng-model=\"vm.formWizard.commission_type\"><md-option ng-repeat=\"commission_type in vm.commission_types\" value=\"{{commission_type.name}}\">{{commission_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Бонус агенту в %</label><md-select ng-model=\"vm.formWizard.bordersq_stock\"><md-option ng-repeat=\"bordersq_stock in vm.bordersq_stocks\" value=\"{{bordersq_stock.name}}\">{{bordersq_stock.rusname}}</md-option></md-select></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Число комнат <strong>*</strong></label><md-select ng-model=\"vm.formWizard.rooms_number\" required=\"\"><md-option ng-repeat=\"rooms_type in vm.rooms_type_list\" value=\"{{rooms_type.name}}\">{{rooms_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story\" ng-model=\"vm.formWizard.story\" placeholder=\"Этаж <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"{{vm.formWizard.story_count}}\" required=\"\"><div ng-messages=\"wizardStep2.story.$error\" ng-show=\"wizardStep2.story.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этаж - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этаж правильно</span></div><div ng-message=\"min\"><span>Введите этаж правильно</span></div><div ng-message=\"max\"><span>Этаж не должен быть больше числа этажей</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Этажность <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"100\" required=\"\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этажность - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комнат</label><md-select ng-model=\"vm.formWizard.furniture\"><md-option ng-repeat=\"furniture in vm.furniture_types\" value=\"{{furniture.name}}\">{{furniture.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\" required=\"\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ипотека<strong>*</strong></label><md-select ng-model=\"vm.formWizard.flat_status\" required=\"\"><md-option ng-repeat=\"flat_status in vm.flat_status_types\" value=\"{{flat_status.name}}\">{{flat_status.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное место**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Лифт</label><md-select ng-model=\"vm.formWizard.lift\"><md-option ng-repeat=\"lift in vm.lift_types\" value=\"{{lift.name}}\">{{lift.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Балкон</label><md-select ng-model=\"vm.formWizard.balcony\"><md-option ng-repeat=\"balcony in vm.balcony_types\" value=\"{{balcony.name}}\">{{balcony.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Стоимость</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.inet_types\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип дома<strong>*</strong></label><md-select ng-model=\"vm.formWizard.type_bild\" required=\"\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип санузла</label><md-select ng-model=\"vm.formWizard.type_bathroom\"><md-option ng-repeat=\"type_bathroom in vm.types_bathroom\" value=\"{{type_bathroom.name}}\">{{type_bathroom.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"count_bathroom_flat\" ng-model=\"vm.formWizard.count_bathroom_flat\" placeholder=\"Количество сан.узлов\" ng-pattern=\"/^[0-9]{1,2}$/\"><div ng-messages=\"wizardStep2.count_bathroom_flat.$error\" ng-show=\"wizardStep2.count_bathroom_flat.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственность</label><md-select ng-model=\"vm.formWizard.ownership\"><md-option ng-repeat=\"ownership in vm.ownership_types\" value=\"{{ownership.name}}\">{{ownership.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>В собственности</label><md-select ng-model=\"vm.formWizard.years_own\"><md-option ng-repeat=\"years_own in vm.years_own_types\" value=\"{{years_own.name}}\">{{years_own.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Парковка</label><md-select ng-model=\"vm.formWizard.tv\"><md-option ng-repeat=\"tv in vm.types_parking\" value=\"{{tv.name}}\">{{tv.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Вид из окон</label><md-select ng-model=\"vm.formWizard.windows\"><md-option ng-repeat=\"window in vm.windows_type\" value=\"{{window.name}}\">{{window.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Общая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_all\" ng-model=\"vm.formWizard.square_all\" placeholder=\"Общая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_all.$error\" ng-show=\"wizardStep2.square_all.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Жилая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_living\" ng-model=\"vm.formWizard.square_living\" placeholder=\"Жилая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxLiving=vm.formWizard.square_all-vm.formWizard.square_kitchen}}\" min=\"0\" max=\"{{vm.maxLiving}}\"><div ng-messages=\"wizardStep2.square_living.$error\" ng-show=\"wizardStep2.square_living.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь кухни, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_kitchen\" ng-model=\"vm.formWizard.square_kitchen\" placeholder=\"Площадь кухни\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxKitchen=vm.formWizard.square_all-vm.formWizard.square_living}}\" min=\"0\" max=\"{{vm.maxKitchen}}\"><div ng-messages=\"wizardStep2.square_kitchen.$error\" ng-show=\"wizardStep2.square_kitchen.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площади комнат через + <strong>*</strong></label> <input name=\"square_rooms\" ng-model=\"vm.formWizard.square_rooms\" placeholder=\"Площади комнат через разделитель\" required=\"\" ng-pattern=\"/^((\\d+(.\\d{1,2})?\\+?)*\\d{1}(.\\d{1,2})?)$/\"><div ng-messages=\"wizardStep2.square_rooms.$error\" ng-show=\"wizardStep2.square_rooms.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь комнат должна быть указана</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"md-title\">Вы приближаетесь к завершению создания объекта!</div><div class=\"pb-16\">Теперь опишите его.<br>Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"2500\" rows=\"15\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее тысячи символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"md-block\"><input type=\"text\" name=\"linktour\" ng-model=\"vm.formWizard.linktour\" ng-pattern=\"/^(?:([a-z]+):(?:([a-z]*):)?\\/\\/)?(?:([^:@]*)(?::([^:@]*))?@)?((?:[a-z0-9_-]+\\.)+[a-z]{2,}|localhost|(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])))(?::(\\d+))?(?:([^:\\?\\#]+))?(?:\\?([^\\#]+))?(?:\\#([^\\s]+))?$/i\" placeholder=\"Ссылка на 3D-тур\"><div ng-messages=\"wizardStep2.linktour.$error\" ng-show=\"wizardStep2.linktour.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Не похоже на ссылку</span></div></div></md-input-container></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Создать объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/objects/newobject/newflatrent/newflatrent.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Новый объект</span></div><div class=\"title\">Квартира</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион*</label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\" required=\"\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район*</label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта*</label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта*</label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.isStreetRequired();vm.searchStreet = \'\';\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица*</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"vm.selectedItem\" md-selected-attr=\"vm.streetFromListWhenSelected\" md-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchStreet\" md-search-text-change=\"vm.searchStringChange(vm.searchStreet)\" md-items=\"item in vm.searchStreetResult(vm.searchStreet)\" md-item-text=\"item.value\" md-autofocus=\"true\" autocomplete-blur=\"\" md-input-id=\"street-autocomplete-id\" ng-required=\"vm.street_qty>0\"><md-item-template><span md-highlight-text=\"vm.searchStreet\" md-highlight-flags=\"^i\">{{item.value}}</span></md-item-template><md-not-found>Улиц с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.street.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Улица обязательно должна быть указана</div><div ng-message=\"vm.streetFromList\">Выберете улицу из списка</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\" required=\"\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"flat_number\" ng-model=\"vm.formWizard.flat_number\" placeholder=\"Номер кв.\"><div ng-messages=\"vm.wizardStep1.flat_number.$error\" ng-show=\"vm.wizardStep1.flat_number.$touched\" role=\"alert\"></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2\"><label>Направление электричек**</label><md-select ng-model=\"vm.formWizard.direction\" ng-required=\"vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2\"><input type=\"number\" name=\"from_mcad\" ng-model=\"vm.formWizard.from_mcad\" placeholder=\"От МКАД, км**\" min=\"0\" max=\"150\" ng-required=\"vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"flats_apartmentscomplex\" ng-model=\"vm.formWizard.flats_apartmentscomplex\" placeholder=\"Название ЖК\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основное метро**</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"item1.id\" md-selected-item-change=\"vm.formWizard.metro_1 = item1.id;\" md-search-text=\"vm.searchMetro_1\" md-items=\"item1 in vm.metroQuerySearch(vm.searchMetro_1)\" md-item-text=\"item1.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro1-autocomplete-id\" ng-required=\"vm.formWizard.region==1\"><md-item-template><span md-highlight-text=\"vm.searchMetro_1\" md-highlight-flags=\"^i\">{{item1.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_1.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути**</label><md-select ng-model=\"vm.formWizard.metro_1_time\" ng-required=\"vm.formWizard.metro_1\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_1 && vm.formWizard.metro_1_time\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item2.id\" md-selected-item-change=\"vm.formWizard.metro_2 = item2.id;\" md-search-text=\"vm.searchMetro_2\" md-items=\"item2 in vm.metroQuerySearch(vm.searchMetro_2)\" md-item-text=\"item2.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro2-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_2\" md-highlight-flags=\"^i\">{{item2.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_2.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_2_time\" ng-required=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Дополнительное метро</label><md-autocomplete class=\"metroAutocomplete\" flex=\"100\" md-selected-item=\"item3.id\" md-selected-item-change=\"vm.formWizard.metro_3 = item3.id;\" md-search-text=\"vm.searchMetro_3\" md-items=\"item3 in vm.metroQuerySearch(vm.searchMetro_3)\" md-item-text=\"item3.name\" autocomplete-metro-blur=\"\" md-input-id=\"metro3-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchMetro_3\" md-highlight-flags=\"^i\">{{item3.name}}</span></md-item-template><md-not-found>Станций с таким названием не найдено</md-not-found><div ng-messages=\"vm.wizardStep1.metro_3.$error\" ng-show=\"vm.wizardStep1.autocompleteField.$touched\" role=\"alert\">><div ng-message=\"required\">Станция обязательно должна быть указана</div></div></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_3_time\" ng-required=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта*</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки*</label><md-select ng-model=\"vm.formWizard.deal_type\" ng-change=\"vm.changeFlatStatuses()\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Источник**</label><md-select ng-model=\"vm.formWizard.source_id\"><md-option ng-repeat=\"source_id in vm.sources\" value=\"{{source_id.id}}\">{{source_id.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости*</label><md-select ng-model=\"vm.formWizard.object_type\" ng-change=\"vm.changeRoomTypes()\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.formWizard.object_type == \'part\'\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"part_percent\" ng-model=\"vm.formWizard.part_percent\" placeholder=\"Процент доли*\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" ng-required=\"vm.formWizard.object_type == \'part\'\"><div ng-messages=\"wizardStep1.part_percent.$error\" ng-show=\"wizardStep1.part_percent.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Срок аренды</label><md-select ng-model=\"vm.formWizard.rent_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"rent_duration in vm.rent_durations\" value=\"{{rent_duration.name}}\">{{rent_duration.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"officesq_stock\" ng-model=\"vm.formWizard.officesq_stock\" placeholder=\"Депозит\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.officesq_stock.$error\" ng-show=\"wizardStep1.officesq_stock.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Предоплата, в месяцах</label><md-select ng-model=\"vm.formWizard.class_bild\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"class_bild in vm.class_bilds\" value=\"{{class_bild.name}}\">{{class_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"usefulsq_stock\" ng-model=\"vm.formWizard.usefulsq_stock\" placeholder=\"Комиссия от клиента\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.usefulsq_stock.$error\" ng-show=\"wizardStep1.usefulsq_stock.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите комиссию без %</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"bordersq_stock\" ng-model=\"vm.formWizard.bordersq_stock\" placeholder=\"Комиссия от агента\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.bordersq_stock.$error\" ng-show=\"wizardStep1.bordersq_stock.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите комиссию без %</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Число комнат <strong>*</strong></label><md-select ng-model=\"vm.formWizard.rooms_number\" required=\"\"><md-option ng-repeat=\"rooms_type in vm.rooms_type_list\" value=\"{{rooms_type.name}}\">{{rooms_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story\" ng-model=\"vm.formWizard.story\" placeholder=\"Этаж <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"{{vm.formWizard.story_count}}\" required=\"\"><div ng-messages=\"wizardStep2.story.$error\" ng-show=\"wizardStep2.story.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этаж - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этаж правильно</span></div><div ng-message=\"min\"><span>Введите этаж правильно</span></div><div ng-message=\"max\"><span>Этаж не должен быть больше числа этажей</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Этажность <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"100\" required=\"\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этажность - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"tech_4\" ng-model=\"vm.formWizard.tech_4\" placeholder=\"Координаты\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Кондиционер</label><md-select ng-model=\"vm.formWizard.furniture\"><md-option ng-repeat=\"furniture in vm.furniture_types\" value=\"{{furniture.name}}\">{{furniture.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\" required=\"\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Посудомоечная машина<strong>*</strong></label><md-select ng-model=\"vm.formWizard.flat_status\"><md-option ng-repeat=\"flat_status in vm.flat_status_types\" value=\"{{flat_status.name}}\">{{flat_status.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Лифт</label><md-select ng-model=\"vm.formWizard.lift\"><md-option ng-repeat=\"lift in vm.lift_types\" value=\"{{lift.name}}\">{{lift.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Балкон</label><md-select ng-model=\"vm.formWizard.balcony\"><md-option ng-repeat=\"balcony in vm.balcony_types\" value=\"{{balcony.name}}\">{{balcony.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип дома<strong>*</strong></label><md-select ng-model=\"vm.formWizard.type_bild\" required=\"\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип санузла</label><md-select ng-model=\"vm.formWizard.type_bathroom\"><md-option ng-repeat=\"type_bathroom in vm.types_bathroom\" value=\"{{type_bathroom.name}}\">{{type_bathroom.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"count_bathroom_flat\" ng-model=\"vm.formWizard.count_bathroom_flat\" placeholder=\"Количество сан.узлов\" ng-pattern=\"/^[0-9]{1,2}$/\"><div ng-messages=\"wizardStep2.count_bathroom_flat.$error\" ng-show=\"wizardStep2.count_bathroom_flat.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Интернет</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.yes_no_array\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Стиральная машина</label><md-select ng-model=\"vm.formWizard.phone\"><md-option ng-repeat=\"phone_type in vm.phone_types\" value=\"{{phone_type.name}}\">{{phone_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телевизор</label><md-select ng-model=\"vm.formWizard.tv\"><md-option ng-repeat=\"tv in vm.yes_no_array\" value=\"{{tv.name}}\">{{tv.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Вид из окон</label><md-select ng-model=\"vm.formWizard.windows\"><md-option ng-repeat=\"window in vm.windows_type\" value=\"{{window.name}}\">{{window.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Общая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_all\" ng-model=\"vm.formWizard.square_all\" placeholder=\"Общая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_all.$error\" ng-show=\"wizardStep2.square_all.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Жилая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_living\" ng-model=\"vm.formWizard.square_living\" placeholder=\"Жилая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxLiving=vm.formWizard.square_all-vm.formWizard.square_kitchen}}\" min=\"0\" max=\"{{vm.maxLiving}}\"><div ng-messages=\"wizardStep2.square_living.$error\" ng-show=\"wizardStep2.square_living.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь кухни, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_kitchen\" ng-model=\"vm.formWizard.square_kitchen\" placeholder=\"Площадь кухни\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxKitchen=vm.formWizard.square_all-vm.formWizard.square_living}}\" min=\"0\" max=\"{{vm.maxKitchen}}\"><div ng-messages=\"wizardStep2.square_kitchen.$error\" ng-show=\"wizardStep2.square_kitchen.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площади комнат через + <strong>*</strong></label> <input name=\"square_rooms\" ng-model=\"vm.formWizard.square_rooms\" placeholder=\"Площади комнат через разделитель\" required=\"\" ng-pattern=\"/^((\\d+(.\\d{1,2})?\\+?)*\\d{1}(.\\d{1,2})?)$/\"><div ng-messages=\"wizardStep2.square_rooms.$error\" ng-show=\"wizardStep2.square_rooms.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь комнат должна быть указана</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"md-title\">Вы приближаетесь к завершению создания объекта!</div><div class=\"pb-16\">Теперь опишите его.<br>Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"2500\" rows=\"15\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее тысячи символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"md-block\"><input type=\"text\" name=\"linktour\" ng-model=\"vm.formWizard.linktour\" ng-pattern=\"/^(?:([a-z]+):(?:([a-z]*):)?\\/\\/)?(?:([^:@]*)(?::([^:@]*))?@)?((?:[a-z0-9_-]+\\.)+[a-z]{2,}|localhost|(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])))(?::(\\d+))?(?:([^:\\?\\#]+))?(?:\\?([^\\#]+))?(?:\\#([^\\s]+))?$/i\" placeholder=\"Ссылка на 3D-тур\"><div ng-messages=\"wizardStep2.linktour.$error\" ng-show=\"wizardStep2.linktour.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Не похоже на ссылку</span></div></div></md-input-container></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Создать объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/objects/newobject/newsuburbian/newsuburbian.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Новый объект</span></div><div class=\"title\">Дом/земля</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион*</label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\" required=\"\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район**</label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта**</label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта*</label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.loadStreets()\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица*</label><md-autocomplete class=\"streetAutocomplete\" flex=\"100\" md-selected-item=\"vm.selectedItem\" md-selected-attr=\"vm.streetFromListWhenSelected\" md-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchStreet\" md-search-text-change=\"vm.searchStringChange(vm.searchStreet)\" md-items=\"item in vm.searchStreetResult(vm.searchStreet)\" md-item-text=\"item.value\" md-autofocus=\"true\" autocomplete-blur=\"\" md-input-id=\"street-autocomplete-id\"><md-item-template><span md-highlight-text=\"vm.searchStreet\" md-highlight-flags=\"^i\">{{item.value}}</span></md-item-template></md-autocomplete></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2\"><label>Направление электричек**</label><md-select ng-model=\"vm.formWizard.direction\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option><div ng-messages=\"vm.wizardStep1.direction.$error\" ng-show=\"vm.wizardStep1.direction.$touched\" role=\"alert\"><div ng-message=\"required\"><span>*</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.city_type!=\'г\' || vm.formWizard.region==2\"><input type=\"number\" name=\"from_mcad\" ng-model=\"vm.formWizard.from_mcad\" placeholder=\"От МКАД, км**\" min=\"0\" max=\"150\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта*</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки*</label><md-select ng-model=\"vm.formWizard.deal_type\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Источник**</label><md-select ng-model=\"vm.formWizard.source_id\"><md-option ng-repeat=\"source in vm.sources\" value=\"{{source.id}}\">{{source.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости*</label><md-select ng-model=\"vm.formWizard.object_type\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><label>Целевое назначение земель</label><md-select ng-model=\"vm.formWizard.country_land_type\" ng-required=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-option ng-repeat=\"country_land_type in vm.land_types\" value=\"{{country_land_type.name}}\">{{country_land_type.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Срок аренды</label><md-select ng-model=\"vm.formWizard.rent_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"rent_duration in vm.rent_durations\" value=\"{{rent_duration.name}}\">{{rent_duration.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственник*</label><md-select ng-model=\"vm.formWizard.client_id\" required=\"\"><md-option ng-repeat=\"client in vm.my_clients\" value=\"{{client.id}}\">{{client.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.deal_type != \'rent\'\"><input type=\"text\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Цена*\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type != \'rent\'\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commission\" ng-model=\"vm.formWizard.commission\" placeholder=\"Комиссия*\" ng-pattern=\"/[0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.commission.$error\" ng-show=\"wizardStep1.commission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите комиссию правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комиссии</label><md-select ng-model=\"vm.formWizard.commission_type\"><md-option ng-repeat=\"commission_type in vm.commission_types\" value=\"{{commission_type.name}}\">{{commission_type.rusname}}</md-option></md-select></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Гараж</label><md-select ng-model=\"vm.formWizard.count_garage\"><md-option ng-repeat=\"count_garage in vm.yes_no_array\" value=\"{{count_garage.name}}\">{{count_garage.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.count_garage == \'yes\')\"><label>Коммуникации в гараже</label><md-select ng-model=\"vm.formWizard.energi_garage\"><md-option ng-repeat=\"energi_garage in vm.energi_garage_types\" value=\"{{energi_garage.name}}\">{{energi_garage.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Количество этажей в доме\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"6\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Материал дома*</label><md-select ng-model=\"vm.formWizard.type_bild\" ng-required=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"tech_4\" ng-model=\"vm.formWizard.tech_4\" placeholder=\"Координаты\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Запасное окно**</label></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"furniture\" ng-model=\"vm.formWizard.furniture\" placeholder=\"Количетсво комнат\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\" ng-required=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Эркер</label><md-select ng-model=\"vm.formWizard.erker\"><md-option ng-repeat=\"erker in vm.yes_no_array\" value=\"{{erker.name}}\">{{erker.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Мансарда</label><md-select ng-model=\"vm.formWizard.garret\"><md-option ng-repeat=\"garret in vm.yes_no_array\" value=\"{{garret.name}}\">{{garret.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Цоколь</label><md-select ng-model=\"vm.formWizard.socle\"><md-option ng-repeat=\"socle in vm.yes_no_array\" value=\"{{socle.name}}\">{{socle.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Баня</label><md-select ng-model=\"vm.formWizard.bath_house\"><md-option ng-repeat=\"bathhouse in vm.yes_no_array\" value=\"{{bathhouse.name}}\">{{bathhouse.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Сауна</label><md-select ng-model=\"vm.formWizard.sauna\"><md-option ng-repeat=\"sauna in vm.yes_no_array\" value=\"{{sauna.name}}\">{{sauna.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Балкон</label><md-select ng-model=\"vm.formWizard.balcony\"><md-option ng-repeat=\"balcony in vm.yes_no_array\" value=\"{{balcony.name}}\">{{balcony.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Интернет</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.yes_no_array\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телефон</label><md-select ng-model=\"vm.formWizard.phone\"><md-option ng-repeat=\"phone_type in vm.yes_no_array\" value=\"{{phone_type.name}}\">{{phone_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телевизор</label><md-select ng-model=\"vm.formWizard.tv\"><md-option ng-repeat=\"tv in vm.yes_no_array\" value=\"{{tv.name}}\">{{tv.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Бассейн</label><md-select ng-model=\"vm.formWizard.pool\"><md-option ng-repeat=\"pool in vm.yes_no_array\" value=\"{{pool.name}}\">{{pool.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Газ</label><md-select ng-model=\"vm.formWizard.gas_item\"><md-option ng-repeat=\"gas_item in vm.gas_types\" value=\"{{gas_item.name}}\">{{gas_item.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Отопление</label><md-select ng-model=\"vm.formWizard.heating\"><md-option ng-repeat=\"heating in vm.heating_types\" value=\"{{heating.name}}\">{{heating.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Электричество</label><md-select ng-model=\"vm.formWizard.enegi\"><md-option ng-repeat=\"enegi in vm.enegi_types\" value=\"{{enegi.name}}\">{{enegi.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Водоснабжение</label><md-select ng-model=\"vm.formWizard.water_on_item\"><md-option ng-repeat=\"water_on_item in vm.water_types\" value=\"{{water_on_item.name}}\">{{water_on_item.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Канализация</label><md-select ng-model=\"vm.formWizard.sewage_item\"><md-option ng-repeat=\"sewage_item in vm.sewage_types\" value=\"{{sewage_item.name}}\">{{sewage_item.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><label>Площадь дома, м<sup>2</sup> <strong>**</strong></label> <input name=\"square_living\" ng-model=\"vm.formWizard.square_living\" placeholder=\"Площадь дома\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_living.$error\" ng-show=\"wizardStep2.square_living.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"(vm.formWizard.object_type == \'cottage\' || vm.formWizard.object_type == \'country_house\' || vm.formWizard.object_type == \'townhouse\')\"><label>Площадь участка, м<sup>2</sup> <strong>**</strong></label> <input name=\"earthsq\" ng-model=\"vm.formWizard.earthsq\" placeholder=\"Площадь участка**\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.earthsq.$error\" ng-show=\"wizardStep2.earthsq.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"[\'cottage\',\'townhouse\',\'country_house\'].indexOf(vm.formWizard.object_type)<0\"><label>Площадь земельного участка, соток <strong>**</strong></label> <input name=\"square_land\" ng-model=\"vm.formWizard.square_land\" placeholder=\"Площадь участка**\" type=\"number\" ng-required=\"[\'cottage\',\'townhouse\',\'country_house\'].indexOf(vm.formWizard.object_type)<0\" min=\"0\"><div ng-messages=\"wizardStep2.square_land.$error\" ng-show=\"wizardStep2.square_land.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"md-title\">Вы приближаетесь к завершению создания объекта!</div><div class=\"pb-16\">Теперь опишите его.<br>Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"2500\" rows=\"15\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее тысячи символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"md-block\"><input type=\"text\" name=\"linktour\" ng-model=\"vm.formWizard.linktour\" ng-pattern=\"/^(?:([a-z]+):(?:([a-z]*):)?\\/\\/)?(?:([^:@]*)(?::([^:@]*))?@)?((?:[a-z0-9_-]+\\.)+[a-z]{2,}|localhost|(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}(?:(?:[01]?\\d\\d?|2[0-4]\\d|25[0-5])))(?::(\\d+))?(?:([^:\\?\\#]+))?(?:\\?([^\\#]+))?(?:\\#([^\\s]+))?$/i\" placeholder=\"Ссылка на 3D-тур\"><div ng-messages=\"wizardStep2.linktour.$error\" ng-show=\"wizardStep2.linktour.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Не похоже на ссылку</span></div></div></md-input-container></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Создать объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span></md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img ng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div class=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" ng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" ng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" ng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" md-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item class=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" ng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\"><h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div class=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4><span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" aria-label=\"Call\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon md-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></div></md-toolbar><md-content flex=\"\" layout-paddings=\"\" ms-scroll=\"\" id=\"chat-dialog\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img ng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex=\"\"><div class=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content><form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea ng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex=\"\" ng-model=\"vm.replyMessage\" placeholder=\"Type and hit enter to send message\" translate=\"\" translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\"></textarea><md-button class=\"md-fab md-icon-button\" type=\"submit\" aria-label=\"Send message\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader><md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar></ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><span style=\"font-weight:700; color:#ff0000;\">{{ifExistsReminders(\'phrase\')}}</span><md-button ng-show=\"(checkRule(20,\'all\') || checkRule(53,\'all\'))\" class=\"{{ifExistsReminders(\'color\')}} md-icon-button\" ng-click=\"vm.showReminders()\" aria-label=\"Remind to call\"><md-icon md-font-icon=\"{{ifExistsReminders(\'icon\')}}\" class=\"icon s32\" hide-xs=\"\"></md-icon></md-button><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">{{vm.username}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>{{\'TOOLBAR.PROFILE\' | translate}}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">{{\'TOOLBAR.LOGOUT\' | translate}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul class=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-horizontal-nested.html\"><div ms-navigation-horizontal-item layout=\"row\"> <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\" ng-class=\"{\'active md-accent-bg\': vm.isActive}\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </div> <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-class=\"{\'active md-accent-bg\': vm.isActive}\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren\"> <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\"><div ms-navigation-item layout=\"row\"> <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </div> <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren\"> <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/main/apps/dashboards/analytics/dashboard-analytics.html","<div id=\"dashboard-analytics\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><div class=\"text-boxed green-600-bg white-fg\">{{vm.widget1.onlineUsers}} online users</div></div><div class=\"pb-32 border-bottom\"><nvd3 class=\"h-400 remove-x-lines remove-opacity\" options=\"vm.widget1.bigChart.options\" data=\"vm.widget1.bigChart.data\"></nvd3></div><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div class=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div layout=\"column\" flex=\"\"><div class=\"h3 secondary-text pb-8\">{{vm.widget1.sessions.title}}</div><div class=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.sessions.value}}</div><div><nvd3 class=\"h-40\" options=\"vm.widget1.sessions.options\" data=\"vm.widget1.sessions.data\"></nvd3></div></div></div><div class=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div layout=\"column\" flex=\"\"><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pageviews.title}}</div><div class=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pageviews.value}}</div><div><nvd3 class=\"h-40\" options=\"vm.widget1.pageviews.options\" data=\"vm.widget1.pageviews.data\"></nvd3></div></div></div><div class=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div layout=\"column\" flex=\"\"><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pagesSessions.title}}</div><div class=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pagesSessions.value}}</div><div><nvd3 class=\"h-40\" options=\"vm.widget1.pagesSessions.options\" data=\"vm.widget1.pagesSessions.data\"></nvd3></div></div></div><div class=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div layout=\"column\" flex=\"\"><div class=\"h3 secondary-text pb-8\">{{vm.widget1.avgSessionDuration.title}}</div><div class=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.avgSessionDuration.value}}</div><div><nvd3 class=\"h-40\" options=\"vm.widget1.avgSessionDuration.options\" data=\"vm.widget1.avgSessionDuration.data\"></nvd3></div></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"65\"><ms-widget-front class=\"white-bg\"><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><ui-gmap-google-map center=\"vm.widget2.map.center\" zoom=\"vm.widget2.map.zoom\" options=\"vm.widget2.map.options\"><ui-gmap-markers models=\"vm.widget2.map.markers\" coords=\"\'coords\'\"><ui-gmap-windows show=\"show\"><div ng-non-bindable=\"\">{{sessions}}</div></ui-gmap-windows></ui-gmap-markers></ui-gmap-google-map></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"35\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget3.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget3.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div class=\"ph-16 pv-20 border-bottom\" ng-repeat=\"page in vm.widget3.pages[vm.widget3.currentRange]\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" flex=\"\"><span class=\"h4 pb-10\">{{page.path}}</span><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" value=\"{{page.value}}\"></md-progress-linear></div><div class=\"pl-32 h3 font-weight-500 secondary-text\">{{page.value}}%</div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-16 pb-8 md-accent-bg\"><div class=\"h3\">{{vm.widget4.title}}</div></div><md-tabs class=\"md-accent no-radius\" md-dynamic-height=\"\"><md-tab label=\"{{tab.label}}\" ng-repeat=\"tab in vm.widget4.tabs\"><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" ng-repeat=\"group in tab.groups\"><div class=\"h2 m-16 pb-16 border-bottom\">{{group.title}}</div><div class=\"p-16 pb-32\" ng-repeat=\"data in group.data\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between start\"><span class=\"h3\">{{data.title}}</span> <span class=\"h3 secondary-text font-weight-500\">{{data.value}}%</span></div><md-progress-linear class=\"{{data.progressColor}}\" md-mode=\"determinate\" value=\"{{data.value}}\"></md-progress-linear></div></div></div></md-tab></md-tabs></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/apps/dashboards/project/dashboard-project.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Welcome back, John!</span></div><div class=\"toolbar\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div><div layout=\"row\"><div class=\"selected-project\">{{vm.selectedProject.name}}</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button class=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin=\"\" md-menu-align-target=\"\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"project in vm.projects\"><md-button ng-click=\"vm.selectProject(project)\" aria-label=\"{{project.name}}\"><span ng-class=\"{\'secondary-text\': vm.selectedProject == project}\">{{project.name}}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content\"><md-tabs md-dynamic-height=\"\"><md-tab label=\"Home\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.widget1.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget1.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">{{vm.widget2.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget2.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{vm.widget4.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap=\"\"><div class=\"pv-8 h3\">{{vm.widget5.title}}</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" ng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" ng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\"><nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" data=\"vm.widget5.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" layout-wrap=\"\"><div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\" ng-repeat=\"(name, widget) in vm.widget5.supporting.widgets\"><div class=\"h4 secondary-text\">{{widget.data.label}}</div><div class=\"md-display-1\">{{widget.data.count[vm.widget5.currentRange]}}</div><nvd3 class=\"h-50\" config=\"vm.widget5.supporting.chart.config\" options=\"vm.widget5.supporting.chart.options\" data=\"widget.chart.data\"></nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget6.currentRange\" ng-change=\"vm.widget6.changeRange(vm.widget6.currentRange)\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div class=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" data=\"vm.widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerRight.title}}</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget7.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"event in vm.widget7.schedule[vm.widget7.currentRange]\"><div><div class=\"h3\">{{event.title}}</div><div><span class=\"secondary-text\">{{event.time}}</span> <span ng-if=\"event.location\">, {{event.location}}</span></div></div><md-button class=\"md-icon-button\" aria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Budget Summary\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget8.title}}</div><md-divider></md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget9.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget9.currentRange\" ng-change=\"vm.widget9.changeRange(vm.widget9.currentRange)\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.weeklySpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.weeklySpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex=\"\"><nvd3 class=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.weeklySpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.totalSpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.totalSpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex=\"\"><nvd3 class=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.totalSpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.remaining.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.remaining.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex=\"\"><nvd3 class=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.remaining.chartData\"></nvd3></div></div><div class=\"pv-24 mh-24 border-top\"><div class=\"h4 secondary-text\">{{vm.widget9.totalBudget.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.totalBudget.count}}</span></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"simple-table-container\" ms-responsive-table=\"\"><div class=\"table-title\">{{vm.widget10.title}}</div><table class=\"simple\"><thead><tr><th ng-repeat=\"column in vm.widget10.table.columns\">{{column.title}}</th></tr></thead><tbody><tr ng-repeat=\"row in vm.widget10.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">{{cell.value}}</span> <i ng-if=\"cell.icon\" class=\"icon {{cell.icon}}\"></i></td></tr></tbody></table></div></ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Team Members\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 mb-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">{{vm.widget11.title}}</div><div class=\"text-boxed red-bg white-fg m-0\">{{vm.widget11.table.rows.length}} members</div></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget11.dtOptions\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in ::vm.widget11.table.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ::vm.widget11.table.rows\"><td ng-repeat=\"cell in row\"><img class=\"avatar\" ng-if=\"$index === 0\" ng-src=\"assets/images/avatars/{{cell}}\"> <span ng-if=\"$index != 0\">{{cell}}</span></td></tr></tbody></table></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div class=\"widget-group\"><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin=\"\" md-menu-align-target=\"\" aria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\"><div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.month}}</span></div><div class=\"font-size-72 line-height-88 secondary-text font-weight-400\">{{vm.nowWidget.now.day}}</div><div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div><md-divider></md-divider></ms-widget-front></ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4\"><md-icon md-font-icon=\"icon-map-marker\" class=\"icon mr-8\"></md-icon>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin=\"\" md-menu-align-target=\"\" aria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\"></md-icon><span class=\"md-display-2 font-weight-300 secondary-text\">{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}}</span> <span class=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span class=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div class=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}}</span> <span class=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\"><div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\"></md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span class=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div></md-sidenav></div>");
$templateCache.put("app/main/apps/dashboards/server/dashboard-server.html","<div id=\"dashboard-server\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 class=\"h-320\" options=\"vm.widget1.chart.options\" data=\"vm.widget1.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-harddisk\"></md-icon><div class=\"h3\">{{vm.widget2.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pb-24\" layout=\"row\" layout-align=\"start center\"><div class=\"h2\">{{vm.widget2.value.used}}</div><div class=\"h2 secondary-text pl-8\">/ {{vm.widget2.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget2.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back class=\"p-16 pr-32 pink-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 blue-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-server-network\"></md-icon><div class=\"h3\">{{vm.widget3.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pb-24\" layout=\"row\" layout-align=\"start end\"><div class=\"h2\">{{vm.widget3.value.used}}</div><div class=\"h2 pl-8 secondary-text\">/ {{vm.widget3.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget3.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back class=\"p-16 pr-32 blue-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-clock-fast\"></md-icon><div class=\"h3\">{{vm.widget4.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pb-8 h1\">{{vm.widget4.value}}</div><div class=\"chart-fill-16\"><nvd3 class=\"h-50 remove-opacity remove-line-stroke\" config=\"vm.widget4.chart.config\" options=\"vm.widget4.chart.options\" data=\"vm.widget4.chart.data\"></nvd3></div></ms-widget-front><ms-widget-back class=\"p-16 pr-32 teal-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 indigo-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-scale\"></md-icon><div class=\"h3\">{{vm.widget5.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"h1 pb-8\" layout=\"row\" layout-align=\"start center\"><span>{{vm.widget5.value}}</span><md-icon md-font-icon=\"icon-trending-down\" class=\"ml-16\"></md-icon></div><div class=\"secondary-text\">{{vm.widget5.footnote}}</div></div></ms-widget-front><ms-widget-back class=\"p-16 pr-32 indigo-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget5.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 class=\"h-140 remove-x-lines remove-opacity\" config=\"vm.widget6.chart.config\" options=\"vm.widget6.chart.options\" data=\"vm.widget6.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"60\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget7.title}}</span> <span class=\"ml-16 text-boxed pink-bg white-fg\">{{vm.widget7.table.rows.length}} processes</span></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget7.dtOptions\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in ::vm.widget7.table.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ::vm.widget7.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">{{cell.value}}</span></td></tr></tbody></table></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"40\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget8.title}}</span> <span class=\"ml-16 text-boxed blue-bg white-fg\">Showing last {{vm.widget8.activities.length}} activity</span></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"ph-16 pv-15 border-bottom\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"activity in vm.widget8.activities\"><div><i class=\"icon pr-16 mr-16 border-right\" ng-class=\"{\'icon-arrow-down red-fg\':activity.type === \'Input\', \'icon-arrow-up green-fg\':activity.type === \'Output\'}\"></i></div><div class=\"h4 text-bold\" flex=\"\">{{activity.process}}</div><div class=\"h4 font-weight-500 secondary-text\">{{activity.value}}</div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/components/charts/c3/c3.html","<div id=\"c3\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div class=\"title\">C3.js</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"http://jettro.github.io/c3-angular-directive/\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div class=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"line-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"line\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"line\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Line Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"line-area-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"area\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"area\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Spline Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"spline-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"spline\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"spline\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Spline Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"spline-area-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"area-spline\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"area-spline\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Step Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"step-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"step\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"step\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Step Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"step-area-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"area-step\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"area-step\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Stacked Bar Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"stacked-bar-plot1-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"bar\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"bar\"><chart-group group-values=\"data 1,data 2\"></chart-group></chart-column></chart-column></c3chart></div><div class=\"md-title\">Scatter Plot Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"scatter-plot2-chart\"><chart-column column-id=\"Data 1 x\" column-values=\"3.2, 3.2, 3.1, 2.3, 2.8, 2.8, 3.3, 2.4, 2.9, 2.7, 2.0, 3.0, 2.2, 2.9, 2.9, 3.1, 3.0, 2.7, 2.2, 2.5, 3.2, 2.8, 2.5, 2.8, 2.9, 3.0, 2.8, 3.0, 2.9, 2.6, 2.4, 2.4, 2.7, 2.7, 3.0, 3.4, 3.1, 2.3, 3.0, 2.5, 2.6, 3.0, 2.6, 2.3, 2.7, 3.0, 2.9, 2.9, 2.5, 2.8\"><chart-column column-id=\"Data 2 x\" column-values=\"3.3, 2.7, 3.0, 2.9, 3.0, 3.0, 2.5, 2.9, 2.5, 3.6, 3.2, 2.7, 3.0, 2.5, 2.8, 3.2, 3.0, 3.8, 2.6, 2.2, 3.2, 2.8, 2.8, 2.7, 3.3, 3.2, 2.8, 3.0, 2.8, 3.0, 2.8, 3.8, 2.8, 2.8, 2.6, 3.0, 3.4, 3.1, 3.0, 3.1, 3.1, 3.1, 2.7, 3.2, 3.3, 3.0, 2.5, 3.0, 3.4, 3.0\"><chart-column column-id=\"Data 1\" column-values=\"1.4, 1.5, 1.5, 1.3, 1.5, 1.3, 1.6, 1.0, 1.3, 1.4, 1.0, 1.5, 1.0, 1.4, 1.3, 1.4, 1.5, 1.0, 1.5, 1.1, 1.8, 1.3, 1.5, 1.2, 1.3, 1.4, 1.4, 1.7, 1.5, 1.0, 1.1, 1.0, 1.2, 1.6, 1.5, 1.6, 1.5, 1.3, 1.3, 1.3, 1.2, 1.4, 1.2, 1.0, 1.3, 1.2, 1.3, 1.3, 1.1, 1.3\" column-type=\"scatter\"><chart-column column-id=\"Data 2\" column-values=\"2.5, 1.9, 2.1, 1.8, 2.2, 2.1, 1.7, 1.8, 1.8, 2.5, 2.0, 1.9, 2.1, 2.0, 2.4, 2.3, 1.8, 2.2, 2.3, 1.5, 2.3, 2.0, 2.0, 1.8, 2.1, 1.8, 1.8, 1.8, 2.1, 1.6, 1.9, 2.0, 2.2, 1.5, 1.4, 2.3, 2.4, 1.8, 1.8, 2.1, 2.4, 2.3, 1.9, 2.3, 2.5, 2.3, 1.9, 2.0, 2.3, 1.8\" column-type=\"scatter\"><chart-axes values-xs=\"Data 1:Data 1 x,Data 2:Data 2 x\"></chart-axes></chart-column></chart-column></chart-column></chart-column></c3chart></div><div class=\"md-title\">Pie Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"pie-plot1-chart\"><chart-column column-id=\"Data 1\" column-values=\"70\" column-type=\"pie\"><chart-column column-id=\"Data 2\" column-values=\"35\" column-type=\"pie\"><chart-column column-id=\"Data 3\" column-values=\"60\" column-type=\"pie\"><chart-pie expand=\"true\"></chart-pie></chart-column></chart-column></chart-column></c3chart></div><div class=\"md-title\">Donut Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"donut-plot1-chart\"><chart-column column-id=\"Data 1\" column-values=\"70\" column-type=\"donut\"><chart-column column-id=\"Data 2\" column-values=\"35\" column-type=\"donut\"><chart-column column-id=\"Data 3\" column-values=\"60\" column-type=\"donut\"><chart-donut title=\"Donut\" width=\"60\"></chart-donut></chart-column></chart-column></chart-column></c3chart></div><div class=\"md-title\">Gauge Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"gauge-plot1-chart\"><chart-column column-id=\"Data 1\" column-values=\"70\" column-type=\"gauge\"><chart-gauge min=\"50\" max=\"75\" units=\"hours\" width=\"39\"></chart-gauge></chart-column></c3chart></div></div></div>");
$templateCache.put("app/main/components/charts/chart-js/chart-js.html","<div id=\"chartJs\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div class=\"title\">Chart.js</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"https://github.com/jtblin/angular-chart.js\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div class=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"vm.lineChart.data\" chart-labels=\"vm.lineChart.labels\" chart-legend=\"true\" chart-series=\"vm.lineChart.series\"></canvas></div><div class=\"md-title\">Bar Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"vm.barChart.data\" chart-labels=\"vm.barChart.labels\"></canvas></div><div class=\"md-title\">Doughnut Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"vm.doughnutChart.data\" chart-labels=\"vm.doughnutChart.labels\"></canvas></div><div class=\"md-title\">Radar Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"radar\" class=\"chart chart-radar\" chart-data=\"vm.radarChart.data\" chart-labels=\"vm.radarChart.labels\"></canvas></div><div class=\"md-title\">Pie Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"vm.pieChart.data\" chart-labels=\"vm.pieChart.labels\"></canvas></div><div class=\"md-title\">Polar Area Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"polar-area\" class=\"chart chart-polar-area\" chart-data=\"vm.polarChart.data\" chart-labels=\"vm.polarChart.labels\"></canvas></div></div></div>");
$templateCache.put("app/main/components/charts/chartist/chartist.html","<div id=\"chartist\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div class=\"title\">Chartist</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"https://github.com/paradox41/angular-chartist.js\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div class=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.lineChart.data\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.lineChart.options\"></chartist></div><div class=\"md-title\">Line Area Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.lineAreaChart.data\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.lineAreaChart.options\"></chartist></div><div class=\"md-title\">Bi-polar Line Chart With Area Only</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.biPolarLineChart.data\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.biPolarLineChart.options\"></chartist></div><div class=\"md-title\">Bar Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.barChart.data\" chartist-chart-type=\"Bar\" chartist-chart-options=\"vm.barChart.options\" chartist-responsive-options=\"vm.barChart.responsiveOptions\"></chartist></div><div class=\"md-title\">Horizontal Bar Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.horizontalBarChart.data\" chartist-chart-type=\"Bar\" chartist-chart-options=\"vm.horizontalBarChart.options\"></chartist></div><div class=\"md-title\">Bi-polar Bar Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.biPolarBarChart.data\" chartist-chart-type=\"Bar\" chartist-chart-options=\"vm.biPolarBarChart.options\"></chartist></div><div class=\"md-title\">Stacked Bar Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.stackedBarChart.data\" chartist-chart-type=\"Bar\" chartist-chart-options=\"vm.stackedBarChart.options\" chartist-events=\"vm.stackedBarChart.events\"></chartist></div><div class=\"md-title\">Doughnut Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.donutChart.data\" chartist-chart-type=\"Pie\" chartist-chart-options=\"vm.donutChart.options\"></chartist></div><div class=\"md-title\">Pie Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.pieChart.data\" chartist-chart-type=\"Pie\" chartist-chart-options=\"vm.pieChart.options\" chartist-responsive-options=\"vm.pieChart.responsiveOptions\"></chartist></div><div class=\"md-title\">Gauge Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.gaugeChart.data\" chartist-chart-type=\"Pie\" chartist-chart-options=\"vm.gaugeChart.options\"></chartist></div></div></div>");
$templateCache.put("app/main/components/charts/nvd3/nvd3.html","<div id=\"nvd3\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div class=\"title\">nvD3</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"http://krispo.github.io/angular-nvd3/#/\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div class=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.lineChart.options\" data=\"vm.lineChart.data\" class=\"with-3d-shadow with-transitions\"></nvd3></div><div class=\"md-title\">Stacked Area Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.stackedAreaChart.options\" data=\"vm.stackedAreaChart.data\"></nvd3></div><div class=\"md-title\">Sparkline Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.sparklineChart.options\" data=\"vm.sparklineChart.data\"></nvd3></div><div class=\"md-title\">Historical Bar Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.historicalBarChart.options\" data=\"vm.historicalBarChart.data\"></nvd3></div><div class=\"md-title\">Multi Bar Horizontal Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.multiBarHorizontalChart.options\" data=\"vm.multiBarHorizontalChart.data\"></nvd3></div><div class=\"md-title\">Pie Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.pieChart.options\" data=\"vm.pieChart.data\"></nvd3></div><div class=\"md-title\">Donut Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.donutChart.options\" data=\"vm.donutChart.data\"></nvd3></div><div class=\"md-title\">Bullet Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.bulletChart.options\" data=\"vm.bulletChart.data\"></nvd3></div><div class=\"md-title\">Scatter Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.scatterChart.options\" data=\"vm.scatterChart.data\"></nvd3></div></div></div>");
$templateCache.put("app/main/components/maps/tabs/custom-marker.html","<ui-gmap-google-map center=\"vm.customMarkerMap.center\" zoom=\"vm.customMarkerMap.zoom\"><ui-gmap-marker coords=\"vm.customMarkerMap.marker.coords\" idkey=\"vm.customMarkerMap.marker.id\" options=\"vm.customMarkerMap.marker.options\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/info-window.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker coords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"><ui-gmap-window show=\"\'true\'\"><div ng-non-bindable=\"\"><div id=\"siteNotice\"></div><h1 id=\"firstHeading\" class=\"firstHeading\">Uluru</h1><div id=\"bodyContent\"><p><b>Uluru</b>, also referred to as <b>Ayers Rock</b>, is a large sandstone rock formation in the southern part of the Northern Territory, central Australia.</p><p>Attribution: Uluru, <a href=\"//en.wikipedia.org/w/index.php?title=Uluru&amp;oldid=297882194\">http://en.wikipedia.org/w/index.php?title=Uluru</a> (last visited June 22, 2009).</p></div></div></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/satellite.html","<ui-gmap-google-map center=\"vm.satelliteMap.center\" zoom=\"vm.satelliteMap.zoom\" options=\"vm.satelliteMap.options\"></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/simple-marker.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker coords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/simple.html","<ui-gmap-google-map center=\"vm.simpleMap.center\" zoom=\"vm.simpleMap.zoom\"></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/terrain.html","<ui-gmap-google-map center=\"vm.terrainMap.center\" zoom=\"vm.terrainMap.zoom\" options=\"vm.terrainMap.options\"></ui-gmap-google-map>");
$templateCache.put("app/main/components/material-docs/demo/docs-demo.tmpl.html","<div class=\"doc-demo-content doc-content\"><div flex=\"\" layout=\"column\" style=\"z-index:1\"><div class=\"doc-description\" ng-bind-html=\"demoCtrl.demoDescription.contents | toHtml\"></div><div ng-transclude=\"\"></div><section class=\"demo-container md-whiteframe-z1\" ng-class=\"{\'show-source\': demoCtrl.$showSource}\"><md-toolbar class=\"demo-toolbar md-primary\"><div class=\"md-toolbar-tools\"><h3>{{demoCtrl.demoTitle}}</h3><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"View Source\" ng-class=\"{ active: demoCtrl.$showSource }\" ng-click=\"demoCtrl.$showSource = !demoCtrl.$showSource\"><md-tooltip md-autohide=\"\">View Source</md-tooltip><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_code_24px.svg\"></md-icon></md-button></div></md-toolbar><md-tabs class=\"demo-source-tabs md-primary\" md-dynamic-height=\"\" ng-show=\"demoCtrl.$showSource\"><md-tab ng-repeat=\"file in demoCtrl.orderedFiles\" label=\"{{file.name}}\"><md-content md-scroll-y=\"\" class=\"demo-source-container\"><hljs class=\"no-header\" code=\"file.contentsPromise\" lang=\"{{file.fileType}}\" should-interpolate=\"demoCtrl.interpolateCode\"></hljs></md-content></md-tab></md-tabs><demo-include files=\"demoCtrl.files\" module=\"demoCtrl.demoModule\" class=\"{{demoCtrl.demoId}}\"></demo-include></section></div></div>");
$templateCache.put("app/main/components/tables/datatable/datatable.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div class=\"title\">Datatable</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"https://l-lin.github.io/angular-datatables\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div class=\"md-title\">Zero Configuration</div><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Position</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Office</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Age</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Salary</span></div></th></tr></thead><tbody><tr ng-repeat=\"employee in ::vm.employees\"><td>{{ employee.name }}</td><td>{{ employee.position }}</td><td>{{ employee.office }}</td><td>{{ employee.age }}</td><td>{{ employee.startDate }}</td><td>{{ employee.salary }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/components/tables/simple-table/simple-table.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div class=\"title\">Simple Table</div></div></div><div class=\"content\">Tables are used to present raw data sets, and usually appear in desktop enterprise products.<p>Data sets may include:</p><ul><li>Three or more columns of data</li><li>A corresponding visualization</li><li>The ability for users to query and manipulate data at scale</li></ul><div class=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\">Employees</div><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th>Name</th><th>Position</th><th>Office</th><th class=\"text-right\">Age</th><th class=\"text-right\">Start Date</th><th class=\"text-right\">Salary</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-repeat=\"person in vm.employees\"><td class=\"name\">{{person.name}}</td><td class=\"position\">{{person.position}}</td><td class=\"office\">{{person.office}}</td><td class=\"age text-right\">{{person.age}}</td><td class=\"start-date text-right\">{{person.startDate}}</td><td class=\"salary text-right\">{{person.salary | currency}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password</div><form name=\"forgotPasswordForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate=\"\" translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"forgotPasswordForm.email.$error\" ng-show=\"forgotPasswordForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"lock-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" layout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img class=\"avatar big\" src=\"assets/images/avatars/katherine.jpg\"><md-icon md-font-icon=\"icon-lock\" class=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex=\"\" layout=\"column\" layout-align=\"start\" layout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\">Your session is locked</div><div class=\"subtitle\" translate=\"LOCK.SUBTITLE\">Due to inactivity, your session is locked. Enter your password to continue.</div></div></div><form name=\"lockForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input ng-model=\"vm.form.username\" placeholder=\"Username\" translate=\"\" translate-attr-placeholder=\"LOCK.USERNAME\" disabled=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"LOCK.PASSWORD\" required=\"\"><div ng-messages=\"lockForm.password.$error\" ng-show=\"lockForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"LOCK.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"UNLOCK\" ng-disabled=\"lockForm.$invalid || lockForm.$pristine\" translate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\">UNLOCK</md-button></form><div class=\"message\"><a ui-sref=\"app.pages_auth_login\" class=\"md-accent-color\"><span translate=\"LOCK.ARE_YOU_NOT\">Are you not</span><span>Jane Doe?</span></a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"loginForm.email.$error\" ng-show=\"loginForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"LOGIN.PASSWORD\" required=\"\"><div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"separator\"><span class=\"text\" translate=\"LOGIN.OR\">OR</span></div><md-button class=\"md-raised google\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span translate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><md-button class=\"md-raised facebook\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span translate=\"LOGIN.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button><div class=\"register\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">Don\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register\" translate=\"LOGIN.CREATE_ACCOUNT\">Create an account</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login-v2/login-v2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex=\"\" hide=\"\" show-gt-sm=\"\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"LOGIN_V2.INTRO_TITLE\">Welcome to the FUSE!</div><div class=\"description\" translate=\"LOGIN_V2.INTRO_DESCRIPTION\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.</div></div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll=\"\"><div id=\"login-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm=\"\"><span>F</span></div><div class=\"title\" translate=\"LOGIN_V2.TITLE\">Log in to your account</div><div class=\"description\" translate=\"LOGIN_V2.DESCRIPTION\">Sed mollis velit facilisis facilisis viverra</div><form name=\"loginForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"LOGIN_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"loginForm.email.$error\" ng-show=\"loginForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"LOGIN_V2.PASSWORD\" required=\"\"><div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN_V2.REMEMBER_ME\">Remember Me</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" translate=\"LOGIN_V2.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN_V2.LOG_IN\" translate-attr-aria-label=\"LOGIN_V2.LOG_IN\">LOG IN</md-button></form><div class=\"separator\"><span class=\"text\" translate=\"LOGIN_V2.OR\">OR</span></div><div layout=\"column\" layout-align=\"start center\"><md-button class=\"md-raised google\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span translate=\"LOGIN_V2.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><md-button class=\"md-raised facebook\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span translate=\"LOGIN_V2.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button></div><div class=\"register\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN_V2.DONT_HAVE_ACCOUNT\">Don\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register-v2\" translate=\"LOGIN_V2.CREATE_ACCOUNT\">Create an account</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"register-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account</div><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" translate=\"\" translate-attr-placeholder=\"REGISTER.NAME\" required=\"\"><div ng-messages=\"registerForm.username.$error\" ng-show=\"registerForm.username.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"REGISTER.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"registerForm.email.$error\" ng-show=\"registerForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"REGISTER.PASSWORD\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate=\"\" translate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required=\"\"></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER.READ_ACCEPT\">I read and accept</span> <a href=\"#\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\">terms and conditions</a></div></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"CREATE MY ACCOUNT\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"REGISTER.LOGIN\">Log in</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/register-v2/register-v2.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" flex=\"\" hide=\"\" show-gt-sm=\"\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"REGISTER_V2.INTRO_TITLE\">Welcome to the FUSE!</div><div class=\"description\" translate=\"REGISTER_V2.INTRO_DESCRIPTION\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div id=\"register-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm=\"\"><span>F</span></div><div class=\"title\" translate=\"REGISTER_V2.TITLE\">Create an account</div><div class=\"description\" translate=\"REGISTER_V2.DESCRIPTION\">Sed mollis velit facilisis facilisis viverra</div><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.NAME\" required=\"\"><div ng-messages=\"registerForm.username.$error\" ng-show=\"registerForm.username.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"registerForm.email.$error\" ng-show=\"registerForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.PASSWORD\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required=\"\"></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER_V2.READ_ACCEPT\">I read and accept</span> <a href=\"#\" class=\"md-accent-color\" translate=\"REGISTER_V2.TERMS_COND\">terms and conditions</a></div></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"CREATE MY ACCOUNT\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login-v2\" translate=\"REGISTER_V2.LOGIN\">Log in</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"reset-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password</div><form name=\"resetPasswordForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate=\"\" translate-attr-placeholder=\"RESETPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"resetPasswordForm.email.$error\" ng-show=\"resetPasswordForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"RESETPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"RESETPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate=\"\" translate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required=\"\"><div ng-messages=\"resetPasswordForm.passwordConfirm.$error\" ng-show=\"resetPasswordForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" translate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" translate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div class=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate=\"\" translate-attr-placeholder=\"ERROR404.SEARCH\" flex=\"\"></div><a class=\"back-link md-accent-color\" href=\"/\" translate=\"ERROR404.GO_BACK\">Go back to dashboard</a></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" translate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" translate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/ui/page-layouts/blank/blank.html","<div class=\"page-layout blank\" layout=\"row\"><h2>Blank page</h2></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-content.html","<div class=\"demo-content\"><img src=\"assets/images/etc/early-sunrise.jpg\" class=\"md-card-image\" alt=\"sunrise\"><h1>Early Sunrise</h1><h4 class=\"secondary-text\">Demo Content</h4><p>One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections.</p><blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What\'s happened to me? \" he thought. It wasn\'t a dream.</p><footer>John Doe</footer></blockquote><p>His room, a proper human room although a little too small, lay peacefully between its four familiar walls. A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame.</p><p>It showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window at the dull weather. Drops of rain could be heard hitting the pane, which made him feel quite sad.</p><p>\"How about if I sleep a little bit longer and forget all this nonsense\", he thought, but that was something he was unable to do because he was used to sleeping on his right, and in his present state couldn\'t get into that position. However hard he threw himself onto his right, he always rolled back to where he was.</p><p>He must have tried it a hundred times, shut his eyes so that he wouldn\'t have to look at the floundering legs, and only stopped when he began to feel a mild, dull pain there that he had never felt before. \"Oh, God\", he thought, \"what a strenuous career it is that I\'ve chosen!</p><p>Travelling day in and day out. Doing business like this takes much more effort than doing your own business at home, and on top of that there\'s the curse of travelling, worries about making train connections, bad and irregular food, contact with different people all the time so that you can never get to know anyone or become friendly with them.</p><p>\"He felt a slight itch up on his belly; pushed himself slowly up on his back towards the headboard so that he could lift his head better; found where the itch was, and saw that it was covered with lots of little white spots which he didn\'t know what to make of; and when he tried to feel the place with one of his legs he drew it quickly back because as soon as he touched it he was overcome by a cold shudder. He slid back into his former position.</p><p>\"Getting up early all the time\", he thought, \"it makes you stupid. You\'ve got to get enough sleep. Other travelling salesmen live a life of luxury. For instance, whenever I go back to the guest house during the morning to copy out the contract, these gentlemen are always still sitting there eating their breakfasts. I ought to just try that with my boss; I\'d get kicked out on the spot. But who knows, maybe that would be the best thing for me...</p></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-sidenav.html","<div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">Sidenav Demo</md-subheader><md-list-item><p>Sidenav Item 1</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 2</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 3</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 4</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 5</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 6</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 7</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 8</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 9</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 10</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 11</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 12</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 13</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 14</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 15</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 16</p></md-list-item></md-list></div>");
$templateCache.put("app/modules/ownerbase/028 elements/elements/index.html","<!DOCTYPE html><html lang=\"ru\"><head><meta charset=\"utf-8\"><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><title>JavaScript</title><link rel=\"stylesheet\" href=\"css/style.css\"></head><body><div class=\"box\" id=\"box\"></div><button>1</button> <button>2</button> <button>3</button> <button>4</button> <button>5</button><div class=\"circle\"></div><div class=\"circle\"></div><div class=\"circle\"></div><div class=\"wrapper\"><div class=\"heart\"></div><div class=\"heart\"></div><div class=\"heart\"></div></div><script src=\"js/script.js\"></script></body></html>");
$templateCache.put("app/objects/editobject/editflat/versions/editflat (ajax).html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Новый объект</span></div><div class=\"title\">Квартира</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион</label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\" required=\"\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район</label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select><div ng-messages=\"vm.wizardStep1.district.$error\" ng-show=\"vm.wizardStep1.district.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта</label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта</label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.loadStreets()\" required=\"\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option><div ng-messages=\"vm.wizardStep1.city.$error\" ng-show=\"vm.wizardStep1.city.$touched\" role=\"alert\"><div ng-message=\"required\"><span></span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица</label><md-select ng-model=\"vm.formWizard.street\" ng-required=\"vm.formWizard.region==1 || vm.formWizard.city_type==\'г\'\"><md-option ng-repeat=\"street in vm.streets\" value=\"{{street.name}}\">{{street.name}}</md-option><div ng-messages=\"vm.wizardStep1.street.$error\" ng-show=\"vm.wizardStep1.street.$touched\" role=\"alert\"><div ng-message=\"itsrequired\"><span>Улица обязательно должна быть указана</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\" required=\"\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 2\"><label>Направление электричек</label><md-select ng-model=\"vm.formWizard.direction\" ng-required=\"vm.formWizard.region==2\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option><div ng-messages=\"vm.wizardStep1.direction.$error\" ng-show=\"vm.wizardStep1.direction.$touched\" role=\"alert\"><div ng-message=\"required\"><span>*</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основное метро</label><md-select ng-model=\"vm.formWizard.metro_1\" ng-required=\"vm.formWizard.region==1\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option><div ng-messages=\"vm.wizardStep1.metro_1.$error\" ng-show=\"vm.wizardStep1.metro_1.$touched\" role=\"alert\"><div ng-message=\"required\"><span>*</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_1_time\" ng-required=\"vm.formWizard.metro_1\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_1 && vm.formWizard.metro_1_time\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительное метро</label><md-select ng-model=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_2_time\" ng-required=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Дополнительное метро</label><md-select ng-model=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_3_time\" ng-required=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки</label><md-select ng-model=\"vm.formWizard.deal_type\" ng-change=\"vm.changeFlatStatuses()\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Источник</label><md-select ng-model=\"vm.formWizard.source_id\" required=\"\"><md-option ng-repeat=\"source in vm.sources\" value=\"{{source.id}}\">{{source.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости</label><md-select ng-model=\"vm.formWizard.object_type\" ng-change=\"vm.changeRoomTypes()\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.formWizard.object_type == \'part\'\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"part_percent\" ng-model=\"vm.formWizard.part_percent\" placeholder=\"Процент доли\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" ng-required=\"vm.formWizard.object_type == \'part\'\"><div ng-messages=\"wizardStep1.part_percent.$error\" ng-show=\"wizardStep1.part_percent.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Срок аренды</label><md-select ng-model=\"vm.formWizard.rent_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"rent_duration in vm.rent_durations\" value=\"{{rent_duration.name}}\">{{rent_duration.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Период оплаты</label><md-select ng-model=\"vm.formWizard.pay_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"pay_duration in vm.pay_durations\" value=\"{{pay_duration.name}}\">{{pay_duration.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственник (*)</label><md-select ng-model=\"vm.formWizard.owner_id\" required=\"\"><md-option ng-repeat=\"client in vm.my_clients\" value=\"{{client.id}}\">{{client.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.deal_type != \'rent\'\"><input type=\"text\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Цена\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type != \'rent\'\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commission\" ng-model=\"vm.formWizard.commission\" placeholder=\"Комиссия\" ng-pattern=\"/[0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.commission.$error\" ng-show=\"wizardStep1.commission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите комиссию правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комиссии</label><md-select ng-model=\"vm.formWizard.commission_type\"><md-option ng-repeat=\"commission_type in vm.commission_types\" value=\"{{commission_type.name}}\">{{commission_type.rusname}}</md-option></md-select></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Число комнат <strong>*</strong></label><md-select ng-model=\"vm.formWizard.rooms_number\" required=\"\"><md-option ng-repeat=\"rooms_type in vm.rooms_type_list\" value=\"{{rooms_type.name}}\">{{rooms_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story\" ng-model=\"vm.formWizard.story\" placeholder=\"Этаж <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"{{vm.formWizard.story_count}}\" required=\"\"><div ng-messages=\"wizardStep2.story.$error\" ng-show=\"wizardStep2.story.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этаж - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этаж правильно</span></div><div ng-message=\"min\"><span>Введите этаж правильно</span></div><div ng-message=\"max\"><span>Этаж не должен быть больше числа этажей</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Этажность <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"30\" required=\"\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этажность - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Холодильник</label><md-select ng-model=\"vm.formWizard.tech_4\"><md-option ng-repeat=\"tech_4 in vm.yes_no_array\" value=\"{{tech_4.name}}\">{{tech_4.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Стиральная машина</label><md-select ng-model=\"vm.formWizard.tech_8\"><md-option ng-repeat=\"tech_8 in vm.yes_no_array\" value=\"{{tech_8.name}}\">{{tech_8.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Мебель</label><md-select ng-model=\"vm.formWizard.furniture\"><md-option ng-repeat=\"furniture in vm.furniture_types\" value=\"{{furniture.name}}\">{{furniture.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\" required=\"\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Статус <strong>*</strong></label><md-select ng-model=\"vm.formWizard.flat_status\" required=\"\"><md-option ng-repeat=\"flat_status in vm.flat_status_types\" value=\"{{flat_status.name}}\">{{flat_status.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>В собственности</label><md-select ng-model=\"vm.formWizard.years_own\"><md-option ng-repeat=\"years_own in vm.years_own_types\" value=\"{{years_own.name}}\">{{years_own.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Лифт</label><md-select ng-model=\"vm.formWizard.lift\"><md-option ng-repeat=\"lift in vm.lift_types\" value=\"{{lift.name}}\">{{lift.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Балкон</label><md-select ng-model=\"vm.formWizard.balcony\"><md-option ng-repeat=\"balcony in vm.balcony_types\" value=\"{{balcony.name}}\">{{balcony.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Право собственности</label><md-select ng-model=\"vm.formWizard.ownership\"><md-option ng-repeat=\"ownership in vm.ownership_types\" value=\"{{ownership.name}}\">{{ownership.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип дома<strong>*</strong></label><md-select ng-model=\"vm.formWizard.type_bild\" required=\"\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип санузла</label><md-select ng-model=\"vm.formWizard.type_bathroom\"><md-option ng-repeat=\"type_bathroom in vm.types_bathroom\" value=\"{{type_bathroom.name}}\">{{type_bathroom.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"count_bathroom_flat\" ng-model=\"vm.formWizard.count_bathroom_flat\" placeholder=\"Количество сан.узлов\" ng-pattern=\"/^[0-9]{1,2}$/\"><div ng-messages=\"wizardStep2.count_bathroom_flat.$error\" ng-show=\"wizardStep2.count_bathroom_flat.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Интернет</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.yes_no_array\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телефон</label><md-select ng-model=\"vm.formWizard.phone\"><md-option ng-repeat=\"phone_type in vm.phone_types\" value=\"{{phone_type.name}}\">{{phone_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телевизор</label><md-select ng-model=\"vm.formWizard.tv\"><md-option ng-repeat=\"tv in vm.yes_no_array\" value=\"{{tv.name}}\">{{tv.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Общая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_all\" ng-model=\"vm.formWizard.square_all\" placeholder=\"Общая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_all.$error\" ng-show=\"wizardStep2.square_all.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Жилая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_living\" ng-model=\"vm.formWizard.square_living\" placeholder=\"Жилая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxLiving=vm.formWizard.square_all-vm.formWizard.square_kitchen}}\" min=\"0\" max=\"{{vm.maxLiving}}\"><div ng-messages=\"wizardStep2.square_living.$error\" ng-show=\"wizardStep2.square_living.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь кухни, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_kitchen\" ng-model=\"vm.formWizard.square_kitchen\" placeholder=\"Площадь кухни\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxKitchen=vm.formWizard.square_all-vm.formWizard.square_living}}\" min=\"0\" max=\"{{vm.maxKitchen}}\"><div ng-messages=\"wizardStep2.square_kitchen.$error\" ng-show=\"wizardStep2.square_kitchen.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площади комнат через + <strong>*</strong></label> <input name=\"square_rooms\" ng-model=\"vm.formWizard.square_rooms\" placeholder=\"Площади комнат через разделитель\" required=\"\" ng-pattern=\"/^((\\d+(.\\d{1,2})?\\+?)*\\d{1}(.\\d{1,2})?)$/\"><div ng-messages=\"wizardStep2.square_rooms.$error\" ng-show=\"wizardStep2.square_rooms.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь комнат должна быть указана</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"300\" rows=\"5\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 300 символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">4</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Фотографии</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"pb-16\">Фотографии добавляются независимо от других данных объекта. Если Вы просто добавили фотографии, то можете просто выйти из редактирования объекта. При следующем посещении этой страницы они уже будут в таблице.<br>Выбрать файлы для загрузки можно ниже.<br>Позже будет реализована</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstanceCallback\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Фотография</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Размер</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"photo in ::vm.photos\"><td><img ng-src=\"{{photo.filename}}\" style=\"width: 400px; height: {{photo.height*400/photo.width}}px\"></td><td>{{ photo.width }}x{{ photo.height }}px / {{ photo.size/1024/1024|number:2 }} Мб</td><td><md-button alt=\"Установить эту фотографию главной\" class=\"md-raised md-accent\" ng-click=\"vm.setMainPhoto(photo.id);\" aria-label=\"Set this as main photo\" ng-show=\"photo.id!=vm.mainImage\"><md-icon md-font-icon=\"icon-flag-variant\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.removePhoto(photo.id);\" aria-label=\"Remove this\" ng-show=\"photo.id!=vm.mainImage\"><md-icon md-font-icon=\"icon-content-cut\" class=\"s16\"></md-icon></md-button><span ng-show=\"photo.id==vm.mainImage\">Главная фотография выводится<br>как миниатюра на рекламных порталах.<br>Вы не можете ее удалить</span></td></tr></tbody></table><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Не загружайте фотографии с водяными знаками, номерами телефонов и прочей посторонней информацией.<br>Если Вы хотите использовать чужие фотографии, то предварительно отредактируйте их (например, измените размер)<br>Если не следовать этим правилам, то объект вполне может оказаться заблокированным на некоторых порталах</div></div><md-input-container class=\"md-block\"><div class=\"row\"><div class=\"col-md-3\"><h3><md-icon md-font-icon=\"icon-paperclip\" class=\"s16\"></md-icon>Выберите файлы</h3><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" aria-label=\"Photos\"><br></div><div class=\"col-md-9\" style=\"margin-bottom: 40px\"><h3>Выбрано файлов для загрузки: {{ uploader.queue.length }}</h3><br><br><table class=\"table\" ng-show=\"uploader.queue.length\"><thead><tr><th width=\"50%\">Имя</th><th ng-show=\"uploader.isHTML5\">Размер</th><th>Действия</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} Мб</td><td nowrap=\"\"><md-button class=\"md-raised md-accent\" ng-click=\"item.upload();vm.successLoadPhotosMessage();\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" aria-label=\"Download this\"><md-icon md-font-icon=\"icon-box-download\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"item.remove();\" aria-label=\"Remove this\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><br><br><div ng-show=\"uploader.queue.length\"><md-button class=\"md-raised md-accent\" ng-click=\"uploader.uploadAll();vm.successLoadPhotosMessage();\" ng-disabled=\"!uploader.getNotUploadedItems().length\" aria-label=\"Download all\">Загрузить все</md-button><md-button class=\"md-raised md-warn\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\" aria-label=\"Clear download list\">Очистить все</md-button></div></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Изменить объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/objects/editobject/editflat/versions/editflat (original).html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Новый объект</span></div><div class=\"title\">Квартира</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион</label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\" required=\"\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район</label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select><div ng-messages=\"vm.wizardStep1.district.$error\" ng-show=\"vm.wizardStep1.district.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта</label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта</label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.loadStreets()\" required=\"\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option><div ng-messages=\"vm.wizardStep1.city.$error\" ng-show=\"vm.wizardStep1.city.$touched\" role=\"alert\"><div ng-message=\"required\"><span></span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица</label><md-select ng-model=\"vm.formWizard.street\" ng-required=\"vm.formWizard.region==1 || vm.formWizard.city_type==\'г\'\"><md-option ng-repeat=\"street in vm.streets\" value=\"{{street.name}}\">{{street.name}}</md-option><div ng-messages=\"vm.wizardStep1.street.$error\" ng-show=\"vm.wizardStep1.street.$touched\" role=\"alert\"><div ng-message=\"itsrequired\"><span>Улица обязательно должна быть указана</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\" required=\"\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 2\"><label>Направление электричек</label><md-select ng-model=\"vm.formWizard.direction\" ng-required=\"vm.formWizard.region==2\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option><div ng-messages=\"vm.wizardStep1.direction.$error\" ng-show=\"vm.wizardStep1.direction.$touched\" role=\"alert\"><div ng-message=\"required\"><span>*</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основное метро</label><md-select ng-model=\"vm.formWizard.metro_1\" ng-required=\"vm.formWizard.region==1\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option><div ng-messages=\"vm.wizardStep1.metro_1.$error\" ng-show=\"vm.wizardStep1.metro_1.$touched\" role=\"alert\"><div ng-message=\"required\"><span>*</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_1_time\" ng-required=\"vm.formWizard.metro_1\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_1 && vm.formWizard.metro_1_time\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительное метро</label><md-select ng-model=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_2_time\" ng-required=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Дополнительное метро</label><md-select ng-model=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_3_time\" ng-required=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки</label><md-select ng-model=\"vm.formWizard.deal_type\" ng-change=\"vm.changeFlatStatuses()\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Источник</label><md-select ng-model=\"vm.formWizard.source_id\" required=\"\"><md-option ng-repeat=\"source in vm.sources\" value=\"{{source.id}}\">{{source.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости</label><md-select ng-model=\"vm.formWizard.object_type\" ng-change=\"vm.changeRoomTypes()\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.formWizard.object_type == \'part\'\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"part_percent\" ng-model=\"vm.formWizard.part_percent\" placeholder=\"Процент доли\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" ng-required=\"vm.formWizard.object_type == \'part\'\"><div ng-messages=\"wizardStep1.part_percent.$error\" ng-show=\"wizardStep1.part_percent.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Срок аренды</label><md-select ng-model=\"vm.formWizard.rent_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"rent_duration in vm.rent_durations\" value=\"{{rent_duration.name}}\">{{rent_duration.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Период оплаты</label><md-select ng-model=\"vm.formWizard.pay_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"pay_duration in vm.pay_durations\" value=\"{{pay_duration.name}}\">{{pay_duration.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственник (*)</label><md-select ng-model=\"vm.formWizard.owner_id\" required=\"\"><md-option ng-repeat=\"client in vm.my_clients\" value=\"{{client.id}}\">{{client.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.deal_type != \'rent\'\"><input type=\"text\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Цена\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type != \'rent\'\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commission\" ng-model=\"vm.formWizard.commission\" placeholder=\"Комиссия\" ng-pattern=\"/[0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.commission.$error\" ng-show=\"wizardStep1.commission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите комиссию правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комиссии</label><md-select ng-model=\"vm.formWizard.commission_type\"><md-option ng-repeat=\"commission_type in vm.commission_types\" value=\"{{commission_type.name}}\">{{commission_type.rusname}}</md-option></md-select></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Число комнат <strong>*</strong></label><md-select ng-model=\"vm.formWizard.rooms_number\" required=\"\"><md-option ng-repeat=\"rooms_type in vm.rooms_type_list\" value=\"{{rooms_type.name}}\">{{rooms_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story\" ng-model=\"vm.formWizard.story\" placeholder=\"Этаж <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"{{vm.formWizard.story_count}}\" required=\"\"><div ng-messages=\"wizardStep2.story.$error\" ng-show=\"wizardStep2.story.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этаж - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этаж правильно</span></div><div ng-message=\"min\"><span>Введите этаж правильно</span></div><div ng-message=\"max\"><span>Этаж не должен быть больше числа этажей</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Этажность <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"30\" required=\"\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этажность - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Холодильник</label><md-select ng-model=\"vm.formWizard.tech_4\"><md-option ng-repeat=\"tech_4 in vm.yes_no_array\" value=\"{{tech_4.name}}\">{{tech_4.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Стиральная машина</label><md-select ng-model=\"vm.formWizard.tech_8\"><md-option ng-repeat=\"tech_8 in vm.yes_no_array\" value=\"{{tech_8.name}}\">{{tech_8.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Мебель</label><md-select ng-model=\"vm.formWizard.furniture\"><md-option ng-repeat=\"furniture in vm.furniture_types\" value=\"{{furniture.name}}\">{{furniture.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\" required=\"\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Статус <strong>*</strong></label><md-select ng-model=\"vm.formWizard.flat_status\" required=\"\"><md-option ng-repeat=\"flat_status in vm.flat_status_types\" value=\"{{flat_status.name}}\">{{flat_status.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>В собственности</label><md-select ng-model=\"vm.formWizard.years_own\"><md-option ng-repeat=\"years_own in vm.years_own_types\" value=\"{{years_own.name}}\">{{years_own.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Лифт</label><md-select ng-model=\"vm.formWizard.lift\"><md-option ng-repeat=\"lift in vm.lift_types\" value=\"{{lift.name}}\">{{lift.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Балкон</label><md-select ng-model=\"vm.formWizard.balcony\"><md-option ng-repeat=\"balcony in vm.balcony_types\" value=\"{{balcony.name}}\">{{balcony.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Право собственности</label><md-select ng-model=\"vm.formWizard.ownership\"><md-option ng-repeat=\"ownership in vm.ownership_types\" value=\"{{ownership.name}}\">{{ownership.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип дома<strong>*</strong></label><md-select ng-model=\"vm.formWizard.type_bild\" required=\"\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип санузла</label><md-select ng-model=\"vm.formWizard.type_bathroom\"><md-option ng-repeat=\"type_bathroom in vm.types_bathroom\" value=\"{{type_bathroom.name}}\">{{type_bathroom.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"count_bathroom_flat\" ng-model=\"vm.formWizard.count_bathroom_flat\" placeholder=\"Количество сан.узлов\" ng-pattern=\"/^[0-9]{1,2}$/\"><div ng-messages=\"wizardStep2.count_bathroom_flat.$error\" ng-show=\"wizardStep2.count_bathroom_flat.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Интернет</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.yes_no_array\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телефон</label><md-select ng-model=\"vm.formWizard.phone\"><md-option ng-repeat=\"phone_type in vm.phone_types\" value=\"{{phone_type.name}}\">{{phone_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телевизор</label><md-select ng-model=\"vm.formWizard.tv\"><md-option ng-repeat=\"tv in vm.yes_no_array\" value=\"{{tv.name}}\">{{tv.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Общая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_all\" ng-model=\"vm.formWizard.square_all\" placeholder=\"Общая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_all.$error\" ng-show=\"wizardStep2.square_all.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Жилая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_living\" ng-model=\"vm.formWizard.square_living\" placeholder=\"Жилая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxLiving=vm.formWizard.square_all-vm.formWizard.square_kitchen}}\" min=\"0\" max=\"{{vm.maxLiving}}\"><div ng-messages=\"wizardStep2.square_living.$error\" ng-show=\"wizardStep2.square_living.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь кухни, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_kitchen\" ng-model=\"vm.formWizard.square_kitchen\" placeholder=\"Площадь кухни\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxKitchen=vm.formWizard.square_all-vm.formWizard.square_living}}\" min=\"0\" max=\"{{vm.maxKitchen}}\"><div ng-messages=\"wizardStep2.square_kitchen.$error\" ng-show=\"wizardStep2.square_kitchen.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площади комнат через + <strong>*</strong></label> <input name=\"square_rooms\" ng-model=\"vm.formWizard.square_rooms\" placeholder=\"Площади комнат через разделитель\" required=\"\" ng-pattern=\"/^((\\d+(.\\d{1,2})?\\+?)*\\d{1}(.\\d{1,2})?)$/\"><div ng-messages=\"wizardStep2.square_rooms.$error\" ng-show=\"wizardStep2.square_rooms.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь комнат должна быть указана</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"300\" rows=\"5\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 300 символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">4</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Фотографии</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"pb-16\">Фотографии добавляются независимо от других данных объекта. Если Вы просто добавили фотографии, то можете просто выйти из редактирования объекта. При следующем посещении этой страницы они уже будут в таблице.<br>Выбрать файлы для загрузки можно ниже.<br>Позже будет реализована</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Фотография</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Размер</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"photo in ::vm.photos\"><td><img ng-src=\"{{photo.filename}}\" style=\"width: 400px; height: {{photo.height*400/photo.width}}px\"></td><td>{{ photo.width }}x{{ photo.height }}px / {{ photo.size/1024/1024|number:2 }} Мб</td><td><md-button alt=\"Установить эту фотографию главной\" class=\"md-raised md-accent\" ng-click=\"vm.setMainPhoto(photo.id);\" aria-label=\"Set this as main photo\" ng-show=\"photo.id!=vm.mainImage\"><md-icon md-font-icon=\"icon-flag-variant\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.removePhoto(photo.id);\" aria-label=\"Remove this\" ng-show=\"photo.id!=vm.mainImage\"><md-icon md-font-icon=\"icon-content-cut\" class=\"s16\"></md-icon></md-button><span ng-show=\"photo.id==vm.mainImage\">Главная фотография выводится<br>как миниатюра на рекламных порталах.<br>Вы не можете ее удалить</span></td></tr></tbody></table><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Не загружайте фотографии с водяными знаками, номерами телефонов и прочей посторонней информацией.<br>Если Вы хотите использовать чужие фотографии, то предварительно отредактируйте их (например, измените размер)<br>Если не следовать этим правилам, то объект вполне может оказаться заблокированным на некоторых порталах</div></div><md-input-container class=\"md-block\"><div class=\"row\"><div class=\"col-md-3\"><h3><md-icon md-font-icon=\"icon-paperclip\" class=\"s16\"></md-icon>Выберите файлы</h3><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" aria-label=\"Photos\"><br></div><div class=\"col-md-9\" style=\"margin-bottom: 40px\"><h3>Выбрано файлов для загрузки: {{ uploader.queue.length }}</h3><br><br><table class=\"table\" ng-show=\"uploader.queue.length\"><thead><tr><th width=\"50%\">Имя</th><th ng-show=\"uploader.isHTML5\">Размер</th><th>Действия</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} Мб</td><td nowrap=\"\"><md-button class=\"md-raised md-accent\" ng-click=\"item.upload();vm.successLoadPhotosMessage();\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" aria-label=\"Download this\"><md-icon md-font-icon=\"icon-box-download\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"item.remove();\" aria-label=\"Remove this\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><br><br><div ng-show=\"uploader.queue.length\"><md-button class=\"md-raised md-accent\" ng-click=\"uploader.uploadAll();vm.successLoadPhotosMessage();\" ng-disabled=\"!uploader.getNotUploadedItems().length\" aria-label=\"Download all\">Загрузить все</md-button><md-button class=\"md-raised md-warn\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\" aria-label=\"Clear download list\">Очистить все</md-button></div></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Изменить объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/objects/editobject/editflatrent/versions/editflat (ajax).html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Новый объект</span></div><div class=\"title\">Квартира</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион</label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\" required=\"\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район</label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select><div ng-messages=\"vm.wizardStep1.district.$error\" ng-show=\"vm.wizardStep1.district.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта</label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта</label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.loadStreets()\" required=\"\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option><div ng-messages=\"vm.wizardStep1.city.$error\" ng-show=\"vm.wizardStep1.city.$touched\" role=\"alert\"><div ng-message=\"required\"><span></span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица</label><md-select ng-model=\"vm.formWizard.street\" ng-required=\"vm.formWizard.region==1 || vm.formWizard.city_type==\'г\'\"><md-option ng-repeat=\"street in vm.streets\" value=\"{{street.name}}\">{{street.name}}</md-option><div ng-messages=\"vm.wizardStep1.street.$error\" ng-show=\"vm.wizardStep1.street.$touched\" role=\"alert\"><div ng-message=\"itsrequired\"><span>Улица обязательно должна быть указана</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\" required=\"\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 2\"><label>Направление электричек</label><md-select ng-model=\"vm.formWizard.direction\" ng-required=\"vm.formWizard.region==2\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option><div ng-messages=\"vm.wizardStep1.direction.$error\" ng-show=\"vm.wizardStep1.direction.$touched\" role=\"alert\"><div ng-message=\"required\"><span>*</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основное метро</label><md-select ng-model=\"vm.formWizard.metro_1\" ng-required=\"vm.formWizard.region==1\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option><div ng-messages=\"vm.wizardStep1.metro_1.$error\" ng-show=\"vm.wizardStep1.metro_1.$touched\" role=\"alert\"><div ng-message=\"required\"><span>*</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_1_time\" ng-required=\"vm.formWizard.metro_1\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_1 && vm.formWizard.metro_1_time\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительное метро</label><md-select ng-model=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_2_time\" ng-required=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Дополнительное метро</label><md-select ng-model=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_3_time\" ng-required=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки</label><md-select ng-model=\"vm.formWizard.deal_type\" ng-change=\"vm.changeFlatStatuses()\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Источник</label><md-select ng-model=\"vm.formWizard.source_id\" required=\"\"><md-option ng-repeat=\"source in vm.sources\" value=\"{{source.id}}\">{{source.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости</label><md-select ng-model=\"vm.formWizard.object_type\" ng-change=\"vm.changeRoomTypes()\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.formWizard.object_type == \'part\'\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"part_percent\" ng-model=\"vm.formWizard.part_percent\" placeholder=\"Процент доли\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" ng-required=\"vm.formWizard.object_type == \'part\'\"><div ng-messages=\"wizardStep1.part_percent.$error\" ng-show=\"wizardStep1.part_percent.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Срок аренды</label><md-select ng-model=\"vm.formWizard.rent_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"rent_duration in vm.rent_durations\" value=\"{{rent_duration.name}}\">{{rent_duration.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Период оплаты</label><md-select ng-model=\"vm.formWizard.pay_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"pay_duration in vm.pay_durations\" value=\"{{pay_duration.name}}\">{{pay_duration.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственник (*)</label><md-select ng-model=\"vm.formWizard.owner_id\" required=\"\"><md-option ng-repeat=\"client in vm.my_clients\" value=\"{{client.id}}\">{{client.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.deal_type != \'rent\'\"><input type=\"text\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Цена\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type != \'rent\'\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commission\" ng-model=\"vm.formWizard.commission\" placeholder=\"Комиссия\" ng-pattern=\"/[0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.commission.$error\" ng-show=\"wizardStep1.commission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите комиссию правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комиссии</label><md-select ng-model=\"vm.formWizard.commission_type\"><md-option ng-repeat=\"commission_type in vm.commission_types\" value=\"{{commission_type.name}}\">{{commission_type.rusname}}</md-option></md-select></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Число комнат <strong>*</strong></label><md-select ng-model=\"vm.formWizard.rooms_number\" required=\"\"><md-option ng-repeat=\"rooms_type in vm.rooms_type_list\" value=\"{{rooms_type.name}}\">{{rooms_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story\" ng-model=\"vm.formWizard.story\" placeholder=\"Этаж <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"{{vm.formWizard.story_count}}\" required=\"\"><div ng-messages=\"wizardStep2.story.$error\" ng-show=\"wizardStep2.story.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этаж - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этаж правильно</span></div><div ng-message=\"min\"><span>Введите этаж правильно</span></div><div ng-message=\"max\"><span>Этаж не должен быть больше числа этажей</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Этажность <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"30\" required=\"\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этажность - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Холодильник</label><md-select ng-model=\"vm.formWizard.tech_4\"><md-option ng-repeat=\"tech_4 in vm.yes_no_array\" value=\"{{tech_4.name}}\">{{tech_4.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Стиральная машина</label><md-select ng-model=\"vm.formWizard.tech_8\"><md-option ng-repeat=\"tech_8 in vm.yes_no_array\" value=\"{{tech_8.name}}\">{{tech_8.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Мебель</label><md-select ng-model=\"vm.formWizard.furniture\"><md-option ng-repeat=\"furniture in vm.furniture_types\" value=\"{{furniture.name}}\">{{furniture.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\" required=\"\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Статус <strong>*</strong></label><md-select ng-model=\"vm.formWizard.flat_status\" required=\"\"><md-option ng-repeat=\"flat_status in vm.flat_status_types\" value=\"{{flat_status.name}}\">{{flat_status.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>В собственности</label><md-select ng-model=\"vm.formWizard.years_own\"><md-option ng-repeat=\"years_own in vm.years_own_types\" value=\"{{years_own.name}}\">{{years_own.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Лифт</label><md-select ng-model=\"vm.formWizard.lift\"><md-option ng-repeat=\"lift in vm.lift_types\" value=\"{{lift.name}}\">{{lift.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Балкон</label><md-select ng-model=\"vm.formWizard.balcony\"><md-option ng-repeat=\"balcony in vm.balcony_types\" value=\"{{balcony.name}}\">{{balcony.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Право собственности</label><md-select ng-model=\"vm.formWizard.ownership\"><md-option ng-repeat=\"ownership in vm.ownership_types\" value=\"{{ownership.name}}\">{{ownership.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип дома<strong>*</strong></label><md-select ng-model=\"vm.formWizard.type_bild\" required=\"\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип санузла</label><md-select ng-model=\"vm.formWizard.type_bathroom\"><md-option ng-repeat=\"type_bathroom in vm.types_bathroom\" value=\"{{type_bathroom.name}}\">{{type_bathroom.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"count_bathroom_flat\" ng-model=\"vm.formWizard.count_bathroom_flat\" placeholder=\"Количество сан.узлов\" ng-pattern=\"/^[0-9]{1,2}$/\"><div ng-messages=\"wizardStep2.count_bathroom_flat.$error\" ng-show=\"wizardStep2.count_bathroom_flat.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Интернет</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.yes_no_array\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телефон</label><md-select ng-model=\"vm.formWizard.phone\"><md-option ng-repeat=\"phone_type in vm.phone_types\" value=\"{{phone_type.name}}\">{{phone_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телевизор</label><md-select ng-model=\"vm.formWizard.tv\"><md-option ng-repeat=\"tv in vm.yes_no_array\" value=\"{{tv.name}}\">{{tv.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Общая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_all\" ng-model=\"vm.formWizard.square_all\" placeholder=\"Общая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_all.$error\" ng-show=\"wizardStep2.square_all.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Жилая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_living\" ng-model=\"vm.formWizard.square_living\" placeholder=\"Жилая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxLiving=vm.formWizard.square_all-vm.formWizard.square_kitchen}}\" min=\"0\" max=\"{{vm.maxLiving}}\"><div ng-messages=\"wizardStep2.square_living.$error\" ng-show=\"wizardStep2.square_living.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь кухни, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_kitchen\" ng-model=\"vm.formWizard.square_kitchen\" placeholder=\"Площадь кухни\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxKitchen=vm.formWizard.square_all-vm.formWizard.square_living}}\" min=\"0\" max=\"{{vm.maxKitchen}}\"><div ng-messages=\"wizardStep2.square_kitchen.$error\" ng-show=\"wizardStep2.square_kitchen.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площади комнат через + <strong>*</strong></label> <input name=\"square_rooms\" ng-model=\"vm.formWizard.square_rooms\" placeholder=\"Площади комнат через разделитель\" required=\"\" ng-pattern=\"/^((\\d+(.\\d{1,2})?\\+?)*\\d{1}(.\\d{1,2})?)$/\"><div ng-messages=\"wizardStep2.square_rooms.$error\" ng-show=\"wizardStep2.square_rooms.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь комнат должна быть указана</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"300\" rows=\"5\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 300 символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">4</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Фотографии</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"pb-16\">Фотографии добавляются независимо от других данных объекта. Если Вы просто добавили фотографии, то можете просто выйти из редактирования объекта. При следующем посещении этой страницы они уже будут в таблице.<br>Выбрать файлы для загрузки можно ниже.<br>Позже будет реализована</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstanceCallback\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Фотография</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Размер</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"photo in ::vm.photos\"><td><img ng-src=\"{{photo.filename}}\" style=\"width: 400px; height: {{photo.height*400/photo.width}}px\"></td><td>{{ photo.width }}x{{ photo.height }}px / {{ photo.size/1024/1024|number:2 }} Мб</td><td><md-button alt=\"Установить эту фотографию главной\" class=\"md-raised md-accent\" ng-click=\"vm.setMainPhoto(photo.id);\" aria-label=\"Set this as main photo\" ng-show=\"photo.id!=vm.mainImage\"><md-icon md-font-icon=\"icon-flag-variant\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.removePhoto(photo.id);\" aria-label=\"Remove this\" ng-show=\"photo.id!=vm.mainImage\"><md-icon md-font-icon=\"icon-content-cut\" class=\"s16\"></md-icon></md-button><span ng-show=\"photo.id==vm.mainImage\">Главная фотография выводится<br>как миниатюра на рекламных порталах.<br>Вы не можете ее удалить</span></td></tr></tbody></table><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Не загружайте фотографии с водяными знаками, номерами телефонов и прочей посторонней информацией.<br>Если Вы хотите использовать чужие фотографии, то предварительно отредактируйте их (например, измените размер)<br>Если не следовать этим правилам, то объект вполне может оказаться заблокированным на некоторых порталах</div></div><md-input-container class=\"md-block\"><div class=\"row\"><div class=\"col-md-3\"><h3><md-icon md-font-icon=\"icon-paperclip\" class=\"s16\"></md-icon>Выберите файлы</h3><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" aria-label=\"Photos\"><br></div><div class=\"col-md-9\" style=\"margin-bottom: 40px\"><h3>Выбрано файлов для загрузки: {{ uploader.queue.length }}</h3><br><br><table class=\"table\" ng-show=\"uploader.queue.length\"><thead><tr><th width=\"50%\">Имя</th><th ng-show=\"uploader.isHTML5\">Размер</th><th>Действия</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} Мб</td><td nowrap=\"\"><md-button class=\"md-raised md-accent\" ng-click=\"item.upload();vm.successLoadPhotosMessage();\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" aria-label=\"Download this\"><md-icon md-font-icon=\"icon-box-download\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"item.remove();\" aria-label=\"Remove this\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><br><br><div ng-show=\"uploader.queue.length\"><md-button class=\"md-raised md-accent\" ng-click=\"uploader.uploadAll();vm.successLoadPhotosMessage();\" ng-disabled=\"!uploader.getNotUploadedItems().length\" aria-label=\"Download all\">Загрузить все</md-button><md-button class=\"md-raised md-warn\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\" aria-label=\"Clear download list\">Очистить все</md-button></div></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Изменить объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/objects/editobject/editflatrent/versions/editflat (original).html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Объекты</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"child\">Новый объект</span></div><div class=\"title\">Квартира</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Основные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Регион</label><md-select ng-model=\"vm.formWizard.region\" ng-change=\"vm.loadDistricts();\" required=\"\"><md-option ng-repeat=\"region in vm.regions\" value=\"{{region.id}}\">{{region.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Район</label><md-select ng-model=\"vm.formWizard.district\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"district in vm.districts\" value=\"{{district.id}}\">{{district.name}}</md-option></md-select><div ng-messages=\"vm.wizardStep1.district.$error\" ng-show=\"vm.wizardStep1.district.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип населенного пункта</label><md-select ng-model=\"vm.formWizard.city_type\" ng-change=\"vm.loadCities()\" required=\"\"><md-option ng-repeat=\"city_type in vm.city_types\" value=\"{{city_type.socr}}\">{{city_type.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Название населенного пункта</label><md-select ng-model=\"vm.formWizard.city\" ng-change=\"vm.loadStreets()\" required=\"\"><md-option ng-repeat=\"city in vm.cities\" value=\"{{city.name}}\">{{city.name}}</md-option><div ng-messages=\"vm.wizardStep1.city.$error\" ng-show=\"vm.wizardStep1.city.$touched\" role=\"alert\"><div ng-message=\"required\"><span></span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Улица</label><md-select ng-model=\"vm.formWizard.street\" ng-required=\"vm.formWizard.region==1 || vm.formWizard.city_type==\'г\'\"><md-option ng-repeat=\"street in vm.streets\" value=\"{{street.name}}\">{{street.name}}</md-option><div ng-messages=\"vm.wizardStep1.street.$error\" ng-show=\"vm.wizardStep1.street.$touched\" role=\"alert\"><div ng-message=\"itsrequired\"><span>Улица обязательно должна быть указана</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"house_number\" ng-model=\"vm.formWizard.house_number\" placeholder=\"Номер дома\" required=\"\"><div ng-messages=\"vm.wizardStep1.house_number.$error\" ng-show=\"vm.wizardStep1.house_number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 2\"><label>Направление электричек</label><md-select ng-model=\"vm.formWizard.direction\" ng-required=\"vm.formWizard.region==2\"><md-option ng-repeat=\"direction in vm.directions\" value=\"{{direction.id}}\">{{direction.name}}</md-option><div ng-messages=\"vm.wizardStep1.direction.$error\" ng-show=\"vm.wizardStep1.direction.$touched\" role=\"alert\"><div ng-message=\"required\"><span>*</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Основное метро</label><md-select ng-model=\"vm.formWizard.metro_1\" ng-required=\"vm.formWizard.region==1\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option><div ng-messages=\"vm.wizardStep1.metro_1.$error\" ng-show=\"vm.wizardStep1.metro_1.$touched\" role=\"alert\"><div ng-message=\"required\"><span>*</span></div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_1_time\" ng-required=\"vm.formWizard.metro_1\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_1 && vm.formWizard.metro_1_time\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Дополнительное метро</label><md-select ng-model=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_2_time\" ng-required=\"vm.formWizard.metro_2\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Дополнительное метро</label><md-select ng-model=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro in vm.metrostations\" value=\"{{metro.id}}\">{{metro.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.region == 1 && vm.formWizard.metro_2 && vm.formWizard.metro_2_time\"><label>Время в пути</label><md-select ng-model=\"vm.formWizard.metro_3_time\" ng-required=\"vm.formWizard.metro_3\"><md-option ng-repeat=\"metro_time in vm.metro_time_list\" value=\"{{metro_time.name}}\">{{metro_time.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип объекта</label><md-select ng-model=\"vm.formWizard.object_type_2\" required=\"\"><md-option ng-repeat=\"object_type_2 in vm.object_types_2\" value=\"{{object_type_2.name}}\">{{object_type_2.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип сделки</label><md-select ng-model=\"vm.formWizard.deal_type\" ng-change=\"vm.changeFlatStatuses()\" required=\"\"><md-option ng-repeat=\"deal_type in vm.deal_types\" value=\"{{deal_type.name}}\">{{deal_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Источник</label><md-select ng-model=\"vm.formWizard.source_id\" required=\"\"><md-option ng-repeat=\"source in vm.sources\" value=\"{{source.id}}\">{{source.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип недвижимости</label><md-select ng-model=\"vm.formWizard.object_type\" ng-change=\"vm.changeRoomTypes()\" required=\"\"><md-option ng-repeat=\"object_type in vm.object_types\" value=\"{{object_type.name}}\">{{object_type.rusname}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.formWizard.object_type == \'part\'\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"part_percent\" ng-model=\"vm.formWizard.part_percent\" placeholder=\"Процент доли\" ng-pattern=\"/^(0|[1-9]\\d?)$/\" ng-required=\"vm.formWizard.object_type == \'part\'\"><div ng-messages=\"wizardStep1.part_percent.$error\" ng-show=\"wizardStep1.part_percent.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите процент правильно</span></div></div></md-input-container></div><div layout=\"column\" ng-show=\"vm.formWizard.deal_type == \'rent\'\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"rentcost\" ng-model=\"vm.formWizard.rentcost\" placeholder=\"Арендная плата\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><div ng-messages=\"wizardStep1.rentcost.$error\" ng-show=\"wizardStep1.rentcost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Срок аренды</label><md-select ng-model=\"vm.formWizard.rent_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"rent_duration in vm.rent_durations\" value=\"{{rent_duration.name}}\">{{rent_duration.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Период оплаты</label><md-select ng-model=\"vm.formWizard.pay_duration\" ng-required=\"vm.formWizard.deal_type == \'rent\'\"><md-option ng-repeat=\"pay_duration in vm.pay_durations\" value=\"{{pay_duration.name}}\">{{pay_duration.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Собственник (*)</label><md-select ng-model=\"vm.formWizard.owner_id\" required=\"\"><md-option ng-repeat=\"client in vm.my_clients\" value=\"{{client.id}}\">{{client.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-show=\"vm.formWizard.deal_type != \'rent\'\"><input type=\"text\" name=\"cost\" ng-model=\"vm.formWizard.cost\" placeholder=\"Цена\" ng-pattern=\"/[0-9]$/\" ng-required=\"vm.formWizard.deal_type != \'rent\'\"><div ng-messages=\"wizardStep1.cost.$error\" ng-show=\"wizardStep1.cost.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Введите цену правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"commission\" ng-model=\"vm.formWizard.commission\" placeholder=\"Комиссия\" ng-pattern=\"/[0-9]$/\" required=\"\"><div ng-messages=\"wizardStep1.commission.$error\" ng-show=\"wizardStep1.commission.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Поле обязательно должно быть заполнено</span></div><div ng-message=\"pattern\"><span>Введите комиссию правильно</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип комиссии</label><md-select ng-model=\"vm.formWizard.commission_type\"><md-option ng-repeat=\"commission_type in vm.commission_types\" value=\"{{commission_type.name}}\">{{commission_type.rusname}}</md-option></md-select></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Дополнительные параметры</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Число комнат <strong>*</strong></label><md-select ng-model=\"vm.formWizard.rooms_number\" required=\"\"><md-option ng-repeat=\"rooms_type in vm.rooms_type_list\" value=\"{{rooms_type.name}}\">{{rooms_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story\" ng-model=\"vm.formWizard.story\" placeholder=\"Этаж <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"{{vm.formWizard.story_count}}\" required=\"\"><div ng-messages=\"wizardStep2.story.$error\" ng-show=\"wizardStep2.story.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этаж - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этаж правильно</span></div><div ng-message=\"min\"><span>Введите этаж правильно</span></div><div ng-message=\"max\"><span>Этаж не должен быть больше числа этажей</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"story_count\" ng-model=\"vm.formWizard.story_count\" placeholder=\"Этажность <strong>*</strong>\" ng-pattern=\"/^([1-9]\\d?)$/\" min=\"1\" max=\"30\" required=\"\"><div ng-messages=\"wizardStep2.story_count.$error\" ng-show=\"wizardStep2.story_count.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Этажность - обязательное поле</span></div><div ng-message=\"pattern\"><span>Введите этажность правильно</span></div><div ng-message=\"min\"><span>Введите этажность правильно</span></div><div ng-message=\"max\"><span>Введите этажность правильно</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Холодильник</label><md-select ng-model=\"vm.formWizard.tech_4\"><md-option ng-repeat=\"tech_4 in vm.yes_no_array\" value=\"{{tech_4.name}}\">{{tech_4.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Стиральная машина</label><md-select ng-model=\"vm.formWizard.tech_8\"><md-option ng-repeat=\"tech_8 in vm.yes_no_array\" value=\"{{tech_8.name}}\">{{tech_8.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Мебель</label><md-select ng-model=\"vm.formWizard.furniture\"><md-option ng-repeat=\"furniture in vm.furniture_types\" value=\"{{furniture.name}}\">{{furniture.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Ремонт <strong>*</strong></label><md-select ng-model=\"vm.formWizard.repairs\" required=\"\"><md-option ng-repeat=\"repairs in vm.repairs_types\" value=\"{{repairs.name}}\">{{repairs.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Статус <strong>*</strong></label><md-select ng-model=\"vm.formWizard.flat_status\" required=\"\"><md-option ng-repeat=\"flat_status in vm.flat_status_types\" value=\"{{flat_status.name}}\">{{flat_status.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>В собственности</label><md-select ng-model=\"vm.formWizard.years_own\"><md-option ng-repeat=\"years_own in vm.years_own_types\" value=\"{{years_own.name}}\">{{years_own.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Лифт</label><md-select ng-model=\"vm.formWizard.lift\"><md-option ng-repeat=\"lift in vm.lift_types\" value=\"{{lift.name}}\">{{lift.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Балкон</label><md-select ng-model=\"vm.formWizard.balcony\"><md-option ng-repeat=\"balcony in vm.balcony_types\" value=\"{{balcony.name}}\">{{balcony.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Право собственности</label><md-select ng-model=\"vm.formWizard.ownership\"><md-option ng-repeat=\"ownership in vm.ownership_types\" value=\"{{ownership.name}}\">{{ownership.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип дома<strong>*</strong></label><md-select ng-model=\"vm.formWizard.type_bild\" required=\"\"><md-option ng-repeat=\"type_bild in vm.type_bild_list\" value=\"{{type_bild.name}}\">{{type_bild.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Тип санузла</label><md-select ng-model=\"vm.formWizard.type_bathroom\"><md-option ng-repeat=\"type_bathroom in vm.types_bathroom\" value=\"{{type_bathroom.name}}\">{{type_bathroom.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"count_bathroom_flat\" ng-model=\"vm.formWizard.count_bathroom_flat\" placeholder=\"Количество сан.узлов\" ng-pattern=\"/^[0-9]{1,2}$/\"><div ng-messages=\"wizardStep2.count_bathroom_flat.$error\" ng-show=\"wizardStep2.count_bathroom_flat.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Интернет</label><md-select ng-model=\"vm.formWizard.inet\"><md-option ng-repeat=\"inet in vm.yes_no_array\" value=\"{{inet.name}}\">{{inet.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телефон</label><md-select ng-model=\"vm.formWizard.phone\"><md-option ng-repeat=\"phone_type in vm.phone_types\" value=\"{{phone_type.name}}\">{{phone_type.rusname}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Телевизор</label><md-select ng-model=\"vm.formWizard.tv\"><md-option ng-repeat=\"tv in vm.yes_no_array\" value=\"{{tv.name}}\">{{tv.rusname}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Общая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_all\" ng-model=\"vm.formWizard.square_all\" placeholder=\"Общая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" min=\"0\"><div ng-messages=\"wizardStep2.square_all.$error\" ng-show=\"wizardStep2.square_all.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Жилая площадь, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_living\" ng-model=\"vm.formWizard.square_living\" placeholder=\"Жилая площадь\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxLiving=vm.formWizard.square_all-vm.formWizard.square_kitchen}}\" min=\"0\" max=\"{{vm.maxLiving}}\"><div ng-messages=\"wizardStep2.square_living.$error\" ng-show=\"wizardStep2.square_living.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площадь кухни, м<sup>2</sup> <strong>*</strong></label> <input name=\"square_kitchen\" ng-model=\"vm.formWizard.square_kitchen\" placeholder=\"Площадь кухни\" required=\"\" ng-pattern=\"/^[0-9]{1,10}(\\.[0-9]{1,2})?$/\" type=\"number\" ng-change=\"{{vm.maxKitchen=vm.formWizard.square_all-vm.formWizard.square_living}}\" min=\"0\" max=\"{{vm.maxKitchen}}\"><div ng-messages=\"wizardStep2.square_kitchen.$error\" ng-show=\"wizardStep2.square_kitchen.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь должна быть указана</span></div><div ng-message=\"min\"><span>Площадь не может быть отрицательной</span></div><div ng-message=\"max\"><span>Жилая площадь и площадь кухни больше общей</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Площади комнат через + <strong>*</strong></label> <input name=\"square_rooms\" ng-model=\"vm.formWizard.square_rooms\" placeholder=\"Площади комнат через разделитель\" required=\"\" ng-pattern=\"/^((\\d+(.\\d{1,2})?\\+?)*\\d{1}(.\\d{1,2})?)$/\"><div ng-messages=\"wizardStep2.square_rooms.$error\" ng-show=\"wizardStep2.square_rooms.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Площадь комнат должна быть указана</span></div><div ng-message=\"pattern\"><span>Проверьте правильность ввода</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Описание</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Будьте внимательны: запрещено использовать в тексте описания слова <i>\"альтернатива\"</i> (для свободной продажи) или <i>\"нежилой фонд\"</i>! Не пишите свой телефон, дату продажи объекта - это может привести к блокировке объекта на рекламных площадках.</div></div><md-input-container class=\"md-block\"><label>Описание объекта <strong>*</strong></label> <textarea ng-model=\"vm.formWizard.description\" columns=\"1\" md-maxlength=\"300\" rows=\"5\" required=\"\"></textarea><div ng-messages=\"wizardStep2.description.$error\" ng-show=\"wizardStep2.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"md-maxlength\"><span>Описание не должно быть длиннее 300 символов</span></div><div ng-message=\"required\"><span>Описание - обязательное поле</span></div></div></md-input-container></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">4</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Фотографии</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"pb-16\">Фотографии добавляются независимо от других данных объекта. Если Вы просто добавили фотографии, то можете просто выйти из редактирования объекта. При следующем посещении этой страницы они уже будут в таблице.<br>Выбрать файлы для загрузки можно ниже.<br>Позже будет реализована</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Фотография</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Размер</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"photo in ::vm.photos\"><td><img ng-src=\"{{photo.filename}}\" style=\"width: 400px; height: {{photo.height*400/photo.width}}px\"></td><td>{{ photo.width }}x{{ photo.height }}px / {{ photo.size/1024/1024|number:2 }} Мб</td><td><md-button alt=\"Установить эту фотографию главной\" class=\"md-raised md-accent\" ng-click=\"vm.setMainPhoto(photo.id);\" aria-label=\"Set this as main photo\" ng-show=\"photo.id!=vm.mainImage\"><md-icon md-font-icon=\"icon-flag-variant\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.removePhoto(photo.id);\" aria-label=\"Remove this\" ng-show=\"photo.id!=vm.mainImage\"><md-icon md-font-icon=\"icon-content-cut\" class=\"s16\"></md-icon></md-button><span ng-show=\"photo.id==vm.mainImage\">Главная фотография выводится<br>как миниатюра на рекламных порталах.<br>Вы не можете ее удалить</span></td></tr></tbody></table><div class=\"content\" layout=\"column\"><div class=\"pb-16\">Не загружайте фотографии с водяными знаками, номерами телефонов и прочей посторонней информацией.<br>Если Вы хотите использовать чужие фотографии, то предварительно отредактируйте их (например, измените размер)<br>Если не следовать этим правилам, то объект вполне может оказаться заблокированным на некоторых порталах</div></div><md-input-container class=\"md-block\"><div class=\"row\"><div class=\"col-md-3\"><h3><md-icon md-font-icon=\"icon-paperclip\" class=\"s16\"></md-icon>Выберите файлы</h3><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" aria-label=\"Photos\"><br></div><div class=\"col-md-9\" style=\"margin-bottom: 40px\"><h3>Выбрано файлов для загрузки: {{ uploader.queue.length }}</h3><br><br><table class=\"table\" ng-show=\"uploader.queue.length\"><thead><tr><th width=\"50%\">Имя</th><th ng-show=\"uploader.isHTML5\">Размер</th><th>Действия</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} Мб</td><td nowrap=\"\"><md-button class=\"md-raised md-accent\" ng-click=\"item.upload();vm.successLoadPhotosMessage();\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" aria-label=\"Download this\"><md-icon md-font-icon=\"icon-box-download\" class=\"s16\"></md-icon></md-button><md-button class=\"md-raised md-warn\" ng-click=\"item.remove();\" aria-label=\"Remove this\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><br><br><div ng-show=\"uploader.queue.length\"><md-button class=\"md-raised md-accent\" ng-click=\"uploader.uploadAll();vm.successLoadPhotosMessage();\" ng-disabled=\"!uploader.getNotUploadedItems().length\" aria-label=\"Download all\">Загрузить все</md-button><md-button class=\"md-raised md-warn\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\" aria-label=\"Clear download list\">Очистить все</md-button></div></div></div></md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Назад</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Далее</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Изменить объект</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div class=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button class=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" layout-align=\"space-between\" layout-fill=\"\" flex=\"\"><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" ng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex=\"\"></span><md-button class=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate=\"\" translate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex=\"\"><span class=\"h4\">{{vm.calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span> {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class=\"secondary-text\">{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-bell-ring-outline\"></md-icon><div layout=\"column\" flex=\"\"><span class=\"h4\" translate=\"CALENDAR.30_MIN_BEFORE\">30 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.15_MIN_BEFORE\">15 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.30_MIN_LATER\">30 minutes later</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-map-marker\"></md-icon><div layout=\"column\" flex=\"\"><span class=\"h4\">Istanbul, Turkey</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon><div layout=\"row\" flex=\"\"><img src=\"assets/images/avatars/alice.jpg\" class=\"avatar\" alt=\"alice\"> <img src=\"assets/images/avatars/joyce.jpg\" class=\"avatar\" alt=\"joyce\"> <img src=\"assets/images/avatars/vincent.jpg\" class=\"avatar\" alt=\"vincent\"></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label> <input name=\"title\" ng-model=\"vm.calendarEvent.title\" required=\"\"><div ng-messages=\"eventForm.title.$error\" ng-show=\"eventForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-list class=\"all-day\"><md-list-item><p translate=\"CALENDAR.ALL_DAY\">Весь день</p><md-switch class=\"md-secondary\" ng-model=\"vm.calendarEvent.allday\" aria-label=\"All day\" translate=\"\" translate-attr-aria-label=\"CALENDAR.ALL_DAY\"></md-switch></md-list-item></md-list><div layout=\"row\" class=\"date-row\"><md-datepicker ng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\"></md-datepicker><md-input-container flex=\"\" md-no-float=\"\"><input ng-model=\"vm.calendarEvent.startTime\" placeholder=\"Start Time\" translate=\"\" translate-attr-placeholder=\"CALENDAR.START_TIME\"></md-input-container></div><div layout=\"row\" class=\"date-row\"><md-datepicker ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\"></md-datepicker><md-input-container flex=\"\" md-no-float=\"\"><input ng-model=\"vm.calendarEvent.endTime\" placeholder=\"End Time\" translate=\"\" translate-attr-placeholder=\"CALENDAR.END_TIME\"></md-input-container></div><md-input-container class=\"md-block\" flex=\"\"><label translate=\"CALENDAR.REPEAT\">Repeat</label> <input ng-model=\"vm.calendarEvent.repeat\"></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label translate=\"CALENDAR.LOCATION\">Location</label> <input ng-model=\"vm.calendarEvent.location\"></md-input-container><div class=\"notifications\" layout=\"column\"><div class=\"title\" translate=\"CALENDAR.NOTIFICATIONS\">Notifications</div><md-select ng-model=\"notification\" placeholder=\"Notification\" ng-repeat=\"notification in vm.calendarEvent.notifications\"><md-option ng-repeat=\"opt in vm.notifications\" value=\"{{opt}}\">{{opt}}</md-option></md-select><md-button aria-label=\"+ Add Another Notification\" translate=\"CALENDAR.ADD_NOTIFICATION\" translate-attr-aria-label=\"CALENDAR.ADD_NOTIFICATION\">+ Add Another Notification</md-button></div><md-input-container flex=\"\" class=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes</label> <textarea ng-model=\"vm.task.notes\" md-maxlength=\"250\"></textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/file-manager/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/file-manager/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div class=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" placeholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/file-manager/views/grid/grid-view.html","<div class=\"grid-view\" layout=\"column\"><div class=\"folders\" layout=\"row\" layout-wrap=\"\"><div class=\"md-background-bg md-hue-1 md-whiteframe-1dp item folder\" ng-click=\"vm.select(folder)\" ng-repeat=\"folder in vm.folders | filter:global.search\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"start center\"><span class=\"file-icon\"><md-icon md-font-icon=\"icon-{{folder.type}}\"></md-icon></span> <span class=\"name\">{{folder.name}}</span></div><div class=\"show-details\" hide-gt-md=\"\"><md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate=\"\" translate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\" ng-click=\"vm.toggleDetails(folder)\"></md-icon></md-button></div></div></div><div class=\"files\" layout=\"row\" layout-wrap=\"\"><div ng-click=\"vm.select(file)\" class=\"md-whiteframe-1dp item file\" ng-repeat=\"file in vm.files | filter:global.search\" layout=\"column\"><div class=\"preview\"><img ng-src=\"{{file.preview}}\"></div><div class=\"bottom md-background-bg md-hue-1\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"start center\" flex=\"\"><span class=\"file-icon\"><md-icon md-font-icon=\"icon-{{file.type}}\"></md-icon></span> <span class=\"name\">{{file.name}}</span></div><div class=\"show-details\" hide-gt-md=\"\"><md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate=\"\" translate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\" ng-click=\"vm.toggleDetails(file)\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/apps/file-manager/views/list/list-view.html","<table class=\"simple list-view\"><thead><tr><th></th><th translate=\"FM.NAME\">Name</th><th hide=\"\" show-gt-sm=\"\" translate=\"FM.TYPE\">Type</th><th hide-xs=\"\" translate=\"FM.OWNER\">Owner</th><th hide-xs=\"\" translate=\"FM.SIZE\">Size</th><th hide=\"\" show-gt-md=\"\" translate=\"FM.LAST_MODIFIED\">Last Modified</th><th hide-gt-md=\"\"></th></tr></thead><tbody><tr ng-repeat=\"folder in vm.folders | filter:global.search\" ng-click=\"vm.select(folder)\" ng-class=\"{\'selected\' : vm.selected === folder}\"><td class=\"file-icon\"><md-icon md-font-icon=\"icon-{{folder.type}}\"></md-icon></td><td class=\"name\">{{folder.name}}</td><td class=\"type\" hide=\"\" show-gt-sm=\"\">{{folder.type}}</td><td class=\"owner\" hide-xs=\"\">{{folder.owner}}</td><td class=\"size\" hide-xs=\"\">{{folder.size === \'\' ? \'-\': folder.size}}</td><td class=\"last-modified\" hide=\"\" show-gt-md=\"\">{{folder.modified}}</td><td class=\"show-details\" hide-gt-md=\"\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(folder)\" aria-label=\"Toggle details sidenav\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon></md-button></td></tr><tr ng-repeat=\"file in vm.files | filter:global.search\" ng-click=\"vm.select(file)\" ng-class=\"{\'selected\' : vm.selected === file}\"><td class=\"file-icon\"><md-icon md-font-icon=\"icon-{{file.type}}\"></md-icon></td><td class=\"name\">{{file.name}}</td><td class=\"type\" hide=\"\" show-gt-sm=\"\">{{file.type}}</td><td class=\"owner\" hide-xs=\"\">{{file.owner}}</td><td class=\"size\" hide-xs=\"\">{{file.size === \'\' ? \'-\': file.size}}</td><td class=\"last-modified\" hide=\"\" show-gt-md=\"\">{{file.modified}}</td><td class=\"show-details\" hide-gt-md=\"\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(file)\" aria-label=\"Details\" translate=\"\" translate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon></md-button></td></tr></tbody></table>");
$templateCache.put("app/main/apps/mail/dialogs/compose/compose-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"MAIL.NEW_MESSAGE\">New Message</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate=\"\" translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label translate=\"MAIL.FROM\">From</label> <input ng-model=\"vm.form.from\" type=\"email\" disabled=\"\"></md-input-container><md-input-container class=\"md-block to\" ng-class=\"{\'hidden-cc\': vm.hiddenCC, \'hidden-bcc\': vm.hiddenBCC}\"><label translate=\"MAIL.TO\">To</label> <input ng-model=\"vm.form.to\" type=\"email\"><div class=\"cc-bcc\" layout=\"row\" layout-align=\"start center\"><div class=\"show-cc\" ng-show=\"vm.hiddenCC\" ng-click=\"vm.hiddenCC = false\">CC</div><div class=\"show-bcc\" ng-show=\"vm.hiddenBCC\" ng-click=\"vm.hiddenBCC = false\">BCC</div></div></md-input-container><md-input-container class=\"md-block\" ng-hide=\"vm.hiddenCC\"><label translate=\"MAIL.CC\">Cc</label> <input ng-model=\"vm.form.cc\" type=\"email\"></md-input-container><md-input-container class=\"md-block\" ng-hide=\"vm.hiddenBCC\"><label translate=\"MAIL.BCC\">Bcc</label> <input ng-model=\"vm.form.bcc\" type=\"t\"></md-input-container><md-input-container class=\"md-block\"><label translate=\"MAIL.SUBJECT\">Subject</label> <input ng-model=\"vm.form.subject\" type=\"text\"></md-input-container><text-angular ng-model=\"vm.form.message\"></text-angular><div class=\"attachment-list\"><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-2.doc</span> <span class=\"size\">(12 Kb)</span></div><md-button class=\"md-icon-button\" aria-label=\"Delete attachment\" translate=\"\" translate-attr-aria-label=\"MAIL.DELETE_ATTACHMENT\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-1.jpg</span> <span class=\"size\">(350 Kb)</span></div><md-button class=\"md-icon-button\" aria-label=\"Delete attachment\" translate=\"\" translate-attr-aria-label=\"MAIL.DELETE_ATTACHMENT\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MAIL.SEND\" translate-attr-aria-label=\"MAIL.SEND\">SEND</md-button><md-button class=\"md-icon-button\" aria-label=\"Attach file\" translate-attr-aria-label=\"MAIL.ATTACH_FILE\"><md-icon md-font-icon=\"icon-paperclip\"></md-icon><md-tooltip><span translate=\"MAIL.ATTACH_FILE\"></span></md-tooltip></md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" aria-label=\"Delete\" translate-attr-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"MAIL.DELETE\"></span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/mail/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon></span> <span class=\"logo-text\" translate=\"MAIL.MAILBOX\">Mailbox</span></div><div class=\"account\"><div class=\"title\">John Doe</div><md-select class=\"account-selection simplified\" placeholder=\"Mail Selection\" ng-model=\"vm.selectedAccount\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><md-content ms-scroll=\"\" class=\"content\" flex=\"\"><div class=\"compose-button\"><md-button class=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"vm.composeDialog($event)\" translate=\"MAIL.COMPOSE\">COMPOSE</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-inbox\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MAIL.INBOX\">Inbox</span></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><span class=\"title\" flex=\"\" translate=\"MAIL.STARRED\">Starred</span></div></md-button><md-button class=\"item\" aria-label=\"important\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span class=\"title\" flex=\"\" translate=\"MAIL.IMPORTANT\">Important</span></div></md-button><md-button class=\"item\" aria-label=\"sent\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MAIL.SENT\">Sent</span></div></md-button><md-button class=\"item\" aria-label=\"drafts\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email-open\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MAIL.DRAFTS\">Drafts</span></div></md-button><md-button class=\"item\" aria-label=\"all mail\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MAIL.ALL_MAIL\">All Mail</span></div></md-button><md-button class=\"item\" aria-label=\"spam\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-octagon\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MAIL.SPAM\">Spam</span></div></md-button><md-button class=\"item\" aria-label=\"trash\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MAIL.TRASH\">Trash</span></div></md-button><div class=\"item subheader\" translate=\"MAIL.LABELS\">Labels</div><md-button class=\"item\" aria-label=\"label notes\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-label\" class=\"s16 green-fg\"></md-icon><span class=\"title\">Notes</span></div></md-button><md-button class=\"item\" aria-label=\"label paypal\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-label\" class=\"s16 orange-fg\"></md-icon><span class=\"title\">Paypal</span></div></md-button><md-button class=\"item\" aria-label=\"label invoices\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-label\" class=\"s16 blue-grey-fg\"></md-icon><span class=\"title\">Invoices</span></div></md-button><md-button class=\"item\" aria-label=\"label amazon\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-label\" class=\"s16 blue-fg\"></md-icon><span class=\"title\">Amazon</span></div></md-button><md-divider></md-divider><md-button class=\"item\" aria-label=\"settings\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cog\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MAIL.SETTINGS\">Settings</span></div></md-button><md-button class=\"item\" aria-label=\"help\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-help\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MAIL.HELP\">Help</span></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/mail/views/list/list-view.html","<div class=\"mail-list-item {{mail.status}}\" ng-repeat=\"mail in vm.inbox | filter: vm.search | filter: global.search\" md-ink-ripple=\"\" ng-click=\"vm.selectMail(mail)\" ng-class=\"{\'starred\': mail.starred, \'selected\': vm.selectedMail === mail, \'checked\': vm.isChecked(mail)}\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(mail)\" ng-click=\"vm.toggleCheck(mail, $event)\" aria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div class=\"info\" flex=\"\" layout=\"column\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"mail.from.avatar\" alt=\"{{mail.from.name}}\" ng-src=\"{{mail.from.avatar}}\"><div class=\"avatar\" ng-if=\"!mail.from.avatar\" ms-random-class=\"vm.colors\">{{mail.from.name[0]}}</div><span class=\"text-truncate\">{{mail.from.name}}</span><md-icon md-font-icon=\"icon-paperclip\" class=\"has-attachment s16\" ng-if=\"mail.hasAttachments\"></md-icon></div><div class=\"subject text-truncate\">{{mail.subject}}</div><div class=\"message\">{{mail.message | htmlToPlaintext | limitTo:90}}{{mail.message.length > 90 ? \'...\' : \'\'}}</div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"time\">{{mail.time}}</div><md-button class=\"md-icon-button\" ng-click=\"vm.toggleStarred(mail, $event)\" aria-label=\"Toggle starred\" translate=\"\" translate-attr-toogle-starred=\"MAIL.TOGGLE_STARRED\"><md-icon ng-if=\"mail.starred\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!mail.starred\" md-font-icon=\"icon-star-outline\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/apps/mail/views/read/read-view.html","<div class=\"mail-header\"><div class=\"subject\" flex=\"\">{{vm.selectedMail.subject}}</div></div><div class=\"mail-content\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\" layout-align=\"start start\"><div><img ng-if=\"vm.selectedMail.from.avatar\" alt=\"{{vm.selectedMail.from.name}}\" ng-src=\"{{vm.selectedMail.from.avatar}}\" class=\"avatar\"><div ng-if=\"!vm.selectedMail.from.avatar\" class=\"avatar\" ms-random-class=\"vm.colors\">{{vm.selectedMail.from.name[0]}}</div></div><div layout=\"column\" layout-align=\"start start\"><div class=\"name\">{{vm.selectedMail.from.name}}</div><div class=\"to\" layout=\"row\" layout-align=\"start center\"><div class=\"to-text\" translate=\"MAIL.INFO.TO\">to</div><div>{{vm.selectedMail.to[0].name}}</div></div></div></div><a class=\"toggle-details md-accent-color\" ng-hide=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" translate=\"MAIL.SHOW_DETAILS\">Show Details</a> <a class=\"toggle-details md-accent-color\" ng-show=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" translate=\"MAIL.HIDE_DETAILS\">Hide Details</a><div ng-show=\"vm.selectedMailShowDetails\" class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\" translate=\"MAIL.DETAILS.FROM\">From:</span> <span class=\"title\" translate=\"MAIL.DETAILS.TO\">To:</span> <span class=\"title\" translate=\"MAIL.DETAILS.DATE\">Date:</span></div><div layout=\"column\"><span class=\"detail\">{{vm.selectedMail.from.email}}</span> <span class=\"detail\">{{vm.selectedMail.to[0].email}}</span> <span class=\"detail\">{{vm.selectedMail.time}}</span></div></div></div><md-menu><md-button aria-label=\"More\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" translate=\"\" translate-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"MAIL.MORE\"></span></md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Reply\" translate-aria-label=\"MAIL.REPLY\" ng-click=\"vm.replyDialog($event)\"><md-icon md-font-icon=\"icon-reply\"></md-icon><span translate=\"MAIL.REPLY\">Reply</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Archive\" translate-aria-label=\"MAIL.ARCHIVE\"><md-icon md-font-icon=\"icon-archive\"></md-icon><span translate=\"MAIL.ARCHIVE\">Archive</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Spam\" translate-aria-label=\"MAIL.SPAM\"><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><span translate=\"MAIL.SPAM\">Spam</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" translate-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"MAIL.DELETE\">Delete</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Mark as unread\" translate-aria-label=\"MAIL.MARK_AS_UNREAD\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><span translate=\"MAIL.MARK_AS_UNREAD\">Mark as unread</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Mark as important\" translate-aria-label=\"MAIL.MARK_AS_IMPORTANT\"><md-icon md-font-icon=\"icon-marker-check\"></md-icon><span translate=\"MAIL.MARK_AS_IMPORTANT\">Mark as important</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Add label\" translate-aria-label=\"MAIL.ADD_LABEL\"><md-icon md-font-icon=\"icon-label\"></md-icon><span translate=\"MAIL.ADD_LABEL\">Add label</span></md-button></md-menu-item></md-menu-content></md-menu></div><div ng-bind-html=\"vm.selectedMail.message\"></div></div><div ng-if=\"vm.selectedMail.attachments\" class=\"attachments\"><div class=\"title\"><span translte=\"MAIL.ATTACHMENTS\">Attachments</span> ({{vm.selectedMail.attachments.length}})</div><div class=\"attachment-list\" layout-wrap=\"\" layout=\"row\"><div class=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.selectedMail.attachments\"><img class=\"preview\" ng-src=\"{{attachment.preview}}\"><div layout=\"column\"><a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.VIEW\">View</a> <a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.DOWNLOAD\">Download</a><div class=\"size\">({{attachment.size}})</div></div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/dialogs/card/card-dialog.html","<md-dialog class=\"card-dialog\" aria-label=\"Card Dialog\" ng-cloak=\"\"><md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><div class=\"due-date\"><div ng-if=\"!vm.card.due\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"year\" max-view=\"hour\" start-view=\"month\"><md-button class=\"md-icon-button\" aria-label=\"Due date\" translate=\"\" translate-attr-aria-label=\"SB.DUE_DATE\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></md-button></div></div><md-menu ng-if=\"vm.card.due\" md-offset=\"0 48\" class=\"remove-due-date\"><md-button class=\"md-icon-button\" aria-label=\"Members\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></md-button><md-menu-content class=\"remove-due-date-menu-content\" width=\"4\" ms-scroll=\"\"><md-menu-item><md-button ng-click=\"vm.card.due = \'\'\" aria-label=\"remove due date\" translate-attr-aria-label=\"SB.REMOVE_DUE_DATE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"SB.REMOVE_DUE_DATE\">Remove Due Date</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 48\" class=\"labels\"><md-button class=\"md-icon-button\" aria-label=\"Label\" translate=\"\" translate-attr-aria-label=\"SB.LABEL\" ng-click=\"vm.labelTabIndex = 0;$mdOpenMenu($event)\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-label-outline\"></md-icon></md-button><md-menu-content class=\"labels-menu-content\" width=\"4\" ms-scroll=\"\"><md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height=\"\"><md-tab><md-tab-body><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Search labels...\" type=\"text\" ng-model=\"vm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\"></md-input-container></md-menu-item><md-menu-item class=\"label\" ng-repeat=\"label in vm.labels | filter: vm.filterLabel\"><md-button class=\"label-toggle-button\" md-prevent-menu-close=\"\" ng-class=\"\'md-\'+label.color+\'-bg\'\" ng-click=\"vm.toggleInArray(label.id, vm.card.idLabels)\" aria-label=\"Toggle Label\" translate=\"\" translate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\"><span>{{label.name}}</span> <i ng-if=\"vm.exists(label.id, vm.card.idLabels)\" class=\"icon-check s16\"></i></div></md-button><md-button class=\"md-icon-button label-edit-button\" md-prevent-menu-close=\"\" ng-click=\"vm.editLabelId = label.id; vm.labelTabIndex = 2\" aria-label=\"Edit Label\" translate=\"\" translate-attr-aria-label=\"SB.EDIT_LABEL\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button class=\"add-label-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 1\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span translate=\"SB.ADD_NEW_LABEL\">Add new label</span></md-button></md-menu-item></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"add-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 0\" aria-label=\"Back\" translate=\"\" translate-attr-aria-label=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex=\"\" translate=\"SB.CREATE_LABEL\">Create Label</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\"><form ng-submit=\"vm.addNewLabel(); vm.labelTabIndex = 0\" layout=\"column\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.newLabelName\" translate=\"\" translate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i class=\"icon-check s18\" ng-if=\"vm.newLabelColor === palette\"></i></label></div><md-button type=\"submit\" md-prevent-menu-close=\"\" class=\"create-button md-accent md-raised\" aria-label=\"Create\" translate=\"\" translate-attr-aria-label=\"SB.CREATE\"><span translate=\"SB.CREATE\">Create</span></md-button></form></div></div></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 0\" aria-label=\"back\" translate=\"\" translate-attr-aria-label=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex=\"\" translate=\"SB.EDIT_LABEL\">Edit Label</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.board.labels.getById(vm.editLabelId).name\" translate=\"\" translate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.board.labels.getById(vm.editLabelId).color\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i ng-if=\"vm.board.labels.getById(vm.editLabelId).color === palette\" class=\"icon-check s18\"></i></label></div><div layout=\"row\" layout-align=\"end center\" flex=\"\"><md-button class=\"remove-button md-icon-button\" type=\"submit\" md-prevent-menu-close=\"\" ng-click=\"vm.removeLabel(); vm.labelTabIndex=0\" aria-label=\"remove\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div></md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><md-menu md-offset=\"0 48\" class=\"members\"><md-button class=\"md-icon-button\" aria-label=\"Members\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-account-multiple\"></md-icon></md-button><md-menu-content class=\"members-menu-content\" width=\"4\" ms-scroll=\"\"><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Search members...\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.memberSearchText\" translate=\"\" translate-attr-placeholder=\"SB.SEARCH_MEMBERS\"></md-input-container></md-menu-item><md-menu-item class=\"member\" ng-repeat=\"member in vm.members | filter: vm.filterMember\"><md-button ng-click=\"vm.toggleInArray(member.id, vm.card.idMembers)\" md-prevent-menu-close=\"\" aria-label=\"toggle member\" translate=\"\" translate-attr-aria-label=\"SB.TOGGLE_MEMBER\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"avatar\"><p class=\"member-name\">{{ member.name }}</p></div><i class=\"icon-check s16\" ng-if=\"vm.exists(member.id, vm.card.idMembers)\"></i></div></md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"\" aria-label=\"Attachment\" translate=\"\" translate-attr-aria-label=\"SB.ATTACHMENT\"><md-icon md-font-icon=\"icon-attachment\"></md-icon></md-button><md-menu md-offset=\"0 48px\" class=\"checklist\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"checklist\" translate=\"\" translate-attr-aria-label=\"SB.CHECKLIST\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-menu-content class=\"checklist-menu-content\" width=\"4\"><form ng-submit=\"vm.createCheckList()\" layout=\"column\" layout-align=\"start end\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Checklist Title\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.newCheckListTitle\" translate=\"\" translate-attr-placeholder=\"SB.CHECKLIST_TITLE\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Add Checklist\" translate=\"\" translate-attr-aria-label=\"SB.ADD_CHECKLIST\"><span translate=\"SB.ADD_CHECKLIST\">Add Checklist</span></md-button></form></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"subscribe\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Subscribe\" translate=\"\" translate-attr-aria-label=\"SB.SUBSCRIBE\"><md-icon md-menu-origin=\"\" ng-if=\"vm.card.subscribed\" md-font-icon=\"icon-eye\"></md-icon><md-icon md-menu-origin=\"\" ng-if=\"!vm.card.subscribed\" md-font-icon=\"icon-eye-off\"></md-icon></md-button><md-menu-content class=\"subscribe-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.card.subscribed = !vm.card.subscribed\" aria-label=\"Subscribed\" translate=\"\" translate-attr-aria-label=\"SB.SUBSCRIBED\"><span ng-if=\"!vm.card.subscribed\" translate=\"SB.SUBSCRIBE\">Subscribe</span> <span ng-if=\"vm.card.subscribed\" translate=\"SB.UNSUBSCRIBE\">Unsubscribe</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"options\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.removeCard()\" aria-label=\"Remove Card\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE_CARD\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target=\"\"></md-icon><span translate=\"SB.REMOVE_CARD\">Remove Card</span></md-button></md-menu-item></md-menu-content></md-menu><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate=\"\" translate-attr-aria-label=\"SB.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div class=\"card-breadcrumb\" layout=\"row\" layout-align=\"start center\"><span>{{vm.board.name}}</span> <i class=\"icon-menu-right\"></i> <span>{{vm.getCardList().name}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.card.subscribed\" class=\"card-subscribe s18\" md-font-icon=\"icon-eye\"></md-icon><div class=\"card-name\"><span editable-text=\"vm.card.name\">{{vm.card.name}}</span></div></div></div><div ng-if=\"vm.card.due\" class=\"due-date\" layout=\"row\" layout-align=\"start center\"><div class=\"picker day-picker\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"year\" max-view=\"month\" start-view=\"month\"><div layout=\"row\" layout-align=\"start center\"><i class=\"s18 icon icon-calendar\"></i> <span>{{vm.card.due | date:\'mediumDate\'}}</span></div></div><div class=\"picker hour-picker\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"day\" max-view=\"hour\" start-view=\"day\"><div layout=\"row\" layout-align=\"start center\"><i class=\"s18 icon icon-clock\"></i> <span>{{vm.card.due | date:\'shortTime\'}}</span></div></div><div class=\"remove-due-date\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.card.due = \'\'\"><i class=\"s16 icon icon-close\"></i></div></div></div><div class=\"description\"><md-input-container class=\"md-block\"><label translate=\"SB.DESCRIPTION\">Description</label> <textarea ng-model=\"vm.card.description\" columns=\"1\" md-maxlength=\"150\" rows=\"5\"></textarea></md-input-container></div><div class=\"sections\"><div ng-if=\"vm.card.idLabels[0] || vm.card.idMembers[0]\" class=\"section\" layout=\"row\"><div ng-if=\"vm.card.idLabels[0]\" flex=\"\" class=\"labels\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-label-outline s18\"></i> <span class=\"section-title\" translate=\"SB.LABELS\">Labels</span></div><div class=\"section-content\"><md-chips class=\"label-chips\" ng-model=\"vm.card.idLabels\" md-autocomplete-snap=\"\" md-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedLabel\" md-search-text=\"vm.searchLabelText\" md-items=\"label in vm.labelQuerySearch(vm.searchLabelText)\" md-item-text=\"label.name\" placeholder=\"Search for a label\"><span md-highlight-text=\"vm.searchLabelText\">{{label.name}}</span></md-autocomplete><md-chip-template class=\"label-chip\" ng-class=\"\'md-\'+vm.board.labels.getById($chip).color+\'-bg\'\"><span>{{vm.board.labels.getById($chip).name}}</span></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div><div ng-if=\"vm.card.idMembers[0]\" flex=\"\" class=\"members\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span class=\"section-title\" translate=\"SB.MEMBERS\">Members</span></div><div class=\"section-content\"><md-chips class=\"member-chips\" ng-model=\"vm.card.idMembers\" md-autocomplete-snap=\"\" md-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedMember\" md-search-text=\"vm.searchText\" md-items=\"member in vm.memberQuerySearch(vm.searchText)\" md-item-text=\"member.name\" placeholder=\"Search for a member\"><span md-highlight-text=\"vm.searchText\">{{member.name}}</span></md-autocomplete><md-chip-template class=\"member-chip\"><img class=\"member-chip-avatar\" ng-src=\"{{vm.board.members.getById($chip).avatar}}\"><md-tooltip>{{vm.board.members.getById($chip).name}}</md-tooltip></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div></div><div ng-if=\"vm.card.attachments[0]\" class=\"section\"><div class=\"attachments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"section-title\" translate=\"SB.ATTACHMENTS\">Attachments</span></div><div class=\"section-content\"><div class=\"attachment\" ng-repeat=\"item in vm.card.attachments\" ng-switch=\"item.type\"><div ng-switch-when=\"image\" layout=\"row\"><div class=\"attachment-preview md-whiteframe-2dp\" ng-style=\"{\'background-image\': \'url({{item.src}})\'}\"></div><div class=\"attachment-content\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span class=\"attachment-name\">{{item.name}}</span> <i ng-if=\"vm.card.idAttachmentCover === item.id\" class=\"icon-star yellow-700-fg attachment-is-cover s18\"></i></div><span class=\"attachment-time\">{{item.time}}</span><md-menu><md-button class=\"md-raised attachment-actions-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"attachment actions\"><span layout=\"row\" layout-align=\"center center\"><span translate=\"SB.ACTIONS\">Actions</span> <i class=\"icon-chevron-down s20\"></i></span></md-button><md-menu-content><md-menu-item><md-button ng-click=\"vm.toggleCoverImage(item.id)\" aria-label=\"Toggle Cover Image\" translate=\"\" translate-attr-aria-label=\"SB.TOGGLE_COVER_IMAGE\"><span ng-if=\"vm.card.idAttachmentCover !== item.id\" translate=\"\">Make Cover</span> <span ng-if=\"vm.card.idAttachmentCover === item.id\" translate=\"\">Remove Cover</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.removeAttachment(item)\" aria-label=\"Remove Attachment\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE_ATTACHMENT\"><span translate=\"SB.REMOVE_ATTACHMENT\">Remove Attachment</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-switch-when=\"link\" layout=\"row\"><div class=\"attachment-preview md-whiteframe-2dp\" layout=\"column\" layout-align=\"center center\"><span translate=\"SB.LINK\">LINK</span></div><div class=\"attachment-content\" layout=\"column\"><span class=\"attachment-url\">{{item.url}}</span> <span class=\"attachment-time\">{{item.time}}</span></div></div></div><md-button class=\"add-attachment-button\" aria-label=\"add attachment\"><div layout=\"row\" layout-align=\"start center\"><i class=\"icon-plus s20\"></i> <span translate=\"SB.ADD_AN_ATTACHMENT\">Add an attachment</span></div></md-button></div></div></div><div ng-if=\"vm.card.checklists\" class=\"section\" ng-repeat=\"checklist in vm.card.checklists\"><div class=\"checklist\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked s18\"></i> <span flex=\"\" class=\"section-title\" editable-text=\"checklist.name\">{{checklist.name}}</span><md-menu md-position-mode=\"target-right target\" class=\"options\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.removeChecklist(checklist)\" aria-label=\"Remove Checklist\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE_CHECKLIST\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"SB.REMOVE_CHECKLIST\">Remove Checklist</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"section-content\"><div class=\"checklist-progress\" layout=\"row\" layout-align=\"start center\"><span class=\"checklist-progress-value\">{{checklist.checkItemsChecked}} / {{checklist.checkItems.length}}</span><md-progress-linear class=\"md-accent checklist-progressbar\" md-mode=\"determinate\" value=\"{{100 * checklist.checkItemsChecked / checklist.checkItems.length}}\"></md-progress-linear></div><div class=\"check-items\"><div class=\"check-item\" ng-repeat=\"checkItem in checklist.checkItems\"><md-checkbox ng-model=\"checkItem.checked\" ng-change=\"vm.updateCheckedCount(checklist)\" aria-label=\"{{checkItem.name}}\">{{checkItem.name}}</md-checkbox></div></div><form name=\"newCheckItemForm\" class=\"new-check-item-form\" ng-submit=\"vm.addCheckItem(vm[checklist.id].newCheckItem, checklist);vm[checklist.id].newCheckItem = \'\'\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"no-errors-spacer\" flex=\"\"><label layout=\"row\" layout-align=\"center\"><i class=\"icon-plus s18\"></i> <span translate=\"SB.ADD_AN_ITEM\">Add an item</span></label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm[checklist.id].newCheckItem\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Add\" translate=\"\" translate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.ADD\">Add</span></md-button></form></div></div></div><div class=\"section\"><div class=\"comments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"section-title\" translate=\"SB.COMMENTS\">Comments</span></div><div class=\"section-content\"><form name=\"cardCommentForm\" ng-submit=\"vm.addNewComment(vm.newCommentText); vm.newCommentText =\'\'\" class=\"comment new-comment\" layout=\"column\" layout-align=\"start\" no-validate=\"\"><div layout=\"row\"><img class=\"comment-member-avatar\" src=\"assets/images/avatars/profile.jpg\"><md-input-container flex=\"\" md-no-float=\"\"><textarea ms-scroll=\"\" placeholder=\"Write a comment..\" ng-model=\"vm.newCommentText\" required=\"\" translate=\"\" translate-attr-placeholder=\"SB.WRITE_A_COMMENT\"></textarea></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"cardCommentForm.$invalid || cardCommentForm.$pristine\" aria-label=\"Add\"><span translate=\"SB.ADD\">Add</span></md-button></div></form><div class=\"comment\" layout=\"row\" ng-repeat=\"comment in vm.card.comments\"><img class=\"comment-member-avatar\" ng-src=\"{{vm.board.members.getById(comment.idMember).avatar}}\"><div layout=\"column\"><div class=\"comment-member-name\">{{vm.board.members.getById(comment.idMember).name}}</div><div class=\"comment-bubble\">{{comment.message}}</div><div class=\"comment-time secondary-text\">{{comment.time}}</div></div></div></div></div></div><div ng-if=\"vm.card.activities[0]\" class=\"section\"><div class=\"activities\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-format-list-bulleted s18\"></i> <span class=\"section-title\" translate=\"SB.ACTIVITY\">Activity</span></div><div class=\"section-content\"><div class=\"activity\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"activity in vm.card.activities\"><img class=\"activity-member-avatar\" ng-src=\"{{vm.board.members.getById(activity.idMember).avatar}}\"><div class=\"activity-member-name\">{{vm.board.members.getById(activity.idMember).name}}</div><div class=\"activity-message\">{{activity.message}}</div><div class=\"activity-time secondary-text\">{{activity.time}}</div></div></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><span flex=\"\" class=\"menu-title\" translate=\"SB.FILTER_CARDS\">Filter Cards</span><md-button ng-if=\"vm.filteringIsOn()\" ng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"SB.CLEAR_FILTER\">Clear Filters</span></md-tooltip></md-button></div></md-toolbar><md-content class=\"\" ms-scroll=\"\"><md-list><md-subheader class=\"md-no-sticky\" translate=\"SB.FILTER_BY_CARD_NAME\">Filter by Card Name</md-subheader><md-list-item><input flex=\"\" placeholder=\"Type Card Name\" type=\"text\" ng-model=\"vm.cardFilters.name\" translate=\"\" translate-attr-placeholder=\"SB.TYPE_CARD_NAME\"></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\" translate=\"SB.FILTER_BY_LABELS\">Filter by Labels</md-subheader><md-list-item class=\"label\" ng-repeat=\"label in vm.labels\" ng-click=\"vm.toggleInArray(label.id, vm.cardFilters.labels)\"><md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i class=\"icon-check s16\" ng-if=\"vm.exists(label.id, vm.cardFilters.labels)\"></i></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\" translate=\"SB.FILTER_BY_MEMBERS\">Filter by Members</md-subheader><md-list-item class=\"member\" ng-repeat=\"member in vm.members\" ng-click=\"vm.toggleInArray(member.id, vm.cardFilters.members)\" aria-label=\"Toggle Member\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p class=\"member-name\">{{ member.name }}</p><i class=\"icon-check s16\" ng-if=\"vm.exists(member.id, vm.cardFilters.members)\"></i></md-list-item></md-list></md-content>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button ng-hide=\"vm.selectedMenu === \'Settings\'\" class=\"md-icon-button\" ng-click=\"vm.selectedMenu = \'Settings\'\" aria-label=\"back\" translate=\"\" translate-attr-aria-label=\"SB.BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span flex=\"\" class=\"menu-title\">{{vm.selectedMenu}}</span></div></md-toolbar><md-content ng-show=\"vm.selectedMenu === \'Settings\'\" class=\"animate-slide-right settings\" ms-scroll=\"\" ms-sidenav-helper=\"\"><md-list><md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'Board Color\'\"><md-icon md-font-icon=\"icon-format-color-fill\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.BOARD_COLOR\">Board Color</p></md-list-item><md-list-item class=\"item\" ng-click=\"vm.board.settings.cardCoverImages = !vm.board.settings.cardCoverImages\"><md-icon md-font-icon=\"icon-image-area\" class=\"s18\"></md-icon><p flex=\"\" class=\"title\" translate=\"SB.CARD_COVER_IMAGES\">Card Cover Images</p><md-icon ng-show=\"vm.board.settings.cardCoverImages\" md-font-icon=\"icon-check\" class=\"s18\"></md-icon></md-list-item><md-list-item class=\"item\" ng-click=\"vm.board.settings.subscribed = !vm.board.settings.subscribed\"><md-icon md-font-icon=\"icon-eye\" class=\"s18\"></md-icon><p flex=\"\" class=\"title\" translate=\"SB.SUBSCRIBE\">Subscribe</p><md-icon ng-show=\"vm.board.settings.subscribed\" md-font-icon=\"icon-check\" class=\"s18\"></md-icon></md-list-item><md-list-item class=\"item\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.COPY_BOARD\">Copy Board</p></md-list-item><md-list-item class=\"item\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.DELETE_BOARD\">Delete Board</p></md-list-item><md-divider></md-divider><md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'Labels\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-label\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.LABELS\">Labels</p></md-list-item><md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'Members\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.MEMBERS\">Members</p></md-list-item></md-list></md-content><md-content ng-show=\"vm.selectedMenu === \'Board Color\'\" class=\"animate-slide-left board-color-selection\"><div layout=\"column\" layout-fill=\"\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html\'\" ng-controller=\"ColorMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'Labels\'\" class=\"animate-slide-left labels\"><div layout=\"column\" layout-fill=\"\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html\'\" ng-controller=\"LabelsMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'Members\'\" class=\"animate-slide-left members\"><div layout=\"column\" layout-fill=\"\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html\'\" ng-controller=\"MembersMenuController as vm\"></div></md-content>");
$templateCache.put("app/main/apps/scrumboard/views/board/board-view.html","<div id=\"board\" ng-class=\"vm.board.settings.color+\'-100-bg\'\" ui-sortable=\"vm.sortableListOptions\" ng-model=\"vm.board.lists\" layout=\"row\"><div class=\"list-wrapper\" ng-repeat=\"list in vm.board.lists track by list.id\"><div class=\"list md-whiteframe-1dp\" layout=\"column\"><div class=\"list-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"list-header-name\"><span editable-text=\"list.name\">{{list.name}}</span></div><md-menu md-offset=\"0 48px\" class=\"options list-header-option-button\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.removeList($event,list)\" aria-label=\"Remove List\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE_LIST\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target=\"\"></md-icon><span translate=\"SB.REMOVE_LIST\">Remove List</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"list-content\" ms-scroll=\"\"><div class=\"list-cards\" ui-sortable=\"vm.sortableCardOptions\" ng-model=\"list.idCards\"><div ng-if=\"cardId\" class=\"list-card md-whiteframe-3dp\" ng-repeat=\"cardId in list.idCards | filter: vm.cardFilter track by $index\" ng-click=\"vm.openCardDialog($event, cardId)\"><div ng-if=\"vm.board.settings.cardCoverImages && vm.board.cards.getById(cardId).idAttachmentCover\" class=\"list-card-cover\"><img ng-src=\"{{vm.board.cards.getById(cardId).attachments.getById(vm.board.cards.getById(cardId).idAttachmentCover).src}}\"></div><div class=\"list-card-details\"><div class=\"list-card-sort-handle\"><md-icon md-font-icon=\"icon-cursor-move\" class=\"icon s16\"></md-icon></div><div ng-if=\"vm.board.cards.getById(cardId).idLabels.length > 0\" class=\"list-card-labels\" layout=\"row\" layout-wrap=\"\"><span class=\"list-card-label\" ng-class=\"\'md-\'+vm.board.labels.getById(labelId).color+\'-bg\'\" ng-repeat=\"labelId in vm.board.cards.getById(cardId).idLabels\"><md-tooltip>{{vm.board.labels.getById(labelId).name}}</md-tooltip></span></div><div class=\"list-card-name\">{{vm.board.cards.getById(cardId).name}}</div><div ng-if=\"vm.board.cards.getById(cardId).due || vm.board.cards.getById(cardId).checkItems\" class=\"list-card-badges\" layout=\"row\" layout-align=\"start center\"><span class=\"badge due-date\" ng-class=\"{\'overdue\': vm.isOverdue(vm.board.cards.getById(cardId).due)}\" ng-if=\"vm.board.cards.getById(cardId).due\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-clock s16\"></i> <span>{{vm.board.cards.getById(cardId).due | date:\'mediumDate\'}}</span></span><span ng-if=\"vm.board.cards.getById(cardId).checkItems\" class=\"badge check-items\" ng-class=\"{\'completed\': vm.board.cards.getById(cardId).checkItemsChecked === vm.board.cards.getById(cardId).checkItems}\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked-circle s16\"></i> <span>{{vm.board.cards.getById(cardId).checkItemsChecked}}</span> <span>/</span> <span>{{vm.board.cards.getById(cardId).checkItems}}</span></span></div><div ng-if=\"vm.board.cards.getById(cardId).idMembers.length > 0\" class=\"list-card-members\" layout=\"row\"><div class=\"list-card-member\" ng-repeat=\"memberId in vm.board.cards.getById(cardId).idMembers\"><img class=\"list-card-member-avatar\" ng-src=\"{{vm.board.members.getById(memberId).avatar}}\"><md-tooltip><div class=\"name\">{{ vm.board.members.getById(memberId).name}}</div></md-tooltip></div></div></div><div class=\"list-card-footer\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span ng-if=\"vm.board.cards.getById(cardId).subscribed\" class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-eye s18\"></i></span><span ng-if=\"vm.board.cards.getById(cardId).description !== \'\'\" class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-document s18\"></i></span></div><div layout=\"row\" layout-align=\"end center\"><span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).attachments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"value\">{{vm.board.cards.getById(cardId).attachments.length}}</span></span><span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).comments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"value\">{{vm.board.cards.getById(cardId).comments.length}}</span></span></div></div></div></div></div><div class=\"list-footer list-add-card\" ms-sb-add-card=\"\" ms-list-id=\"list.id\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\"><div><i class=\"icon-plus s20\"></i></div><span transalte=\"SB.ADD_A_CARD\">Add a card</span></div></div></div><div class=\"new-list-wrapper\"><div class=\"list new-list md-whiteframe-1dp\"><span editable-text=\"vm.newListName\" e-form=\"newListForm\" onaftersave=\"vm.addNewList()\"></span><md-button class=\"new-list-form-button\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><div layout=\"row\" layout-align=\"start center\"><i class=\"icon-plus md-red-bg\"></i> <span translate=\"SB.ADD_A_LIST\">Add a list</span></div></md-button></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/boards/boards-view.html","<div id=\"boards\" class=\"md-accent-bg\" layout=\"column\" flex=\"\"><div id=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex=\"\"><h1 translate=\"SB.SCRUMBOARD_APP\">Scrumboard App</h1><div class=\"board-list\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" ui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-trello\" class=\"icon s64\"></md-icon><div class=\"board-name\">{{board.name}}</div></div><div class=\"board-list-item add-new-board\" layout=\"column\" layout-align=\"center center\" ui-sref=\"app.scrumboard.boards.addBoard\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add new board</div></div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/calendar-view.html","<div id=\"board-calendar\" class=\"page-layout simple right-sidenav\" flex=\"\" layout=\"row\" ng-class=\"vm.board.settings.color+\'-100-bg\'\"><md-sidenav class=\"sidenav scheduled-tasks-sidenav md-sidenav-left\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"scheduled-tasks-sidenav\" ng-include=\"\'app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div id=\"calendar\" class=\"md-whiteframe-2dp\" flex=\"\" layout=\"column\" ng-class=\"vm.currentMonthShort\"><div class=\"calendar-header\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><md-button hide-gt-md=\"\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'scheduled-tasks-sidenav\')\" aria-label=\"Scheduled Cards Sidenav\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><md-tooltip><span translate=\"SB.SCHEDULED_CARDS\">Scheduled Cards</span></md-tooltip></md-button><div class=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" aria-label=\"Previous\" translate=\"\" translate-attr-aria-label=\"SB.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate=\"\" translate-attr-aria-label=\"SB.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate=\"\" translate-attr-aria-label=\"SB.TODAY\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"SB.TODAY\">Today</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate=\"\" translate-attr-aria-label=\"SB.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span translate=\"SB.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate=\"\" translate-attr-aria-label=\"SB.WEEK\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"SB.WEEK\">Week</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate=\"\" translate-attr-aria-label=\"SB.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"SB.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"calendar-main\" ms-scroll=\"\" flex=\"\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.eventSources\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/apps/todo/dialogs/task/task-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label translate=\"TODO.TITLE\">Title</label> <input name=\"title\" ng-model=\"vm.task.title\" required=\"\"><div ng-messages=\"taskForm.title.$error\" ng-show=\"taskForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><div class=\"tags\"><label translate=\"TODO.TAGS\">Tags</label><md-chips ng-model=\"vm.task.tags\" md-transform-chip=\"vm.newTag($chip)\"><md-chip-template><span ng-if=\"$chip.color\" class=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.label}}</span></md-chip-template></md-chips></div><div layout-sm=\"column\" layout=\"row\"><div flex=\"\" class=\"date-container\"><label translate=\"TODO.START_DATE\">Start Date</label><md-datepicker flex=\"\" ng-model=\"vm.task.startDate\" md-placeholder=\"Start Date\"></md-datepicker></div><div flex=\"\" class=\"date-container\"><label translate=\"TODO.DUE_DATE\">Due Date</label><md-datepicker flex=\"\" ng-model=\"vm.task.dueDate\" md-placeholder=\"Due Date\"></md-datepicker></div></div><div class=\"notes\"><label translate=\"TODO.NOTES\">Notes</label><text-angular ng-model=\"vm.task.notes\"></text-angular></div><div class=\"attachment-list\"><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-2.doc</span> <span class=\"size\">(12 Kb)</span></div><md-button class=\"md-icon-button\"><md-icon md-font-icon=\"icon-close\" aria-label=\"delete attachment\" class=\"s16\"></md-icon></md-button></div><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-1.jpg</span> <span class=\"size\">(350 Kb)</span></div><md-button class=\"md-icon-button\" aria-label=\"Delete attachment\" translate=\"\" translate-attr-aria-label=\"TODO.DELETE_ATTACHMENT\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newTask\" ng-click=\"vm.saveTask()\" class=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"SAVE\" translate=\"TODO.SAVE\" translate-attr-aria-label=\"TODO.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newTask\" ng-click=\"vm.addNewTask()\" class=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"TODO.ADD_TASK\" translate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button><md-button class=\"md-icon-button\" aria-label=\"Attach file\" translate=\"\" translate-attr-aria-label=\"TODO.ATTACH_FILE\"><md-icon md-font-icon=\"icon-paperclip\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Insert picture\" translate=\"\" translate-attr-aria-label=\"TODO.INSERT_PICTURE\"><md-icon md-font-icon=\"icon-file-image-box\"></md-icon></md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteTask($event)\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/todo/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"TODO.TO_DO\">To-Do</span></div><md-select class=\"project-selection simplified\" ng-model=\"vm.selectedProject\" placeholder=\"Select Project\"><md-option ng-repeat=\"(project, title) in vm.projects\" value=\"{{project}}\">{{title}}</md-option></md-select></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"add-task-button\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.openTaskDialog($event)\" aria-label=\"ADD TASK\" translate=\"TODO.ADD_TASK\" translate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"All Tasks\" translate=\"\" translate-attr-aria-label=\"TODO.ALL_TASKS\" ng-class=\"{\'selected\':vm.showAllTasks}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.ALL_TASKS\">All Tasks</span></div></md-button><div class=\"item subheader\" translate=\"TODO.FILTERS\">Filters</div><md-button class=\"item\" aria-label=\"Starred\" translate=\"\" translate-attr-aria-label=\"TODO.STARRED\" ng-click=\"vm.toggleFilterWithEmpty(\'starred\')\" ng-class=\"{\'selected\':vm.taskFilters.starred}\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.STARRED\">Starred</span></md-button><md-button class=\"item\" aria-label=\"Priority\" translate=\"\" translate-attr-aria-label=\"TODO.PRIORITY\" ng-click=\"vm.toggleFilterWithEmpty(\'important\')\" ng-class=\"{\'selected\':vm.taskFilters.important}\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.PRIORITY\">Priority</span></md-button><md-button class=\"item\" aria-label=\"Scheduled\" translate=\"\" translate-attr-aria-label=\"TODO.SCHEDULED\" ng-click=\"vm.toggleFilterWithEmpty(\'dueDate\')\" ng-class=\"{\'selected\':vm.taskFilters.dueDate}\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.SCHEDULED\">Scheduled</span></md-button><md-button class=\"item\" aria-label=\"Today\" translate=\"\" translate-attr-aria-label=\"TODO.TODAY\" ng-click=\"vm.toggleFilterWithEmpty(\'startDate\')\" ng-class=\"{\'selected\':vm.taskFilters.startDate}\"><md-icon md-font-icon=\"icon-calendar-today\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.TODAY\">Today</span></md-button><md-button class=\"item\" aria-label=\"Done\" translate=\"\" translate-attr-aria-label=\"TODO.DONE\" ng-click=\"vm.toggleFilterWithEmpty(\'completed\')\" ng-class=\"{\'selected\':vm.taskFilters.completed}\"><md-icon md-font-icon=\"icon-check\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DONE\">Done</span></md-button><md-button class=\"item\" aria-label=\"Deleted\" translate=\"\" translate-attr-aria-label=\"TODO.DELETED\" ng-click=\"vm.toggleFilter(\'deleted\')\" ng-class=\"{\'selected\':vm.taskFilters.deleted}\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DELETED\">Deleted</span></md-button><div class=\"item subheader\" translate=\"TODO.TAGS\">Tags</div><md-button class=\"tag item\" aria-label=\"tag {{tag.label}}\" ng-repeat=\"tag in vm.tags\" ng-click=\"vm.toggleTagFilter(tag)\" ng-class=\"{\'selected\':vm.isTagFilterExists(tag)}\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : tag.color}\"></md-icon><span class=\"title\">{{tag.label}}</span></md-button></div></md-content>");
$templateCache.put("app/main/apps/todo/views/list/list-view.html","<div class=\"todo-items\" ng-sortable=\"vm.sortableOptions\" ng-model=\"vm.tasks\" ng-class=\"{\'sortable\': vm.taskOrder === \'\'}\"><div class=\"todo-item\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.openTaskDialog($event, task)\" ng-repeat=\"task in vm.tasks | orderBy:vm.taskOrder:vm.taskOrderDescending | filter:global.search | filter:vm.taskFilters.search | filterByTags:vm.taskFilters.tags | filter:{\'completed\': vm.taskFilters.completed} | filter:{\'deleted\': vm.taskFilters.deleted} | filter:{\'important\': vm.taskFilters.important} | filter:{\'starred\':vm.taskFilters.starred} | filter:vm.filterByStartDate | filter:vm.filterByDueDate track by $index\" ng-class=\"{\'starred\': task.starred, \'selected\': task.selected, \'completed\': task.completed}\"><div class=\"handle\" ng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div><md-checkbox class=\"no-label\" ng-checked=\"task.completed\" ng-click=\"vm.toggleCompleted(task, $event)\" aria-label=\"{{task.completed ? \'Not completed\' : \'Completed\'}}\"></md-checkbox><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"info\" flex=\"\"><div class=\"title\">{{task.title}}</div><div class=\"notes\">{{task.notes}}</div><div class=\"tags\" layout=\"row\" layout-align=\"start center\"><div class=\"tag\" layout=\"row\" layout-align=\"start center\" data-ng-repeat=\"tag in task.tags\"><div class=\"tag-color\" ng-style=\"{\'background-color\': tag.color}\"></div><div class=\"tag-label\">{{tag.label}}</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"is-important red-600-fg\" ng-if=\"task.important\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"is-starred amber-600-fg\" ng-if=\"task.starred\"></md-icon><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"task.completed = !task.completed\" aria-label=\"Toggle done\" translate-attr-aria-label=\"TODO.TOGGLE_DONE\"><md-icon ng-class=\"task.completed === false ? \'grey-fg\' : \'blue-fg\'\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"s18\"></md-icon><span ng-show=\"!task.completed\" translate=\"TODO.MARK_AS_DONE\">Mark as done</span> <span ng-show=\"task.completed\" translate=\"TODO.MARK_AS_UNDONE\">Mark as undone</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"task.important = !task.important\" aria-label=\"Toggle important\" translate-attr-aria-label=\"TODO.TOGGLE_IMPORTANT\"><md-icon ng-class=\"task.important === false ? \'grey-fg\' : \'red-600-fg\'\" md-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon><span ng-show=\"!task.important\" translate=\"TODO.MARK_AS_IMPORTANT\">Mark as important</span> <span ng-show=\"task.important\" translate=\"TODO.REMOVE_IMPORTANT\">Remove important</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"task.starred = !task.starred\" aria-label=\"Toggle star\" translate-attr-aria-label=\"TODO.TOGGLE_STAR\"><md-icon ng-class=\"task.starred === false ? \'grey-fg\' : \'amber-600-fg\'\" md-font-icon=\"icon-star\" class=\"s18\"></md-icon><span ng-show=\"!task.starred\" translate=\"TODO.ADD_STAR\">Add star</span> <span ng-show=\"task.starred\" translate=\"TODO.REMOVE_STAR\">Remove star</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/CSS/button.html","<div class=\"doc-content theming\"><h1 id=\"-lt-md-button-gt-\">&lt;md-button&gt;</h1><p>Below is a snapshot of the Angular Material <strong>button</strong> component demos with the default themes and standard options:</p><p><img src=\"https://cloud.githubusercontent.com/assets/210413/7947020/fafde934-093f-11e5-9584-27eb2deedd0f.png\" alt=\"buttonsdemo\"></p><p><br></p><h3 id=\"css-styles\">CSS Styles</h3><p>The base CSS class for all <code>&lt;md-button&gt;</code> components is <code>.md-button</code>:</p><hljs lang=\"css\">.md-button { padding: 0 6px 0 6px; margin: 6px 8px 6px 8px; min-width: 88px; border-radius: 3px; font-size: 14px; text-align: center; text-transform: uppercase; text-decoration:none; border: none; outline: none; }</hljs><p>When defining custom CSS overrides, developers should create their own CSS class. For example, to define a <code>.btn1</code> override to <strong>md-button</strong> use:</p><hljs lang=\"css\">.btn1 { // your custom overrides here }</hljs><hljs lang=\"html\"><md-button class=\"btn1\" ng-click=\"acceptOffer();\">Accept</md-button></hljs><p><br></p><h3 id=\"theme-requirements\">Theme Requirements</h3><p>All Angular Material components have specific CSS rules constructed using the theme name and theme-class overrides. For the <strong>Default</strong> theme, however, these rules are added to the components styles using the <code>.md-default-theme</code> class. If, however, you have configured a custom theme called <code>companyX</code> that is <strong>NOT</strong> the default theme, then any CSS overrides <strong>must</strong> use fully-specified classname. For <code>&lt;md-button&gt;</code> the <strong>fully-specified classname</strong> will be <code>.md-button.md-companyX-theme.btn1</code>.</p><hljs lang=\"css\">.md-button.md-companyX-theme.btn1 { } .md-button.md-companyX-theme.md-primary.btn1 { } .md-button.md-companyX-theme.md-accent.btn1 { } .md-button.md-companyX-theme.md-warn.btn1 { }</hljs><p><br></p><h2 id=\"flat-buttons\">Flat Buttons</h2><p><img src=\"https://cloud.githubusercontent.com/assets/210413/7945984/bda14884-0939-11e5-9196-131ded20ca77.png\" alt=\"mdbuttonflatdefault3\"></p><hljs lang=\"html\"><md-button>Button</md-button></hljs><hljs lang=\"css\">.md-button { color : currentColor; } .md-button:not([disabled]):hover { background-color: rgba(158, 158, 158, 0.2); } .md-button[disabled] { color : rgba(0, 0, 0, 0.26); background-color: transparent; }</hljs><p><br></p><h4 id=\"custom-css-overrides\">Custom CSS Overrides</h4><p><img src=\"https://cloud.githubusercontent.com/assets/210413/7945987/c1b1c700-0939-11e5-879c-ba804ca03267.png\" alt=\"mdbuttonflatdefault_overrides2\"></p><hljs lang=\"html\"><md-button class=\"btn1\">Button</md-button></hljs><hljs lang=\"css\">.btn1 { color : rgb(49, 46, 46); background-color: rgba(255, 222, 121, 0.96); border-radius: 10px 0 0 10px; font-size: 16px; } .btn1:not([disabled]):hover { background-color: rgba(107, 103, 91, 0.96); color: white; } .btn1[disabled] { color : rgb(187, 187, 187); background-color: rgba(230, 230, 229, 0.96); }</hljs><p><br></p><h2 id=\"raised-buttons\">Raised Buttons</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7254163/fe898728-e849-11e4-943b-a9cd88ec9573.PNG\" alt=\"raisedbutton\"></p><p>Add the <code>.md-raised</code> class to create a raised button:</p><hljs lang=\"html\"><md-button class=\"md-raised\">Button</md-button></hljs><hljs lang=\"css\">.md-button.md-raised:not([disabled]) { box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26); }</hljs><p><br></p><h2 id=\"cornered-buttons\">Cornered buttons</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7254379/682592ac-e84b-11e4-8d33-78314cea8bda.PNG\" alt=\"corneredbutton\"></p><p>Add the <code>.md-cornered</code> class to create a button with corners:</p><hljs lang=\"html\"><md-button class=\"md-raised md-cornered\">Button</md-button></hljs><hljs lang=\"css\">.md-button.md-cornered { border-radius: 0; }</hljs><p><br></p><h2 id=\"default-fab-button\">Default FAB Button</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7254736/8fec7ee8-e84d-11e4-9cf9-58ea9221c3c2.PNG\" alt=\"floatingbutton\"></p><p>Add the <code>.md-fab</code> class in order to create a floating action button (aka FAB):</p><hljs lang=\"html\"><md-button class=\"md-fab\" aria-label=\"Eat cake\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/cake.svg\"></md-icon></md-button></hljs><hljs lang=\"css\">.md-button.md-fab { line-height: 5.6rem; min-width: 0; width: 5.6rem; height: 5.6rem; border-radius: 50%; }</hljs><p><br></p><h2 id=\"mini-fab-button\">Mini FAB Button</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7273617/1fcca280-e8fe-11e4-9588-231a9e860be1.PNG\" alt=\"minibutton\"></p><p>Add the <code>.md-mini</code> class in order to create small, mini-FAB buttons:</p><hljs lang=\"html\"><md-button class=\"md-fab md-mini\" aria-label=\"Eat cake\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/cake.svg\"></md-icon></md-button></hljs><hljs lang=\"css\">.md-button.md-fab.md-mini { line-height: 4rem; width: 4rem; height: 4rem; }</hljs><p><br></p><h2 id=\"icon-button-using-svgs\">Icon button using SVGs</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7273908/d701bd8a-e900-11e4-84c7-44c580c7372d.PNG\" alt=\"iconbutton\"></p><p>Create icon buttons by adding the <code>.md-icon-button</code> class and the <code>&lt;md-icon ...&gt;</code> component:</p><hljs lang=\"html\"><md-button class=\"md-icon-button md-primary\" aria-label=\"Settings\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/menu.svg\"></md-icon></md-button></hljs><hljs lang=\"css\">.md-button.md-icon-button { margin: 0 0.6rem; height: 4.8rem; min-width: 0; line-height: 4.8rem; padding-left: 0; padding-right: 0; width: 4.8rem; }</hljs><p><br></p><h2 id=\"icon-button-using-font-icons\">Icon button using Font-icons</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7670414/f57721ba-fcab-11e4-9a22-67970063797c.PNG\" alt=\"fonticonbutton\"></p><p>Here is another example of a button with font icons:</p><hljs lang=\"html\"><md-button><md-icon md-font-icon=\"icon-home\" ng-style=\"{color: \'green\', \'font-size\':\'36px\', height:\'36px\'}\"></md-icon></md-button></hljs><p><br></p><h2 id=\"grouping-with-css-overrides\">Grouping with CSS Overrides</h2><p><img src=\"https://cloud.githubusercontent.com/assets/210413/7961138/1b48bb16-09cb-11e5-9283-bdda28b8bb66.png\" alt=\"mdbuttongroup\"></p><p>Using the customization approaches documented above, we can easily create a mdButtonGroup:</p><hljs lang=\"html\"><section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-button class=\"groupX left\">Apple</md-button><md-button class=\"groupX middle\">Samsung</md-button><md-button class=\"groupX middle\">Sony</md-button><md-button class=\"groupX right\">B&amp;O</md-button></section></hljs><hljs lang=\"css\">.groupX { font-size: 16px; margin: 20px 0; padding: 3px 15px 3px 15px; color: rgb(49, 46, 46); background-color: rgba(224, 224, 224, 0.96); text-transform: none; font-weight: 400; min-width:100px; } .md-button.left { border-radius: 10px 0 0 10px; } .md-button.middle { border-radius: 0; border-left: 1px solid rgba(230, 230, 230, 0.96); border-right: 1px solid rgba(230, 230, 230, 0.96); } .md-button.right { border-radius: 0 10px 10px 0; } .md-button:not([disabled]):hover { background-color: rgba(193, 193, 193, 0.96); color: rgba(44, 65, 164, 0.96); transition: 0.3s; }</hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/CSS/checkbox.html","<div class=\"doc-content theming\"><h2>CSS Styles</h2><p>The css decalaration of the <code>&lt;md-checkbox&gt;</code> component is:</p><hljs lang=\"css\">md-checkbox { margin: 8px; cursor: pointer; padding-left: 18px; padding-right: 0; line-height: 26px; min-width: 18px; min-height: 18px; }</hljs><p><br></p><h3>Ink color</h3><p>In order to change the color when the checkbox is checked:</p><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/8035909/b2130da0-0dfc-11e5-932f-4424d3b46d5b.PNG\" alt=\"greencheckbox\"></p><hljs lang=\"html\"><md-checkbox class=\"green\">Green Checkbox</md-checkbox></hljs><hljs lang=\"css\">md-checkbox.md-checked.green .md-icon { background-color: rgba(0, 255, 0, 0.87); }</hljs><p><br></p><h3>Disabled</h3><p>In order to change the color when a disabled checkbox is checked:</p><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/8036177/dc941a86-0dfe-11e5-8892-ac19ec6926fe.PNG\" alt=\"checkboxdisabledred\"><br></p><hljs lang=\"html\"><md-checkbox ng-disabled=\"true\" class=\"red\" ng-model=\"data.cb4\" ng-init=\"data.cb4=true\">Checkbox: Disabled, Checked</md-checkbox></hljs><hljs lang=\"css\">md-checkbox.md-checked[disabled].red .md-icon { background-color: rgba(255, 0, 0, 0.26); }</hljs><p><br></p><h3>Borders</h3><p>In order to add a custom border do the following:</p><img src=\"https://cloud.githubusercontent.com/assets/1292882/8037214/388dd40c-0e05-11e5-82a7-4bfa2541e968.PNG\" alt=\"checkboxcustomborder\"><br><br><hljs lang=\"html\"><div><md-checkbox ng-model=\"data.cb2\" aria-label=\"Checkbox 2\" ng-true-value=\"\'yup\'\" ng-false-value=\"\'nope\'\">Default Border</md-checkbox></div><div><md-checkbox ng-model=\"data.cb2\" aria-label=\"Checkbox 2\" ng-true-value=\"\'yup\'\" class=\"dotted\" ng-false-value=\"\'nope\'\">Custom Border</md-checkbox></div></hljs><hljs lang=\"css\">md-checkbox.dotted .md-icon { border-width: 1px; border-style: dashed; }</hljs><br><h3>Bi-Di</h3><p>The mdCheckbox directive supports bi-directional specifiers in the <code>&lt;html dir=&quot;rtl&quot;&gt;</code> tag:</p><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/8036091/fb40bcf6-0dfd-11e5-8319-25e68939d1a3.PNG\" alt=\"checkboxrtl\"></p></div>");
$templateCache.put("app/main/components/material-docs/partials/CSS/typography.html","<div class=\"doc-content theming\"><p>Angular Material provides typography CSS classes you can use to create visual consistency across your application.</p><p><a href=\"http://www.google.com/design/spec/style/typography.html\">Reference the Material Design specification for Typography.</a></p><section class=\"demo-container\"><md-toolbar class=\"demo-toolbar\"><div class=\"md-toolbar-tools\"><h3>Heading Styles</h3></div></md-toolbar><div class=\"md-whiteframe-z1 docs-list\"><p style=\"margin-top: 0;\">To preserve <a href=\"http://webaim.org/techniques/semanticstructure/\">semantic structures</a>, you should style the <code>&lt;h1&gt;</code> - <code>&lt;h6&gt;</code> heading tags with the styling classes shown below:</p><div layout=\"row\" class=\"docs-descriptions\"><h4 class=\"md-body-1\" flex=\"25\" id=\"headings-selectors\">Selectors</h4><h4 class=\"md-body-1\" id=\"headings-output\">Output</h4></div><md-divider></md-divider><ul><li layout=\"column\" layout-gt-md=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-display-4</code></span><h5 aria-describedby=\"headings-output\" class=\"md-display-4 docs-output\">Light 112px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-display-3</code></span><h5 aria-describedby=\"headings-output\" class=\"md-display-3 docs-output\">Regular 56px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-display-2</code></span><h5 aria-describedby=\"headings-output\" class=\"md-display-2 docs-output\">Regular 45px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-display-1</code></span><h5 aria-describedby=\"headings-output\" class=\"md-display-1 docs-output\">Regular 34px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-headline</code></span><h5 aria-describedby=\"headings-output\" class=\"md-headline docs-output\">Regular 24px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-title</code></span><h5 aria-describedby=\"headings-output\" class=\"md-title docs-output\">Medium 20px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-subhead</code></span><h5 aria-describedby=\"headings-output\" class=\"md-subhead docs-output\">Regular 16px</h5></li></ul><h4 class=\"md-title\">Example</h4><hljs lang=\"html\"><h1 class=\"md-display-3\">Headline</h1><h2 class=\"md-display-1\">Headline</h2><h3 class=\"md-headline\">Headline</h3></hljs><br><span class=\"md-body-1\">Note: Base font size is <code>10px</code> for easy rem units (1.2rem = 12px). Body font size is <code>14px</code>. sp = scalable pixels.</span></div></section><section class=\"demo-container\"><md-toolbar class=\"demo-toolbar\"><div class=\"md-toolbar-tools\"><h3>Body Copy</h3></div></md-toolbar><div class=\"md-whiteframe-z1 docs-list\"><div layout=\"row\" class=\"docs-descriptions\"><h4 class=\"md-body-1\" flex=\"25\" id=\"body-selectors\">Selectors</h4><h4 class=\"md-body-1\" id=\"body-output\">Output</h4></div><md-divider></md-divider><ul><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>.md-body-1</code><br></span><p class=\"docs-output md-body-1\" aria-describedby=\"body-output\">Regular 14px</p></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>\n          .md-body-2</code></span><p class=\"md-body-2 docs-output\" aria-describedby=\"body-output\">Medium 14px</p></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>.md-button</code></span><div class=\"docs-output\" aria-describedby=\"body-output\"><md-button class=\"md-raised\" style=\"margin-left:0; margin-right:0;\">Medium 14px</md-button></div></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>.md-caption</code><br></span><div class=\"docs-output\" aria-describedby=\"body-output\"><small class=\"md-caption\">Regular 12px</small></div></li></ul><h4 class=\"md-title\">Examples</h4><hljs lang=\"html\"><p class=\"md-body-2\">Body copy with medium weight.</p><md-button>Button</md-button><p class=\"md-body-1\">Regular body copy <small class=\"md-caption\">with small text</small>.</p><span class=\"md-caption\">Caption</span></hljs></div></section></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/01_introduction.html","<div class=\"doc-content theming\"><p>Material Design is a visual language with specifications for innovative user experiences (UX) and user interface (UI) elements. Themes convey meaning through color, tones, and contrasts, similar to how Layouts convey meaning through keylines and alignments.</p><p>Theme <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-palette\"><strong>color palettes</strong></a>, alphas, and shadows deliver a consistent tone to your application and a unified feel for all Angular Material UI components.</p><p>Theming allows changing the color of your Angular Material application. If you need more custom styling (such as layout changes including padding, margins, etc) you will need to either write CSS rules with custom selectors, or build a custom version of the <code>angular-material.css</code> file using SASS and custom variables.</p><p><img src=\"https://cloud.githubusercontent.com/assets/210413/4816236/bf7783dc-5edd-11e4-88ef-1f8b6e87e1d7.png\" alt=\"color palette\" style=\"max-width: 100%;\"></p><h2 id=\"theming-approach\">Theming Approach</h2><p>Angular Material makes it easy to design an app which follows the Material style guide&#39;s suggested design patterns:</p><blockquote><p>Limit your selection of colors by choosing three color hues from the primary palette and one accent color from the secondary palette. The accent color may or may not need fallback options.</p></blockquote><p>This concept is central to how Angular Material approaches theming.</p><h2 id=\"important-terms\">Important Terms</h2><h3 id=\"hues-shades\">Hues / Shades</h3><p>A hue/shade is a single color within a palette.</p><h3 id=\"palettes\">Palettes</h3><p>A palette is a collection of hues. By default, Angular Material ships with all palettes from the material design spec built in. Valid palettes include:</p><ul><li>red</li><li>pink</li><li>purple</li><li>deep-purple</li><li>indigo</li><li>blue</li><li>light-blue</li><li>cyan</li><li>teal</li><li>green</li><li>light-green</li><li>lime</li><li>yellow</li><li>amber</li><li>orange</li><li>deep-orange</li><li>brown</li><li>grey</li><li>blue-grey</li></ul><h3 id=\"color-intentions\">Color Intentions</h3><p>A color intention is a mapping of a palette for a given intention within your application.</p><p>Valid color intentions in Angular Material include:</p><ul><li><em>primary</em> - used to represent primary interface elements for a user</li><li><em>accent</em> - used to represent secondary interface elements for a user</li><li><em>warn</em> - used to represent interface elements that the user should be careful of</li></ul><h3 id=\"themes\">Themes</h3><p>A theme is a configuration of palettes used for specific color intentions. A theme also specifies a background color palette to be used for the application.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/02_declarative_syntax.html","<div class=\"doc-content theming\"><p>Theming in angular material uses classes to apply an intention group to a given component. Most components in Angular Material support intention classes as expected, including:</p><ul><li>md-button</li><li>md-checkbox</li><li>md-progress-circular</li><li>md-progress-linear</li><li>md-radio-button</li><li>md-slider</li><li>md-switch</li><li>md-tabs</li><li>md-text-float</li><li>md-toolbar</li></ul><h3 id=\"specifying-intention-group\">Specifying intention group</h3><p>The classes to apply the color intention for a given component are as follows: <code>md-primary</code>, <code>md-accent</code>, <code>md-warn</code>.</p><hljs lang=\"html\"><md-button class=\"md-primary\">Click me</md-button><md-button class=\"md-accent\">or maybe me</md-button><md-button class=\"md-warn\">Careful</md-button></hljs><h3 id=\"differentiating-within-an-intention-group-\">Differentiating within an intention group.</h3><p>If you need to slightly differentiate an element, you can specify an additional class of <code>md-hue-1</code>, <code>md-hue-2</code>, or <code>md-hue-3</code>. Use these classes sparingly in your application to avoid overwhelming users.</p><hljs lang=\"html\"><md-button class=\"md-primary\">Click me</md-button><md-button class=\"md-primary md-hue-1\">Click me</md-button><md-button class=\"md-primary md-hue-2\">Click me</md-button></hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/03_configuring_a_theme.html","<div class=\"doc-content theming\"><h2 id=\"configuring-a-theme\">Configuring a theme</h2><p>By default your Angular Material application will use the default theme, a theme that is pre-configured with the following palettes for intention groups:</p><ul><li><em>primary</em> - indigo</li><li><em>accent</em> - pink</li><li><em>warn</em> - red</li><li><em>background</em> - grey (note that white is in this palette)</li></ul><p>Configuring of the default theme is done by using the <code>$mdThemingProvider</code> during application configuration.</p><h3 id=\"configuring-color-intentions\">Configuring Color Intentions</h3><p>You can specify a color palette for a given color intention by calling the appropriate configuration method (<code>theme.primaryPalette</code>, <code>theme.accentPalette</code>, <code>theme.warnPalette</code>, <code>theme.backgroundPalette</code>).</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;pink&#39;) .accentPalette(&#39;orange&#39;); });</hljs><h3 id=\"specifying-dark-themes\">Specifying Dark Themes</h3><p>You can mark a theme as dark by calling <code>theme.dark()</code>.</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .dark(); });</hljs><h3 id=\"specifying-custom-hues-for-color-intentions\">Specifying Custom Hues For Color Intentions</h3><p>You can specify the hues from a palette that will be used by an intention group by default and for the <code>md-hue-1</code>, <code>md-hue-2</code>, <code>md-hue-3</code> classes.</p><p>By default, shades <code>500</code>, <code>300</code> <code>800</code> and <code>A100</code> are used for <code>primary</code> and <code>warn</code> intentions, while <code>A200</code>, <code>A100</code>, <code>A400</code> and <code>A700</code> are used for <code>accent</code>.</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;pink&#39;, { &#39;default&#39;: &#39;400&#39;, // by default use shade 400 from the pink palette for primary intentions &#39;hue-1&#39;: &#39;100&#39;, // use shade 100 for the <code>md-hue-1</code> class &#39;hue-2&#39;: &#39;600&#39;, // use shade 600 for the <code>md-hue-2</code> class &#39;hue-3&#39;: &#39;A100&#39; // use shade A100 for the <code>md-hue-3</code> class }) // If you specify less than all of the keys, it will inherit from the // default shades .accentPalette(&#39;purple&#39;, { &#39;default&#39;: &#39;200&#39; // use shade 200 for default, and keep all other shades the same }); });</hljs><h3 id=\"defining-custom-palettes\">Defining Custom Palettes</h3><p>As mentioned before, Angular Material ships with the Material Design Spec&#39;s color palettes built in. In the event that you need to define a custom color palette, you can use <code>$mdThemingProvider</code> to define it, thereby making it available to your theme for use in its intention groups. Note that you must specify all hues in the definition map.</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.definePalette(&#39;amazingPaletteName&#39;, { &#39;50&#39;: &#39;ffebee&#39;, &#39;100&#39;: &#39;ffcdd2&#39;, &#39;200&#39;: &#39;ef9a9a&#39;, &#39;300&#39;: &#39;e57373&#39;, &#39;400&#39;: &#39;ef5350&#39;, &#39;500&#39;: &#39;f44336&#39;, &#39;600&#39;: &#39;e53935&#39;, &#39;700&#39;: &#39;d32f2f&#39;, &#39;800&#39;: &#39;c62828&#39;, &#39;900&#39;: &#39;b71c1c&#39;, &#39;A100&#39;: &#39;ff8a80&#39;, &#39;A200&#39;: &#39;ff5252&#39;, &#39;A400&#39;: &#39;ff1744&#39;, &#39;A700&#39;: &#39;d50000&#39;, &#39;contrastDefaultColor&#39;: &#39;light&#39;, // whether, by default, text (contrast) // on this palette should be dark or light &#39;contrastDarkColors&#39;: [&#39;50&#39;, &#39;100&#39;, //hues which contrast should be &#39;dark&#39; by default &#39;200&#39;, &#39;300&#39;, &#39;400&#39;, &#39;A100&#39;], &#39;contrastLightColors&#39;: undefined // could also specify this if default was &#39;dark&#39; }); $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;amazingPaletteName&#39;) });</hljs><p>Sometimes it is easier to extend an existing color palette to overwrite a few colors than define a whole new one. You can use <code>$mdThemingProvider.extendPalette</code> to quickly extend an existing color palette.</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { // Extend the red theme with a few different colors var neonRedMap = $mdThemingProvider.extendPalette(&#39;red&#39;, { &#39;500&#39;: &#39;ff0000&#39; }); // Register the new color palette map with the name <code>neonRed</code> $mdThemingProvider.definePalette(&#39;neonRed&#39;, neonRedMap); // Use that theme for the primary intentions $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;neonRed&#39;) });</hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/04_multiple_themes.html","<div class=\"doc-content theming\"><p>In most applications, declaring multiple themes is <strong>not</strong> necessary. Instead, you should configure the <code>default</code> theme for your needs. If you need multiple themes in a single application, Angular Material does provide tools to make this possible.</p><h3 id=\"registering-another-theme\">Registering another theme</h3><p>Use the <code>$mdThemingProvider</code> to register a second theme within your application. By default all themes will inherit from the <code>default</code> theme. Once you have registered the second theme, you can configure it with the same chainable interface used on the default theme.</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;altTheme&#39;) .primaryPalette(&#39;purple&#39;) // specify primary color, all // other color intentions will be inherited // from default });</hljs><h3 id=\"using-another-theme\">Using another theme</h3><h4 id=\"via-the-provider\">Via the Provider</h4><p>You can change the default theme to be used across your entire application using the provider:</p><hljs lang=\"js\">$mdThemingProvider.setDefaultTheme(&#39;altTheme&#39;);</hljs><h4 id=\"via-a-directive\">Via a Directive</h4><p>Angular Material also exposes the <code>md-theme</code> directive which will set the theme on an element and all child elements.</p><p>In the following example, the application will use the <code>default</code> theme, while the second child <code>div</code> will use the <code>altTheme</code>. This allows you to theme different parts of your application differently.</p><hljs lang=\"html\"><div><md-button class=\"md-primary\">I will be blue (by default)</md-button><div md-theme=\"altTheme\"><md-button class=\"md-primary\">I will be purple (altTheme)</md-button></div></div></hljs><h4 id=\"dynamic-themes\">Dynamic Themes</h4><p>By default, to save on performance, theming directives will <strong>not</strong> watch <code>md-theme</code> for changes. If you need themes to be dynamically modified, you will need to use the <code>md-theme-watch</code> directive.</p><hljs lang=\"html\"><div><md-button ng-click=\"dynamicTheme = \'default\'\">Default</md-button><md-button ng-click=\"dynamicTheme = \'altTheme\'\">altTheme</md-button><div md-theme=\"{{ dynamicTheme }}\" md-theme-watch=\"\"><md-button class=\"md-primary\">I&#39;m dynamic</md-button></div></div></hljs><p>If you need this behavior in your entire application (ie. on all <code>md-theme</code> directives) you can use the <code>$mdThemingProvider</code> to enable it.</p><hljs lang=\"js\">$mdThemingProvider.alwaysWatchTheme(true);</hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/05_under_the_hood.html","<div class=\"doc-content theming\"><h3 id=\"under-the-hood\">Under the Hood</h3><p>Angular Material dynamically generates CSS for registered themes by injecting several <code>&lt;script&gt;</code> tags into the <code>&lt;head&gt;</code> section of the application at runtime. Here is how that process currently works:</p><ol><li><p>During the Angular Material build process, a function in <code>gulp/util.js</code> called <a href=\"https://github.com/angular/material/blob/master/gulp/util.js#L187\">themeBuildStream()</a> compiles all <code>*-theme.scss</code> files from components into a single CSS string that is injected into the <code>material.core</code> module as a constant called <code>$MD_THEME_CSS</code>.</p></li><li><p>At runtime, a function in <code>src/core/services/theming/theming.js</code> called <a href=\"https://github.com/angular/material/blob/master/src/core/services/theming/theming.js#L450\">generateThemes()</a> parses <code>$MD_THEME_CSS</code> to generate the <code>&lt;style&gt;</code> tags that are added to the <code>&lt;head&gt;</code> section of the application. A closure variable called <code>GENERATED</code> is used to keep track of the themes that have had their CSS generated.</p></li><li><p>For each of the four (4) palettes (e.g. <code>primary</code>, <code>accent</code>, <code>warn</code> and <code>background</code>) <em>in each registered theme</em> (including the default theme), there are four (4) <code>&lt;style&gt;</code> tags added to the <code>&lt;head&gt;</code> section (e.g. <code>.md-primary</code>, <code>.md-primary.md-hue-1</code>, <code>.md-primary.md-hue-2</code>, <code>.md-primary.md-hue-3</code>). Each registered theme results in 16 <code>&lt;style&gt;</code> tags being generated.</p></li></ol></div>");
$templateCache.put("app/main/pages/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap=\"\"><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.GENDER\">Gender</div><div class=\"info\">{{vm.about.general.gender}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.BIRTHDAY\">Birthday</div><div class=\"info\">{{vm.about.general.birthday}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LOCATIONS\">Locations</div><div class=\"info location\" ng-repeat=\"location in vm.about.general.locations\"><span>{{location}}</span><md-icon md-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon></div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.ABOUT_ME\">About Me</div><div class=\"info\">{{vm.about.general.about}}</div></div></div></div><div class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.WORK\">Work</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.OCCUPATION\">Occupation</div><div class=\"info\">{{vm.about.work.occupation}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.SKILLS\">Skills</div><div class=\"info\">{{vm.about.work.skills}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.JOBS\">Jobs</div><table class=\"info jobs\"><tr class=\"job\" ng-repeat=\"job in vm.about.work.jobs\"><td class=\"company\">{{job.company}}</td><td class=\"date\">{{job.date}}</td></tr></table></div></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.CONTACT\">Contact</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\">{{vm.about.contact.address}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TEL\">Tel.</div><div class=\"info\" ng-repeat=\"tel in vm.about.contact.tel\"><span>{{tel}}</span></div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.WEBSITE\">Website</div><div class=\"info\" ng-repeat=\"website in vm.about.contact.websites\"><span>{{website}}</span></div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.EMAILS\">Emails</div><div class=\"info\" ng-repeat=\"email in vm.about.contact.emails\"><span>{{email}}</span></div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.FRIENDS\">Friends</div><div class=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>454</span> <span translate=\"PROFILE.MORE\">More</span></div></header><div class=\"content\" layout=\"row\" layout-wrap=\"\"><div class=\"friend\" flex=\"20\" ng-repeat=\"friend in vm.about.friends\"><img ng-src=\"{{friend.avatar}}\"></div></div></div><div class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.JOINED_GROUPS\">Joined Groups</div><div class=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>6</span> <span translate=\"PROFILE.MORE\">More</span></div></header><div class=\"content\"><div class=\"group\" ng-repeat=\"group in vm.about.groups\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{group.logo}}\" class=\"logo\" alt=\"{{group.name}}\"><div><div class=\"name\">{{group.name}}</div><div class=\"category\">{{group.category}}</div><div class=\"members\">{{group.members}} people</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate=\"\" translate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\"><span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" layout=\"row\" layout-wrap=\"\"><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" ng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div class=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap=\"\"><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex=\"\"><textarea placeholder=\"Write something..\" translate=\"\" translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea><footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"insert photo\" translate=\"\" translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon md-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate=\"\" translate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span translate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add location\" translate=\"\" translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon md-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span></md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" translate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider></md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in vm.posts\"><header layout=\"row\" layout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-src=\"{{post.user.avatar}}\"><div layout=\"column\"><div class=\"title\"><span class=\"username md-accent-color\">{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" translate=\"PROFILE.TYPE_POST\">posted on your timeline</span> <span ng-if=\"post.type == \'something\'\" translate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> <span ng-if=\"post.type == \'video\'\" translate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span ng-if=\"post.type == \'article\'\" translate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div class=\"time\">{{post.time}}</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate=\"\" translate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div class=\"content\"><div ng-if=\"post.message\" class=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\"><img ng-if=\"post.media.type === \'image\'\" ng-src=\"{{post.media.preview}}\"><div ng-if=\"post.media.type === \'video\'\" ng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div class=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div class=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span translate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>({{post.like}})</span></div></md-button><md-button class=\"share-button\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>({{post.share}})</span></div></md-button></div></div><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div ng-if=\"post.comments\" class=\"comment-count\">{{post.comments.length}} comments<md-icon md-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill=\"\" ng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\"><div flex=\"\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.user.name}}</span> <span class=\"time\">{{comment.time}}</span></div><div class=\"message\">{{comment.message}}</div><div class=\"actions\" layout=\"row\" layout-align=\"space-between center\"><a href=\"#\" class=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply</a><md-icon flex=\"\" md-font-icon=\"icon-flag\" class=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" layout=\"row\" layout-fill=\"\"><img src=\"assets/images/avatars/profile.jpg\" class=\"avatar\"><form flex=\"\"><textarea placeholder=\"Add a comment...\" translate=\"\" translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button ng-click=\"\" class=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" translate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div class=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" flex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">See All</div></header><div class=\"content\" layout=\"row\" layout-wrap=\"\"><div class=\"activities\"><div class=\"activity\" layout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in vm.activities\"><img ng-src=\"{{activity.user.avatar}}\" class=\"avatar\" alt=\"{{activity.user.name}}\"><div layout=\"column\"><div><span class=\"username md-accent-color\">{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div><span class=\"time secondary-text\">{{activity.time}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/search/tabs/classic/classic.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><span class=\"result-count h3 secondary-text\"><span>54</span> <span translate=\"SEARCH.RESULTS\">Results</span></span><div class=\"pager\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span></span> <span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"results\"><div class=\"result-item\" ng-repeat=\"item in vm.classic\"><div class=\"title\">{{item.title}}</div><div class=\"url\">{{item.url}}</div><div class=\"excerpt\">{{item.excerpt}}</div></div></div><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs=\"\"><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs=\"\"><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs=\"\"><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs=\"\"><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs=\"\"><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs=\"\"><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs=\"\"><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs=\"\"><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs=\"\"><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/contacts/contacts.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.CONTACTS\">Contacts</span> <span class=\"secondary-text\"><span>13</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span></span> <span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><table class=\"results simple clickable\" ms-responsive-table=\"\"><thead><tr><th></th><th translate=\"SEARCH.NAME\">Name</th><th translate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.PHONE\">Phone</th><th translate=\"SEARCH.EMAIL\">Email</th></tr></thead><tbody><tr class=\"result-item\" ng-repeat=\"contact in vm.contacts\"><td class=\"text-left avatar-cell\" ng-if=\"contact.avatar\"><img class=\"avatar\" alt=\"{{contact.name}}\" ng-src=\"{{contact.avatar}}\"></td><td class=\"text-left avatar-cell\" ng-if=\"!contact.avatar\"><div class=\"avatar\" ms-random-class=\"vm.colors\">{{contact.name[0]}}</div></td><td class=\"name\">{{contact.name}}</td><td class=\"position\">{{contact.position}}</td><td class=\"phone\">{{contact.phone}}</td><td class=\"email\">{{contact.email}}</td></tr></tbody></table><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs=\"\"><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs=\"\"><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs=\"\"><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs=\"\"><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs=\"\"><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs=\"\"><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs=\"\"><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs=\"\"><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs=\"\"><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/emails/emails.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.EMAILS\">E-Mails</span> <span class=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span></span> <span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"results\"><div class=\"result-item {{mail.status}}\" ng-repeat=\"mail in vm.mails | filter: vm.search\" md-ink-ripple=\"\"><div layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"mail.from.avatar\" alt=\"{{mail.from.name}}\" ng-src=\"{{mail.from.avatar}}\"><div class=\"avatar\" ng-if=\"!mail.from.avatar\" ms-random-class=\"vm.colors\">{{mail.from.name[0]}}</div><div class=\"info\" flex=\"\" layout=\"column\"><div class=\"name text-truncate\">{{mail.from.name}}</div><div class=\"subject secondary-text text-truncate\">{{mail.subject}}</div><div class=\"message secondary-text text-truncate\">{{mail.message | htmlToPlaintext}}</div></div><div layout=\"column\" layout-align=\"center end\"><div class=\"time secondary-text\">{{mail.time}}</div></div></div></div></div><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs=\"\"><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs=\"\"><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs=\"\"><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs=\"\"><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs=\"\"><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs=\"\"><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs=\"\"><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs=\"\"><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs=\"\"><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/users/users.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.USERS\">Users</span> <span class=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span></span> <span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><table class=\"results simple clickable\" ms-responsive-table=\"\"><thead><tr><th translate=\"SEARCH.NAME\">Name</th><th translate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.OFFICE\">Office</th><th class=\"text-right\" translate=\"SEARCH.AGE\">Age</th><th class=\"text-right\" translate=\"SEARCH.START_DATE\">Start Date</th><th class=\"text-right\" translate=\"SEARCH.SALARY\">Salary</th><th class=\"text-left\" translate=\"SEARCH.EMAIL\">Email</th></tr></thead><tbody><tr class=\"result-item user\" ng-repeat=\"user in vm.users\"><td class=\"name\">{{user.name}}</td><td class=\"position\">{{user.position}}</td><td class=\"office\">{{user.office}}</td><td class=\"age text-right\">{{user.age}}</td><td class=\"start-date text-right\">{{user.startDate}}</td><td class=\"salary text-right\">{{user.salary | currency}}</td><td class=\"email text-left\">{{user.email}}</td></tr></tbody></table><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs=\"\"><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs=\"\"><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs=\"\"><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs=\"\"><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs=\"\"><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs=\"\"><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs=\"\"><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs=\"\"><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs=\"\"><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth/fullwidth.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with independent scroll</span></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>Content toolbar</span></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout carded left-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" flex=\"\"><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Left sidenav with page scroll</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p>Content toolbar</p></div><md-content class=\"content\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html","<div class=\"page-layout carded right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Right sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>Content toolbar</p><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle right pane\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll=\"\" flex=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Left sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p>Content toolbar</p></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/fullwidth/fullwidth.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\"><span class=\"h2\">Fullwidth</span></div><div class=\"content\" md-background-bg=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html","<div class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with independent scroll</span></div></div><div class=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout simple left-sidenav single-scroll\" layout=\"row\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with page scroll</span></div></div><div class=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">Right sidenav with independent scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout simple right-sidenav single-scroll\" layout=\"row\"><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">Right sidenav with page scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/tabbed/tabbed.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\"><span class=\"h2\">Tabbed</span></div><div class=\"content\"><md-tabs md-dynamic-height=\"\"><md-tab label=\"Tab 1\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 2\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 3\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html","<md-dialog class=\"custom-theme-dialog\" aria-label=\"Custom Theme\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Custom Theme Generator</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" ng-repeat=\"type in [\'primary\', \'accent\', \'warn\', \'background\']\"><h3 class=\"type\">{{type}}</h3><md-input-container><label>Palette</label><md-select ng-model=\"vm.theme[type].name\" ng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].contrast, 1)}\"><md-option ng-value=\"palette\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\">{{palette}}</md-option></md-select></md-input-container><div layout=\"row\" ng-repeat=\"hueType in [\'default\', \'hue-1\', \'hue-2\', \'hue-3\']\"><md-input-container><label>{{hueType}}</label><md-select ng-model=\"vm.theme[type].hues[hueType]\" ng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].contrast, 1)}\"><md-option ng-value=\"hue\" ng-repeat=\"(hue, opt) in vm.palettes[vm.theme[type].name]\" ng-style=\"{\'background-color\': vm.rgba(opt.value), \'color\': vm.rgba(opt.contrast, 1)}\">{{hue}}</md-option></md-select></md-input-container></div></div><md-divider></md-divider><div layout=\"row\"><p>To make this theme permanent, copy the below code and add it into the \"fuseThemes\" object in \"core/theming/fuse-themes.constant.js\" file. You can also replace the \"CUSTOM_THEME_NAME\" with your theme name.</p></div><div layout=\"row\"><textarea readonly=\"\" class=\"theme-object\">\"CUSTOM_THEME_NAME\" : {{vm.theme}}</textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.setTheme()\">Set Theme</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ui/theme-colors/tabs/background/background.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.background.color}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .secondary-text</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .hint-text</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .divider</div></div><div flex=\"100\" class=\"md-primary-bg md-background-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.background.color}}</div><div flex=\"\">.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.background.hue1.color}}</div><div flex=\"\">.md-background-bg .md-hue-1</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.hue1.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .md-hue-1 .secondary-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .md-hue-1 .hint-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding=\"\"><div flex=\"\" class=\"md-background-fg md-hue-1\">As foreground color</div><div flex=\"\" class=\"md-background-fg md-hue-1\">{{vm.themes.active.theme.background.hue1.color}}</div><div flex=\"\" class=\"md-background-fg md-hue-1\">.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.background.hue2.color}}</div><div flex=\"\">.md-background-bg .md-hue-2</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.hue2.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .md-hue-2 .secondary-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .md-hue-2 .hint-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding=\"\"><div flex=\"\" class=\"md-background-fg md-hue-2\">As foreground color</div><div flex=\"\" class=\"md-background-fg md-hue-2\">{{vm.themes.active.theme.background.hue2.color}}</div><div flex=\"\" class=\"md-background-fg md-hue-2\">.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.background.hue3.color}}</div><div flex=\"\">.md-background-bg .md-hue-3</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.hue3.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .md-hue-3 .secondary-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .md-hue-3 .hint-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding=\"\"><div flex=\"\" class=\"md-background-fg md-hue-3\">As foreground color</div><div flex=\"\" class=\"md-background-fg md-hue-3\">{{vm.themes.active.theme.background.hue3.color}}</div><div flex=\"\" class=\"md-background-fg md-hue-3\">.md-background-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/accent/accent.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.accent.color}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .secondary-text</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .hint-text</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .divider</div></div><div flex=\"100\" class=\"md-accent-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.color}}</div><div flex=\"\">.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.accent.hue1.color}}</div><div flex=\"\">.md-accent-bg .md-hue-1</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .md-hue-1 .secondary-text</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .md-hue-1 .hint-text</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-1\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.hue1.color}}</div><div flex=\"\">.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.accent.hue2.color}}</div><div flex=\"\">.md-accent-bg .md-hue-2</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .md-hue-2 .secondary-text</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .md-hue-2 .hint-text</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-2\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.hue2.color}}</div><div flex=\"\">.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.accent.hue3.color}}</div><div flex=\"\">.md-accent-bg .md-hue-3</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .md-hue-3 .secondary-text</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .md-hue-3 .hint-text</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-3\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.hue3.color}}</div><div flex=\"\">.md-accent-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/primary/primary.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.primary.color}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .secondary-text</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .hint-text</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .divider</div></div><div flex=\"100\" class=\"md-primary-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.color}}</div><div flex=\"\">.md-primary-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.primary.hue1.color}}</div><div flex=\"\">.md-primary-bg .md-hue-1</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .md-hue-1 .secondary-text</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .md-hue-1 .hint-text</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-1\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.hue1.color}}</div><div flex=\"\">.md-primary-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.primary.hue2.color}}</div><div flex=\"\">.md-primary-bg .md-hue-2</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .md-hue-2 .secondary-text</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .md-hue-2 .hint-text</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-2\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.hue2.color}}</div><div flex=\"\">.md-primary-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.primary.hue3.color}}</div><div flex=\"\">.md-primary-bg .md-hue-3</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .md-hue-3 .secondary-text</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .md-hue-3 .hint-text</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-3\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.hue3.color}}</div><div flex=\"\">.md-primary-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/warn/warn.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.warn.color}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .secondary-text</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .hint-text</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .divider</div></div><div flex=\"100\" class=\"md-warn-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.color}}</div><div flex=\"\">.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.warn.hue1.color}}</div><div flex=\"\">.md-warn-bg .md-hue-1</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .md-hue-1 .secondary-text</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .md-hue-1 .hint-text</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-1\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.hue1.color}}</div><div flex=\"\">.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.warn.hue2.color}}</div><div flex=\"\">.md-warn-bg .md-hue-2</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .md-hue-2 .secondary-text</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .md-hue-2 .hint-text</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-2\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.hue2.color}}</div><div flex=\"\">.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.warn.hue3.color}}</div><div flex=\"\">.md-warn-bg .md-hue-3</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .md-hue-3 .secondary-text</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .md-hue-3 .hint-text</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-3\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.hue3.color}}</div><div flex=\"\">.md-warn-fg</div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with page scroll</span></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>Content toolbar</span></div><md-content class=\"content\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout carded right-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" flex=\"\"><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Right sidenav with page scroll</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>Content toolbar</p><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle right pane\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/index.html","<div class=\"doc-content\"><h1><code>material.components.autocomplete</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.bottomSheet/index.html","<div class=\"doc-content\"><h1><code>material.components.bottomSheet</code></h1><p>BottomSheet</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.button/index.html","<div class=\"doc-content\"><h1><code>material.components.button</code></h1><p>Button</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.card/index.html","<div class=\"doc-content\"><h1><code>material.components.card</code></h1><p>Card components.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/index.html","<div class=\"doc-content\"><h1><code>material.components.chips</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.content/index.html","<div class=\"doc-content\"><h1><code>material.components.content</code></h1><p>Scrollable content</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.checkbox/index.html","<div class=\"doc-content\"><h1><code>material.components.checkbox</code></h1><p>Checkbox module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/index.html","<div class=\"doc-content\"><h1><code>material.components.datepicker</code></h1><p>Datepicker</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/index.html","<div class=\"doc-content\"><h1><code>material.components.dialog</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.divider/index.html","<div class=\"doc-content\"><h1><code>material.components.divider</code></h1><p>Divider module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabActions/index.html","<div class=\"doc-content\"><h1><code>material.components.fabActions</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabSpeedDial/index.html","<div class=\"doc-content\"><h1><code>material.components.fabSpeedDial</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabToolbar/index.html","<div class=\"doc-content\"><h1><code>material.components.fabToolbar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabTrigger/index.html","<div class=\"doc-content\"><h1><code>material.components.fabTrigger</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/index.html","<div class=\"doc-content\"><h1><code>material.components.gridList</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/index.html","<div class=\"doc-content\"><h1><code>material.components.input</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/index.html","<div class=\"doc-content\"><h1><code>material.components.icon</code></h1><p>Icon</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/index.html","<div class=\"doc-content\"><h1><code>material.components.list</code></h1><p>List module</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu/index.html","<div class=\"doc-content\"><h1><code>material.components.menu</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu-bar/index.html","<div class=\"doc-content\"><h1><code>material.components.menu-bar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressCircular/index.html","<div class=\"doc-content\"><h1><code>material.components.progressCircular</code></h1><p>Circular Progress module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressLinear/index.html","<div class=\"doc-content\"><h1><code>material.components.progressLinear</code></h1><p>Linear Progress module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/index.html","<div class=\"doc-content\"><h1><code>material.components.radioButton</code></h1><p>radioButton module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.select/index.html","<div class=\"doc-content\"><h1><code>material.components.select</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.showHide/index.html","<div class=\"doc-content\"><h1><code>material.components.showHide</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/index.html","<div class=\"doc-content\"><h1><code>material.components.sidenav</code></h1><p>A Sidenav QP component.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.slider/index.html","<div class=\"doc-content\"><h1><code>material.components.slider</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sticky/index.html","<div class=\"doc-content\"><h1><code>material.components.sticky</code></h1><p>Sticky effects for md</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.subheader/index.html","<div class=\"doc-content\"><h1><code>material.components.subheader</code></h1><p>SubHeader module</p><p>Subheaders are special list tiles that delineate distinct sections of a list or grid list and are typically related to the current filtering or sorting criteria. Subheader tiles are either displayed inline with tiles or can be associated with content, for example, in an adjacent column.</p><p>Upon scrolling, subheaders remain pinned to the top of the screen and remain pinned until pushed on or off screen by the next subheader. @see <a href=\"https://www.google.com/design/spec/components/subheaders.html\">Material Design Specifications</a></p><blockquote><p>To improve the visual grouping of content, use the system color for your subheaders.</p></blockquote></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/index.html","<div class=\"doc-content\"><h1><code>material.components.swipe</code></h1><p>Swipe module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.switch/index.html","<div class=\"doc-content\"><h1><code>material.components.switch</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/index.html","<div class=\"doc-content\"><h1><code>material.components.tabs</code></h1><p>Tabs, created with the <code>&lt;md-tabs&gt;</code> directive provide <em>tabbed</em> navigation with different styles. The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.</p><p>Features include support for:</p><ul><li>static or dynamic tabs,</li><li>responsive designs,</li><li>accessibility support (ARIA),</li><li>tab pagination,</li><li>external or internal tab content,</li><li>focus indicators and arrow-key navigations,</li><li>programmatic lookup and access to tab controllers, and</li><li>dynamic transitions through different tab contents.</li></ul></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toast/index.html","<div class=\"doc-content\"><h1><code>material.components.toast</code></h1><p>Toast</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toolbar/index.html","<div class=\"doc-content\"><h1><code>material.components.toolbar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tooltip/index.html","<div class=\"doc-content\"><h1><code>material.components.tooltip</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/index.html","<div class=\"doc-content\"><h1><code>material.components.virtualRepeat</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.whiteframe/index.html","<div class=\"doc-content\"><h1><code>material.components.whiteframe</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.componentRegistry/index.html","<div class=\"doc-content\"><h1><code>material.core.componentRegistry</code></h1><p>A component instance registration service. Note: currently this as a private service in the SideNav component.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.util/index.html","<div class=\"doc-content\"><h1><code>material.core.util</code></h1><p>Util</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/index.html","<div class=\"doc-content\"><h1><code>material.core.ripple</code></h1><p>Ripple</p></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Label</md-subheader><md-list-item class=\"label\"><div layout=\"row\" layout-align=\"start center\"><md-menu md-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" ng-class=\"vm.newLabelColor+\'-fg\'\" class=\"label-icon\"></md-icon></md-button><md-menu-content class=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" aria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i></label></div></md-menu-content></md-menu><span editable-text=\"vm.newLabelName\" e-form=\"newLabelForm\" onaftersave=\"vm.addNewLabel()\"></span><p flex=\"\" class=\"title new-label-form-button\" ng-click=\"newLabelForm.$show()\" ng-hide=\"newLabelForm.$visible\">Enter New Label Name</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"label\" ng-repeat=\"label in vm.board.labels\"><div layout=\"row\" layout-align=\"start center\"><md-menu md-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon></md-button><md-menu-content class=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"label.color\" ng-value=\"palette\" aria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i></label></div></md-menu-content></md-menu><p flex=\"\" class=\"title\" editable-text=\"label.name\">{{label.name}}</p><md-button ng-click=\"vm.removeLabel($event, label.id);\" class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Member</md-subheader><md-list-item class=\"add-new-member\"><form ng-submit=\"vm.newMember()\" layout=\"row\" layout-align=\"start center\"><input flex=\"\" placeholder=\"Type Member Name\" type=\"text\" ng-model=\"vm.newMemberSearchInput\"><md-button type=\"submit\" class=\"md-accent md-raised\" aria-label=\"Add New Member\">Add</md-button></form></md-list-item><md-divider></md-divider><md-list-item class=\"member\" ng-repeat=\"member in vm.board.members\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p class=\"member-name\">{{ member.name }}</p><md-button ng-click=\"vm.removeMember($event, member.id);\" class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html","<md-dialog class=\"event-calendar-dialog\" aria-label=\"Event Dialog\" ng-cloak=\"\"><md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">{{vm.dueDate | date:\'mediumDate\':\'UTC\'}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-tabs md-dynamic-height=\"\"><md-tab><md-tab-label><span translate=\"SB.ADD_A_CARD\">Add a card</span></md-tab-label><md-tab-body><div class=\"new-card\" layout=\"column\"><form name=\"newCardForm\" novalidate=\"\"><md-input-container class=\"new-card-name md-block\" md-no-float=\"\"><input name=\"name\" ng-model=\"vm.newCard.name\" placeholder=\"Card name\" required=\"\"><div ng-messages=\"newCardForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><div class=\"lists\"><p>Select a list:</p><md-radio-group ng-model=\"vm.newCard.listId\" required=\"\"><md-radio-button ng-repeat=\"list in vm.board.lists\" ng-value=\"list.id\">{{list.name}}</md-radio-button></md-radio-group></div><md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.addNewCard()\" ng-disabled=\"newCardForm.$invalid || newCardForm.$pristine\">Add</md-button></md-dialog-actions></form></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"SB.ASSIGN_THE_DATE_TO_CARDS\">Assign the date to cards</span></md-tab-label><md-tab-body><div class=\"assign-due-date\"><md-list class=\"cards\"><md-content class=\"cards-content\" flex=\"\" ms-scroll=\"\"><md-list-item class=\"card\" ng-repeat=\"card in vm.board.cards\" ng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" aria-label=\"card\"><p layout=\"column\" layout-align=\"start start\"><span class=\"card-name\">{{card.name}}</span> <span ng-if=\"card.due\" class=\"card-date\">{{card.due | date}}</span></p><md-checkbox ng-checked=\"vm.exists(card.id, vm.selectedCards)\" ng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" class=\"md-secondary\" aria-label=\"card\"></md-checkbox></md-list-item></md-content></md-list><md-dialog-actions><md-button ng-disabled=\"!vm.selectedCards[0]\" ng-click=\"vm.assignDueDate()\" class=\"md-accent md-raised\">Assign</md-button></md-dialog-actions></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html","<div class=\"md-title sidenav-title\">Scheduled Cards</div><div class=\"cards\"><div ng-if=\"vm.cards.length <= 0\"><span translate=\"SB.NO_SCHEDULED_CARD\">There is no scheduled card.</span></div><div class=\"card\" layout=\"row\" ng-repeat=\"card in vm.cards\"><md-button class=\"md-raised card-date\" ng-click=\"vm.goToDate(card.start)\"><div class=\"day-in-week\">{{card.due | date:\'EEEE\'}}</div><div class=\"day\">{{card.due | date:\'d\' }}</div><div class=\"month-year\">{{card.due | date:\'MMM yyyy\'}}</div></md-button><div class=\"card-title\" flex=\"\" layout=\"column\" layout-align=\"center start\" ng-click=\"vm.openCardDialog($event, card.idCard)\"><span>{{card.title}}</span></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html","<div class=\"header md-whiteframe-2dp\"><md-list><md-list-item class=\"selected-color\"><p class=\"title\" flex=\"\">Selected Color:</p><div ng-if=\"!vm.board.settings.color\" class=\"preview md-background-bg md-hue-1\"></div><div ng-if=\"vm.board.settings.color\" class=\"preview\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\">{{vm.board.settings.color}}</div><md-button class=\"md-icon-button\" ng-click=\"vm.board.settings.color = \'\'\" aria-label=\"Default Color\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button></md-list-item></md-list></div><div flex=\"\" class=\"content\" ms-scroll=\"\" ms-sidenav-helper=\"\"><md-list><md-list-item class=\"color\" ng-repeat=\"(paletteName, palette) in vm.palettes\" ng-click=\"vm.board.settings.color = paletteName\" ng-class=\"\'md-\'+paletteName+\'-bg\'\" aria-label=\"color select\"><p flex=\"\">{{paletteName}}</p><i class=\"icon-check s16\" ng-if=\"paletteName === vm.board.settings.color\"></i></md-list-item></md-list></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/directive/mdAutocomplete.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-autocomplete&gt;</code> is a special input component with a drop-down of all possible matches to a custom query. This component allows you to provide real-time suggestions as the user types in the input area.</p><p>To start, you will need to specify the required parameters and provide a template for your results. The content inside <code>md-autocomplete</code> will be treated as a template.</p><p>In more complex cases, you may want to include other content such as a message to display when no matches were found. You can do this by wrapping your template in <code>md-item-template</code> and adding a tag for <code>md-not-found</code>. An example of this is shown below.</p><h3 id=\"validation\">Validation</h3><p>You can use <code>ng-messages</code> to include validation the same way that you would normally validate; however, if you want to replicate a standard input with a floating label, you will have to do the following:</p><ul><li>Make sure that your template is wrapped in <code>md-item-template</code></li><li>Add your <code>ng-messages</code> code inside of <code>md-autocomplete</code></li><li>Add your validation properties to <code>md-autocomplete</code> (ie. <code>required</code>)</li><li>Add a <code>name</code> to <code>md-autocomplete</code> (to be used on the generated <code>input</code>)</li></ul><p>There is an example below of how this should look.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"basic-example\">Basic Example</h3><hljs lang=\"html\"><md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" md-item-text=\"item.display\"><span md-highlight-text=\"searchText\">{{item.display}}</span></md-autocomplete></hljs><h3 id=\"example-with-not-found-message\">Example with &quot;not found&quot; message</h3><hljs lang=\"html\"><md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" md-item-text=\"item.display\"><md-item-template><span md-highlight-text=\"searchText\">{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></hljs><p>In this example, our code utilizes <code>md-item-template</code> and <code>md-not-found</code> to specify the different parts that make up our component.</p><h3 id=\"example-with-validation\">Example with validation</h3><hljs lang=\"html\"><form name=\"autocompleteForm\"><md-autocomplete required=\"\" md-input-name=\"autocomplete\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" md-item-text=\"item.display\"><md-item-template><span md-highlight-text=\"searchText\">{{item.display}}</span></md-item-template><div ng-messages=\"autocompleteForm.autocomplete.$error\"><div ng-message=\"required\">This field is required</div></div></md-autocomplete></form></hljs><p>In this example, our code utilizes <code>md-item-template</code> and <code>md-not-found</code> to specify the different parts that make up our component.</p></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-items</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression in the format of <code>item in items</code> to iterate over matches for your search.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-selected-item-change <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression to be run each time a new item is selected</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-search-text-change <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression to be run each time the search text updates</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-search-text <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>A model to bind the search query text to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-selected-item <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>A model to bind the selected item to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-item-text <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression that will convert your object to a single string.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-cache <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Disables the internal caching that happens in autocomplete</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-disabled <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Determines whether or not to disable the input field</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-min-length <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Specifies the minimum length of text before autocomplete will make suggestions</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-delay <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Specifies the amount of time (in milliseconds) to wait before looking for results</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-autofocus <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If true, will immediately focus the input element</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-autoselect <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If true, the first item will be selected by default</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-menu-class <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>This will be applied to the dropdown menu for styling</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-floating-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>This will add a floating label to autocomplete and wrap it in <code>md-input-container</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-input-name <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The name attribute given to the input element to be used with FormController</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-input-id <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>An ID to be added to the input element</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-input-minlength <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The minimum length for the input&#39;s value for validation</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-input-maxlength <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The maximum length for the input&#39;s value for validation</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-select-on-match <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When set, autocomplete will automatically select exact the item if the search text is an exact match</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/directive/mdHighlightText.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>md-highlight-text</code> directive allows you to specify text that should be highlighted within an element. Highlighted text will be wrapped in <code>&lt;span class=&quot;highlight&quot;&gt;&lt;/span&gt;</code> which can be styled through CSS. Please note that child elements may not be used with this directive.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><input placeholder=\"Enter a search term...\" ng-model=\"searchTerm\" type=\"text\"><ul><li ng-repeat=\"result in results\" md-highlight-text=\"searchTerm\">{{result.text}}</li></ul></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-highlight-text</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>A model to be searched for</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-highlight-flags <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>A list of flags (loosely based on JavaScript RexExp flags).</p><h4 id=\"-supported-flags-\"><strong>Supported flags</strong>:</h4><ul><li><code>g</code>: Find all matches within the provided text</li><li><code>i</code>: Ignore case when searching for matches</li><li><code>$</code>: Only match if the text ends with the search term</li><li><code>^</code>: Only match if the text begins with the search term</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.backdrop/directive/mdBackdrop.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-backdrop&gt;</code> is a backdrop element used by other components, such as dialog and bottom sheet. Apply class <code>opaque</code> to make the backdrop use the theme backdrop color.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><ul><li>as element:<pre><code>&lt;md-backdrop&gt;&#13;&#10;...&#13;&#10;&lt;/md-backdrop&gt;&#13;</code></pre></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.bottomSheet/service/$mdBottomSheet.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdBottomSheet</code> opens a bottom sheet over the app and provides a simple promise API.</p><h2 id=\"restrictions\">Restrictions</h2><ul><li>The bottom sheet&#39;s template must have an outer <code>&lt;md-bottom-sheet&gt;</code> element.</li><li>Add the <code>md-grid</code> class to the bottom sheet for a grid layout.</li><li>Add the <code>md-list</code> class to the bottom sheet for a list layout.</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div ng-controller=\"MyController\"><md-button ng-click=\"openBottomSheet()\">Open a Bottom Sheet!</md-button></div></hljs><hljs lang=\"js\">var app = angular.module(&#39;app&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdBottomSheet) { $scope.openBottomSheet = function() { $mdBottomSheet.show({ template: &#39;<md-bottom-sheet>Hello!</md-bottom-sheet>&#39; }); }; });</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"show\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdBottomSheet.show(options);\n</code></h3><div class=\"service-desc\"><p>Show a bottom sheet with the specified options.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* options</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>An options object, with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>: The url of an html template file that will be used as the content of the bottom sheet. Restrictions: the template must have an outer <code>md-bottom-sheet</code> element.</li><li><code>template</code> - <code>{string=}</code>: Same as templateUrl, except this is an actual template string.</li><li><code>scope</code> - <code>{object=}</code>: the scope to link the template / controller to. If none is specified, it will create a new child scope. This scope will be destroyed when the bottom sheet is removed unless <code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>: whether to preserve the scope when the element is removed. Default is false</li><li><code>controller</code> - <code>{string=}</code>: The controller to associate with this bottom sheet.</li><li><code>locals</code> - <code>{string=}</code>: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, <code>locals: {three: 3}</code> would inject <code>three</code> into the controller with the value of 3.</li><li><code>clickOutsideToClose</code> - <code>{boolean=}</code>: Whether the user can click outside the bottom sheet to close it. Default true.</li><li><code>escapeToClose</code> - <code>{boolean=}</code>: Whether the user can press escape to close the bottom sheet. Default true.</li><li><code>resolve</code> - <code>{object=}</code>: Similar to locals, except it takes promises as values and the bottom sheet will not open until the promises resolve.</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li><li><code>parent</code> - <code>{element=}</code>: The element to append the bottom sheet to. The <code>parent</code> may be a <code>function</code>, <code>string</code>, <code>object</code>, or null. Defaults to appending to the body of the root element (or the root element) of the application. e.g. angular.element(document.getElementById(&#39;content&#39;)) or &quot;#content&quot;</li><li><code>disableParentScroll</code> - <code>{boolean=}</code>: Whether to disable scrolling while the bottom sheet is open. Default true.</li></ul></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that can be resolved with <code>$mdBottomSheet.hide()</code> or rejected with <code>$mdBottomSheet.cancel()</code>.</p></td></tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdBottomSheet.hide([response]);\n</code></h3><div class=\"service-desc\"><p>Hide the existing bottom sheet and resolve the promise returned from <code>$mdBottomSheet.show()</code>. This call will close the most recently opened/current bottomsheet (if any).</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the resolved promise.</p></td></tr></tbody></table></div></li><li id=\"cancel\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdBottomSheet.cancel([response]);\n</code></h3><div class=\"service-desc\"><p>Hide the existing bottom sheet and reject the promise returned from <code>$mdBottomSheet.show()</code>.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the rejected promise.</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.card/directive/mdCard.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-card&gt;</code> directive is a container element used within <code>&lt;md-content&gt;</code> containers.</p><p>An image included as a direct descendant will fill the card&#39;s width, while the <code>&lt;md-card-content&gt;</code> container will wrap text content and provide padding. An <code>&lt;md-card-footer&gt;</code> element can be optionally included to put content flush against the bottom edge of the card.</p><p>Action buttons can be included in an <code>&lt;md-card-actions&gt;</code> element, similar to <code>&lt;md-dialog-actions&gt;</code>. You can then position buttons using layout attributes.</p><p>Card is built with:</p><ul><li><code>&lt;md-card-header&gt;</code> - Header for the card, holds avatar, text and squared image<ul><li><code>&lt;md-card-avatar&gt;</code> - Card avatar<ul><li><code>md-user-avatar</code> - Class for user image</li><li><code>&lt;md-icon&gt;</code></li></ul></li><li><code>&lt;md-card-header-text&gt;</code> - Contains elements for the card description<ul><li><code>md-title</code> - Class for the card title</li><li><code>md-subhead</code> - Class for the card sub header</li></ul></li></ul></li><li><code>&lt;img&gt;</code> - Image for the card</li><li><code>&lt;md-card-title&gt;</code> - Card content title<ul><li><code>&lt;md-card-title-text&gt;</code><ul><li><code>md-headline</code> - Class for the card content title</li><li><code>md-subhead</code> - Class for the card content sub header</li></ul></li><li><code>&lt;md-card-title-media&gt;</code> - Squared image within the title<ul><li><code>md-media-sm</code> - Class for small image</li><li><code>md-media-md</code> - Class for medium image</li><li><code>md-media-lg</code> - Class for large image</li></ul></li></ul></li><li><code>&lt;md-card-content&gt;</code> - Card content<ul><li><code>md-media-xl</code> - Class for extra large image</li></ul></li><li><code>&lt;md-card-actions&gt;</code> - Card actions<ul><li><code>&lt;md-card-icon-actions&gt;</code> - Icon actions</li></ul></li></ul><p>Cards have constant width and variable heights; where the maximum height is limited to what can fit within a single view on a platform, but it can temporarily expand as needed.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"card-with-optional-footer\">Card with optional footer</h3><hljs lang=\"html\"><md-card><img src=\"card-image.png\" class=\"md-card-image\" alt=\"image caption\"><md-card-content><h2>Card headline</h2><p>Card content</p></md-card-content><md-card-footer>Card footer</md-card-footer></md-card></hljs><h3 id=\"card-with-actions\">Card with actions</h3><hljs lang=\"html\"><md-card><img src=\"card-image.png\" class=\"md-card-image\" alt=\"image caption\"><md-card-content><h2>Card headline</h2><p>Card content</p></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button>Action 1</md-button><md-button>Action 2</md-button></md-card-actions></md-card></hljs><h3 id=\"card-with-header-image-title-actions-and-content\">Card with header, image, title actions and content</h3><hljs lang=\"html\"><md-card><md-card-header><md-card-avatar><img class=\"md-user-avatar\" src=\"avatar.png\"></md-card-avatar><md-card-header-text><span class=\"md-title\">Title</span> <span class=\"md-subhead\">Sub header</span></md-card-header-text></md-card-header><img ng-src=\"card-image.png\" class=\"md-card-image\" alt=\"image caption\"><md-card-title><md-card-title-text><span class=\"md-headline\">Card headline</span> <span class=\"md-subhead\">Card subheader</span></md-card-title-text></md-card-title><md-card-actions layout=\"row\" layout-align=\"start center\"><md-button>Action 1</md-button><md-button>Action 2</md-button><md-card-icon-actions><md-button class=\"md-icon-button\" aria-label=\"icon\"><md-icon md-svg-icon=\"icon\"></md-icon></md-button></md-card-icon-actions></md-card-actions><md-card-content><p>Card content</p></md-card-content></md-card></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.button/directive/mdButton.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-button&gt;</code> is a button directive with optional ink ripples (default enabled).</p><p>If you supply a <code>href</code> or <code>ng-href</code> attribute, it will become an <code>&lt;a&gt;</code> element. Otherwise, it will become a <code>&lt;button&gt;</code> element. As per the <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">Material Design specifications</a> the FAB button background is filled with the accent color [by default]. The primary color palette may be used with the <code>md-primary</code> class.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>Regular buttons:</p><hljs lang=\"html\"><md-button>Flat Button</md-button><md-button href=\"http://google.com\">Flat link</md-button><md-button class=\"md-raised\">Raised Button</md-button><md-button ng-disabled=\"true\">Disabled Button</md-button><md-button><md-icon md-svg-src=\"your/icon.svg\"></md-icon>Register Now</md-button></hljs><p>FAB buttons:</p><hljs lang=\"html\"><md-button class=\"md-fab\" aria-label=\"FAB\"><md-icon md-svg-src=\"your/icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Mini FAB\"><md-icon md-svg-src=\"your/icon.svg\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Custom Icon Button\"><md-icon md-svg-icon=\"path/to/your.svg\"></md-icon></md-button></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If present, disable ripple ink effects.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-disabled <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>En/Disable based on the expression</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-ripple-size <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Overrides the default ripple size logic. Options: <code>full</code>, <code>partial</code>, <code>auto</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Adds alternative text to button for accessibility, useful for icon buttons. If no default text is found, a warning will be logged.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.content/directive/mdContent.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-content&gt;</code> directive is a container element useful for scrollable content</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><ul><li>Add the <code>[layout-padding]</code> attribute to make the content padded.</li></ul><hljs lang=\"html\"><md-content layout-padding=\"\">Lorem ipsum dolor sit amet, ne quod novum mei.</md-content></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChip.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-chip&gt;</code> is a component used within <code>&lt;md-chips&gt;</code> and is responsible for rendering individual chips.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-chip>{{$chip}}</md-chip></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChipRemove.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-chip-remove&gt;</code> Designates an element to be used as the delete button for a chip. This element is passed as a child of the <code>md-chips</code> element.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-chips><button md-chip-remove=\"\">DEL</button></md-chips></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChips.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-chips&gt;</code> is an input component for building lists of strings or objects. The list items are displayed as &#39;chips&#39;. This component can make use of an <code>&lt;input&gt;</code> element or an <code>&lt;md-autocomplete&gt;</code> element.</p><h3 id=\"custom-templates\">Custom templates</h3><p>A custom template may be provided to render the content of each chip. This is achieved by specifying an <code>&lt;md-chip-template&gt;</code> element containing the custom content as a child of <code>&lt;md-chips&gt;</code>.</p><p>Note: Any attributes on <code>&lt;md-chip-template&gt;</code> will be dropped as only the innerHTML is used for the chip template. The variables <code>$chip</code> and <code>$index</code> are available in the scope of <code>&lt;md-chip-template&gt;</code>, representing the chip object and its index in the list of chips, respectively. To override the chip delete control, include an element (ideally a button) with the attribute <code>md-chip-remove</code>. A click listener to remove the chip will be added automatically. The element is also placed as a sibling to the chip content (on which there are also click listeners) to avoid a nested ng-click situation.</p><p></p><h3>Pending Features</h3><p></p><ul style=\"padding-left:20px;\"><ul>Style<li>Colours for hover, press states (ripple?).</li></ul><ul>Validation<li>allow a validation callback</li><li>hilighting style for invalid chips</li></ul><ul>Item mutation<li>Support <code>&lt;md-chip-edit&gt;</code> template, show/hide the edit element on tap/click? double tap/double click?</li></ul><ul>Truncation and Disambiguation (?)<li>Truncate chip text where possible, but do not truncate entries such that two are indistinguishable.</li></ul><ul>Drag and Drop<li>Drag and drop chips between related <code>&lt;md-chips&gt;</code> elements.</li></ul></ul><p><span style=\"font-size:.8em;text-align:center\">Warning: This component is a WORK IN PROGRESS. If you use it now, it will probably break on you in the future.</span></p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-chips ng-model=\"myItems\" placeholder=\"Add an item\" readonly=\"isReadOnly\"></md-chips></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>A model to bind the list of items to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-transform-chip</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression of form <code>myFunction($chip)</code> that when called expects one of the following return values:</p><ul><li>an object representing the <code>$chip</code> input string</li><li><code>undefined</code> to simply add the <code>$chip</code> input string, or</li><li><code>null</code> to prevent the chip from being appended</li></ul></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-require-match</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If true, and the chips template contains an autocomplete, only allow selection of pre-defined chips (i.e. you cannot add new ones).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">secondary-placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input, displayed when there is at least on item in the list</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">readonly <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Disables list manipulation (deleting or adding list items), hiding the input and delete buttons</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-add <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression which will be called when a chip has been added.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-remove <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression which will be called when a chip has been removed.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-select <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression which will be called when a chip is selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">delete-hint <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>A string read by screen readers instructing users that pressing the delete key will remove the chip.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">delete-button-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>A label for the delete button. Also hidden and read by screen readers.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-separator-keys <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An array of key codes used to separate chips.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdContactChips.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-contact-chips&gt;</code> is an input component based on <code>md-chips</code> and makes use of an <code>md-autocomplete</code> element. The component allows the caller to supply a query expression which returns a list of possible contacts. The user can select one of these and add it to the list of chips.</p><p>You may also use the <code>md-highlight-text</code> directive along with it&#39;s parameters to control the appearance of the matched text inside of the contacts&#39; autocomplete popup.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-contact-chips ng-model=\"ctrl.contacts\" md-contacts=\"ctrl.querySearch($query)\" md-contact-name=\"name\" md-contact-image=\"image\" md-contact-email=\"email\" placeholder=\"To\"></md-contact-chips></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>A model to bind the list of items to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-contacts</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression expected to return contacts matching the search test, <code>$query</code>.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-contact-name</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The field name of the contact object representing the contact&#39;s name.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-contact-email</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The field name of the contact object representing the contact&#39;s email address.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-contact-image</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The field name of the contact object representing the contact&#39;s image.</p><p>// The following attribute has been removed but may come back.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">secondary-placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input, displayed when there is at least on item in the list</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">filter-selected <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Whether to filter selected contacts from the list of suggestions shown in the autocomplete.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.checkbox/directive/mdCheckbox.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The checkbox directive is used like the normal <a href=\"https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D\">angular checkbox</a>.</p><p>As per the <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">material design spec</a> the checkbox is in the accent color by default. The primary color palette may be used with the <code>md-primary</code> class.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-checkbox ng-model=\"isChecked\" aria-label=\"Finished?\">Finished ?</md-checkbox><md-checkbox md-no-ink=\"\" ng-model=\"hasInk\" aria-label=\"No Ink Effects\">No Ink Effects</md-checkbox><md-checkbox ng-disabled=\"true\" ng-model=\"isDisabled\" aria-label=\"Disabled\">Disabled</md-checkbox></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Assignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">name <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Property name of the form under which the control is published.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-true-value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>The value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-false-value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>The value to which the expression should be set when not selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-change <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Angular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Use of attribute indicates use of ripple ink effects</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Adds label to checkbox for accessibility. Defaults to checkbox&#39;s text. If no default text is found, a warning will be logged.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/directive/mdDatepicker.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-datepicker&gt;</code> is a component used to select a single date. For information on how to configure internationalization for the date picker, see <code>$mdDateLocaleProvider</code>.</p><p>This component supports <a href=\"https://docs.angularjs.org/api/ngMessages/directive/ngMessages\">ngMessages</a>. Supported attributes are:</p><ul><li><code>required</code>: whether a required date is not set.</li><li><code>mindate</code>: whether the selected date is before the minimum allowed date.</li><li><code>maxdate</code>: whether the selected date is after the maximum allowed date.</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-datepicker ng-model=\"birthday\"></md-datepicker></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>The component&#39;s model. Expects a JavaScript Date object.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-change <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Expression evaluated when the model value changes.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-min-date <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>Expression representing a min date (inclusive).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-max-date <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>Expression representing a max date (inclusive).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-date-filter <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-function\">function(Date): boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-function\">function(Date): boolean</code></td><td class=\"description\"><p>Function expecting a date and returning a boolean whether it can be selected or not.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">String</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">String</code></td><td class=\"description\"><p>The date input placeholder value.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-disabled <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether the datepicker is disabled.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-required <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether a value is required for the datepicker.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/service/$mdDateLocaleProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>$mdDateLocaleProvider</code> is the provider that creates the <code>$mdDateLocale</code> service. This provider that allows the user to specify messages, formatters, and parsers for date internationalization. The <code>$mdDateLocale</code> service itself is consumed by Angular Material components that that deal with dates.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">myAppModule.config(function($mdDateLocaleProvider) { // Example of a French localization. $mdDateLocaleProvider.months = [&#39;janvier&#39;, &#39;février&#39;, &#39;mars&#39;, ...]; $mdDateLocaleProvider.shortMonths = [&#39;janv&#39;, &#39;févr&#39;, &#39;mars&#39;, ...]; $mdDateLocaleProvider.days = [&#39;dimanche&#39;, &#39;lundi&#39;, &#39;mardi&#39;, ...]; $mdDateLocaleProvider.shortDays = [&#39;Di&#39;, &#39;Lu&#39;, &#39;Ma&#39;, ...]; // Can change week display to start on Monday. $mdDateLocaleProvider.firstDayOfWeek = 1; // Optional. $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...]; // Example uses moment.js to parse and format dates. $mdDateLocaleProvider.parseDate = function(dateString) { var m = moment(dateString, &#39;L&#39;, true); return m.isValid() ? m.toDate() : new Date(NaN); }; $mdDateLocaleProvider.formatDate = function(date) { return moment(date).format(&#39;L&#39;); }; $mdDateLocaleProvider.monthHeaderFormatter = function(date) { return myShortMonths[date.getMonth()] + &#39; &#39; + date.getFullYear(); }; // In addition to date display, date components also need localized messages // for aria-labels for screen-reader users. $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) { return &#39;Semaine &#39; + weekNumber; }; $mdDateLocaleProvider.msgCalendar = &#39;Calendrier&#39;; $mdDateLocaleProvider.msgOpenCalendar = &#39;Ouvrir le calendrier&#39;; });</hljs></section><section class=\"api-section\"><h2>Properties</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Property</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">months <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>Array of month names (in order).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">shortMonths <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>Array of abbreviated month names.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">days <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>Array of the days of the week (in order).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">shortDays <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>Array of abbreviated dayes of the week.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">dates <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>Array of dates of the month. Only necessary for locales using a numeral system other than [1, 2, 3...].</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">firstDayOfWeek <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>The first day of the week. Sunday = 0, Monday = 1, etc.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">parseDate <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-function\">function(string): Date</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-function\">function(string): Date</code></td><td class=\"description\"><p>Function to parse a date object from a string.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">formatDate <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-function\">function(Date): string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-function\">function(Date): string</code></td><td class=\"description\"><p>Function to format a date object to a string.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">monthHeaderFormatter <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-function\">function(Date): string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-function\">function(Date): string</code></td><td class=\"description\"><p>Function that returns the label for a month given a date.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">weekNumberFormatter <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-function\">function(number): string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-function\">function(number): string</code></td><td class=\"description\"><p>Function that returns a label for a week given the week number.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">msgCalendar <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Translation of the label &quot;Calendar&quot; for the current locale.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">msgOpenCalendar <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Translation of the button label &quot;Open calendar&quot; for the current locale.</p></td></tr></tbody></table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/service/$mdDialog.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdDialog</code> opens a dialog over the app to inform users about critical information or require them to make decisions. There are two approaches for setup: a simple promise API and regular object syntax.</p><h2 id=\"restrictions\">Restrictions</h2><ul><li>The dialog is always given an isolate scope.</li><li>The dialog&#39;s template must have an outer <code>&lt;md-dialog&gt;</code> element. Inside, use an <code>&lt;md-dialog-content&gt;</code> element for the dialog&#39;s content, and use an <code>&lt;md-dialog-actions&gt;</code> element for the dialog&#39;s actions.</li><li>Dialogs must cover the entire application to keep interactions inside of them. Use the <code>parent</code> option to change where dialogs are appended.</li></ul><h2 id=\"sizing\">Sizing</h2><ul><li>Complex dialogs can be sized with <code>flex=&quot;percentage&quot;</code>, i.e. <code>flex=&quot;66&quot;</code>.</li><li>Default max-width is 80% of the <code>rootElement</code> or <code>parent</code>.</li></ul><h2 id=\"css\">CSS</h2><ul><li><code>.md-dialog-content</code> - class that sets the padding on the content as the spec file</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div ng-app=\"demoApp\" ng-controller=\"EmployeeController\"><div><md-button ng-click=\"showAlert()\" class=\"md-raised md-warn\">Employee Alert!</md-button></div><div><md-button ng-click=\"showDialog($event)\" class=\"md-raised\">Custom Dialog</md-button></div><div><md-button ng-click=\"closeAlert()\" ng-disabled=\"!hasAlert()\" class=\"md-raised\">Close Alert</md-button></div><div><md-button ng-click=\"showGreeting($event)\" class=\"md-raised md-primary\">Greet Employee</md-button></div></div></hljs><h3 id=\"javascript-object-syntax\">JavaScript: object syntax</h3><hljs lang=\"js\">(function(angular, undefined){ &quot;use strict&quot;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;AppCtrl&#39;, AppController); function AppController($scope, $mdDialog) { var alert; $scope.showAlert = showAlert; $scope.showDialog = showDialog; $scope.items = [1, 2, 3]; // Internal method function showAlert() { alert = $mdDialog.alert({ title: &#39;Attention&#39;, textContent: &#39;This is an example of how easy dialogs can be!&#39;, ok: &#39;Close&#39; }); $mdDialog .show( alert ) .finally(function() { alert = undefined; }); } function showDialog($event) { var parentEl = angular.element(document.body); $mdDialog.show({ parent: parentEl, targetEvent: $event, template: &#39;<md-dialog aria-label=\"List dialog\">&#39; + &#39;<md-dialog-content>&#39;+ &#39;<md-list>&#39;+ &#39;<md-list-item ng-repeat=\"item in items\">&#39;+ &#39;<p>Number {{item}}</p>&#39; + &#39; &#39;+ &#39;</md-list-item></md-list>&#39;+ &#39;</md-dialog-content>&#39; + &#39;<md-dialog-actions>&#39; + &#39;<md-button ng-click=\"closeDialog()\" class=\"md-primary\">&#39; + &#39; Close Dialog&#39; + &#39;</md-button>&#39; + &#39;</md-dialog-actions>&#39; + &#39;</md-dialog>&#39;, locals: { items: $scope.items }, controller: DialogController }); function DialogController($scope, $mdDialog, items) { $scope.items = items; $scope.closeDialog = function() { $mdDialog.hide(); } } } } })(angular);</hljs><h3 id=\"javascript-promise-api-syntax-custom-dialog-template\">JavaScript: promise API syntax, custom dialog template</h3><hljs lang=\"js\">(function(angular, undefined){ &quot;use strict&quot;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;EmployeeController&#39;, EmployeeEditor) .controller(&#39;GreetingController&#39;, GreetingController); // Fictitious Employee Editor to show how to use simple and complex dialogs. function EmployeeEditor($scope, $mdDialog) { var alert; $scope.showAlert = showAlert; $scope.closeAlert = closeAlert; $scope.showGreeting = showCustomGreeting; $scope.hasAlert = function() { return !!alert }; $scope.userName = $scope.userName || &#39;Bobby&#39;; // Dialog #1 - Show simple alert dialog and cache // reference to dialog instance function showAlert() { alert = $mdDialog.alert() .title(&#39;Attention, &#39; + $scope.userName) .textContent(&#39;This is an example of how easy dialogs can be!&#39;) .ok(&#39;Close&#39;); $mdDialog .show( alert ) .finally(function() { alert = undefined; }); } // Close the specified dialog instance and resolve with &#39;finished&#39; flag // Normally this is not needed, just use &#39;$mdDialog.hide()&#39; to close // the most recent dialog popup. function closeAlert() { $mdDialog.hide( alert, &quot;finished&quot; ); alert = undefined; } // Dialog #2 - Demonstrate more complex dialogs construction and popup. function showCustomGreeting($event) { $mdDialog.show({ targetEvent: $event, template: &#39;<md-dialog>&#39; + &#39;<md-dialog-content>Hello {{ employee }}!</md-dialog-content>&#39; + &#39;<md-dialog-actions>&#39; + &#39;<md-button ng-click=\"closeDialog()\" class=\"md-primary\">&#39; + &#39; Close Greeting&#39; + &#39;</md-button>&#39; + &#39;</md-dialog-actions>&#39; + &#39;</md-dialog>&#39;, controller: &#39;GreetingController&#39;, onComplete: afterShowAnimation, locals: { employee: $scope.userName } }); // When the &#39;enter&#39; animation finishes... function afterShowAnimation(scope, element, options) { // post-show code here: DOM element focus, etc. } } // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog // Here we used ng-controller=&quot;GreetingController as vm&quot; and // $scope.vm ===<controller instance=\"\">function showCustomGreeting() { $mdDialog.show({ clickOutsideToClose: true, scope: $scope, // use parent scope in template preserveScope: true, // do not forget this if use parent scope // Since GreetingController is instantiated with ControllerAs syntax // AND we are passing the parent &#39;$scope&#39; to the dialog, we MUST // use &#39;vm.<xxx>&#39; in the template markup template: &#39;<md-dialog>&#39; + &#39;<md-dialog-content>&#39; + &#39; Hi There {{vm.employee}}&#39; + &#39;</md-dialog-content>&#39; + &#39;</md-dialog>&#39;, controller: function DialogController($scope, $mdDialog) { $scope.closeDialog = function() { $mdDialog.hide(); } } }); } } // Greeting controller used with the more complex &#39;showCustomGreeting()&#39; custom dialog function GreetingController($scope, $mdDialog, employee) { // Assigned from construction <code>locals</code> options... $scope.employee = employee; $scope.closeDialog = function() { // Easily hides most recent dialog shown... // no specific instance reference is needed. $mdDialog.hide(); }; } })(angular);</xxx></controller></hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"alert\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.alert();\n</code></h3><div class=\"service-desc\"><p>Builds a preconfigured dialog with the specified message.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdDialogPreset</code> with the chainable configuration methods:</p><ul><li>$mdDialogPreset#title(string) - Sets the alert title.</li><li>$mdDialogPreset#textContent(string) - Sets the alert message.</li><li>$mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.</li><li>$mdDialogPreset#ok(string) - Sets the alert &quot;Okay&quot; button text.</li><li>$mdDialogPreset#theme(string) - Sets the theme of the alert dialog.</li><li>$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.</li></ul></td></tr></tbody></table></div></li><li id=\"confirm\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.confirm();\n</code></h3><div class=\"service-desc\"><p>Builds a preconfigured dialog with the specified message. You can call show and the promise returned will be resolved only if the user clicks the confirm action on the dialog.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdDialogPreset</code> with the chainable configuration methods:</p><p>Additionally, it supports the following methods:</p><ul><li>$mdDialogPreset#title(string) - Sets the confirm title.</li><li>$mdDialogPreset#textContent(string) - Sets the confirm message.</li><li>$mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.</li><li>$mdDialogPreset#ok(string) - Sets the confirm &quot;Okay&quot; button text.</li><li>$mdDialogPreset#cancel(string) - Sets the confirm &quot;Cancel&quot; button text.</li><li>$mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.</li><li>$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.</li></ul></td></tr></tbody></table></div></li><li id=\"show\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.show(optionsOrPreset);\n</code></h3><div class=\"service-desc\"><p>Show a dialog with the specified options.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* optionsOrPreset</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Either provide an <code>$mdDialogPreset</code> returned from <code>alert()</code>, and <code>confirm()</code>, or an options object with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>: The url of a template that will be used as the content of the dialog.</li><li><code>template</code> - <code>{string=}</code>: HTML template to show in the dialog. This <strong>must</strong> be trusted HTML with respect to Angular&#39;s <a href=\"https://docs.angularjs.org/api/ng/service/$sce\">$sce service</a>. This template should <strong>never</strong> be constructed with any kind of user input or user data.</li><li><code>autoWrap</code> - <code>{boolean=}</code>: Whether or not to automatically wrap the template with a <code>&lt;md-dialog&gt;</code> tag if one is not provided. Defaults to true. Can be disabled if you provide a custom dialog directive.</li><li><code>targetEvent</code> - <code>{DOMClickEvent=}</code>: A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.</li><li><code>openFrom</code> - <code>{string|Element|object}</code>: The query selector, DOM element or the Rect object that is used to determine the bounds (top, left, height, width) from which the Dialog will originate.</li><li><code>closeTo</code> - <code>{string|Element|object}</code>: The query selector, DOM element or the Rect object that is used to determine the bounds (top, left, height, width) to which the Dialog will target.</li><li><code>scope</code> - <code>{object=}</code>: the scope to link the template / controller to. If none is specified, it will create a new isolate scope. This scope will be destroyed when the dialog is removed unless <code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>: whether to preserve the scope when the element is removed. Default is false</li><li><code>disableParentScroll</code> - <code>{boolean=}</code>: Whether to disable scrolling while the dialog is open. Default true.</li><li><code>hasBackdrop</code> - <code>{boolean=}</code>: Whether there should be an opaque backdrop behind the dialog. Default true.</li><li><code>clickOutsideToClose</code> - <code>{boolean=}</code>: Whether the user can click outside the dialog to close it. Default false.</li><li><code>escapeToClose</code> - <code>{boolean=}</code>: Whether the user can press escape to close the dialog. Default true.</li><li><code>focusOnOpen</code> - <code>{boolean=}</code>: An option to override focus behavior on open. Only disable if focusing some other way, as focus management is required for dialogs to be accessible. Defaults to true.</li><li><code>controller</code> - <code>{function|string=}</code>: The controller to associate with the dialog. The controller will be injected with the local <code>$mdDialog</code>, which passes along a scope for the dialog.</li><li><code>locals</code> - <code>{object=}</code>: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, <code>locals: {three: 3}</code> would inject <code>three</code> into the controller, with the value 3. If <code>bindToController</code> is true, they will be copied to the controller instead.</li><li><code>bindToController</code> - <code>bool</code>: bind the locals to the controller, instead of passing them in. These values will not be available until after initialization.</li><li><code>resolve</code> - <code>{object=}</code>: Similar to locals, except it takes promises as values, and the dialog will not open until all of the promises resolve.</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li><li><code>parent</code> - <code>{element=}</code>: The element to append the dialog to. Defaults to appending to the root element of the application.</li><li><code>onShowing</code> `{function=} Callback function used to announce the show() action is starting.</li><li><code>onComplete</code> <code>{function=}</code>: Callback function used to announce when the show() action is finished.</li><li><code>onRemoving</code> <code>{function=}</code>: Callback function used to announce the close/hide() action is starting. This allows developers to run custom animations in parallel the close animations.</li><li><code>fullscreen</code> <code>{boolean=}</code>: An option to apply <code>.md-dialog-fullscreen</code> class on open.</li></ul></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that can be resolved with <code>$mdDialog.hide()</code> or rejected with <code>$mdDialog.cancel()</code>.</p></td></tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.hide([response]);\n</code></h3><div class=\"service-desc\"><p>Hide an existing dialog and resolve the promise returned from <code>$mdDialog.show()</code>.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the resolved promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that is resolved when the dialog has been closed.</p></td></tr></tbody></table></div></li><li id=\"cancel\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.cancel([response]);\n</code></h3><div class=\"service-desc\"><p>Hide an existing dialog and reject the promise returned from <code>$mdDialog.show()</code>.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the rejected promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that is resolved when the dialog has been closed.</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/directive/mdDialog.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-dialog&gt;</code> - The dialog&#39;s template must be inside this element.</p><p>Inside, use an <code>&lt;md-dialog-content&gt;</code> element for the dialog&#39;s content, and use an <code>&lt;md-dialog-actions&gt;</code> element for the dialog&#39;s actions.</p><ul><li><h2 id=\"css\">CSS</h2></li><li><code>.md-dialog-content</code> - class that sets the padding on the content as the spec file</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"dialog-template\">Dialog template</h3><hljs lang=\"html\"><md-dialog aria-label=\"List dialog\"><md-dialog-content><md-list><md-list-item ng-repeat=\"item in items\"><p>Number {{item}}</p></md-list-item></md-list></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Close Dialog</md-button></md-dialog-actions></md-dialog></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabActions/directive/mdFabActions.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-fab-actions&gt;</code> directive is used inside of a <code>&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code> directive to mark an element (or elements) as the actions and setup the proper event listeners.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>See the <code>&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code> directives for example usage.</p></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.divider/directive/mdDivider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-divider></md-divider><md-divider md-inset=\"\"></md-divider></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-inset <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Add this attribute to activate the inset divider style.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabSpeedDial/directive/mdFabSpeedDial.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-fab-speed-dial&gt;</code> directive is used to present a series of popup elements (usually <code>&lt;md-button&gt;</code>s) for quick access to common actions.</p><p>There are currently two animations available by applying one of the following classes to the component:</p><ul><li><code>md-fling</code> - The speed dial items appear from underneath the trigger and move into their appropriate positions.</li><li><code>md-scale</code> - The speed dial items appear in their proper places by scaling from 0% to 100%.</li></ul><p>You may also easily position the trigger by applying one one of the following classes to the <code>&lt;md-fab-speed-dial&gt;</code> element:</p><ul><li><code>md-fab-top-left</code></li><li><code>md-fab-top-right</code></li><li><code>md-fab-bottom-left</code></li><li><code>md-fab-bottom-right</code></li></ul><p>These CSS classes use <code>position: absolute</code>, so you need to ensure that the container element also uses <code>position: absolute</code> or <code>position: relative</code> in order for them to work.</p><p>Additionally, you may use the standard <code>ng-mouseenter</code> and <code>ng-mouseleave</code> directives to open or close the speed dial. However, if you wish to allow users to hover over the empty space where the actions will appear, you must also add the <code>md-hover-full</code> class to the speed dial element. Without this, the hover effect will only occur on top of the trigger.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-fab-speed-dial md-direction=\"up\" class=\"md-fling\"><md-fab-trigger><md-button aria-label=\"Add...\"><md-icon icon=\"/assets/angular-material-assets/img/icons/plus.svg\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Add User\"><md-icon icon=\"/assets/angular-material-assets/img/icons/user.svg\"></md-icon></md-button><md-button aria-label=\"Add Group\"><md-icon icon=\"/assets/angular-material-assets/img/icons/group.svg\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-direction</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>From which direction you would like the speed dial to appear relative to the trigger element.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-open <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Programmatically control whether or not the speed-dial is visible.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabSpeedDial/directive/mdFabTrigger.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-fab-trigger&gt;</code> directive is used inside of a <code>&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code> directive to mark an element (or elements) as the trigger and setup the proper event listeners.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>See the <code>&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code> directives for example usage.</p></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabToolbar/directive/mdFabToolbar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-fab-toolbar&gt;</code> directive is used present a toolbar of elements (usually <code>&lt;md-button&gt;</code>s) for quick access to common actions when a floating action button is activated (via click or keyboard navigation).</p><p>You may also easily position the trigger by applying one one of the following classes to the <code>&lt;md-fab-toolbar&gt;</code> element:</p><ul><li><code>md-fab-top-left</code></li><li><code>md-fab-top-right</code></li><li><code>md-fab-bottom-left</code></li><li><code>md-fab-bottom-right</code></li></ul><p>These CSS classes use <code>position: absolute</code>, so you need to ensure that the container element also uses <code>position: absolute</code> or <code>position: relative</code> in order for them to work.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-fab-toolbar md-direction=\"left\"><md-fab-trigger><md-button aria-label=\"Add...\"><md-icon icon=\"/assets/angular-material-assets/img/icons/plus.svg\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Add User\"><md-icon icon=\"/assets/angular-material-assets/img/icons/user.svg\"></md-icon></md-button><md-button aria-label=\"Add Group\"><md-icon icon=\"/assets/angular-material-assets/img/icons/group.svg\"></md-icon></md-button></md-fab-actions></md-fab-toolbar></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-direction</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>From which direction you would like the toolbar items to appear relative to the trigger element. Supports <code>left</code> and <code>right</code> directions.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-open <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Programmatically control whether or not the toolbar is visible.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/directive/mdGridList.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Grid lists are an alternative to standard list views. Grid lists are distinct from grids used for layouts and other visual presentations.</p><p>A grid list is best suited to presenting a homogenous data type, typically images, and is optimized for visual comprehension and differentiating between like data types.</p><p>A grid list is a continuous element consisting of tessellated, regular subdivisions called cells that contain tiles (<code>md-grid-tile</code>).</p><p><img src=\"//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png\" style=\"width: 300px; height: auto; margin-right: 16px;\" alt=\"Concept of grid explained visually\"> <img src=\"//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png\" style=\"width: 300px; height: auto;\" alt=\"Grid concepts legend\"></p><p>Cells are arrayed vertically and horizontally within the grid.</p><p>Tiles hold content and can span one or more cells vertically or horizontally.</p><h3 id=\"responsive-attributes\">Responsive Attributes</h3><p>The <code>md-grid-list</code> directive supports &quot;responsive&quot; attributes, which allow different <code>md-cols</code>, <code>md-gutter</code> and <code>md-row-height</code> values depending on the currently matching media query (as defined in <code>$mdConstant.MEDIA</code>).</p><p>In order to set a responsive attribute, first define the fallback value with the standard attribute name, then add additional attributes with the following convention: <code>{base-attribute-name}-{media-query-name}=&quot;{value}&quot;</code> (ie. <code>md-cols-lg=&quot;8&quot;</code>)</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>Basic:</p><hljs lang=\"html\"><md-grid-list md-cols=\"5\" md-gutter=\"1em\" md-row-height=\"4:3\"><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>Fixed-height rows:</p><hljs lang=\"html\"><md-grid-list md-cols=\"4\" md-row-height=\"200px\" ...=\"\"><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>Fit rows:</p><hljs lang=\"html\"><md-grid-list md-cols=\"4\" md-row-height=\"fit\" style=\"height: 400px;\" ...=\"\"><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>Using responsive attributes:</p><hljs lang=\"html\"><md-grid-list md-cols-sm=\"2\" md-cols-md=\"4\" md-cols-lg=\"8\" md-cols-gt-lg=\"12\" ...=\"\"><md-grid-tile></md-grid-tile></md-grid-list></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-cols</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Number of columns in the grid.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-row-height</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>One of</p><ul><li>CSS length - Fixed height rows (eg. <code>8px</code> or <code>1rem</code>)</li><li><code>{width}:{height}</code> - Ratio of width to height (eg. <code>md-row-height=&quot;16:9&quot;</code>)</li><li><code>&quot;fit&quot;</code> - Height will be determined by subdividing the available height by the number of rows</li></ul></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-gutter <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The amount of space between tiles in CSS units (default 1px)</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-layout <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Expression to evaluate after layout. Event object is available as <code>$event</code>, and contains performance information.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/directive/mdGridTile.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Tiles contain the content of an <code>md-grid-list</code>. They span one or more grid cells vertically or horizontally, and use <code>md-grid-tile-{footer,header}</code> to display secondary content.</p><h3 id=\"responsive-attributes\">Responsive Attributes</h3><p>The <code>md-grid-tile</code> directive supports &quot;responsive&quot; attributes, which allow different <code>md-rowspan</code> and <code>md-colspan</code> values depending on the currently matching media query (as defined in <code>$mdConstant.MEDIA</code>).</p><p>In order to set a responsive attribute, first define the fallback value with the standard attribute name, then add additional attributes with the following convention: <code>{base-attribute-name}-{media-query-name}=&quot;{value}&quot;</code> (ie. <code>md-colspan-sm=&quot;4&quot;</code>)</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>With header:</p><hljs lang=\"html\"><md-grid-tile><md-grid-tile-header><h3>This is a header</h3></md-grid-tile-header></md-grid-tile></hljs><p>With footer:</p><hljs lang=\"html\"><md-grid-tile><md-grid-tile-footer><h3>This is a footer</h3></md-grid-tile-footer></md-grid-tile></hljs><p>Spanning multiple rows/columns:</p><hljs lang=\"html\"><md-grid-tile md-colspan=\"2\" md-rowspan=\"3\"></md-grid-tile></hljs><p>Responsive attributes:</p><hljs lang=\"html\"><md-grid-tile md-colspan=\"1\" md-colspan-sm=\"3\" md-colspan-md=\"5\"></md-grid-tile></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-colspan <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The number of columns to span (default 1). Cannot exceed the number of columns in the grid. Supports interpolation.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-rowspan <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The number of rows to span (default 1). Supports interpolation.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/directive/mdInput.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>You can use any <code>&lt;input&gt;</code> or <code>&lt;textarea&gt;</code> element as a child of an <code>&lt;md-input-container&gt;</code>. This allows you to build complex forms for data entry.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-input-container><label>Color</label> <input type=\"text\" ng-model=\"color\" required=\"\" md-maxlength=\"10\"></md-input-container></hljs><h3>With Errors</h3><p><code>md-input-container</code> also supports errors using the standard <code>ng-messages</code> directives and animates the messages when they become visible using from the <code>ngEnter</code>/<code>ngLeave</code> events or the <code>ngShow</code>/<code>ngHide</code> events.</p><p>By default, the messages will be hidden until the input is in an error state. This is based off of the <code>md-is-error</code> expression of the <code>md-input-container</code>. This gives the user a chance to fill out the form before the errors become visible.</p><hljs lang=\"html\"><form name=\"colorForm\"><md-input-container><label>Favorite Color</label> <input name=\"favoriteColor\" ng-model=\"favoriteColor\" required=\"\"><div ng-messages=\"userForm.lastName.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></form></hljs><p>We automatically disable this auto-hiding functionality if you provide any of the following visibility directives on the <code>ng-messages</code> container:</p><ul><li><code>ng-if</code></li><li><code>ng-show</code>/<code>ng-hide</code></li><li><code>ng-switch-when</code>/<code>ng-switch-default</code></li></ul><p>You can also disable this functionality manually by adding the <code>md-auto-hide=&quot;false&quot;</code> expression to the <code>ng-messages</code> container. This may be helpful if you always want to see the error messages or if you are building your own visibilty directive.</p><p><em><b>Note:</b> The <code>md-auto-hide</code> attribute is a static string that is only checked upon initialization of the <code>ng-messages</code> directive to see if it equals the string <code>false</code>.</em></p><hljs lang=\"html\"><form name=\"userForm\"><md-input-container><label>Last Name</label> <input name=\"lastName\" ng-model=\"lastName\" required=\"\" md-maxlength=\"10\" minlength=\"4\"><div ng-messages=\"userForm.lastName.$error\" ng-show=\"userForm.lastName.$dirty\"><div ng-message=\"required\">This is required!</div><div ng-message=\"md-maxlength\">That&#39;s too long!</div><div ng-message=\"minlength\">That&#39;s too short!</div></div></md-input-container><md-input-container><label>Biography</label> <textarea name=\"bio\" ng-model=\"biography\" required=\"\" md-maxlength=\"150\"></textarea><div ng-messages=\"userForm.bio.$error\" ng-show=\"userForm.bio.$dirty\"><div ng-message=\"required\">This is required!</div><div ng-message=\"md-maxlength\">That&#39;s too long!</div></div></md-input-container><md-input-container><input aria-label=\"title\" ng-model=\"title\"></md-input-container><md-input-container><input placeholder=\"title\" ng-model=\"title\"></md-input-container></form></hljs><h3>Notes</h3><ul><li>Requires <a href=\"https://docs.angularjs.org/api/ngMessages\">ngMessages</a>.</li><li>Behaves like the <a href=\"https://docs.angularjs.org/api/ng/directive/input\">AngularJS input directive</a>.</li></ul><p>The <code>md-input</code> and <code>md-input-container</code> directives use very specific positioning to achieve the error animation effects. Therefore, it is <em>not</em> advised to use the Layout system inside of the <code>&lt;md-input-container&gt;</code> tags. Instead, use relative or absolute positioning.</p></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-maxlength <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The maximum number of characters allowed in this input. If this is specified, a character counter will be shown underneath the input.<br><br>The purpose of <strong><code>md-maxlength</code></strong> is exactly to show the max length counter text. If you don&#39;t want the counter text and only need &quot;plain&quot; validation, you can use the &quot;simple&quot; <code>ng-maxlength</code> or maxlength attributes.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Aria-label is required when no label is present. A warning message will be logged in the console if not present.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>An alternative approach to using aria-label when the label is not PRESENT. The placeholder text is copied to the aria-label attribute.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-autogrow <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, textareas will not grow automatically.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-detect-hidden <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, textareas will be sized properly when they are revealed after being hidden. This is off by default for performance reasons because it guarantees a reflow every digest cycle.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/directive/mdInputContainer.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-input-container&gt;</code> is the parent of any input or textarea element.</p><p>Input and textarea elements will not behave properly unless the md-input-container parent is provided.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-input-container><label>Username</label> <input type=\"text\" ng-model=\"user.name\"></md-input-container><md-input-container><label>Description</label> <textarea ng-model=\"user.description\"></textarea></md-input-container></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-is-error <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>When the given expression evaluates to true, the input container will go into error state. Defaults to erroring if the input has been touched and is invalid.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-float <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, placeholders will not be converted to floating labels.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/directive/mdIcon.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>md-icon</code> directive makes it easier to use vector-based icons in your app (as opposed to raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.</p><p>Icons should be consider view-only elements that should not be used directly as buttons; instead nest a <code>&lt;md-icon&gt;</code> inside a <code>md-button</code> to add hover and click features.</p><h3 id=\"icon-fonts\">Icon fonts</h3><p>Icon fonts are a technique in which you use a font where the glyphs in the font are your icons instead of text. Benefits include a straightforward way to bundle everything into a single HTTP request, simple scaling, easy color changing, and more.</p><p><code>md-icon</code> lets you consume an icon font by letting you reference specific icons in that font by name rather than character code.</p><h3 id=\"svg\">SVG</h3><p>For SVGs, the problem with using <code>&lt;img&gt;</code> or a CSS <code>background-image</code> is that you can&#39;t take advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG animation.</p><p><code>md-icon</code> makes it easier to use SVG icons by <em>inlining</em> the SVG into an <code>&lt;svg&gt;</code> element in the document. The most straightforward way of referencing an SVG icon is via URL, just like a traditional <code>&lt;img&gt;</code>. <code>$mdIconProvider</code>, as a convenience, lets you <em>name</em> an icon so you can reference it by name instead of URL throughout your templates.</p><p>Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can also be given a name, which acts as a namespace for individual icons, so you can reference them like <code>&quot;social:cake&quot;</code>.</p><p>When using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be easily loaded and used.When use font-icons, developers must following three (3) simple steps:</p><ol><li>Load the font library. e.g.<br>&lt;link href=&quot;<a href=\"https://fonts.googleapis.com/icon?family=Material+Icons\">https://fonts.googleapis.com/icon?family=Material+Icons</a>&quot; rel=&quot;stylesheet&quot;&gt;</li><li>Use either (a) font-icon class names or (b) font ligatures to render the font glyph by using its textual name</li><li>Use &lt;md-icon md-font-icon=&quot;classname&quot; /&gt; or<br>use &lt;md-icon md-font-set=&quot;font library classname or alias&quot;&gt; textual_name &lt;/md-icon&gt; or<br>use &lt;md-icon md-font-set=&quot;font library classname or alias&quot;&gt; numerical_character_reference &lt;/md-icon&gt;</li></ol><p>Full details for these steps can be found:</p><ul><li><a href=\"http://google.github.io/material-design-icons/\">http://google.github.io/material-design-icons/</a></li><li><a href=\"http://google.github.io/material-design-icons/#icon-font-for-the-web\">http://google.github.io/material-design-icons/#icon-font-for-the-web</a></li></ul><p>The Material Design icon style <code>.material-icons</code> and the icon font references are published in Material Design Icons:</p><ul><li><a href=\"http://www.google.com/design/icons/\">http://www.google.com/design/icons/</a></li><li><a href=\"https://www.google.com/design/icons/#ic_accessibility\">https://www.google.com/design/icons/#ic_accessibility</a></li></ul><p></p><h2 id=\"material_design_icons\">Material Design Icons</h2>Using the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and determine its textual name and character reference code. Click on any icon to see the slide-up information panel with details regarding a SVG download or information on the font-icon usage.<p></p><p><a href=\"https://www.google.com/design/icons/#ic_accessibility\" target=\"_blank\" style=\"border-bottom:none;\"><img src=\"https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png\" aria-label=\"Material Design Icon-Selector\" style=\"max-width:75%;padding-left:10%\"></a></p><p><span class=\"image_caption\">Click on the image above to link to the <a href=\"https://www.google.com/design/icons/#ic_accessibility\" target=\"_blank\">Material Design Icon-Selector</a>.</span></p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>When using SVGs:</p><hljs lang=\"html\"><md-icon md-svg-icon=\"social:android\" aria-label=\"android\"></md-icon><md-icon md-svg-src=\"/android.svg\" aria-label=\"android\"></md-icon><md-icon md-svg-src=\"{{ getAndroid() }}\" aria-label=\"android\"></md-icon></hljs><p>Use the <code>$mdIconProvider</code> to configure your application with svg iconsets.</p><hljs lang=\"js\">angular.module(&#39;appSvgIconSets&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;DemoCtrl&#39;, function($scope) {}) .config(function($mdIconProvider) { $mdIconProvider .iconSet(&#39;social&#39;, &#39;assets/angular-material-assets/img/icons/sets/social-icons.svg&#39;, 24) .defaultIconSet(&#39;assets/angular-material-assets/img/icons/sets/core-icons.svg&#39;, 24); });</hljs><p>When using Font Icons with classnames:</p><hljs lang=\"html\"><md-icon md-font-icon=\"android\" aria-label=\"android\"></md-icon><md-icon class=\"icon_home\" aria-label=\"Home\"></md-icon></hljs><p>When using Material Font Icons with ligatures:</p><hljs lang=\"html\"><md-icon>face</md-icon><md-icon md-font-set=\"material-icons\">face</md-icon><md-icon>#xE87C;</md-icon><md-icon class=\"material-icons md-light md-48\">face</md-icon></hljs><p>When using other Font-Icon libraries:</p><hljs lang=\"js\">// Specify a font-icon style alias angular.config(function($mdIconProvider) { $mdIconProvider.fontSet(&#39;fa&#39;, &#39;fontawesome&#39;); });</hljs><hljs lang=\"html\"><md-icon md-font-set=\"fa\">email</md-icon></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-font-icon</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>String name of CSS icon associated with the font-face will be used to render the icon. Requires the fonts and the named CSS styles to be preloaded.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-font-set</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>CSS style name associated with the font library; which will be assigned as the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname; internally use <code>$mdIconProvider.fontSet(&lt;alias&gt;)</code> to determine the style name.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-svg-src</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>String URL (or expression) used to load, cache, and display an external SVG.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-svg-icon</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>md-svg-icon String name used for lookup of the icon from the internal cache; interpolated strings or expressions may also be used. Specific set names can be used with the syntax <code>&lt;set name&gt;:&lt;icon name&gt;</code>.<br><br>To use icon sets, developers are required to pre-register the sets using the <code>$mdIconProvider</code> service.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Labels icon for accessibility. If an empty string is provided, icon will be hidden from accessibility layer with <code>aria-hidden=&quot;true&quot;</code>. If there&#39;s no aria-label on the icon nor a label on the parent element, a warning will be logged to the console.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">alt <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Labels icon for accessibility. If an empty string is provided, icon will be hidden from accessibility layer with <code>aria-hidden=&quot;true&quot;</code>. If there&#39;s no alt on the icon nor a label on the parent element, a warning will be logged to the console.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/service/$mdIcon.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>$mdIcon</code> service is a function used to lookup SVG icons.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">function SomeDirective($mdIcon) { // See if the icon has already been loaded, if not // then lookup the icon from the registry cache, load and cache // it for future requests. // NOTE: ID queries require configuration with $mdIconProvider $mdIcon(&#39;android&#39;).then(function(iconEl) { element.append(iconEl); }); $mdIcon(&#39;work:chair&#39;).then(function(iconEl) { element.append(iconEl); }); // Load and cache the external SVG using a URL $mdIcon(&#39;assets/angular-material-assets/img/icons/android.svg&#39;).then(function(iconEl) { element.append(iconEl); }); };</hljs><p>NOTE: The <code>&lt;md-icon /&gt;</code> directive internally uses the <code>$mdIcon</code> service to query, loaded, and instantiate SVG DOM elements.</p></section><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* id</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is performed. The Id may be a unique icon ID or may include an iconSet ID prefix.</p><p>For the <strong>id</strong> query to work properly, this means that all id-to-URL mappings must have been previously configured using the <code>$mdIconProvider</code>.</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>Clone of the initial SVG DOM element; which was created from the SVG markup in the SVG data file.</p></td></tr></tbody></table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/service/$mdIconProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdIconProvider</code> is used only to register icon IDs with URLs. These configuration features allow icons and icon sets to be pre-registered and associated with source URLs <strong>before</strong> the <code>&lt;md-icon /&gt;</code> directives are compiled.</p><p>If using font-icons, the developer is responsible for loading the fonts.</p><p>If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded internally by the <code>$mdIcon</code> service using the <code>$http</code> service. When an SVG is requested by name/ID, the <code>$mdIcon</code> service searches its registry for the associated source URL; that URL is used to on-demand load and parse the SVG dynamically.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">app.config(function($mdIconProvider) { // Configure URLs for icons specified by [set:]id. $mdIconProvider .defaultFontSet( &#39;fontawesome&#39; ) .defaultIconSet(&#39;my/app/icons.svg&#39;) // Register a default set of SVG icons .iconSet(&#39;social&#39;, &#39;my/app/social.svg&#39;) // Register a named icon set of SVGs .icon(&#39;android&#39;, &#39;my/app/android.svg&#39;) // Register a specific icon (by name) .icon(&#39;work:chair&#39;, &#39;my/app/chair.svg&#39;); // Register icon in a specific set });</hljs><p>SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime <strong>startup</strong> process (shown below):</p><hljs lang=\"js\">app.config(function($mdIconProvider) { // Register a default set of SVG icon definitions $mdIconProvider.defaultIconSet(&#39;my/app/icons.svg&#39;) }) .run(function($http, $templateCache){ // Pre-fetch icons sources by URL and cache in the $templateCache... // subsequent $http calls will look there first. var urls = [ &#39;imy/app/icons.svg&#39;, &#39;assets/angular-material-assets/img/icons/android.svg&#39;]; angular.forEach(urls, function(url) { $http.get(url, {cache: $templateCache}); }); });</hljs><p>NOTE: the loaded SVG data is subsequently cached internally for future requests.</p></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"icon\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.icon(id, url, [viewBoxSize]);\n</code></h3><div class=\"service-desc\"><p>Register a source URL for a specific icon name; the name may include optional &#39;icon set&#39; name prefix. These icons will later be retrieved from the cache using <code>$mdIcon( &lt;icon name&gt; )</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* id</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Icon name/id used to register the icon</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* url</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>specifies the external location for the data file. Used internally by <code>$http</code> to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">viewBoxSize <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Sets the width and height the icon&#39;s viewBox. It is ignored for icons with an existing viewBox. Default size is 24.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div></li><li id=\"iconSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.iconSet(id, url, [viewBoxSize]);\n</code></h3><div class=\"service-desc\"><p>Register a source URL for a &#39;named&#39; set of icons; group of SVG definitions where each definition has an icon id. Individual icons can be subsequently retrieved from this cached set using <code>$mdIcon(&lt;icon set name&gt;:&lt;icon name&gt;)</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* id</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Icon name/id used to register the iconset</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* url</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>specifies the external location for the data file. Used internally by <code>$http</code> to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">viewBoxSize <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Sets the width and height of the viewBox of all icons in the set. It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size. Default value is 24.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div></li><li id=\"defaultIconSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.defaultIconSet(url, [viewBoxSize]);\n</code></h3><div class=\"service-desc\"><p>Register a source URL for the default &#39;named&#39; set of icons. Unless explicitly registered, subsequent lookups of icons will failover to search this &#39;default&#39; icon set. Icon can be retrieved from this cached, default set using <code>$mdIcon(&lt;name&gt;)</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* url</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>specifies the external location for the data file. Used internally by <code>$http</code> to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">viewBoxSize <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Sets the width and height of the viewBox of all icons in the set. It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size. Default value is 24.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div></li><li id=\"defaultFontSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.defaultFontSet(name);\n</code></h3><div class=\"service-desc\"><p>When using Font-Icons, Angular Material assumes the the Material Design icons will be used and automatically configures the default font-set == &#39;material-icons&#39;. Note that the font-set references the font-icon library class style that should be applied to the <code>&lt;md-icon&gt;</code>.</p><p>Configuring the default means that the attributes <code>md-font-set=&quot;material-icons&quot;</code> or <code>class=&quot;material-icons&quot;</code> do not need to be explicitly declared on the <code>&lt;md-icon&gt;</code> markup. For example:</p><p><code>&lt;md-icon&gt; face &lt;/md-icon&gt;</code> will render as <code>&lt;span class=&quot;material-icons&quot;&gt; face &lt;/span&gt;</code>, and</p><p><code>&lt;md-icon md-font-set=&quot;fa&quot;&gt; face &lt;/md-icon&gt;</code> will render as <code>&lt;span class=&quot;fa&quot;&gt; face &lt;/span&gt;</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* name</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>of the font-library style that should be applied to the md-icon DOM element</p></td></tr></tbody></table></div></li><li id=\"defaultViewBoxSize\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.defaultViewBoxSize([viewBoxSize]);\n</code></h3><div class=\"service-desc\"><p>While <code>&lt;md-icon /&gt;</code> markup can also be style with sizing CSS, this method configures the default width <strong>and</strong> height used for all icons; unless overridden by specific CSS. The default sizing is (24px, 24px).</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">viewBoxSize <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Sets the width and height of the viewBox for an icon or an icon set. All icons in a set should be the same size. The default value is 24.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/directive/mdList.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-list&gt;</code> directive is a list container for 1..n <code>&lt;md-list-item&gt;</code> tags.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"item in todos\"><md-checkbox ng-model=\"item.done\"></md-checkbox><div class=\"md-list-item-text\"><h3>{{item.title}}</h3><p>{{item.description}}</p></div></md-list-item></md-list></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/directive/mdListItem.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-list-item&gt;</code> directive is a container intended for row items in a <code>&lt;md-list&gt;</code> container. The <code>md-2-line</code> and <code>md-3-line</code> classes can be added to a <code>&lt;md-list-item&gt;</code> to increase the height with 22px and 40px respectively.</p><h2 id=\"css\">CSS</h2><p><code>.md-avatar</code> - class for image avatars</p><p><code>.md-avatar-icon</code> - class for icon avatars</p><p><code>.md-offset</code> - on content without an avatar</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-list><md-list-item><img class=\"md-avatar\" ng-src=\"path/to/img\"> <span>Item content in list</span></md-list-item><md-list-item><md-icon class=\"md-avatar-icon\" md-svg-icon=\"communication:phone\"></md-icon><span>Item content in list</span></md-list-item></md-list></hljs><p><em><strong>Note:</strong> We automatically apply special styling when the inner contents are wrapped inside of a <code>&lt;md-button&gt;</code> tag. This styling is automatically ignored for <code>class=&quot;md-secondary&quot;</code> buttons and you can include a class of <code>class=&quot;md-exclude&quot;</code> if you need to use a non-secondary button that is inside the list, but does not wrap the contents.</em></p></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu/directive/mdMenu.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Menus are elements that open when clicked. They are useful for displaying additional options within the context of an action.</p><p>Every <code>md-menu</code> must specify exactly two child elements. The first element is what is left in the DOM and is used to open the menu. This element is called the trigger element. The trigger element&#39;s scope has access to <code>$mdOpenMenu($event)</code> which it may call to open the menu. By passing $event as argument, the corresponding event is stopped from propagating up the DOM-tree.</p><p>The second element is the <code>md-menu-content</code> element which represents the contents of the menu when it is open. Typically this will contain <code>md-menu-item</code>s, but you can do custom content as well.</p><hljs lang=\"html\"><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" class=\"md-icon-button\" aria-label=\"Open sample menu\"><md-icon md-svg-icon=\"call:phone\"></md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click=\"doSomething()\">Do Something</md-button></md-menu-item></md-menu-content></md-menu></hljs><h2 id=\"sizing-menus\">Sizing Menus</h2><p>The width of the menu when it is open may be specified by specifying a <code>width</code> attribute on the <code>md-menu-content</code> element. See the <a href=\"http://www.google.com/design/spec/components/menus.html#menus-specs\">Material Design Spec</a> for more information.</p><h2 id=\"aligning-menus\">Aligning Menus</h2><p>When a menu opens, it is important that the content aligns with the trigger element. Failure to align menus can result in jarring experiences for users as content suddenly shifts. To help with this, <code>md-menu</code> provides serveral APIs to help with alignment.</p><h3 id=\"target-mode\">Target Mode</h3><p>By default, <code>md-menu</code> will attempt to align the <code>md-menu-content</code> by aligning designated child elements in both the trigger and the menu content.</p><p>To specify the alignment element in the <code>trigger</code> you can use the <code>md-menu-origin</code> attribute on a child element. If no <code>md-menu-origin</code> is specified, the <code>md-menu</code> will be used as the origin element.</p><p>Similarly, the <code>md-menu-content</code> may specify a <code>md-menu-align-target</code> for a <code>md-menu-item</code> to specify the node that it should try and align with.</p><p>In this example code, we specify an icon to be our origin element, and an icon in our menu content to be our alignment target. This ensures that both icons are aligned when the menu opens.</p><hljs lang=\"html\"><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" class=\"md-icon-button\" aria-label=\"Open some menu\"><md-icon md-menu-origin=\"\" md-svg-icon=\"call:phone\"></md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click=\"doSomething()\" aria-label=\"Do something\"><md-icon md-menu-align-target=\"\" md-svg-icon=\"call:phone\"></md-icon>Do Something</md-button></md-menu-item></md-menu-content></md-menu></hljs><p>Sometimes we want to specify alignment on the right side of an element, for example if we have a menu on the right side a toolbar, we want to right align our menu content.</p><p>We can specify the origin by using the <code>md-position-mode</code> attribute on both the <code>x</code> and <code>y</code> axis. Right now only the <code>x-axis</code> has more than one option. You may specify the default mode of <code>target target</code> or <code>target-right target</code> to specify a right-oriented alignment target. See the position section of the demos for more examples.</p><h3 id=\"menu-offsets\">Menu Offsets</h3><p>It is sometimes unavoidable to need to have a deeper level of control for the positioning of a menu to ensure perfect alignment. <code>md-menu</code> provides the <code>md-offset</code> attribute to allow pixel level specificty of adjusting the exact positioning.</p><p>This offset is provided in the format of <code>x y</code> or <code>n</code> where <code>n</code> will be used in both the <code>x</code> and <code>y</code> axis.</p><p>For example, to move a menu by <code>2px</code> from the top, we can use:</p><hljs lang=\"html\"><md-menu md-offset=\"2 0\"></md-menu></hljs><h3 id=\"preventing-close\">Preventing close</h3><p>Sometimes you would like to be able to click on a menu item without having the menu close. To do this, ngMaterial exposes the <code>md-prevent-menu-close</code> attribute which can be added to a button inside a menu to stop the menu from automatically closing. You can then close the menu programatically by injecting <code>$mdMenu</code> and calling <code>$mdMenu.hide()</code>.</p><hljs lang=\"html\"><md-menu-item><md-button ng-click=\"doSomething()\" aria-label=\"Do something\" md-prevent-menu-close=\"md-prevent-menu-close\"><md-icon md-menu-align-target=\"\" md-svg-icon=\"call:phone\"></md-icon>Do Something</md-button></md-menu-item></hljs></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" class=\"md-icon-button\"><md-icon md-svg-icon=\"call:phone\"></md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click=\"doSomething()\">Do Something</md-button></md-menu-item></md-menu-content></md-menu></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-position-mode</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The position mode in the form of <code>x</code>, <code>y</code>. Default value is <code>target</code>,<code>target</code>. Right now the <code>x</code> axis also suppports <code>target-right</code>.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-offset</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>An offset to apply to the dropdown after positioning <code>x</code>, <code>y</code>. Default value is <code>0</code>,<code>0</code>.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu-bar/directive/mdMenuBar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Menu bars are containers that hold multiple menus. They change the behavior and appearence of the <code>md-menu</code> directive to behave similar to an operating system provided menu.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-menu-bar><md-menu><button ng-click=\"$mdOpenMenu()\">File</button><md-menu-content><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'share\', $event)\">Share...</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-menu-item><md-menu><md-button ng-click=\"$mdOpenMenu()\">New</md-button><md-menu-content><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Document\', $event)\">Document</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Spreadsheet\', $event)\">Spreadsheet</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Presentation\', $event)\">Presentation</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Form\', $event)\">Form</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Drawing\', $event)\">Drawing</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item></md-menu-item></md-menu-content></md-menu></md-menu-bar></hljs><h2 id=\"menu-bar-controls\">Menu Bar Controls</h2><p>You may place <code>md-menu-items</code> that function as controls within menu bars. There are two modes that are exposed via the <code>type</code> attribute of the <code>md-menu-item</code>. <code>type=&quot;checkbox&quot;</code> will function as a boolean control for the <code>ng-model</code> attribute of the <code>md-menu-item</code>. <code>type=&quot;radio&quot;</code> will function like a radio button, setting the <code>ngModel</code> to the <code>string</code> value of the <code>value</code> attribute. If you need non-string values, you can use <code>ng-value</code> to provide an expression (this is similar to how angular&#39;s native <code>input[type=radio]</code> works.</p><hljs lang=\"html\"><md-menu-bar><md-menu><button ng-click=\"$mdOpenMenu()\">Sample Menu</button><md-menu-content><md-menu-item type=\"checkbox\" ng-model=\"settings.allowChanges\">Allow changes</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item type=\"radio\" ng-model=\"settings.mode\" ng-value=\"1\">Mode 1</md-menu-item><md-menu-item type=\"radio\" ng-model=\"settings.mode\" ng-value=\"1\">Mode 2</md-menu-item><md-menu-item type=\"radio\" ng-model=\"settings.mode\" ng-value=\"1\">Mode 3</md-menu-item></md-menu-content></md-menu></md-menu-bar></hljs><h3 id=\"nesting-menus\">Nesting Menus</h3><p>Menus may be nested within menu bars. This is commonly called cascading menus. To nest a menu place the nested menu inside the content of the <code>md-menu-item</code>.</p><hljs lang=\"html\"><md-menu-item><md-menu><button ng-click=\"$mdOpenMenu()\">New<md-menu-content><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Document\', $event)\">Document</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Spreadsheet\', $event)\">Spreadsheet</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Presentation\', $event)\">Presentation</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Form\', $event)\">Form</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Drawing\', $event)\">Drawing</md-button></md-menu-item></md-menu-content></button></md-menu></md-menu-item></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressCircular/directive/mdProgressCircular.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The circular progress directive is used to make loading content in your app as delightful and painless as possible by minimizing the amount of visual change a user sees before they can view and interact with content.</p><p>For operations where the percentage of the operation completed can be determined, use a determinate indicator. They give users a quick sense of how long an operation will take.</p><p>For operations where the user is asked to wait a moment while something finishes up, and it’s not necessary to expose what&#39;s happening behind the scenes and how long it will take, use an indeterminate indicator.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-progress-circular md-mode=\"determinate\" value=\"...\"></md-progress-circular><md-progress-circular md-mode=\"determinate\" ng-value=\"...\"></md-progress-circular><md-progress-circular md-mode=\"determinate\" value=\"...\" md-diameter=\"100\"></md-progress-circular><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-mode</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Select from one of two modes: <strong>&#39;determinate&#39;</strong> and <strong>&#39;indeterminate&#39;</strong>.</p><p>Note: if the <code>md-mode</code> value is set as undefined or specified as not 1 of the two (2) valid modes, then <code>.ng-hide</code> will be auto-applied as a style to the component.</p><p>Note: if not configured, the <code>md-mode=&quot;indeterminate&quot;</code> will be auto injected as an attribute. If <code>value=&quot;&quot;</code> is also specified, however, then <code>md-mode=&quot;determinate&quot;</code> would be auto-injected instead.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>In determinate mode, this number represents the percentage of the circular progress. Default: 0</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-diameter <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>This specifies the diamter of the circular progress. The value may be a percentage (eg &#39;25%&#39;) or a pixel-size value (eg &#39;48&#39;). If this attribute is not present then a default value of &#39;48px&#39; is assumed.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressLinear/directive/mdProgressLinear.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The linear progress directive is used to make loading content in your app as delightful and painless as possible by minimizing the amount of visual change a user sees before they can view and interact with content.</p><p>Each operation should only be represented by one activity indicator For example: one refresh operation should not display both a refresh bar and an activity circle.</p><p>For operations where the percentage of the operation completed can be determined, use a determinate indicator. They give users a quick sense of how long an operation will take.</p><p>For operations where the user is asked to wait a moment while something finishes up, and it’s not necessary to expose what&#39;s happening behind the scenes and how long it will take, use an indeterminate indicator.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-progress-linear md-mode=\"determinate\" value=\"...\"></md-progress-linear><md-progress-linear md-mode=\"determinate\" ng-value=\"...\"></md-progress-linear><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><md-progress-linear md-mode=\"buffer\" value=\"...\" md-buffer-value=\"...\"></md-progress-linear><md-progress-linear md-mode=\"query\"></md-progress-linear></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-mode</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Select from one of four modes: determinate, indeterminate, buffer or query.</p><p>Note: if the <code>md-mode</code> value is set as undefined or specified as 1 of the four (4) valid modes, then <code>.ng-hide</code> will be auto-applied as a style to the component.</p><p>Note: if not configured, the <code>md-mode=&quot;indeterminate&quot;</code> will be auto injected as an attribute. If <code>value=&quot;&quot;</code> is also specified, however, then <code>md-mode=&quot;determinate&quot;</code> would be auto-injected instead.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-buffer-value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/directive/mdRadioButton.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-radio-button&gt;</code>directive is the child directive required to be used within <code>&lt;md-radio-group&gt;</code> elements.</p><p>While similar to the <code>&lt;input type=&quot;radio&quot; ng-model=&quot;&quot; value=&quot;&quot;&gt;</code> directive, the <code>&lt;md-radio-button&gt;</code> directive provides ink effects, ARIA support, and supports use within named radio groups.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-radio-button value=\"1\" aria-label=\"Label 1\">Label 1</md-radio-button><md-radio-button ng-model=\"color\" ng-value=\"specialValue\" aria-label=\"Green\">Green</md-radio-button></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ngModel</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Assignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ngValue</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Angular expression which sets the value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* value</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ngChange <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Angular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">name <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Property name of the form under which the control is published.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Adds label to radio button for accessibility. Defaults to radio button&#39;s text. If no text content is available, a warning will be logged.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/directive/mdRadioGroup.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-radio-group&gt;</code> directive identifies a grouping container for the 1..n grouped radio buttons; specified using nested <code>&lt;md-radio-button&gt;</code> tags.</p><p>As per the <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">material design spec</a> the radio button is in the accent color by default. The primary color palette may be used with the <code>md-primary</code> class.</p><p>Note: <code>&lt;md-radio-group&gt;</code> and <code>&lt;md-radio-button&gt;</code> handle tabindex differently than the native <code>&lt;input type=&#39;radio&#39;&gt;</code> controls. Whereas the native controls force the user to tab through all the radio buttons, <code>&lt;md-radio-group&gt;</code> is focusable, and by default the <code>&lt;md-radio-button&gt;</code>s are not.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-radio-group ng-model=\"selected\"><md-radio-button ng-repeat=\"d in colorOptions\" ng-value=\"d.value\" aria-label=\"{{ d.label }}\">{{ d.label }}</md-radio-button></md-radio-group></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Assignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Use of attribute indicates flag to disable ink ripple effects.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.select/directive/mdSelect.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Displays a select box, bound to an ng-model.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>With a placeholder (label and aria-label are added dynamically)</p><hljs lang=\"html\"><md-input-container><md-select ng-model=\"someModel\" placeholder=\"Select a state\"><md-option ng-value=\"opt\" ng-repeat=\"opt in neighborhoods2\">{{ opt }}</md-option></md-select></md-input-container></hljs><p>With an explicit label</p><hljs lang=\"html\"><md-input-container><label>State</label><md-select ng-model=\"someModel\"><md-option ng-value=\"opt\" ng-repeat=\"opt in neighborhoods2\">{{ opt }}</md-option></md-select></md-input-container></hljs><h2 id=\"selects-and-object-equality\">Selects and object equality</h2><p>When using a <code>md-select</code> to pick from a list of objects, it is important to realize how javascript handles equality. Consider the following example:</p><hljs lang=\"js\">angular.controller(&#39;MyCtrl&#39;, function($scope) { $scope.users = [ { id: 1, name: &#39;Bob&#39; }, { id: 2, name: &#39;Alice&#39; }, { id: 3, name: &#39;Steve&#39; } ]; $scope.selectedUser = { id: 1, name: &#39;Bob&#39; }; });</hljs><hljs lang=\"html\"><div ng-controller=\"MyCtrl\"><md-select ng-model=\"selectedUser\"><md-option ng-value=\"user\" ng-repeat=\"user in users\">{{ user.name }}</md-option></md-select></div></hljs><p>At first one might expect that the select should be populated with &quot;Bob&quot; as the selected user. However, this is not true. To determine whether something is selected, <code>ngModelController</code> is looking at whether <code>$scope.selectedUser == (any user in $scope.users);</code>;</p><p>Javascript&#39;s <code>==</code> operator does not check for deep equality (ie. that all properties on the object are the same), but instead whether the objects are <em>the same object in memory</em>. In this case, we have two instances of identical objects, but they exist in memory as unique entities. Because of this, the select will have no value populated for a selected user.</p><p>To get around this, <code>ngModelController</code> provides a <code>track by</code> option that allows us to specify a different expression which will be used for the equality operator. As such, we can update our <code>html</code> to make use of this by specifying the <code>ng-model-options=&quot;{trackBy: &#39;$value.id&#39;}&quot;</code> on the <code>md-select</code> element. This converts our equality expression to be <code>$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));</code> which results in Bob being selected as desired.</p><p>Working HTML:</p><hljs lang=\"html\"><div ng-controller=\"MyCtrl\"><md-select ng-model=\"selectedUser\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-value=\"user\" ng-repeat=\"user in users\">{{ user.name }}</md-option></md-select></div></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>The model!</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">multiple <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether it&#39;s multiple.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-close <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Expression to be evaluated when the select is closed.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder hint text.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Optional label for accessibility. Only necessary if no placeholder or explicit label is present.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-container-class <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Class list to get applied to the <code>.md-select-menu-container</code> element (for custom styling).</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/directive/mdSidenav.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>A Sidenav component that can be opened and closed programatically.</p><p>By default, upon opening it will slide out on top of the main content area.</p><p>For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default. It can be overridden with the <code>md-autofocus</code> directive on the child element you want focused.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div layout=\"row\" ng-controller=\"MyController\"><md-sidenav md-component-id=\"left\" class=\"md-sidenav-left\">Left Nav!</md-sidenav><md-content>Center Content<md-button ng-click=\"openLeftMenu()\">Open Left Menu</md-button></md-content><md-sidenav md-component-id=\"right\" md-is-locked-open=\"$mdMedia(\'min-width: 333px\')\" class=\"md-sidenav-right\"><form><md-input-container><label for=\"testInput\">Test input</label> <input id=\"testInput\" type=\"text\" ng-model=\"data\" md-autofocus=\"\"></md-input-container></form></md-sidenav></div></hljs><hljs lang=\"js\">var app = angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdSidenav) { $scope.openLeftMenu = function() { $mdSidenav(&#39;left&#39;).toggle(); }; });</hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-is-open <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>A model bound to whether the sidenav is opened.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-component-id <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>componentId to use with $mdSidenav service.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-is-locked-open <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>When this expression evalutes to true, the sidenav &#39;locks open&#39;: it falls into the content&#39;s flow instead of appearing over it. This overrides the <code>is-open</code> attribute.</p><p>The $mdMedia() service is exposed to the is-locked-open attribute, which can be given a media query or one of the <code>sm</code>, <code>gt-sm</code>, <code>md</code>, <code>gt-md</code>, <code>lg</code> or <code>gt-lg</code> presets. Examples:</p><ul><li><code>&lt;md-sidenav md-is-locked-open=&quot;shouldLockOpen&quot;&gt;&lt;/md-sidenav&gt;</code></li><li><code>&lt;md-sidenav md-is-locked-open=&quot;$mdMedia(&#39;min-width: 1000px&#39;)&quot;&gt;&lt;/md-sidenav&gt;</code></li><li><code>&lt;md-sidenav md-is-locked-open=&quot;$mdMedia(&#39;sm&#39;)&quot;&gt;&lt;/md-sidenav&gt;</code> (locks open on small screens)</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/directive/mdSidenavFocus.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>mdSidenavFocus</code> provides a way to specify the focused element when a sidenav opens. This is completely optional, as the sidenav itself is focused by default.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-sidenav><form><md-input-container><label for=\"testInput\">Label</label> <input id=\"testInput\" type=\"text\" md-sidenav-focus=\"\"></md-input-container></form></md-sidenav></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/service/$mdSidenav.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdSidenav</code> makes it easy to interact with multiple sidenavs in an app.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">// Async lookup for sidenav instance; will resolve when the instance is available $mdSidenav(componentId).then(function(instance) { $log.debug( componentId + &quot;is now ready&quot; ); }); // Async toggle the given sidenav; // when instance is known ready and lazy lookup is not needed. $mdSidenav(componentId) .toggle() .then(function(){ $log.debug(&#39;toggled&#39;); }); // Async open the given sidenav $mdSidenav(componentId) .open() .then(function(){ $log.debug(&#39;opened&#39;); }); // Async close the given sidenav $mdSidenav(componentId) .close() .then(function(){ $log.debug(&#39;closed&#39;); }); // Sync check to see if the specified sidenav is set to be open $mdSidenav(componentId).isOpen(); // Sync check to whether given sidenav is locked open // If this is true, the sidenav will be open regardless of close() $mdSidenav(componentId).isLockedOpen();</hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.slider/directive/mdSlider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-slider&gt;</code> component allows the user to choose from a range of values.</p><p>As per the <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">material design spec</a> the slider is in the accent color by default. The primary color palette may be used with the <code>md-primary</code> class.</p><p>It has two modes: &#39;normal&#39; mode, where the user slides between a wide range of values, and &#39;discrete&#39; mode, where the user slides between only a few select values.</p><p>To enable discrete mode, add the <code>md-discrete</code> attribute to a slider, and use the <code>step</code> attribute to change the distance between values the user is allowed to pick.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p></p><h4>Normal Mode</h4><p></p><hljs lang=\"html\"><md-slider ng-model=\"myValue\" min=\"5\" max=\"500\"></md-slider></hljs><h4>Discrete Mode</h4><hljs lang=\"html\"><md-slider md-discrete=\"\" ng-model=\"myDiscreteValue\" step=\"10\" min=\"10\" max=\"130\"></md-slider></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-discrete <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether to enable discrete mode.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">step <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The distance between values the user is allowed to pick. Default 1.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">min <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The minimum value the user is allowed to pick. Default 0.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">max <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The maximum value the user is allowed to pick. Default 100.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sticky/service/$mdSticky.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>$mdSticky</code>service provides a mixin to make elements sticky.</p></div><div><section class=\"api-section\"><section class=\"api-section\"></section><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td></td><td class=\"description\"><p>A <code>$mdSticky</code> function that takes three arguments:</p><ul><li><code>scope</code></li><li><code>element</code>: The element that will be &#39;sticky&#39;</li><li><code>elementClone</code>: A clone of the element, that will be shown when the user starts scrolling past the original element. If not provided, it will use the result of <code>element.clone()</code>.</li></ul></td></tr></tbody></table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.subheader/directive/mdSubheader.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-subheader&gt;</code> directive is a subheader for a section. By default it is sticky. You can make it not sticky by applying the <code>md-no-sticky</code> class to the subheader.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-subheader>Online Friends</md-subheader></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeDown.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The md-swipe-down directive allows you to specify custom behavior when an element is swiped down.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-down=\"onSwipDown()\">Swipe me down!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeLeft.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The md-swipe-left directive allows you to specify custom behavior when an element is swiped left.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-left=\"onSwipeLeft()\">Swipe me left!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeRight.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The md-swipe-right directive allows you to specify custom behavior when an element is swiped right.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-right=\"onSwipeRight()\">Swipe me right!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeUp.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The md-swipe-up directive allows you to specify custom behavior when an element is swiped up.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-up=\"onSwipeUp()\">Swipe me up!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.switch/directive/mdSwitch.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-switch ng-model=\"isActive\" aria-label=\"Finished?\">Finished ?</md-switch><md-switch md-no-ink=\"\" ng-model=\"hasInk\" aria-label=\"No Ink Effects\">No Ink Effects</md-switch><md-switch ng-disabled=\"true\" ng-model=\"isDisabled\" aria-label=\"Disabled\">Disabled</md-switch></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Assignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">name <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Property name of the form under which the control is published.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-true-value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>The value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-false-value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>The value to which the expression should be set when not selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-change <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Angular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-disabled <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>En/Disable based on the expression.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Use of attribute indicates use of ripple ink effects.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Publish the button label used by screen-readers for accessibility. Defaults to the switch&#39;s text.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/directive/mdTab.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Use the <code>&lt;md-tab&gt;</code> a nested directive used within <code>&lt;md-tabs&gt;</code> to specify a tab with a <strong>label</strong> and optional <em>view content</em>.</p><p>If the <code>label</code> attribute is not specified, then an optional <code>&lt;md-tab-label&gt;</code> tag can be used to specify more complex tab header markup. If neither the <strong>label</strong> nor the <strong>md-tab-label</strong> are specified, then the nested markup of the <code>&lt;md-tab&gt;</code> is used as the tab header markup.</p><p>Please note that if you use <code>&lt;md-tab-label&gt;</code>, your content <strong>MUST</strong> be wrapped in the <code>&lt;md-tab-body&gt;</code> tag. This is to define a clear separation between the tab content and the tab label.</p><p>This container is used by the TabsController to show/hide the active tab&#39;s content view. This synchronization is automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can be initiated via data binding changes, programmatic invocation, or user gestures.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-tab label=\"\" disabled=\"\" md-on-select=\"\" md-on-deselect=\"\"><h3>My Tab content</h3></md-tab><md-tab><md-tab-label><h3>My Tab content</h3></md-tab-label><md-tab-body><p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p></md-tab-body></md-tab></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Optional attribute to specify a simple string as the tab label</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-disabled <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If present, disabled tab selection.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-deselect <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Expression to be evaluated after the tab has been de-selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-select <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Expression to be evaluated after the tab has been selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-active <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When true, sets the active tab. Note: There can only be one active tab at a time.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/directive/mdTabs.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-tabs&gt;</code> directive serves as the container for 1..n <code>&lt;md-tab&gt;</code> child directives to produces a Tabs components. In turn, the nested <code>&lt;md-tab&gt;</code> directive is used to specify a tab label for the <strong>header button</strong> and a [optional] tab view content that will be associated with each tab button.</p><p>Below is the markup for its simplest usage:</p><hljs lang=\"html\"><md-tabs><md-tab label=\"Tab #1\"></md-tab><md-tab label=\"Tab #2\"></md-tab><md-tab label=\"Tab #3\"></md-tab></md-tabs></hljs><p>Tabs supports three (3) usage scenarios:</p><ol><li>Tabs (buttons only)</li><li>Tabs with internal view content</li><li>Tabs with external view content</li></ol><p><strong>Tab-only</strong> support is useful when tab buttons are used for custom navigation regardless of any other components, content, or views. <strong>Tabs with internal views</strong> are the traditional usages where each tab has associated view content and the view switching is managed internally by the Tabs component. <strong>Tabs with external view content</strong> is often useful when content associated with each tab is independently managed and data-binding notifications announce tab selection changes.</p><p>Additional features also include:</p><ul><li>Content can include any markup.</li><li>If a tab is disabled while active/selected, then the next tab will be auto-selected.</li></ul><h3 id=\"explanation-of-tab-stretching\">Explanation of tab stretching</h3><p>Initially, tabs will have an inherent size. This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS. Calculations will be based on this size.</p><p>On mobile devices, tabs will be expanded to fill the available horizontal space. When this happens, all tabs will become the same size.</p><p>On desktops, by default, stretching will never occur.</p><p>This default behavior can be overridden through the <code>md-stretch-tabs</code> attribute. Here is a table showing when stretching will occur:</p><table><thead><tr><th><code>md-stretch-tabs</code></th><th>mobile</th><th>desktop</th></tr></thead><tbody><tr><td><code>auto</code></td><td>stretched</td><td>---</td></tr><tr><td><code>always</code></td><td>stretched</td><td>stretched</td></tr><tr><td><code>never</code></td><td>---</td><td>---</td></tr></tbody></table></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-tabs md-selected=\"selectedIndex\"><img ng-src=\"assets/angular-material-assets/img/angular.png\" class=\"centered\"><md-tab ng-repeat=\"tab in tabs | orderBy:predicate:reversed\" md-on-select=\"onTabSelected(tab)\" md-on-deselect=\"announceDeselected(tab)\" ng-disabled=\"tab.disabled\"><md-tab-label>{{tab.title}} <img src=\"assets/angular-material-assets/img/removeTab.png\" ng-click=\"removeTab(tab)\" class=\"delete\"></md-tab-label><md-tab-body>{{tab.content}}</md-tab-body></md-tab></md-tabs></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-selected <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-integer\">integer</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-integer\">integer</code></td><td class=\"description\"><p>Index of the active/selected tab</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If present, disables ink ripple effects.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink-bar <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If present, disables the selection ink bar.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-align-tabs <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Attribute to indicate position of tab buttons: <code>bottom</code> or <code>top</code>; default is <code>top</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-stretch-tabs <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Attribute to indicate whether or not to stretch tabs: <code>auto</code>, <code>always</code>, or <code>never</code>; default is <code>auto</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-dynamic-height <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When enabled, the tab wrapper will resize based on the contents of the selected tab</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-center-tabs <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When enabled, tabs will be centered provided there is no need for pagination</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-pagination <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When enabled, pagination will remain off</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-swipe-content <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When enabled, swipe gestures will be enabled for the content area to jump between tabs</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-enable-disconnect <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When enabled, scopes will be disconnected for tabs that are not being displayed. This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-autoselect <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, any tabs added after the initial load will be automatically selected</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toast/service/$mdToast.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdToast</code> is a service to build a toast notification on any position on the screen with an optional duration, and provides a simple promise API.</p><h2 id=\"restrictions-on-custom-toasts\">Restrictions on custom toasts</h2><ul><li>The toast&#39;s template must have an outer <code>&lt;md-toast&gt;</code> element.</li><li>For a toast action, use element with class <code>md-action</code>.</li><li>Add the class <code>md-capsule</code> for curved corners.</li></ul><h2 id=\"parent-container-notes\">Parent container notes</h2><p>The toast is positioned using absolute positioning relative to it&#39;s first non-static parent container. Thus, if the requested parent container uses static positioning, we will temporarily set it&#39;s positioning to <code>relative</code> while the toast is visible and reset it when the toast is hidden.</p><p>Because of this, it is usually best to ensure that the parent container has a fixed height and prevents scrolling by setting the <code>overflow: hidden;</code> style. Since the position is based off of the parent&#39;s height, the toast may be mispositioned if you allow the parent to scroll.</p><p>You can, however, have a scrollable element inside of the container; just make sure the container itself does not scroll.</p><hljs lang=\"html\"><div layout-fill=\"\" id=\"toast-container\"><md-content>I can have lots of content and scroll!</md-content></div></hljs></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div ng-controller=\"MyController\"><md-button ng-click=\"openToast()\">Open a Toast!</md-button></div></hljs><hljs lang=\"js\">var app = angular.module(&#39;app&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdToast) { $scope.openToast = function($event) { $mdToast.show($mdToast.simple().textContent(&#39;Hello!&#39;)); // Could also do $mdToast.showSimple(&#39;Hello&#39;); }; });</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"showSimple\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.showSimple(message);\n</code></h3><div class=\"service-desc\"><p>Convenience method which builds and shows a simple toast.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* message</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The message to display inside the toast</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that can be resolved with <code>$mdToast.hide()</code> or rejected with <code>$mdToast.cancel()</code>.</p></td></tr></tbody></table></div></li><li id=\"simple\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.simple();\n</code></h3><div class=\"service-desc\"><p>Builds a preconfigured toast.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>a <code>$mdToastPreset</code> with the following chainable configuration methods.</p><p><em><strong>Note:</strong> These configuration methods are provided in addition to the methods provided by the <code>build()</code> and <code>show()</code> methods below.</em></p><ul><li><p><code>.textContent(string)</code> - Sets the toast content to the specified string.</p></li><li><p><code>.action(string)</code> - Adds an action button. If clicked, the promise (returned from <code>show()</code>) will resolve with the value <code>&#39;ok&#39;</code>; otherwise, it is resolved with <code>true</code> after a <code>hideDelay</code> timeout.</p></li><li><p><code>.highlightAction(boolean)</code> - Whether or not the action button will have an additional highlight class.</p></li><li><p><code>.capsule(boolean)</code> - Whether or not to add the <code>md-capsule</code> class to the toast to provide rounded corners.</p></li><li><p><code>.theme(string)</code> - Sets the theme on the toast to the requested theme. Default is <code>$mdThemingProvider</code>&#39;s default.</p></li></ul></td></tr></tbody></table></div></li><li id=\"updateTextContent\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.updateTextContent();\n</code></h3><div class=\"service-desc\"><p>Updates the content of an existing toast. Useful for updating things like counts, etc.</p></div><div class=\"method-param-table\"></div></li><li id=\"build\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.build();\n</code></h3><div class=\"service-desc\"><p>Creates a custom <code>$mdToastPreset</code> that you can configure.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>a <code>$mdToastPreset</code> with the chainable configuration methods for shows&#39; options (see below).</p></td></tr></tbody></table></div></li><li id=\"show\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.show(optionsOrPreset);\n</code></h3><div class=\"service-desc\"><p>Shows the toast.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* optionsOrPreset</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Either provide an <code>$mdToastPreset</code> returned from <code>simple()</code> and <code>build()</code>, or an options object with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>: The url of an html template file that will be used as the content of the toast. Restrictions: the template must have an outer <code>md-toast</code> element.</li><li><code>template</code> - <code>{string=}</code>: Same as templateUrl, except this is an actual template string.</li><li><code>autoWrap</code> - <code>{boolean=}</code>: Whether or not to automatically wrap the template content with a <code>&lt;div class=&quot;md-toast-content&quot;&gt;</code> if one is not provided. Defaults to true. Can be disabled if you provide a custom toast directive.</li><li><code>scope</code> - <code>{object=}</code>: the scope to link the template / controller to. If none is specified, it will create a new child scope. This scope will be destroyed when the toast is removed unless <code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>: whether to preserve the scope when the element is removed. Default is false</li><li><code>hideDelay</code> - <code>{number=}</code>: How many milliseconds the toast should stay active before automatically closing. Set to 0 or false to have the toast stay open until closed manually. Default: 3000.</li><li><code>position</code> - <code>{string=}</code>: Where to place the toast. Available: any combination of &#39;bottom&#39;, &#39;left&#39;, &#39;top&#39;, &#39;right&#39;. Default: &#39;bottom left&#39;.</li><li><code>controller</code> - <code>{string=}</code>: The controller to associate with this toast. The controller will be injected the local <code>$mdToast.hide( )</code>, which is a function used to hide the toast.</li><li><code>locals</code> - <code>{string=}</code>: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, <code>locals: {three: 3}</code> would inject <code>three</code> into the controller with the value of 3.</li><li><code>bindToController</code> - <code>bool</code>: bind the locals to the controller, instead of passing them in. These values will not be available until after initialization.</li><li><code>resolve</code> - <code>{object=}</code>: Similar to locals, except it takes promises as values and the toast will not open until the promises resolve.</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li><li><code>parent</code> - <code>{element=}</code>: The element to append the toast to. Defaults to appending to the root element of the application.</li></ul></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that can be resolved with <code>$mdToast.hide()</code> or rejected with <code>$mdToast.cancel()</code>. <code>$mdToast.hide()</code> will resolve either with a Boolean value == &#39;true&#39; or the value passed as an argument to <code>$mdToast.hide()</code>. And <code>$mdToast.cancel()</code> will resolve the promise with a Boolean value == &#39;false&#39;</p></td></tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.hide([response]);\n</code></h3><div class=\"service-desc\"><p>Hide an existing toast and resolve the promise returned from <code>$mdToast.show()</code>.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the resolved promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>a promise that is called when the existing element is removed from the DOM. The promise is resolved with either a Boolean value == &#39;true&#39; or the value passed as the argument to <code>.hide()</code>.</p></td></tr></tbody></table></div></li><li id=\"cancel\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.cancel([response]);\n</code></h3><div class=\"service-desc\"><p><code>DEPRECATED</code> - The promise returned from opening a toast is used only to notify about the closing of the toast. As such, there isn&#39;t any reason to also allow that promise to be rejected, since it&#39;s not clear what the difference between resolve and reject would be.</p><p>Hide the existing toast and reject the promise returned from <code>$mdToast.show()</code>.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the rejected promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>a promise that is called when the existing element is removed from the DOM The promise is resolved with a Boolean value == &#39;false&#39;.</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toolbar/directive/mdToolbar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>md-toolbar</code> is used to place a toolbar in your app.</p><p>Toolbars are usually used above a content area to display the title of the current page, and show relevant action buttons for that page.</p><p>You can change the height of the toolbar by adding either the <code>md-medium-tall</code> or <code>md-tall</code> class to the toolbar.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div layout=\"column\" layout-fill=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><span>My App&#39;s Title</span><span flex=\"\"></span><md-button>Right Bar Button</md-button></div></md-toolbar><md-content>Hello!</md-content></div></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-scroll-shrink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether the header should shrink away as the user scrolls down, and reveal itself as the user scrolls up.</p><p><em><strong>Note (1):</strong> for scrollShrink to work, the toolbar must be a sibling of a <code>md-content</code> element, placed before it. See the scroll shrink demo.</em></p><p><em><strong>Note (2):</strong> The <code>md-scroll-shrink</code> attribute is only parsed on component initialization, it does not watch for scope changes.</em></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-shrink-speed-factor <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>How much to change the speed of the toolbar&#39;s shrinking by. For example, if 0.25 is given then the toolbar will shrink at one fourth the rate at which the user scrolls down. Default 0.5.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tooltip/directive/mdTooltip.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Tooltips are used to describe elements that are interactive and primarily graphical (not textual).</p><p>Place a <code>&lt;md-tooltip&gt;</code> as a child of the element it describes.</p><p>A tooltip will activate when the user focuses, hovers over, or touches the parent.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-button class=\"md-fab md-accent\" aria-label=\"Play\"><md-tooltip>Play Music</md-tooltip><md-icon icon=\"assets/angular-material-assets/img/icons/ic_play_arrow_24px.svg\"></md-icon></md-button></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-visible <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Boolean bound to whether the tooltip is currently visible.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-delay <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>How many milliseconds to wait to show the tooltip after the user focuses, hovers, or touches the parent. Defaults to 300ms.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-autohide <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If present or provided with a boolean value, the tooltip will hide on mouse leave, regardless of focus</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-direction <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Which direction would you like the tooltip to go? Supports left, right, top, and bottom. Defaults to bottom.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/directive/mdVirtualRepeat.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>md-virtual-repeat</code> specifies an element to repeat using virtual scrolling.</p><p>Virtual repeat is a limited substitute for ng-repeat that renders only enough dom nodes to fill the container and recycling them as the user scrolls. Arrays, but not objects are supported for iteration. Track by, as alias, and (key, value) syntax are not supported.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-virtual-repeat-container><div md-virtual-repeat=\"i in items\">Hello {{i}}!</div></md-virtual-repeat-container><md-virtual-repeat-container md-orient-horizontal=\"\"><div md-virtual-repeat=\"i in items\" md-item-size=\"20\">Hello {{i}}!</div></md-virtual-repeat-container></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-item-size <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The height or width of the repeated elements (which must be identical for each element). Optional. Will attempt to read the size from the dom if missing, but still assumes that all repeated nodes have same height or width.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-extra-name <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Evaluates to an additional name to which the current iterated item can be assigned on the repeated scope (needed for use in <code>md-autocomplete</code>).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-demand <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, treats the md-virtual-repeat argument as an object that can fetch rows rather than an array.</p><p><strong>NOTE:</strong> This object must implement the following interface with two (2) methods:</p><ul><li><code>getItemAtIndex: function(index) [object]</code> The item at that index or null if it is not yet loaded (it should start downloading the item in that case).</li><li><code>getLength: function() [number]</code> The data length to which the repeater container should be sized. Ideally, when the count is known, this method should return it. Otherwise, return a higher number than the currently loaded items to produce an infinite-scroll behavior.</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/directive/mdVirtualRepeatContainer.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>md-virtual-repeat-container</code> provides the scroll container for md-virtual-repeat.</p><p>Virtual repeat is a limited substitute for ng-repeat that renders only enough dom nodes to fill the container and recycling them as the user scrolls.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-virtual-repeat-container md-top-index=\"topIndex\"><div md-virtual-repeat=\"i in items\" md-item-size=\"20\">Hello {{i}}!</div></md-virtual-repeat-container></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-top-index <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Binds the index of the item that is at the top of the scroll container to $scope. It can both read and set the scroll position.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-orient-horizontal <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether the container should scroll horizontally (defaults to orientation and scrolling vertically).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-auto-shrink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, the container will shrink to fit the number of items when that number is less than its original size.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-auto-shrink-min <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Minimum number of items that md-auto-shrink will shrink to (default: 0).</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdButtonInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Provides ripple effects for md-button. See $mdInkRipple service for all possible configuration options.</p></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">scope <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Scope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">options <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>(Optional) Configuration options to override the default ripple configuration</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdCheckboxInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Provides ripple effects for md-checkbox. See $mdInkRipple service for all possible configuration options.</p></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">scope <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Scope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">options <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdListInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Provides ripple effects for md-list. See $mdInkRipple service for all possible configuration options.</p></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">scope <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Scope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">options <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdMedia.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdMedia</code> is used to evaluate whether a given media query is true or false given the current device&#39;s screen / window size. The media query will be re-evaluated on resize, allowing you to register a watch.</p><p><code>$mdMedia</code> also has pre-programmed support for media queries that match the layout breakpoints:</p><table class=\"md-api-table\"><thead><tr><th>Breakpoint</th><th>mediaQuery</th></tr></thead><tbody><tr><td>xs</td><td>(max-width: 599px)</td></tr><tr><td>gt-xs</td><td>(min-width: 600px)</td></tr><tr><td>sm</td><td>(min-width: 600px) and (max-width: 959px)</td></tr><tr><td>gt-sm</td><td>(min-width: 960px)</td></tr><tr><td>md</td><td>(min-width: 960px) and (max-width: 1279px)</td></tr><tr><td>gt-md</td><td>(min-width: 1280px)</td></tr><tr><td>lg</td><td>(min-width: 1280px) and (max-width: 1919px)</td></tr><tr><td>gt-lg</td><td>(min-width: 1920px)</td></tr><tr><td>xl</td><td>(min-width: 1920px)</td></tr></tbody></table><p>See Material Design&#39;s <a href=\"https://www.google.com/design/spec/layout/adaptive-ui.html\">Layout - Adaptive UI</a> for more details.</p><p><a href=\"https://www.google.com/design/spec/layout/adaptive-ui.html\"><img src=\"https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png\" width=\"100%\" height=\"100%\"></a></p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">app.controller(&#39;MyController&#39;, function($mdMedia, $scope) { $scope.$watch(function() { return $mdMedia(&#39;lg&#39;); }, function(big) { $scope.bigScreen = big; }); $scope.screenIsSmall = $mdMedia(&#39;sm&#39;); $scope.customQuery = $mdMedia(&#39;(min-width: 1234px)&#39;); $scope.anotherCustom = $mdMedia(&#39;max-width: 300px&#39;); });</hljs></section><section class=\"api-section\"><section class=\"api-section\"></section><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>a boolean representing whether or not the given media query is true or false.</p></td></tr></tbody></table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdTabInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Provides ripple effects for md-tabs. See $mdInkRipple service for all possible configuration options.</p></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">scope <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Scope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">options <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.gestures/service/$mdGestureProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>In some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked. <code>$mdGestureProvider</code> is used to configure the Gesture module to ignore or skip click hijacking on mobile devices.</p><hljs lang=\"js\">app.config(function($mdGestureProvider) { // For mobile devices without jQuery loaded, do not // intercept click events during the capture phase. $mdGestureProvider.skipClickHijack(); });</hljs></div><div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.theming/service/$mdThemingProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Provider to configure the <code>$mdTheming</code> service.</p></div><div><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"setDefaultTheme\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdThemingProvider.setDefaultTheme(themeName);\n</code></h3><div class=\"service-desc\"></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* themeName</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Default theme name to be applied to elements. Default value is <code>default</code>.</p></td></tr></tbody></table></div></li><li id=\"alwaysWatchTheme\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdThemingProvider.alwaysWatchTheme(watch);\n</code></h3><div class=\"service-desc\"></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* watch</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether or not to always watch themes for changes and re-apply classes when they change. Default is <code>false</code>. Enabling can reduce performance.</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.util/directive/mdAutofocus.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdUtil.findFocusTarget()</code> provides an optional way to identify the focused element when a dialog, bottomsheet, sideNav or other element opens. This is optional attribute finds a nested element with the mdAutoFocus attribute and optional expression. An expression may be specified as the directive value; to enable conditional activation of the autoFocus.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"dialog\">Dialog</h3><hljs lang=\"html\"><md-dialog><form><md-input-container><label for=\"testInput\">Label</label> <input id=\"testInput\" type=\"text\" md-autofocus=\"\"></md-input-container></form></md-dialog></hljs><h3 id=\"bottomsheet\">Bottomsheet</h3><hljs lang=\"html\"><md-bottom-sheet class=\"md-list md-has-header\"><md-subheader>Comment Actions</md-subheader><md-list><md-list-item ng-repeat=\"item in items\"><md-button md-autofocus=\"$index == 2\"><md-icon md-svg-src=\"{{item.icon}}\"></md-icon><span class=\"md-inline-list-icon-label\">{{ item.name }}</span></md-button></md-list-item></md-list></md-bottom-sheet></hljs><h3 id=\"autocomplete\">Autocomplete</h3><hljs lang=\"html\"><md-autocomplete md-autofocus=\"\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" md-item-text=\"item.display\"><span md-highlight-text=\"searchText\">{{item.display}}</span></md-autocomplete></hljs><h3 id=\"sidenav\">Sidenav</h3><hljs lang=\"html\"><div layout=\"row\" ng-controller=\"MyController\"><md-sidenav md-component-id=\"left\" class=\"md-sidenav-left\">Left Nav!</md-sidenav><md-content>Center Content<md-button ng-click=\"openLeftMenu()\">Open Left Menu</md-button></md-content><md-sidenav md-component-id=\"right\" md-is-locked-open=\"$mdMedia(\'min-width: 333px\')\" class=\"md-sidenav-right\"><form><md-input-container><label for=\"testInput\">Test input</label> <input id=\"testInput\" type=\"text\" ng-model=\"data\" md-autofocus=\"\"></md-input-container></form></md-sidenav></div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/src/service/$mdTheming.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Service that makes an element apply theming related classes to itself.</p><pre><code class=\"lang-js\">app.directive(&#39;myFancyDirective&#39;, function($mdTheming) {\n  return {\n    restrict: &#39;e&#39;,\n    link: function(scope, el, attrs) {\n      $mdTheming(el);\n    }\n  };\n});\n</code></pre></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-el\">el</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-el\">el</code></td><td class=\"description\"><p>to apply theming to</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/directive/mdInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>md-ink-ripple</code> directive allows you to specify the ripple color or id a ripple is allowed.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"string-values\">String values</h3><hljs lang=\"html\"><any md-ink-ripple=\"#FF0000\">Ripples in red</any><any md-ink-ripple=\"false\">Not rippling</any></hljs><h3 id=\"interpolated-values\">Interpolated values</h3><hljs lang=\"html\"><any md-ink-ripple=\"{{ randomColor() }}\">Ripples with the return value of &#39;randomColor&#39; function</any><any md-ink-ripple=\"{{ canRipple() }}\">Ripples if &#39;canRipple&#39; function return value is not &#39;false&#39; or &#39;0&#39;</any></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-ink-ripple</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>A color string <code>#FF0000</code> or boolean (<code>false</code> or <code>0</code>) for preventing ripple</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/service/$mdInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdInkRipple</code> is a service for adding ripples to any element</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">app.factory(&#39;$myElementInkRipple&#39;, function($mdInkRipple) { return { attach: function (scope, element, options) { return $mdInkRipple.attach(scope, element, angular.extend({ center: false, dimBackground: true }, options)); } }; }); app.controller(&#39;myController&#39;, function ($scope, $element, $myElementInkRipple) { $scope.onClick = function (ev) { $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true }); } });</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"attach\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdInkRipple.attach([scope], [element], [options]);\n</code></h3><div class=\"service-desc\"><p>Attaching given scope, element and options to inkRipple controller</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">scope <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Scope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">options <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultRipple configuration</p><ul><li><code>center</code> - Whether the ripple should start from the center of the container element</li><li><code>dimBackground</code> - Whether the background should be dimmed with the ripple color</li><li><code>colorElement</code> - The element the ripple should take its color from, defined by css property <code>color</code></li><li><code>fitRipple</code> - Whether the ripple should fill the element</li></ul></td></tr></tbody></table></div></li></ul></section></div></div>");}]);